/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: Date; output: Date; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

/** Audit record for a2a payments  */
export type A2ARecord = Node & {
  __typename: 'A2ARecord';
  accountNumbers: Array<Scalars['String']['output']>;
  action: A2ARecordAction;
  amount: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
};

export enum A2ARecordAction {
  FetchAccount = 'FetchAccount',
  PaymentFailed = 'PaymentFailed',
  PaymentSuccess = 'PaymentSuccess'
}

export type A2ARecordConnection = {
  __typename: 'A2ARecordConnection';
  edges: Array<A2ARecordEdge>;
  pageInfo: PageInfo;
  totalAmount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type A2ARecordEdge = {
  __typename: 'A2ARecordEdge';
  cursor: Scalars['String']['output'];
  node: A2ARecord;
};

export type AcceptSavingsShareResponse = {
  __typename: 'AcceptSavingsShareResponse';
  /** Unique id for access to saving, for a particular customer */
  customerProxyId: Scalars['String']['output'];
};

export type AcceptShareInput = {
  /** Unique id for access to saving, for a particular customer */
  customerProxyId: Scalars['String']['input'];
};

/** Access profile used to filter services to a curated recommendation list */
export enum AccessProfile {
  ACCOUNTANT = 'ACCOUNTANT'
}

/** Bank account */
export type Account = Node & {
  __typename: 'Account';
  accountNumber: Scalars['String']['output'];
  accountProductName: Scalars['String']['output'];
  /** An active overdraft application, null if none is active or if the active application has invalid data. Can return a 403 response if user doesn't have access. Currently, this is only functional for corporate overdraft applications. */
  activeOverdraftApplication: Maybe<ActiveOverdraftApplicationResponse>;
  availableAmount: Scalars['Float']['output'];
  balance: Scalars['Float']['output'];
  /** @deprecated Should not be used. Since 2026-06-24. Issue to remove: WEB-43953  */
  balanceEndOfLastBankingDay: Scalars['Float']['output'];
  bindingTime: BindingTime;
  /** Information about the bound balance for the account */
  boundBalanceInfo: AccountBoundBalanceInfo;
  canBeRegularSavingsAccount: Scalars['Boolean']['output'];
  canCreateSavingsPlans: Scalars['Boolean']['output'];
  closures: AccountClosures;
  currency: Scalars['String']['output'];
  currencyQuote: Maybe<CurrencyQuoteResponse>;
  customerProxies: Array<CustomerProxy>;
  /** Average number of debitcard transactions for last 3 months */
  debitCardTransactionEstimate: Scalars['Int']['output'];
  debitCardsV2: Maybe<DebitCardConnection>;
  depositInterestRate: Scalars['Float']['output'];
  disposableAmountInfo: DisposableAmountInfo;
  domesticBalance: Scalars['Float']['output'];
  eligibleCardholdersForDebitCardCreation: EligibleCardholdersForDebitCardCreation;
  exchangeRate: Scalars['Float']['output'];
  /**
   * Document representing the fee summary of an account
   * @deprecated Reason: Use feeSummaryDocumentV2 instead. Since: 2026-03-23. Issue to remove it: WEB-41681
   */
  feeSummaryDocument: Maybe<DocumentBucket>;
  /** Document representing the fee summary of an account */
  feeSummaryDocumentV2: Maybe<GenericFile>;
  /** @deprecated This field is deprecated and will be removed in future versions. Since 2026-06-22. Issue to remove: WEB-43911 */
  fit: Scalars['Float']['output'];
  /** Property showing whether this account has a fee summary document or not */
  hasFeeSummaryDocument: Scalars['Boolean']['output'];
  /** True if the accounts available amount should be hidden. The API marks it as true only when the account owner is under 18 years old and the account type is one of the following: Framtíðargrunnur verðtryggður - RS, Framtíðargrunnur verðtryggður, or Framtíðargrunnur óverðtryggður. */
  hideAvailableAmount: Scalars['Boolean']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Should not be used. Use id or accountNumber for a unique identifier. Since 2026-06-22. Issue to remove: WEB-43902 */
  idAccount: Scalars['Int']['output'];
  /** If prerequisites for current user are needed then query for Viewer.invalidPrerequisitesForDebitCardCreation instead. This field is only relevant for prerequisites of another cardholder than the current user. */
  invalidPrerequisitesForDebitCardCreation: Array<InvalidPrerequisiteForCreateDebitCard>;
  /** @deprecated Should not be used. There is no replacement as we should stop using this. Since 2026-06-22. Issue to remove: WEB-43908 */
  isCashpoolAccount: Scalars['Boolean']['output'];
  isCurrencyAccount: Scalars['Boolean']['output'];
  isDefaultAccount: Scalars['Boolean']['output'];
  isDepositAccount: Scalars['Boolean']['output'];
  /** Whether the account has been marked as favorite */
  isFavorite: Scalars['Boolean']['output'];
  /** True if account is a Landsbankinn account */
  isLandsbankinnAccount: Scalars['Boolean']['output'];
  isNoticeAccount: Scalars['Boolean']['output'];
  /**
   * This property is true if the associated account product has the 'OverdraftInSelfService' attribute.
   *   This property does not say if modifying the overdraft limit or applying for overdraft in self service is possible. The account could be closed or other preconditions not fulfilled.
   */
  isOverdraftAllowed: Scalars['Boolean']['output'];
  /**
   *
   *   - If personal user then this is true if user kennitala is same as account owner kennitala.
   *   - If corporate user then this is true if company kennitala is same as account owner kennitala.
   *
   */
  isOwnAccount: Scalars['Boolean']['output'];
  isSavingsAccount: Scalars['Boolean']['output'];
  isVaxtareikningur30: Scalars['Boolean']['output'];
  isWithdrawalAccount: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  lastTransactionDate: Maybe<Scalars['DateTimeISO']['output']>;
  loanInterestRate: Scalars['Float']['output'];
  /** Indicates whether the account is locked or not, and if it is locked, what functions are locked. */
  lockedState: AccountLockedState;
  name: Scalars['String']['output'];
  noticeDateMax: Scalars['DateTimeISO']['output'];
  noticeDateMin: Scalars['DateTimeISO']['output'];
  noticeDays: Scalars['Int']['output'];
  noticeDaysMax: Scalars['Int']['output'];
  notices: Maybe<NoticeConnection>;
  orderedAmountAvailable: Scalars['Float']['output'];
  orderedAmountTotal: Scalars['Float']['output'];
  /** The interest rate for the overdraft. This value can vary between different accounts. */
  overdraftInterestRate: Maybe<Scalars['Float']['output']>;
  overdraftLimit: Scalars['Float']['output'];
  /** The restrictions placed on applying for an overdraft, for this account. Will return null if overdraft is not allowed. */
  overdraftRestrictions: Maybe<OverdraftRestrictions>;
  overdraftUsed: Scalars['Float']['output'];
  overdraftValidTo: Maybe<Scalars['DateTimeISO']['output']>;
  owner: Scalars['String']['output'];
  /** List of pending transactions */
  pendingTransactions: PendingAccountTransactionConnection;
  /** Proxy accesses the current user has provided to others for this account */
  proxyAccesses: Maybe<ProxyAccessesForProduct>;
  showInSummary: Scalars['Boolean']['output'];
  showOnFrontpage: Scalars['Boolean']['output'];
  state: BankAccountState;
  /** @deprecated This field is deprecated and will be removed in future versions. Since 2026-06-22. Issue to remove: WEB-43913 */
  swift: Scalars['String']['output'];
  /** Will return null until RB has closed the account completely. After RB has closed the account completely the date on which it was closed will be returned. */
  terminatedDate: Maybe<Scalars['DateTimeISO']['output']>;
  transactions: BankAccountTransactionConnection;
  /**
   * Identical to the field transactions, but also returns pending transactions
   * @deprecated Deprecated: Replaced by 2 separate fields: transactions and pendingTransactions. Since: 2026-03-24. Issue to remove it: WEB-41700
   */
  transactionsUnion: BankAccountTransactionUnionConnection;
  turnover: Scalars['Float']['output'];
  unpaidInterest: Scalars['Float']['output'];
  /** This is `true` if you are only permitted to withdraw from this account to your own account. */
  withdrawToOwnAccountOnly: Scalars['Boolean']['output'];
};


/** Bank account */
export type AccountActiveOverdraftApplicationArgs = {
  filter?: InputMaybe<ActiveOverdraftApplicationsFilterArgs>;
};


/** Bank account */
export type AccountCurrencyQuoteArgs = {
  payment: CurrencyAmountInput;
};


/** Bank account */
export type AccountDebitCardsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DebitCardFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DebitCardsOrderBy>;
};


/** Bank account */
export type AccountInvalidPrerequisitesForDebitCardCreationArgs = {
  cardHolderKennitala: Scalars['String']['input'];
};


/** Bank account */
export type AccountNoticesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Bank account */
export type AccountPendingTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<PendingAccountTransactionsSortBy>;
};


/** Bank account */
export type AccountProxyAccessesArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Bank account */
export type AccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<TransactionFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionsOrderBy>;
};


/** Bank account */
export type AccountTransactionsUnionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<TransactionFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BankAccountTransactionsUnionOrderBy>;
};

/** Access level for an account permission */
export enum AccountAccessLevel {
  FULL = 'FULL',
  NONE = 'NONE',
  READ_ONLY = 'READ_ONLY'
}

export type AccountAuthorization = Node & {
  __typename: 'AccountAuthorization';
  /** If user can transfer from the account */
  canTransfer: Scalars['Boolean']['output'];
  /** If user can view */
  canView: Scalars['Boolean']['output'];
  /** Display number */
  displayNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Kennitala */
  kennitala: Scalars['String']['output'];
  /** Owner name */
  ownerName: Scalars['String']['output'];
  /** Name of the product, either the account type or card type */
  productName: Maybe<Scalars['String']['output']>;
  /** If transfer access is allowed for this account */
  transferAccessAllowed: Scalars['Boolean']['output'];
  /** All users with information about their access to the account, only resolve when getting one account */
  users: Maybe<AccountUserAccessAuthorizationConnection>;
};


export type AccountAuthorizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsersAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsersAuthorizationOrderBy>;
};

export type AccountAuthorizationConnection = {
  __typename: 'AccountAuthorizationConnection';
  /** Overall access level for the accounts. Will have a value if user has same access level for all accounts in the connection. Note that AccountsAuthorizationArgs.withAccessOnly affect the value of this field. */
  allAccess: Maybe<AccountAccessLevel>;
  edges: Array<AccountAuthorizationEdge>;
  /** If the connection includes subsidiaries */
  includesSubsidiaries: Scalars['Boolean']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccountAuthorizationEdge = {
  __typename: 'AccountAuthorizationEdge';
  cursor: Scalars['String']['output'];
  node: AccountAuthorization;
};

export type AccountBoundBalanceInfo = {
  __typename: 'AccountBoundBalanceInfo';
  /** An enum to determine what view the bound balance screen should show for this account or if we should not show it at all. */
  accountBoundBalanceView: AccountBoundBalanceView;
  /** The deposit payout disclaimer for the account. Used for values that will be available to order soon and describes when the money will be paid out after ordering it. */
  depositPayoutDisclaimer: Maybe<Scalars['String']['output']>;
  /** The deposit rebound disclaimer for the account. Used for values that will be available soon but then will be bound again. */
  depositReboundDisclaimer: Maybe<Scalars['String']['output']>;
};

/** The different variations of views that the bound balance screen can show for different account types. There are 4 variations of views plus an option to not show the button to see the bound balance screen. */
export enum AccountBoundBalanceView {
  /** This view has 1 table to show, one for amounts that will be available later. */
  AVAILABLE_LATER = 'AVAILABLE_LATER',
  /** This view has 2 tables to show, one for the amount that is available now and one for the amount that will be available for one month. */
  AVAILABLE_NOW_AND_AVAILABLE_FOR_ONE_MONTH = 'AVAILABLE_NOW_AND_AVAILABLE_FOR_ONE_MONTH',
  /** This view has 3 tables to show, one for the amount that is available now, one for the amount that will be available for one month, and one for the orders. */
  AVAILABLE_NOW_AND_AVAILABLE_FOR_ONE_MONTH_AND_ORDERS = 'AVAILABLE_NOW_AND_AVAILABLE_FOR_ONE_MONTH_AND_ORDERS',
  /** Hide bound balance button. */
  HIDE_BOUND_BALANCE_BUTTON = 'HIDE_BOUND_BALANCE_BUTTON',
  /** This view has 2 tables to show, one for the amount that will be available for order and one for the orders. */
  WILL_BE_AVAILABLE_FOR_ORDER_AND_ORDERS = 'WILL_BE_AVAILABLE_FOR_ORDER_AND_ORDERS'
}

/** Info on the closure process for a given account */
export type AccountClosure = {
  __typename: 'AccountClosure';
  /** Bank account with this closure request. */
  account: Account;
  /** The settlement account is the account that will receive the balance of the closed account and/or be used to settle any remaining debts on the account being closed. */
  settlementAccount: Account;
};

/** Validation check for user as to whether the requested account can be closed. This includes checking the user's access, whether this type of account can be closed, whether blockings are preventing closure etc. */
export enum AccountClosurePrerequisite {
  /** Foreign currency account's balance is too high for closure. Make a withdrawal first */
  FOREIGN_CURRENCY_OVER_LIMIT = 'FOREIGN_CURRENCY_OVER_LIMIT',
  /** Account has an active blocking */
  HAS_BLOCKING = 'HAS_BLOCKING',
  /** Account has an active reservation */
  HAS_RESERVATION = 'HAS_RESERVATION',
  /** Cannot close this account type. Account of this type cannot be closed in self-service. Only applicable for customers, not internal users */
  INVALID_ACCOUNT_TYPE = 'INVALID_ACCOUNT_TYPE',
  /** The Accounts/Closures/v1/Prerequisites API returning 403. Probably because this is not user's own account or user does not have transfer access. */
  NOT_ALLOWED = 'NOT_ALLOWED',
  /** The api has added unknown type value. This should be logged. */
  UNKNOWN = 'UNKNOWN',
  /** User must have one valid account to use as a settlement account */
  USER_LAST_ACCOUNT = 'USER_LAST_ACCOUNT',
  /** User must be at least 13 years of age to close accounts */
  USER_UNDER_13 = 'USER_UNDER_13',
  /** User must be at least 18 years of age to close accounts of this type */
  USER_UNDER_18 = 'USER_UNDER_18'
}

/** User is forbidden to request closure of this account */
export type AccountClosureRequestForbidden = Error & {
  __typename: 'AccountClosureRequestForbidden';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AccountClosureRequestSuccessPayload = {
  __typename: 'AccountClosureRequestSuccessPayload';
  /** Info on the closure process for a given account */
  closure: AccountClosure;
};

/** Everything for closure of an account */
export type AccountClosures = {
  __typename: 'AccountClosures';
  /** If the balance on the account is negative an empty list will be returned. If the account can not be closed null will be returned. If the account can be closed and the balance is positive then a list of settlements will be returned */
  estimatedSettlements: Array<AccountEstimatedSettlement>;
  /** If nothing prevents the account from being closed, the returned list is empty, otherwise it contains the reasons why a given account can't be closed. */
  prerequisites: Array<AccountClosurePrerequisite>;
  /** Returns an ordered list of valid settlement accounts for a given closure request */
  validSettlementAccounts: AccountConnection;
};


/** Everything for closure of an account */
export type AccountClosuresValidSettlementAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountConnection = {
  __typename: 'AccountConnection';
  edges: Array<AccountEdge>;
  /** Individuals that user can query accounts for. Independent of filters and parameters of the query itself. */
  owners: Maybe<Array<AccountOwner>>;
  pageInfo: PageInfo;
  totalClosed: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  /** The total overdraft limit of the queried accounts */
  totalOverdraftLimit: Maybe<Scalars['Float']['output']>;
  /** The total overdraft amount currently being used */
  totalOverdraftUsed: Maybe<Scalars['Float']['output']>;
};

export type AccountEdge = {
  __typename: 'AccountEdge';
  cursor: Scalars['String']['output'];
  node: Account;
};

/** Represents estimated amount to be transferred when closing the account */
export type AccountEstimatedSettlement = {
  __typename: 'AccountEstimatedSettlement';
  amount: CurrencyAmount;
  /** Returns true if the month is null. When the month is null it means the settlement is happening immediately. */
  immediateSettlement: Scalars['Boolean']['output'];
  /**
   *
   * When amount will be disbursed from the account.
   * Represented as a string formatted as : yyyy-MM
   * Example: 2023-04
   *
   * If null then this settlement will happen now.
   *
   */
  month: Maybe<Scalars['String']['output']>;
};

export type AccountFilterArgs = {
  /** A list of account IDs to filter by. If provided, only accounts with these IDs will be returned, ignoring other filters. */
  accountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  canBeRegularSavingsAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of account search types that will be excluded. Example use: [Withdrawal, DepositAccount] => all accounts that are withdrawal accounts OR deposit accounts will be excluded */
  exclude?: InputMaybe<Array<AccountSearchType>>;
  hasOverdraftLimit?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of account search types that must be fulfilled. Example use: [Withdrawal, DepositAccount] => all accounts that are withdrawal accounts AND deposit accounts will be included */
  include?: InputMaybe<Array<AccountSearchType>>;
  includedCurrencies?: InputMaybe<Array<Scalars['String']['input']>>;
  isOwnAccount?: InputMaybe<Scalars['Boolean']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  /** Use to filter accounts by state. If omitted default value of `[BankAccountState.Open]` is used. */
  state?: InputMaybe<Array<BankAccountState>>;
  type?: InputMaybe<AccountSearchType>;
};

export enum AccountIdentifierType {
  BBAN = 'BBAN',
  CARD_NUMBER = 'CARD_NUMBER',
  IBAN = 'IBAN',
  UNKNOWN = 'UNKNOWN'
}

/** Account information, used for withdrawal and deposit account */
export type AccountInfo = {
  __typename: 'AccountInfo';
  accountNumber: Maybe<Scalars['String']['output']>;
  kennitala: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type AccountInsufficientAvailableToBuy = Error & {
  __typename: 'AccountInsufficientAvailableToBuy';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Represents the locked state of an account. Locked accounts cannot be used for transactions. */
export enum AccountLockedState {
  /** The account is bound */
  BOUND = 'BOUND',
  /** The account is locked for deposits and withdrawals */
  DEPOSITS_AND_WITHDRAWALS_NOT_ALLOWED = 'DEPOSITS_AND_WITHDRAWALS_NOT_ALLOWED',
  /** The account is not locked and can be used for transactions. */
  NOT_LOCKED = 'NOT_LOCKED',
  /** The account locked state is unknown */
  UNKNOWN = 'UNKNOWN',
  /** The account is locked for withdrawals */
  WITHDRAWALS_NOT_ALLOWED = 'WITHDRAWALS_NOT_ALLOWED'
}

/** Interest statistics for a specific month */
export type AccountMonthlyStatisticInfo = {
  __typename: 'AccountMonthlyStatisticInfo';
  /** The interest earned during this month */
  interest: CurrencyAmount;
  /** The month for which the statistics are calculated */
  month: Scalars['Date']['output'];
};

/** Monthly statistics breakdown and totals for a specific savings account */
export type AccountMonthlyStatisticsInfo = {
  __typename: 'AccountMonthlyStatisticsInfo';
  /** Monthly breakdown of statistics for this account for the last 12 months including the current month (13 months total) */
  monthlyStatistics: Array<AccountMonthlyStatisticInfo>;
  /** Total statistics aggregated for the last 12 months (excluding current month) for this account */
  totals: StatisticTotalsInfo;
};

export type AccountNotAllowedForMarketSubscription = Error & {
  __typename: 'AccountNotAllowedForMarketSubscription';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Account number input component */
export type AccountNumberFormComponent = FormComponentBase & {
  __typename: 'AccountNumberFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  validation: Maybe<FormComponentValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type AccountOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: AccountOrderByOption;
};

export enum AccountOrderByOption {
  IsCurrency = 'IsCurrency'
}

export type AccountOwner = {
  __typename: 'AccountOwner';
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Error detail for an account permission update */
export type AccountPermissionError = {
  __typename: 'AccountPermissionError';
  /** Field that caused the error */
  field: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** A failed account permission update with error details */
export type AccountPermissionUpdateFailure = {
  __typename: 'AccountPermissionUpdateFailure';
  /** Attempted access level */
  access: Maybe<AccountAccessLevel>;
  /** Display number of the account */
  displayNumber: Maybe<Scalars['String']['output']>;
  /** List of validation or processing errors */
  errors: Array<AccountPermissionError>;
  /** Username involved in the failed update */
  username: Scalars['String']['output'];
};

/** Account product */
export type AccountProduct = Node & Product & {
  __typename: 'AccountProduct';
  adultCreationFormId: Maybe<Scalars['Float']['output']>;
  bindingDuration: Maybe<Scalars['Int']['output']>;
  bindingInterestsRatio: Maybe<Scalars['Float']['output']>;
  bindingRule: Maybe<AccountProductBindingRule>;
  corporateCreationFormId: Maybe<Scalars['Int']['output']>;
  currencies: Maybe<Array<Scalars['String']['output']>>;
  debitcardFee: Maybe<Scalars['Float']['output']>;
  depositInterestRate: Maybe<Scalars['Float']['output']>;
  depositInterestSteps: Maybe<Array<AccountProductInterestStep>>;
  description: Maybe<Scalars['String']['output']>;
  displayDescription: Maybe<Scalars['String']['output']>;
  displayDescriptionLong: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  hasServiceFeesDocument: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  indexed: Scalars['Boolean']['output'];
  interestCalculationRule: Maybe<AccountProductInterestCalculationRule>;
  isDebitcardAvailable: Scalars['Boolean']['output'];
  /** Indicates that the account product is Framtíðargrunnur, verðtryggður, which is only available for minor */
  isMinorIndexedFutureFund: Scalars['Boolean']['output'];
  isOverdraftAvailable: Scalars['Boolean']['output'];
  isSavingsAccount: Scalars['Boolean']['output'];
  isTermDepositAccount: Scalars['Boolean']['output'];
  loanInterestRate: Maybe<Scalars['Float']['output']>;
  maxAge: Maybe<Scalars['Int']['output']>;
  minAge: Maybe<Scalars['Int']['output']>;
  minBalance: Maybe<Scalars['Float']['output']>;
  minorCreationFormId: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  noticeDays: Maybe<Scalars['Float']['output']>;
  /** @deprecated Reason: Use serviceFeesDocumentV2 instead. Since: 2026-03-18. Issue to remove it: WEB-41573 */
  serviceFeesDocument: Maybe<DocumentBucket>;
  serviceFeesDocumentV2: Maybe<GenericFile>;
  /** Link to a document with special terms. This is available for few products only - and will be null for most our the accounts. */
  specialTermsLink: Maybe<Scalars['String']['output']>;
  termsAndConditionsId: Maybe<Scalars['Int']['output']>;
  type: ProductType;
  withdrawalAccounts: Maybe<Array<Account>>;
};

/** Account product applicant */
export type AccountProductApplicant = {
  __typename: 'AccountProductApplicant';
  accountProductGroups: Array<AccountProductGroup>;
  age: Maybe<Scalars['Int']['output']>;
  applicantInfo: Maybe<NationalRegistryEntry>;
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  prerequisites: Array<AccountProductPrerequisite>;
  /** Used for creating saving goal account product, which is exclusive for the app. Will return null of applicant does not meet prerequisites. */
  savingGoalProduct: Maybe<AccountProduct>;
};

export enum AccountProductBindingRule {
  Days = 'Days',
  None = 'None',
  NoticeDays = 'NoticeDays',
  TermDeposit = 'TermDeposit'
}

/** Group of Account Products */
export type AccountProductGroup = {
  __typename: 'AccountProductGroup';
  accountProducts: Array<AccountProduct>;
  description: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: AccountProductGroupType;
};

export enum AccountProductGroupType {
  BoundAccount = 'BoundAccount',
  CurrencyAccount = 'CurrencyAccount',
  CurrentAccount = 'CurrentAccount',
  HoldingAccount = 'HoldingAccount',
  SavingsAccount = 'SavingsAccount'
}

export type AccountProductInput = {
  /** Auðkenni annars aðila, t.d. barns */
  applicantId?: InputMaybe<Scalars['String']['input']>;
  createDebitCardForOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required */
  currency: Scalars['String']['input'];
  /** Required. The (GraphQL) ID of an account product */
  id: Scalars['String']['input'];
  /** Upphæð fastvaxtareiknings */
  initialAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Leyninúmer */
  securityCode?: InputMaybe<Scalars['String']['input']>;
  /** Ráðstöfunarreikningur fastvaxtareiknings */
  withdrawalAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type AccountProductInsufficientAvailableFund = Error & {
  __typename: 'AccountProductInsufficientAvailableFund';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum AccountProductInterestCalculationRule {
  EndOfBindingTime = 'EndOfBindingTime',
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

/** Interest step */
export type AccountProductInterestStep = {
  __typename: 'AccountProductInterestStep';
  amount: Maybe<Scalars['Float']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  interestRate: Maybe<Scalars['Float']['output']>;
  loyaltyLevel: Maybe<CustomerLoyaltyLevel>;
};

/** Account product application prerequisites */
export type AccountProductPrerequisite = {
  __typename: 'AccountProductPrerequisite';
  description: Maybe<Scalars['String']['output']>;
  effect: Maybe<AccountProductPrerequisiteEffect>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
};

export enum AccountProductPrerequisiteEffect {
  Blocked = 'Blocked',
  ElectronicSignatureRequired = 'ElectronicSignatureRequired',
  Information = 'Information',
  ManualVerification = 'ManualVerification'
}

export type AccountProductSecurityCodeInvalid = Error & {
  __typename: 'AccountProductSecurityCodeInvalid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AccountProductSecurityCodePartOfOwnersDetail = Error & {
  __typename: 'AccountProductSecurityCodePartOfOwnersDetail';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum AccountSearchType {
  Bound = 'Bound',
  CashPool = 'CashPool',
  ClaimPayment = 'ClaimPayment',
  CreditCardDirectDebitAccounts = 'CreditCardDirectDebitAccounts',
  Currency = 'Currency',
  Custodial = 'Custodial',
  DepositAccount = 'DepositAccount',
  NoticeDeposit = 'NoticeDeposit',
  OverdraftAllowed = 'OverdraftAllowed',
  Savings = 'Savings',
  Withdrawal = 'Withdrawal'
}

export type AccountSecurityCodeChangedPayload = {
  __typename: 'AccountSecurityCodeChangedPayload';
  success: Scalars['Boolean']['output'];
};

export type AccountSecurityCodeUnauthorized = Error & {
  __typename: 'AccountSecurityCodeUnauthorized';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum AccountSummaryType {
  AvailableAmount = 'AvailableAmount',
  Balance = 'Balance'
}

/** Financial transaction on bank account, i.e. transfer, debit payments */
export type AccountTransaction = Node & {
  __typename: 'AccountTransaction';
  accountNumber: Scalars['String']['output'];
  amountV2: CurrencyAmount;
  balanceAfterTransaction: Scalars['Float']['output'];
  bankBranch: Scalars['String']['output'];
  batchId: Scalars['String']['output'];
  bookingDate: Scalars['DateTimeISO']['output'];
  customDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-11. Issue to remove it: WEB-38505 */
  debitCardWarrantyNumber: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  /** @deprecated Use detailsV2 instead. Since: 2026-03-26. Issue to remove it: WEB-38427 */
  details: AccountTransactionDetails;
  detailsV2: Maybe<AccountTransactionDetailUnion>;
  displayText: Scalars['String']['output'];
  exchangeRate: Scalars['Float']['output'];
  foreignAmount: Maybe<CurrencyAmount>;
  id: Scalars['ID']['output'];
  payerDescription: Scalars['String']['output'];
  /** Payment ID associated with the transaction */
  paymentId: Maybe<Scalars['ID']['output']>;
  /** Permission information that the customer has over a specific account transaction */
  permissions: AccountTransactionPermissions;
  /** PDF document representing the receipt of an account transaction */
  receipt: Maybe<GenericFile>;
  /** The original receiver currency amount, only present if the transaction went through fx conversion */
  receiverAmount: Maybe<CurrencyAmount>;
  recipientAccountNumber: Maybe<Scalars['String']['output']>;
  recipientKennitala: Scalars['String']['output'];
  recipientName: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  referenceNumber: Scalars['String']['output'];
  reservationDate: Maybe<Scalars['DateTimeISO']['output']>;
  sentReceipts: Array<AccountTransactionReceipt>;
  textCodeDescription: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  transactionCodeKey: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  valueDate: Scalars['DateTimeISO']['output'];
};

/** Type of an transaction's details */
export enum AccountTransactionDetailType {
  /** The transaction represents a card deposit */
  CARD_DEPOSIT = 'CARD_DEPOSIT',
  /** The transaction represents a card transaction */
  CARD_TRANSACTION = 'CARD_TRANSACTION',
  /** The transaction represents a claim payment */
  CLAIM_PAYMENT = 'CLAIM_PAYMENT',
  /** The transaction represents a credit transfer */
  CREDIT_TRANSFER = 'CREDIT_TRANSFER',
  /** The transaction represents a default payment */
  DEFAULT_PAYMENT = 'DEFAULT_PAYMENT',
  /** The transaction represents an international payment */
  INTERNATIONAL_PAYMENT = 'INTERNATIONAL_PAYMENT',
  /** The transaction represents a loan deposit */
  LOAN_DEPOSIT = 'LOAN_DEPOSIT',
  /** Unknown type of transaction */
  UNKNOWN = 'UNKNOWN'
}

export type AccountTransactionDetailUnion = AccountTransactionDetailsCardDeposit | AccountTransactionDetailsCardTransaction | AccountTransactionDetailsClaimPayment | AccountTransactionDetailsCreditTransfer | AccountTransactionDetailsDefaultPayment | AccountTransactionDetailsInternationalPayment | AccountTransactionDetailsLoanDeposit | AccountTransactionDetailsUnknownPayment;

/** Extra details for a financial transaction */
export type AccountTransactionDetails = {
  __typename: 'AccountTransactionDetails';
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-05. Issue to remove it: WEB-38315 */
  atmLocationDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced in permissions. Use its correspondent. Since: 2026-02-03. Issue to remove it: WEB-38427 */
  canGeneratePdfReceipt: Scalars['Boolean']['output'];
  /** @deprecated Replaced by permissions. Use its correspondent. Since: 2026-02-03. Issue to remove it: WEB-38427 */
  canSendCorrespondence: Scalars['Boolean']['output'];
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: noticeAndPaymentFee. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimAnnouncementFee: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: principalAmount. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimCapitalAmount: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: defaultCharge. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimDefaultCharge: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: otherDefaultCost. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimDefaultCost: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: discount. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimDiscount: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: dueDate. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: finalDueDate. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimFinalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: otherCost. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimOtherFees: Maybe<Scalars['Float']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsClaimPayment. New field: defaultInterest. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  claimPenaltyInterest: Maybe<Scalars['Float']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-05. Issue to remove it: WEB-38370 */
  contractName: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsCardDeposit. New field: cardNumber. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  creditCardNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsCardDeposit. New field: kennitala. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  creditCardOwnerKennitala: Maybe<Scalars['String']['output']>;
  creditCardOwnerName: Maybe<Scalars['String']['output']>;
  /** @deprecated Use exchangeRate from the base object. 'Since: 2025-11-05. Issue to remove it: WEB-38308 */
  exchangeRate: Scalars['Float']['output'];
  /** @deprecated Replaced in detailsV2, if the type is AccountTransactionDetailsCardTransaction. New field: merchantCategoryCode. Since: 2026-05-07. Issue to remove it: WEB-38427 */
  mcc: Maybe<Scalars['String']['output']>;
  /** @deprecated Use payerDescription from the base object. Since: 2025-11-07. Issue to remove it: WEB-38399 */
  paymentCreatorDescription: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-06. Issue to remove it: WEB-38366 */
  topUpPhoneCompany: Maybe<Scalars['String']['output']>;
  /** @deprecated Use reservationDate from the base object. 'Since: 2025-11-05. Issue to remove it: WEB-38299 */
  transactionDate: Scalars['DateTimeISO']['output'];
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-05. Issue to remove it: WEB-38319 */
  withdrawalAddress: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-07. Issue to remove it: WEB-38392 */
  withdrawalAuthorizationNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-06. Issue to remove it: WEB-38333 */
  withdrawalCity: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-06. Issue to remove it: WEB-38347 */
  withdrawalCountry: Maybe<Scalars['String']['output']>;
  /** @deprecated Redundant (Field is not returned anymore). Since: 2025-11-05. Issue to remove it: WEB-38322 */
  withdrawalZipCode: Maybe<Scalars['String']['output']>;
};

/** Details of an account transaction representing a card deposit */
export type AccountTransactionDetailsCardDeposit = {
  __typename: 'AccountTransactionDetailsCardDeposit';
  cardHolderName: Scalars['String']['output'];
  cardNumber: Scalars['String']['output'];
  initiation: Maybe<AccountTransactionInitiation>;
  kennitala: Scalars['String']['output'];
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a card transaction */
export type AccountTransactionDetailsCardTransaction = {
  __typename: 'AccountTransactionDetailsCardTransaction';
  initiation: Maybe<AccountTransactionInitiation>;
  merchantCategoryCode: Maybe<Scalars['String']['output']>;
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a claim payment */
export type AccountTransactionDetailsClaimPayment = {
  __typename: 'AccountTransactionDetailsClaimPayment';
  defaultCharge: Scalars['Float']['output'];
  defaultInterest: Scalars['Float']['output'];
  discount: Scalars['Float']['output'];
  dueDate: Scalars['DateTimeISO']['output'];
  finalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  initiation: Maybe<AccountTransactionInitiation>;
  noticeAndPaymentFee: Scalars['Float']['output'];
  otherCost: Scalars['Float']['output'];
  otherDefaultCost: Scalars['Float']['output'];
  principalAmount: Maybe<Scalars['Float']['output']>;
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a credit transfer */
export type AccountTransactionDetailsCreditTransfer = {
  __typename: 'AccountTransactionDetailsCreditTransfer';
  initiation: Maybe<AccountTransactionInitiation>;
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a default payment */
export type AccountTransactionDetailsDefaultPayment = {
  __typename: 'AccountTransactionDetailsDefaultPayment';
  initiation: Maybe<AccountTransactionInitiation>;
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a international payment */
export type AccountTransactionDetailsInternationalPayment = {
  __typename: 'AccountTransactionDetailsInternationalPayment';
  exchangeRateDetails: Maybe<AccountTransactionExchangeRateDetails>;
  initiation: Maybe<AccountTransactionInitiation>;
  instructedAmount: CurrencyAmount;
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing a loan deposit */
export type AccountTransactionDetailsLoanDeposit = {
  __typename: 'AccountTransactionDetailsLoanDeposit';
  initiation: Maybe<AccountTransactionInitiation>;
  /** (Global) ID of the loan */
  loanId: Scalars['ID']['output'];
  type: AccountTransactionDetailType;
};

/** Details of an account transaction representing an unknown (and unhandled type of) payment */
export type AccountTransactionDetailsUnknownPayment = {
  __typename: 'AccountTransactionDetailsUnknownPayment';
  initiation: Maybe<AccountTransactionInitiation>;
  type: AccountTransactionDetailType;
};

export type AccountTransactionEdge = {
  __typename: 'AccountTransactionEdge';
  cursor: Scalars['String']['output'];
  node: AccountTransaction;
};

/** Indicates the calculation method for the exchange rate */
export enum AccountTransactionExchangeRateCalculationMethod {
  /** Exchange rate should be divided to get the converted amount in the transaction currency. */
  DIVIDER = 'DIVIDER',
  /** Exchange rate should be multiplied to get the converted amount in the transaction currency. */
  MULTIPLIER = 'MULTIPLIER',
  /** Unknown calculation method. */
  UNKNOWN = 'UNKNOWN'
}

/** Exchange rate details for an account transaction */
export type AccountTransactionExchangeRateDetails = {
  __typename: 'AccountTransactionExchangeRateDetails';
  calculationMethod: AccountTransactionExchangeRateCalculationMethod;
  rate: Maybe<Scalars['Float']['output']>;
};

/** Details about an account transaction initiation */
export type AccountTransactionInitiation = {
  __typename: 'AccountTransactionInitiation';
  /** A description of the application used to make the payment */
  applicationDescription: Maybe<Scalars['String']['output']>;
  /** The initiator's kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** The initiator's name */
  name: Maybe<Scalars['String']['output']>;
};

/** Object containing permission details for a transaction */
export type AccountTransactionPermissions = {
  __typename: 'AccountTransactionPermissions';
  /** Field showing whether the user can or cannot generate the PDF receipt for an account transaction */
  canGeneratePdfReceipt: Scalars['Boolean']['output'];
  /** Field showing whether the user can or cannot send (sms or email) correspondence for an account transaction */
  canSendCorrespondence: Scalars['Boolean']['output'];
};

export type AccountTransactionReceipt = {
  __typename: 'AccountTransactionReceipt';
  createdDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  receiptText: Scalars['String']['output'];
  receiver: Scalars['String']['output'];
  sentDate: Scalars['DateTimeISO']['output'];
  /** @deprecated Redundant field. Since: 2026-04-30. Issue to remove it: WEB-42487 */
  status: AccountTransactionReceiptStatus;
  type: AccountTransactionReceiptType;
};

export enum AccountTransactionReceiptStatus {
  SendingFailed = 'SendingFailed',
  SentSuccessfully = 'SentSuccessfully',
  Waiting = 'Waiting'
}

export enum AccountTransactionReceiptType {
  Address = 'Address',
  Email = 'Email',
  PhoneNumber = 'PhoneNumber'
}

/** Type of bulk account permission update operation */
export enum AccountUpdateType {
  BY_ACCOUNT = 'BY_ACCOUNT',
  BY_USER = 'BY_USER'
}

export type AccountUserAccessAuthorization = {
  __typename: 'AccountUserAccessAuthorization';
  /** If user can transfer */
  canTransfer: Scalars['Boolean']['output'];
  /** If user can view */
  canView: Scalars['Boolean']['output'];
  /** ID (Global) of the authorization object */
  id: Scalars['ID']['output'];
  /** Kennitala */
  kennitala: Scalars['String']['output'];
  /** User full name */
  name: Scalars['String']['output'];
  /** User name */
  username: Scalars['String']['output'];
};

export type AccountUserAccessAuthorizationConnection = {
  __typename: 'AccountUserAccessAuthorizationConnection';
  /** Overall access level for the users. Will have a value if all users have the same access level in the connection. Note that UsersAuthorizationFilterArgs.withAccessOnly affect the value of this field. */
  allAccess: Maybe<AccountAccessLevel>;
  /** Overall access level for the users. Will have a value if all users have the same access level in the connection. Note that UsersAuthorizationFilterArgs.withAccessOnly affect the value of this field. */
  allAuthorizationAccessLevel: Maybe<AuthorizationAccessLevel>;
  edges: Array<AccountUserAccessAuthorizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccountUserAccessAuthorizationEdge = {
  __typename: 'AccountUserAccessAuthorizationEdge';
  cursor: Scalars['String']['output'];
  node: AccountUserAccessAuthorization;
};

/** Fields that users can be ordered by */
export enum AccountUsersAuthorizationOrderByOptions {
  KENNITALA = 'KENNITALA',
  NAME = 'NAME',
  READ_ACCESS = 'READ_ACCESS',
  TRANSFER_ACCESS = 'TRANSFER_ACCESS',
  USERNAME = 'USERNAME'
}

export type AccountsAuthorizationOrderBy = {
  /** Direction to order accounts by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order accounts by */
  field: AccountsAuthorizationOrderByOptions;
};

/** Fields that accounts can be ordered by */
export enum AccountsAuthorizationOrderByOptions {
  DISPLAY_NUMBER = 'DISPLAY_NUMBER',
  OWNER_NAME = 'OWNER_NAME',
  OWNER_NATIONAL_ID = 'OWNER_NATIONAL_ID',
  READ_ACCESS = 'READ_ACCESS',
  TRANSFER_ACCESS = 'TRANSFER_ACCESS'
}

/** Aggregated monthly statistics and totals across all savings accounts */
export type AccountsMonthlyStatisticsInfo = {
  __typename: 'AccountsMonthlyStatisticsInfo';
  /** Aggregated monthly statistics across all accounts for the last 12 months including the current month (13 months total) */
  aggregatedMonthlyStatistics: Array<AccountMonthlyStatisticInfo>;
  /** Total statistics aggregated across all accounts for the last 12 months (excluding current month). Is null when there are no accounts */
  aggregatedTotals: Maybe<StatisticTotalsInfo>;
};

/** Push notification settings on all of customer's accounts. */
export type AccountsPushNotificationsSettings = {
  __typename: 'AccountsPushNotificationsSettings';
  /** Settings for deposit notifications on all of customers accounts. */
  deposits: PushNotificationsSettingWithAmount;
  /** Global Id for accounts settings - unique per customer */
  id: Scalars['ID']['output'];
  /** Settings for low balance notifications on all of customers accounts. */
  lowBalanceThreshold: PushNotificationsSettingWithAmount;
  /** Settings for notifications on customers proxied accounts. */
  proxiedAccounts: PushNotificationsSetting;
};

/** Accounts widget */
export type AccountsWidget = {
  __typename: 'AccountsWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type Acquiring = {
  __typename: 'Acquiring';
  /** ID (Global) of the acquiring object */
  id: Scalars['ID']['output'];
  merchants: Array<AcquiringMerchant>;
  settlements: AcquiringSettlementStatementConnection;
  settlementsExcel: GenericFile;
  singleSettlementTransactions: AcquiringSettlementTransactionConnection;
  singleSettlementTransactionsExcel: GenericFile;
  summaries: AcquiringSummaries;
  transactionFeeSummary: AcquiringSettlementTransactionFeeSummary;
  transactions: AcquiringSettlementTransactionConnection;
  transactionsExcel: GenericFile;
  transactionsFilterOptions: AcquiringSettlementTransactionsFilterOptions;
};


export type AcquiringSettlementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AcquiringSettlementFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AcquiringSettlementOrderBy>;
};


export type AcquiringSettlementsExcelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AcquiringSettlementFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AcquiringSettlementOrderBy>;
};


export type AcquiringSingleSettlementTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AcquiringSettlementTransactionsOrderBy>;
  settlementId: Scalars['ID']['input'];
};


export type AcquiringSingleSettlementTransactionsExcelArgs = {
  settlementId: Scalars['ID']['input'];
};


export type AcquiringSummariesArgs = {
  filter: AcquiringSummariesFilterArgs;
};


export type AcquiringTransactionFeeSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type AcquiringTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AcquiringSettlementTransactionFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AcquiringSettlementTransactionsOrderBy>;
};


export type AcquiringTransactionsExcelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: AcquiringSettlementTransactionFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AcquiringSettlementTransactionsOrderBy>;
};

export type AcquiringContactInput = {
  email: Scalars['String']['input'];
  mobileNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AcquiringEcommerce = {
  __typename: 'AcquiringEcommerce';
  ecommerceSystem: Scalars['String']['output'];
};

export type AcquiringEcommerceInput = {
  ecommerceSystem: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type AcquiringEcommerceOrderBy = {
  field: AcquiringEcommerceSortByOptions;
};

export enum AcquiringEcommerceSortByOptions {
  ECOMMERCE_SYSTEM = 'ECOMMERCE_SYSTEM'
}

export type AcquiringLocationInput = {
  address: Scalars['String']['input'];
  checkoutSystem: Scalars['String']['input'];
  deliveryDays: Scalars['Float']['input'];
  ecommerce: AcquiringEcommerceInput;
  monthlyCardTurnover: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  percentageOfNonImmediateDelivery?: InputMaybe<Scalars['Float']['input']>;
  postCode: Scalars['Float']['input'];
  terminals?: InputMaybe<Array<AcquiringTerminalsInput>>;
  typeOfBusiness: Scalars['String']['input'];
};

export type AcquiringMerchant = {
  __typename: 'AcquiringMerchant';
  /** ID (Global) of the merchant */
  id: Scalars['ID']['output'];
  /** Merchant kennitala */
  kennitala: Scalars['String']['output'];
  /** List of locations for merchant grouped by currency */
  locationByCurrency: Array<LocationGroupedByCurrencyEntry>;
  /** Merchant name */
  name: Scalars['String']['output'];
  /** List of currencies for merchant */
  settlementCurrencies: Array<Scalars['String']['output']>;
  /** Starting date */
  startingDate: Scalars['Date']['output'];
};

export type AcquiringMerchantLocation = {
  __typename: 'AcquiringMerchantLocation';
  /** Merchant location client number */
  clientNumber: Scalars['String']['output'];
  /** ID of the merchant location */
  id: Scalars['ID']['output'];
  /** Merchant location name */
  name: Scalars['String']['output'];
  /** Merchant location settlement info */
  settlementInformation: AcquiringMerchantLocationSettlementInfo;
};

export type AcquiringMerchantLocationSettlementInfo = {
  __typename: 'AcquiringMerchantLocationSettlementInfo';
  /** Account ID of the settlement information */
  accountId: Scalars['String']['output'];
  /** Currency of the settlement information */
  currency: Scalars['String']['output'];
};

export type AcquiringPeriodSummaries = {
  __typename: 'AcquiringPeriodSummaries';
  /** Details for the period */
  summaryDetails: Array<AcquiringSummariesPeriodDetails>;
};

export type AcquiringPreApplicationInput = {
  averageTransactionAmount: Scalars['Float']['input'];
  contact: AcquiringContactInput;
  isBlended: Scalars['Boolean']['input'];
  isInterchange: Scalars['Boolean']['input'];
  /** Kennitala of the business applying for the service. */
  kennitala: Scalars['String']['input'];
  locations: Array<AcquiringLocationInput>;
  name: Scalars['String']['input'];
  percentageOfForeignCardTurnover: Scalars['Float']['input'];
  percentageOfMobilePaymentTurnover?: InputMaybe<Scalars['Float']['input']>;
  /** Account number */
  settlementAccount: Scalars['String']['input'];
};

export type AcquiringSettlement = {
  __typename: 'AcquiringSettlement';
  appliedQuery: AcquiringSettlementAppliedQuery;
  dailySummaries: Array<AcquiringSettlementDailySummary>;
  totalSummary: AcquiringSettlementTotalSummary;
};

/** The query parameters that were applied to fetch the settlements. */
export type AcquiringSettlementAppliedQuery = {
  __typename: 'AcquiringSettlementAppliedQuery';
  period: CalendarPeriod;
};

export type AcquiringSettlementContractInfo = {
  __typename: 'AcquiringSettlementContractInfo';
  hasAccess: Scalars['Boolean']['output'];
  hasAcquiringSettlementContract: Scalars['Boolean']['output'];
  hasAcquiringSettlementEcomContract: Scalars['Boolean']['output'];
};

export type AcquiringSettlementDailySummary = {
  __typename: 'AcquiringSettlementDailySummary';
  /** Date of transactions summary */
  date: Scalars['DateTimeISO']['output'];
  /** Total amount of sales for the day */
  salesAmount: CurrencyAmount;
  /** Total number of sales for the day */
  salesVolume: Scalars['Int']['output'];
};

export type AcquiringSettlementFilterArgs = {
  /** Merchant RS2 client number */
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date range start */
  dateFrom: Scalars['Date']['input'];
  /** Date range end */
  dateTo: Scalars['Date']['input'];
  /** Merchant kennitala */
  merchantKennitala?: InputMaybe<Scalars['String']['input']>;
};

export type AcquiringSettlementOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: AcquiringSettlementOrderByOptions;
};

export enum AcquiringSettlementOrderByOptions {
  CLIENT_NUMBER = 'CLIENT_NUMBER',
  DEDUCTIONS_AMOUNT = 'DEDUCTIONS_AMOUNT',
  SETTLEMENT_AMOUNT = 'SETTLEMENT_AMOUNT',
  SETTLEMENT_DATE = 'SETTLEMENT_DATE',
  SETTLEMENT_ID = 'SETTLEMENT_ID',
  TOTAL_FEES_AMOUNT = 'TOTAL_FEES_AMOUNT',
  TRADE_NAME = 'TRADE_NAME',
  TURNOVER_AMOUNT = 'TURNOVER_AMOUNT'
}

export type AcquiringSettlementStatement = Node & {
  __typename: 'AcquiringSettlementStatement';
  /** Merchant RS2 client number */
  clientNumber: Scalars['String']['output'];
  /** Total amount of deductions in the settlement */
  deductionsAmount: CurrencyAmount;
  /** ID (Global) of the settlement */
  id: Scalars['ID']['output'];
  pdf: Maybe<GenericFile>;
  /** Amount for the settlement */
  settlementAmount: CurrencyAmount;
  /** Date of settlement */
  settlementDate: Scalars['DateTimeISO']['output'];
  /** ID (Api) of the settlement */
  settlementId: Scalars['String']['output'];
  /** Total amount of sales */
  totalSalesAmount: CurrencyAmount;
  /** Trade name */
  tradeName: Scalars['String']['output'];
  /** Total amount for the settlements turnover */
  turnoverAmount: CurrencyAmount;
};

export type AcquiringSettlementStatementConnection = {
  __typename: 'AcquiringSettlementStatementConnection';
  edges: Array<AcquiringSettlementStatementEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AcquiringSettlementStatementEdge = {
  __typename: 'AcquiringSettlementStatementEdge';
  cursor: Scalars['String']['output'];
  node: AcquiringSettlementStatement;
};

export type AcquiringSettlementTotalSummary = {
  __typename: 'AcquiringSettlementTotalSummary';
  /** Average sale amount per transaction */
  averageSaleAmount: CurrencyAmount;
  /** Total ecom transactions amount */
  ecomAmount: CurrencyAmount;
  /** Total number of ecom transactions */
  ecomVolume: Scalars['Int']['output'];
  /** Total fee amount (includes all additional fees, service charges, transaction fees, etc.) */
  feeAmount: CurrencyAmount;
  /** Total pos transactions amount */
  posAmount: CurrencyAmount;
  /** Total number of pos transactions */
  posVolume: Scalars['Int']['output'];
  /** Total refunded amount */
  refundsAmount: CurrencyAmount;
  /** Total number of refunds */
  refundsVolume: Scalars['Int']['output'];
  /** Total reversal amount */
  reversalsAmount: CurrencyAmount;
  /** Total number of reversals */
  reversalsVolume: Scalars['Int']['output'];
  /** Total sale amount */
  salesAmount: CurrencyAmount;
  /** Total number of sales */
  salesVolume: Scalars['Int']['output'];
  /** Total sale amount */
  settledAmount: CurrencyAmount;
};

export type AcquiringSettlementTransaction = {
  __typename: 'AcquiringSettlementTransaction';
  /** Reference number (Acquirer) */
  acquirerReference: Scalars['String']['output'];
  /** Total amount of sales */
  amount: CurrencyAmount;
  /** Authorization code */
  authorizationCode: Scalars['String']['output'];
  /** Card organization (e.g., Visa) */
  cardOrganization: Scalars['String']['output'];
  /** Card scheme (e.g., VISA-CREDIT) */
  cardScheme: Maybe<Scalars['String']['output']>;
  /** Type of card */
  cardType: Scalars['String']['output'];
  /** Merchant RS2 client number */
  clientNumber: Scalars['String']['output'];
  /** External reference */
  externalReference: Scalars['String']['output'];
  /** ID (Global) of the transaction */
  id: Scalars['ID']['output'];
  /** Issuer country code */
  issuerCountry: Scalars['String']['output'];
  /** Kennitala (Icelandic social security number) */
  kennitala: Scalars['String']['output'];
  /** Masked card number */
  maskedCardnumber: Scalars['String']['output'];
  /** Merchant ID */
  mid: Scalars['String']['output'];
  /** Organization name */
  organizationName: Scalars['String']['output'];
  /** Localized description of payment technology (e.g., ICC_CONTACTLESS) */
  paymentTechnology: Maybe<Scalars['String']['output']>;
  /** Processing date */
  processingDate: Scalars['DateTimeISO']['output'];
  /** Retrieval reference number */
  retrievalReference: Scalars['String']['output'];
  /** Sales channel */
  salesChannel: Maybe<AcquiringSettlementTransactionSalesChannel>;
  /** ID (Api) of the settlement */
  settlementId: Maybe<Scalars['String']['output']>;
  /** Stan */
  stan: Scalars['String']['output'];
  /** Terminal ID */
  terminalId: Scalars['String']['output'];
  /** Transaction category */
  transactionCategory: AcquiringSettlementTransactionCategory;
  /** Date of settlement */
  transactionDate: Scalars['DateTimeISO']['output'];
  /** Transaction slip number */
  transactionSlip: Scalars['String']['output'];
};

export type AcquiringSettlementTransactionCategory = {
  __typename: 'AcquiringSettlementTransactionCategory';
  /** Transaction category name */
  description: Scalars['String']['output'];
  /** Transaction category type */
  type: AcquiringSettlementTransactionType;
};

export type AcquiringSettlementTransactionConnection = {
  __typename: 'AcquiringSettlementTransactionConnection';
  edges: Array<AcquiringSettlementTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AcquiringSettlementTransactionEdge = {
  __typename: 'AcquiringSettlementTransactionEdge';
  cursor: Scalars['String']['output'];
  node: AcquiringSettlementTransaction;
};

export type AcquiringSettlementTransactionFeeSummary = {
  __typename: 'AcquiringSettlementTransactionFeeSummary';
  /** The bank's commission fee (Þóknun Landsbankans). */
  bankCommissionFees: Maybe<CurrencyAmount>;
  /** Interchange fees paid to the issuing bank (Millibankagjald). */
  interchangeFees: Maybe<CurrencyAmount>;
  /** Fees charged by the service provider / platform (Gjald þjónustuaðila). */
  platformFees: Maybe<CurrencyAmount>;
  /** Card scheme fees charged by the card networks (Skemagjöld). */
  schemeFees: Maybe<CurrencyAmount>;
  /** The total amount of fees for the given transaction. */
  totalFees: Maybe<CurrencyAmount>;
  /** The bank's per-transaction fee (Færslugjald Landsbankans). */
  transactionFees: Maybe<CurrencyAmount>;
};

export type AcquiringSettlementTransactionFilterArgs = {
  /** Min transaction to filter */
  amountFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Max transaction to filter */
  amountTo?: InputMaybe<Scalars['Int']['input']>;
  /** Authorization number */
  authorizationCode?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of the car number */
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  /** Merchant RS2 client number */
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date range start */
  dateFrom: Scalars['Date']['input'];
  /** Date range end */
  dateTo: Scalars['Date']['input'];
  /** Merchant kennitala */
  merchantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Transaction sales channel type */
  salesChannel?: InputMaybe<AcquiringSettlementTransactionSalesChannelType>;
  /** Free text search term */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** POS equipment terminal ID */
  terminalId?: InputMaybe<Scalars['String']['input']>;
  /** Transaction category type */
  transactionCategory?: InputMaybe<AcquiringSettlementTransactionType>;
};

export enum AcquiringSettlementTransactionOrderByOptions {
  AUTHORIZATION_CODE = 'AUTHORIZATION_CODE',
  CARD_NUMBER = 'CARD_NUMBER',
  SALES_CHANNEL = 'SALES_CHANNEL',
  TRANSACTION_AMOUNT = 'TRANSACTION_AMOUNT',
  TRANSACTION_CATEGORY = 'TRANSACTION_CATEGORY',
  TRANSACTION_DATE = 'TRANSACTION_DATE'
}

export type AcquiringSettlementTransactionSalesChannel = {
  __typename: 'AcquiringSettlementTransactionSalesChannel';
  /** Transaction sales channel description */
  description: Scalars['String']['output'];
  /** Transaction sales channel type */
  type: AcquiringSettlementTransactionSalesChannelType;
};

export enum AcquiringSettlementTransactionSalesChannelType {
  ECOMMERCE = 'ECOMMERCE',
  MAIL = 'MAIL',
  MOTO = 'MOTO',
  PHONE = 'PHONE',
  POS = 'POS',
  UNKNOWN = 'UNKNOWN'
}

export enum AcquiringSettlementTransactionType {
  REFUND = 'REFUND',
  REVERSAL = 'REVERSAL',
  SALE = 'SALE',
  UNKNOWN = 'UNKNOWN'
}

export type AcquiringSettlementTransactionsFilterOptions = {
  __typename: 'AcquiringSettlementTransactionsFilterOptions';
  /** List of sales channels */
  salesChannels: Array<AcquiringSettlementTransactionSalesChannel>;
  /** List of transaction categories */
  transactionCategories: Array<AcquiringSettlementTransactionCategory>;
};

export type AcquiringSettlementTransactionsOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: AcquiringSettlementTransactionOrderByOptions;
};

export type AcquiringSummaries = {
  __typename: 'AcquiringSummaries';
  /** Average sales amount */
  averageSaleAmount: CurrencyAmount;
  /** Stats by country */
  countries: Array<AcquiringSummariesCountryStatistics>;
  /** Total e-com amount */
  ecomAmount: CurrencyAmount;
  /** Total e-com volume */
  ecomVolume: Scalars['Float']['output'];
  /** Total fees amount */
  feesAmount: CurrencyAmount;
  /** Stats by merchant location */
  merchantLocations: Array<AcquiringSummariesMerchantLocation>;
  /** Period summary statistics based on the selected period type */
  periodSummary: Maybe<AcquiringPeriodSummaries>;
  /** Total POS amount */
  posAmount: CurrencyAmount;
  /** Total POS volume */
  posVolume: Scalars['Float']['output'];
  /** Total refunds amount */
  refundsAmount: CurrencyAmount;
  /** Total refunds volume */
  refundsVolume: Scalars['Float']['output'];
  /** Total reversals amount */
  reversalsAmount: CurrencyAmount;
  /** Total reversals volume */
  reversalsVolume: Scalars['Float']['output'];
  /** Total sales amount */
  salesAmount: CurrencyAmount;
  /** Settlement amount */
  settledAmount: CurrencyAmount;
};

export type AcquiringSummariesCountryStatistics = {
  __typename: 'AcquiringSummariesCountryStatistics';
  /** Country name */
  country: Scalars['String']['output'];
  /** Percents of the sales done by this country */
  salesVolumePercentage: Scalars['Float']['output'];
};

export type AcquiringSummariesFilterArgs = {
  /** Merchant RS2 client number */
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  /** Currency (code) of the settlement */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Date range start */
  dateFrom: Scalars['Date']['input'];
  /** Date range end */
  dateTo: Scalars['Date']['input'];
  /** Merchant kennitala */
  merchantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Period to get the data (monthly/daily) */
  periodType: AcquiringSummariesPeriodType;
};

export type AcquiringSummariesMerchantLocation = {
  __typename: 'AcquiringSummariesMerchantLocation';
  /** Total sales by this location */
  amount: CurrencyAmount;
  /** Merchant location client number */
  clientNumber: Scalars['String']['output'];
  /** Merchant name */
  name: Scalars['String']['output'];
};

export type AcquiringSummariesPeriodDetails = {
  __typename: 'AcquiringSummariesPeriodDetails';
  /** Date of the transaction */
  date: Scalars['Date']['output'];
  /** Total sales daily amount */
  salesAmount: CurrencyAmount;
};

export enum AcquiringSummariesPeriodType {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY'
}

export type AcquiringTerminal = {
  __typename: 'AcquiringTerminal';
  acquiringTerminalId: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  isMobile: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type AcquiringTerminalOrderBy = {
  field: AcquiringTerminalSortByOptions;
};

export enum AcquiringTerminalSortByOptions {
  FRIENDLY_NAME = 'FRIENDLY_NAME',
  IS_MOBILE = 'IS_MOBILE',
  TYPE = 'TYPE'
}

export type AcquiringTerminalsInput = {
  numberOf: Scalars['Float']['input'];
  type: Scalars['String']['input'];
};

/** Acquiring widget */
export type AcquiringWidget = {
  __typename: 'AcquiringWidget';
  /** Acquiring widget data */
  data: Maybe<AcquiringWidgetData>;
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

/** Acquiring widget data */
export type AcquiringWidgetData = {
  __typename: 'AcquiringWidgetData';
  /** Total sale in the last thirty days before and including yesterday */
  saleLastThirtyDays: CurrencyAmount;
  /** Total sale yesterday */
  saleYesterday: Maybe<CurrencyAmount>;
};

export type ActiveCompanyOnboarding = Error & {
  __typename: 'ActiveCompanyOnboarding';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ActiveOverdraftApplication = {
  __typename: 'ActiveOverdraftApplication';
  /** Date until which the overdraft is valid */
  dateTo: Scalars['DateTimeISO']['output'];
  /** The ID of the loan application */
  loanApplicationId: Scalars['String']['output'];
  /** The requested overdraft amount */
  requestedAmount: Scalars['Float']['output'];
  /** The status of the overdraft application */
  status: LoanApplicationStatus;
};

export type ActiveOverdraftApplicationResponse = LoanAccessForbiddenError | OverdraftApplication;

export type ActiveOverdraftApplicationsFilterArgs = {
  /** Indicates whether the account behind the application currently has overdraft enabled */
  accountHasActiveOverdraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** Exclude active overdraft applications with this status, or list of statuses */
  excludeStatus?: InputMaybe<Array<LoanApplicationStatus>>;
};

export type ActiveOverdraftApplicationsResponse = LoanAccessForbiddenError | OverdraftApplications;

/** Active real estate loan application */
export type ActiveRealEstateLoanApplication = {
  __typename: 'ActiveRealEstateLoanApplication';
  amount: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  creditAssessment: Maybe<CreditAssessment>;
  /** The active comment is a comment on the customers credit assessment. */
  customerHasActiveComment: Scalars['Boolean']['output'];
  hasLoanRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  increaseAmount: Scalars['Float']['output'];
  isAutomaticProcess: Scalars['Boolean']['output'];
  isManualProcess: Scalars['Boolean']['output'];
  /** Indicates if the loan application is a refinancing application */
  isRefinance: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  loanApplicationSignatureStatus: LoanApplicationSignatureStatus;
  minMaxLoanResult: Maybe<RealEstateLoanApplicationOptionsResult>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  paymentsPerMonth: Maybe<LoanApplicationPaymentsPerMonthResult>;
  realEstateLoanApplication: Maybe<RealEstateLoanApplication>;
  status: LoanApplicationStatus;
  type: LoanApplicationType;
};


/** Active real estate loan application */
export type ActiveRealEstateLoanApplicationPaymentsPerMonthArgs = {
  loanAmount: Scalars['Float']['input'];
};

export type ActiveSavingMethodsInfo = {
  __typename: 'ActiveSavingMethodsInfo';
  /** The active Credit Card Saving linked to the savings goal */
  creditCardSavingsInfo: Maybe<CardSavingsInfo>;
  /** The active Debit Card Saving linked to the savings goal */
  debitCardSavingsInfo: Maybe<CardSavingsInfo>;
  incomeRatioInfo: IncomeRatioInfo;
  periodicPayment: Maybe<PeriodicPayment>;
};

export type ActivityType = {
  __typename: 'ActivityType';
  availableServiceLocation: Array<SmartBookingServiceLocation>;
  type: ConsultationType;
};

/** An actor in the system such as a user */
export type Actor = {
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Result of an adaptive authentication risk evaluation, containing the required follow-up action */
export type AdaptiveAuthentication = {
  __typename: 'AdaptiveAuthentication';
  /** The action the user must complete to proceed */
  action: AdaptiveAuthenticationActionResponse;
  /** Identifier of the adaptive authentication transaction */
  transactionId: Scalars['String']['output'];
};

/** The action required to complete adaptive authentication */
export type AdaptiveAuthenticationActionResponse = AdaptiveAuthenticationBiometricAction | AdaptiveAuthenticationDenyAction | AdaptiveAuthenticationPhoneCallAction | AdaptiveAuthenticationQuestionAction | AdaptiveAuthenticationSecurityCodeAction | AdaptiveAuthenticationSmsAction;

/** Types of adaptive authentication actions */
export enum AdaptiveAuthenticationActionType {
  /** Allow the action without further authentication */
  ALLOW = 'ALLOW',
  /** Use biometric authentication (e.g., fingerprint, facial recognition) */
  BIOMETRIC = 'BIOMETRIC',
  /** Deny the action outright */
  DENY = 'DENY',
  /** Make a phone call to the user with a one-time code */
  PHONE_CALL = 'PHONE_CALL',
  /** Ask the user a security question */
  QUESTIONS = 'QUESTIONS',
  SECURITY_CODE = 'SECURITY_CODE',
  /** Send an SMS to the user with a one-time code */
  SMS = 'SMS'
}

/** Action requiring the user to verify with biometrics (e.g. fingerprint, facial recognition) */
export type AdaptiveAuthenticationBiometricAction = {
  __typename: 'AdaptiveAuthenticationBiometricAction';
  type: AdaptiveAuthenticationActionType;
};

/** Confirmation of how the one-time code was delivered to the chosen phone number */
export type AdaptiveAuthenticationConfirmPhoneNumberResponse = AdaptiveAuthenticationPhoneCallPayload | AdaptiveAuthenticationSmsPayload;

/** Action denying the request outright, no further authentication is possible */
export type AdaptiveAuthenticationDenyAction = {
  __typename: 'AdaptiveAuthenticationDenyAction';
  type: AdaptiveAuthenticationActionType;
};

/** Action requiring the user to verify via a one-time code delivered by phone call */
export type AdaptiveAuthenticationPhoneCallAction = {
  __typename: 'AdaptiveAuthenticationPhoneCallAction';
  /** Phone numbers the call can be made to */
  phoneNumbers: Array<Scalars['String']['output']>;
  type: AdaptiveAuthenticationActionType;
};

/** Confirmation that a verification phone call was initiated */
export type AdaptiveAuthenticationPhoneCallPayload = {
  __typename: 'AdaptiveAuthenticationPhoneCallPayload';
  /** Phone number the call was made to */
  phoneNumber: Scalars['String']['output'];
  /** Security number displayed to the user to confirm during the call */
  securityNumber: Scalars['String']['output'];
};

/** Status of an adaptive authentication phone call step up */
export enum AdaptiveAuthenticationPhoneCallStatus {
  /** The phone call step up has failed */
  FAILED = 'FAILED',
  /** The phone call step up is still pending */
  PENDING = 'PENDING',
  /** The phone call step up was successful */
  SUCCESS = 'SUCCESS'
}

/** Action requiring the user to answer a security question */
export type AdaptiveAuthenticationQuestionAction = {
  __typename: 'AdaptiveAuthenticationQuestionAction';
  /** The security question the user must answer */
  question: Scalars['String']['output'];
  type: AdaptiveAuthenticationActionType;
};

/** Action requiring the user to enter their security code */
export type AdaptiveAuthenticationSecurityCodeAction = {
  __typename: 'AdaptiveAuthenticationSecurityCodeAction';
  type: AdaptiveAuthenticationActionType;
};

/** Action requiring the user to verify via a one-time code sent by SMS */
export type AdaptiveAuthenticationSmsAction = {
  __typename: 'AdaptiveAuthenticationSmsAction';
  /** Phone numbers the one-time code can be sent to */
  phoneNumbers: Array<Scalars['String']['output']>;
  type: AdaptiveAuthenticationActionType;
};

/** Confirmation that a one-time code was sent by SMS */
export type AdaptiveAuthenticationSmsPayload = {
  __typename: 'AdaptiveAuthenticationSmsPayload';
  /** Phone number the one-time code was sent to */
  phoneNumber: Scalars['String']['output'];
};

/** Result of answering an adaptive authentication step-up challenge */
export type AdaptiveAuthenticationStepUpChallengeResponse = {
  __typename: 'AdaptiveAuthenticationStepUpChallengeResponse';
  /** Security question to display for the next attempt after an incorrect answer, if provided */
  nextQuestion: Maybe<Scalars['String']['output']>;
  /** Number of attempts remaining before the request is denied */
  remainingAttempts: Maybe<Scalars['Int']['output']>;
  /** Whether the challenge was answered successfully */
  success: Scalars['Boolean']['output'];
};

export type AddCardTransactionAttachmentInput = {
  file: Scalars['Upload']['input'];
  transactionId: Scalars['ID']['input'];
};

export type AddCardTransactionAttachmentPayload = {
  __typename: 'AddCardTransactionAttachmentPayload';
  attachment: Maybe<CardTransactionAttachment>;
  /** Error object if there was an error deleting the attachment, null if successful */
  error: Maybe<AddCardTransactionAttachmentUnion>;
  filename: Maybe<Scalars['String']['output']>;
};

export type AddCardTransactionAttachmentUnion = CardTransactionNotFound | UnknownError;

export type AddCollateralToLoanApplicationError = UnknownError;

export type AddCollateralToLoanApplicationInput = {
  /** The loan product catalog type of the collateral to add */
  collateralProductCatalogId: LoanProductCatalogType;
  /** List of guarantors */
  guarantors: Array<CollateralGuarantorInput>;
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
};

/** The response payload from creating a collateral request */
export type AddCollateralToLoanApplicationPayload = {
  __typename: 'AddCollateralToLoanApplicationPayload';
  /** Collateral request attached to a loan application. Will be null if unsuccessful */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  error: Maybe<AddCollateralToLoanApplicationError>;
};

export type AddConversationResponseInput = {
  /** Id of the conversation to add the response to. Max length, enforced by Boost.ai API is 110 characters. */
  conversationId: Scalars['ID']['input'];
  /** Text response to add to the conversation. */
  text: Scalars['String']['input'];
};

export type AddConversationResponsePayload = {
  __typename: 'AddConversationResponsePayload';
  /** The response id of the added response. */
  addedResponseId: Maybe<Scalars['ID']['output']>;
  /** The conversation with the added replies if any. If the conversation status is VIRTUAL_AGENT then the responses from the chatbot will be included. */
  conversation: CustomerConversation;
};

export type AddExistingCollateralToLoanApplicationError = UnknownError;

export type AddExistingCollateralToLoanApplicationInput = {
  /** Global GraphQL Id of a loan application */
  loanApplicationId: Scalars['String']['input'];
};

/** Response payload from applying existing collaterals to a loan application */
export type AddExistingCollateralsToLoanApplicationPayload = {
  __typename: 'AddExistingCollateralsToLoanApplicationPayload';
  error: Maybe<AddExistingCollateralToLoanApplicationError>;
  success: Scalars['Boolean']['output'];
};

export type AddGiftCardInput = {
  /** bin can be used when fetching card via QR-code */
  bin?: InputMaybe<Scalars['String']['input']>;
  /** last 10 numbers of the card number, without the 4507 42 prefix */
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  cvv?: InputMaybe<Scalars['String']['input']>;
};

export type AddMultipleCardTransactionAttachmentsInput = {
  files: Array<Scalars['Upload']['input']>;
  transactionId: Scalars['ID']['input'];
};

export type AddMultipleCardTransactionAttachmentsPayload = {
  __typename: 'AddMultipleCardTransactionAttachmentsPayload';
  results: Array<AddCardTransactionAttachmentPayload>;
};

export type AddPaymentApprovalInput = {
  processIds: Array<Scalars['String']['input']>;
};

/**
 * Response type for the addPaymentApproval mutation
 * Contains the updated approvals and any errors that occurred during the process
 */
export type AddPaymentApprovalResponse = {
  __typename: 'AddPaymentApprovalResponse';
  approvals: Array<PaymentApproval>;
  errors: Array<PaymentApprovalError>;
};

/** Account numbers for depositing */
export type AdditionalAccounts = {
  __typename: 'AdditionalAccounts';
  /** Account number assigned to the allCost charge */
  allCostAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to allDefaultCharge */
  allDefaultChargeAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to default charge */
  defaultChargeAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to the defaultInterest */
  defaultInterestAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to noticeAndPaymentFee */
  noticeAndPaymentFeeAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to otherCost */
  otherCostAccount: Maybe<Scalars['String']['output']>;
  /** Account number assigned to the otherDefaultCost charge */
  otherDefaultCostAccount: Maybe<Scalars['String']['output']>;
};

/** Information about accounts for depositing */
export type AdditionalDepositingAccounts = {
  __typename: 'AdditionalDepositingAccounts';
  /** Combined list of account numbers */
  accounts: Maybe<AdditionalAccounts>;
  /** Information about first deduction and account */
  firstPrincipalDeduction: Maybe<DeductionAccountInfo>;
  /** Information about second deduction and account */
  secondPrincipalDeduction: Maybe<DeductionAccountInfo>;
  /** Information about third deduction and account */
  thirdPrincipalDeduction: Maybe<DeductionAccountInfo>;
};

export type Address = {
  __typename: 'Address';
  addressLine1: Maybe<Scalars['String']['output']>;
  addressLine2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<CustomerLocation>;
  isValid: Scalars['Boolean']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

/** Adult content was detected in the uploaded image */
export type AdultContentDetectedError = Error & {
  __typename: 'AdultContentDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AllowedCreditAssessmentApplicantPayload = {
  __typename: 'AllowedCreditAssessmentApplicantPayload';
  isAllowed: Scalars['Boolean']['output'];
};

/** The withdrawal account has insufficient funds */
export type AmountUnavailable = Error & {
  __typename: 'AmountUnavailable';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** File format of the annual statement to download */
export enum AnnualStatementFormat {
  EXCEL = 'EXCEL',
  PDF = 'PDF'
}

/** Annualized returns over various periods */
export type AnnualizedReturns = {
  __typename: 'AnnualizedReturns';
  fifteenYearReturn: Maybe<Scalars['Float']['output']>;
  fiveYearReturn: Maybe<Scalars['Float']['output']>;
  fourYearReturn: Maybe<Scalars['Float']['output']>;
  oneYearReturn: Maybe<Scalars['Float']['output']>;
  tenYearReturn: Maybe<Scalars['Float']['output']>;
  threeYearReturn: Maybe<Scalars['Float']['output']>;
  twoYearReturn: Maybe<Scalars['Float']['output']>;
};

export type AnswerStepUpSequrityQuestionInput = {
  answer: Scalars['String']['input'];
};

export type AnswerStepUpSequrityQuestionPayload = {
  __typename: 'AnswerStepUpSequrityQuestionPayload';
  /** The attempt information for SMS stepup */
  attempts: Maybe<RsaChallengeAttempts>;
  /** A new question to be answered in the case of a problem with previous answer */
  question: Maybe<Scalars['String']['output']>;
  /** Indication if the given request was successful */
  success: Scalars['Boolean']['output'];
};

/** Svör við tilhlýðileikamati, fyrir kaup og sölu í sjóðum */
export type AnswerTradingAppropriatenessTestInput = {
  education: GeneralKnowledgeAssessment;
  etfs: CategoryQuestionInput;
  experience: GeneralKnowledgeAssessment;
  investmentFunds: CategoryQuestionInput;
  jobExperience: GeneralKnowledgeAssessment;
  knowledge: GeneralKnowledgeAssessment;
  listedBonds: CategoryQuestionInput;
  listedEquities: CategoryQuestionInput;
  ucitsFunds: CategoryQuestionInput;
};

export enum AppleWalletCardStatus {
  /** The card can be added to Apple Wallet. */
  AVAILABLE = 'AVAILABLE',
  /** The card could be added if there were less tokens. The card is probably registered in too many devices. */
  TOO_MANY_TOKENS = 'TOO_MANY_TOKENS',
  /** The card cannot be added to Apple Wallet. */
  UNAVAILABLE = 'UNAVAILABLE'
}

/** Application Account */
export type ApplicationAccount = Node & {
  __typename: 'ApplicationAccount';
  /** Api key (client ID) of the client */
  apikey: Scalars['String']['output'];
  /** Certificates associated with the application account */
  certificates: Array<ApplicationAccountCertificate>;
  /** Application account description */
  description: Maybe<Scalars['String']['output']>;
  /** Indicates if the account has active certificates. True if a public certificate is present, or if any regular certificate is neither revoked nor expired. */
  hasActiveCertificates: Scalars['Boolean']['output'];
  /** ID (Global) of the application account */
  id: Scalars['ID']['output'];
  /** Linked B2B user. Resolving this triggers a downstream request per application account, so it should only be requested for a single application account (e.g. the details view) and not in list operations. */
  linkedB2BUser: Maybe<CompanyUser>;
  /** Linked B2B user name */
  linkedB2BUsername: Maybe<Scalars['String']['output']>;
  /** Application account name */
  name: Scalars['String']['output'];
  /** Permissions associated with the application account */
  permissions: Array<ApplicationAccountPermission>;
};

/** Application Account Certificate */
export type ApplicationAccountCertificate = {
  __typename: 'ApplicationAccountCertificate';
  /** Date the certificate expires */
  expires: Maybe<Scalars['Date']['output']>;
  /** ID (Global) of the certificate */
  id: Scalars['ID']['output'];
  /** Whether certificate is public or Landsbankinn */
  isPublic: Scalars['Boolean']['output'];
  /** Status of the certificate (whether it is revoked or active) */
  isRevoked: Maybe<Scalars['Boolean']['output']>;
  /** National ID (kennitala) of the account */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Name of the account */
  name: Maybe<Scalars['String']['output']>;
  /** Serial number of the account */
  serialNumber: Maybe<Scalars['String']['output']>;
};

/** Application Account Connection */
export type ApplicationAccountConnection = {
  __typename: 'ApplicationAccountConnection';
  edges: Array<ApplicationAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApplicationAccountEdge = {
  __typename: 'ApplicationAccountEdge';
  cursor: Scalars['String']['output'];
  node: ApplicationAccount;
};

export type ApplicationAccountIdInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
};

/** Payload for application account mutations (create, update, remove) */
export type ApplicationAccountMutationPayload = {
  __typename: 'ApplicationAccountMutationPayload';
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['output'];
};

/** Ordering options for application accounts */
export type ApplicationAccountOrderByInput = {
  /** Direction to order by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order by */
  field: ApplicationAccountOrderByOptionsInput;
};

/** Fields that application accounts can be ordered by */
export enum ApplicationAccountOrderByOptionsInput {
  /** Order by application account description */
  DESCRIPTION = 'DESCRIPTION',
  /** Order by application account name */
  NAME = 'NAME'
}

/** Application Account Permission */
export type ApplicationAccountPermission = {
  __typename: 'ApplicationAccountPermission';
  /** Permission type description */
  description: Scalars['String']['output'];
  /** Whether the permission is enabled */
  enabled: Scalars['Boolean']['output'];
  /** ID of the permission */
  id: Scalars['ID']['output'];
  /** Permission type name */
  name: Scalars['String']['output'];
};

/** From which application was the payment performed from */
export type ApplicationCode = {
  __typename: 'ApplicationCode';
  /** Enum representing the application code */
  code: PaymentApplicationCode;
  /** Name of the application in IS/EN depending on accept-language header */
  description: Maybe<Scalars['String']['output']>;
};

/** Everything to create a credit card application */
export type ApplyForCreditCard = {
  __typename: 'ApplyForCreditCard';
  /** Fetches delivery locations for plastic cards: customer addresses and branch locations. */
  deliveryLocations: Array<CreditCardDeliveryAddress>;
  /** Only, at least for now, for kids cards ("category": "Child"). Returns to those children for whom a child card (Vasapeningar) can be applied for. */
  familyMembers: Array<CreditCardApplicationFamilyMember>;
  prerequisitesV2: CardPrerequisite;
  /** @deprecated Reason: Use productsV2 instead, it handles the property that is outside of the data object. Removed: 2025-06-13. Issue(s) to remove it: WEB-30735 */
  products: Array<CreditCardProduct>;
  productsV2: CardProductDetails;
};


/** Everything to create a credit card application */
export type ApplyForCreditCardFamilyMembersArgs = {
  filter?: InputMaybe<CreditCardApplicationFamilyMembersFilterArgs>;
};


/** Everything to create a credit card application */
export type ApplyForCreditCardPrerequisitesV2Args = {
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardPrerequisiteType: CardPrerequisiteType;
  creditCardCategory: CreditCardCategory;
};


/** Everything to create a credit card application */
export type ApplyForCreditCardProductsV2Args = {
  cardCategory?: InputMaybe<CreditCardCategory>;
};

/** Input for applying for expense distribution */
export type ApplyForExpenseDistributionInput = {
  /** Account number of the account used for expense distribution */
  serviceAccountNumber: Scalars['String']['input'];
};

export type ApplyForExpenseDistributionPayload = {
  __typename: 'ApplyForExpenseDistributionPayload';
  /** True if it was successful to apply */
  success: Scalars['Boolean']['output'];
};

export type AppointmentNotFound = Error & {
  __typename: 'AppointmentNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ArchiveCompanyUserErrorUnion = UnknownError;

/** Input to archive a company user */
export type ArchiveCompanyUserInput = {
  /** Username of the company user to archive */
  username: Scalars['String']['input'];
};

/** Payload returned when archiving a company user */
export type ArchiveCompanyUserPayload = {
  __typename: 'ArchiveCompanyUserPayload';
  /** Error returned when archiving a company user fails */
  error: Maybe<ArchiveCompanyUserErrorUnion>;
  /** Whether archiving the company user was successful or not */
  success: Scalars['Boolean']['output'];
};

export enum AssessmentSubject {
  AukalanApplication = 'AukalanApplication',
  CreditCardChangeLimit = 'CreditCardChangeLimit',
  Lanarammi = 'Lanarammi',
  NewCreditCard = 'NewCreditCard',
  OverdraftApplication = 'OverdraftApplication'
}

export enum AssetCompositionType {
  Cash = 'Cash',
  Instrument = 'Instrument',
  SharesOutStanding = 'SharesOutStanding',
  Unknown = 'Unknown'
}

/** Result from initialization of Audkenni process */
export type AsyncInitializeSignatureProcessForAudkenniResult = {
  __typename: 'AsyncInitializeSignatureProcessForAudkenniResult';
  /** Poll id for `asyncInitializeSignatureProcessForAudkenni */
  id: Scalars['String']['output'];
};

/** Result from initialization of Audkenni process */
export type AsyncNextDigitalSignatureDocumentByIdResult = {
  __typename: 'AsyncNextDigitalSignatureDocumentByIdResult';
  /** Poll id for `asyncSignNextDigitalSignatureDocumentByIdResult */
  id: Scalars['String']['output'];
};

/** Atms */
export type Atm = Node & {
  __typename: 'Atm';
  currencies: Maybe<Array<Scalars['String']['output']>>;
  hasWheelchairAccess: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openingHours: AtmOpeningHour;
  type: Maybe<AtmType>;
};

/** ServicePointHours */
export type AtmOpeningHour = {
  __typename: 'AtmOpeningHour';
  text: Scalars['String']['output'];
  type: AtmOpeningHours;
};

/** Opening hours for atms */
export enum AtmOpeningHours {
  AlwaysOpen = 'AlwaysOpen',
  BranchHours = 'BranchHours',
  BusinessHours = 'BusinessHours',
  FullDay = 'FullDay',
  OnServiceHour = 'OnServiceHour',
  TemporarilyClosed = 'TemporarilyClosed',
  TenToFour = 'TenToFour',
  Unknown = 'Unknown'
}

/** Types of Atm. f.x. deposit or currency */
export enum AtmType {
  Atm = 'Atm',
  CoinCounterAtm = 'CoinCounterAtm',
  CoinRollAtm = 'CoinRollAtm',
  Contactless = 'Contactless',
  CorporateDepositAtm = 'CorporateDepositAtm',
  CurrencyAtm = 'CurrencyAtm',
  DepositAtm = 'DepositAtm',
  GiftCardAtm = 'GiftCardAtm'
}

/** Result from initialization of Audkenni process */
export type AudkenniSignatureInitializationResult = {
  __typename: 'AudkenniSignatureInitializationResult';
  /** Error returned after an unsuccessful initialization */
  error: Maybe<SignDigitalSignatureGroupDocumentsError>;
  /** Payload of a successful initialization */
  payload: Maybe<InitializeSignatureProcessForAudkenniPayload>;
  status: AudkenniSignatureInitializationStatus;
};

/** The status of the `asyncInitializeSignatureProcessForAudkenni` */
export enum AudkenniSignatureInitializationStatus {
  /** Audkenni has returned a result(error or otherwise) */
  READY = 'READY',
  /** Something has gone horribly wrong. Treat as error */
  UNKNOWN = 'UNKNOWN',
  /** Audkenni has not responded */
  WAITING = 'WAITING'
}

/** Aukakronur information */
export type Aukakronur = Node & {
  __typename: 'Aukakronur';
  /** Use accumulatedV2 instead, Since: 2026-04-29. Issue(s) to remove it: WEB-42427 */
  accumulated: AukakronurAccumulated;
  /** List of accumulated Aukakronur points over a period of time. If year argument is provided, list will contain only one item for the specified year. If year argument is not provided, list will contain items last 12 months, so it could contain 2 items if the period covers 2 calendar years */
  accumulatedV2: Array<AukakronurAccumulated>;
  activeCardId: Scalars['Int']['output'];
  /** Total earned amount of the customer in Aukakronur since the beginning. */
  allTimeEarned: Maybe<Scalars['Float']['output']>;
  /** Checks if the user can add this card to Apple Wallet. */
  appleWalletCardStatus: AppleWalletCardStatus;
  /** Total amount of the customer in Aukakronur. Fund + Card balance. If total amount is more than card balance, then it mean the fund hasn't transferred to the card yet. */
  availableAmount: Scalars['Float']['output'];
  /** If true, then card can be added to mobile wallet products. */
  canAddToPaymentService: Scalars['Boolean']['output'];
  canSeePrivateInfo: Scalars['Boolean']['output'];
  canToggleFrozenStatus: Scalars['Boolean']['output'];
  /** Balance of the Aukakronur Card. */
  cardBalance: Maybe<Scalars['Float']['output']>;
  cardHolderName: Scalars['String']['output'];
  cardNumber: Maybe<Scalars['String']['output']>;
  /** Expiration date for the virtual card behind the Aukakronur card. This date will be the last day in the month of expiration so the card will expire at midnight this day. If there is no plastic card available  */
  expirationDate: Maybe<Scalars['DateTimeISO']['output']>;
  fundId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Pan ID is used for registering card with mobile wallet products. */
  panId: Maybe<Scalars['String']['output']>;
  privateInfo: CardPrivateInfoResponse;
  privateInfoV2: CardPrivateInfoResultV2;
  state: AukakronurCardState;
  status: CardStatus;
  transactions: AukakronurTransactionConnection;
  type: CreditCardType;
  virtualCardNumberMasked: Maybe<Scalars['String']['output']>;
};


/** Aukakronur information */
export type AukakronurAccumulatedArgs = {
  year?: InputMaybe<Scalars['String']['input']>;
};


/** Aukakronur information */
export type AukakronurAccumulatedV2Args = {
  year?: InputMaybe<Scalars['String']['input']>;
};


/** Aukakronur information */
export type AukakronurTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  filter?: InputMaybe<TransactionFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionsOrderBy>;
};

export type AukakronurAccumulated = {
  __typename: 'AukakronurAccumulated';
  /**
   *
   *     Array of 12 numbers where first item is for January, second for February etc.
   *
   */
  data: Array<AukakronurAccumulatedData>;
  total: Scalars['Float']['output'];
  year: Scalars['String']['output'];
};

/** Aukakronur amount accumulated on a given date. */
export type AukakronurAccumulatedData = {
  __typename: 'AukakronurAccumulatedData';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export enum AukakronurCardState {
  Closed = 'Closed',
  Created = 'Created',
  Deprecated = 'Deprecated',
  Destroyed = 'Destroyed',
  NoCard = 'NoCard',
  Open = 'Open',
  Sold = 'Sold',
  Terminated = 'Terminated'
}

export type AukakronurCustomer = {
  __typename: 'AukakronurCustomer';
  /** User has access to Aukakrónur and can receive aukakronur from other customers. */
  hasAccessToAukakronur: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * User has access to Aukakrónur
   * @deprecated Reason: Use hasAccessToAukakronur instead. Since: 2024-10-15. Issue to remove it: WEB-28932
   */
  isActive: Scalars['Boolean']['output'];
};

export type AukakronurCustomerLookupResponse = AukakronurCustomer | AukakronurCustomerNotFound;

export type AukakronurCustomerNotFound = Error & {
  __typename: 'AukakronurCustomerNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Aukakronur partners */
export type AukakronurPartner = Node & {
  __typename: 'AukakronurPartner';
  /** The image blur hash for the partner logo */
  blurHash: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  locations: Array<AukakronurPartnerLocation>;
  /** The image ID for the partner logo */
  logoImageId: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  /** A list of product category types pertaining to the specific partner. */
  retailTypes: Maybe<Array<AukakronurPartnerType>>;
  totalNumberOfLocations: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};


/** Aukakronur partners */
export type AukakronurPartnerBlurHashArgs = {
  hashType?: InputMaybe<AukakronurPartnerLogoType>;
};

export type AukakronurPartnerConnection = {
  __typename: 'AukakronurPartnerConnection';
  edges: Array<AukakronurPartnerEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AukakronurPartnerEdge = {
  __typename: 'AukakronurPartnerEdge';
  cursor: Scalars['String']['output'];
  node: AukakronurPartner;
};

export type AukakronurPartnerLocation = {
  __typename: 'AukakronurPartnerLocation';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  /** @deprecated Use locationCoordinates instead. Since: 2026-07-15. Issue(s) to remove it: WEB-44563 */
  latitude: Scalars['Float']['output'];
  /** The coordinates of the location. Null if no coordinates are available. */
  locationCoordinates: Maybe<AukakronurPartnerLocationCoordinates>;
  /** @deprecated Use locationCoordinates instead. Since: 2026-07-15. Issue(s) to remove it: WEB-44563 */
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region: Region;
};

/** Coordinates for an aukakronur partner location */
export type AukakronurPartnerLocationCoordinates = {
  __typename: 'AukakronurPartnerLocationCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** Types of logos available for aukakronur partners  */
export enum AukakronurPartnerLogoType {
  /** A compact version of the logo */
  COMPACT = 'COMPACT',
  /** The original logo */
  ORIGINAL = 'ORIGINAL',
  /** Unknown type */
  UNKNOWN = 'UNKNOWN'
}

export type AukakronurPartnerOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  /** Field based on which we are ordering the results by */
  field?: InputMaybe<AukakronurPartnerOrderByOption>;
};

/** Criteria of ordering the items from the aukakronur partners */
export enum AukakronurPartnerOrderByOption {
  /** Sort by DISCOUNT */
  Discount = 'Discount',
  /** Sort by NAME */
  Name = 'Name'
}

export enum AukakronurPartnerType {
  Car = 'Car',
  Clothing = 'Clothing',
  Gifts = 'Gifts',
  Groceries = 'Groceries',
  Health = 'Health',
  Hobbies = 'Hobbies',
  Home = 'Home',
  Restaurants = 'Restaurants',
  Traveling = 'Traveling',
  Unknown = 'Unknown'
}

export type AukakronurPartnersFilterArgs = {
  /** Filter the Aukakronur companies (partners) by its kennitala. */
  partnerNationalId?: InputMaybe<Scalars['String']['input']>;
  /** Filter the Aukakronur companies (partners) to only include those with at least one retailer location in the specified region. */
  region?: InputMaybe<Region>;
  /** Filter the Aukakronur companies (partners) by a single retail type (e.g. Groceries, Health, Hobbies). */
  retailTypeId?: InputMaybe<AukakronurPartnerType>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

/** A retail type category for aukakronur partners */
export type AukakronurRetailType = {
  __typename: 'AukakronurRetailType';
  /** The name of the retail type category */
  name: Maybe<Scalars['String']['output']>;
  /** The retail type category as an enum */
  partnerType: AukakronurPartnerType;
  /** The unique identifier for the retail type category */
  retailTypeId: Scalars['String']['output'];
};

/** Financial transaction on aukakronur card */
export type AukakronurTransaction = Node & {
  __typename: 'AukakronurTransaction';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  transactionId: Scalars['String']['output'];
};

/** The query parameters that were applied to fetch the Aukakronur transactions in this connection */
export type AukakronurTransactionAppliedQuery = {
  __typename: 'AukakronurTransactionAppliedQuery';
  period: CalendarPeriod;
};

export type AukakronurTransactionConnection = {
  __typename: 'AukakronurTransactionConnection';
  /** The query parameters that were applied to fetch the aukakronur transactions */
  appliedQuery: AukakronurTransactionAppliedQuery;
  edges: Array<AukakronurTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AukakronurTransactionEdge = {
  __typename: 'AukakronurTransactionEdge';
  cursor: Scalars['String']['output'];
  node: AukakronurTransaction;
};

/** Aukakronur widget */
export type AukakronurWidget = {
  __typename: 'AukakronurWidget';
  /** Aukakronur widget data */
  data: Maybe<Aukakronur>;
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type AukalanLoanDurationInput = {
  /** The account number of the account that is connected to the overdraft that they want to refinance with Aukalan. */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The amount of Aukalan they want to take. */
  amount: Scalars['Int']['input'];
};

/** The auth source the IDP gave the logged in user */
export enum AuthSource {
  /** User is in business with Landsbankinn */
  CUSTOMER = 'CUSTOMER',
  /** User is within the organization (IT employee) */
  INTERNAL = 'INTERNAL',
  /** User is not in business with Landsbankinn */
  NATIONAL = 'NATIONAL',
  /** Unknown auth source */
  UNKNOWN = 'UNKNOWN'
}

/** Authenticator device that has been used to log in to onlinebanking, usually through the app */
export type Authenticator = Node & {
  __typename: 'Authenticator';
  description: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  registeredDate: Scalars['DateTimeISO']['output'];
  username: Scalars['String']['output'];
};

export type AuthenticatorConnection = {
  __typename: 'AuthenticatorConnection';
  edges: Array<AuthenticatorEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuthenticatorEdge = {
  __typename: 'AuthenticatorEdge';
  cursor: Scalars['String']['output'];
  node: Authenticator;
};

export enum Authority {
  Partial = 'Partial',
  Total = 'Total'
}

export type Authorization = {
  __typename: 'Authorization';
  /** All accounts with definition if the user has access to them */
  accounts: Maybe<AccountAuthorizationConnection>;
  /** Application accounts for the user */
  applicationAccounts: ApplicationAccountConnection;
  /** All cards with definition if the user has access to them */
  cards: Maybe<CardAuthorizationConnection>;
  /** Services available to the acting user (Company level) */
  companyServices: Maybe<Array<ServiceAuthorization>>;
  /** ID (Global) of the authorization */
  id: Scalars['ID']['output'];
  /** Is user access manager */
  isAccessManager: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Get authorization services */
  ownServices: Maybe<Array<ServiceAuthorization>>;
  /** Recommended services for the given access profile */
  recommendedServices: Array<ServiceType>;
  /** Get user roles */
  roles: Array<AuthorizationRoleType>;
  /** Get service permissions for a user */
  services: Maybe<Array<ServiceAuthorization>>;
  /** Get company users connected to current user's company through kennitala */
  users: CompanyUserConnection;
  /** Get withdrawal limit and limit used for acting user */
  withdrawalLimit: AuthorizationWithdrawalLimit;
};


export type AuthorizationAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionsAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountsAuthorizationOrderBy>;
  orderByFields?: InputMaybe<Array<AccountsAuthorizationOrderBy>>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationApplicationAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ApplicationAccountOrderByInput>;
};


export type AuthorizationCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionsAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardsAuthorizationOrderBy>;
  orderByFields?: InputMaybe<Array<CardsAuthorizationOrderBy>>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationCompanyServicesArgs = {
  filter?: InputMaybe<CompanyServicesAuthorizationFilter>;
  orderBy?: InputMaybe<ServicesAuthorizationOrderBy>;
};


export type AuthorizationOwnServicesArgs = {
  filter?: InputMaybe<OwnServicesAuthorizationFilter>;
  orderBy?: InputMaybe<ServicesAuthorizationOrderBy>;
};


export type AuthorizationRecommendedServicesArgs = {
  accessProfile: AccessProfile;
};


export type AuthorizationRolesArgs = {
  filter?: InputMaybe<UserRoleAuthorizationFilter>;
};


export type AuthorizationServicesArgs = {
  filter?: InputMaybe<ServicesAuthorizationFilter>;
  orderBy?: InputMaybe<ServicesAuthorizationOrderBy>;
  username?: InputMaybe<Scalars['String']['input']>;
};


export type AuthorizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CompanyUserFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Reusable access level for the `allAuthorizationAccessLevel` property of card and service authorization connections. For services, a backend `full` access level corresponds to `READ_ONLY`. */
export enum AuthorizationAccessLevel {
  NONE = 'NONE',
  READ_ONLY = 'READ_ONLY'
}

/** The role of the user in relation to company authorizations */
export enum AuthorizationRoleType {
  /** User is an access manager, meaning they can manage access to accounts and services for other users in the company */
  ACCESS_MANAGER = 'ACCESS_MANAGER',
  /** User has read access to access rights, meaning they can see what access other users have but cannot manage it themselves */
  ACCESS_RIGHTS_READ = 'ACCESS_RIGHTS_READ',
  /** User is a B2B user, meaning they have access to company services but do not have a specific role in managing access */
  B2B_USER = 'B2B_USER',
  /** User is a CEO of the company */
  CEO = 'CEO',
  /** User is responsible for daily operations in the company */
  DAILY_OPERATIONS = 'DAILY_OPERATIONS',
  /** User is a procurator for the company */
  PROCURATOR = 'PROCURATOR'
}

/** The type of service authorization */
export enum AuthorizationServiceType {
  /** Authorization service for claims */
  CLAIMS = 'CLAIMS',
  /** Authorization service for direct debit claimant */
  DIRECT_DEBIT_CLAIMANT = 'DIRECT_DEBIT_CLAIMANT'
}

export type AuthorizationWithdrawalLimit = {
  __typename: 'AuthorizationWithdrawalLimit';
  /** Maximum withdrawal limit for the acting user */
  limit: CurrencyAmount;
  /** Amount of the withdrawal limit already used by the acting user */
  used: Maybe<CurrencyAmount>;
};

/** Info for the total amount and the list of currently available amounts */
export type AvailableAmountInfo = {
  __typename: 'AvailableAmountInfo';
  /** List of currently available amounts and the respective details about them */
  amounts: Array<CurrentlyAvailableAmount>;
  /** The total amount of money summed from all the amounts in the list */
  total: CurrencyAmount;
};

export type AvailableRecipient = {
  __typename: 'AvailableRecipient';
  customerProxyId: Maybe<Scalars['String']['output']>;
  /** Describes whether the person has contributed to the selected saving. */
  hasContributed: Scalars['Boolean']['output'];
  /** Describes whether the person is related to the saving owner. */
  isFamilyMember: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Avatar image metadata for a user */
export type AvatarInfo = {
  __typename: 'AvatarInfo';
  /** BlurHash string for the avatar image, a compact algorithm that represents an image as a short, readable string */
  blurHash: Maybe<Scalars['String']['output']>;
  /** Cache key for the avatar image */
  cacheKey: Maybe<Scalars['String']['output']>;
  /** Global ID of the avatar info payload. Necessary for client caching. */
  id: Scalars['ID']['output'];
  /** Avatar image URL details for the current user, including URLs across every size and pixel density combination and an optional srcSet string. Provide size to filter URLs to a single size and include a srcSet for responsive image rendering. */
  urlDetail: Maybe<AvatarUrlDetail>;
};


/** Avatar image metadata for a user */
export type AvatarInfoUrlDetailArgs = {
  size: AvatarSize;
};

/** User avatar image size */
export enum AvatarSize {
  /** Large avatar size */
  LARGE = 'LARGE',
  /** Medium avatar size */
  MEDIUM = 'MEDIUM',
  /** Small avatar size */
  SMALL = 'SMALL',
  /** Extra small avatar size */
  XTRA_SMALL = 'XTRA_SMALL'
}

/** A resolved CDN URL for an avatar image at a specific size and pixel density */
export type AvatarUrl = {
  __typename: 'AvatarUrl';
  /** Pixel density of the avatar image */
  pixelDensity: PixelDensity;
  /** Size of the avatar image */
  size: AvatarSize;
  /** CDN URL for the avatar image */
  url: Scalars['String']['output'];
};

/** Avatar image URL details for a user, including a list of resolved CDN URLs across size and pixel density combinations and an optional srcSet string for responsive image rendering */
export type AvatarUrlDetail = {
  __typename: 'AvatarUrlDetail';
  /** List of avatar URLs for different sizes */
  avatarUrls: Maybe<Array<AvatarUrl>>;
  /** A srcSet CDN URL list for the avatar image usable for different view ports in clients when displaying responsive images. */
  srcSet: Maybe<Scalars['String']['output']>;
};

/** Terminated represents ClosedWithMoney and Unknown StatusType from Accounts 3.1 service */
export enum BankAccountState {
  Closed = 'Closed',
  Open = 'Open',
  Terminated = 'Terminated'
}

/** The query parameters that were applied to fetch the transactions in this connection. */
export type BankAccountTransactionAppliedQuery = {
  __typename: 'BankAccountTransactionAppliedQuery';
  period: CalendarPeriod;
};

export type BankAccountTransactionConnection = {
  __typename: 'BankAccountTransactionConnection';
  /** The query parameters that were applied to fetch the transactions in this connection. */
  appliedQuery: BankAccountTransactionAppliedQuery;
  edges: Array<AccountTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BankAccountTransactionUnion = AccountTransaction | PendingAccountTransaction;

export type BankAccountTransactionUnionConnection = {
  __typename: 'BankAccountTransactionUnionConnection';
  edges: Array<BankAccountTransactionUnionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BankAccountTransactionUnionEdge = {
  __typename: 'BankAccountTransactionUnionEdge';
  cursor: Scalars['String']['output'];
  node: BankAccountTransactionUnion;
};

export type BankAccountTransactionsUnionOrderBy = {
  direction: OrderByDirection;
  field: TransactionsOrderByOption;
};

export type BankNotFound = Error & {
  __typename: 'BankNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type BannerLocationInput = {
  /** Location of the recommendation banner. */
  bannerLocation: CustomerRecommendationBannerLocationType;
};

/** Contains beneficial owner information (raunverulegur eigandi fyrirtækis) */
export type BeneficialOwner = {
  __typename: 'BeneficialOwner';
  /** Questions already answered for the beneficial owner */
  answeredQuestions: Array<KycQuestionName>;
  /** Beneficial owner's Guid from the CRM system */
  beneficialOwnerId: Maybe<Scalars['String']['output']>;
  /** Citizenship in ISO format */
  citizenship: Maybe<Scalars['String']['output']>;
  /** Date of birth as DD/MM/YYYY formatted string */
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** Date of birth calendar date */
  dateOfBirthCalendarDate: Maybe<Scalars['Date']['output']>;
  /** Does the beneficial owner have direct ownership */
  directHolding: Scalars['Boolean']['output'];
  /** Does the beneficial owner have direct voting stake */
  directVoting: Scalars['Boolean']['output'];
  /** Does the beneficial owner have a foreign legal address */
  hasForeignLegalAddress: Scalars['Boolean']['output'];
  /** Percentage of holding stake */
  holding: Scalars['Float']['output'];
  /** Does the beneficial owner have indirect ownership */
  indirectHolding: Scalars['Boolean']['output'];
  /** Does the beneficial owner have indirect voting stake */
  indirectVoting: Scalars['Boolean']['output'];
  /** Beneficial owner's kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Beneficial owner's legal address */
  legalAddress: Address;
  /** Beneficial owner's name */
  name: Scalars['String']['output'];
  /** Tegund eignarhalds */
  ownershipTypes: Maybe<Array<Scalars['String']['output']>>;
  /** Is the owner politically exposed (Er eigandi tengdur innherjum) */
  politicallyExposedPerson: Maybe<Array<PoliticallyExposedPerson>>;
  /** Beneficial owner's tax residencies */
  taxResidencies: Maybe<Array<TaxResidency>>;
  /** Does the beneficial owner have a veto */
  veto: Scalars['Boolean']['output'];
  /** Percentage of voting stake */
  vote: Scalars['Float']['output'];
};

export type BeneficialOwnerInput = {
  /** Questions already answered for the beneficial owner */
  answeredQuestions?: InputMaybe<Array<KycQuestionName>>;
  /** Id in guid format from CRM */
  beneficialOwnerId?: InputMaybe<Scalars['String']['input']>;
  /** ISO country code */
  citizenship?: InputMaybe<Scalars['String']['input']>;
  /** String format DD/MM/YYYY */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  directHolding: Scalars['Boolean']['input'];
  directVoting: Scalars['Boolean']['input'];
  foreignLegalAddress?: InputMaybe<ForeignLegalAddressInput>;
  holding: Scalars['Float']['input'];
  indirectHolding: Scalars['Boolean']['input'];
  indirectVoting: Scalars['Boolean']['input'];
  kennitala?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  politicallyExposedPerson?: InputMaybe<Array<PoliticallyExposedPersonInput>>;
  /** Skattalegar heimilisfestir */
  taxResidencies?: InputMaybe<Array<TaxResidenciesInput>>;
  veto: Scalars['Boolean']['input'];
  vote: Scalars['Float']['input'];
};

export type BindingTime = {
  __typename: 'BindingTime';
  bindingTimeType: BindingTimeType;
  count: Scalars['Int']['output'];
};

export enum BindingTimeType {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week',
  Year = 'Year'
}

export type BiometricStepUpPayload = {
  __typename: 'BiometricStepUpPayload';
  success: Scalars['Boolean']['output'];
};

/** Bonds */
export type Bond = Node & {
  __typename: 'Bond';
  ask: Maybe<Scalars['Float']['output']>;
  askYield: Maybe<Scalars['Float']['output']>;
  bid: Maybe<Scalars['Float']['output']>;
  bidYield: Maybe<Scalars['Float']['output']>;
  details: Maybe<BondDetails>;
  exchangeSymbol: Scalars['String']['output'];
  history: BondHistory;
  /** Only for authenticated users */
  holdings: Maybe<PortfolioHoldingConnection>;
  id: Scalars['ID']['output'];
  intradayAccumulatedTurnover: Maybe<Scalars['Float']['output']>;
  intradayHighPrice: Maybe<Scalars['Float']['output']>;
  intradayHighYield: Maybe<Scalars['Float']['output']>;
  intradayLowPrice: Maybe<Scalars['Float']['output']>;
  intradayLowYield: Maybe<Scalars['Float']['output']>;
  intradayNetChange: Maybe<Scalars['Float']['output']>;
  intradayNumberOfTrades: Maybe<Scalars['Float']['output']>;
  intradayPerChange: Maybe<Scalars['Float']['output']>;
  last: Maybe<Scalars['Float']['output']>;
  lastDuration: Maybe<Scalars['Float']['output']>;
  lastPriceDifference: Maybe<Scalars['Float']['output']>;
  lastTradeDate: Maybe<Scalars['DateTimeISO']['output']>;
  lastYield: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  updatedUtc: Scalars['DateTimeISO']['output'];
};


/** Bonds */
export type BondHistoryArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  granularity?: InputMaybe<HistoryGranularity>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Bonds */
export type BondHoldingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BondConnection = {
  __typename: 'BondConnection';
  bondMarketStatus: MarketStatus;
  edges: Array<BondEdge>;
  exchangeOpeningHours: Maybe<MarketOpeningHours>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Static details for a bond */
export type BondDetails = {
  __typename: 'BondDetails';
  isLinkedToIcelandicCPI: Maybe<Scalars['Boolean']['output']>;
};

export type BondEdge = {
  __typename: 'BondEdge';
  cursor: Scalars['String']['output'];
  node: Bond;
};

export type BondHistory = {
  __typename: 'BondHistory';
  /** The query parameters that were applied to fetch the bond history. */
  appliedQuery: BondHistoryAppliedQuery;
  changes: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  entries: Array<BondHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  open: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** The query parameters that were applied to fetch the bond history. */
export type BondHistoryAppliedQuery = {
  __typename: 'BondHistoryAppliedQuery';
  period: CalendarPeriod;
};

export type BondHistoryEntry = {
  __typename: 'BondHistoryEntry';
  close: Maybe<Scalars['Float']['output']>;
  date: Maybe<Scalars['DateTimeISO']['output']>;
  high: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  last: Maybe<Scalars['Float']['output']>;
  low: Maybe<Scalars['Float']['output']>;
  open: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  turnover: Maybe<Scalars['Float']['output']>;
  yield: Maybe<Scalars['Float']['output']>;
};

export type BondLoanApplication = LoanApplication & Node & {
  __typename: 'BondLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  bond: LoanApplicationBond;
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  /** This field is currently used for corporate overdraft only. It indicates whether the current user can use surety bonds and if risk rating is missing. For freelance users this will always return SURETY_BOND_NOT_ALLOWED. */
  creditScoreRiskRatingResult: Maybe<CreditScoreRiskRatingResultType>;
  /** This field is currently used for corporate overdraft only. It indicates whether the requested amount for the overdraft loan application can be covered (insured) by existing collaterals. Currently, only truthful if there exists an "allsherjarveð í fasteign", with an unused value that exceeds the requested loan amount. */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** This field is currently used for corporate overdraft only. It returns surety guarantors (ábyrgðaraðilar) on an overdraft loan application. The list of guarantors is ordered with the main applicant as the first guarantor in the list. */
  guarantors: Maybe<Array<LoanApplicationGuarantor>>;
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. It indicates whether the applications could theoretically be automatically approved, as opposed to explicitly requiring manual approval. A true value does not always result in automatic approval, as there are other factors, but a false value will always result in manual approval. For freelance users this is always false. */
  isWithinPreApprovedAllowedLimits: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  /** This field is currently used for corporate overdraft only. It returns the calculated fee for surety (sjálfskuldarábyrgð) on an overdraft loan application. */
  suretyCollateralFee: Maybe<CurrencyAmount>;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


export type BondLoanApplicationCreditScoreRiskRatingResultArgs = {
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
};


export type BondLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

/** If you want the highest or lowest change in bonds */
export enum BondOrder {
  Low = 'Low',
  Rise = 'Rise',
  Turnover = 'Turnover'
}

export type BookAppointmentInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<SmartBookingCompanyInput>;
  customer?: InputMaybe<SmartBookingCustomerInput>;
  reservationId: Scalars['String']['input'];
};

export type BookAppointmentPayload = {
  __typename: 'BookAppointmentPayload';
  activityType: ConsultationType;
  branch: SmartBookingServiceLocation;
  id: Scalars['String']['output'];
  /** Additional information for the booked service */
  serviceDescription: Maybe<Scalars['String']['output']>;
  serviceName: Scalars['String']['output'];
  startTime: Scalars['DateTimeISO']['output'];
};

export type BookAppointmentUnioin = BookAppointmentPayload | KennitalaNotFoundError | ReservationsTimeSlotExpiredError;

/** Information about amounts that are bound until a certain date */
export type BoundAmount = {
  __typename: 'BoundAmount';
  /** The amount of money that will be available for withdrawal */
  disposableAmount: CurrencyAmount;
  /** The date when the amount will no longer be available for withdrawal. Null if the amount will not be bound again */
  ends: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when the amount will become available for withdrawal */
  starts: Scalars['DateTimeISO']['output'];
};

/** Info for the total amount and the list of bound amounts */
export type BoundAmountInfo = {
  __typename: 'BoundAmountInfo';
  /** List of bound amounts and the respective details about them */
  amounts: Array<BoundAmount>;
  /** The total amount of money summed from all the amounts in the list */
  total: CurrencyAmount;
};

/** Branches */
export type Branch = Node & {
  __typename: 'Branch';
  branchNumber: Maybe<Scalars['String']['output']>;
  branchServices: Maybe<Array<BranchServices>>;
  hasPostOffice: Maybe<Scalars['Boolean']['output']>;
  hasWheelchairAccess: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openingHours: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
};

/** Services available at branches */
export enum BranchServices {
  CashierService = 'CashierService',
  CorporateBankingService = 'CorporateBankingService',
  FinanceConsultation = 'FinanceConsultation',
  Insurance = 'Insurance',
  MailDelivery = 'MailDelivery',
  RetailBankingService = 'RetailBankingService',
  ServiceVisit = 'ServiceVisit'
}

/** Status of a bulk permission update operation */
export enum BulkUpdateStatus {
  PARTIAL_SUCCESS = 'PARTIAL_SUCCESS',
  SUCCESS = 'SUCCESS'
}

export enum BusinessPurpose {
  Acquiring = 'Acquiring',
  AssetManagement = 'AssetManagement',
  BusinessOperations = 'BusinessOperations',
  Foreign = 'Foreign',
  NonProfit = 'NonProfit',
  Other = 'Other',
  SalaryDeposit = 'SalaryDeposit',
  Savings = 'Savings',
  SecuritiesTransactions = 'SecuritiesTransactions',
  UNKNOWN = 'UNKNOWN'
}

/** Button component */
export type ButtonFormComponent = FormComponentBase & {
  __typename: 'ButtonFormComponent';
  action: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  variant: Maybe<Scalars['String']['output']>;
};

export type CalculatePaymentDistributionInput = {
  dueDate: Scalars['DateTimeISO']['input'];
  loanAmount: Scalars['Float']['input'];
  numberOfPayments: Scalars['Int']['input'];
};

/** Input type for calculating the time difference with the server. */
export type CalculateTimeOffsetInput = {
  /** The client's current time to be compared with the server time. */
  clientTime: Scalars['DateTimeISO']['input'];
};

/** Rule to determine when to apply discount/charge */
export enum CalculationRuleAfter {
  /** Apply after the "dueDate" has passed */
  AFTER_DUE_DATE = 'AFTER_DUE_DATE',
  /** Apply after final "dueDate" has passed, not the initial due date */
  AFTER_FINAL_DUE_DATE = 'AFTER_FINAL_DUE_DATE'
}

/** Rule to determine when to apply discount/charge */
export enum CalculationRuleBefore {
  /** Apply anytime before the "dueDate" has passed */
  BEFORE_DUE_DATE = 'BEFORE_DUE_DATE',
  /** Apply before final "dueDate" has passed, not the initial due date */
  BEFORE_FINAL_DUE_DATE = 'BEFORE_FINAL_DUE_DATE'
}

/** A period of time between two calendar dates. */
export type CalendarPeriod = {
  __typename: 'CalendarPeriod';
  from: Scalars['Date']['output'];
  to: Scalars['Date']['output'];
};

export type CanOnboardCompanyPayload = {
  __typename: 'CanOnboardCompanyPayload';
  company: CompanyAvailableForOnboarding;
};

export type CanOnboardCompanyResponse = ActiveCompanyOnboarding | CanOnboardCompanyPayload | CompanyIncompatible | CompanyNotFound | InvalidIsatCode | UnauthorizedContact | UnmetOnboardingConditions;

export type CancelAppointmentErrorUnion = AppointmentNotFound | UnknownError;

export type CancelAppointmentInput = {
  /** Reservation (model) id */
  id: Scalars['String']['input'];
};

export type CancelAppointmentPayload = {
  __typename: 'CancelAppointmentPayload';
  error: Maybe<CancelAppointmentErrorUnion>;
  success: Scalars['Boolean']['output'];
};

export type CancelCardSavingInput = {
  cardSavingSubscriptionId: Scalars['String']['input'];
};

export type CancelCardSavingSubscriptionResponse = CardSavingSubscriptionNotFound | CardSavingSubscriptionPayload;

export type CancelDirectDebitMandateInput = {
  id: Scalars['ID']['input'];
};

export type CancelDirectDebitMandatePayload = {
  __typename: 'CancelDirectDebitMandatePayload';
  directDebitMandate: DirectDebitMandate;
};

export type CancelDirectDebitMandateResult = CancelDirectDebitMandatePayload | DirectDebitMandateNotFound;

export type CancelInvoiceErrorUnion = InvoiceDeleted | InvoiceNotFound | InvoiceUnavailableError | UnknownError;

export type CancelInvoiceInput = {
  id: Scalars['ID']['input'];
};

export type CancelInvoicePayloadV2 = {
  __typename: 'CancelInvoicePayloadV2';
  error: Maybe<CancelInvoiceErrorUnion>;
  invoice: Maybe<Invoice>;
};

export type CancelInvoiceScheduleErrorUnion = InvoiceScheduleCleanupFailedError | InvoiceScheduleNotFound | UnknownError;

export type CancelInvoiceScheduleInput = {
  cancelRelatedUnpaidClaims?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type CancelInvoiceSchedulePayloadV2 = {
  __typename: 'CancelInvoiceSchedulePayloadV2';
  error: Maybe<CancelInvoiceScheduleErrorUnion>;
  invoiceScheduleId: Maybe<Scalars['ID']['output']>;
};

export type CancelLoanDrawDownRequestInput = {
  /** Reason for cancelling the draw down request. To assist employees who processes the request. (Preferably in Icelandic) */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The (Global) ID of the draw down request to cancel */
  drawDownId: Scalars['ID']['input'];
};

export type CancelLoanPeriodicPaymentInput = {
  id: Scalars['ID']['input'];
};

export type CancelLoanPeriodicPaymentPayload = {
  __typename: 'CancelLoanPeriodicPaymentPayload';
  loanPeriodicPayment: LoanPeriodicPayment;
};

export type CancelLoanPeriodicPaymentResponse = CancelLoanPeriodicPaymentPayload | PeriodicPaymentNotFound;

export type CancelMarketOrderInput = {
  marketOrderId: Scalars['String']['input'];
};

export type CancelMarketOrderPayload = {
  __typename: 'CancelMarketOrderPayload';
  id: Scalars['String']['output'];
};

export type CancelMarketOrderResult = CancelMarketOrderPayload | CancelMarketOrderStatusNotOpen;

export type CancelMarketOrderStatusNotOpen = Error & {
  __typename: 'CancelMarketOrderStatusNotOpen';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CancelMarketSubscriptionInput = {
  subscriptionId: Scalars['String']['input'];
};

export type CancelMarketSubscriptionPaylaod = {
  __typename: 'CancelMarketSubscriptionPaylaod';
  subscriptionId: Scalars['String']['output'];
};

export type CancelMarketSubscriptionResult = CancelMarketSubscriptionPaylaod | MarketSubscriptionNotFound;

export type CancelNoticeInput = {
  /** Notice (model) id */
  id: Scalars['String']['input'];
  noticeType: NoticeType;
};

/**
 * Response type for the cancelPaymentApproval mutation
 * Contains the updated approval or error that occurred during the process
 */
export type CancelPaymentApprovalResponse = {
  __typename: 'CancelPaymentApprovalResponse';
  approval: Maybe<PaymentApproval>;
  error: Maybe<PaymentApprovalError>;
};

export type CancelPaymentDistributionInput = {
  cardId: Scalars['ID']['input'];
  paymentDistributionId: Scalars['ID']['input'];
};

/** Object containing the cancelled payment distribution */
export type CancelPaymentDistributionPayload = {
  __typename: 'CancelPaymentDistributionPayload';
  paymentDistribution: PaymentDistribution;
};

export type CancelPaymentDistributionResponse = CancelPaymentDistributionPayload | PaymentDistributionNotFound;

export type CancelPaymentInput = {
  id: Scalars['ID']['input'];
};

export type CancelPaymentPayload = {
  __typename: 'CancelPaymentPayload';
  payment: Payment;
};

export type CancelPaymentResponse = CancelPaymentPayload | PaymentNotFound | UserDoesNotHaveAccessToTheDebtorAccountError;

export type CancelPeriodicPaymentInput = {
  id: Scalars['ID']['input'];
};

export type CancelPeriodicPaymentPayload = {
  __typename: 'CancelPeriodicPaymentPayload';
  periodicPayment: PeriodicPayment;
};

export type CancelPeriodicPaymentResponse = CancelPeriodicPaymentPayload | PeriodicPaymentNotFound;

export enum CarLoanType {
  Contract = 'Contract',
  Loan = 'Loan'
}

/** Access level for a card permission */
export enum CardAccessLevel {
  NONE = 'NONE',
  READ_ONLY = 'READ_ONLY'
}

/** The activity status of the card */
export enum CardActivityStatus {
  /** Card is active */
  ACTIVE = 'ACTIVE',
  /** Card is reactivated after being terminated */
  ACTIVE_REACTIVATED = 'ACTIVE_REACTIVATED',
  /** Card will be frozen */
  FROZEN = 'FROZEN',
  /** Card is pending termination until annual renewal date by the owner */
  PENDING_TERMINATION_BY_OWNER = 'PENDING_TERMINATION_BY_OWNER',
  PENDING_TERMINATION_BY_SERVICE_PROVIDER = 'PENDING_TERMINATION_BY_SERVICE_PROVIDER',
  /** Card is immediately terminated by the owner */
  TERMINATED_BY_OWNER = 'TERMINATED_BY_OWNER',
  /** Card is terminated due to being lost */
  TERMINATED_LOST = 'TERMINATED_LOST',
  /** Card is terminated due to being stolen */
  TERMINATED_STOLEN = 'TERMINATED_STOLEN',
  /** Card status is unknown */
  UNKNOWN = 'UNKNOWN'
}

/** Payment card annual fee */
export type CardAnnualFeeType = {
  __typename: 'CardAnnualFeeType';
  /** The amount of the annual fee. Resolved as ISK */
  amount: CurrencyAmount;
  /** The month when the annual fee is charged. 01 to 12 */
  month: Maybe<Scalars['String']['output']>;
};

/** Card application */
export type CardApplication = Node & {
  __typename: 'CardApplication';
  /** Kennitala (Icelandic national identification number) of the applicant. */
  applicantKennitala: Maybe<Scalars['String']['output']>;
  /** Email address of the card holder. */
  cardHolderEmail: Maybe<Scalars['String']['output']>;
  /** Kennitala (Icelandic national identification number) of the card holder. */
  cardHolderKennitala: Maybe<Scalars['String']['output']>;
  /** Mobile phone number of the card holder. */
  cardHolderMobile: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the card, if available. */
  cardId: Maybe<Scalars['Float']['output']>;
  /** CardIdChanged is returned if the card application was a change card application. It is the cardId of the card that was changed. */
  cardIdChanged: Maybe<Scalars['Float']['output']>;
  /** Email address of the card owner. */
  cardOwnerEmail: Maybe<Scalars['String']['output']>;
  /** Kennitala (Icelandic national identification number) of the card owner. */
  cardOwnerKennitala: Scalars['String']['output'];
  /** Mobile phone number of the card owner. */
  cardOwnerMobile: Maybe<Scalars['String']['output']>;
  /** Date when the card application was created. */
  createdDate: Scalars['DateTimeISO']['output'];
  /** Spending limit per card until due date. */
  creditLine: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Issued card type associated with the card application. Can be physical, digital or unknown. */
  issuedCardType: IssuedCardType;
  /** Loyalty type associated with the card application. */
  loyaltyType: CardLoyalty;
  /** Masked card number associated with the card application. */
  maskedCardNumber: Maybe<Scalars['String']['output']>;
  /** Current status of the card application. */
  status: CardApplicationStatus;
};

export enum CardApplicationStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  CARD_CREATION_ERROR = 'CARD_CREATION_ERROR',
  DECLINED = 'DECLINED',
  DONE = 'DONE',
  NEW = 'NEW',
  SENT_TO_APPROVAL = 'SENT_TO_APPROVAL',
  UNKNOWN = 'UNKNOWN'
}

export type CardAuthorization = Node & {
  __typename: 'CardAuthorization';
  /** If user can view */
  canView: Scalars['Boolean']['output'];
  /** Card holder kennitala */
  cardHolderKennitala: Maybe<Scalars['String']['output']>;
  /** Card holder name */
  cardHolderName: Maybe<Scalars['String']['output']>;
  /** Display number */
  displayNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Kennitala */
  kennitala: Scalars['String']['output'];
  /** Owner name */
  ownerName: Scalars['String']['output'];
  /** Name of the product, either the account type or card type */
  productName: Maybe<Scalars['String']['output']>;
  /** All users with information about their access to the card, only resolve when getting one card */
  users: Maybe<UserAccessAuthorizationConnection>;
};


export type CardAuthorizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsersAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsersAuthorizationOrderBy>;
};

export type CardAuthorizationConnection = {
  __typename: 'CardAuthorizationConnection';
  /** Overall access level for the cards. Will have a value if user has same access level for all cards in the connection. Note that CardsAuthorizationArgs.withAccessOnly affect the value of this field. */
  allAuthorizationAccessLevel: Maybe<AuthorizationAccessLevel>;
  edges: Array<CardAuthorizationEdge>;
  /** If the connection includes subsidiaries */
  includesSubsidiaries: Scalars['Boolean']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardAuthorizationEdge = {
  __typename: 'CardAuthorizationEdge';
  cursor: Scalars['String']['output'];
  node: CardAuthorization;
};

/** The status of the Click to Pay request */
export enum CardClickToPayRequestStatus {
  /** Request failed */
  FAILED = 'FAILED',
  /** New request */
  NEW = 'NEW',
  /** Request is being processed */
  PROCESSING = 'PROCESSING',
  /** Request has been submitted */
  SUBMITTED = 'SUBMITTED',
  /** Request was successful */
  SUCCESS = 'SUCCESS',
  /** Request status is unknown */
  UNKNOWN = 'UNKNOWN'
}

export type CardDeliveryAddressInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  /** The ISO country code for the representation of the country names */
  countryCode: Scalars['String']['input'];
  /** The country id for the country */
  countryId?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
};

export type CardDeposit = Node & PaymentInterface & {
  __typename: 'CardDeposit';
  cardNumber: Scalars['String']['output'];
  cardOwnerKennitala: Scalars['String']['output'];
  cardOwnerName: Scalars['String']['output'];
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export type CardDepositInitialPaymentData = Node & PaymentInterface & {
  __typename: 'CardDepositInitialPaymentData';
  /** Credit card belonging to the card holder */
  card: Maybe<CreditCard>;
  cardNumber: Scalars['String']['output'];
  cardOwnerKennitala: Scalars['String']['output'];
  cardOwnerName: Scalars['String']['output'];
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export type CardHolderMustBeAPerson = Error & {
  __typename: 'CardHolderMustBeAPerson';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum CardLoyalty {
  AUKAKRONUR = 'AUKAKRONUR',
  NONE = 'NONE',
  VILDARPUNKTAR = 'VILDARPUNKTAR'
}

export type CardNotFoundError = Error & {
  __typename: 'CardNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Notification option */
export type CardNotificationOption = {
  __typename: 'CardNotificationOption';
  description: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  /** The title of this notification option */
  name: Scalars['String']['output'];
  /** The id of the notification option */
  notificationOptionId: Scalars['String']['output'];
};

/** Error detail for a card permission update */
export type CardPermissionError = {
  __typename: 'CardPermissionError';
  /** Field that caused the error */
  field: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** A failed card permission update with error details */
export type CardPermissionUpdateFailure = {
  __typename: 'CardPermissionUpdateFailure';
  /** Attempted access level */
  access: Maybe<CardAccessLevel>;
  /** Card ID (Global) */
  cardId: Maybe<Scalars['ID']['output']>;
  /** List of validation or processing errors */
  errors: Array<CardPermissionError>;
  /** Username involved in the failed update */
  username: Scalars['String']['output'];
};

/** Wrapper of pin values */
export type CardPin = {
  __typename: 'CardPin';
  value: Scalars['String']['output'];
};

export type CardPinPayloadErrorUnion = UnknownError;

export type CardPinPayloadV2 = {
  __typename: 'CardPinPayloadV2';
  error: Maybe<CardPinPayloadErrorUnion>;
  result: Maybe<CardPin>;
};

/** NOTE: Only one adaptive authentication transaction can be active per request, so PIN cannot be fetched in a connection */
export type CardPinResultV2 = AdaptiveAuthentication | CardPinPayloadV2;

/** A card prerequisite */
export type CardPrerequisite = {
  __typename: 'CardPrerequisite';
  /** A list of prerequisites which user fails to meet as a requirement for a card application */
  failures: Array<CardsPrerequisitesFailure>;
  /** Indicates if a card application is allowed or not. Resolves to true if all prerequisites are valid */
  isAllowed: Scalars['Boolean']['output'];
};

/** Type of card prerequisite */
export enum CardPrerequisiteType {
  /** Change a card */
  CHANGE = 'CHANGE',
  /** Create a new card */
  CREATE = 'CREATE',
  /** Reissue a card */
  REISSUE = 'REISSUE',
  /** Replace a card */
  REPLACE = 'REPLACE'
}

export type CardPrivateInfo = {
  __typename: 'CardPrivateInfo';
  cardNumber: Scalars['String']['output'];
  cvv: Scalars['String']['output'];
};

export type CardPrivateInfoPayloadErrorUnion = UnknownError | UserIsNotAllowedToSeePrivateInfo;

export type CardPrivateInfoPayloadV2 = {
  __typename: 'CardPrivateInfoPayloadV2';
  error: Maybe<CardPrivateInfoPayloadErrorUnion>;
  result: Maybe<CardPrivateInfo>;
};

export type CardPrivateInfoResponse = CardPrivateInfo | RsaStepUpResponse | UserIsNotAllowedToSeePrivateInfo;

export type CardPrivateInfoResultV2 = AdaptiveAuthentication | CardPrivateInfoPayloadV2;

/** Card Products Payload */
export type CardProductDetails = {
  __typename: 'CardProductDetails';
  products: Array<CreditCardProduct>;
  /** Indicates if the user is recommended/able to take status assessment */
  statusAssessmentRecommended: Scalars['Boolean']['output'];
};

/** The status of the reissue application */
export enum CardReissueStatus {
  /** Card is not reissued */
  NOT_REISSUED = 'NOT_REISSUED',
  /** Card reissue prerequisites failed */
  PREREQUISITES_FAILED = 'PREREQUISITES_FAILED',
  /** Card is reissuable */
  REISSUABLE = 'REISSUABLE',
  /** Card is reissued */
  REISSUED = 'REISSUED',
  /** Card reissue status is unknown */
  UNKNOWN = 'UNKNOWN'
}

/** Card Saving data */
export type CardSaving = Node & {
  __typename: 'CardSaving';
  created: Scalars['DateTimeISO']['output'];
  customerId: Scalars['String']['output'];
  destination: CardSavingDestination;
  id: Scalars['ID']['output'];
  savingsType: CardSavingType;
  source: CardSavingSource;
};

export type CardSavingDestination = {
  __typename: 'CardSavingDestination';
  id: Scalars['String']['output'];
  type: CardSavingDestinationType;
};

export type CardSavingDestinationInput = {
  /** Destination (model) id */
  id: Scalars['String']['input'];
  type: CardSavingDestinationType;
};

/** Card saving destination type */
export enum CardSavingDestinationType {
  /** Card saving destination is a charity */
  Charity = 'Charity',
  /** Card saving destination is a savings account */
  SavingsAccount = 'SavingsAccount'
}

export type CardSavingEdge = {
  __typename: 'CardSavingEdge';
  cursor: Scalars['String']['output'];
  node: CardSaving;
};

/** Card saving method type */
export enum CardSavingMethodType {
  /** Card saving method is increase by */
  IncreaseBy = 'IncreaseBy',
  /** Card saving method is round up */
  RoundUp = 'RoundUp'
}

export type CardSavingNotFound = Error & {
  __typename: 'CardSavingNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CardSavingSource = {
  __typename: 'CardSavingSource';
  accountId: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maskedCardNumber: Scalars['String']['output'];
  type: CardSavingSourceType;
};

export type CardSavingSourceInput = {
  id: Scalars['String']['input'];
  type: CardSavingSourceType;
};

/** Card saving source type */
export enum CardSavingSourceType {
  /** Card saving source is a credit card */
  CreditCard = 'CreditCard',
  /** Card saving source is a debit card */
  DebitCard = 'DebitCard'
}

export type CardSavingSubscriptionNotFound = Error & {
  __typename: 'CardSavingSubscriptionNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CardSavingSubscriptionPayload = {
  __typename: 'CardSavingSubscriptionPayload';
  cardSavingSubscription: CardSaving;
};

export type CardSavingType = {
  __typename: 'CardSavingType';
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  type: CardSavingMethodType;
};

export type CardSavingTypeInput = {
  /** @deprecated Only id is needed, please use that instead */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** You can use either id or amount and type, please use the id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Only id is needed, please use that instead */
  type?: InputMaybe<CardSavingMethodType>;
};

export type CardSavingsConnection = {
  __typename: 'CardSavingsConnection';
  edges: Array<CardSavingEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardSavingsInfo = {
  __typename: 'CardSavingsInfo';
  active: Scalars['Boolean']['output'];
  availableAccounts: AccountConnection;
  methodType: SavingMethodType;
  savingMethodId: Maybe<Scalars['String']['output']>;
  savingsType: Maybe<CardSavingType>;
};


export type CardSavingsInfoAvailableAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CardStatus {
  Active = 'Active',
  Closed = 'Closed',
  Frozen = 'Frozen',
  NoCard = 'NoCard'
}

/** Termination status code of a card */
export enum CardTerminationStatus {
  PENDING_TERMINATION_BY_OWNER = 'PENDING_TERMINATION_BY_OWNER',
  PENDING_TERMINATION_BY_SERVICE_PROVIDER = 'PENDING_TERMINATION_BY_SERVICE_PROVIDER',
  TERMINATED_LOST = 'TERMINATED_LOST',
  TERMINATED_STOLEN = 'TERMINATED_STOLEN'
}

/** Base card transaction for both Debit and Credit cards */
export type CardTransaction = Node & {
  __typename: 'CardTransaction';
  /** Transaction amount in ISK */
  amount: CurrencyAmount;
  /** Authorization number for the transaction */
  authorizationNumber: Maybe<Scalars['String']['output']>;
  /** Indicates whether the transaction can have attachments. Attachments include LedgerKey, Comment, and Attachments. */
  canHaveAttachments: Scalars['Boolean']['output'];
  /** Attachments for the transaction */
  cardTransactionAttachments: Maybe<Array<CardTransactionAttachment>>;
  /** Category or type of merchant (e.g., "Matvöruverslun") */
  categoryCodeDescription: Maybe<Scalars['String']['output']>;
  /** City where the transaction took place */
  city: Maybe<Scalars['String']['output']>;
  /** Comment for the transaction */
  comment: Maybe<Scalars['String']['output']>;
  /** Country where the transaction took place */
  country: Maybe<Scalars['String']['output']>;
  /** Currency exchange rate applied to the transaction */
  currencyRate: Maybe<CurrencyAmount>;
  /** Main description of transaction (categoryCodeDescription) */
  displayDescription: Scalars['String']['output'];
  /** Main display title of the transaction (merchantName) */
  displayTitle: Scalars['String']['output'];
  /** Only defined if the transaction was converted to another currency */
  foreignAmount: Maybe<CurrencyAmount>;
  /** Indicates whether the transaction has accounting records (ledgerKey, comment, attachments) */
  hasAccountingRecords: Scalars['Boolean']['output'];
  /** Constructed from cardId:transactionId */
  id: Scalars['ID']['output'];
  /** A ledger key used for bookkeeping purposes. Consists of an identifier and a description */
  ledgerKey: Maybe<CardTransactionsLedgerKey>;
  /** A ledger key group used for bookkeeping purposes. */
  ledgerKeyGroup: Maybe<CardTransactionsLedgerKeyGroupBase>;
  /** A ledger key sub group used for bookkeeping purposes. */
  ledgerKeySubGroup: Maybe<CardTransactionsLedgerKeySubGroupBase>;
  /** Defined if the client received loyalty points for this transaction */
  loyalty: Maybe<CardTransactionLoyalty>;
  /** Merchant receipt number for the transaction */
  merchantReceiptNumber: Maybe<Scalars['String']['output']>;
  /** The payment date of the transaction */
  paymentDate: Scalars['DateTimeISO']['output'];
  /** The type of the card transaction */
  type: CardTransactionType;
};

export type CardTransactionAttachment = {
  __typename: 'CardTransactionAttachment';
  /** @deprecated Reason: Use documentV2 instead. Since: 2026-03-19. Issue to remove it: WEB-41581 */
  document: DocumentBucket;
  documentV2: GenericFile;
  id: Scalars['ID']['output'];
  isImage: Scalars['Boolean']['output'];
};

export type CardTransactionAttachmentNotFound = Error & {
  __typename: 'CardTransactionAttachmentNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CardTransactionConnection = {
  __typename: 'CardTransactionConnection';
  /** The query parameters that were applied to fetch the transactions in this connection */
  appliedQuery: CardTransactionsAppliedQuery;
  edges: Array<CardTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardTransactionControl = {
  __typename: 'CardTransactionControl';
  /** Description for the transaction control */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the transaction control is on or off */
  isActive: Scalars['Boolean']['output'];
  /** The name of the transaction control */
  name: Scalars['String']['output'];
  /** The type of the transaction control */
  type: CardTransactionControlType;
};

export type CardTransactionControlNotFoundError = Error & {
  __typename: 'CardTransactionControlNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum CardTransactionControlType {
  ATM_WITHDRAWAL = 'ATM_WITHDRAWAL',
  CONTACTLESS_PAYMENTS = 'CONTACTLESS_PAYMENTS',
  ECOMMERCE = 'ECOMMERCE',
  FOREIGN_PAYMENTS = 'FOREIGN_PAYMENTS',
  UNKNOWN = 'UNKNOWN'
}

export type CardTransactionEdge = {
  __typename: 'CardTransactionEdge';
  cursor: Scalars['String']['output'];
  node: CardTransaction;
};

export type CardTransactionLedgerKeyGroupsResponse = {
  __typename: 'CardTransactionLedgerKeyGroupsResponse';
  hasAccess: Scalars['Boolean']['output'];
  ledgerKeyGroups: Maybe<CardTransactionsLedgerKeyGroupsConnection>;
};

/** Response for the card transactions' ledger keys */
export type CardTransactionLedgerKeysResponse = {
  __typename: 'CardTransactionLedgerKeysResponse';
  hasAccess: Scalars['Boolean']['output'];
  ledgerKeys: Maybe<CardTransactionsLedgerKeyConnection>;
};

export type CardTransactionLedgerKeysSubGroupsResponse = {
  __typename: 'CardTransactionLedgerKeysSubGroupsResponse';
  hasAccess: Scalars['Boolean']['output'];
  ledgerKeySubGroups: Maybe<CardTransactionsLedgerKeySubGroupsConnection>;
};

/** Loyalty reward information */
export type CardTransactionLoyalty = {
  __typename: 'CardTransactionLoyalty';
  /** Loyalty points */
  points: Scalars['Float']['output'];
  /** Which loyalty system. */
  system: CardLoyalty;
};

export type CardTransactionNotFound = Error & {
  __typename: 'CardTransactionNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum CardTransactionType {
  Authorization = 'Authorization',
  ClaimDeposit = 'ClaimDeposit',
  DomesticWithdrawal = 'DomesticWithdrawal',
  Fee = 'Fee',
  ForeignWithdrawal = 'ForeignWithdrawal',
  Interest = 'Interest',
  OtherDeposit = 'OtherDeposit',
  Refund = 'Refund',
  Unknown = 'Unknown'
}

/** The query parameters that were applied to fetch the debit card transactions in this connection */
export type CardTransactionsAppliedQuery = {
  __typename: 'CardTransactionsAppliedQuery';
  period: CalendarPeriod;
};

/** Financial transaction to a foreign recipient */
export type CardTransactionsLedgerKey = Node & {
  __typename: 'CardTransactionsLedgerKey';
  /** A description for the identifier usually used for bookkeeping purposes. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** An identifier, usually a key, used for bookkeeping purposes */
  identifier: Scalars['String']['output'];
};

export type CardTransactionsLedgerKeyConnection = {
  __typename: 'CardTransactionsLedgerKeyConnection';
  edges: Array<CardTransactionsLedgerKeyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardTransactionsLedgerKeyEdge = {
  __typename: 'CardTransactionsLedgerKeyEdge';
  cursor: Scalars['String']['output'];
  node: CardTransactionsLedgerKey;
};

/** Ledger key group for the card transactions detail */
export type CardTransactionsLedgerKeyGroup = Node & {
  __typename: 'CardTransactionsLedgerKeyGroup';
  /** A description for the identifier of the ledger key group, usually used for bookkeeping purposes. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** An identifier, usually a key, used for bookkeeping purposes */
  identifier: Maybe<Scalars['String']['output']>;
};

/** Object representing a ledger key group, used for the card transaction details. */
export type CardTransactionsLedgerKeyGroupBase = {
  __typename: 'CardTransactionsLedgerKeyGroupBase';
  /** A description for the identifier of the ledger key group, usually used for bookkeeping purposes. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['output'];
  /** An identifier, usually a key, used for bookkeeping purposes */
  identifier: Maybe<Scalars['String']['output']>;
};

export type CardTransactionsLedgerKeyGroupEdge = {
  __typename: 'CardTransactionsLedgerKeyGroupEdge';
  cursor: Scalars['String']['output'];
  node: CardTransactionsLedgerKeyGroup;
};

export type CardTransactionsLedgerKeyGroupsConnection = {
  __typename: 'CardTransactionsLedgerKeyGroupsConnection';
  edges: Array<CardTransactionsLedgerKeyGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardTransactionsLedgerKeyNotFoundError = Error & {
  __typename: 'CardTransactionsLedgerKeyNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Ledger key sub group for the card transactions detail */
export type CardTransactionsLedgerKeySubGroup = Node & {
  __typename: 'CardTransactionsLedgerKeySubGroup';
  /** A description for the identifier of the ledger key sub group, usually used for bookkeeping purposes. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** An identifier, usually a key, used for bookkeeping purposes */
  identifier: Maybe<Scalars['String']['output']>;
};

/** Object representing a ledger key sub group, used for the card transaction details. */
export type CardTransactionsLedgerKeySubGroupBase = {
  __typename: 'CardTransactionsLedgerKeySubGroupBase';
  /** A description for the identifier of the ledger key sub group, usually used for bookkeeping purposes. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['output'];
  /** An identifier, usually a key, used for bookkeeping purposes */
  identifier: Maybe<Scalars['String']['output']>;
};

export type CardTransactionsLedgerKeySubGroupEdge = {
  __typename: 'CardTransactionsLedgerKeySubGroupEdge';
  cursor: Scalars['String']['output'];
  node: CardTransactionsLedgerKeySubGroup;
};

export type CardTransactionsLedgerKeySubGroupsConnection = {
  __typename: 'CardTransactionsLedgerKeySubGroupsConnection';
  edges: Array<CardTransactionsLedgerKeySubGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CardTransactionsOrderBy = {
  direction: OrderByDirection;
  field: CardTransactionsOrderByOption;
};

export enum CardTransactionsOrderByOption {
  Amount = 'Amount',
  CurrencyRate = 'CurrencyRate',
  ForeignAmount = 'ForeignAmount',
  PurchaseDay = 'PurchaseDay',
  Seller = 'Seller'
}

/** Type of bulk card permission update operation */
export enum CardUpdateType {
  BY_CARD = 'BY_CARD',
  BY_USER = 'BY_USER'
}

export type CardsAuthorizationOrderBy = {
  /** Direction to order cards by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order cards by */
  field: CardsAuthorizationOrderByOptions;
};

/** Fields that cards can be ordered by */
export enum CardsAuthorizationOrderByOptions {
  CARD_HOLDER_NAME = 'CARD_HOLDER_NAME',
  DISPLAY_NUMBER = 'DISPLAY_NUMBER',
  OWNER_NAME = 'OWNER_NAME',
  OWNER_NATIONAL_ID = 'OWNER_NATIONAL_ID',
  READ_ACCESS = 'READ_ACCESS'
}

export type CardsCloseUnion = CreditCard | DebitCard;

export type CardsClosurePayload = {
  __typename: 'CardsClosurePayload';
  card: Maybe<CardsCloseUnion>;
};

/** Permissions for card related operations. */
export type CardsPermissions = {
  __typename: 'CardsPermissions';
  /** User specific permissions for ledger keys */
  ledgerKeys: CardsPermissionsAttributes;
};

/** Permission attributes for card related operations. The attributes indicate whether the user has read and write permissions for the corresponding keys. */
export type CardsPermissionsAttributes = {
  __typename: 'CardsPermissionsAttributes';
  /** Indicates whether the user has read permissions for the corresponding key */
  canRead: Scalars['Boolean']['output'];
  /** Indicates whether the user has write permissions for the corresponding key */
  canWrite: Scalars['Boolean']['output'];
};

/** Status of an issued card */
export enum CardsPrerequisitesFailure {
  /** Card is discontinued(no usable) and cannot be used */
  CARD_DISCONTINUED = 'CARD_DISCONTINUED',
  /** Card owner's legal address is invalid */
  HAS_INVALID_LEGAL_ADDRESS = 'HAS_INVALID_LEGAL_ADDRESS',
  /** Card owner's residential address is invalid */
  HAS_INVALID_RESIDENTIAL_ADDRESS = 'HAS_INVALID_RESIDENTIAL_ADDRESS',
  /** Card owner's email is missing */
  MISSING_EMAIL = 'MISSING_EMAIL',
  /** Card owner's phone number is missing */
  MISSING_PHONE_NUMBER = 'MISSING_PHONE_NUMBER',
  /** Card owner needs access */
  NEEDS_ACCESS = 'NEEDS_ACCESS',
  /** Card owner needs identification */
  NEEDS_IDENTIFICATION = 'NEEDS_IDENTIFICATION',
  /** Card owner needs KYC (Know Your Customer) identification */
  NEEDS_KYC = 'NEEDS_KYC',
  /** Card owner's has too many active cards for a certain card type */
  TOO_MANY_ACTIVE_CARDS = 'TOO_MANY_ACTIVE_CARDS',
  UNKNOWN = 'UNKNOWN'
}

/** CashPool service */
export type CashPool = Node & {
  __typename: 'CashPool';
  /** Cash pool accounts and their summary */
  accountsOverview: Maybe<CashPoolAccountsOverview>;
  /** Available amount in cash pool */
  availableAmount: CurrencyAmount;
  /** Balance of cash pool */
  balance: CurrencyAmount;
  /** Base deposit interest rate of cash pool */
  baseDepositInterestRate: Scalars['Float']['output'];
  /** Base overdraft interest rate of cash pool */
  baseOverdraftInterestRate: Scalars['Float']['output'];
  /** Excel document that provides an overview of the cashPool for the month */
  cashPoolMonthlyOverviewDocument: Maybe<DocumentBucket>;
  /** Currency of cash pool */
  currency: Scalars['String']['output'];
  /** Deposit interest rate of cash pool */
  depositInterestRate: Scalars['Float']['output'];
  /** Deviation account BBAN of cash pool */
  deviationAccountBban: Maybe<Scalars['String']['output']>;
  /** End of interest period for cash pool */
  endOfInterestPeriod: Maybe<Scalars['Date']['output']>;
  /** ID (Global) of cash pool */
  id: Scalars['ID']['output'];
  /** Intraday (within the day) transactions sum of cash pool */
  intradayTransactionsSum: CurrencyAmount;
  /** Main account BBAN of cash pool */
  mainAccountBban: Scalars['String']['output'];
  /** Overdraft interest rate of cash pool */
  overdraftInterestRate: Scalars['Float']['output'];
  /** Overdraft limit of cash pool */
  overdraftLimit: CurrencyAmount;
  /** Owner kennitala of cash pool */
  ownerKennitala: Scalars['String']['output'];
  /** Owner name of cash pool */
  ownerName: Maybe<Scalars['String']['output']>;
  /** Start of interest period for cash pool */
  startOfInterestPeriod: Maybe<Scalars['Date']['output']>;
  /** Total overdraft limit of cash pool */
  totalOverdraftLimit: CurrencyAmount;
  /** Total unpaid deposit interest of cash pool */
  totalUnpaidDepositInterest: Scalars['Float']['output'];
  /** Total unpaid overdraft interest of cash pool */
  totalUnpaidOverdraftInterest: Scalars['Float']['output'];
};

/** CashPool account */
export type CashPoolAccount = Node & {
  __typename: 'CashPoolAccount';
  accountEndOfDayFinancials: CashPoolAccountEndOfDayFinancialsConnection;
  /** Available amount in cashPool account */
  availableAmount: CurrencyAmount;
  /** Balance of cashPool account */
  balance: CurrencyAmount;
  /** BBAN of cashPool account */
  bban: Scalars['String']['output'];
  /** Currency of cashPool account */
  currency: Scalars['String']['output'];
  /** Deposit interest rate of cashPool account */
  depositInterestRate: Scalars['Float']['output'];
  /** Deposit margin of cashPool account */
  depositMargin: Scalars['Float']['output'];
  /** End of interest period for cashPool account */
  endOfInterestPeriod: Maybe<Scalars['String']['output']>;
  /** IBAN of cashPool account */
  iban: Maybe<Scalars['String']['output']>;
  /** ID of cashPool account */
  id: Scalars['ID']['output'];
  /** Intraday (within the day) transactions sum of cashPool account */
  intradayTransactionsSum: CurrencyAmount;
  /** Indicates if the cashPool account is active in service */
  isActiveInService: Scalars['Boolean']['output'];
  /** Indicates if the cashPool account is a deviation account */
  isDeviationAccount: Scalars['Boolean']['output'];
  /** Indicates if the cashPool account is interest-free */
  isInterestFree: Scalars['Boolean']['output'];
  /** Overdraft interest rate of cashPool account */
  overdraftInterestRate: Scalars['Float']['output'];
  /** Overdraft limit of cashPool account */
  overdraftLimit: CurrencyAmount;
  /** Overdraft margin of cashPool account */
  overdraftMargin: Scalars['Float']['output'];
  /** Owner kennitala of cashPool account */
  ownerKennitala: Scalars['String']['output'];
  /** Owner name of cashPool account */
  ownerName: Maybe<Scalars['String']['output']>;
  /** Start of interest period for cashPool account */
  startOfInterestPeriod: Maybe<Scalars['String']['output']>;
  /** Unpaid deposit interest of cashPool account */
  unpaidDepositInterest: Scalars['Float']['output'];
  /** Unpaid overdraft interest of cashPool account */
  unpaidOverdraftInterest: Scalars['Float']['output'];
};


/** CashPool account */
export type CashPoolAccountAccountEndOfDayFinancialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: CashPoolAccountEndOfDayFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CashPoolAccountEndOfDayFilterArgs = {
  /** Start date for filtering CashPool account end-of-day financials (beginning of day is used) */
  dateFrom: Scalars['DateTimeISO']['input'];
  /** End date for filtering CashPool account end-of-day financials (end of day is used) */
  dateTo: Scalars['DateTimeISO']['input'];
};

/** CashPool account end of day balance */
export type CashPoolAccountEndOfDayFinancials = {
  __typename: 'CashPoolAccountEndOfDayFinancials';
  /** CashPool account end of day balance */
  balance: CurrencyAmount;
  /** Date of balance */
  date: Maybe<Scalars['Date']['output']>;
  /** ID (Global) of cashPool account */
  id: Scalars['ID']['output'];
  /** CashPool account end of day transaction sum */
  transactionsSum: CurrencyAmount;
};

/** A connection for a list of ProxyAccess objects */
export type CashPoolAccountEndOfDayFinancialsConnection = {
  __typename: 'CashPoolAccountEndOfDayFinancialsConnection';
  edges: Array<CashPoolAccountEndOfDayFinancialsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CashPoolAccountEndOfDayFinancialsEdge = {
  __typename: 'CashPoolAccountEndOfDayFinancialsEdge';
  cursor: Scalars['String']['output'];
  node: CashPoolAccountEndOfDayFinancials;
};

export type CashPoolAccountSettingsInput = {
  /** The amount of decreased deposit interest from the base cash pool deposit interest (IS: Innvextir) */
  depositMargin?: InputMaybe<Scalars['Float']['input']>;
  /** If this value is true then depositMargin and overdraftMargin are not used */
  isInterestFree?: InputMaybe<Scalars['Boolean']['input']>;
  overdraftLimit?: InputMaybe<Scalars['Float']['input']>;
  /** The amount of increased interest from the base cash pool overdraft interest (IS: Skuldavextir) */
  overdraftMargin?: InputMaybe<Scalars['Float']['input']>;
};

/** Cash pool account summary, calculated from all the accounts in the cash pool */
export type CashPoolAccountSummary = {
  __typename: 'CashPoolAccountSummary';
  /** Total available amount across all accounts in the cash pool */
  available: CurrencyAmount;
  /** Total balance across all accounts in the cash pool */
  balance: CurrencyAmount;
  /** Sum of intraday transactions across all accounts in the cash pool */
  intraDayTransactions: CurrencyAmount;
  /** Total overdraft limit across all accounts in the cash pool */
  overdraftLimit: CurrencyAmount;
};

/** CashPool accounts and their summary */
export type CashPoolAccountsOverview = {
  __typename: 'CashPoolAccountsOverview';
  accountSummary: Maybe<CashPoolAccountSummary>;
  accounts: Array<CashPoolAccount>;
};

/** Category refers to different categories of funds, whether use has experience or knowledge with said fund */
export type CategoryQuestion = {
  __typename: 'CategoryQuestion';
  hasExperience: Scalars['Boolean']['output'];
  hasKnowledge: Scalars['Boolean']['output'];
};

export type CategoryQuestionInput = {
  hasExperience: Scalars['Boolean']['input'];
  hasKnowledge: Scalars['Boolean']['input'];
};

export type CentralBankCategoryCode = Node & {
  __typename: 'CentralBankCategoryCode';
  /** Central bank identifier with length 3 and contains letters and numbers. */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Short localized text that describes the category code. Is used in frontend to display the category code. It has max length of 70 characters. */
  title: Scalars['String']['output'];
};

export type CentralBankCategoryCodeConnection = {
  __typename: 'CentralBankCategoryCodeConnection';
  edges: Array<CentralBankCategoryCodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CentralBankCategoryCodeEdge = {
  __typename: 'CentralBankCategoryCodeEdge';
  cursor: Scalars['String']['output'];
  node: CentralBankCategoryCode;
};

export enum CentralBankCategoryCodeRank {
  All = 'All',
  Ranked = 'Ranked',
  Unranked = 'Unranked'
}

/** CentralBankRate */
export type CentralBankRate = Node & {
  __typename: 'CentralBankRate';
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CentralBankRateConnection = {
  __typename: 'CentralBankRateConnection';
  edges: Array<CentralBankRateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CentralBankRateEdge = {
  __typename: 'CentralBankRateEdge';
  cursor: Scalars['String']['output'];
  node: CentralBankRate;
};

export type ChangeEmployeeDetailsInPayrollInput = {
  /** New account number */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** ID (Global) of the employee that will be changed */
  employeeId: Scalars['ID']['input'];
  /** ID (Global) of other payroll to move employee to */
  newPayrollId?: InputMaybe<Scalars['ID']['input']>;
  /** ID (Global) of the payroll where the employee is stored */
  payrollId: Scalars['ID']['input'];
};

/** Payload for changing employee details in payroll */
export type ChangeEmployeeDetailsInPayrollPayload = {
  __typename: 'ChangeEmployeeDetailsInPayrollPayload';
  /** New employee from a successful change request */
  employee: Maybe<PayrollEmployee>;
  /** Error returned after an unsuccessful change request */
  error: Maybe<ChangeEmployeeInPayrollError>;
};

export type ChangeEmployeeInPayrollError = EmployeeAccountAndKennitalaDoNotMatchError | EmployeeInvalidAccountNumberError;

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangePasswordPayload = {
  __typename: 'ChangePasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordPayloadErrorUnion = NewPasswordNotValid | OldPasswordIncorrect | UnknownError;

export type ChangePasswordPayloadV2 = {
  __typename: 'ChangePasswordPayloadV2';
  error: Maybe<ChangePasswordPayloadErrorUnion>;
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordResult = ChangePasswordPayload | NewPasswordNotValid | OldPasswordIncorrect | RsaStepUpResponse;

export type ChangePasswordResultV2 = AdaptiveAuthentication | ChangePasswordPayloadV2;

export type ChangePayrollNameInput = {
  /** ID (Global) of payroll to change */
  id: Scalars['ID']['input'];
  /** Name of new payroll */
  name: Scalars['String']['input'];
};

/** Payload for changing payroll name */
export type ChangePayrollNamePayload = {
  __typename: 'ChangePayrollNamePayload';
  payroll: Maybe<Payroll>;
};

/** Single checkbox component */
export type CheckboxFormComponent = FormComponentBase & {
  __typename: 'CheckboxFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export type CipMissing = Error & {
  __typename: 'CipMissing';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Unpaid claim/invoice */
export type Claim = Node & {
  __typename: 'Claim';
  /** The total amount to pay in ISK. This includes principal amount plus all other costs. */
  amount: Scalars['Float']['output'];
  /** ID (Api) of the batch that the claim belongs to. */
  batchId: Maybe<Scalars['String']['output']>;
  /** Number on the claim. Often number as on an issued invoice. */
  billNumber: Maybe<Scalars['String']['output']>;
  /** Booking ID (Api) (bókunarnúmer) */
  bookingId: Maybe<Scalars['String']['output']>;
  /** Can the claim be paid in bulk with other claims? */
  canBeBulkPaid: Scalars['Boolean']['output'];
  /** Can the user delete the claim? Should be only available for optional claims. */
  canBeDeleted: Scalars['Boolean']['output'];
  /** Can the claim be direct debited? (beingreiðsla) */
  canBeDirectDebited: Scalars['Boolean']['output'];
  /** Can the claim be hidden by the user? */
  canBeHidden: Scalars['Boolean']['output'];
  /** Can the user pay the claim? */
  canBePaid: Scalars['Boolean']['output'];
  /** Can the claim be partially paid? (greiða hluta) */
  canBePartialPaid: Scalars['Boolean']['output'];
  /** Can the user schedule when the claim should be paid? */
  canBeScheduled: Scalars['Boolean']['output'];
  /** Can user cancel direct debit for this claim? (beingreiðsla) */
  canDirectDebitBeCancelled: Scalars['Boolean']['output'];
  /** ID (Api) for the claim. */
  claimId: Scalars['String']['output'];
  /** Account id of the claimant for claim. */
  claimantAccountId: Scalars['String']['output'];
  /** ID (Api) for the claimant. */
  claimantId: Scalars['String']['output'];
  /** Full name of the claimant. */
  claimantName: Scalars['String']['output'];
  /** List of electronic documents connected to the claim. Returns null if hasConnectedDocuments is false. */
  connectedDocuments: Maybe<Array<ElectronicDocument>>;
  /** The currency code of the amount to pay. The amount to pay is always in ISK but the principal amount can be in foreign currency. */
  currencyCode: Scalars['String']['output'];
  /** The exchange rate from principal amount currency to ISK. */
  currencySellingRate: Maybe<Scalars['Float']['output']>;
  /** 16 char optional text, "viðskiptanúmer", defined by the claimant. For the claim to have `canBeDirectDebited: true` this field must be defied. This field is one of the keys when creating a direct debit mandate ("beingreiðslusamningur"). */
  customerNumber: Maybe<Scalars['String']['output']>;
  /** Default cost (vanskilakostnaður). */
  defaultCharge: Scalars['Float']['output'];
  /** Description for claim. */
  description: Maybe<Scalars['String']['output']>;
  /** Information object about direct debit agreement on claim */
  directDebit: Maybe<DirectDebitMandate>;
  /** ID (Api) for direct debit agreement. */
  directDebitContractId: Maybe<Scalars['String']['output']>;
  /** If the claim is paid before due date, this is the discount that is applied to the principal amount. */
  discount: Scalars['Float']['output'];
  /** Title of the claim combined of claimant name and text key name, joined by a dash. Example: "Landsbankinn - Lán" */
  displayTitle: Scalars['String']['output'];
  /** The date from where interests are calculated if claim is not paid on final due date. (gjalddagi) */
  dueDate: Scalars['DateTimeISO']['output'];
  /** Final date to pay the claim, otherwise the customer must pay interest (eindagi). */
  finalDueDate: Scalars['DateTimeISO']['output'];
  /** Indicates if there are any connected documents to the claim. */
  hasConnectedDocuments: Scalars['Boolean']['output'];
  /** Is true if final due date has passed. */
  hasFinalDueDatePassed: Scalars['Boolean']['output'];
  /** Is there a stored payment for this claim? (vinnuborð) */
  hasStoredPayment: Scalars['Boolean']['output'];
  /** Is this claim hidden by the user? (falin krafa) */
  hidden: Scalars['Boolean']['output'];
  /** ID (Global) for the claim. */
  id: Scalars['ID']['output'];
  /** Claim template identifier (Vísir). */
  identifier: Scalars['String']['output'];
  /** Is the claim currently in direct debit? (í beingreiðslu) */
  inDirectDebit: Scalars['Boolean']['output'];
  /** Maximum amount to pay for claim. */
  maxPaymentAmount: Scalars['Float']['output'];
  /** Minimum amount to pay when partially paying claim. */
  minPaymentAmount: Scalars['Float']['output'];
  /** Notification cost (tilkynningar- og greiðslugjald) */
  notificationCost: Scalars['Float']['output'];
  /** Is this an optional claim? (valgreiðsla) */
  optional: Scalars['Boolean']['output'];
  /** Other costs related to the claim. */
  otherCost: Scalars['Float']['output'];
  /** Other default cost (annar vanskilakostnaður). */
  otherDefaultCost: Scalars['Float']['output'];
  /** The type of payment for this claim */
  paymentType: ClaimPaymentType;
  /** ID (Api) for the payor. */
  payorId: Scalars['String']['output'];
  /** Full name of the payor. */
  payorName: Scalars['String']['output'];
  /** PDF document with overview of the claim */
  pdfDocument: DocumentBucket;
  /** The interest rate for the case where claim is not paid on final due date. Starts on due date. */
  penaltyInterest: Scalars['Float']['output'];
  /** The principal amount (höfuðstóll) of the claim. It can be in a different currency than ISK. See principalAmountCurrency. */
  principalAmount: Scalars['Float']['output'];
  /** Currency code of the principal amount. */
  principalAmountCurrency: Scalars['String']['output'];
  /** Optional reference key on claim. Default is payers kennitala (tilvísun) */
  reference: Maybe<Scalars['String']['output']>;
  /** Information about scheduled payment */
  scheduledPayment: Maybe<ScheduledClaimPaymentResponse>;
  /** Text key object for claim */
  textKey: TextKey;
  /** Total cost of the claim. It includes notificationCost ("Tilkynningar og greiðslugjald"), other costs, defaultCharge ("Innheimtuviðvörun"), otherDefaultCost ("Milliinnheimtubréf") and penaltyInterest ("Dráttarvextir"). */
  totalCost: Scalars['Float']['output'];
  /** Account id of withdrawal account. */
  withdrawalAccountId: Maybe<Scalars['String']['output']>;
};

/** Claim connection that includes excel document */
export type ClaimConnection = {
  __typename: 'ClaimConnection';
  edges: Array<ClaimEdge>;
  /** Base64 encoded string of excel document */
  excelDocument: Scalars['String']['output'];
  pageInfo: PageInfo;
  /** Total amount of all claims on current page */
  totalAmount: CurrencyAmount;
  totalCount: Scalars['Int']['output'];
};


/** Claim connection that includes excel document */
export type ClaimConnectionExcelDocumentArgs = {
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClaimsFilterArgs>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['ID']['input']>;
  payorId?: InputMaybe<Scalars['String']['input']>;
  searchStringKennitala?: InputMaybe<Scalars['String']['input']>;
  searchStringName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClaimSearchType>;
};

/** Information about default interest of the claim */
export type ClaimDefaultInterest = {
  __typename: 'ClaimDefaultInterest';
  /** Default interest rate */
  rate: Scalars['Float']['output'];
  /** Whether central bank rate is applied */
  useCentralBankRate: Scalars['Boolean']['output'];
};

/** Configuration of a certain discount */
export type ClaimDiscount = {
  __typename: 'ClaimDiscount';
  /** Number of days to apply to the calculation rule to apply discount */
  numberOfDays: Scalars['Int']['output'];
  /** Value of the discount (amount) */
  value: CurrencyAmount;
};

/** Information about possible discounts */
export type ClaimDiscountInfo = {
  __typename: 'ClaimDiscountInfo';
  /** Rule to determine when to apply discount */
  calculationRule: CalculationRuleBefore;
  /** Information about first discount */
  firstDiscount: ClaimDiscount;
  /** Is discount set to be applied in percentage */
  isPercentage: Scalars['Boolean']['output'];
  /** Information about second discount */
  secondDiscount: ClaimDiscount;
};

/** The payment assigned to a claim exists, but the claim itself was already paid or deleted. The API returns this error When trying to (re)pay this type of payment */
export type ClaimDoesNotExistCanBeAlreadyPaidOrDeleted = Error & {
  __typename: 'ClaimDoesNotExistCanBeAlreadyPaidOrDeleted';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ClaimEdge = {
  __typename: 'ClaimEdge';
  cursor: Scalars['String']['output'];
  node: Claim;
};

export type ClaimLookupResponse = Claim | ClaimNotFound;

export type ClaimNotFound = Error & {
  __typename: 'ClaimNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Information about fees for notice */
export type ClaimNoticeAndPaymentFee = {
  __typename: 'ClaimNoticeAndPaymentFee';
  /** Fee for paperless notice */
  paperlessFee: CurrencyAmount;
  /** Fee for printed notice */
  printingFee: CurrencyAmount;
};

export type ClaimPayer = {
  __typename: 'ClaimPayer';
  claims: ClaimConnection;
  /** Direct Debit Mandates of a claim payer */
  directDebitMandates: DirectDebitMandateConnection;
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
  showInSummary: Scalars['Boolean']['output'];
};


export type ClaimPayerClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClaimsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClaimSearchType>;
};


export type ClaimPayerDirectDebitMandatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DirectDebitMandateType>;
};

/** ClaimPayment */
export type ClaimPayment = Node & PaymentInterface & {
  __typename: 'ClaimPayment';
  claim: ClaimPaymentClaim;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  /** Payment exchange rate info */
  exchangeRate: Maybe<PaymentExchangeRate>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  isFuturePayment: Scalars['Boolean']['output'];
  isPartialPayment: Scalars['Boolean']['output'];
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export type ClaimPaymentClaim = {
  __typename: 'ClaimPaymentClaim';
  claimLookup: Maybe<Claim>;
  claimNumber: Scalars['String']['output'];
  claimant: ClaimPaymentClaimClaimant;
  /** Only available for completed payments */
  details: Maybe<ClaimPaymentClaimDetails>;
  dueDate: Maybe<Scalars['DateTimeISO']['output']>;
  finalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  payor: ClaimPaymentClaimPayor;
};

export type ClaimPaymentClaimClaimant = {
  __typename: 'ClaimPaymentClaimClaimant';
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClaimPaymentClaimCostBreakDown = {
  __typename: 'ClaimPaymentClaimCostBreakDown';
  defaultCharge: CurrencyAmount;
  defaultInterest: CurrencyAmount;
  discount: CurrencyAmount;
  noticeAndPaymentFee: CurrencyAmount;
  otherCost: CurrencyAmount;
  otherDefaultCost: CurrencyAmount;
};

export type ClaimPaymentClaimDetails = {
  __typename: 'ClaimPaymentClaimDetails';
  billNumber: Scalars['String']['output'];
  categoryCode: Scalars['String']['output'];
  categoryCodeDescription: Scalars['String']['output'];
  claimNumber: Scalars['String']['output'];
  costBreakDown: ClaimPaymentClaimCostBreakDown;
  description: Maybe<Scalars['String']['output']>;
  principalAmount: CurrencyAmount;
  /** Reference to payment (tilvísun) */
  reference: Maybe<Scalars['String']['output']>;
};

export type ClaimPaymentClaimPayor = {
  __typename: 'ClaimPaymentClaimPayor';
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ClaimPaymentInitialPaymentData = Node & PaymentInterface & {
  __typename: 'ClaimPaymentInitialPaymentData';
  claim: ClaimPaymentClaim;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  /** Payment exchange rate info */
  exchangeRate: Maybe<PaymentExchangeRate>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  isFuturePayment: Scalars['Boolean']['output'];
  isPartialPayment: Scalars['Boolean']['output'];
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export enum ClaimPaymentType {
  Direct = 'Direct',
  DirectInOtherBank = 'DirectInOtherBank',
  PaymentServiceOrEqualisation = 'PaymentServiceOrEqualisation',
  Scheduled = 'Scheduled',
  ScheduledFailed = 'ScheduledFailed',
  Undefined = 'Undefined'
}

export enum ClaimSearchType {
  All = 'All',
  Direct = 'Direct',
  Hidden = 'Hidden',
  Normal = 'Normal',
  NormalAndDirect = 'NormalAndDirect',
  NormalAndOptional = 'NormalAndOptional',
  NotHidden = 'NotHidden',
  Optional = 'Optional'
}

/** Settings for the claim */
export type ClaimSettings = {
  __typename: 'ClaimSettings';
  /** Information about default charges */
  defaultCharge: DefaultChargeInfo;
  /** Information about default interest of the claim */
  defaultInterest: ClaimDefaultInterest;
  /** Information about possible discounts */
  discount: ClaimDiscountInfo;
  /** The date from where interests are calculated if claim is not paid on final due date. */
  dueDateRule: Scalars['Int']['output'];
  /** Final date to pay the claim, otherwise the customer must pay interest */
  finalDueDateRule: Scalars['Int']['output'];
  /** Whether the claim can be payed non-consecutively */
  isOutOfSequencePaymentAllowed: Scalars['Boolean']['output'];
  /** Whether the payment can be done in parts */
  isPartialPaymentAllowed: Scalars['Boolean']['output'];
  /** Number of month until the claim is cancelled */
  monthsUntilCancellation: Scalars['Int']['output'];
  /** Information about fees for notice */
  noticeAndPaymentFee: ClaimNoticeAndPaymentFee;
  /** Other costs related to the claim */
  otherCost: CurrencyAmount;
  /** Other default cost (annar vanskilakostnaður) */
  otherDefaultCost: CurrencyAmount;
};

/** Claim status */
export enum ClaimStatusType {
  /** Claims with direct debit (beingreiðsla) */
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  /** Claims with future payment (framvirk) */
  FUTURE_PAYMENT = 'FUTURE_PAYMENT',
  /** Claims waiting to be paid */
  WAITING_TO_BE_PAID = 'WAITING_TO_BE_PAID'
}

export enum ClaimSummaryType {
  Direct = 'Direct',
  Optional = 'Optional',
  PaymentService = 'PaymentService',
  Scheduled = 'Scheduled'
}

/** Claimant categories, with associated bank details. */
export type ClaimantCategory = {
  __typename: 'ClaimantCategory';
  /** Bank branch number associated with the claimant category */
  bank: Maybe<Scalars['String']['output']>;
  /** Category code of the claimant category */
  code: Maybe<Scalars['String']['output']>;
  /** Description of the claimant category */
  description: Maybe<Scalars['String']['output']>;
  /** Name of the category */
  name: Maybe<Scalars['String']['output']>;
};

export type ClaimantIdCategoryCodeCombinationMissingError = Error & {
  __typename: 'ClaimantIdCategoryCodeCombinationMissingError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Configuration that describes of the way we reference the claimant */
export type ClaimantStatementReference = {
  __typename: 'ClaimantStatementReference';
  /** Extended reference of the claimant */
  extendedReferenceType: InvoiceTemplateExtendedReference;
  /** Short reference of the claimant */
  shortReferenceType: InvoiceTemplateShortReference;
};

export type ClaimsFilterArgs = {
  /** Filter by claimant kennitala */
  claimantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Filter by claimant name */
  claimantName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by claim status */
  statusTypes?: InputMaybe<Array<ClaimStatusType>>;
};

/** Age bucket in a claims financing settlement (IS: Aldurspottur) */
export type ClaimsFinancingAgeBucket = {
  __typename: 'ClaimsFinancingAgeBucket';
  /** ID (Global) of the age bucket */
  id: Scalars['ID']['output'];
  /** Name of the bucket (IS: Nafn) */
  name: Scalars['String']['output'];
  /** Amount payable in the bucket (IS: Til greiðslu) */
  payableAmount: CurrencyAmount;
  /** Principal amount in the bucket (IS: Höfuðstóll) */
  principalAmount: CurrencyAmount;
  /** Ratio of payers in the bucket (IS: Hlutfall). Returns null if scoped within payor */
  ratio: Maybe<Scalars['Float']['output']>;
};

/** The status of a claims financing agreement (IS: Staða kröfufjármögnunar) */
export enum ClaimsFinancingAgreementStatus {
  /** The agreement is active (IS: Virk) */
  Active = 'Active',
  /** The agreement has been closed (IS: Lokað) */
  Closed = 'Closed',
  /** The agreement is in some other state (IS: Annað) */
  Other = 'Other',
  /** The agreement has been registered but is not yet active (IS: Skráð) */
  Registered = 'Registered',
  /** The agreement status is not returned by the API (IS: Óþekkt) */
  Unknown = 'Unknown'
}

/** A claims financing agreement (IS: Kröfufjármögnun) */
export type ClaimsFinancingDetail = Node & {
  __typename: 'ClaimsFinancingDetail';
  /** Claims financing account number (IS: Kröfufjármögnunarreikningur) */
  claimsFinancingAccountNumber: Maybe<Scalars['String']['output']>;
  /** Collateral ratio (IS: Veðhlutfall) */
  collateralRatio: Scalars['Float']['output'];
  /** Disposition account number (IS: Ráðstöfunarreikningur) */
  dispositionAccountNumber: Maybe<Scalars['String']['output']>;
  /** ID (Global) of the claims financing agreement */
  id: Scalars['ID']['output'];
  /** Lending frame (IS: Lánarammi) */
  lendingFrameAmount: CurrencyAmount;
  /** The portfolio settlement for the agreement (IS: Uppgjör). null when no settlement is available. */
  portfolioSettlement: Maybe<ClaimsFinancingPortfolioSettlement>;
  /** Status of the agreement (IS: Staða) */
  status: ClaimsFinancingAgreementStatus;
};

export type ClaimsFinancingErrors = ClaimsFinancingNoAccountAccessError | ClaimsFinancingNoResultError;

/** Object containing the claims financing agreement for the user or an error if there is a problem fetching the data */
export type ClaimsFinancingInfo = {
  __typename: 'ClaimsFinancingInfo';
  /** Claims financing agreement for the user, if available */
  data: Maybe<ClaimsFinancingDetail>;
  /** Business errors related to fetching claims financing information */
  error: Maybe<ClaimsFinancingErrors>;
};

/** Error indicating that the user does not have the privilege required to view claims financing. Clients should show a "privilege needed" screen. */
export type ClaimsFinancingNoAccountAccessError = Error & {
  __typename: 'ClaimsFinancingNoAccountAccessError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Error indicating that the customer is not registered for claims financing or has no agreements. Clients should show marketing content. */
export type ClaimsFinancingNoResultError = Error & {
  __typename: 'ClaimsFinancingNoResultError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Payer in a claims financing settlement (IS: Greiðandi) */
export type ClaimsFinancingPayer = {
  __typename: 'ClaimsFinancingPayer';
  /** Age buckets for the payer (IS: Aldurspottar) */
  ageBuckets: Array<ClaimsFinancingAgeBucket>;
  /** Creditworthy receivables for the payer (IS: Lánshæfar kröfur) */
  creditworthyReceivablesAmount: CurrencyAmount;
  /** ID (Global) of the payer */
  id: Scalars['ID']['output'];
  /** Kennitala of the payer */
  kennitala: Scalars['String']['output'];
  /** Maximum loan amount for the payer (IS: Lánshámark) */
  maximumLoanAmount: CurrencyAmount;
  /** Name of the payer (IS: Nafn) */
  name: Scalars['String']['output'];
  /** Payment class of the payer (IS: Greiðsluflokkur) */
  paymentClass: ClaimsFinancingPaymentClass;
  /** Portfolio payable for the payer (IS: Til greiðslu úr safni) */
  portfolioPayableAmount: CurrencyAmount;
  /** Portfolio principal for the payer (IS: Höfuðstóll safns) */
  portfolioPrincipalAmount: CurrencyAmount;
};

/** Payment class of a payer in claims financing (IS: Greiðsluflokkur) */
export enum ClaimsFinancingPaymentClass {
  /** Payment class A (IS: Greiðsluflokkur A) */
  A = 'A',
  /** Payment class B (IS: Greiðsluflokkur B) */
  B = 'B',
  /** Payment class C (IS: Greiðsluflokkur C) */
  C = 'C',
  /** Payment class D (IS: Greiðsluflokkur D) */
  D = 'D',
  /** Payment class E (IS: Greiðsluflokkur E) */
  E = 'E',
  /** The payment class returned by the API is not recognized (IS: Óþekkt) */
  Unknown = 'Unknown'
}

/** Aggregated figures per payment class in a settlement (IS: Samtala eftir greiðsluflokki) */
export type ClaimsFinancingPaymentClassAggregate = {
  __typename: 'ClaimsFinancingPaymentClassAggregate';
  /** ID (Global) of the payment class aggregate */
  id: Scalars['ID']['output'];
  /** Lending base for the class (IS: Lánagrunnur) */
  lendingBaseAmount: CurrencyAmount;
  /** Number of payers in the class (IS: Fjöldi greiðenda) */
  payerCount: Scalars['Int']['output'];
  /** Payment class (IS: Greiðsluflokkur) */
  paymentClass: ClaimsFinancingPaymentClass;
  /** Principal amount for the class (IS: Höfuðstóll) */
  principalAmount: CurrencyAmount;
};

/** Claims financing settlement details (IS: Uppgjör kröfufjármögnunar) */
export type ClaimsFinancingPortfolioSettlement = {
  __typename: 'ClaimsFinancingPortfolioSettlement';
  /** Age buckets across the settlement (IS: Aldurspottar) */
  ageBuckets: Array<ClaimsFinancingAgeBucket>;
  /** Amount available after same-day payments (IS: Til ráðstöfunar núna) */
  availableNowAmount: CurrencyAmount;
  /** Amount paid within the same day (IS: Greitt innan dags) */
  paidWithinDayAmount: CurrencyAmount;
  /** Payers in the settlement (IS: Greiðendur) */
  payers: Array<ClaimsFinancingPayer>;
  /** Aggregated figures per payment class (IS: Samtölur eftir greiðsluflokki) */
  paymentClasses: Array<ClaimsFinancingPaymentClassAggregate>;
  /** Settlement figures (IS: Uppgjör) */
  settlement: ClaimsFinancingSettlement;
};

/** Claims financing settlement (IS: Uppgjör) */
export type ClaimsFinancingSettlement = {
  __typename: 'ClaimsFinancingSettlement';
  /** Account balance before settlement (IS: Staða reiknings fyrir uppgjör) */
  accountBalanceBeforeSettlementAmount: CurrencyAmount;
  /** Available for disposition (IS: Til ráðstöfunar) */
  availableForDispositionAmount: CurrencyAmount;
  /** Calculated lending base (IS: Reiknaður lánagrunnur) */
  calculatedLendingBaseAmount: CurrencyAmount;
  /** Creation date of the settlement (IS: Stofnað) */
  createdDate: Scalars['DateTimeISO']['output'];
  /** ID (Global) of the settlement */
  id: Scalars['ID']['output'];
  /** Lending base (IS: Lánagrunnur) */
  lendingBaseAmount: CurrencyAmount;
  /** Lending limit (IS: Útlánaheimild) */
  lendingLimitAmount: CurrencyAmount;
  /** Permissible lending (IS: Leyfileg útlán) */
  permissibleLendingAmount: CurrencyAmount;
  /** Total portfolio payable (IS: Heildar til greiðslu úr safni) */
  totalPortfolioPayableAmount: CurrencyAmount;
  /** Total portfolio principal (IS: Heildar höfuðstóll safns) */
  totalPortfolioPrincipalAmount: CurrencyAmount;
};

export type ClaimsSubscriptions = {
  __typename: 'ClaimsSubscriptions';
  creation: Scalars['Boolean']['output'];
  finalDueDate: Scalars['Boolean']['output'];
};

/** Claims widget */
export type ClaimsWidget = {
  __typename: 'ClaimsWidget';
  /** Claims widget data */
  data: Maybe<InvoicesClaimsStatistics>;
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type ClickToPayNoAccessError = Error & {
  __typename: 'ClickToPayNoAccessError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ClickToPayRequest = Node & {
  __typename: 'ClickToPayRequest';
  id: Scalars['ID']['output'];
  /** The status of the Click to Pay request */
  requestStatus: CardClickToPayRequestStatus;
};

export type ClientVersionNotSupported = Error & {
  __typename: 'ClientVersionNotSupported';
  /** The clients application version is less then the required application version. Currently only applies to the mobile App */
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CloseCardAndCreateNewInput = {
  /** Reason for the card being closed */
  closeCardTerminationReason: CloseCardTerminationReason;
  /** The delivery address for the card */
  deliveryAddress?: InputMaybe<CardDeliveryAddressInput>;
  /** A branch number. Used if the applicant chooses to get his card from a specific branch */
  deliveryBranchId?: InputMaybe<Scalars['String']['input']>;
  /** The node id of the card being updated */
  id: Scalars['ID']['input'];
};

export type CloseCardAndCreateNewPayload = {
  __typename: 'CloseCardAndCreateNewPayload';
  /** The id of the newly created card */
  cardId: Scalars['Float']['output'];
};

export type CloseCardInput = {
  /** The status of the card being terminated */
  cardStatus: CloseCardRequestActivityStatus;
  /** The node id of the card being updated */
  id: Scalars['ID']['input'];
};

/** The status of the card being terminated */
export enum CloseCardRequestActivityStatus {
  /** Card is pending termination until annual renewal date by the owner */
  PENDING_TERMINATION_BY_OWNER = 'PENDING_TERMINATION_BY_OWNER',
  /** Card is immediately terminated by the owner */
  TERMINATED_BY_OWNER = 'TERMINATED_BY_OWNER',
  /** Card is terminated due to being lost */
  TERMINATED_LOST = 'TERMINATED_LOST',
  /** Card is terminated due to being stolen */
  TERMINATED_STOLEN = 'TERMINATED_STOLEN'
}

/** The reason for terminating a card */
export enum CloseCardTerminationReason {
  /** Lost card */
  LOST = 'LOST',
  /** Stolen card */
  STOLEN = 'STOLEN'
}

export type CollateralGuarantorInput = {
  /** The email of the guarantor */
  email: Scalars['String']['input'];
  /** The kennitala of the guarantor */
  kennitala: Scalars['String']['input'];
};

export type CollectionBond = LiabilityLoanInterface & Node & {
  __typename: 'CollectionBond';
  annuitet: Scalars['Boolean']['output'];
  baseIndex: Maybe<Scalars['Float']['output']>;
  collectionStatus: CollectionBondStatus;
  /** Icelandic: vanskil */
  defaultedAmount: CurrencyAmount;
  /** Excel document bucket containing excel file with detailed information about the bond and its payments */
  detailedCollectionBondExcelReport: Maybe<DocumentBucket>;
  firstDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  fullAccountNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  indexTypeEnum: LiabilityIndexType;
  indexed: Scalars['Boolean']['output'];
  initialAmount: CurrencyAmount;
  interestCategory: Maybe<Scalars['String']['output']>;
  interestRate: Scalars['Float']['output'];
  issueDate: Scalars['DateTimeISO']['output'];
  lastPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** account number of the loan */
  loanNumber: Scalars['String']['output'];
  loanStatusType: LiabilityLoanStatus;
  mainDebtor: LiabilityParty;
  monthsBetweenPayments: Scalars['Int']['output'];
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Total number of due dates */
  numberOfMonths: Scalars['Int']['output'];
  oldestDefaultedDate: Maybe<Scalars['DateTimeISO']['output']>;
  payBack: Maybe<LiabilityPayback>;
  payments: LiabilityPaymentsConnection;
  /** Icelandic: Eftirstöðvar */
  remainder: CurrencyAmount;
  remainingPayments: Scalars['Int']['output'];
};


export type CollectionBondPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LiabilityPaymentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionBondConnection = {
  __typename: 'CollectionBondConnection';
  edges: Array<CollectionBondEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CollectionBondEdge = {
  __typename: 'CollectionBondEdge';
  cursor: Scalars['String']['output'];
  node: CollectionBond;
};

export type CollectionBondFilterArgs = {
  /** Kennitala of the debtor, providing this will only return the bonds the viewer has loaned to the corresponding kennitala */
  borrowerKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the bond, made up of branch, ledger, and account */
  loanNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Status of the collection bond */
export enum CollectionBondStatus {
  /** IS: Innheimtuviðvörun */
  COLLECTION_ALERT = 'COLLECTION_ALERT',
  /** IS: Greiðsluaðlögun */
  DEBT_MITIGATION = 'DEBT_MITIGATION',
  /** IS: Ytri innheimta */
  EXTERNAL_COLLECTION = 'EXTERNAL_COLLECTION',
  /** IS: Milliinnheimta */
  INTERMEDIATE_COLLECTION = 'INTERMEDIATE_COLLECTION',
  /** IS: Í vanskilum (innheimtuferli ekki hafið) */
  IN_DEFAULT = 'IN_DEFAULT',
  /** IS: Lögfræðiinnheimta */
  LEGAL_COLLECTION = 'LEGAL_COLLECTION',
  /** IS: Engin innheimtustaða */
  NONE = 'NONE',
  /** IS: Komið til baka úr ytri innheimtu */
  PREP_FOR_LEGAL_COLLECTION = 'PREP_FOR_LEGAL_COLLECTION',
  /** Unknown collection status */
  UNKNOWN = 'UNKNOWN'
}

/** Collection company */
export type CollectionCompany = {
  __typename: 'CollectionCompany';
  /**
   * Company code
   * @deprecated Not in use; will always return an empty string
   */
  companyCode: Scalars['String']['output'];
  /** ID (global) of the company */
  id: Scalars['ID']['output'];
  /** ID (kennitala) of the company */
  kennitala: Scalars['String']['output'];
  /** Company name */
  name: Scalars['String']['output'];
};

export type CollectionCompanyConnection = {
  __typename: 'CollectionCompanyConnection';
  edges: Array<CollectionCompanyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CollectionCompanyEdge = {
  __typename: 'CollectionCompanyEdge';
  cursor: Scalars['String']['output'];
  node: CollectionCompany;
};

/** Claims access permissions for third parties */
export type CollectionServiceThirdParty = Node & {
  __typename: 'CollectionServiceThirdParty';
  id: Scalars['ID']['output'];
  /** Name of the third party */
  name: Scalars['String']['output'];
  /** Kennitala of the third party */
  nationalId: Scalars['String']['output'];
  /** Third party permissions */
  permissions: Array<CollectionServiceThirdPartyPermission>;
};

export type CollectionServiceThirdPartyConnection = {
  __typename: 'CollectionServiceThirdPartyConnection';
  edges: Array<CollectionServiceThirdPartyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CollectionServiceThirdPartyEdge = {
  __typename: 'CollectionServiceThirdPartyEdge';
  cursor: Scalars['String']['output'];
  node: CollectionServiceThirdParty;
};

/** All claims access permissions for a specific third party */
export type CollectionServiceThirdPartyPermission = {
  __typename: 'CollectionServiceThirdPartyPermission';
  /** Kennitala of the customer */
  customerKennitala: Scalars['String']['output'];
  /** True if this permission is enabled, false if it is not. */
  enabled: Scalars['Boolean']['output'];
  /** Entity id of this permission (optional) */
  entityId: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of this permission */
  id: Scalars['ID']['output'];
  /** Id of the third party */
  thirdPartyId: Scalars['ID']['output'];
  /** Kennitala of the third party */
  thirdPartyKennitala: Scalars['String']['output'];
  /** Name of the third party */
  thirdPartyName: Scalars['String']['output'];
  /** Third party permission type */
  type: CollectionServiceThirdPartyPermissionsType;
};

/** Third party permissions type */
export type CollectionServiceThirdPartyPermissionsType = {
  __typename: 'CollectionServiceThirdPartyPermissionsType';
  /** Description of the permission type */
  description: Scalars['String']['output'];
  /** Domain that this permission type belongs to */
  domain: Scalars['String']['output'];
  /** Unique identifier of this permission type */
  id: Scalars['String']['output'];
  /** Name of this permission type */
  name: Scalars['String']['output'];
};

export type CollectionServiceThirdPartyTogglePermissionErrorUnion = UnknownError | UserDoesNotHavePermissionToTogglePermissionError;

/** A commission granted to the bank by a user using electronic id */
export type Commission = Node & {
  __typename: 'Commission';
  coApplicant: Maybe<CommissionApplicant>;
  created: Scalars['DateTimeISO']['output'];
  /** Id for the digitalSignatureDocument pdf */
  digitalSignatureDocumentId: Scalars['ID']['output'];
  digitalSignatureGroup: DigitalSignatureGroup;
  expires: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  mainApplicant: CommissionApplicant;
  processId: Maybe<Scalars['String']['output']>;
  recordId: Maybe<Scalars['String']['output']>;
  status: CommissionStatus;
};

/** Either main- or coApplicant of the commission */
export type CommissionApplicant = {
  __typename: 'CommissionApplicant';
  emailAddress: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export enum CommissionCreditAssessmentType {
  AutomaticCreditAssessment = 'AutomaticCreditAssessment',
  BranchCreditAssessment = 'BranchCreditAssessment',
  CarAssessment = 'CarAssessment',
  CreditAssessment = 'CreditAssessment',
  GuarantorAssessment = 'GuarantorAssessment'
}

export type CommissionCustomer = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  kennitala: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionFilterArgs = {
  /** Filter by one or more commission statuses */
  comissionStatuses?: InputMaybe<Array<CommissionStatus>>;
  creditAssessmentType?: InputMaybe<CommissionCreditAssessmentType>;
};

export enum CommissionStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Error = 'Error',
  InSigning = 'InSigning',
  Pending = 'Pending'
}

export type CompaniesAvailableForOnboardingPayload = {
  __typename: 'CompaniesAvailableForOnboardingPayload';
  companies: Array<CompanyAvailableForOnboarding>;
};

/** Information about the company of the fbl user,Contains kyc information */
export type Company = {
  __typename: 'Company';
  /** Raunverulegir eigendur fyrirtækis frá fyrirtækjaskrá RSK */
  beneficialOwners: Maybe<Array<BeneficialOwner>>;
  creditLimit: Scalars['Float']['output'];
  /** Get full company info connected to the customer */
  customerCompanyInfo: CustomerCompanyInfo;
  /** 24-hour withdrawal limit for the company that is current user */
  customerDailyWithdrawalLimit: CurrencyAmount;
  employee: Maybe<EmployeeInformation>;
  hasActivePaymentApprovalRules: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Atvinnugreinaflokkun (isat) frá fyrirtækjaskrá RSK */
  isat: Scalars['String']['output'];
  /** National id (kennitala) of the company */
  kennitala: Scalars['String']['output'];
  /** Get known parties (real owners and stakeholders) for the company. Only available to access managers of the company. */
  knownParties: Array<KnownParty>;
  /** Tegund áreiðanleikakönnunar sem fyrirtæki þarf að fylla út, byggir á legal form */
  kycCategory: KycCategory;
  /** The latest onboarding application of the company. Returns null if no application is found, and for national logins. */
  latestOnboardingApplication: Maybe<CompanyOnboardingApplication>;
  /** @deprecated Deprecated, use viewer.legalAddress as it is the company's legalAddress registered in Landsbankinn when Corporate User */
  legalAddress: Address;
  /** Name of the company */
  name: Scalars['String']['output'];
  /** @deprecated Use latestOnboardingApplication instead, which uses Onboarding v4. Since: 2026-09-15. Issue to remove it: WEB-45892 */
  onboardingApplication: Maybe<OnboardingCorporateApplication>;
  /**
   * Get company services
   * @deprecated Moved to authorization object. Issue to remove: WEB-37072
   */
  services: Array<CompanyService>;
  /** Forsvarsmenn fyrirtækis frá fyrirtækjaskrá RSK */
  stakeholders: Maybe<Array<Stakeholder>>;
  /** Get current company and its subsidiaries */
  subsidiaries: Maybe<Array<CompanySubsidiary>>;
  viewerCanAnswerKyc: Scalars['Boolean']['output'];
  viewerCanCreateAccountProducts: Scalars['Boolean']['output'];
  viewerCanMakeLoanDeposit: Scalars['Boolean']['output'];
  /** The viewer's credit worthy list */
  viewerCreditWorthyList: Maybe<Array<CompanyCreditWorthy>>;
  /** Viewer's stake in the company. Fetched from the beneficial owner list. */
  viewerHolding: Maybe<Scalars['Float']['output']>;
  viewerTradeAuthorization: CompanyTradeAuthorization;
};


/** Information about the company of the fbl user,Contains kyc information */
export type CompanyEmployeeArgs = {
  kennitala: Scalars['String']['input'];
};


/** Information about the company of the fbl user,Contains kyc information */
export type CompanyKnownPartiesArgs = {
  statuses?: InputMaybe<Array<KnownPartyStatus>>;
};


/** Information about the company of the fbl user,Contains kyc information */
export type CompanyViewerCreditWorthyListArgs = {
  productType: CompanyCreditScoreType;
};

export type CompanyAvailableForOnboarding = {
  __typename: 'CompanyAvailableForOnboarding';
  companyKennitala: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Whether the company is a house association (ísl. húsfélag), based on its legal form. */
  isHouseAssociation: Scalars['Boolean']['output'];
};

export enum CompanyContactRole {
  Ceo = 'Ceo',
  Procurator = 'Procurator',
  Treasurer = 'Treasurer'
}

/** The type of credit score checks that can be made for companies */
export enum CompanyCreditScoreType {
  CREDIT_CARD = 'CREDIT_CARD',
  DRAW_DOWN = 'DRAW_DOWN',
  /** Lánarammi B&T */
  MANUAL_VEHICLE = 'MANUAL_VEHICLE',
  OVERDRAFT = 'OVERDRAFT',
  OVERDRAFT_EXTENSION = 'OVERDRAFT_EXTENSION',
  PRE_APPROVED_LIMIT = 'PRE_APPROVED_LIMIT',
  /** Sjálfskuldarábyrgð */
  SURETY = 'SURETY',
  UNKNOWN = 'UNKNOWN',
  VEHICLE = 'VEHICLE'
}

/** Describes the validity of a credit worthy condition (lánshæfi) */
export type CompanyCreditWorthy = {
  __typename: 'CompanyCreditWorthy';
  /** The type of credit worthy */
  creditWorthyType: CompanyCreditWorthyType;
  /** A description of the credit worthy type and its conditions */
  description: Maybe<Scalars['String']['output']>;
  /** Whether the credit worthy value is valid or not, can be null if missing */
  isValid: Maybe<Scalars['Boolean']['output']>;
};

/** The type of credit worthy (lánshæfi) check or condition. The descriptions are taken directly from the CreditScore service */
export enum CompanyCreditWorthyType {
  /** Tekjur */
  ACTIVE_INCOME = 'ACTIVE_INCOME',
  /** Velta */
  ACTIVE_TURN_OVER = 'ACTIVE_TURN_OVER',
  /** Ársreikningur má ekki vera of gamall */
  ANNUAL_REPORT_AGE = 'ANNUAL_REPORT_AGE',
  /** Ársreikningar þurfa að vera bak í bak */
  ANNUAL_REPORT_BACK_TO_BACK = 'ANNUAL_REPORT_BACK_TO_BACK',
  /** Engar rauðar athugasemdir í CRM */
  BAD_CRM_COMMENTS = 'BAD_CRM_COMMENTS',
  /** Vanskilamerkingar í vanskilavakt */
  DEFAULT_MONITORING_MARKINGS = 'DEFAULT_MONITORING_MARKINGS',
  /** Eigið fé: >0 */
  EQUITY = 'EQUITY',
  /** Eigið fé: >0 eða EBITDA: >0 */
  EQUITY_EBITDA = 'EQUITY_EBITDA',
  /** Eiginfjárhlutfall: >0% */
  EQUITY_RATIO = 'EQUITY_RATIO',
  EWS_COLOR = 'EWS_COLOR',
  /** Ábyrgðaraðili þarf að vera framkvæmdastjóri eða prókúruhafi. */
  GUARANTOR_COMPANY_ROLE = 'GUARANTOR_COMPANY_ROLE',
  GUARANTOR_DEFAULT_MONITORING_MARKINGS = 'GUARANTOR_DEFAULT_MONITORING_MARKINGS',
  /** Eignarhlutur umsækjanda >= 25%. Lágmark annar eigandi þá með 25% svo að heildin sé lágmark 50% eignarhlutur. Ef eignarhlutur umsækjanda er 50% þarf ekki annan eiganda */
  GUARANTOR_OWNERSHIP_RATIO = 'GUARANTOR_OWNERSHIP_RATIO',
  GUARANTOR_RISK_RATING = 'GUARANTOR_RISK_RATING',
  /** Einhver vanskil hjá landsbankanum */
  HAS_DEFAULTED_DEBT = 'HAS_DEFAULTED_DEBT',
  /** EBITDA: >0 */
  IS_EBITDA = 'IS_EBITDA',
  /** Viðskiptavinur þarf að vera búinn að samþykkja Kyc */
  KYC = 'KYC',
  LEGAL_FORM = 'LEGAL_FORM',
  LOW_RISK_RATING = 'LOW_RISK_RATING',
  REPRESENTATIVES_CONNECTED_TO_BANKRUPT_COMPANY = 'REPRESENTATIVES_CONNECTED_TO_BANKRUPT_COMPANY',
  REPRESENTATIVES_CONNECTED_TO_WRITTEN_OFF_COMPANY = 'REPRESENTATIVES_CONNECTED_TO_WRITTEN_OFF_COMPANY',
  /** Velta síðustu 12m er 75% % af bókuðum rekstrartekjum síðasta ársreiknings */
  TURNOVER_INCOME_LAST12M_RATIO = 'TURNOVER_INCOME_LAST12M_RATIO',
  /** Velta rekstrarárs síðasta ársreiknings þarf að vera 75 % af bókuðum rekstrartekjum? */
  TURNOVER_INCOME_YEAR_RATIO = 'TURNOVER_INCOME_YEAR_RATIO',
  UNKNOWN = 'UNKNOWN'
}

export type CompanyIncompatible = Error & {
  __typename: 'CompanyIncompatible';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CompanyNotFound = Error & {
  __typename: 'CompanyNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A company onboarding application */
export type CompanyOnboardingApplication = {
  __typename: 'CompanyOnboardingApplication';
  /** Onboarding application ID (Global) */
  applicationId: Scalars['ID']['output'];
  /** The company being onboarded */
  company: OnboardingCompanyCustomer;
  /** The contact person for the application */
  contact: OnboardingCompanyCustomer;
  /** When the application was created */
  created: Scalars['DateTimeISO']['output'];
  /** The prerequisites the application has to fulfil before it can be approved */
  prerequisites: Array<CompanyOnboardingApplicationPrerequisite>;
  /** The service representative (property manager) of the company, if one has been saved */
  serviceRepresentative: Maybe<OnboardingCompanyCustomer>;
  /** The status of the application */
  status: CompanyOnboardingApplicationStatus;
  /** The username of the user created for the company */
  username: Maybe<Scalars['String']['output']>;
};

/** A prerequisite a company onboarding application has to fulfil before it can be approved */
export type CompanyOnboardingApplicationPrerequisite = {
  __typename: 'CompanyOnboardingApplicationPrerequisite';
  /** The fulfilment status of the prerequisite */
  status: CompanyOnboardingApplicationPrerequisiteStatus;
  /** The kind of prerequisite */
  type: CompanyOnboardingApplicationPrerequisiteType;
};

/** The fulfilment status of a company onboarding application prerequisite */
export enum CompanyOnboardingApplicationPrerequisiteStatus {
  CANCELLED_OR_REJECTED = 'CANCELLED_OR_REJECTED',
  DONE = 'DONE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  PENDING = 'PENDING',
  REQUIRED = 'REQUIRED',
  UNKNOWN = 'UNKNOWN'
}

/** The kinds of prerequisites a company onboarding application has to fulfil before it can be approved */
export enum CompanyOnboardingApplicationPrerequisiteType {
  CONTRACT_SIGNING = 'CONTRACT_SIGNING',
  FOLLOW_UP_CASE = 'FOLLOW_UP_CASE',
  KYC = 'KYC',
  UNKNOWN = 'UNKNOWN'
}

export enum CompanyOnboardingApplicationStatus {
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
  WAITING_FOR_PREREQUISITES = 'WAITING_FOR_PREREQUISITES'
}

/** A company the current person has a role in, according to the companies register */
export type CompanyParticipation = {
  __typename: 'CompanyParticipation';
  /** National id (kennitala) of the company */
  kennitala: Scalars['String']['output'];
  /** Name of the company */
  name: Scalars['String']['output'];
  /** The current person's roles in the company */
  roles: Array<CompanyParticipationRole>;
};

/** The current person's role in a company, according to the companies register */
export enum CompanyParticipationRole {
  CEO = 'CEO',
  PROCURATOR = 'PROCURATOR',
  UNKNOWN = 'UNKNOWN'
}

export type CompanyService = {
  __typename: 'CompanyService';
  id: Scalars['ID']['output'];
  serviceType: Scalars['String']['output'];
  serviceTypeName: Scalars['String']['output'];
};

export type CompanyServicesAuthorizationFilter = {
  /** Filter services by their types */
  serviceTypes?: InputMaybe<Array<AuthorizationServiceType>>;
};

export type CompanySubsidiary = {
  __typename: 'CompanySubsidiary';
  /** ID (global) of subsidiary */
  id: Scalars['ID']['output'];
  /** National id (kennitala) of subsidiary */
  kennitala: Scalars['String']['output'];
  /** Name of subsidiary */
  name: Scalars['String']['output'];
};

export enum CompanyTradeAuthorization {
  Full = 'Full',
  None = 'None',
  Read = 'Read'
}

/** Represents a company user available to the currently logged in customer */
export type CompanyUser = Actor & Node & {
  __typename: 'CompanyUser';
  /** Authorizations for a company user */
  authorizations: CompanyUserAuthorizations;
  /** The online bank account can be accessed by the customer */
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether the user is a B2B user or not */
  isB2BUser: Scalars['Boolean']['output'];
  /** Whether the user is a B2B user and kennitala is company's kennitala */
  isCorporateB2BUser: Scalars['Boolean']['output'];
  /** Kennitala of current user */
  kennitala: Scalars['String']['output'];
  /** Name of current user */
  name: Scalars['String']['output'];
  /** Status of current user */
  state: CustomerStatus;
  /** Amount (ISK) withdrawn during the current day by the user */
  totalWithdrawalsToday: Maybe<CurrencyAmount>;
  /** Type of current user (i.e. corporate, personal) */
  type: UserType;
  /** Landsbankinn username of current user */
  username: Scalars['String']['output'];
  /** Amount limit (ISK) available for withdrawal by the user */
  withdrawalLimit: Maybe<CurrencyAmount>;
};

export type CompanyUserAuthorizations = Node & {
  __typename: 'CompanyUserAuthorizations';
  /** All accounts with definition if the user has access to them */
  accounts: Maybe<AccountAuthorizationConnection>;
  /** All cards with definition if the user has access to them */
  cards: Maybe<CardAuthorizationConnection>;
  /** Whether the user has any authorization across services, accounts, or cards */
  hasAnyAuthorization: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Get service permissions for a specific company user */
  services: Maybe<Array<ServiceAuthorization>>;
  username: Scalars['String']['output'];
};


export type CompanyUserAuthorizationsAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionsAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountsAuthorizationOrderBy>;
  orderByFields?: InputMaybe<Array<AccountsAuthorizationOrderBy>>;
};


export type CompanyUserAuthorizationsCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PermissionsAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardsAuthorizationOrderBy>;
  orderByFields?: InputMaybe<Array<CardsAuthorizationOrderBy>>;
};


export type CompanyUserAuthorizationsServicesArgs = {
  filter?: InputMaybe<ServicesAuthorizationFilter>;
  orderBy?: InputMaybe<ServicesAuthorizationOrderBy>;
};

export type CompanyUserConnection = {
  __typename: 'CompanyUserConnection';
  edges: Array<CompanyUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyUserEdge = {
  __typename: 'CompanyUserEdge';
  cursor: Scalars['String']['output'];
  node: CompanyUser;
};

export type CompanyUserFilterArgs = {
  /** Filter to only return active users if true or only inactive users if false */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to return limits information in the response */
  includeUserLimits?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to only search users whose name or kennitala includes this string */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyWithdrawalLimit = {
  __typename: 'CompanyWithdrawalLimit';
  id: Scalars['Int']['output'];
  maxWithdrawalLimit: CurrencyAmount;
};

export type ConfirmLegalEntityKycInput = {
  beneficialOwners?: InputMaybe<Array<BeneficialOwnerInput>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactOccupation?: InputMaybe<Scalars['String']['input']>;
  legalEntity: LegalEntityInput;
  stakeholders: Array<StakeholderInput>;
};

export type ConfirmPaymentDistributionErrorUnion = UnknownError;

export type ConfirmPaymentDistributionInput = {
  contractId: Scalars['String']['input'];
};

export type ConfirmPaymentDistributionPayload = {
  __typename: 'ConfirmPaymentDistributionPayload';
  error: Maybe<ConfirmPaymentDistributionErrorUnion>;
  paymentDistribution: Maybe<PaymentDistribution>;
};

/** ConsultationService */
export type ConsultationService = Node & {
  __typename: 'ConsultationService';
  allowAdditionalCustomer: Maybe<Scalars['Boolean']['output']>;
  customerType: SmartBookingCustomerType;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  types: Array<ActivityType>;
};

export enum ConsultationType {
  Appointment = 'Appointment',
  Phonecall = 'Phonecall',
  Videocall = 'Videocall'
}

/** Application for a overdraft loan */
export type ConsumerLoanApplication = LoanApplication & Node & {
  __typename: 'ConsumerLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  /** This field is currently used for corporate overdraft only. It indicates whether the current user can use surety bonds and if risk rating is missing. For freelance users this will always return SURETY_BOND_NOT_ALLOWED. */
  creditScoreRiskRatingResult: Maybe<CreditScoreRiskRatingResultType>;
  /** This field is currently used for corporate overdraft only. It indicates whether the requested amount for the overdraft loan application can be covered (insured) by existing collaterals. Currently, only truthful if there exists an "allsherjarveð í fasteign", with an unused value that exceeds the requested loan amount. */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** This field is currently used for corporate overdraft only. It returns surety guarantors (ábyrgðaraðilar) on an overdraft loan application. The list of guarantors is ordered with the main applicant as the first guarantor in the list. */
  guarantors: Maybe<Array<LoanApplicationGuarantor>>;
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. It indicates whether the applications could theoretically be automatically approved, as opposed to explicitly requiring manual approval. A true value does not always result in automatic approval, as there are other factors, but a false value will always result in manual approval. For freelance users this is always false. */
  isWithinPreApprovedAllowedLimits: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  /** This field is currently used for corporate overdraft only. It returns the calculated fee for surety (sjálfskuldarábyrgð) on an overdraft loan application. */
  suretyCollateralFee: Maybe<CurrencyAmount>;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


/** Application for a overdraft loan */
export type ConsumerLoanApplicationCreditScoreRiskRatingResultArgs = {
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
};


/** Application for a overdraft loan */
export type ConsumerLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

/** Company contact info */
export type Contact = {
  __typename: 'Contact';
  email: Maybe<Scalars['String']['output']>;
  kennitala: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Occupation of the company contact, always the ContactOccupation value (ceo), never its id */
  occupation: Maybe<Scalars['String']['output']>;
};

/** Valid occupations with Landsbankinn */
export type ContactOccupation = Node & {
  __typename: 'ContactOccupation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContactOccupationConnection = {
  __typename: 'ContactOccupationConnection';
  edges: Array<ContactOccupationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContactOccupationEdge = {
  __typename: 'ContactOccupationEdge';
  cursor: Scalars['String']['output'];
  node: ContactOccupation;
};

export type ContactUsInput = {
  description: Scalars['String']['input'];
  email: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export enum ContactVerificationStatus {
  Completed = 'Completed',
  Expired = 'Expired',
  Pending = 'Pending'
}

export enum ContentBackground {
  COMMON_WHITE = 'COMMON_WHITE',
  PRIMARY = 'PRIMARY'
}

/** Each block has a full bleed background and margins. */
export type ContentBlock = {
  __typename: 'ContentBlock';
  background: ContentBackground;
  items: Array<ContentBlockItemUnion>;
};

export type ContentBlockItemUnion = ContentBullets | ContentHeading | ContentParagraph;

export type ContentBullet = {
  __typename: 'ContentBullet';
  /** A html string that supports <b> tags. */
  html: Scalars['String']['output'];
};

export type ContentBullets = {
  __typename: 'ContentBullets';
  items: Array<ContentBullet>;
  startIndex: Scalars['Float']['output'];
};

/** Content disposition type for files */
export enum ContentDispositionType {
  /** Download the file directly */
  ATTACHMENT = 'ATTACHMENT',
  /** Display the file in the browser */
  INLINE = 'INLINE'
}

export type ContentHeading = {
  __typename: 'ContentHeading';
  /** A html string that supports <b> tags. */
  html: Scalars['String']['output'];
  level: ContentHeadingLevel;
};

/** Heading levels used for the heading element, e.g. First will result in h1, Second will result in h2. */
export enum ContentHeadingLevel {
  FIRST = 'FIRST',
  SECOND = 'SECOND'
}

export type ContentParagraph = {
  __typename: 'ContentParagraph';
  /** A html string that supports <b> tags. */
  html: Scalars['String']['output'];
};

/** Result of a search query (done via Google's Discovery Engine) */
export type ContentSearch = {
  __typename: 'ContentSearch';
  link: Scalars['String']['output'];
  text: Scalars['String']['output'];
  thumbnailLink: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ContentSearchConnection = {
  __typename: 'ContentSearchConnection';
  edges: Array<ContentSearchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContentSearchEdge = {
  __typename: 'ContentSearchEdge';
  cursor: Scalars['String']['output'];
  node: ContentSearch;
};

export type ContributionsTotalTransaction = {
  __typename: 'ContributionsTotalTransaction';
  accountId: Scalars['String']['output'];
  amount: Scalars['Int']['output'];
  /** Unique id for access to saving, for a particular customer */
  customerProxyId: Maybe<Scalars['String']['output']>;
  isLegalEntity: Scalars['Boolean']['output'];
  payorId: Scalars['String']['output'];
  payorName: Scalars['String']['output'];
};

/** Action link is a predefined response provided by the chatbot to the user. */
export type ConversationActionLinkElement = {
  __typename: 'ConversationActionLinkElement';
  /** Element id. When user selects this predefined response this id should be sent back to the server. */
  id: Scalars['ID']['output'];
  /** Text content of the response. */
  text: Scalars['String']['output'];
};

export type ConversationElementUnion = ConversationImageElement | ConversationLinksElement | ConversationTextElement;

export type ConversationExternalLinkElement = {
  __typename: 'ConversationExternalLinkElement';
  /** Element id. */
  id: Scalars['ID']['output'];
  /** Text content of the response. */
  text: Scalars['String']['output'];
  /** Url of the response. */
  url: Scalars['String']['output'];
};

/** The feedback that a conversation can take. */
export enum ConversationFeedback {
  /** User gives a conversation a negative feedback. */
  NEGATIVE = 'NEGATIVE',
  /** User gives a conversation a positive feedback. */
  POSITIVE = 'POSITIVE'
}

export type ConversationImageElement = {
  __typename: 'ConversationImageElement';
  /** Url of the image. */
  url: Scalars['String']['output'];
};

export type ConversationLinkElement = ConversationActionLinkElement | ConversationExternalLinkElement;

export type ConversationLinksElement = {
  __typename: 'ConversationLinksElement';
  /** Links content of the response. */
  links: Array<ConversationLinkElement>;
};

export type ConversationResponse = {
  __typename: 'ConversationResponse';
  /** Timestamp of when the response was created. */
  created: Scalars['DateTimeISO']['output'];
  /** Elements of the response. */
  elements: Array<ConversationElementUnion>;
  /** Id of the response. */
  id: Scalars['ID']['output'];
  /** The source of the response, e.g. was it from user, bot or client. */
  source: ConversationResponseSource;
};

/** Source of a response. */
export enum ConversationResponseSource {
  /** Response is from customer service agent. */
  AGENT = 'AGENT',
  /** Response is from Ellí (our AI bot). */
  BOT = 'BOT',
  /** Response is from user. */
  CLIENT = 'CLIENT'
}

/** Status of a conversation. */
export enum ConversationStatus {
  /** Conversation is assigned to human agent. */
  ASSIGNED_TO_HUMAN = 'ASSIGNED_TO_HUMAN',
  /** Conversation is blocked. */
  BLOCKED = 'BLOCKED',
  /** Conversation is in human chat queue. */
  IN_HUMAN_CHAT_QUEUE = 'IN_HUMAN_CHAT_QUEUE',
  /** It's a separate api call to get conversation status so UNKNOWN is returned when fetching list of conversations. */
  UNKNOWN = 'UNKNOWN',
  /** Conversation is handled by virtual agent. */
  VIRTUAL_AGENT = 'VIRTUAL_AGENT'
}

export type ConversationTextElement = {
  __typename: 'ConversationTextElement';
  /** Text content of the response. */
  text: Scalars['String']['output'];
};

export type ConversationsFilterArgs = {
  /** Use to only get conversations with lastModified after a specific date. */
  lastModifiedAfter?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

/** Success data result for create direct debit agreement */
export type CorrectDirectDebitAgreementSuccessData = {
  __typename: 'CorrectDirectDebitAgreementSuccessData';
  createdAgreement: CreateDirectDebitAgreementSuccessData;
  /** ID (Global) of the cleared direct debit mandate order */
  deletedOrderId: Maybe<Scalars['ID']['output']>;
};

/** Input to correct a direct debit mandate order and create a direct debit agreement */
export type CorrectDirectDebitMandateOrderInput = {
  /** Category code, 2 letters/digits (ISK: Textalykill) */
  categoryCode: Scalars['String']['input'];
  /** Bank branch number */
  categoryCodeBranch?: InputMaybe<Scalars['String']['input']>;
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber: Scalars['String']['input'];
  /** ID (Global) of the direct debit mandate order to correct */
  orderId: Scalars['ID']['input'];
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala: Scalars['String']['input'];
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Scalars['String']['input'];
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Scalars['String']['input'];
};

/** Payload for correcting a direct debit mandate order and creating a direct debit agreement */
export type CorrectDirectDebitMandateOrderPayload = {
  __typename: 'CorrectDirectDebitMandateOrderPayload';
  /** Success data for correcting a direct debit mandate order */
  data: Maybe<CorrectDirectDebitAgreementSuccessData>;
  /** Error, if any, that occurred during the creation of the direct debit agreement */
  error: Maybe<CreateDirectDebitAgreementErrorUnion>;
};

/** Dial code information for phone numbers from a country */
export type CountryDialCode = Node & {
  __typename: 'CountryDialCode';
  dialCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  iso2: Scalars['String']['output'];
  name: CountryDialCodeName;
};

export type CountryDialCodeConnection = {
  __typename: 'CountryDialCodeConnection';
  edges: Array<CountryDialCodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryDialCodeEdge = {
  __typename: 'CountryDialCodeEdge';
  cursor: Scalars['String']['output'];
  node: CountryDialCode;
};

export type CountryDialCodeName = {
  __typename: 'CountryDialCodeName';
  en: Scalars['String']['output'];
  is: Scalars['String']['output'];
  pl: Scalars['String']['output'];
};

export type CreateAccountProductPayload = {
  __typename: 'CreateAccountProductPayload';
  account: Maybe<Account>;
  accountNumber: Maybe<Scalars['String']['output']>;
  debitCardCreatedForOwner: Maybe<Scalars['Boolean']['output']>;
  securityCodeSet: Maybe<Scalars['Boolean']['output']>;
  withdrawalAccount: Maybe<Account>;
};

export type CreateAccountProductResponse = AccountProductInsufficientAvailableFund | AccountProductSecurityCodeInvalid | AccountProductSecurityCodePartOfOwnersDetail | CreateAccountProductPayload;

export type CreateAcquiringPreApplicationPayload = {
  __typename: 'CreateAcquiringPreApplicationPayload';
  success: Scalars['Boolean']['output'];
};

export type CreateAndApproveCreditCardLimitLoanApplicationPayload = {
  __typename: 'CreateAndApproveCreditCardLimitLoanApplicationPayload';
  creditCardLimitLoanApplication: CreditCardLimitLoanApplication;
};

/** Payload containing cryptographic data required to provision an Opaque Payment Card (OPC) for Apple Wallet. */
export type CreateAppleWalletOpcPayload = {
  __typename: 'CreateAppleWalletOPCPayload';
  /** Base64-encoded activation data used to initialize the card in Apple Wallet. */
  activationData: Scalars['String']['output'];
  /** Encrypted pass data required for secure card provisioning. */
  encryptedPassData: Scalars['String']['output'];
  /** Ephemeral public key used in the cryptographic exchange with Apple Wallet. */
  ephemeralPublicKey: Scalars['String']['output'];
  /** Base64-encoded wrapped key used for decrypting card data during provisioning. */
  wrappedKey: Scalars['String']['output'];
};

export type CreateAppleWalletOpaquePaymentCardInput = {
  /** The (global) id of the card for which to create an opaque payment credential (OPC). */
  cardId: Scalars['ID']['input'];
  /** Array of base64-encoded X.509 certificates required for Apple Wallet tokenization. */
  certificates: Array<Scalars['String']['input']>;
  /** A cryptographic nonce generated by the client for this tokenization request. */
  nonce: Scalars['String']['input'];
  /** Signature of the nonce, generated using the client's private key. */
  nonceSignature: Scalars['String']['input'];
};

/** Input for creating a certificate for an application account */
export type CreateApplicationAccountCertificateInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
  /** Password to encrypt the certificate (.pfx) */
  certificateKey: Scalars['String']['input'];
};

/** Payload for create certificate mutation */
export type CreateApplicationAccountCertificatePayload = {
  __typename: 'CreateApplicationAccountCertificatePayload';
  /** Contains url to get the certificate */
  certificate: GenericFile;
};

/** Input for creating an application account */
export type CreateApplicationAccountInput = {
  /** Description of the application account */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name of the application account */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationAccountPublicCertificateInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
  /** National ID (kennitala) of the public certificate party. Defaults to the current customer kennitala. */
  kennitala?: InputMaybe<Scalars['String']['input']>;
};

/** Payload for create public certificate mutation */
export type CreateApplicationAccountPublicCertificatePayload = {
  __typename: 'CreateApplicationAccountPublicCertificatePayload';
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['output'];
  /** Application account kennitala */
  kennitala: Scalars['String']['output'];
  /** Application account name */
  name: Maybe<Scalars['String']['output']>;
};

export type CreateAukakronurTransferCustomerNotFoundError = Error & {
  __typename: 'CreateAukakronurTransferCustomerNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateAukakronurTransferErrorUnion = CreateAukakronurTransferCustomerNotFoundError | UnknownError;

export type CreateAukakronurTransferInput = {
  /** Amount of aukakronur to transfer */
  amount: Scalars['Float']['input'];
  /** Kennitala of the person receiving the aukakronur transfer */
  depositKennitala: Scalars['String']['input'];
};

/** Returns either success true and no error or success false error of type CreateAukakronurTransferError */
export type CreateAukakronurTransferPayload = {
  __typename: 'CreateAukakronurTransferPayload';
  error: Maybe<CreateAukakronurTransferErrorUnion>;
  /** If successful patch the return object is a card transaction control */
  success: Scalars['Boolean']['output'];
};

export type CreateBondLoanApplicationInput = {
  /** Reikningur sem á að greiða lánið inná. Ef greiða á lánið inn á kort þá skal setja hér inn sama og directDebitAccountnumber. */
  accountNumber: Scalars['String']['input'];
  /** Upphæð láns */
  amount: Scalars['Float']['input'];
  /** Ef greiða á lánið inn á kort. */
  cardId?: InputMaybe<Scalars['Int']['input']>;
  /** Skuldfærslureikningur. */
  directDebitAccountNumber: Scalars['String']['input'];
  /** Lánstími í mánuðum. Möguleg gildi sótt úr product catalog. */
  loanDurationMonths: Scalars['Int']['input'];
};

export type CreateBondLoanApplicationPayload = {
  __typename: 'CreateBondLoanApplicationPayload';
  bondLoanApplication: BondLoanApplication;
};

export type CreateCardApplicationError = RequestedCreditLineTooHighError | UnknownError;

export type CreateCardApplicationInput = {
  /** Termination status of the card that is subject to change. Only applicable when cardIdChanged is provided */
  cardChangedTerminationStatus?: InputMaybe<CardTerminationStatus>;
  /** The card holder email, should be provided for for corporate cards applications */
  cardHolderEmail?: InputMaybe<Scalars['String']['input']>;
  /** The card holder kennitala */
  cardHolderKennitala?: InputMaybe<Scalars['String']['input']>;
  /** The card holder mobile phone number, should be provided for corporate card applications */
  cardHolderMobilePhone?: InputMaybe<Scalars['String']['input']>;
  /** If a cardIdChanged is provided, then this is a change of card request. The cardIdChanged card will then be closed and a new card will be issued */
  cardIdChanged?: InputMaybe<Scalars['String']['input']>;
  /** The catalogId for the product */
  catalogId: Scalars['Int']['input'];
  /** The credit line for the card. This is the maximum amount that can be spent on the card. This should be left empty for Vasapeningakort, Plúskort etc. */
  creditLine?: InputMaybe<Scalars['Float']['input']>;
  /** The delivery address for the card */
  deliveryAddress?: InputMaybe<AddressInput>;
  /** A branch number. Used if the applicant chooses to get his card from a specific branch */
  deliveryBranchId?: InputMaybe<Scalars['String']['input']>;
  /** The account number that will be used for direct debit payments */
  directDebitAccount?: InputMaybe<Scalars['String']['input']>;
  /** If the card should be issued as physical card or digital card */
  isPhysicalCard: Scalars['Boolean']['input'];
};

/** Returns card application or null */
export type CreateCardApplicationPayload = {
  __typename: 'CreateCardApplicationPayload';
  /** If successful post the return object is a card application */
  cardApplication: Maybe<CardApplication>;
  /** Error returned after an unsuccessful creation request */
  error: Maybe<CreateCardApplicationError>;
};

/** The card to deposit to cannot be found by the payment system */
export type CreateCardDepositCardNotFoundError = Error & {
  __typename: 'CreateCardDepositCardNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The card number and card owner kennitala do not match in the RB system */
export type CreateCardDepositCardOwnerKennitalaAndNumberDoNotMatchError = Error & {
  __typename: 'CreateCardDepositCardOwnerKennitalaAndNumberDoNotMatchError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The withdrawal account could not be resolved for the card deposit */
export type CreateCardDepositDebtorAccountNotFoundError = Error & {
  __typename: 'CreateCardDepositDebtorAccountNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Deposits to debit cards are not supported/allowed. This error is returned if a mutation payload for card deposit contains a card number of a debit card. */
export type CreateCardDepositDepositToDebitCardsNotAllowed = Error & {
  __typename: 'CreateCardDepositDepositToDebitCardsNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateCardDepositErrorV2 = CreateCardDepositCardNotFoundError | CreateCardDepositCardOwnerKennitalaAndNumberDoNotMatchError | CreateCardDepositDebtorAccountNotFoundError | CreateCardDepositDepositToDebitCardsNotAllowed | CreateCardDepositLbCardsOnlyAllowedError | CreatePaymentAmountUnavailableError | CreatePaymentExceedsDailyLimitsError | CreditCardServiceUnavailable | UnknownError;

export type CreateCardDepositInput = {
  /** The node id for the card to make a deposit to */
  cardId?: InputMaybe<Scalars['ID']['input']>;
  /** The card number to make a deposit to. Either card number and kennitala or cardId must be provided. */
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  /** The card owners kennitala. Either card number and kennitala or cardId must be provided. */
  cardOwnerKennitala?: InputMaybe<Scalars['String']['input']>;
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Also known as withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  /** Description for account statement (Skýring) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Client is SCA compatible and can receive SCA response for this mutation */
  isScaCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isStoredPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference for payment (Tilvísun) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
};

/** Landsbankinn cards only allowed. This error is returned if the card to deposit to is from another bank. */
export type CreateCardDepositLbCardsOnlyAllowedError = Error & {
  __typename: 'CreateCardDepositLbCardsOnlyAllowedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateCardDepositPayloadV2 = {
  __typename: 'CreateCardDepositPayloadV2';
  error: Maybe<CreateCardDepositErrorV2>;
  result: Maybe<CreatePaymentScaResponse>;
};

export type CreateCardDepositResponse = CreateCardDepositCardNotFoundError | CreateCardDepositCardOwnerKennitalaAndNumberDoNotMatchError | CreateCardDepositDepositToDebitCardsNotAllowed | CreateCardDepositLbCardsOnlyAllowedError | CreatePaymentAmountUnavailableError | CreatePaymentExceedsDailyLimitsError | CreatePaymentScaResponse | RsaStepUpResponse;

export type CreateCardDepositResultV2 = AdaptiveAuthentication | CreateCardDepositPayloadV2;

export type CreateCardSavingSubscriptionInput = {
  destination: CardSavingDestinationInput;
  savingsType: CardSavingTypeInput;
  source: CardSavingSourceInput;
};

export type CreateCardSavingsResponse = CardSavingSubscriptionPayload | SavingsTypeNotFound | SubscriptionDestinationInvalid;

export type CreateCardTransactionsLedgerKeyErrorUnion = CustomerDoesNotHaveAccessCardTransactionsLedgerKeysError;

export type CreateCardTransactionsLedgerKeyGroupErrorUnion = CustomerDoesNotHaveAccessCardTransactionsLedgerKeyGroupsError | UnknownError;

export type CreateCardTransactionsLedgerKeyGroupInput = {
  /** The description of the ledger key group. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['input'];
  /** The identifier of the ledger key group, Example: 2785 */
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardTransactionsLedgerKeyGroupPayload = {
  __typename: 'CreateCardTransactionsLedgerKeyGroupPayload';
  cardTransactionsLedgerKeyGroup: Maybe<CardTransactionsLedgerKeyGroup>;
  error: Maybe<CreateCardTransactionsLedgerKeyGroupErrorUnion>;
};

export type CreateCardTransactionsLedgerKeyInput = {
  /** The description of the ledger key. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['input'];
  /** The identifier of the ledger key, Example: 2785 */
  identifier: Scalars['String']['input'];
};

/** Returns cardTransactionLedgerKey that contains id, ledgerKey and identifier or null */
export type CreateCardTransactionsLedgerKeyPayload = {
  __typename: 'CreateCardTransactionsLedgerKeyPayload';
  /** If successful post the return object is a cardTransactionsLedgerKey response */
  cardTransactionsLedgerKey: Maybe<CardTransactionsLedgerKey>;
  error: Maybe<CreateCardTransactionsLedgerKeyErrorUnion>;
};

export type CreateCardTransactionsLedgerKeySubGroupErrorUnion = CustomerDoesNotHaveAccessCardTransactionsLedgerKeySubGroupsError | UnknownError;

export type CreateCardTransactionsLedgerKeySubGroupInput = {
  /** The description of the ledger key sub group. Example: Hótelkostnaður erlendis */
  description: Scalars['String']['input'];
  /** The identifier of the ledger key sub group. Example: 2785 */
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCardTransactionsLedgerKeySubGroupPayload = {
  __typename: 'CreateCardTransactionsLedgerKeySubGroupPayload';
  cardTransactionsLedgerKeySubGroup: Maybe<CardTransactionsLedgerKeySubGroup>;
  error: Maybe<CreateCardTransactionsLedgerKeySubGroupErrorUnion>;
};

export type CreateClaimPaymentInput = {
  claimId: Scalars['ID']['input'];
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  requestedPaymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CreateClaimSigningBasketInput = {
  claims: Array<CreateClaimPaymentInput>;
  debtorAccountId: Scalars['ID']['input'];
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  isStoredPayment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentApprovalCompatible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateClaimSigningBasketPayload = {
  __typename: 'CreateClaimSigningBasketPayload';
  /** The signing basket response */
  scaResponse: Maybe<CreateSigningBasketScaResponse>;
  /** The id of the payments that are waiting for approval and not in the signing basket */
  waitingApprovalClaimIds: Array<Scalars['ID']['output']>;
};

export type CreateClaimSigningBasketResponse = CreateClaimSigningBasketPayload | CreatePaymentAmountUnavailableError | CreatePaymentExceedsCompanyDailyLimitsError | CreatePaymentExceedsDailyLimitsError | CreateSigningBasketScaResponse | StoredClaimPaymentsPayload | UnknownError;

export type CreateCommissionInput = {
  /** A reason type of a loan for commission */
  creditAssessmentReasonType?: InputMaybe<CreditAssessmentReasonType>;
  creditAssessmentType?: InputMaybe<CommissionCreditAssessmentType>;
  customer: CommissionCustomer;
  /** (GraphQL) ID of a loan application */
  loanApplicationId?: InputMaybe<Scalars['String']['input']>;
  spouse?: InputMaybe<CommissionCustomer>;
};

export type CreateCommissionPayload = {
  __typename: 'CreateCommissionPayload';
  commission: Commission;
};

export type CreateCreditAssessmentInput = {
  creditAssessmentType: CreditAssessmentType;
  /** ID of the loan application that is related to this CreditAssessment. */
  loanApplicationId: Scalars['ID']['input'];
  mainCustomerKennitala: Scalars['String']['input'];
  secondaryCustomerKennitala?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCreditAssessmentPayload = {
  __typename: 'CreateCreditAssessmentPayload';
  creditAssessmentId: Scalars['String']['output'];
  /** Global GraphQL Id of the created credit assessment */
  creditAssessmentNodeId: Scalars['ID']['output'];
};

export type CreateCreditCardLimitLoanApplicationInput = {
  cardId: Scalars['Float']['input'];
  creditLimit: Scalars['Float']['input'];
  isNewCardApplication?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true then the application will become an order application */
  isOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCreditCardProductApplicationDocumentPayload = {
  __typename: 'CreateCreditCardProductApplicationDocumentPayload';
  contractId: Scalars['String']['output'];
};

export type CreateCreditTransferCannotDepositToOwnPaidLeaveAccountError = Error & {
  __typename: 'CreateCreditTransferCannotDepositToOwnPaidLeaveAccountError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateCreditTransferErrorV2 = CreateCreditTransferCannotDepositToOwnPaidLeaveAccountError | CreatePaymentCompanyUserNotAuthorisedError | CreatePaymentCurrencyExchangeMarketClosedError | CreatePaymentDepositNotAllowedError | CreatePaymentExceedsCompanyDailyLimitsError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreatePaymentInsufficientAvailableFundError | CreatePaymentInvalidPaymentDateError | UnknownError;

export type CreateCreditTransferInput = {
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Also known as withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  depositAccountKennitala: Scalars['String']['input'];
  depositAccountNumber: Scalars['String']['input'];
  /** Description for account statement (Skýring) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Client is SCA compatible and can receive SCA response for this mutation */
  isScaCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  isStoredPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference for payment (Tilvísun) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Requested payment date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  requestedPaymentCalendarDate?: InputMaybe<Scalars['Date']['input']>;
  requestedPaymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  textKey?: InputMaybe<Scalars['String']['input']>;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
};

export type CreateCreditTransferPayloadV2 = {
  __typename: 'CreateCreditTransferPayloadV2';
  error: Maybe<CreateCreditTransferErrorV2>;
  result: Maybe<CreatePaymentScaResponse>;
};

export type CreateCreditTransferResponse = CreateCreditTransferCannotDepositToOwnPaidLeaveAccountError | CreatePaymentCompanyUserNotAuthorisedError | CreatePaymentCurrencyExchangeMarketClosedError | CreatePaymentDepositNotAllowedError | CreatePaymentExceedsCompanyDailyLimitsError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreatePaymentInsufficientAvailableFundError | CreatePaymentInvalidPaymentDateError | CreatePaymentScaResponse | RsaStepUpResponse;

export type CreateCreditTransferResultV2 = AdaptiveAuthentication | CreateCreditTransferPayloadV2;

export type CreateCrossBorderCreditTransferErrorV2 = CreateInternationalPaymentValidationError | CreatePaymentApprovalProcessNotSupportedError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreatePaymentRecipientCountryOnBlacklistError | UnknownError;

/** CrossBorder credit transfer input */
export type CreateCrossBorderCreditTransferInput = {
  /** Central bank category code, for purpose of payment */
  centralBankCategoryCode: Scalars['String']['input'];
  chargeBearer: CrossBorderChargeBearer;
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Payors withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  /** Description for the payment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  isExpress?: InputMaybe<Scalars['Boolean']['input']>;
  isStoredPayment?: InputMaybe<Scalars['Boolean']['input']>;
  method: CrossBorderPaymentMethod;
  recipient: CrossBorderCreditTransferRecipientInput;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
};

export type CreateCrossBorderCreditTransferPayloadV2 = {
  __typename: 'CreateCrossBorderCreditTransferPayloadV2';
  error: Maybe<CreateCrossBorderCreditTransferErrorV2>;
  result: Maybe<CreatePaymentScaResponse>;
};

export type CreateCrossBorderCreditTransferResponse = CreateInternationalPaymentValidationError | CreatePaymentApprovalProcessNotSupportedError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreatePaymentRecipientCountryOnBlacklistError | CreatePaymentScaResponse | RsaStepUpResponse;

export type CreateCrossBorderCreditTransferResultV2 = AdaptiveAuthentication | CreateCrossBorderCreditTransferPayloadV2;

export type CreateCustodialAgreementInput = {
  /** Account to be used when paying out profits and charging costs */
  accountId: Scalars['String']['input'];
  /** If user wants statements and receipts in snail mail */
  sendStatementsAndReceiptsInMail: Scalars['Boolean']['input'];
  /** MiFID compliant appropriateness test, before user can trade online this must be answered */
  tradingAppropriatenessTest?: InputMaybe<AnswerTradingAppropriatenessTestInput>;
};

export type CreateCustodialAgreementPayload = {
  __typename: 'CreateCustodialAgreementPayload';
  appropriatenessTest: Maybe<TradingAppropriatenessTest>;
  custodialAgreement: CustodialAgreement;
};

/** Input for creating a debit card. If no deliveryAddress and no deliveryBranchId is provided then the card is created without a plastic (physical) card */
export type CreateDebitCardApplicationInput = {
  /** Should be defined when creating debit card for another cardholder which is not the current viewer */
  cardHolderKennitala?: InputMaybe<Scalars['String']['input']>;
  /** The delivery address for the card */
  deliveryAddress?: InputMaybe<CardDeliveryAddressInput>;
  /** A branch number. Used if the applicant chooses to get his card from a specific branch */
  deliveryBranchId?: InputMaybe<Scalars['String']['input']>;
  /** If the card should be issued as physical card or digital card. Default is true. */
  isPhysicalCard?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalAccountId: Scalars['String']['input'];
};

export type CreateDebitCardApplicationPayload = {
  __typename: 'CreateDebitCardApplicationPayload';
  debitCard: Maybe<DebitCard>;
};

export type CreateDecisionForVehicleLoanApplicationInput = {
  /** ID of a (vehicle) loan application */
  vehicleLoanApplicationId: Scalars['ID']['input'];
};

export type CreateDirectDebitAgreementErrorUnion = ClaimantIdCategoryCodeCombinationMissingError | InvalidBranchNumberError | MandateAlreadyExistsError | SecurityCodeMissingError | SpecifyBranchMoreThenOneBranchForCategoryCodeError | WithdrawalAccountAndKennitalaDoNotMatchError | WithdrawalAccountNotFoundError;

/** Input for creating a direct debit agreement */
export type CreateDirectDebitAgreementInput = {
  /** Category code, 2 letters/digits (ISK: Textalykill) */
  categoryCode: Scalars['String']['input'];
  /** Bank branch number */
  categoryCodeBranch?: InputMaybe<Scalars['String']['input']>;
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber: Scalars['String']['input'];
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala: Scalars['String']['input'];
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Scalars['String']['input'];
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Scalars['String']['input'];
};

/** Payload with result of creating a direct debit agreement */
export type CreateDirectDebitAgreementPayload = {
  __typename: 'CreateDirectDebitAgreementPayload';
  /** Success result data for the created direct debit agreement. Null if unsuccessful. */
  data: Maybe<CreateDirectDebitAgreementSuccessData>;
  /** Error, if any occurred during the creation of the direct debit agreement */
  error: Maybe<CreateDirectDebitAgreementErrorUnion>;
};

/** Success data result for create direct debit agreement */
export type CreateDirectDebitAgreementSuccessData = {
  __typename: 'CreateDirectDebitAgreementSuccessData';
  /** The direct debit mandate that was created */
  directDebitMandate: Maybe<DirectDebitMandate>;
  /** ID (Global) of the created direct debit mandate */
  id: Scalars['ID']['output'];
};

export type CreateDirectDebitInitiationInput = {
  /** Bank branch number */
  bank?: InputMaybe<Scalars['String']['input']>;
  /** Category code, 2 letters/digits (ISK: Textalykill) */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** Claimant kennitala (ISK: Kennitala kröfuhafa) */
  claimantKennitala: Scalars['String']['input'];
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber: Scalars['String']['input'];
  /** The key to ensure idempotency for the mandate, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala: Scalars['String']['input'];
  validationPeriod: Scalars['String']['input'];
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Scalars['String']['input'];
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Scalars['String']['input'];
};

/** Input for creating direct debit mandate orders with an excel file */
export type CreateDirectDebitMandateOrdersFromFileInput = {
  /** An excel file containing the direct debit mandate orders data */
  file: Scalars['Upload']['input'];
};

/** Payload with result of creating direct debit mandate orders with a file */
export type CreateDirectDebitMandateOrdersFromFilePayload = {
  __typename: 'CreateDirectDebitMandateOrdersFromFilePayload';
  /** Error, if any, that occurred during the file upload */
  error: Maybe<UploadDirectDebitMandateOrdersFileErrorUnion>;
  /** Result if the creation with file was successful */
  result: Maybe<CreateDirectDebitMandateOrdersFromFileResult>;
  /** Was the creation with file successful? */
  success: Scalars['Boolean']['output'];
};

/** Success result of creating direct debit mandate orders with a file */
export type CreateDirectDebitMandateOrdersFromFileResult = {
  __typename: 'CreateDirectDebitMandateOrdersFromFileResult';
  /** Number of direct debit mandate orders created from the uploaded file. These mandates should be treated as pending */
  pendingOrdersCount: Scalars['Int']['output'];
};

export type CreateDirectDebitMandateResponse = CreatePaymentScaResponse | DirectDebitMandateError | MandateAlreadyExists | UnableToCreateMandateForCustomerNumber;

export type CreateEmployeeInPayrollError = EmployeeAccountAndKennitalaDoNotMatchError | EmployeeAlreadyExistsInPayrollError | EmployeeInvalidAccountNumberError | EmployeeInvalidKennitalaError | UnknownError;

export type CreateEmployeeInPayrollInput = {
  /** Account number of new employee */
  accountNumber: Scalars['String']['input'];
  /** Kennitala of new employee */
  kennitala: Scalars['String']['input'];
  /** ID (Global) of the payroll where the employee will be added */
  payrollId: Scalars['ID']['input'];
};

/** Payload for creating an employee in a payroll */
export type CreateEmployeeInPayrollPayload = {
  __typename: 'CreateEmployeeInPayrollPayload';
  /** New employee from a successful creation request */
  employee: Maybe<PayrollEmployee>;
  /** Error returned after an unsuccessful creation request */
  error: Maybe<CreateEmployeeInPayrollError>;
};

export type CreateEmployeesInPayrollFromExcelInput = {
  excelFile: Scalars['Upload']['input'];
  /** ID (Global) of the payroll where the employees will be added */
  payrollId: Scalars['ID']['input'];
};

/** Payload for creating employees from excel file */
export type CreateEmployeesInPayrollFromExcelPayload = {
  __typename: 'CreateEmployeesInPayrollFromExcelPayload';
  /** Error returned after an unsuccessful attempt to parse excel file */
  error: Maybe<EmployeeExcelCreationError>;
  /** Information about insert in case of a successful request */
  inserts: Maybe<EmployeeExcelInserts>;
};

export type CreateExternalAccountConsentInput = {
  /** Global GraphQL identifier of a Payment Service Provider */
  providerId: Scalars['ID']['input'];
  /** The URL that the client will be redirected to when a consent is successfully created */
  redirectUrl: Scalars['String']['input'];
};

/** The result of creating external account consent */
export type CreateExternalAccountConsentResponse = {
  __typename: 'CreateExternalAccountConsentResponse';
  consent: ExternalAccountConsent;
  success: Scalars['Boolean']['output'];
};

export type CreateExternalVehicleLoanApplicationErrorUnion = ExternalVehicleLoanApplicationNoAccessError | UnknownError;

export type CreateExternalVehicleLoanApplicationInput = {
  /** List of applicants */
  applicants: Array<ExternalVehicleLoanApplicationApplicantInput>;
  /** General comment for the application with the max length of 280 characters */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Kennitala of the dealership which is used for all external vehicle sources */
  dealershipKennitala: Scalars['String']['input'];
  /** The amount deposited (innborgun) */
  depositAmount: Scalars['Float']['input'];
  /** The kennitala of the insurance company where the vehicle will be insured */
  insuranceCompanyKennitala: Scalars['String']['input'];
  /** The requested loan duration in months */
  loanDurationMonths?: InputMaybe<Scalars['Int']['input']>;
  /** The distance in km that the vehicle has traveled */
  mileage: Scalars['Int']['input'];
  /** The price of the vehicle */
  price: Scalars['Float']['input'];
  /** Vehicle registration number (Fastanúmer) */
  registrationNumber: Scalars['String']['input'];
  /** List of trade-ins (uppítökubílar) */
  tradeIns?: InputMaybe<Array<ExternalVehicleLoanApplicationTradeInInput>>;
  /** True when individual is applying for a loan as a contractor (einyrki) */
  useCompanyProduct?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleLoanType: VehicleLoanType;
};

export type CreateExternalVehicleLoanApplicationPayload = {
  __typename: 'CreateExternalVehicleLoanApplicationPayload';
  error: Maybe<CreateExternalVehicleLoanApplicationErrorUnion>;
  externalVehicleApplication: Maybe<ExternalVehicleLoanApplication>;
};

export type CreateFinancialStatementsSubscriptionError = SubscribeToFinancialStatementsInsufficientFundsError | SubscribeToFinancialStatementsWithdrawalAccessDeniedError | SubscribeToFinancialStatementsWithdrawalAccountLockedError | UnknownError;

/** Payload for subscribing to financial statements */
export type CreateFinancialStatementsSubscriptionPayload = {
  __typename: 'CreateFinancialStatementsSubscriptionPayload';
  /** Error object if creation failed */
  error: Maybe<CreateFinancialStatementsSubscriptionError>;
  /** Created subscription */
  subscription: Maybe<FinancialStatementsSubscription>;
};

/** Payload after creating a form attachment */
export type CreateFormTemplateAttachmentPayload = {
  __typename: 'CreateFormTemplateAttachmentPayload';
  error: Maybe<CreateFormTemplateAttachmentPayloadErrorUnion>;
  result: Maybe<CreateFormTemplateAttachmentResult>;
};

export type CreateFormTemplateAttachmentPayloadErrorUnion = UnknownError;

/** Result after creating a form attachment. The returned attachment ID is for the client to include in the form submission */
export type CreateFormTemplateAttachmentResult = {
  __typename: 'CreateFormTemplateAttachmentResult';
  attachmentId: Scalars['String']['output'];
};

export type CreateFormTemplateDocumentInput = {
  /** The ID of the form template to create a document pdf */
  formId: Scalars['String']['input'];
  /** The JSON string representing the values for the form fields */
  valueJson: Scalars['String']['input'];
};

/** Payload after creating a form document */
export type CreateFormTemplateDocumentPayload = {
  __typename: 'CreateFormTemplateDocumentPayload';
  error: Maybe<CreateFormTemplateDocumentPayloadErrorUnion>;
  result: Maybe<CreateFormTemplateDocumentResult>;
};

export type CreateFormTemplateDocumentPayloadErrorUnion = UnknownError;

/** Payload after creating a form document */
export type CreateFormTemplateDocumentResult = {
  __typename: 'CreateFormTemplateDocumentResult';
  documentId: Scalars['String']['output'];
  formRequestId: Scalars['String']['output'];
  pdf: GenericFile;
};

export type CreateGeneralLoanApplicationError = GeneralLoanApplicationAlreadyExistsError;

/** Input for creating a general loan application */
export type CreateGeneralLoanApplicationInput = {
  /** Optional supporting documents for the loan application */
  documents?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Requested loan amount and currency */
  loanAmount: CurrencyAmountInput;
  /** Requested loan duration in months. (min: 1, max: 500) */
  loanDurationMonths: Scalars['Float']['input'];
  /** Text describing the purpose of the loan. Max length is 1500 characters */
  loanPurpose: Scalars['String']['input'];
};

/** Payload for creation of general loan application */
export type CreateGeneralLoanApplicationPayload = {
  __typename: 'CreateGeneralLoanApplicationPayload';
  /** The result of a successful creation of a general loan application. Null if the creation was unsuccessful. */
  data: Maybe<GeneralLoanApplicationSuccessData>;
  /** A known business error when creation fails */
  error: Maybe<CreateGeneralLoanApplicationError>;
};

/** Result of creating Opaque Card for Google Wallet. */
export type CreateGoogleWalletOpcPayload = {
  __typename: 'CreateGoogleWalletOPCPayload';
  /** Id of the card that the OPC was crated for. */
  cardId: Scalars['Int']['output'];
  /** The OPC, opaque payment card, JWT, to send to wallet. */
  opc: Scalars['String']['output'];
};

export type CreateGoogleWalletOpaquePaymentCardInput = {
  /** The id of the card to create OPC for */
  cardId: Scalars['ID']['input'];
  /** The stable hardware id fetched from the TapAndPay api. */
  clientDeviceId: Scalars['String']['input'];
  /** The Wallet ID of the active wallet on device. Fetched from the TapAndPay api. */
  clientWalletAccountId: Scalars['String']['input'];
  /** Set true for Aukakrónu card */
  domesticCard: Scalars['Boolean']['input'];
};

export type CreateIndexationNoticePayload = {
  __typename: 'CreateIndexationNoticePayload';
  account: Account;
  noticeId: Scalars['ID']['output'];
};

export type CreateInsuranceOpportunityInput = {
  /** The type of insurance consultation that is requested for. */
  insuranceType?: InputMaybe<InsuranceType>;
};

/** Insurance opportunity request payload */
export type CreateInsuranceOpportunityPayload = {
  __typename: 'CreateInsuranceOpportunityPayload';
  success: Scalars['Boolean']['output'];
};

/** Generic validation failure */
export type CreateInternationalPaymentValidationError = Error & {
  __typename: 'CreateInternationalPaymentValidationError';
  error: Scalars['String']['output'];
  field: InternationalPaymentValidationErrorField;
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateInvoiceBatchFromExcelInput = {
  /** Excel file to create invoice batch from, could also be IKT40. */
  excelFile: Scalars['Upload']['input'];
};

export type CreateInvoiceBatchFromExcelPayload = {
  __typename: 'CreateInvoiceBatchFromExcelPayload';
  /** Shows wether batch was successfully created. */
  success: Scalars['Boolean']['output'];
};

export type CreateInvoiceBatchFromExcelTemplatePayload = {
  __typename: 'CreateInvoiceBatchFromExcelTemplatePayload';
  /** A link where an example template can be downloaded from. */
  downloadLink: Scalars['String']['output'];
};

export type CreateInvoiceError = Error & {
  __typename: 'CreateInvoiceError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateInvoiceErrorUnion = CreateInvoiceError | InvoiceAlreadyExistsError | InvoiceClaimNumberNotAvailableError | InvoiceCollectionCompanyIsNotAvailableError | InvoiceDepositAccountLockedError | InvoiceFirstDefaultChargeIsNotProvidedInTemplateError | InvoiceInvalidFirstDefaultChargeNumberOfDaysError | UnknownError;

export type CreateInvoiceInput = {
  /** Date for when the claim is cancelled */
  cancellationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Number of the claim */
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  /** Global ID of the claim template for the invoice */
  claimTemplateId: Scalars['ID']['input'];
  /** Unique payor identification for claimant, used for direct debit */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Description shown in the invoice overview */
  description: Scalars['String']['input'];
  /** The set due date for the claim, after which additional fees may apply */
  dueDate: Scalars['DateTimeISO']['input'];
  /** The set final due date for the claim, after which additional fees may apply */
  finalDueDate: Scalars['DateTimeISO']['input'];
  /** Fee added if claim is unpaid after the due date */
  firstDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  /** How many days after the due date the firstDefaultCharge is applied */
  firstDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Claims with a younger due date can be paid first */
  isOutOfSequencePaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can partial payments be made to the claim */
  isPartialPaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fee added for notifying payor, printed or electronic */
  notificationFee?: InputMaybe<Scalars['Float']['input']>;
  /** Kennitala / id of the payor */
  payorKennitala: Scalars['String']['input'];
  /** Amount to be collected, before additional fees and interests are applied */
  principalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** 7 letter reference */
  reference: Scalars['String']['input'];
  /** Fee added if claim is unpaid after the final due date */
  secondDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  /** How many days after the final due date the secondDefaultCharge is applied */
  secondDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Will a notification be sent if payment is late */
  sendLatePaymentNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Add default interest using the central bank rate if unpaid after the due date */
  useCentralBankRateDefaultInterest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateInvoicePayload = {
  __typename: 'CreateInvoicePayload';
  invoice: Invoice;
};

export type CreateInvoicePayloadV2 = {
  __typename: 'CreateInvoicePayloadV2';
  error: Maybe<CreateInvoiceErrorUnion>;
  invoice: Maybe<Invoice>;
};

export type CreateInvoiceScheduleErrorUnion = InvoiceScheduleFetchSchedulesError | InvoiceScheduleUnpaidClaimsCleanupError | UnknownError;

export type CreateInvoiceScheduleInput = {
  /** Id of the claim template to create claims in */
  claimTemplateId: Scalars['ID']['input'];
  /** Unique payor identification for claimant, used for direct debit - 16 chars max */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Description to be shown to the payor - 200 chars max */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Which day of the month should the dueDate be */
  dueDateDayOfMonth: Scalars['Int']['input'];
  /** The last possible due date of the claim created on this schedule */
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Which day of the month should the finalDueDate be */
  finalDueDateDayOfMonth: Scalars['Int']['input'];
  /** Kennitala of the payor of this claim */
  payorKennitala: Scalars['String']['input'];
  /** Principal amount of the claim to be created */
  principalAmount: Scalars['Float']['input'];
  /** If set - this is the reference month for the indexation calculations which will be added to the principalAmount each month. */
  principalAmountIndexDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Reference value to be put on each created claim - 16 chars max */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** The first possible due date of the claim created on this schedule */
  startDate: Scalars['DateTimeISO']['input'];
};

export type CreateInvoiceSchedulePayloadV2 = {
  __typename: 'CreateInvoiceSchedulePayloadV2';
  error: Maybe<CreateInvoiceScheduleErrorUnion>;
  invoiceSchedule: Maybe<InvoiceSchedule>;
};

export type CreateInvoiceTemplateInput = {
  categoryCode: Scalars['String']['input'];
  /** Invoice template claimant ID */
  claimantId?: InputMaybe<Scalars['String']['input']>;
  /** Secondary collection's collection company kennitala */
  collectionCompanyKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Additional information for invoice template */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Number of days after which to send the second collection notification */
  daysUntilSecondaryCollectionWarning?: InputMaybe<Scalars['Int']['input']>;
  /** Rule to determine when to apply default charge */
  defaultChargeRule?: InputMaybe<CalculationRuleAfter>;
  /** Default interest rate */
  defaultInterestRate?: InputMaybe<Scalars['Float']['input']>;
  depositAccountId: Scalars['String']['input'];
  /** Name of the invoice template. For example 'Félagsgjöld' */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Rule to determine when to apply discount */
  discountRule?: InputMaybe<CalculationRuleBefore>;
  dueDateRule?: InputMaybe<Scalars['Int']['input']>;
  /** Extended reference of the claimant */
  extendedReference?: InputMaybe<InvoiceTemplateExtendedReference>;
  finalDueDateRule?: InputMaybe<Scalars['Int']['input']>;
  firstDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  firstDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days to apply to the calculation rule to apply first discount */
  firstDiscountDays?: InputMaybe<Scalars['Int']['input']>;
  /** Value of the first discount (amount) */
  firstDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  /** Secondary collection's gracePeriodDays */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  isOutOfSequencePaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPartialPaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is default charge set in percentages */
  isPercentageDefaultCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is discount set to be applied in percentage */
  isPercentageDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  monthsUntilCancellation?: InputMaybe<Scalars['Int']['input']>;
  notificationFee?: InputMaybe<Scalars['Float']['input']>;
  /** Other costs related to the claim */
  otherCost?: InputMaybe<Scalars['Float']['input']>;
  /** Other default cost (annar vanskilakostnaður) */
  otherDefaultCost?: InputMaybe<Scalars['Float']['input']>;
  /** Comment to print in the mail */
  printedComment?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the claimant */
  printingClaimantName?: InputMaybe<Scalars['String']['input']>;
  /** Determines the way we handle the mail */
  printingHandlingOption?: InputMaybe<Scalars['Int']['input']>;
  /** Postal code for the address */
  printingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address to mail to */
  printingStreetAddress?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use registered address */
  printingUseRegisteredAddress?: InputMaybe<Scalars['Boolean']['input']>;
  secondDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  secondDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days to apply to the calculation rule to apply second discount */
  secondDiscountDays?: InputMaybe<Scalars['Int']['input']>;
  /** Value of the second discount (amount) */
  secondDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  sendLatePaymentNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Short reference of the claimant */
  shortReference?: InputMaybe<InvoiceTemplateShortReference>;
  /** Invoice template code */
  templateCode?: InputMaybe<Scalars['String']['input']>;
  /** Invoice template type */
  type?: InputMaybe<InvoiceType>;
  useCentralBankRateDefaultInterest?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalAccountId: Scalars['String']['input'];
};

export type CreateInvoiceTemplatePayload = {
  __typename: 'CreateInvoiceTemplatePayload';
  template: InvoiceTemplate;
};

export type CreateLoanApplicationCommentInput = {
  /** Amount for proposed loan application */
  amount?: InputMaybe<Scalars['Float']['input']>;
  comment: Scalars['String']['input'];
  commentType: LoanApplicationCommentTypeId;
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
};

export type CreateLoanApplicationPackagesInput = {
  /** Loan amount wanted by user */
  amount: Scalars['Float']['input'];
  loanApplicationId: Scalars['ID']['input'];
  /** Number of payments onto the loan per month */
  paymentPerMonth: Scalars['Float']['input'];
};

export type CreateLoanApplicationPaymentInstructionInput = {
  instruction: LoanApplicationPaymentInstructionInput;
  /** ID (Global) of loan application that this payment instruction will be attached to */
  loanApplicationId: Scalars['ID']['input'];
};

export type CreateLoanDrawDownRequestInput = {
  /** Amount to draw down */
  amount: Scalars['Float']['input'];
  /** File attachments for the draw down request */
  attachments?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /** Optional comment for the draw down request. To assist employees processing the request. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Currency code for the draw down amount */
  currencyCode: Scalars['String']['input'];
  /** Account number for the account for disbursement */
  disbursementAccountNumber: Scalars['String']['input'];
  /** Due date for the first payment */
  dueDate: Scalars['Date']['input'];
  /** Account number for the installment account */
  installmentAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the loan to draw down from */
  loanId: Scalars['ID']['input'];
  /** Requested draw down date */
  requestedDate: Scalars['Date']['input'];
};

/** Result of a create down request operation */
export type CreateLoanDrawDownRequestPayload = {
  __typename: 'CreateLoanDrawDownRequestPayload';
  /** The created draw down request, if successful */
  drawDown: Maybe<LoanDrawDown>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type CreateLoanRequestInput = {
  amount: Scalars['Int']['input'];
  indexType: LookUpTypeInput;
  interestId: Scalars['Float']['input'];
  interestRate: Scalars['Float']['input'];
  loanDurationMonths: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  paymentType: LookUpTypeInput;
  productCatalogId: Scalars['Float']['input'];
};

export type CreateLoanRequestsInput = {
  loanApplicationId: Scalars['ID']['input'];
  loanRequests: Array<CreateLoanRequestInput>;
};

export type CreateMarketOrderInput = {
  accountId: Scalars['String']['input'];
  action: MarketInstrumentOrderAction;
  /** amount is required if type is amount */
  amount?: InputMaybe<Scalars['Float']['input']>;
  instrumentId: Scalars['String']['input'];
  portfolioId: Scalars['String']['input'];
  /** price is required if type is limit */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** quantity is required if type is either limit or market */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: MarketInstrumentOrderType;
};

export type CreateMarketOrderPayload = {
  __typename: 'CreateMarketOrderPayload';
  order: MarketOrder;
};

export type CreateMarketOrderResult = AccountInsufficientAvailableToBuy | CreateMarketOrderPayload | CustomerTradeNotAllowed | InvalidTypeFundOrder | MarketOrderAccountNotAllowed | MarketOrderMarketClosed | MinimumTradingOrderAmount | NotEnoughholdingError | OnlineTradeNotAvailableForInstrument | OrderBuyAccountNotAllowed | PortfolioBuyNotAllowed | PortfolioNotFound | PortfolioReadAccessError;

export type CreateMarketSubscriptionInput = {
  accountId: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  instrumentId: Scalars['String']['input'];
  portfolioId: Scalars['String']['input'];
};

export type CreateMarketSubscriptionPaylaod = {
  __typename: 'CreateMarketSubscriptionPaylaod';
  subscription: MarketSubscription;
};

export type CreateMarketSubscriptionResult = AccountNotAllowedForMarketSubscription | CreateMarketSubscriptionPaylaod | MarketSubscriptionInstrumentNotAllowed | MarketSubscriptionNotAllowedForCustomer | MaximumMarketSubscriptionAmountError | MinimumMarketSubscriptionAmountError | PortfolioMarketSubscriptionNotAllowed;

export type CreateOnboardingCorporateApplicationPayload = {
  __typename: 'CreateOnboardingCorporateApplicationPayload';
  application: OnboardingCorporateApplication;
};

export type CreateOnboardingTermsAndConditionsPdfDocumentInput = {
  /** Type of onboarding. */
  onboardingType: OnboardingType;
};

export type CreateOverdraftLoanApplicationInput = {
  accountNumber: Scalars['String']['input'];
  /** The exact end date for the overdraft, as opposed to the month-based overdraft duration object. */
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** only nullable meanwhile duration exist */
  overdraftDuration?: InputMaybe<OverdraftDuration>;
  requestedAmount: Scalars['Float']['input'];
};

export type CreateOverdraftLoanApplicationPayload = {
  __typename: 'CreateOverdraftLoanApplicationPayload';
  overdraftLoanApplication: OverdraftLoanApplication;
};

export type CreateOverdraftToBondLoanApplicationInput = {
  /** Reikningur sem á að greiða lánið inná. Yfirdráttur þessa reiknings verður færður niður sem nemur upphæð lánsins. */
  accountNumber: Scalars['String']['input'];
  /** Upphæð láns */
  amount: Scalars['Float']['input'];
  /** Skuldfærslureikningur. */
  directDebitAccountNumber: Scalars['String']['input'];
  /** Lánstími í mánuðum. Möguleg gildi sótt úr product catalog. */
  loanDurationMonths: Scalars['Int']['input'];
};

export type CreateOverdraftToBondLoanApplicationPayload = {
  __typename: 'CreateOverdraftToBondLoanApplicationPayload';
  application: OverdraftToBondLoanApplication;
};

/** New paid leave account */
export type CreatePaidLeaveAccountInputv2 = {
  depositAccountId: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
};

export type CreatePaidLeaveAccountPayload = {
  __typename: 'CreatePaidLeaveAccountPayload';
  paidLeaveAccount: Maybe<PaidLeaveAccountv2>;
};

export type CreatePaidLeaveAccountsErrorPayload = {
  __typename: 'CreatePaidLeaveAccountsErrorPayload';
  errors: Array<PaidLeaveAccountError>;
};

export type CreatePaidLeaveAccountsPayload = {
  __typename: 'CreatePaidLeaveAccountsPayload';
  payload: Maybe<Scalars['String']['output']>;
};

/** The debtor account available fund is insufficient for the payment to be created */
export type CreatePaymentAmountUnavailableError = Error & {
  __typename: 'CreatePaymentAmountUnavailableError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Approval process is not supported for requested payment. Exclusive for corporate user */
export type CreatePaymentApprovalProcessNotSupportedError = Error & {
  __typename: 'CreatePaymentApprovalProcessNotSupportedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Input to create a claim payment in a payment batch. Must include all relevant information for fast processing */
export type CreatePaymentBatchClaimPaymentInput = {
  /** The bill number of the claim. Must be provided if present */
  billNumber?: InputMaybe<Scalars['String']['input']>;
  /** The category code for the claim payment. Must be provided if present */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The claim number */
  claimNumber: Scalars['String']['input'];
  /** The kennitala of the claimant */
  claimantId: Scalars['String']['input'];
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Description for account statement (Skýring) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The due date of the claim */
  dueDate: Scalars['Date']['input'];
  /** If the claim payment is a partial payment */
  isPartialPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment date */
  paymentDate?: InputMaybe<Scalars['Date']['input']>;
  /** Claim reference. Must be provided if present */
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Input to create a payment batch from input */
export type CreatePaymentBatchInput = {
  /** The category code for the batch */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The account kennitala to be used for payments in the batch */
  debtorAccountKennitala: Scalars['String']['input'];
  /** The account number to be used for the payments in the batch */
  debtorAccountNumber: Scalars['String']['input'];
  /** The name of the payment batch */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Payments in the batch */
  payments: CreatePaymentBatchPaymentsInput;
};

export type CreatePaymentBatchPayload = {
  __typename: 'CreatePaymentBatchPayload';
  initiationId: Scalars['ID']['output'];
};

export type CreatePaymentBatchPayloadV2 = {
  __typename: 'CreatePaymentBatchPayloadV2';
  /** The error of the batch. Indicates a problem with the file or the header (first two lines) */
  error: Maybe<PaymentBatchInitiationErrorSubject>;
  /** The ID of the payment batch. Will be undefined if we get an error creating the payment batch */
  initiationId: Maybe<Scalars['ID']['output']>;
};

/** Batch payments input */
export type CreatePaymentBatchPaymentsInput = {
  /** List of claim payments in the batch */
  claims?: InputMaybe<Array<CreatePaymentBatchClaimPaymentInput>>;
};

/** User is not authorised to execute domestic payments in FBLI */
export type CreatePaymentCompanyUserNotAuthorisedError = Error & {
  __typename: 'CreatePaymentCompanyUserNotAuthorisedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Payments requiring foreign exchange are unavailable while exchange market is closed */
export type CreatePaymentCurrencyExchangeMarketClosedError = Error & {
  __typename: 'CreatePaymentCurrencyExchangeMarketClosedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** User is not allowed to deposit into the selected account */
export type CreatePaymentDepositNotAllowedError = Error & {
  __typename: 'CreatePaymentDepositNotAllowedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreatePaymentDistributionInput = {
  cardId: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
  loanAmount: Scalars['Float']['input'];
  numberOfPayments: Scalars['Int']['input'];
};

/** Create payment distribution payload */
export type CreatePaymentDistributionPayload = {
  __typename: 'CreatePaymentDistributionPayload';
  paymentDistribution: PaymentDistribution;
};

/** The company daily withdrawal limit would be exceeded with the payment */
export type CreatePaymentExceedsCompanyDailyLimitsError = Error & {
  __typename: 'CreatePaymentExceedsCompanyDailyLimitsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The users daily withdrawal limit would be exceeded with the payment */
export type CreatePaymentExceedsDailyLimitsError = Error & {
  __typename: 'CreatePaymentExceedsDailyLimitsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The users withdrawal limit would be exceeded with the payment */
export type CreatePaymentExceedsLimitError = Error & {
  __typename: 'CreatePaymentExceedsLimitError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreatePaymentInstructionPayload = {
  __typename: 'CreatePaymentInstructionPayload';
  success: Scalars['Boolean']['output'];
};

/** The withdrawal account available fund is insufficient for the payment to be created */
export type CreatePaymentInsufficientAvailableFundError = Error & {
  __typename: 'CreatePaymentInsufficientAvailableFundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The payment date is invalid */
export type CreatePaymentInvalidPaymentDateError = Error & {
  __typename: 'CreatePaymentInvalidPaymentDateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The start date is invalid (periodic) */
export type CreatePaymentInvalidStartDateError = Error & {
  __typename: 'CreatePaymentInvalidStartDateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Payment recipient already exists */
export type CreatePaymentRecipientAlreadyExistsError = Error & {
  __typename: 'CreatePaymentRecipientAlreadyExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Payment to recipients country is not allowed */
export type CreatePaymentRecipientCountryOnBlacklistError = Error & {
  __typename: 'CreatePaymentRecipientCountryOnBlacklistError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreatePaymentRecipientErrorUnion = CreatePaymentRecipientAlreadyExistsError | CreatePaymentRecipientCountryOnBlacklistError | UnknownError;

export type CreatePaymentRecipientInput = {
  /** Account identifier of the recipient. */
  accountIdentifier: Scalars['String']['input'];
  /** Type of the account identifier. */
  accountIdentifierType: AccountIdentifierType;
  /** Address of the recipient. */
  address?: InputMaybe<InternationalPaymentAddressInput>;
  /** Bank information of the recipient. */
  bankInfo?: InputMaybe<PaymentRecipientBankInfoInput>;
  /** Kennitala of the recipient. */
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** Name of the recipient. */
  name: Scalars['String']['input'];
  paymentType: PaymentType;
};

/** Create a new payment recipient payload */
export type CreatePaymentRecipientPayload = {
  __typename: 'CreatePaymentRecipientPayload';
  /** Error returned after an unsuccessful creation of payment recipient */
  error: Maybe<CreatePaymentRecipientErrorUnion>;
  /** Created payment recipient */
  paymentRecipient: Maybe<PaymentRecipient>;
};

export type CreatePaymentScaActionResponse = ScaActionIdpConsentRequired | ScaActionNoActionRequired;

/** The payment needs to go through the sca process to be executed */
export type CreatePaymentScaResponse = {
  __typename: 'CreatePaymentScaResponse';
  /** Indicate which action the client should take in regards to the payment sca process */
  action: CreatePaymentScaActionResponse;
  /** GraphQL node id created with pisId */
  paymentInitiationId: Scalars['ID']['output'];
  /** Payment initiation id */
  pisId: Scalars['String']['output'];
  scaConfirmUrl: Scalars['String']['output'];
};

export type CreatePayrollInput = {
  /** Name of new payroll */
  name: Scalars['String']['input'];
};

/** Payload for creation of payroll */
export type CreatePayrollPayload = {
  __typename: 'CreatePayrollPayload';
  payroll: Maybe<Payroll>;
};

export type CreatePensionApplicationInput = {
  email: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreatePensionApplicationPayload = {
  __typename: 'CreatePensionApplicationPayload';
  /** The payment body, should be defined if there are no errors creating the payment */
  applicationDocument: Maybe<PensionApplicationSignableDocument>;
  error: Maybe<PensionApplicationErrorUnion>;
};

export type CreatePensionCorrespondenceInput = {
  /** The type of pension flow (mandatory or supplementary) */
  pensionType: PensionCorrespondenceFlowType;
};

/** Pension correspondence request payload */
export type CreatePensionCorrespondencePayload = {
  __typename: 'CreatePensionCorrespondencePayload';
  success: Scalars['Boolean']['output'];
};

export type CreatePeriodicCreditTransferErrorV2 = CreatePaymentInvalidStartDateError | UnknownError;

export type CreatePeriodicCreditTransferInput = {
  /** Ending calendar date in the form YYYY-MM-DD for periodic transfer, which excludes time information and resolves time zone issues. */
  calendarEndDate?: InputMaybe<Scalars['Date']['input']>;
  /** Starting calendar date in the form YYYY-MM-DD for periodic transfer, which excludes time information and resolves time zone issues. This field will be required (non-nullable) in the future. Reference: WEB-40730 */
  calendarStartDate?: InputMaybe<Scalars['Date']['input']>;
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Day of execution in the form DD. [ 01, 02, ..., 31 ]. [01, 02, ..., 05] if weekly transfers */
  dayOfExecution?: InputMaybe<Scalars['String']['input']>;
  /** Also known as withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  depositAccountKennitala: Scalars['String']['input'];
  depositAccountNumber: Scalars['String']['input'];
  /** Description for account statement (Skýring) */
  description?: InputMaybe<Scalars['String']['input']>;
  frequency: PaymentFrequency;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Client is SCA compatible and can receive SCA response for this mutation */
  isScaCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference for payment (Tilvísun) */
  reference?: InputMaybe<Scalars['String']['input']>;
  textKey?: InputMaybe<Scalars['String']['input']>;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
};

export type CreatePeriodicCreditTransferPayloadV2 = {
  __typename: 'CreatePeriodicCreditTransferPayloadV2';
  error: Maybe<CreatePeriodicCreditTransferErrorV2>;
  result: Maybe<CreatePaymentScaResponse>;
};

export type CreatePeriodicCreditTransferResponse = CreatePaymentInvalidStartDateError | CreatePaymentScaResponse | RsaStepUpResponse;

export type CreatePeriodicCreditTransferResultV2 = AdaptiveAuthentication | CreatePeriodicCreditTransferPayloadV2;

export type CreateProxyAccessInput = {
  /** read or transfer (write) access */
  accessType: ProxyAccessAccessType;
  /** Approver of this proxy access */
  approver?: InputMaybe<ProxyAccessApproverType>;
  /**
   * Identifier for a specific product. This will not be null for products with productType Account and Card
   *       in which case it will be an Account number or masked Card number respectively.
   */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Product type this proxy access is on: Account | Card | Claim | Market | ElectronicDocument */
  productType: ProxyAccessProductType;
  /** Recipient of this proxy access */
  recipient?: InputMaybe<ProxyAccessApproverType>;
};

export type CreateRealEstateLoanApplicationPayload = {
  __typename: 'CreateRealEstateLoanApplicationPayload';
  loanApplication: RealEstateLoanApplication;
};

export type CreateRealEstateLoanRequestOptionInput = {
  amount: Scalars['Int']['input'];
  /** Interest type of the loan VariableInterests or FixedInterests */
  indexType: IndexType;
  interestId: Scalars['Float']['input'];
  interestRate: Scalars['Float']['input'];
  loanDurationMonths: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
  /** Payment type of the loan EqualInstallments or Annuitet */
  paymentType: LoanProductPaymentType;
  productCatalogId: Scalars['Float']['input'];
};

export type CreateRealEstateLoanRequestOptionsInput = {
  loanApplicationId: Scalars['ID']['input'];
  loanRequestOptions: Array<CreateRealEstateLoanRequestOptionInput>;
};

export type CreateRecurringCardPaymentErrorUnion = UnknownError;

export type CreateRecurringCardPaymentPayload = {
  __typename: 'CreateRecurringCardPaymentPayload';
  /** Errors encountered while creating the recurring card payment token */
  error: Maybe<CreateRecurringCardPaymentErrorUnion>;
  recurringCardPayment: Maybe<RecurringPaymentTokenResponse>;
};

export type CreateRegularSavingInput = {
  creditorAccount?: InputMaybe<RegularSavingCreditorAccountInput>;
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /**
   * It represents the day when the newly created PeriodicCreditTransfer will occur. E.g.: "01", "02", ..., "31".
   * There are few more restrictive dates - look in https://dev.lais.net/pages/viewpage.action?pageId=60445027 -> dayOfExecution
   */
  dayOfExecution?: InputMaybe<Scalars['String']['input']>;
  /** Also known as withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  /** Description for account statement (Skýring) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Use only the following frequencies: Daily, Weekly, EveryTwoWeeks, Monthly, EveryTwoMonths, Quarterly, SemiAnnual, Annual */
  frequency: PaymentFrequency;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** Client is SCA compatible and can receive SCA response for this mutation */
  isScaCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  periodicPaymentType: PeriodicPaymentType;
  /** Reference for payment (Tilvísun) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
  validity?: InputMaybe<RegularSavingValidityInput>;
};

export type CreateRegularSavingResponse = RegularSavingCreditorAndDebtorAccountsCannotBeTheSame | RegularSavingDepositNotAllowed | RegularSavingFrequencyTypeNotSupported | RegularSavingInvalidAccount | RegularSavingInvalidDayOfExecution | RegularSavingInvalidInstructedAmount | RegularSavingInvalidPaymentType | RegularSavingInvalidSecurityCode | RegularSavingInvalidValidity | RegularSavingPayload | RegularSavingPlanAlreadyCreated | RegularSavingSavingsAccountNotFound | RegularSavingStartDateInvalid | RegularSavingUnexpectedError | RegularSavingWithdrawalDepositAccountCurrencyMismatch;

/** Create a salary batch from user input */
export type CreateSalaryPaymentBatchInput = {
  /** The category code for the salary payment batch, applies to all payments in the batch */
  categoryCode: Scalars['String']['input'];
  /** The global id for the debtor account */
  debtorAccountId: Scalars['String']['input'];
  /** The name of the payroll for the salary payment batch */
  name: Scalars['String']['input'];
  /** Requested payment date */
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** List of salary payments */
  salaryPayments: Array<SalaryPaymentInput>;
};

export type CreateSavingGoalInput = {
  categoryId: Scalars['String']['input'];
  endGoalDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  goalAmount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSavingShareInput = {
  accountId: Scalars['String']['input'];
  proxyHolderId: Scalars['String']['input'];
};

export type CreateSavingSharePayload = {
  __typename: 'CreateSavingSharePayload';
  displayNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  proxyHolderId: Scalars['String']['output'];
};

export type CreateSavingShareResponse = CreateSavingSharePayload | ShareLegalEntityError | ShareOutsideFamilyError | ShareToYoungError | SharerToYoungError;

export type CreateSepaCreditTransferErrorV2 = CreateInternationalPaymentValidationError | CreatePaymentApprovalProcessNotSupportedError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreateSepaCreditTransferPaymentNotAllowed | UnknownError;

/** Sepa credit transfer input */
export type CreateSepaCreditTransferInput = {
  /** Central bank category code, for purpose of payment */
  centralBankCategoryCode: Scalars['String']['input'];
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Payors withdrawal account */
  debtorAccountId: Scalars['ID']['input'];
  /** Description for the payment */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  isStoredPayment?: InputMaybe<Scalars['Boolean']['input']>;
  recipient: SepaCreditTransferRecipientInput;
  /** Payed on behalf */
  ultimateCreditor?: InputMaybe<UltimatePartyInput>;
  /** Care of */
  ultimateDebtor?: InputMaybe<UltimatePartyInput>;
};

export type CreateSepaCreditTransferPayloadV2 = {
  __typename: 'CreateSepaCreditTransferPayloadV2';
  error: Maybe<CreateSepaCreditTransferErrorV2>;
  result: Maybe<CreatePaymentScaResponse>;
};

/** Recipient not found */
export type CreateSepaCreditTransferPaymentNotAllowed = Error & {
  __typename: 'CreateSepaCreditTransferPaymentNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreateSepaCreditTransferResponse = CreateInternationalPaymentValidationError | CreatePaymentApprovalProcessNotSupportedError | CreatePaymentExceedsDailyLimitsError | CreatePaymentExceedsLimitError | CreatePaymentScaResponse | CreateSepaCreditTransferPaymentNotAllowed | RsaStepUpResponse;

export type CreateSepaCreditTransferResultV2 = AdaptiveAuthentication | CreateSepaCreditTransferPayloadV2;

/** The payments need to go through the sca process to be executed */
export type CreateSigningBasketScaResponse = {
  __typename: 'CreateSigningBasketScaResponse';
  id: Scalars['ID']['output'];
  signingBasketId: Scalars['String']['output'];
};

export type CreateSimpleCommissionInput = {
  /** The assessment subject that requires a simple commission. */
  assessmentSubject?: InputMaybe<AssessmentSubject>;
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

/** The result of a create simple commission operation */
export type CreateSimpleCommissionPayload = {
  __typename: 'CreateSimpleCommissionPayload';
  commission: SimpleCommission;
};

export type CreateStoredPaymentSigningBasketError = InitiateSigningBasketExchangeRateCurrenciesMismatchError | UnknownError;

export type CreateStoredPaymentSigningBasketPayload = {
  __typename: 'CreateStoredPaymentSigningBasketPayload';
  /**
   * The errors that occurred during payment initiation, this is null if no errors occurred
   * @deprecated Reason: To be able to handle errors in Signing Basket Initiation. Use a combination of paymentErrors and signingBasketErrors instead. Since: 2025-02-25. Removed: 2025-08-25. Issue(s) to remove it: WEB-33217
   */
  errors: Maybe<Array<InitiateStoredPaymentError>>;
  /** The errors that occurred during payment initiation, this is null if no errors occurred. These are tied to the PisID of the payment that failed */
  paymentErrors: Maybe<Array<InitiateStoredPaymentError>>;
  /** The signing basket response, this is null if no signing basket was created */
  scaResponse: Maybe<CreateSigningBasketScaResponse>;
  /** The errors that occurred during initiating a signing basket, this is null if no errors occurred. This is unrelated to the initialization of the payments */
  signingBasketErrors: Maybe<Array<CreateStoredPaymentSigningBasketError>>;
};

export type CreateStoredPaymentSigningBasketResponse = CreatePaymentScaResponse | CreateStoredPaymentSigningBasketPayload;

/** How should the user authenticate the payment */
export enum CreateThirdPartyPaymentAuthFlow {
  /** Additional authentication is needed, could be either PKI Sim or Audkennisapp */
  REQUIRES_AUTHENTICATION = 'REQUIRES_AUTHENTICATION',
  /** The user must be redirected to an external payment page to continue */
  REQUIRES_REDIRECT = 'REQUIRES_REDIRECT',
  /** The payment status could not be determined or is in an undefined state */
  UNKNOWN = 'UNKNOWN'
}

export type CreateThirdPartyPaymentCreditTransfer = {
  __typename: 'CreateThirdPartyPaymentCreditTransfer';
  authFlow: CreateThirdPartyPaymentAuthFlow;
  authUrl: Scalars['String']['output'];
  thirdPartyPaymentId: Scalars['ID']['output'];
};

export type CreateThirdPartyPaymentCreditTransferInput = {
  /** Recipients account */
  creditorAccount: ThirdPartyPaymentCreditorAccountInput;
  /** Payors withdrawal account */
  debtorAccount: ThirdPartyPaymentDebtorAccountInput;
  /** Description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The key to ensure idempotency for the payment */
  idempotency: Scalars['String']['input'];
  /** The payment amount and ISO currency code */
  instructedAmount: ThirdPartyPaymentInstructedAmountInput;
  /** Requested payment date, If no date is provided will request a payment date now */
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** GraphQL provider id */
  providerId: Scalars['ID']['input'];
  redirectUrl: Scalars['String']['input'];
  /** Reference (Tilvísun) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Category code of the invoice template used for the claim */
  textKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreateThirdPartyPaymentCreditTransferPayload = {
  __typename: 'CreateThirdPartyPaymentCreditTransferPayload';
  error: Maybe<ThirdPartyPaymentCreditTransferErrorUnion>;
  /** The payment body, should be defined if there are no errors creating the payment */
  paymentInitiation: Maybe<CreateThirdPartyPaymentCreditTransfer>;
};

export type CreateUserErrorUnion = KennitalaDoesNotExistsError | UnknownError | UserExistsError;

export type CreateUserInput = {
  /** Kennitala of the user to be created */
  kennitala: Scalars['String']['input'];
};

export type CreateUserPayload = {
  __typename: 'CreateUserPayload';
  error: Maybe<CreateUserErrorUnion>;
  success: Scalars['Boolean']['output'];
  user: Maybe<CompanyUser>;
};

export type CreditApplicationResult = CardHolderMustBeAPerson | CipMissing | CreditCardApplicationPayload | CustomerTooYoung | InvalidCountryId | LoanApplicationNotApproved | RequestedCreditLineError | ScannedCertificateMissing | SelfServiceProhibited;

export type CreditAsessmentIncomeDetail = {
  __typename: 'CreditAsessmentIncomeDetail';
  amount: Scalars['Float']['output'];
  date: Scalars['DateTimeISO']['output'];
  employerName: Scalars['String']['output'];
};

/** Credit assessment for loan purposes */
export type CreditAssessment = Node & {
  __typename: 'CreditAssessment';
  applicantDetails: CreditAssessmentApplicantDetails;
  arePayableDebtsDecided: Scalars['Boolean']['output'];
  areVehicleDebtsDecided: Scalars['Boolean']['output'];
  assets: Array<CreditAssessmentAsset>;
  conclusionDocument: CreditAssessmentDocument;
  createdDate: Scalars['DateTimeISO']['output'];
  /** Type of the credit assessment, e.g. a credit assessment for a real estate loan or car loan */
  creditAssessmentType: CreditAssessmentType;
  debts: Array<CreditAssessmentDebt>;
  expenses: Array<CreditAssessmentExpense>;
  id: Scalars['ID']['output'];
  incomes: Array<CreditAssessmentIncome>;
  loanApplication: RealEstateLoanApplication;
  loanResult: CreditAssessmentLoanResult;
  newVehicle: Maybe<CreditAssessmentVehicle>;
  payableDebts: Array<CreditAssessmentDebt>;
  realEstates: Array<CreditAssessmentRealEstate>;
  reasonType: CreditAssessmentReasonType;
  resultSummary: CreditAssessmentResultSummary;
  sellableRealEstates: Array<CreditAssessmentRealEstate>;
  status: CreditAssessmentStatus;
  vehicleDebts: Array<CreditAssessmentDebt>;
  vehicles: Array<CreditAssessmentAsset>;
};

export type CreditAssessmentApplicant = {
  __typename: 'CreditAssessmentApplicant';
  email: Maybe<Scalars['String']['output']>;
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreditAssessmentApplicantDetails = {
  __typename: 'CreditAssessmentApplicantDetails';
  applicants: Array<CreditAssessmentApplicant>;
  children: Scalars['Int']['output'];
};

/** An asset linked to a credit assessment, can be cars, motorcycles etc. affects credit assessment results */
export type CreditAssessmentAsset = {
  __typename: 'CreditAssessmentAsset';
  amount: Scalars['Float']['output'];
  amountUsedInFinancing: Scalars['Float']['output'];
  assetType: CreditAssessmentAssetType;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  registrationNumber: Maybe<Scalars['String']['output']>;
  useInExpenseCalculation: Scalars['Boolean']['output'];
  willBeUsedInFinancing: Scalars['Boolean']['output'];
};

export enum CreditAssessmentAssetType {
  Balance = 'Balance',
  CurrencyTurnover = 'CurrencyTurnover',
  GottenFromTaxChief = 'GottenFromTaxChief',
  Grant = 'Grant',
  NoCategory = 'NoCategory',
  Other = 'Other',
  PensionSpecialSaving = 'PensionSpecialSaving',
  Stocks = 'Stocks',
  TurnoverAccount = 'TurnoverAccount',
  Vehicle = 'Vehicle'
}

export type CreditAssessmentCalculation = {
  __typename: 'CreditAssessmentCalculation';
  familyExpense: Scalars['Float']['output'];
  /** Income remdainder per month */
  incomeRemainder: Scalars['Float']['output'];
  linCustomerPayment: Scalars['Float']['output'];
  linSpousePayment: Scalars['Float']['output'];
  otherExpense: Scalars['Float']['output'];
  otherLoanPayment: Scalars['Float']['output'];
  overdraftPaymentPerMonth: Scalars['Float']['output'];
  /** Loans calculated based on income remainder and equity */
  possibleLoans: Maybe<Array<RecommendedLoanStep>>;
  vehicleExpense: Scalars['Float']['output'];
};

export type CreditAssessmentCalculatorCustomerArgs = {
  /** LÍN greiðslur */
  hasLinPayments: Scalars['Boolean']['input'];
  income: Scalars['Float']['input'];
  /** Total credit limit */
  overdraftCreditLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type CreditAssessmentCreationStatus = {
  __typename: 'CreditAssessmentCreationStatus';
  creditAssessment: Maybe<CreditAssessment>;
  hasSpouse: Scalars['Boolean']['output'];
  status: CreditAssessmentCreationStatusEnum;
};

export enum CreditAssessmentCreationStatusEnum {
  CreditAssessmentCreated = 'CreditAssessmentCreated',
  ErrorCreatingCreditAssessment = 'ErrorCreatingCreditAssessment',
  GatheringInformation = 'GatheringInformation',
  NoCreditAssessment = 'NoCreditAssessment',
  PendingSignature = 'PendingSignature',
  PendingSpouseSignature = 'PendingSpouseSignature'
}

/** Debt linked to a credit assessment, real estate loans, credit card loans and other debts */
export type CreditAssessmentDebt = {
  __typename: 'CreditAssessmentDebt';
  actionType: DebtActionType;
  addedByCustomer: Scalars['Boolean']['output'];
  canBePaidUp: Scalars['Boolean']['output'];
  creditor: LoanActor;
  debtId: Scalars['String']['output'];
  debtName: Scalars['String']['output'];
  debtType: CreditAssessmentDebtType;
  description: Maybe<Scalars['String']['output']>;
  /** Represents fastanúmer and differs for mortgages and carLoans */
  guaranteeNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  indexLinked: Scalars['Boolean']['output'];
  /** Interest rate of the debt */
  interest: Scalars['Float']['output'];
  isFixed: Scalars['Boolean']['output'];
  isLandsbankinnDebt: Maybe<Scalars['Boolean']['output']>;
  /** When the fixed interest period comes to and end */
  lastFixedPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  loanType: CreditInfoLoanTypeEnum;
  newPaymentPerMonth: Scalars['Float']['output'];
  paymentPerMonth: Scalars['Float']['output'];
  paymentPerMonthAfterAction: Scalars['Float']['output'];
  realEstateRef: Scalars['String']['output'];
  /** The combined loan number consists of ledger, branch and account but only account if not landsbankinn debt */
  reference: Maybe<Scalars['String']['output']>;
  remainder: Scalars['Float']['output'];
  showInPaidUp: Scalars['Boolean']['output'];
};

export type CreditAssessmentDebtInput = {
  actionType?: InputMaybe<DebtActionType>;
  debtId?: InputMaybe<Scalars['Int']['input']>;
  debtName?: InputMaybe<Scalars['String']['input']>;
  payUp?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPerMonth?: InputMaybe<Scalars['Float']['input']>;
  remainder?: InputMaybe<Scalars['Float']['input']>;
};

export enum CreditAssessmentDebtType {
  Consumer = 'Consumer',
  Consumerism = 'Consumerism',
  Government = 'Government',
  RealEstate = 'RealEstate',
  Student = 'Student',
  Unknown = 'Unknown',
  Vehicle = 'Vehicle'
}

export type CreditAssessmentDocument = {
  __typename: 'CreditAssessmentDocument';
  documentPdf: Scalars['String']['output'];
};

/** Expenses calculated for a credit assessment, cost of living etc */
export type CreditAssessmentExpense = {
  __typename: 'CreditAssessmentExpense';
  afterAmount: Scalars['Float']['output'];
  amount: Scalars['Float']['output'];
  description: Maybe<Scalars['String']['output']>;
  expenseType: CreditAssessmentExpenseType;
  id: Scalars['String']['output'];
  registrationNumber: Maybe<Scalars['String']['output']>;
};

export type CreditAssessmentExpenseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  expenseId?: InputMaybe<Scalars['Int']['input']>;
  paymentPerMonth?: InputMaybe<Scalars['Float']['input']>;
};

export enum CreditAssessmentExpenseType {
  BoughtRealEstate = 'BoughtRealEstate',
  Other = 'Other',
  RealEstate = 'RealEstate',
  Subsistance = 'Subsistance',
  Transportation = 'Transportation',
  Vehicle = 'Vehicle'
}

export type CreditAssessmentFees = {
  __typename: 'CreditAssessmentFees';
  creditAssessmentForCouplesFee: Fee;
  creditAssessmentForIndividualsFee: Fee;
};

export type CreditAssessmentIncome = {
  __typename: 'CreditAssessmentIncome';
  amount: Scalars['Float']['output'];
  /** Income (model) id */
  id: Scalars['String']['output'];
  incomeDetail: Array<CreditAsessmentIncomeDetail>;
  incomeOrigin: LookUpType;
  incomeType: LookUpType;
  name: Scalars['String']['output'];
};

export type CreditAssessmentLoanResult = {
  __typename: 'CreditAssessmentLoanResult';
  equity: Scalars['Float']['output'];
  preLoanPaymentPerMonth: Scalars['Float']['output'];
  preLoanPaymentPerMonthWithNewRealEstateExpense: Scalars['Float']['output'];
  realEstateValuation: Scalars['Float']['output'];
  results: Array<ViableLoan>;
  totalLoanRefinancing: Maybe<Scalars['Float']['output']>;
};

export type CreditAssessmentNextFees = {
  __typename: 'CreditAssessmentNextFees';
  /** This number depends on few factors, the most important ones being the number of applicants, and if these customers have used their "free car assessment [bílamat] creation" for the current year or not. This fee will be either 0 ISK, 1.490 ISK or 2.980 ISK. (The numbers might differ, depending on when [time-wise] one is using this field) */
  carNextFeeCharge: Scalars['Float']['output'];
  /** This number represents the fee for the CreditAssessment. It depends of the number of applicants */
  creditAssessmentFee: Scalars['Float']['output'];
  /** Fee for guarantor credit assessment */
  guarantorAssessmentFee: Scalars['Float']['output'];
};

/** Real estate used for credit assessment, can be buying, selling or refinancing */
export type CreditAssessmentRealEstate = {
  __typename: 'CreditAssessmentRealEstate';
  actionType: CreditAssessmentRealEstateType;
  address: Scalars['String']['output'];
  amountInDebt: Scalars['Float']['output'];
  amountUsedInFinancing: Scalars['Float']['output'];
  debts: Array<CreditAssessmentDebt>;
  description: Scalars['String']['output'];
  equityUsedForNewRealEstate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  marketPrice: Scalars['Float']['output'];
  realEstateRef: Scalars['String']['output'];
  realEstateValuation: Scalars['Float']['output'];
};

export type CreditAssessmentRealEstateInput = {
  realEstateId?: InputMaybe<Scalars['String']['input']>;
  willBeSold?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CreditAssessmentRealEstateType {
  None = 'None',
  WillBeBought = 'WillBeBought',
  WillBeRefinanced = 'WillBeRefinanced',
  WillBeSold = 'WillBeSold'
}

/** The type of mortgage that a credit assessment can have */
export enum CreditAssessmentReasonType {
  AUTOMOBILE_LOAN = 'AUTOMOBILE_LOAN',
  /** Credit assessment of type debt relief (skuldarúrræði) */
  DEBT_RELIEF = 'DEBT_RELIEF',
  OTHER_LOAN = 'OTHER_LOAN',
  REAL_ESTATE_LOAN = 'REAL_ESTATE_LOAN',
  REFINANCING = 'REFINANCING'
}

export type CreditAssessmentResultSummary = {
  __typename: 'CreditAssessmentResultSummary';
  postCarOperatingCostPaymentPerMonth: Scalars['Float']['output'];
  preLoanPaymentPerMonth: Scalars['Float']['output'];
  vehicleOperatingCost: Scalars['Float']['output'];
};

export enum CreditAssessmentStatus {
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  Error = 'Error',
  Finished = 'Finished',
  GatheringInformation = 'GatheringInformation',
  InProgress = 'InProgress',
  InProgressByCustomer = 'InProgressByCustomer',
  StatusAssessment = 'StatusAssessment'
}

/** Type of credit assessment */
export enum CreditAssessmentType {
  /** Bílamat | Car credit assessment */
  CAR_CREDIT_ASSESSMENT = 'CAR_CREDIT_ASSESSMENT',
  /** Fullgild greiðslumat (allt sótt) stofnað úr innri client | Credit assessment created by an internal user */
  CREDIT_ASSESSMENT = 'CREDIT_ASSESSMENT',
  /** Fullgild greiðslumat(allt sótt) stofnað úr ytri client | Credit assessment created by an external user (from web) */
  CREDIT_ASSESSMENT_WEB = 'CREDIT_ASSESSMENT_WEB',
  /** Greiðslumat stofnað úr innri client allt sótt nema RSK | Credit assessment created by an internal user, retrieving all the data except data from RSK */
  CREDIT_ASSESSMENT_WITHOUT_RSK_DATA = 'CREDIT_ASSESSMENT_WITHOUT_RSK_DATA',
  /** Stöðumat | Credit assessment with no external data */
  CREDIT_ASSESSMENT_WITH_ONLY_LI_DATA = 'CREDIT_ASSESSMENT_WITH_ONLY_LI_DATA',
  GUARANTOR_ASSESSMENT_WITH_ONLY_LI_DATA = 'GUARANTOR_ASSESSMENT_WITH_ONLY_LI_DATA',
  /** Létt greiðslumat sjalfsafgreiðsla | Automatic light-weight credit assessment (stöðumat) */
  LIGHT_CREDIT_ASSESSMENT_AUTOMATIC = 'LIGHT_CREDIT_ASSESSMENT_AUTOMATIC',
  /** Létt greiðslumat útibú | Manual (done at the branch) light-weight credit assessment (stöðumat) */
  LIGHT_CREDIT_ASSESSMENT_BRANCH = 'LIGHT_CREDIT_ASSESSMENT_BRANCH',
  /** Greiðsluerfiðleikamat | Loan adjustment - when there are problems, and we try to fix something */
  LOAN_ADJUSTMENT = 'LOAN_ADJUSTMENT',
  /** Úrræðimat | New version of LoanAdjustment */
  PAYMENT_DIFFICULTIES = 'PAYMENT_DIFFICULTIES'
}

/** Vehicle used for credit assessment */
export type CreditAssessmentVehicle = {
  __typename: 'CreditAssessmentVehicle';
  id: Scalars['ID']['output'];
  operatingCost: Scalars['Float']['output'];
  vehicleType: CreditAssessmentVehicleType;
};

export type CreditAssessmentVehicleInput = {
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  vehicleType?: InputMaybe<CreditAssessmentVehicleType>;
  willBeSold?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CreditAssessmentVehicleType {
  Car = 'Car',
  Caravan = 'Caravan',
  Motorcycle = 'Motorcycle'
}

/** credit cards */
export type CreditCard = Node & {
  __typename: 'CreditCard';
  alias: Maybe<Scalars['String']['output']>;
  /** Notify if available amount is below the threshold amount */
  amountAvailableUnderThresholdNotification: Maybe<CreditCardNotificationEventWithThreshold>;
  annualFee: CardAnnualFeeType;
  /** Checks if the user can add this card to Apple Wallet. */
  appleWalletCardStatus: AppleWalletCardStatus;
  availableAmount: Scalars['Float']['output'];
  /** The available products that this card can be changed to */
  availableProducts: CardProductDetails;
  billingAmount: Scalars['Float']['output'];
  calculatePaymentDistribution: PaymentDistribution;
  canAddToPaymentService: Scalars['Boolean']['output'];
  /** Determine if the user can change the card of the current card */
  canChangeCardType: Scalars['Boolean']['output'];
  canChangeCreditLimit: Scalars['Boolean']['output'];
  /** Determines if a user is authorized for card's notification settings */
  canChangeNotifications: Scalars['Boolean']['output'];
  /** Determines if a user is authorized for card's transaction control settings */
  canChangeTransactionControls: Scalars['Boolean']['output'];
  /** Determine if the user can close the card */
  canClose: Scalars['Boolean']['output'];
  /** Indicates whether payment distribution is allowed for this credit card. This field calls the PaymentDistributions API to determine the validity of the card. Use this as a last validation before a payment distribution process is started. Do not use this field to control visibility of payment distribution features in the UI, instead use the `isDistributable` field. */
  canDistributePayments: Maybe<Scalars['Boolean']['output']>;
  canGetPin: Scalars['Boolean']['output'];
  /** Determines if a user can see full un-masked cardnumber and cvv. */
  canSeePrivateInfo: Scalars['Boolean']['output'];
  /** If true then user has the authority to freeze/unfreeze the card */
  canToggleFrozenStatus: Scalars['Boolean']['output'];
  cardActivityStatus: CardActivityStatus;
  /** Email used for contacting card holder */
  cardHolderEmail: Scalars['String']['output'];
  cardHolderKennitala: Scalars['String']['output'];
  /** Mobile used for contacting card holder */
  cardHolderMobile: Scalars['String']['output'];
  cardHolderName: Scalars['String']['output'];
  cardId: Scalars['Int']['output'];
  cardNumberFormatted: Scalars['String']['output'];
  cardNumberMasked: Scalars['String']['output'];
  cardOwnerKennitala: Scalars['String']['output'];
  /** The card owners name */
  cardOwnerName: Maybe<Scalars['String']['output']>;
  /** The card saving that is assigned to this Credit Card, or null (if the card doesn't have one) */
  cardSaving: Maybe<CardSaving>;
  /** Absolute value of the cards credit balance (inneign) */
  creditBalance: Scalars['Float']['output'];
  /** The minimum and maximum limits for credit card */
  creditCardLineOptions: Maybe<CreditCardLineOptions>;
  /**
   * The minimum and maximum limits for credit card (corporate only)
   * @deprecated Only works for corporate cards. Use creditCardLineOptions for personal and corporate cards.
   */
  creditCardLineRanges: Maybe<CreditCardLineRanges>;
  /** @deprecated Do not use. creditLimit and creditLine were being confused here. */
  creditLimit: Scalars['Float']['output'];
  creditLine: Scalars['Float']['output'];
  customName: Scalars['String']['output'];
  /** @deprecated Use totalDebt and creditBalance for correct absolute numbers */
  debt: Scalars['Float']['output'];
  depositAllowed: Scalars['Boolean']['output'];
  /** Notify if a deposit is made to the card */
  depositNotification: Maybe<CreditCardNotificationEvent>;
  dueDate: Maybe<Scalars['DateTimeISO']['output']>;
  expirationDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCompanyCard: Scalars['Boolean']['output'];
  /** If true, then payment distribution is allowed for this card. This field is determined by the API (checked in Cards/V1, 2025-10-20) by the following criteria: The calling user is the card owner and not a company user, the card is not pre-paid and the card is not a company card. It is safe to use this field for controlling visibility of payment distribution features in the UI. */
  isDistributable: Scalars['Boolean']['output'];
  isFrozen: Scalars['Boolean']['output'];
  /** Indicates if the card is in Click to Pay */
  isInClickToPay: Scalars['Boolean']['output'];
  isPhysical: Scalars['Boolean']['output'];
  isPrePaid: Scalars['Boolean']['output'];
  latestInvoice: Maybe<CreditCardInvoice>;
  /** Get this credit card’s transactions from the past 2 years, sorted from newest to oldest. */
  latestTransactions: LatestCreditCardTransactionConnection;
  loyaltyType: CreditCardLoyalty;
  /** Only empty when isPrePaid is true */
  nextDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /**
   * List of all notification options
   * @deprecated Use notificationOptionsV2 instead. Since: 2026-04-10. Issue(s) to remove it: WEB-41546
   */
  notificationOptions: Maybe<Array<CreditCardNotificationOption>>;
  /** List of all notification options */
  notificationOptionsV2: Maybe<Array<CardNotificationOption>>;
  /** Pan ID is used for registering card with mobile wallet products. */
  panId: Maybe<Scalars['String']['output']>;
  /** Constants for payment distribution */
  paymentDistributionInformation: PaymentDistributionInformation;
  paymentDistributions: PaymentDistributionConnection;
  pin: PinStepUpUnion;
  pinV2: CardPinResultV2;
  privateInfo: CardPrivateInfoResponse;
  privateInfoV2: CardPrivateInfoResultV2;
  /** The credit card product that this card is based on */
  product: Maybe<CreditCardProduct>;
  /** Proxy accesses the current user has provided to others for this card */
  proxyAccesses: Maybe<ProxyAccessesForProduct>;
  /** Notify if purchases made with amount higher then threshold amount */
  purchasesOverThresholdNotification: Maybe<CreditCardNotificationEventWithThreshold>;
  referenceNumber: Maybe<Scalars['String']['output']>;
  showInSummary: Scalars['Boolean']['output'];
  showOnFrontpage: Scalars['Boolean']['output'];
  /** Notify if overdraft usage is above the given threshold percentage (0-100) */
  spendOverdraftPercentageNotification: Maybe<CreditCardNotificationEventWithThreshold>;
  status: CardStatus;
  /** The date when the card status was last updated */
  statusChangeDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Absolute value of the cards debt (skuld) */
  totalDebt: Scalars['Float']['output'];
  transactionControls: Maybe<Array<CardTransactionControl>>;
  transactions: CreditCardTransactionConnection;
  type: CreditCardType;
  typeName: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  /** Notify if a withdrawal is made without the physical card */
  withdrawalWithoutCardNotification: Maybe<CreditCardNotificationEvent>;
};


/** credit cards */
export type CreditCardAvailableProductsArgs = {
  cardCategory?: InputMaybe<CreditCardCategory>;
};


/** credit cards */
export type CreditCardCalculatePaymentDistributionArgs = {
  data: CalculatePaymentDistributionInput;
};


/** credit cards */
export type CreditCardLatestTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreditCardTransactionsOrderBy>;
};


/** credit cards */
export type CreditCardPaymentDistributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PaymentDistributionSearchType>;
};


/** credit cards */
export type CreditCardTransactionControlsArgs = {
  filterAndOrderBy?: InputMaybe<Array<CardTransactionControlType>>;
};


/** credit cards */
export type CreditCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreditCardTransactionsOrderBy>;
  period?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardApplication = {
  __typename: 'CreditCardApplication';
  accountNumber: Maybe<Scalars['String']['output']>;
  address: Maybe<DeliveryAddress>;
  applicationStatus: CreditCardApplicationStatus;
  cardHolder: Scalars['String']['output'];
  cardHolderName: Scalars['String']['output'];
  cardId: Scalars['Int']['output'];
  catalogId: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  creditLine: Scalars['Float']['output'];
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maskedCardNumber: Scalars['String']['output'];
  mobilePhone: Maybe<Scalars['String']['output']>;
  /** Pan ID is used for registering card with mobile wallet products. */
  panId: Maybe<Scalars['String']['output']>;
  primaryNumberSuffix: Maybe<Scalars['String']['output']>;
  typeCode: Maybe<Scalars['String']['output']>;
  typeCodeName: Maybe<Scalars['String']['output']>;
};

export type CreditCardApplicationAudit = {
  applicationName: Scalars['String']['input'];
  loginDevice?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardApplicationDocumentResult = CardHolderMustBeAPerson | CipMissing | CreateCreditCardProductApplicationDocumentPayload | CustomerTooYoung | InvalidCountryId | LoanApplicationNotApproved | RequestedCreditLineError | ScannedCertificateMissing | SelfServiceProhibited;

export type CreditCardApplicationFamilyMember = {
  __typename: 'CreditCardApplicationFamilyMember';
  /** Kennitala (Icelandic national identification number) of the family member */
  kennitala: Scalars['String']['output'];
  /** Full name of the family member */
  name: Scalars['String']['output'];
  /** Family member relation type (i.e. Spouse, Sibling, Child) */
  type: CreditCardApplicationFamilyMemberType;
};

export enum CreditCardApplicationFamilyMemberType {
  Child = 'Child',
  Custodian = 'Custodian',
  Sibling = 'Sibling',
  Spouse = 'Spouse'
}

export type CreditCardApplicationFamilyMembersFilterArgs = {
  type: CreditCardApplicationFamilyMemberType;
};

export type CreditCardApplicationInput = {
  /** Skuldfærslureikningur */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<AddressInput>;
  audit?: InputMaybe<CreditCardApplicationAudit>;
  /** Kennitala handhafa. */
  cardHolder: Scalars['String']['input'];
  catalogId: Scalars['Float']['input'];
  /** Id á umsókn um kreditkort skjali. Aðeins fyrir Corporate eða Vasapeninga kort */
  contractId?: InputMaybe<Scalars['String']['input']>;
  creditLine: Scalars['Float']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCardApplicationPayload = {
  __typename: 'CreditCardApplicationPayload';
  application: CreditCardApplication;
};

export enum CreditCardApplicationStatus {
  Approved = 'Approved',
  Cancelled = 'Cancelled',
  CardCreationError = 'CardCreationError',
  Declined = 'Declined',
  New = 'New',
  SentToApproval = 'SentToApproval',
  Unknown = 'Unknown'
}

/** Credit card lookup response */
export type CreditCardBalance = {
  __typename: 'CreditCardBalance';
  availableBalance: Scalars['Float']['output'];
};

export type CreditCardBalanceNotFound = Error & {
  __typename: 'CreditCardBalanceNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum CreditCardCategory {
  /** Krakkakort */
  Child = 'Child',
  /** Venjulegt */
  Credit = 'Credit',
  /** Fyrirframgreitt */
  Prepaid = 'Prepaid'
}

export type CreditCardConnection = {
  __typename: 'CreditCardConnection';
  edges: Array<CreditCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CreditCardConnectionUnion = CreditCardConnection | CreditCardServiceUnavailable;

/** Delivery location for plastic credit card */
export type CreditCardDeliveryAddress = {
  __typename: 'CreditCardDeliveryAddress';
  /** Unique identifier for a delivery address */
  addressId: Scalars['String']['output'];
  /** Street name and number */
  addressLine: Maybe<Scalars['String']['output']>;
  /** Type of the address: Customer address or branch */
  addressType: CreditCardDeliveryAddressType;
  /** Branch Location Id. If addressType is CustomerAddress the value will be null */
  branchId: Maybe<Scalars['String']['output']>;
  /** Municipality */
  city: Maybe<Scalars['String']['output']>;
  /** Name of country of customers address country. Will be null if `addressType is BRANCH */
  country: Maybe<Scalars['String']['output']>;
  /** Country code of customers address country. Will be null if `addressType is BRANCH */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Id of customers address country. Will be null if `addressType is BRANCH` */
  countryId: Maybe<Scalars['String']['output']>;
  /** If this address is of type CustomerAddress this is the name of the customer. If the address is of type Branch this is the name of the branch. */
  name: Scalars['String']['output'];
  /** Opening hours of a branch. If addressType is CustomerAddress the value will be null */
  openingHours: Maybe<Scalars['String']['output']>;
  /** Regional post code as issued by The Electronic Communications Office of Iceland */
  postalCode: Maybe<Scalars['String']['output']>;
};

export enum CreditCardDeliveryAddressType {
  /** Landsbankinn branch */
  BRANCH = 'BRANCH',
  /** Legal or residential address of a customer */
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS'
}

export type CreditCardEdge = {
  __typename: 'CreditCardEdge';
  cursor: Scalars['String']['output'];
  node: CreditCard;
};

export type CreditCardFees = {
  __typename: 'CreditCardFees';
  /** Fee for direct payment on card invoices */
  directPaymentFee: Fee;
  id: Scalars['ID']['output'];
  /** Fee for manual payment on card invoices */
  manualPaymentFee: Fee;
  /** Fee for a new plastic card to replace a stolen or lost card */
  replacementCardFee: Fee;
  /** Fee for SMS monitoring */
  smsMonitoringFee: Fee;
};

export type CreditCardFilterArgs = {
  cardOwnerKennitala?: InputMaybe<Scalars['String']['input']>;
  creditCardsForSavings?: InputMaybe<Scalars['Boolean']['input']>;
  depositAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isCardHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Searches cards by partial text. Supports card holder, card number and card type name. Case in-sensitive. */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CreditCardSearchType>;
};

/** Credit card invoice */
export type CreditCardInvoice = {
  __typename: 'CreditCardInvoice';
  amount: Scalars['Float']['output'];
  dueDate: Scalars['DateTimeISO']['output'];
  isPaid: Scalars['Boolean']['output'];
  outstandingAmount: Scalars['Float']['output'];
};

export type CreditCardLimitLoanApplication = LoanApplication & Node & {
  __typename: 'CreditCardLimitLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  creditCard: CreditCardLimitLoanBond;
  /** This field is currently used for corporate overdraft only. It indicates whether the current user can use surety bonds and if risk rating is missing. For freelance users this will always return SURETY_BOND_NOT_ALLOWED. */
  creditScoreRiskRatingResult: Maybe<CreditScoreRiskRatingResultType>;
  /** This field is currently used for corporate overdraft only. It indicates whether the requested amount for the overdraft loan application can be covered (insured) by existing collaterals. Currently, only truthful if there exists an "allsherjarveð í fasteign", with an unused value that exceeds the requested loan amount. */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** This field is currently used for corporate overdraft only. It returns surety guarantors (ábyrgðaraðilar) on an overdraft loan application. The list of guarantors is ordered with the main applicant as the first guarantor in the list. */
  guarantors: Maybe<Array<LoanApplicationGuarantor>>;
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. It indicates whether the applications could theoretically be automatically approved, as opposed to explicitly requiring manual approval. A true value does not always result in automatic approval, as there are other factors, but a false value will always result in manual approval. For freelance users this is always false. */
  isWithinPreApprovedAllowedLimits: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  /** This field is currently used for corporate overdraft only. It returns the calculated fee for surety (sjálfskuldarábyrgð) on an overdraft loan application. */
  suretyCollateralFee: Maybe<CurrencyAmount>;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


export type CreditCardLimitLoanApplicationCreditScoreRiskRatingResultArgs = {
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
};


export type CreditCardLimitLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

export type CreditCardLimitLoanBond = {
  __typename: 'CreditCardLimitLoanBond';
  availableBalanceAfter: Scalars['Float']['output'];
  availableBalanceBefore: Scalars['Float']['output'];
  cardId: Scalars['Int']['output'];
  cardNumber: Scalars['String']['output'];
  cardType: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** Lánamörk eftir */
  creditLimitAmountAfter: Maybe<Scalars['Float']['output']>;
  /** Lánamörk fyrir */
  creditLimitAmountBefore: Scalars['Float']['output'];
  /** Heimild eftir */
  creditLineAmountAfter: Scalars['Float']['output'];
  /** Heimild fyrir */
  creditLineAmountBefore: Scalars['Float']['output'];
  expirationDate: Scalars['String']['output'];
  extraCreditLimitAmountBefore: Scalars['Float']['output'];
  extraCreditLineAmountBefore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  loanRequestId: Scalars['Int']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
};

/** Credit cards limit of customer */
export type CreditCardLimits = {
  __typename: 'CreditCardLimits';
  balance: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
  totalAvailableFunds: Scalars['Float']['output'];
  totalCommitment: Scalars['Float']['output'];
};

/** Response for the limits of credit cards */
export type CreditCardLimitsResponse = {
  __typename: 'CreditCardLimitsResponse';
  hasAccess: Scalars['Boolean']['output'];
  limits: Maybe<CreditCardLimits>;
};

export type CreditCardLineChangePreview = {
  __typename: 'CreditCardLineChangePreview';
  /** The available amount with new line */
  availableAmount: Maybe<CurrencyAmount>;
  /** The cost to change to the new line */
  fee: Maybe<CurrencyAmount>;
};

/** Options for changing the credit line of a credit card */
export type CreditCardLineOptions = {
  __typename: 'CreditCardLineOptions';
  customerCreditWorthy: Maybe<Array<CustomerCreditWorthy>>;
  isCustomerCreditWorthy: Scalars['Boolean']['output'];
  maxLimit: CurrencyAmount;
  minLimit: CurrencyAmount;
};

/** The minimum and maximum limits of a credit card */
export type CreditCardLineRanges = {
  __typename: 'CreditCardLineRanges';
  maxLimit: CurrencyAmount;
  minLimit: CurrencyAmount;
};

export enum CreditCardLoyalty {
  /** Aukakronur loyalty program */
  Aukakronur = 'Aukakronur',
  /** No loyalty program */
  None = 'None',
  /** Icelandair loyalty program */
  Vildarpunktar = 'Vildarpunktar'
}

/** Different event types */
export type CreditCardNotificationEvent = {
  __typename: 'CreditCardNotificationEvent';
  type: CreditCardNotificationType;
};

/** Different event types */
export type CreditCardNotificationEventInput = {
  type: CreditCardNotificationType;
};

/** Different event types with a numeric threshold */
export type CreditCardNotificationEventWithThreshold = {
  __typename: 'CreditCardNotificationEventWithThreshold';
  threshold: Scalars['Int']['output'];
  type: CreditCardNotificationType;
};

/** Different event types with a numeric threshold */
export type CreditCardNotificationEventWithThresholdInput = {
  threshold: Scalars['Int']['input'];
  type: CreditCardNotificationType;
};

/** Notification option */
export type CreditCardNotificationOption = {
  __typename: 'CreditCardNotificationOption';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Reason: Allow logic moved from frontend to graphql. Since: 2025-09-22. Removed 2026-03-22. Issue to remove it: WEB-37070 */
  isAllowed: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  /** The title of this notification option */
  name: Scalars['String']['output'];
};

export enum CreditCardNotificationType {
  Both = 'Both',
  Email = 'Email',
  No = 'No',
  Sms = 'Sms'
}

export type CreditCardOrderBy = {
  direction: OrderByDirection;
  field: CreditCardOrderByOption;
};

/** Options for ordering credit cards */
export enum CreditCardOrderByOption {
  /** Order by the available amount on the card (IS: Til ráðstöfunar) */
  AVAILABLE_AMOUNT = 'AVAILABLE_AMOUNT',
  /** Order by card holder name */
  CARD_HOLDER_NAME = 'CARD_HOLDER_NAME',
  /** Order by credit line (IS: Heimild) */
  CREDIT_LINE = 'CREDIT_LINE',
  /** Order by the date when the card status was last changed */
  STATUS_CHANGE_DATE = 'STATUS_CHANGE_DATE',
  /** Order by total debt on the card */
  TOTAL_DEBT = 'TOTAL_DEBT'
}

export enum CreditCardPlasticRequirement {
  ALWAYS = 'ALWAYS',
  NEVER = 'NEVER',
  OPTIONAL = 'OPTIONAL',
  UNKNOWN = 'UNKNOWN'
}

/** Credit card product */
export type CreditCardProduct = Node & Product & {
  __typename: 'CreditCardProduct';
  annualFee: Scalars['Float']['output'];
  annualFeeDescription: Maybe<Scalars['String']['output']>;
  cardType: CreditCardProductType;
  catalogId: Scalars['Int']['output'];
  category: CreditCardCategory;
  creditCardType: CreditCardType;
  description: Maybe<Scalars['String']['output']>;
  /** Segir til um hvort vara krefjist þess að notandi eigi skuldfærslureikning til að geta verið stofnuð */
  directDebitAccountRequired: Scalars['Boolean']['output'];
  /** Indicates whether the credit card comes with a physical card. True if physical card is available, false otherwise. */
  hasPhysicalCard: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Level tryggingar, max 5 */
  insuranceCoverage: Scalars['Int']['output'];
  /** Lýsing á tryggingu */
  insuranceDescription: Maybe<Scalars['String']['output']>;
  insuranceName: Scalars['String']['output'];
  isPrePaid: Scalars['Boolean']['output'];
  /** Vildarpunktar, Aukakrónur vs None */
  loyaltyType: CreditCardLoyalty;
  /** Hversu mörgum punktum safnað */
  loyaltyValue: Scalars['Int']['output'];
  /** Opinbert vöruheiti kortsins */
  marketingName: Scalars['String']['output'];
  maxCreditLine: Scalars['Float']['output'];
  minCreditLine: Scalars['Float']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Describes the plastic requirement (physical card) for the credit card */
  plasticRequirement: CreditCardPlasticRequirement;
  type: ProductType;
  /** Týpukóði vöru */
  typeCode: Scalars['String']['output'];
  /** Nafn kortsins */
  typeCodeName: Scalars['String']['output'];
};

export type CreditCardProductApplicationDocument = {
  __typename: 'CreditCardProductApplicationDocument';
  documentPdf: Scalars['String']['output'];
};

export type CreditCardProductApplicationDocumentDataInput = {
  /** Skuldfærslureikningur */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  cardType: Scalars['String']['input'];
  /** Póstfang korthafa eða foreldris í tilfelli Vasapeninga. Notað til að fá staðfestingu á færslum vegna kortaviðskipta á netinu og við uppsetningu korts í farsíma og aðrar snjallgreiðslulausnir. */
  cardholderEmail?: InputMaybe<Scalars['String']['input']>;
  /** Kennitala handhafa */
  cardholderId: Scalars['String']['input'];
  /** Símanúmer korthafa eða foreldris í tilfelli Vasapeninga. Notað til að fá staðfestingu á færslum vegna kortaviðskipta á netinu og við uppsetningu korts í farsíma og aðrar snjallgreiðslulausnir. */
  cardholderTelephone?: InputMaybe<Scalars['String']['input']>;
  creditLimit: Scalars['Float']['input'];
};

export type CreditCardProductApplicationDocumentInput = {
  storedContract: CreditCardProductApplicationDocumentDataInput;
};

export enum CreditCardProductType {
  /** Vasapeningar / Klinkkort / Krakkakort | PK */
  Allowance = 'Allowance',
  /** Viðskiptagull | V */
  BusinessGold = 'BusinessGold',
  /** Viðskipta Platinum | P */
  BusinessPlatinum = 'BusinessPlatinum',
  /** Premium Vildarviðskiptakort | PV */
  BusinessPremium = 'BusinessPremium',
  /** Almennt viðskiptakort | S */
  BusinessRegular = 'BusinessRegular',
  /** Innkaupakort Stafrænt | I2 */
  DigitalPurchase = 'DigitalPurchase',
  /** Gjafakort | HG */
  Gift = 'Gift',
  /** Gullkort | G */
  Gold = 'Gold',
  /** Kortlaust kort | K */
  NoPlastic = 'NoPlastic',
  /** Platinum | E */
  Platinum = 'Platinum',
  /** Plús kort plús | PL */
  PlusCardPlus = 'PlusCardPlus',
  /** Premium Vildarkort | PP */
  Premium = 'Premium',
  /** Innkaupakort | I */
  Purchase = 'Purchase',
  /** Almennt A-kort | A */
  Regular = 'Regular',
  /** Almennt A-kort fyrirframgreitt | P2 */
  RegularPrepaid = 'RegularPrepaid',
  /** Námu A-kort | NL */
  Student = 'Student',
  /** Námu A-kort fyrirframgreitt | PN */
  StudentPrepaid = 'StudentPrepaid',
  /** Unknown */
  Unknown = 'Unknown'
}

export enum CreditCardSearchType {
  Credit = 'Credit',
  PrePaid = 'PrePaid'
}

export type CreditCardServiceUnavailable = Error & {
  __typename: 'CreditCardServiceUnavailable';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CreditCardTransaction = Node & {
  __typename: 'CreditCardTransaction';
  amountV2: CurrencyAmount;
  authorizationNumber: Maybe<Scalars['String']['output']>;
  /** Indicates if the transaction can have attachments */
  canHaveAttachments: Scalars['Boolean']['output'];
  /** Attachments for the transaction */
  cardTransactionAttachments: Maybe<Array<CardTransactionAttachment>>;
  /** Global identifier of the base card transaction. This global Id is of the form CardTransaction:cardId:transactionId. NOTE! This is not the same as the ID field of this object, which is a global ID of the form CreditCardTransaction:cardId:transactionId */
  cardTransactionId: Scalars['ID']['output'];
  categoryCodeDescription: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  /** Comment for the transaction */
  comment: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  currencyRate: Maybe<Scalars['Float']['output']>;
  description: Maybe<Scalars['String']['output']>;
  dueDate: Maybe<Scalars['DateTimeISO']['output']>;
  foreignAmountV2: Maybe<CurrencyAmount>;
  /** Does the transaction have accounting records added to the transaction by an employee (ledgerKey, description, attachments) */
  hasAccountingRecords: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** A ledger key used for bookkeeping purposes. Consists of an identifier and a description */
  ledgerKey: Maybe<CardTransactionsLedgerKey>;
  /** A ledger key group used for bookkeeping purposes. */
  ledgerKeyGroup: Maybe<CardTransactionsLedgerKeyGroupBase>;
  /** A ledger key sub group used for bookkeeping purposes. */
  ledgerKeySubGroup: Maybe<CardTransactionsLedgerKeySubGroupBase>;
  loyalty: Maybe<Loyalty>;
  merchant: Maybe<Scalars['String']['output']>;
  merchantCategoryCode: Maybe<Scalars['String']['output']>;
  merchantReceiptNumber: Maybe<Scalars['String']['output']>;
  purchaseDay: Scalars['DateTimeISO']['output'];
  type: Maybe<CreditCardTransactionType>;
};

export type CreditCardTransactionConnection = {
  __typename: 'CreditCardTransactionConnection';
  dueDate: Scalars['DateTimeISO']['output'];
  edges: Array<CreditCardTransactionEdge>;
  excelDocument: DocumentBucket;
  from: Scalars['DateTimeISO']['output'];
  pageInfo: PageInfo;
  /** only populated when fetching statements for some specific period, example '202604' */
  period: Maybe<Scalars['String']['output']>;
  to: Scalars['DateTimeISO']['output'];
  totalCount: Scalars['Int']['output'];
  totalDepositsAmount: Scalars['Float']['output'];
  totalDomesticWithdrawalAmount: Scalars['Float']['output'];
  totalFeeAmount: Scalars['Float']['output'];
  totalForeignWithdrawalAmount: Scalars['Float']['output'];
  totalWithdrawalAmount: Scalars['Float']['output'];
};

export type CreditCardTransactionEdge = {
  __typename: 'CreditCardTransactionEdge';
  cursor: Scalars['String']['output'];
  node: CreditCardTransaction;
};

export enum CreditCardTransactionType {
  Authorization = 'Authorization',
  ClaimDeposit = 'ClaimDeposit',
  DomesticWithdrawal = 'DomesticWithdrawal',
  Fee = 'Fee',
  ForeignWithdrawal = 'ForeignWithdrawal',
  Interest = 'Interest',
  OtherDeposit = 'OtherDeposit',
  Refund = 'Refund',
  Unknown = 'Unknown'
}

export type CreditCardTransactionsOrderBy = {
  direction: OrderByDirection;
  field: CreditCardTransactionsOrderByOption;
};

export enum CreditCardTransactionsOrderByOption {
  Amount = 'Amount',
  Date = 'Date',
  ForeignAmount = 'ForeignAmount',
  Loyalty = 'Loyalty',
  Rate = 'Rate',
  Seller = 'Seller'
}

export enum CreditCardType {
  Allowance = 'Allowance',
  Aukakronur = 'Aukakronur',
  BusinessGold = 'BusinessGold',
  BusinessPlatinum = 'BusinessPlatinum',
  BusinessPremium = 'BusinessPremium',
  BusinessRegular = 'BusinessRegular',
  DigitalPurchase = 'DigitalPurchase',
  Gift = 'Gift',
  Gold = 'Gold',
  NoPlastic = 'NoPlastic',
  Platinum = 'Platinum',
  /** Currently not in use. Will be mapped in WEB-18193 */
  PlusCard = 'PlusCard',
  /** Currently not in use. Will be mapped in WEB-18193 */
  PlusCardPlus = 'PlusCardPlus',
  Premium = 'Premium',
  Purchase = 'Purchase',
  Regular = 'Regular',
  /** @deprecated 'RegularPrepaid' has been renamed to 'Plúskort plús'. Since: [2023-09-18]. Removed: [????-??-??]. Issue(s) to remove it: WEB-18168 */
  RegularPrepaid = 'RegularPrepaid',
  Student = 'Student',
  /** @deprecated 'StudentPrepaid' has been renamed to 'Plúskort plús'. Since: [2023-09-18]. Removed: [????-??-??]. Issue(s) to remove it: WEB-18168 */
  StudentPrepaid = 'StudentPrepaid',
  Unknown = 'Unknown'
}

/** Credit cards widget */
export type CreditCardsWidget = {
  __typename: 'CreditCardsWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  /** Whether the widget has any cards to display */
  hasCards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

/** CreditInfo - LoanType */
export enum CreditInfoLoanTypeEnum {
  /** Skuldabréf | Bond */
  BOND = 'BOND',
  /** Innheimtuskuldabréf | Collection bond */
  COLLECTION_BOND = 'COLLECTION_BOND',
  /** Kreditkort | Credit card */
  CREDIT_CARD = 'CREDIT_CARD',
  /** Erlentlán | Foreign loan */
  FOREIGN_LOAN = 'FOREIGN_LOAN',
  /** Lánasamningur erlendur | Foreign loan agreement */
  FOREIGN_LOAN_AGREEMENT = 'FOREIGN_LOAN_AGREEMENT',
  /** Yfirdráttarlán erlent | Foreign overdraft */
  FOREIGN_OVERDRAFT = 'FOREIGN_OVERDRAFT',
  /** Ábyrgðir | Guarantees */
  GUARANTEES = 'GUARANTEES',
  /** Fjölgreiðslur | Installments */
  INSTALLMENTS = 'INSTALLMENTS',
  /** Víxill | Invoice */
  INVOICE = 'INVOICE',
  /** Lánasamningur | Loan agreement */
  LOAN_AGREEMENT = 'LOAN_AGREEMENT',
  /** Rekstrarleigusamningur | Operating lease agreement */
  OPERATING_LEASE_AGREEMENT = 'OPERATING_LEASE_AGREEMENT',
  /** Annað | Other */
  OTHER = 'OTHER',
  /** Yfirdráttarlán | Overdraft */
  OVERDRAFT = 'OVERDRAFT',
  /** Eignaleigusamningur | Property lease agreement */
  PROPERTY_LEASE_AGREEMENT = 'PROPERTY_LEASE_AGREEMENT',
  /** New items from the API that are not mapped yet */
  UNKNOWN = 'UNKNOWN',
  /** Bílalán | Vehicle loan */
  VEHICLE_LOAN = 'VEHICLE_LOAN'
}

/** Calculated credit score for a customer */
export type CreditScore = {
  __typename: 'CreditScore';
  hasValidRiskRating: Scalars['Boolean']['output'];
  riskRating: Maybe<Scalars['Float']['output']>;
};

/** Result of a checking credit score risk rating (based on "lánshæfiseinkunn") */
export enum CreditScoreRiskRatingResultType {
  /** No risk rating present. To resolve this, we must fetch the risk rating to CreditInfo (with the user's permission) */
  MISSING_RISK_RATING = 'MISSING_RISK_RATING',
  /** Can use / select surety bond (sjálfskuldarábyrgð) */
  SURETY_BOND_ALLOWED = 'SURETY_BOND_ALLOWED',
  /** Cannot use / select surety bond (sjálfskuldarábyrgð) */
  SURETY_BOND_NOT_ALLOWED = 'SURETY_BOND_NOT_ALLOWED'
}

/** Millifærsla */
export type CreditTransfer = Node & PaymentInterface & {
  __typename: 'CreditTransfer';
  /** Category for the payment */
  categoryCode: Maybe<Scalars['String']['output']>;
  creditorAccount: CreditorAccountType;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  /** Payment exchange rate info */
  exchangeRate: Maybe<PaymentExchangeRate>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  /** End to end identification */
  reference: Maybe<Scalars['String']['output']>;
  status: Maybe<PaymentStatus>;
  type: PaymentType;
  /** Ultimate creditor information */
  ultimateCreditor: Maybe<UltimateParty>;
  /** Ultimate debtor information */
  ultimateDebtor: Maybe<UltimateParty>;
};

export type CreditTransferInitialPaymentData = Node & PaymentInterface & {
  __typename: 'CreditTransferInitialPaymentData';
  creditorAccount: CreditorAccountType;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  reference: Maybe<Scalars['String']['output']>;
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export enum CreditWorthyType {
  BadCrmComments = 'BadCrmComments',
  CriticalRiskRating = 'CriticalRiskRating',
  DefaultMonitoringMarkings = 'DefaultMonitoringMarkings',
  HasIcelandicLegalAddress = 'HasIcelandicLegalAddress',
  HasSignedKyc = 'HasSignedKyc',
  IsGreen = 'IsGreen',
  LowRiskRating = 'LowRiskRating',
  MinimunAge = 'MinimunAge',
  NewResident = 'NewResident',
  ScanedCertified = 'ScanedCertified'
}

export type CreditorAccountType = {
  __typename: 'CreditorAccountType';
  accountNumber: Maybe<Scalars['String']['output']>;
  kennitala: Maybe<Scalars['String']['output']>;
  ownerName: Maybe<Scalars['String']['output']>;
};

export type CrmCasePayload = {
  __typename: 'CrmCasePayload';
  success: Scalars['Boolean']['output'];
};

export type CrmCaseResult = CrmCasePayload | KennitalaNotFoundError | KennitalaNotPersonError;

/** Who pays the credit transfer cost */
export enum CrossBorderChargeBearer {
  /** Debtor pays all the cost */
  Debtor = 'Debtor',
  /** Cost is shared between both debtor and creditor */
  Shared = 'Shared'
}

/** CrossBorder millifærsla */
export type CrossBorderCreditTransfer = InternationalPaymentInterface & Node & {
  __typename: 'CrossBorderCreditTransfer';
  /** Central bank category of the payment. */
  centralBankCategory: Maybe<CentralBankCategoryCode>;
  /** Three letter code that identifies the category of the payment. Use centralBankCategory for more details. */
  centralBankCategoryCode: Scalars['String']['output'];
  chargeBearer: Maybe<CrossBorderChargeBearer>;
  debitedAmount: CurrencyAmount;
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for the payment */
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  exchangeRate: Maybe<Scalars['Float']['output']>;
  /** Payment Exchange Rate information */
  exchangeRateInfo: Maybe<PaymentExchangeRate>;
  fees: Array<InternationalPaymentFee>;
  feesTotal: CurrencyAmount;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  isExpress: Scalars['Boolean']['output'];
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  /** ID (internal) of the payment */
  paymentId: Maybe<Scalars['ID']['output']>;
  /** Previously used notification recipients for similar payments */
  paymentNotificationRecipients: Maybe<Array<Scalars['String']['output']>>;
  paymentStatus: PaymentStatus;
  /** Receipt for the payment */
  receipt: Maybe<DocumentBucket>;
  recipient: Maybe<SwiftRecipient>;
  recipientName: Scalars['String']['output'];
  /** Total service cost amount with a currency code */
  totalCost: CurrencyAmount;
  /** Total amount of the transfer amount + the service cost with a currency code */
  totalDebitedAmount: CurrencyAmount;
  type: PaymentType;
};

export type CrossBorderCreditTransferBankInput = {
  address: InternationalPaymentAddressInput;
  bankIdentifer: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CrossBorderCreditTransferRecipientInput = {
  /** IBAN/BBAN */
  accountIdentifier: Scalars['String']['input'];
  address: InternationalPaymentAddressInput;
  bankInfo: CrossBorderCreditTransferBankInput;
  name: Scalars['String']['input'];
};

/** CrossBorder transfer allowed currencies */
export type CrossBorderCurrencies = {
  __typename: 'CrossBorderCurrencies';
  currencies: Array<Scalars['String']['output']>;
  rates: Array<ExchangeRate>;
};

export enum CrossBorderPaymentMethod {
  FEDWIRE = 'FEDWIRE',
  IBAN = 'IBAN',
  SWIFT = 'SWIFT'
}

/** Selected Culture for user */
export enum Culture {
  En = 'En',
  Is = 'Is',
  Pl = 'Pl'
}

/** Cumulative returns calculated over various periods */
export type CumulativeReturns = {
  __typename: 'CumulativeReturns';
  fifteenYearReturn: Maybe<Scalars['Float']['output']>;
  fiveYearReturn: Maybe<Scalars['Float']['output']>;
  fourYearReturn: Maybe<Scalars['Float']['output']>;
  nineMonthReturn: Maybe<Scalars['Float']['output']>;
  oneDayReturn: Maybe<Scalars['Float']['output']>;
  oneMonthReturn: Maybe<Scalars['Float']['output']>;
  oneWeekReturn: Maybe<Scalars['Float']['output']>;
  oneYearReturn: Maybe<Scalars['Float']['output']>;
  sixMonthReturn: Maybe<Scalars['Float']['output']>;
  tenYearReturn: Maybe<Scalars['Float']['output']>;
  threeMonthReturn: Maybe<Scalars['Float']['output']>;
  threeYearReturn: Maybe<Scalars['Float']['output']>;
  twoMonthReturn: Maybe<Scalars['Float']['output']>;
  twoYearReturn: Maybe<Scalars['Float']['output']>;
  yearToDateReturn: Maybe<Scalars['Float']['output']>;
};

export type CurrencyAmount = {
  __typename: 'CurrencyAmount';
  amount: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
};

export type CurrencyAmountInput = {
  amount: Scalars['Float']['input'];
  currencyCode: Scalars['String']['input'];
};

export type CurrencyExchangeLimitsExceeded = Error & {
  __typename: 'CurrencyExchangeLimitsExceeded';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CurrencyExchangeMarketClosed = Error & {
  __typename: 'CurrencyExchangeMarketClosed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CurrencyExchangeMarketOpeningTime = {
  __typename: 'CurrencyExchangeMarketOpeningTime';
  closingReason: Maybe<Scalars['String']['output']>;
  isOpen: Scalars['Boolean']['output'];
  isTodayABankDay: Scalars['Boolean']['output'];
  openFrom: Scalars['String']['output'];
  openTo: Scalars['String']['output'];
};

export type CurrencyQuote = Node & {
  __typename: 'CurrencyQuote';
  exchangeRate: CurrencyQuoteExchangeRate;
  expires: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
};

export type CurrencyQuoteAccount = {
  currencyCode: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
};

export type CurrencyQuoteExchangeRate = {
  __typename: 'CurrencyQuoteExchangeRate';
  ask: Maybe<Scalars['Float']['output']>;
  askWholesaleRate: Maybe<Scalars['Float']['output']>;
  bid: Maybe<Scalars['Float']['output']>;
  bidWholesaleRate: Maybe<Scalars['Float']['output']>;
  capitalGainsTaxRate: Maybe<Scalars['Float']['output']>;
  cross: Maybe<Scalars['Float']['output']>;
  sourceCurrencyCode: Scalars['String']['output'];
  targetCurrencyCode: Scalars['String']['output'];
};

export type CurrencyQuoteResponse = CurrencyExchangeLimitsExceeded | CurrencyExchangeMarketClosed | CurrencyQuote | PaymentAndAccountCurrenciesAreTheSame;

/** Information about an amount that is currently available for withdrawal but will become bound again at a certain date. */
export type CurrentlyAvailableAmount = {
  __typename: 'CurrentlyAvailableAmount';
  /** The amount of money that is available for withdrawal. */
  disposableAmount: CurrencyAmount;
  /** The date when the amount will no longer be available for withdrawal */
  ends: Scalars['DateTimeISO']['output'];
};

export type CustodialAgreement = Node & {
  __typename: 'CustodialAgreement';
  aggrementId: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  /** Id for the digitalSignatureDocument pdf */
  digitalSignatureDocumentId: Scalars['ID']['output'];
  digitalSignatureGroup: Maybe<DigitalSignatureGroup>;
  id: Scalars['ID']['output'];
  recordId: Scalars['String']['output'];
  status: CustodialAgreementStatus;
};

export enum CustodialAgreementStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  InSigning = 'InSigning'
}

/** Custom content for apps */
export type CustomContent = {
  __typename: 'CustomContent';
  /** Actions to render. Supports 0 to 2 actions. Will be rendered in a row at the bottom of the hero image. */
  actions: Maybe<Array<CustomContentAction>>;
  /** The contents of the content. Supports blocks and within the blocks can be headings, paragraphs and bullets. */
  blocks: Array<CustomContentBlock>;
  /** The id of the custom content. */
  id: Scalars['String']['output'];
};

/** Action includes information to render a button or anchor in the marketing content. This works same as action in RecommendationBanner. */
export type CustomContentAction = {
  __typename: 'CustomContentAction';
  /** Further information to perform the action of the button. This depends on what action type is used. For example if action type is OPEN_BOOK_INSURANCE_CONSULTATION the query could be like "type=LIFE". Further information about what query strings are supported and/or requires can be found in the documentation for CustomerRecommendationBannerAction. */
  query: Maybe<Scalars['String']['output']>;
  /** The text to display in the button. */
  text: Scalars['String']['output'];
  /** The type of action to perform when user clicks the button. */
  type: CustomerRecommendationBannerAction;
  /** The color variant of the rendered button. */
  variant: CustomContentActionVariant;
};

/** Variant of CustomContent action. */
export enum CustomContentActionVariant {
  /** In light mode will render blue button with white text. */
  PRIMARY = 'PRIMARY',
  /** In light mode will render white button with blue border and text. */
  SECONDARY = 'SECONDARY',
  /** In light mode will render orange button with white text. */
  TERTIARY = 'TERTIARY'
}

export type CustomContentBlock = ContentBlock | ImageBlock;

/** An image asset for custom content. Comes with 3 versions: 1x, 2x, 3x. The reason why is because higher resolution displays demand images with more pixels. This object contains url's to three different resolution for different pixel dense screens. The url's point to either jpg or webp files, depends on the client version asking for it. */
export type CustomContentImageAsset = {
  __typename: 'CustomContentImageAsset';
  /** A blur hash for the header image. */
  blurHash: Scalars['String']['output'];
  /** Scale factor 1. */
  oneX: Scalars['String']['output'];
  /** Scale factor 3. */
  threeX: Scalars['String']['output'];
  /** Scale factor 2. */
  twoX: Scalars['String']['output'];
};

export type Customer = Node & {
  __typename: 'Customer';
  /** Age as in how many birthdays has this customer had */
  age: Maybe<Scalars['Int']['output']>;
  /** What will this customers age be by the end of the year. */
  ageByYear: Maybe<Scalars['Int']['output']>;
  birthplace: Maybe<CustomerLocation>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  /** The legal address of the customer (lögheimili) */
  legalAddress: Address;
  name: Scalars['String']['output'];
  nationality: Maybe<CustomerLocation>;
  /** The residential address of the customer (aðsetur) */
  residentialAddress: Maybe<CustomerInfoCivicAddress>;
  spouse: Maybe<Spouse>;
};

export type CustomerCompanyInfo = {
  __typename: 'CustomerCompanyInfo';
  branch: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
  withdrawalLimits: Array<CompanyWithdrawalLimit>;
};

export type CustomerConversation = Node & {
  __typename: 'CustomerConversation';
  /** Timestamp of when the conversation was created. */
  created: Scalars['DateTimeISO']['output'];
  /** Is true if conversation has unread messages. */
  hasUnreadMessages: Scalars['Boolean']['output'];
  /** Is true when human agent is typing. */
  humanIsTyping: Scalars['Boolean']['output'];
  /** Id of the conversation. Constructed from `chatId`. */
  id: Scalars['ID']['output'];
  /** Timestamp of when the conversation was last modified. */
  lastModified: Scalars['DateTimeISO']['output'];
  /** Text content of the last response of the conversation. */
  lastResponse: Scalars['String']['output'];
  /** Source of the last response. */
  lastResponseSource: ConversationResponseSource;
  /** The character limit for responses as of 2024-12-09. When interacting with a customer representative, the user can respond with up to 500 characters. When communicating with AI, the limit is 110 characters. The default limit is 110. */
  maxInputChars: Scalars['Int']['output'];
  /** Timestamp of when the conversation was read. */
  read: Scalars['DateTimeISO']['output'];
  /** The responses of this conversation. */
  responses: Array<ConversationResponse>;
  /** Status of the conversation. */
  status: ConversationStatus;
  /** Subject of the conversation. */
  subject: Maybe<Scalars['String']['output']>;
};

export type CustomerConversationEdge = {
  __typename: 'CustomerConversationEdge';
  cursor: Scalars['String']['output'];
  node: CustomerConversation;
};

/** CustomerCreditWorthy */
export type CustomerCreditWorthy = {
  __typename: 'CustomerCreditWorthy';
  creditWorthyType: CreditWorthyType;
  description: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
};

export type CustomerDoesNotHaveAccessCardTransactionsLedgerKeyGroupsError = Error & {
  __typename: 'CustomerDoesNotHaveAccessCardTransactionsLedgerKeyGroupsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CustomerDoesNotHaveAccessCardTransactionsLedgerKeySubGroupsError = Error & {
  __typename: 'CustomerDoesNotHaveAccessCardTransactionsLedgerKeySubGroupsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CustomerDoesNotHaveAccessCardTransactionsLedgerKeysError = Error & {
  __typename: 'CustomerDoesNotHaveAccessCardTransactionsLedgerKeysError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** CustomerFeedback / Customer Effort Score (CES) - Contains information whether the user needs to complete a review after performing an action. */
export type CustomerFeedback = {
  __typename: 'CustomerFeedback';
  /** Yields true if the user should be prompted to answer feedback after completing a specified process */
  shouldCollectFeedback: Scalars['Boolean']['output'];
};

/** Returns either success true and no error or success false and an error from CustomerFeedbackResponseErrorUnion */
export type CustomerFeedbackResponse = {
  __typename: 'CustomerFeedbackResponse';
  error: Maybe<CustomerFeedbackResponseErrorUnion>;
  /** Did submitting the feedback work? */
  success: Scalars['Boolean']['output'];
};

export type CustomerFeedbackResponseErrorUnion = CustomerFeedbackTypeUnknownError | UnknownError;

export enum CustomerFeedbackType {
  APPLY_FOR_CREDITCARD = 'APPLY_FOR_CREDITCARD',
  CREATE_AUKALAN = 'CREATE_AUKALAN',
  CREATE_CLAIM = 'CREATE_CLAIM',
  CREATE_CREDITCARD_PAYMENT_DISTRIBUTION = 'CREATE_CREDITCARD_PAYMENT_DISTRIBUTION',
  CREATE_OVERDRAFT = 'CREATE_OVERDRAFT',
  CREATE_SAVINGS = 'CREATE_SAVINGS',
  ONBOARDING_CLAIM_COLLECTION = 'ONBOARDING_CLAIM_COLLECTION',
  ONBOARDING_MARKETING = 'ONBOARDING_MARKETING',
  SUBSCRIBE_TO_FUND = 'SUBSCRIBE_TO_FUND',
  TRADE_FUND = 'TRADE_FUND',
  TRADE_STOCK = 'TRADE_STOCK',
  TRANSFER_FOREIGN = 'TRANSFER_FOREIGN'
}

/** Unable to map customer feedback type to api enum value. This could be caused by a normal user trying to give feedback to a corporate action type. */
export type CustomerFeedbackTypeUnknownError = Error & {
  __typename: 'CustomerFeedbackTypeUnknownError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** User's notifications and messages */
export type CustomerInbox = {
  __typename: 'CustomerInbox';
  id: Scalars['ID']['output'];
  /** Fetches all the messages that the user has for the inbox. Returns the values sorted by created date, newest values first. */
  messages: InboxMessageConnection;
  /** The banner node is affected by the location argument. The other properties are not affected by the location argument. */
  notifications: CustomerNotification;
};


/** User's notifications and messages */
export type CustomerInboxMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** User's notifications and messages */
export type CustomerInboxNotificationsArgs = {
  notificationBannerLocation: CustomerNotificationBannerLocationType;
};

/** The actions that the banner and the inbox message detail can do and the button/s on the message detail page. */
export enum CustomerInboxAndNotificationBannerAction {
  /** Clicking the banner or button with this action should open the gift voucher dialog for the gift whose id is given as `giftId` in the action query and activate it. */
  ACTIVATE_GIFT = 'ACTIVATE_GIFT',
  /** Clicking the banner or the button/s on the message detail page with this action should send to the savings page that will open the accept shared saving view application for the user. */
  GO_TO_ACCEPT_SHARED_SAVING_VIEW_PAGE = 'GO_TO_ACCEPT_SHARED_SAVING_VIEW_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the aukakronur page. */
  GO_TO_AUKAKRONUR_PAGE = 'GO_TO_AUKAKRONUR_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the cards monitoring page. */
  GO_TO_CARDS_MONITORING_PAGE = 'GO_TO_CARDS_MONITORING_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the chat page. */
  GO_TO_CHAT_PAGE = 'GO_TO_CHAT_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the claim collection overview page. */
  GO_TO_CLAIM_COLLECTION_OVERVIEW_PAGE = 'GO_TO_CLAIM_COLLECTION_OVERVIEW_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the claim expenses distribution page. */
  GO_TO_CLAIM_EXPENSES_DISTRIBUTION = 'GO_TO_CLAIM_EXPENSES_DISTRIBUTION',
  /** Clicking the banner or the button/s on the message detail page with this action should send the user to the contact information page. */
  GO_TO_CONTACT_INFORMATION_PAGE = 'GO_TO_CONTACT_INFORMATION_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the electronic documents page. */
  GO_TO_ELECTRONIC_DOCUMENTS = 'GO_TO_ELECTRONIC_DOCUMENTS',
  /** Clicking the banner or the button/s on the message detail page with this action should send the user to an external url. */
  GO_TO_EXTERNAL_URL = 'GO_TO_EXTERNAL_URL',
  /** Clicking the banner or button with this action should navigate to the gift (Gjöf) page. */
  GO_TO_GIFT_PAGE = 'GO_TO_GIFT_PAGE',
  /** Clicking the banner with this action should open the inbox message detail dialog for the user. */
  GO_TO_INBOX_MESSAGE = 'GO_TO_INBOX_MESSAGE',
  /** Clicking button with this action should navigate to insurance overview. */
  GO_TO_INSURANCE_PAGE = 'GO_TO_INSURANCE_PAGE',
  /** Clicking button with this action should navigate to loyalty page. */
  GO_TO_LOYALTY_PAGE = 'GO_TO_LOYALTY_PAGE',
  /** Clicking button with this action should navigate to loyalty page points dialog. */
  GO_TO_LOYALTY_PAGE_POINT_STEPS = 'GO_TO_LOYALTY_PAGE_POINT_STEPS',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the markets funds. If actionQuery is defined with symbol then we will go to that specific fund detail page, else we will go to funds overview tab. */
  GO_TO_MARKETS_FUNDS_PAGE = 'GO_TO_MARKETS_FUNDS_PAGE',
  /** Clicking the banner with this action should open the settings monitoring page for the user. */
  GO_TO_MONITORING_PAGE = 'GO_TO_MONITORING_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the mandatory pension page. */
  GO_TO_PENSION_MANDATORY_PAGE = 'GO_TO_PENSION_MANDATORY_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the supplementary pension page. */
  GO_TO_PENSION_SUPPLEMENTARY_PAGE = 'GO_TO_PENSION_SUPPLEMENTARY_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the pre approved limit page. */
  GO_TO_PRE_APPROVED_LIMIT_PAGE = 'GO_TO_PRE_APPROVED_LIMIT_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the proxy access page. */
  GO_TO_PROXY_ACCESS_PAGE = 'GO_TO_PROXY_ACCESS_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, sends the user to the savings page. */
  GO_TO_SAVINGS_PAGE = 'GO_TO_SAVINGS_PAGE',
  /** Clicking a banner or a button with this action, sends the user to the settings overview page. */
  GO_TO_SETTINGS_OVERVIEW_PAGE = 'GO_TO_SETTINGS_OVERVIEW_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action should send the user to the sign electronic document page. */
  GO_TO_SIGN_ELECTRONIC_DOCUMENT_PAGE = 'GO_TO_SIGN_ELECTRONIC_DOCUMENT_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the accounts monitoring dialog for the user. */
  OPEN_ACCOUNTS_MONITORING = 'OPEN_ACCOUNTS_MONITORING',
  /** Clicking button with this action should navigate to aukakronur partners page. */
  OPEN_AUKAKRONUR_PARTNERS_PAGE = 'OPEN_AUKAKRONUR_PARTNERS_PAGE',
  /** Clicking the banner or the button/s on the message detail page with this action, opens a aukalan application for the user. */
  OPEN_AUKALAN_APPLICATION = 'OPEN_AUKALAN_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens card application for the user. The actionQuery property should include catalogId for a specific card to open with. If the actionQuery is excluded then it opens the card application for all cards. */
  OPEN_CARD_APPLICATION = 'OPEN_CARD_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the claim monitoring settings dialog for the user. */
  OPEN_CLAIM_MONITORING_SETTINGS = 'OPEN_CLAIM_MONITORING_SETTINGS',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the confirm contact information dialog for the user. */
  OPEN_CONFIRM_CONTACT_INFORMATION = 'OPEN_CONFIRM_CONTACT_INFORMATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the create bank account dialog. */
  OPEN_CREATE_ACCOUNT = 'OPEN_CREATE_ACCOUNT',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the create bank account dialog for the user to create a account for users children. */
  OPEN_CREATE_ACCOUNT_FOR_CHILD = 'OPEN_CREATE_ACCOUNT_FOR_CHILD',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the create bank account dialog for the user. */
  OPEN_CREATE_ACCOUNT_FOR_SELF = 'OPEN_CREATE_ACCOUNT_FOR_SELF',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the create payment distribution for the user. */
  OPEN_CREATE_PAYMENT_DISTRIBUTION = 'OPEN_CREATE_PAYMENT_DISTRIBUTION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens a credit line application for the user. */
  OPEN_CREDIT_LINE_APPLICATION = 'OPEN_CREDIT_LINE_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action should open the kyc application for the user. */
  OPEN_KYC_APPLICATION = 'OPEN_KYC_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the markets monitoring dialog for the user. */
  OPEN_MARKETS_MONITORING = 'OPEN_MARKETS_MONITORING',
  /** Clicking the banner or the button/s on the message detail page with this action, opens a mortgage application for the user. */
  OPEN_MORTGAGE_APPLICATION = 'OPEN_MORTGAGE_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens a new loan application for the user. */
  OPEN_NEW_LOAN_APPLICATION = 'OPEN_NEW_LOAN_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens a overdraft application for the user. */
  OPEN_OVERDRAFT_APPLICATION = 'OPEN_OVERDRAFT_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action should open the refinance mortgage application for the user. */
  OPEN_REFINANCE_MORTGAGE_APPLICATION = 'OPEN_REFINANCE_MORTGAGE_APPLICATION',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the reissue card application for the user. This action supports actionQuery with cardId to open a specific card reissue application. */
  OPEN_REISSUE_CARD = 'OPEN_REISSUE_CARD',
  /** Clicking the banner or the button/s on the message detail page with this action, opens the savings monitoring dialog for the user. */
  OPEN_SAVINGS_MONITORING = 'OPEN_SAVINGS_MONITORING',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The message detail cta/link values. */
export type CustomerInboxDetailMessageAction = {
  __typename: 'CustomerInboxDetailMessageAction';
  /** The actions that the links in the message detail should do. */
  action: CustomerInboxAndNotificationBannerAction;
  /**
   * Some actions need specific data. This property if defined is a parameter query string with that data.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_INBOX_MESSAGE_PAGE should have actionQuery like 'messageId="91"' which we then turn into a graphql id.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_EXTERNAL_URL should have actionQuery like 'externalUrl=https://www.landsbankinn.is/'.
   *   - CustomerInboxAndNotificationBannerAction.OPEN_CARD_APPLICATION should have actionQuery like 'catalogId=5'. If the actionQuery is excluded then it opens the card application for all cards.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_MARKETS_FUNDS_PAGE should have actionQuery like 'symbol=EIGNASJALF'.
   */
  actionQuery: Maybe<Scalars['String']['output']>;
  /** The text that the button should display. */
  text: Scalars['String']['output'];
};

/** The message detail cta button/s. */
export type CustomerInboxDetailMessageCta = {
  __typename: 'CustomerInboxDetailMessageCta';
  /** The primary CTA button. */
  primary: CustomerInboxDetailMessageAction;
  /** The secondary CTA button. */
  secondary: Maybe<CustomerInboxDetailMessageAction>;
};

export type CustomerInboxMessage = Node & {
  __typename: 'CustomerInboxMessage';
  /** The time the message was created. */
  created: Scalars['String']['output'];
  /** The actions that the message detail cta/s should do. Will trigger getByNode API call. */
  cta: Maybe<CustomerInboxDetailMessageCta>;
  /** The id of the message. */
  id: Scalars['ID']['output'];
  /** The actions that the message detail link/s should do. Will trigger getByNode API call. */
  links: Array<CustomerInboxDetailMessageAction>;
  /** The time the message was read. */
  read: Maybe<Scalars['String']['output']>;
  /** The template id of the message. Used for analytics, to see how many times a type of message has been opened. */
  templateId: Maybe<Scalars['String']['output']>;
  /** The text content of the message. Has html formatting. Will trigger getByNode API call. */
  text: Scalars['String']['output'];
  /** The title of the message. */
  title: Scalars['String']['output'];
};

export type CustomerInboxMessageEdge = {
  __typename: 'CustomerInboxMessageEdge';
  cursor: Scalars['String']['output'];
  node: CustomerInboxMessage;
};

/** Civic address of the customer */
export type CustomerInfoCivicAddress = {
  __typename: 'CustomerInfoCivicAddress';
  /** Street address, P.O. box, company name, c/o */
  addressLine1: Scalars['String']['output'];
  /** Apartment, suite, unit, building, floor, etc. */
  addressLine2: Maybe<Scalars['String']['output']>;
  /** The city */
  city: Scalars['String']['output'];
  /** The country */
  country: Scalars['String']['output'];
  /** Country Code, numerical code ("352" for Iceland) */
  countryCode: Maybe<Scalars['String']['output']>;
  /** Country Id, two letter notation ("IS" for Iceland) */
  countryId: Maybe<Scalars['String']['output']>;
  /** True if the address is valid */
  isValid: Maybe<Scalars['Boolean']['output']>;
  /** The postal code */
  postalCode: Scalars['String']['output'];
};

/** Valid location for a customer with Landsbankinn and tax information for that location */
export type CustomerLocation = Node & {
  __typename: 'CustomerLocation';
  code: Maybe<Scalars['String']['output']>;
  countryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  taxIdentificationNumberPattern: Maybe<Scalars['String']['output']>;
};

export type CustomerLocationConnection = {
  __typename: 'CustomerLocationConnection';
  edges: Array<CustomerLocationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerLocationEdge = {
  __typename: 'CustomerLocationEdge';
  cursor: Scalars['String']['output'];
  node: CustomerLocation;
};

/** Customer loyalty information */
export type CustomerLoyalty = {
  __typename: 'CustomerLoyalty';
  /** Get current, claimable and upcoming loyalty benefits for current user */
  benefits: Maybe<CustomerLoyaltyBenefits>;
  /** The loyalty data processing (benefits) consent for the customer */
  benefitsConsent: Maybe<CustomerLoyaltyConsent>;
  /** Get customer loyalty consents for current user */
  consents: Array<CustomerLoyaltyConsent>;
  /** Get the loyalty program detail page for the customer based on their loyalty level */
  detailPage: LoyaltyProgramDetailPage;
  /** The loyalty insurance consent for the customer */
  insuranceConsent: Maybe<CustomerLoyaltyConsent>;
  /** What loyalty level this customer is in */
  level: CustomerLoyaltyLevel;
  /** Get loyalty point sources for current user */
  pointSources: Maybe<Array<CustomerLoyaltyPointSource>>;
  /** Number of points needed to reach the next loyalty level */
  pointsToNextLevel: Maybe<Scalars['Int']['output']>;
  /** Number of points this customer has */
  totalPoints: Scalars['Int']['output'];
};

/** How the customer is benefitting from a loyalty benefit */
export enum CustomerLoyaltyBenefitType {
  /** Access to wellness center */
  ACCESS_WELLNESS_CENTER = 'ACCESS_WELLNESS_CENTER',
  /** Aukakrónur cashback rewards */
  AUKAKRONUR = 'AUKAKRONUR',
  /** Employee benefit */
  EMPLOYEE_BENEFIT = 'EMPLOYEE_BENEFIT',
  /** Employee spouse benefit */
  EMPLOYEE_SPOUSE_BENEFIT = 'EMPLOYEE_SPOUSE_BENEFIT',
  /** Extra Aukakrónur cashback rewards */
  EXTRA_AUKAKRONUR = 'EXTRA_AUKAKRONUR',
  /** Higher interest rates on savings */
  HIGHER_INTERESTS = 'HIGHER_INTERESTS',
  /** Inactive benefit */
  INACTIVE_BENEFIT = 'INACTIVE_BENEFIT',
  /** Insurance benefit */
  INSURANCE = 'INSURANCE',
  /** Discount on mortgage */
  MORTGAGE_DISCOUNT = 'MORTGAGE_DISCOUNT',
  /** Discount on mortgage loan fees */
  MORTGAGE_LOAN_FEE_DISCOUNT = 'MORTGAGE_LOAN_FEE_DISCOUNT',
  /** Personalised offers */
  PERSONALISED_OFFERS = 'PERSONALISED_OFFERS',
  /** Private banking benefit */
  PRIVATE_BANKING_BENEFIT = 'PRIVATE_BANKING_BENEFIT',
  /** Saga Club benefit */
  SAGA_CLUB = 'SAGA_CLUB',
  /** Securities benefit */
  SECURITIES_BENEFIT = 'SECURITIES_BENEFIT',
  /** Benefit for customers aged 18-24 */
  U18_24 = 'U18_24',
  /** Unknown benefit type, possible new benefit type added that is not yet supported */
  UNKNOWN = 'UNKNOWN',
  /** Vild+ benefit */
  VILD_PLUS = 'VILD_PLUS'
}

/** Collection of benefits for a customer, categorized into current, claimable and upcoming */
export type CustomerLoyaltyBenefits = {
  __typename: 'CustomerLoyaltyBenefits';
  /** Benefits the customer can claim by taking action */
  claimableBenefits: Array<CustomerLoyaltyClaimableBenefit>;
  /** Benefits the customer is currently receiving */
  currentBenefits: Array<CustomerLoyaltyCurrentBenefit>;
  /** Benefits available at higher loyalty levels */
  upcomingBenefits: Array<CustomerLoyaltyUpcomingBenefits>;
};

/** A benefit the customer can claim by taking action */
export type CustomerLoyaltyClaimableBenefit = {
  __typename: 'CustomerLoyaltyClaimableBenefit';
  /** Unique identifier */
  benefitId: Scalars['String']['output'];
  /** How the customer is benefitting, e.g. Cashback, Insurance */
  benefitType: CustomerLoyaltyBenefitType;
  /** Consent the customer must give to claim this benefit */
  consentType: Maybe<CustomerLoyaltyConsentType>;
  /** Short description of the benefit */
  description: Maybe<Scalars['String']['output']>;
  /** Id of the detail page */
  detailPageId: Maybe<Scalars['String']['output']>;
  /** Reasons why the customer does not currently qualify for this benefit */
  eligibilityReasons: Maybe<Array<CustomerLoyaltyEligibilityReason>>;
  /** Priority for sorting */
  priority: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

/** Customer loyalty consent information */
export type CustomerLoyaltyConsent = {
  __typename: 'CustomerLoyaltyConsent';
  /** Unique consent type identifier */
  consentId: Scalars['Int']['output'];
  /** The type of consent required for loyalty program participation (e.g., insurance benefits or data processing) */
  consentType: CustomerLoyaltyConsentType;
  /** True if customer has granted the consent */
  granted: Maybe<Scalars['Boolean']['output']>;
  /** Whether the customer has answered this consent (granted is not null) */
  hasAnswered: Scalars['Boolean']['output'];
  /** Whether the customer has granted this consent */
  hasGranted: Scalars['Boolean']['output'];
  /** Localized consent text */
  text: Scalars['String']['output'];
  /** Latest version for this consent type */
  versionNo: Scalars['Int']['output'];
};

/** Types of consent */
export enum CustomerLoyaltyConsentType {
  /** Consent related to data processing for loyalty program */
  LOYALTY_DATA_PROCESSING = 'LOYALTY_DATA_PROCESSING',
  /** Consent related to loyalty insurance benefits */
  LOYALTY_INSURANCE = 'LOYALTY_INSURANCE',
  /** Unknown consent type, possible new consent type added that is not yet supported */
  UNKNOWN = 'UNKNOWN'
}

/** A benefit the customer is currently receiving */
export type CustomerLoyaltyCurrentBenefit = {
  __typename: 'CustomerLoyaltyCurrentBenefit';
  /** Unique identifier */
  benefitId: Scalars['String']['output'];
  /** How the customer is benefitting, e.g. Cashback, Insurance */
  benefitType: CustomerLoyaltyBenefitType;
  /** Short description of the benefit */
  description: Maybe<Scalars['String']['output']>;
  /** Id of the detail page */
  detailPageId: Maybe<Scalars['String']['output']>;
  /** Priority for sorting */
  priority: Scalars['Int']['output'];
  /** Collected reward, if any */
  reward: Maybe<CustomerLoyaltyReward>;
  /** Title */
  title: Scalars['String']['output'];
};

/** Reasons why the customer does not qualify for a benefit */
export enum CustomerLoyaltyEligibilityReason {
  /** Customer has not given the required consent */
  MISSING_CONSENT = 'MISSING_CONSENT',
  /** Customer does not have the required product */
  MISSING_PRODUCT = 'MISSING_PRODUCT',
  /** Other reason */
  OTHER = 'OTHER',
  /** Unknown eligibility reason */
  UNKNOWN = 'UNKNOWN'
}

/** Loyalty levels */
export enum CustomerLoyaltyLevel {
  /** Employee loyalty level. */
  EMPLOYEE = 'EMPLOYEE',
  /** Employee spouse loyalty level. */
  EMPLOYEE_SPOUSE = 'EMPLOYEE_SPOUSE',
  /** Private banking loyalty level. */
  PRIVATE_BANKING = 'PRIVATE_BANKING',
  /** Unknown loyalty level, possible new Loyalty level added that is not yet supported */
  UNKNOWN = 'UNKNOWN',
  /** Customer is not in any loyalty level */
  UTAN_VILDAR = 'UTAN_VILDAR',
  /** Basic tier loyalty level with standard benefits. */
  VILD_1 = 'VILD_1',
  /** Middle tier loyalty level with added benefits. */
  VILD_2 = 'VILD_2',
  /** Top tier loyalty level with premium benefits. */
  VILD_3 = 'VILD_3',
  /** Vild+ loyalty level. */
  VILD_PLUS = 'VILD_PLUS'
}

/** Breakdown of points the customer has or can earn */
export type CustomerLoyaltyPointSource = {
  __typename: 'CustomerLoyaltyPointSource';
  /** Id of the detail page */
  detailPageId: Maybe<Scalars['String']['output']>;
  /** Localized name of this point source type */
  name: Scalars['String']['output'];
  /** Unique identifier for this point source */
  pointSourceId: Scalars['String']['output'];
  /** Number of points for this item */
  points: Scalars['Int']['output'];
  /** Priority level for the associated item */
  priority: Scalars['Int']['output'];
  /** Status of this source */
  status: CustomerLoyaltyPointSourceStatus;
  /** The type of the point source */
  type: CustomerLoyaltyPointSourceType;
};

/** Specifies the status of a point-earning source for a customer, indicating whether points can be earned or have already been earned */
export enum CustomerLoyaltyPointSourceStatus {
  /** Points from this source are available to be earned */
  AVAILABLE = 'AVAILABLE',
  /** Points from this source have already been earned */
  EARNED = 'EARNED',
  /** Unknown point source status, possible new status added that is not yet supported */
  UNKNOWN = 'UNKNOWN'
}

/** Types of point sources */
export enum CustomerLoyaltyPointSourceType {
  /** The customer is actively using the bank's app or online banking */
  APP_ONLINE_BANK = 'APP_ONLINE_BANK',
  /** The customer has a car loan */
  CAR_LOAN = 'CAR_LOAN',
  /** The customer fully or partially owns a company that is in business with the bank */
  CORPORATE_IN_BUSINESS = 'CORPORATE_IN_BUSINESS',
  /** The customer has savings, stocks, or pension with the bank */
  DEPOSITS = 'DEPOSITS',
  /** The customer has savings, stocks, or pension over a certain amount with the bank */
  DEPOSITS_AMT = 'DEPOSITS_AMT',
  /** The customer is an employee of the bank */
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEE_RETIRED = 'EMPLOYEE_RETIRED',
  /** The customer is the spouse of an employee of the bank */
  EMPLOYEE_SPOUSE = 'EMPLOYEE_SPOUSE',
  /** The customer has extra loan(s) */
  EXTRA_LOAN = 'EXTRA_LOAN',
  /** The customer has insurance */
  INSURANCE = 'INSURANCE',
  /** The customer has a mortgage */
  MORTGAGE = 'MORTGAGE',
  /** The customer has a mortgage at the bank for 10 years or more */
  MORTGAGE_10_YRS = 'MORTGAGE_10_YRS',
  /** The customer has other bonds */
  OTHER_BOND = 'OTHER_BOND',
  /** The customer has personal pensions */
  PERSONAL_PENSION = 'PERSONAL_PENSION',
  /** How long the customer has been a customer of the bank */
  RELATIONSHIP_LENGTH = 'RELATIONSHIP_LENGTH',
  /** The customer has stocks, bonds or other securities */
  SECURITIES = 'SECURITIES',
  /** Unknown source of points */
  UNKNOWN = 'UNKNOWN'
}

/** Represents a reward with an associated collected amount and release date */
export type CustomerLoyaltyReward = {
  __typename: 'CustomerLoyaltyReward';
  /** Amount customer has collected */
  amount: Maybe<Scalars['Int']['output']>;
  /** When this reward will be released */
  releaseDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** What kind of reward this is */
  type: CustomerLoyaltyRewardType;
};

/** Type of reward */
export enum CustomerLoyaltyRewardType {
  /** Reward is available for the customer to use */
  AVAILABLE = 'AVAILABLE',
  /** Reward is pending */
  PENDING = 'PENDING',
  /** Reward is pending conditional on some action */
  PENDING_CONDITIONAL = 'PENDING_CONDITIONAL',
  /** Unknown reward type */
  UNKNOWN = 'UNKNOWN'
}

/** A benefit available at a higher loyalty level */
export type CustomerLoyaltyUpcomingBenefit = {
  __typename: 'CustomerLoyaltyUpcomingBenefit';
  /** Unique identifier */
  benefitId: Scalars['String']['output'];
  /** How the customer is benefitting, e.g. Cashback, Insurance */
  benefitType: CustomerLoyaltyBenefitType;
  /** Short description of the benefit */
  description: Maybe<Scalars['String']['output']>;
  /** Id of the detail page */
  detailPageId: Maybe<Scalars['String']['output']>;
  /** Priority for sorting */
  priority: Scalars['Int']['output'];
  /** Title */
  title: Scalars['String']['output'];
};

/** Benefits available if the customer reaches a higher loyalty level */
export type CustomerLoyaltyUpcomingBenefits = {
  __typename: 'CustomerLoyaltyUpcomingBenefits';
  /** Benefits available at this level */
  benefits: Array<CustomerLoyaltyUpcomingBenefit>;
  /** The level at which these benefits become available */
  level: CustomerLoyaltyLevel;
};

export type CustomerNotification = {
  __typename: 'CustomerNotification';
  /**
   * CustomerNotificationBanner (is: Tilkynningarborði) are notifications presented to the user for example on the front page. The notifications are controlled by the CRM backend and will always return the newest or the highest priority notification.
   * @deprecated Reason: Use banners instead which handles multiple banners. Since: 2025-08-28. Removed: 2025-08-29. Issue(s) to remove it: WEB-36536
   */
  banner: Maybe<CustomerNotificationBanner>;
  /** CustomerNotificationBanner (is: Tilkynningarborði) are notifications presented to the user for example on the front page. The notifications are controlled by the CRM backend and will always return the newest or the highest priority notification. */
  banners: Maybe<Array<CustomerNotificationBanner>>;
  /** newUnreadConversations keeps track of how many new conversations have arrived in the inbox since it was last checked. This value resets to 0 when the inbox conversations are fetched. The CRM backend keeps track of this value. This value is used for the chat icon. */
  newUnreadConversations: Scalars['Int']['output'];
  /** newUnreadMessages keeps track of how many new messages have arrived in the inbox since it was last checked. This value resets to 0 when the inbox messages are fetched. The CRM backend keeps track of this value. This value is used for the inbox icon. */
  newUnreadMessages: Scalars['Int']['output'];
  /** newUnreadNotifications keeps track of how many new messages and conversations have arrived in the inbox since it was last checked. This is the sum of new unread messages and new unread conversations. New unread messages resets to 0 when the inbox messages is fetched. New unread conversations resets to 0 when the inbox conversations is fetched. The CRM backend keeps track of these values. This value is used for the notification bell. */
  newUnreadNotifications: Scalars['Int']['output'];
  /** Number of unread conversations. */
  unreadConversations: Scalars['Int']['output'];
  /** Number of unread messages. */
  unreadMessages: Scalars['Int']['output'];
};

/** Notification banner for users */
export type CustomerNotificationBanner = {
  __typename: 'CustomerNotificationBanner';
  /** The actions the banner should do when clicked. */
  action: CustomerInboxAndNotificationBannerAction;
  /**
   * Some actions need specific data. This property if defined is a parameter query string with that data.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_INBOX_MESSAGE should have actionQuery like 'messageId="91"' which we then turn into a graphql id.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_EXTERNAL_URL should have actionQuery like 'externalUrl=https://www.landsbankinn.is/'.
   *   - CustomerInboxAndNotificationBannerAction.OPEN_CARD_APPLICATION should have actionQuery like 'catalogId=5'. If the actionQuery is excluded then it opens the card application for all cards.
   *   - CustomerInboxAndNotificationBannerAction.GO_TO_MARKETS_FUNDS_PAGE should have actionQuery like 'symbol=EIGNASJALF'.
   */
  actionQuery: Maybe<Scalars['String']['output']>;
  /** The severity of the notification banner. */
  bannerSeverity: CustomerNotificationBannerSeverityType;
  /** The id of the notification banner which also is the same id as the id of the message that is in the inbox that is connected to this notification. */
  notificationBannerId: Scalars['String']['output'];
  /** A boolean value that determines if the notification banner is a priority banner or not. A priority banner is always shown until the task related to it is done or the api turns it off. When the banner is a priority banner then the notificationBannerId is always 0. A priority banner never has a message in the inbox attached to it. */
  priority: Scalars['Boolean']['output'];
  /** Text of the banner. */
  text: Maybe<Scalars['String']['output']>;
  /** Title of the banner. */
  title: Maybe<Scalars['String']['output']>;
};

/** The location to display the NotificationBanner. */
export enum CustomerNotificationBannerLocationType {
  /** The notification banner is located on the frontpage and should be displayed there. */
  FRONT_PAGE = 'FRONT_PAGE',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The severity of the notification banner. */
export enum CustomerNotificationBannerSeverityType {
  /** High severity level for the notification banner. */
  HIGH = 'HIGH',
  /** Normal severity level for the notification banner. */
  NORMAL = 'NORMAL',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** Valid occupations with Landsbankinn */
export type CustomerOccupation = Node & {
  __typename: 'CustomerOccupation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomerOccupationConnection = {
  __typename: 'CustomerOccupationConnection';
  edges: Array<CustomerOccupationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CustomerOccupationEdge = {
  __typename: 'CustomerOccupationEdge';
  cursor: Scalars['String']['output'];
  node: CustomerOccupation;
};

/** Customer proxies (umboð) for  Landsbankinn bank accounts */
export type CustomerProxy = {
  __typename: 'CustomerProxy';
  authority: Authority;
  customerProxies: Array<CustomerProxy>;
  displayNumber: Scalars['String']['output'];
  ends: Scalars['DateTimeISO']['output'];
  /** (Model) Id of the customer proxy */
  id: Maybe<Scalars['String']['output']>;
  proxyHolderId: Scalars['String']['output'];
  proxyHolderName: Maybe<Scalars['String']['output']>;
  proxyStatus: Maybe<ProxyStatus>;
  starts: Scalars['DateTimeISO']['output'];
};

/** Product recommendations for the user */
export type CustomerRecommendation = {
  __typename: 'CustomerRecommendation';
  /** CustomerRecommendationBanner (is: Meðmælaborðar) are recommendation advertisements presented to the user on the start page or aukakronur page of the app. The recommendations are controlled by the CRM backend. */
  banner: Maybe<CustomerRecommendationBanner>;
  /** ProductCard (is: Vöruspjöld) are recommendation advertisements presented to the user on the start page of the app. The recommendations are controlled by the CRM backend. */
  productCards: Array<CustomerRecommendationProductCard>;
};


/** Product recommendations for the user */
export type CustomerRecommendationBannerArgs = {
  data: BannerLocationInput;
};

export type CustomerRecommendationAsset = CustomerRecommendationImageAsset | CustomerRecommendationLottieAsset;

/** Recommendation banner for users. The value of the fields can depend on the platform requesting the resource e.g. desktop application can return a longer version of the buttonTxt. */
export type CustomerRecommendationBanner = {
  __typename: 'CustomerRecommendationBanner';
  /** The actions the banner should do when clicked. */
  action: CustomerRecommendationBannerAction;
  /**
   * Some actions need specific data. This property if defined is a parameter query string with that data.
   *   - CustomerRecommendationBannerAction.openCardApplication should have actionQuery like 'catalogId=5'
   *   - CustomerRecommendationBannerAction.GoToFund should have actionQuery like 'symbol=EIGNASJALF'.
   */
  actionQuery: Maybe<Scalars['String']['output']>;
  /** An object with cdn url's of the asset used for background graphics of the banner. The asset can either be animated lottie file or a photograph. */
  asset: CustomerRecommendationAsset;
  /** Id of the banner. */
  bannerId: Maybe<Scalars['String']['output']>;
  /** Blurred version of the banner image that should be displayed when that main image is loading. */
  blurHash: Maybe<Scalars['String']['output']>;
  /** Background color of the button. */
  buttonBackground: Maybe<Scalars['String']['output']>;
  /** Color of the button. */
  buttonColor: Maybe<Scalars['String']['output']>;
  /** Localized text to display as the button text of the banner. */
  buttonTxt: Maybe<Scalars['String']['output']>;
  /** Id of the CRM campaign. */
  campaignId: Maybe<Scalars['String']['output']>;
  /** Name of the campaign. */
  campaignName: Maybe<Scalars['String']['output']>;
  /** The various types the banner can take on desktop devices */
  desktopType: CustomerRecommendationDesktopBannerType;
  /** A value that determines if the banner should have an "X" button that dismisses the banner. */
  dismissible: Scalars['Boolean']['output'];
  /** The external url that the banner should open when clicked. */
  externalUrl: Maybe<Scalars['String']['output']>;
  /** The location where the banner will be displayed. */
  location: CustomerRecommendationBannerLocationType;
  /** Localized text to display as the subtitle of the banner. */
  subtitle: Maybe<Scalars['String']['output']>;
  /** Localized text to display as the title of the banner. */
  title: Scalars['String']['output'];
  /** The various types the banner can take. */
  type: CustomerRecommendationBannerType;
  /** The variant of the banner e.g. light on dark or dark on light. */
  variant: CustomerRecommendationBannerVariant;
};

/** The actions for the banner. */
export enum CustomerRecommendationBannerAction {
  /** Clicking the banner with this action, sends the user to the access control page. */
  GO_TO_ACCESS_CONTROL_PAGE = 'GO_TO_ACCESS_CONTROL_PAGE',
  /** Clicking the banner with this action, sends the user to the aukakronur page. */
  GO_TO_AUKAKRONUR_PAGE = 'GO_TO_AUKAKRONUR_PAGE',
  /** Clicking the banner with this action, sends the user to the cards monitoring page. */
  GO_TO_CARDS_MONITORING_PAGE = 'GO_TO_CARDS_MONITORING_PAGE',
  /** Clicking the banner with this action, sends the user to the chat page. */
  GO_TO_CHAT_PAGE = 'GO_TO_CHAT_PAGE',
  /** Clicking the banner with this action, sends the user to the claim collection overview page. */
  GO_TO_CLAIM_COLLECTION_OVERVIEW_PAGE = 'GO_TO_CLAIM_COLLECTION_OVERVIEW_PAGE',
  /** Clicking the banner with this action, sends the user to the claim expenses distribution page. */
  GO_TO_CLAIM_EXPENSES_DISTRIBUTION = 'GO_TO_CLAIM_EXPENSES_DISTRIBUTION',
  /** Clicking the banner with this action, sends the user to an external url. */
  GO_TO_EXTERNAL_URL = 'GO_TO_EXTERNAL_URL',
  /** Clicking the banner or button with this action should navigate to the gift (Gjöf) page. */
  GO_TO_GIFT_PAGE = 'GO_TO_GIFT_PAGE',
  /** Clicking button with this action should navigate to insurance overview. */
  GO_TO_INSURANCE_PAGE = 'GO_TO_INSURANCE_PAGE',
  /** Clicking the banner with this action, sends the user to the loyalty page. */
  GO_TO_LOYALTY_PAGE = 'GO_TO_LOYALTY_PAGE',
  /** Clicking the banner with this action, sends the user to the loyalty page points dialog. */
  GO_TO_LOYALTY_PAGE_POINT_STEPS = 'GO_TO_LOYALTY_PAGE_POINT_STEPS',
  /** Clicking the banner with this action, sends the user to the markets funds. If actionQuery is defined with symbol then we will go to that specific fund detail page, else we will go to funds overview tab. */
  GO_TO_MARKETS_FUNDS_PAGE = 'GO_TO_MARKETS_FUNDS_PAGE',
  /** Clicking the banner with this action should open the settings monitoring page for the user. */
  GO_TO_MONITORING_PAGE = 'GO_TO_MONITORING_PAGE',
  /** Clicking the banner with this action, sends the user to the mandatory pension page. */
  GO_TO_PENSION_MANDATORY_PAGE = 'GO_TO_PENSION_MANDATORY_PAGE',
  /** Clicking the banner with this action, sends the user to the supplementary pension page. */
  GO_TO_PENSION_SUPPLEMENTARY_PAGE = 'GO_TO_PENSION_SUPPLEMENTARY_PAGE',
  /** Clicking the banner with this action, sends the user to the pre approved limit page. */
  GO_TO_PRE_APPROVED_LIMIT_PAGE = 'GO_TO_PRE_APPROVED_LIMIT_PAGE',
  /** Clicking the banner with this action, sends the user to the proxy access page. */
  GO_TO_PROXY_ACCESS_PAGE = 'GO_TO_PROXY_ACCESS_PAGE',
  /** Clicking the banner with this action, sends the user to the savings page. */
  GO_TO_SAVINGS_PAGE = 'GO_TO_SAVINGS_PAGE',
  /** Clicking the banner with this action, sends the user to the settings overview page. */
  GO_TO_SETTINGS_OVERVIEW_PAGE = 'GO_TO_SETTINGS_OVERVIEW_PAGE',
  /** Clicking the banner with this action, opens the accounts monitoring dialog. */
  OPEN_ACCOUNTS_MONITORING = 'OPEN_ACCOUNTS_MONITORING',
  /** Clicking the banner with this action, sends the user to the aukakronur partners page. */
  OPEN_AUKAKRONUR_PARTNERS_PAGE = 'OPEN_AUKAKRONUR_PARTNERS_PAGE',
  /** Clicking the banner with this action, opens a aukalan application for the user. */
  OPEN_AUKALAN_APPLICATION = 'OPEN_AUKALAN_APPLICATION',
  /** To open book insurance consultation process. The actionQuery property can include "type" param. Possible values see `InsuranceType`. Example "type=Life". */
  OPEN_BOOK_INSURANCE_CONSULTATION = 'OPEN_BOOK_INSURANCE_CONSULTATION',
  /** Clicking the banner with this action, opens card application for the user. The actionQuery property should include catalogId for a specific card to open with. */
  OPEN_CARD_APPLICATION = 'OPEN_CARD_APPLICATION',
  /** Clicking the banner with this action, opens the claim monitoring settings dialog */
  OPEN_CLAIM_MONITORING_SETTINGS = 'OPEN_CLAIM_MONITORING_SETTINGS',
  /** Clicking the banner with this action, opens the create bank account dialog */
  OPEN_CREATE_ACCOUNT = 'OPEN_CREATE_ACCOUNT',
  /** Clicking the banner with this action, opens the create bank account dialog for the user to create a account for users children */
  OPEN_CREATE_ACCOUNT_FOR_CHILD = 'OPEN_CREATE_ACCOUNT_FOR_CHILD',
  /** Clicking the banner with this action, opens the create bank account dialog for the user */
  OPEN_CREATE_ACCOUNT_FOR_SELF = 'OPEN_CREATE_ACCOUNT_FOR_SELF',
  /** Clicking the banner with this action, opens the create collection service dialog. */
  OPEN_CREATE_COLLECTION_SERVICE = 'OPEN_CREATE_COLLECTION_SERVICE',
  /** Clicking the banner with this action, opens the create payment distribution for the user. */
  OPEN_CREATE_PAYMENT_DISTRIBUTION = 'OPEN_CREATE_PAYMENT_DISTRIBUTION',
  /** Clicking the banner with this action, opens a credit line application for the user. */
  OPEN_CREDIT_LINE_APPLICATION = 'OPEN_CREDIT_LINE_APPLICATION',
  /** To open a dialog that fetches and shows custom content. The actionQuery property should include contentId of the content to fetch, example "contentId=1" */
  OPEN_CUSTOM_CONTENT = 'OPEN_CUSTOM_CONTENT',
  /** To open insurance application. To begin with this will be a single sign on to TM.is. The actionQuery property should include "returnUrl" param that dictates where user should land on TM's webpage. */
  OPEN_INSURANCE_APPLICATION = 'OPEN_INSURANCE_APPLICATION',
  /** Clicking the banner with this action, opens the markets monitoring dialog. */
  OPEN_MARKETS_MONITORING = 'OPEN_MARKETS_MONITORING',
  /** Clicking the banner with this action, opens a mortgage application for the user. */
  OPEN_MORTGAGE_APPLICATION = 'OPEN_MORTGAGE_APPLICATION',
  /** Clicking the banner with this action, opens a new loan application for the user. */
  OPEN_NEW_LOAN_APPLICATION = 'OPEN_NEW_LOAN_APPLICATION',
  /** Clicking the banner with this action, opens a overdraft application for the user. */
  OPEN_OVERDRAFT_APPLICATION = 'OPEN_OVERDRAFT_APPLICATION',
  /** Clicking the banner with this action, opens a refinance mortgage application for the user. */
  OPEN_REFINANCE_MORTGAGE_APPLICATION = 'OPEN_REFINANCE_MORTGAGE_APPLICATION',
  /** Clicking the banner with this action, opens the savings monitoring dialog. */
  OPEN_SAVINGS_MONITORING = 'OPEN_SAVINGS_MONITORING',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The location to display the RecommendationBanner. */
export enum CustomerRecommendationBannerLocationType {
  /** The recommendation banner is located on the aukakronur page and should be displayed there. */
  AUKAKRONUR_PAGE = 'AUKAKRONUR_PAGE',
  /** The recommendation banner is located on the frontpage and should be displayed there. */
  FRONT_PAGE = 'FRONT_PAGE',
  /** The recommendation banner should be displayed on the insurance overview page. */
  INSURANCE_OVERVIEW_PAGE = 'INSURANCE_OVERVIEW_PAGE',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The type of the banner. */
export enum CustomerRecommendationBannerType {
  /** Compact banner, with height of 120 px, heading 22px and no button. */
  COMPACT = 'COMPACT',
  /** Compact banner, with height of 120 px, heading 20px and a button on the right side. */
  COMPACT_CTA = 'COMPACT_CTA',
  /** Compact banner, with height of 120 px, heading 28px and a button on the right side. Designed for lottie animated backgrounds. */
  COMPACT_PREDEFINED = 'COMPACT_PREDEFINED',
  /** Large banner, with height of 174 px, heading 22px and an optional button on the bottom left. Has space for subtitle with two lines. */
  LARGE = 'LARGE',
  /** Large banner, with height of 174 px, heading 22px and a button on the bottom left. Has space for subtitle with two lines. */
  LARGE_CTA = 'LARGE_CTA',
  /** Regular banner, with height of 154 px, heading 22px and no button. */
  REGULAR = 'REGULAR',
  /** Regular banner, with height of 154 px, heading 22px and a button on the bottom left. */
  REGULAR_CTA = 'REGULAR_CTA',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The variant of the banner. */
export enum CustomerRecommendationBannerVariant {
  /** Dark text on a light background. */
  DARK_ON_LIGHT = 'DARK_ON_LIGHT',
  /** Light text on a dark background. */
  LIGHT_ON_DARK = 'LIGHT_ON_DARK',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The desktop banner size type. */
export enum CustomerRecommendationDesktopBannerType {
  /** Large desktop banner size. */
  LARGE = 'LARGE',
  /** Medium desktop banner size. */
  MEDIUM = 'MEDIUM',
  /** Small desktop banner size. */
  SMALL = 'SMALL',
  /** Tiny desktop banner size. */
  TINY = 'TINY',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

/** The image the recommendation banner will display. Comes with 3 versions: 1x, 2x, 3x. The reason why is because higher resolution displays demand images with more pixels. This object contains url's to three different resolution for different pixel dense screens. The url's point to either jpg or webp files, depends on the client version asking for it. */
export type CustomerRecommendationImageAsset = {
  __typename: 'CustomerRecommendationImageAsset';
  /** Scale factor 1. */
  oneX: Scalars['String']['output'];
  /** Scale factor 3. */
  threeX: Scalars['String']['output'];
  /** Scale factor 2. */
  twoX: Scalars['String']['output'];
};

/** For animated background graphic. */
export type CustomerRecommendationLottieAsset = {
  __typename: 'CustomerRecommendationLottieAsset';
  /** Source URL for the lottie asset. */
  src: Scalars['String']['output'];
};

/** ProductCard recommendation for the user */
export type CustomerRecommendationProductCard = {
  __typename: 'CustomerRecommendationProductCard';
  /** Localized text to display as the body of the product card. */
  text: Scalars['String']['output'];
  /** Localized text to display as the title of the product card. */
  title: Scalars['String']['output'];
  /** Used to determine which icon to display. */
  type: CustomerRecommendationProductCardType;
};

/** The type of ProductCard. Used to display correct icon. Potentially used to determine onClick action. */
export enum CustomerRecommendationProductCardType {
  /** For user that have an active pension savings but don't have a active additional pensions savings. */
  ADDITIONAL_PENSIONS = 'ADDITIONAL_PENSIONS',
  /** When user does not have a AH account (Veltureikningur) we display a special ProductCard with a text similar to "Stofnaðu bankareikning og fáðu þér debitkort */
  AH = 'AH',
  /** We recommend the user to apply for a credit card. For users that do not have a credit card. */
  CARD = 'CARD',
  /** For corporate users that do not have collection service and have authorization for it. */
  COLLECTION_SERVICE = 'COLLECTION_SERVICE',
  /** For users with good credit score and no loans */
  LOAN = 'LOAN',
  /** For users that a mortgage and/or a car loan but no short term loan */
  LOAN_HAS_MORTAGE = 'LOAN_HAS_MORTAGE',
  /** For user that have an additional pensions savings but don't have a active mandatory pensions savings. */
  MANDATORY_PENSIONS = 'MANDATORY_PENSIONS',
  /** For users that do not have an account overdraft and are eligible for one (loan product). */
  OVERDRAFT = 'OVERDRAFT',
  /** For user that do not have an active pension savings. */
  PENSIONS = 'PENSIONS',
  /** For users that do not have an active "markmið" savings account. */
  SAVINGS = 'SAVINGS',
  /** For users that do not have any securities (stock, bond, fund) in their portfolio. */
  SECURITIES = 'SECURITIES',
  /** Fallback enum for if the API adds a new value. */
  UNKNOWN = 'UNKNOWN'
}

export type CustomerResponse = Customer | ViewerDoesNotHaveAccessToCustomer;

export enum CustomerStatus {
  Active = 'Active',
  Deleted = 'Deleted',
  Inactive = 'Inactive',
  NewlyRegistered = 'NewlyRegistered',
  Unknown = 'Unknown'
}

/** Financial summary for a customer */
export type CustomerSummary = {
  __typename: 'CustomerSummary';
  assets: CustomerSummaryAssets;
  date: Scalars['Date']['output'];
  liabilities: CustomerSummaryLiabilities;
  other: CustomerSummaryOther;
};

/** Financial asset summary for a customer */
export type CustomerSummaryAssets = {
  __typename: 'CustomerSummaryAssets';
  chequingAccounts: CurrencyAmount;
  currencyAccounts: CurrencyAmount;
  paymentCards: CurrencyAmount;
  savingsAccounts: CurrencyAmount;
  securities: CurrencyAmount;
  totalAssets: CurrencyAmount;
};

/** Financial liabilities summary for a customer */
export type CustomerSummaryLiabilities = {
  __typename: 'CustomerSummaryLiabilities';
  carLoans: CurrencyAmount;
  carLoansDefault: CurrencyAmount;
  debenture: CurrencyAmount;
  debentureDefault: CurrencyAmount;
  overdraft: CurrencyAmount;
  overdraftDefault: CurrencyAmount;
  paymentCards: CurrencyAmount;
  paymentCardsDefault: CurrencyAmount;
  totalLiabilities: CurrencyAmount;
  totalLiabilitiesDefault: CurrencyAmount;
};

/** Financial third party guarantees summary for a customer */
export type CustomerSummaryOther = {
  __typename: 'CustomerSummaryOther';
  thirdPartyGuarantees: CurrencyAmount;
  thirdPartyGuaranteesDefault: CurrencyAmount;
};

export type CustomerTooYoung = Error & {
  __typename: 'CustomerTooYoung';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CustomerTradeNotAllowed = Error & {
  __typename: 'CustomerTradeNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Date picker component */
export type DateFormComponent = FormComponentBase & {
  __typename: 'DateFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export type DebitCard = Node & {
  __typename: 'DebitCard';
  account: Maybe<Account>;
  /** The account id of the direct debit */
  accountId: Scalars['String']['output'];
  annualFee: Maybe<CardAnnualFeeType>;
  /** Checks if the user can add this card to Apple Wallet. */
  appleWalletCardStatus: AppleWalletCardStatus;
  canAddToPaymentService: Scalars['Boolean']['output'];
  /** Whether notifications can be changed for this debit card. */
  canChangeNotifications: Scalars['Boolean']['output'];
  /** Determines if a user is authorized for card's transaction control settings */
  canChangeTransactionControls: Scalars['Boolean']['output'];
  /** Determine if the user can close the card */
  canClose: Scalars['Boolean']['output'];
  canGetPin: Scalars['Boolean']['output'];
  /** Determines if a user can see full un-masked cardnumber and cvv. */
  canSeePrivateInfo: Scalars['Boolean']['output'];
  canToggleFrozenStatus: Scalars['Boolean']['output'];
  /** The activity status of the card (e.g terminatedLost, frozen, active and more) */
  cardActivityStatus: CardActivityStatus;
  cardHolderKennitala: Scalars['String']['output'];
  cardHolderName: Scalars['String']['output'];
  /** The (model) id of the card */
  cardId: Scalars['Int']['output'];
  /** The masked credit card number */
  cardNumberMasked: Scalars['String']['output'];
  cardOwnerKennitala: Scalars['String']['output'];
  /** The card owner name */
  cardOwnerName: Maybe<Scalars['String']['output']>;
  /** The card saving that is assigned to this Debit Card, or null (if the card doesn't have one) */
  cardSaving: Maybe<CardSaving>;
  /** The type name of the card */
  cardType: Scalars['String']['output'];
  expirationDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  /** Determine if the card is a corporate card or not */
  isCorporationCard: Scalars['Boolean']['output'];
  /** Indicates if the card is in Click to Pay */
  isInClickToPay: Scalars['Boolean']['output'];
  /** Determines if a user has a physical plastic card or only a virtual one */
  isPhysical: Scalars['Boolean']['output'];
  /** @deprecated Use latestTransactionsV2 instead. Since 2026-07-01. Issue to remove it: WEB-44141 */
  latestTransactions: CardTransactionConnection;
  latestTransactionsV2: LatestCardTransactionConnection;
  /** List of all notification options */
  notificationOptions: Maybe<Array<CardNotificationOption>>;
  /** Pan ID is used for registering card with mobile wallet products. */
  panId: Maybe<Scalars['String']['output']>;
  /** The pin number of the card */
  pin: PinStepUpUnion;
  /** The pin number of the card */
  pinV2: CardPinResultV2;
  privateInfo: CardPrivateInfoResponse;
  privateInfoV2: CardPrivateInfoResultV2;
  /** The reissue status of the card */
  reissueStatus: Maybe<CardReissueStatus>;
  /** The status of the card (active, frozen and unknown) */
  status: CardStatus;
  transactionControls: Array<CardTransactionControl>;
  transactions: CardTransactionConnection;
  type: DebitCardType;
};


export type DebitCardLatestTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<CardTransactionsOrderBy>;
};


export type DebitCardLatestTransactionsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<CardTransactionsOrderBy>;
};


export type DebitCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CardTransactionsOrderBy>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DebitCardConnection = {
  __typename: 'DebitCardConnection';
  edges: Array<DebitCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DebitCardEdge = {
  __typename: 'DebitCardEdge';
  cursor: Scalars['String']['output'];
  node: DebitCard;
};

export type DebitCardFilterArgs = {
  debitCardsForSavings?: InputMaybe<Scalars['Boolean']['input']>;
  isCardHolder?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Debit card product */
export type DebitCardProduct = Node & Product & {
  __typename: 'DebitCardProduct';
  annualFee: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for product in card catalog */
  catalogId: Scalars['Int']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  transactionFeeInformation: Maybe<DebitCardProductTransactionFeeInformation>;
  type: ProductType;
};

/** Transaction fee information on debit card product */
export type DebitCardProductTransactionFeeInformation = {
  __typename: 'DebitCardProductTransactionFeeInformation';
  amount: Scalars['Int']['output'];
  freeTransactions: Scalars['Int']['output'];
};

export enum DebitCardType {
  Debit = 'Debit',
  DebitBusiness = 'DebitBusiness',
  DebitKlassi = 'DebitKlassi',
  DebitStudent = 'DebitStudent',
  Unknown = 'Unknown'
}

export type DebitCardsOrderBy = {
  direction: OrderByDirection;
  field: DebitCardsOrderByOption;
};

/** Options for ordering debit cards */
export enum DebitCardsOrderByOption {
  /** Order by account id */
  ACCOUNT = 'ACCOUNT',
  /** Order by card holder name */
  CARD_HOLDER_NAME = 'CARD_HOLDER_NAME',
  /** Order by card name */
  CARD_NAME = 'CARD_NAME',
  /** Order by masked card number (416293******6422) */
  CARD_NUMBER = 'CARD_NUMBER'
}

export enum DebtActionType {
  CoOpDebt = 'CoOpDebt',
  IgnorePaymentsPerMonth = 'IgnorePaymentsPerMonth',
  MortgageToThirdParty = 'MortgageToThirdParty',
  None = 'None',
  NotApplicable = 'NotApplicable',
  OvertakenByApplicant = 'OvertakenByApplicant',
  OvertakenByOther = 'OvertakenByOther',
  PaidUp = 'PaidUp',
  ReCalculatePaymentPerMonth = 'ReCalculatePaymentPerMonth',
  Unknown = 'Unknown',
  WillBeMovedToNewProperty = 'WillBeMovedToNewProperty',
  WillBePaid = 'WillBePaid',
  WillBePaidUpWithRealEstate = 'WillBePaidUpWithRealEstate'
}

/** Information about account for deduction */
export type DeductionAccountInfo = {
  __typename: 'DeductionAccountInfo';
  /** ID of the account set for deduction */
  accountId: Scalars['String']['output'];
  /** Value of deduction */
  deductible: CurrencyAmount;
  /** Is deduction set in percentages */
  isPercentage: Scalars['Boolean']['output'];
};

export type DefaultAccountFilterArgs = {
  mustBeDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  mustBeWithdrawal?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultCalculatedPaymentDistributionInput = {
  initialAmount?: InputMaybe<Scalars['Float']['input']>;
  initialNumberOfPayments?: InputMaybe<Scalars['Int']['input']>;
};

/** Default charge information */
export type DefaultCharge = {
  __typename: 'DefaultCharge';
  /** Number of days after which apply the charge */
  numberOfDays: Scalars['Int']['output'];
  /** Default charge value (amount of charge) */
  value: CurrencyAmount;
};

/** Information about default charges */
export type DefaultChargeInfo = {
  __typename: 'DefaultChargeInfo';
  /** Rule to determine when to apply default charge */
  calculationRule: CalculationRuleAfter;
  /** Information about first charge */
  firstDefaultCharge: DefaultCharge;
  /** Is charge set in percentages */
  isPercentage: Scalars['Boolean']['output'];
  /** Information about second charge */
  secondDefaultCharge: DefaultCharge;
};

export type DeleteCardTransactionAttachmentErrorUnion = CardTransactionAttachmentNotFound | UnknownError;

export type DeleteCardTransactionAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
};

/** Returns id of the attachment content that was deleted */
export type DeleteCardTransactionAttachmentPayload = {
  __typename: 'DeleteCardTransactionAttachmentPayload';
  /** Id of the attachment content that was deleted, null if not successful */
  attachmentId: Maybe<Scalars['ID']['output']>;
  /** Error object if there was an error deleting the attachment, null if successful */
  error: Maybe<DeleteCardTransactionAttachmentErrorUnion>;
};

export type DeleteCardTransactionsLedgerKeyErrorUnion = CardTransactionsLedgerKeyNotFoundError | CustomerDoesNotHaveAccessCardTransactionsLedgerKeysError | UnknownError;

export type DeleteCardTransactionsLedgerKeyGroupErrorUnion = CustomerDoesNotHaveAccessCardTransactionsLedgerKeyGroupsError | UnknownError;

export type DeleteCardTransactionsLedgerKeyGroupInput = {
  /** The card transaction ledger key group id */
  id: Scalars['ID']['input'];
};

export type DeleteCardTransactionsLedgerKeyGroupPayload = {
  __typename: 'DeleteCardTransactionsLedgerKeyGroupPayload';
  cardTransactionsLedgerKeyGroup: Maybe<CardTransactionsLedgerKeyGroup>;
  error: Maybe<DeleteCardTransactionsLedgerKeyGroupErrorUnion>;
};

export type DeleteCardTransactionsLedgerKeyInput = {
  /** The card transaction ledger key id */
  id: Scalars['ID']['input'];
};

/** Delete card transaction ledger key, return id on success */
export type DeleteCardTransactionsLedgerKeyPayload = {
  __typename: 'DeleteCardTransactionsLedgerKeyPayload';
  error: Maybe<DeleteCardTransactionsLedgerKeyErrorUnion>;
  /** If successful delete the return object cardTransactionsLedgerKey id */
  id: Maybe<Scalars['ID']['output']>;
};

export type DeleteCardTransactionsLedgerKeySubGroupErrorUnion = CustomerDoesNotHaveAccessCardTransactionsLedgerKeySubGroupsError | UnknownError;

export type DeleteCardTransactionsLedgerKeySubGroupInput = {
  /** The card transaction ledger key sub group id */
  id: Scalars['ID']['input'];
};

export type DeleteCardTransactionsLedgerKeySubGroupPayload = {
  __typename: 'DeleteCardTransactionsLedgerKeySubGroupPayload';
  cardTransactionsLedgerKeySubGroup: Maybe<CardTransactionsLedgerKeySubGroup>;
  error: Maybe<DeleteCardTransactionsLedgerKeySubGroupErrorUnion>;
};

export type DeleteClaimResponse = ClaimNotFound | DeleteOptionalClaimPayload;

export type DeleteConversationInput = {
  /** Id of the conversation. */
  conversationId: Scalars['ID']['input'];
};

export type DeleteConversationResponse = {
  __typename: 'DeleteConversationResponse';
  /** Is true if it was successful to delete the conversation. */
  success: Scalars['Boolean']['output'];
};

export type DeleteDirectDebitAgreementErrorUnion = MandateNotFoundError | UnknownError;

/** Input for deleting a direct debit mandate agreement */
export type DeleteDirectDebitAgreementInput = {
  /** ID (Global) of the direct debit agreement to delete */
  id: Scalars['ID']['input'];
};

/** Response for successful direct debit agreement deletion */
export type DeleteDirectDebitAgreementPayload = {
  __typename: 'DeleteDirectDebitAgreementPayload';
  /** Id (Global) of the deleted direct debit agreement */
  agreementId: Maybe<Scalars['ID']['output']>;
  /** Error, if any occurred during the deletion of the direct debit agreement */
  error: Maybe<DeleteDirectDebitAgreementErrorUnion>;
};

/** Input for deleting multiple direct debit mandate agreements at once */
export type DeleteDirectDebitAgreementsInput = {
  /** IDs (Global) of the direct debit agreements to delete */
  ids: Array<Scalars['ID']['input']>;
};

/** Payload for deleting multiple direct debit agreements */
export type DeleteDirectDebitAgreementsPayload = {
  __typename: 'DeleteDirectDebitAgreementsPayload';
  /** The IDs (Global) of deleted direct debit agreements. */
  deletedAgreementIds: Maybe<Array<Scalars['ID']['output']>>;
  /** The failed deletions of direct debit agreements */
  failedAgreementsInfo: Maybe<Array<FailedDirectDebitAgreementDeletion>>;
};

/** Input for deleting a direct debit mandate order */
export type DeleteDirectDebitMandateOrderInput = {
  /** ID (Global) of the direct debit mandate order to delete */
  id: Scalars['ID']['input'];
};

/** Payload for deleting a direct debit mandate order */
export type DeleteDirectDebitMandateOrderPayload = {
  __typename: 'DeleteDirectDebitMandateOrderPayload';
  /** The deleted direct debit mandate order. Behind the scenes it is not deleted, but changed the visibility */
  alteredOrder: Maybe<DirectDebitMandateOrder>;
  /** Was the deletion successful? */
  success: Scalars['Boolean']['output'];
};

/** Input for deleting multiple direct debit mandate orders at once */
export type DeleteDirectDebitMandateOrdersInput = {
  /** IDs (Global) of the direct debit mandate orders to delete */
  ids: Array<Scalars['ID']['input']>;
};

/** Payload for deleting multiple direct debit mandate orders */
export type DeleteDirectDebitMandateOrdersPayload = {
  __typename: 'DeleteDirectDebitMandateOrdersPayload';
  /** The deleted direct debit mandate orders. Behind the scenes they are not deleted, but changed the visibility */
  alteredOrders: Maybe<Array<DirectDebitMandateOrder>>;
  /** IDs (Global) of orders that could not be deleted */
  failedOrderIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Returns true if there is at least one successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteExternalAccountConsentInput = {
  /** Global GraphQL identifier of an external account consent */
  id: Scalars['ID']['input'];
};

/** The result of deleting an external account consent */
export type DeleteExternalAccountConsentResponse = {
  __typename: 'DeleteExternalAccountConsentResponse';
  id: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFinancialStatementsSubscriptionError = UnknownError | UnsubscribeFromFinancialStatementsError;

/** Payload for unsubscribing from financial statements */
export type DeleteFinancialStatementsSubscriptionPayload = {
  __typename: 'DeleteFinancialStatementsSubscriptionPayload';
  /** Error object if success is false */
  error: Maybe<DeleteFinancialStatementsSubscriptionError>;
  /** Whether the subscription was deleted successfully */
  success: Scalars['Boolean']['output'];
};

export type DeleteGiftCardResponse = {
  __typename: 'DeleteGiftCardResponse';
  id: Scalars['String']['output'];
};

export type DeleteKycStakeholderInput = {
  /** Kennitala of the company the KYC is for, for users that are not acting for that company (e.g. national token users) */
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
  stakeholderId: Scalars['String']['input'];
};

export type DeleteOptionalClaimInput = {
  /** The optional claim's ID */
  id: Scalars['String']['input'];
};

/** Response for successful claim deletion */
export type DeleteOptionalClaimPayload = {
  __typename: 'DeleteOptionalClaimPayload';
  claimId: Scalars['ID']['output'];
};

/** Input used to delete a known notification handle */
export type DeletePaymentNotificationsHandleInput = {
  handle: Scalars['String']['input'];
  paymentId: Scalars['ID']['input'];
};

export type DeletePaymentNotificationsHandleResponse = {
  __typename: 'DeletePaymentNotificationsHandleResponse';
  handles: Array<Scalars['String']['output']>;
  paymentId: Scalars['ID']['output'];
};

export type DeletePaymentRecipientInput = {
  /** GraphQL ID of a payment recipient */
  id: Scalars['ID']['input'];
};

export type DeletePhoneNumberInput = {
  phoneType: PhoneType;
};

export type DeletePhoneNumberPayloadErrorUnion = UnknownError;

export type DeletePhoneNumberPayloadV2 = {
  __typename: 'DeletePhoneNumberPayloadV2';
  error: Maybe<DeletePhoneNumberPayloadErrorUnion>;
  result: Maybe<Viewer>;
};

export type DeletePhoneNumberResult = RsaStepUpResponse | Viewer;

export type DeletePhoneNumberResultV2 = AdaptiveAuthentication | DeletePhoneNumberPayloadV2;

/** An error occurred during payment deletion */
export type DeleteStoredPaymentError = {
  __typename: 'DeleteStoredPaymentError';
  errorSubject: PaymentInitiationErrorSubject;
  pisId: Scalars['String']['output'];
};

export type DeleteStoredPaymentInput = {
  instructionType: StoredPaymentInstructionType;
  pisId: Scalars['String']['input'];
};

/** Stored payment deleted successfully */
export type DeleteStoredPaymentPayload = {
  __typename: 'DeleteStoredPaymentPayload';
  deleted: Scalars['Boolean']['output'];
  pisId: Scalars['String']['output'];
};

export type DeleteStoredPaymentResponse = DeleteStoredPaymentError | DeleteStoredPaymentPayload;

export type DeleteStoredPaymentsInput = {
  payments: Array<DeleteStoredPaymentInput>;
};

/** A list of store payments deleted successfully and any errors */
export type DeleteStoredPaymentsPayload = {
  __typename: 'DeleteStoredPaymentsPayload';
  errors: Maybe<Array<DeleteStoredPaymentError>>;
  payments: Maybe<Array<DeleteStoredPaymentPayload>>;
};

export type DeliveryAddress = {
  __typename: 'DeliveryAddress';
  city: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

export type DepositAccountLookupCustomer = {
  __typename: 'DepositAccountLookupCustomer';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  kennitala: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
};

export type DepositAccountLookupInput = {
  /** Account number which will be searched */
  accountNumber: Scalars['String']['input'];
  /** Account owner's kennitala */
  kennitala: Scalars['String']['input'];
};

export type DepositAccountLookupPayload = {
  __typename: 'DepositAccountLookupPayload';
  account: Maybe<Account>;
  accountNumber: Maybe<Scalars['String']['output']>;
  /** If market is closed during currency transfer check whether user has account in the appropriate currency */
  canTransferOutsideMarketHours: Scalars['Boolean']['output'];
  currency: Maybe<Scalars['String']['output']>;
  customer: Maybe<DepositAccountLookupCustomer>;
  id: Scalars['ID']['output'];
  isCurrencyAccount: Maybe<Scalars['Boolean']['output']>;
  openForDeposits: Maybe<Scalars['Boolean']['output']>;
  otherFinancialInstitution: Maybe<Scalars['Boolean']['output']>;
};

export type DepositInfo = {
  accountNumber: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Derivative contract data */
export type DerivativeCollateral = Node & {
  __typename: 'DerivativeCollateral';
  closedDate: Maybe<Scalars['DateTimeISO']['output']>;
  closingPrice: Maybe<Scalars['Float']['output']>;
  collateralNumber: Scalars['String']['output'];
  haircutPercentage: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  marketValue: Maybe<Scalars['Float']['output']>;
  marketValueIsk: Maybe<Scalars['Float']['output']>;
  marketValueWithHaircut: Maybe<Scalars['Float']['output']>;
  maturityDate: Maybe<Scalars['DateTimeISO']['output']>;
  nominal: Scalars['Float']['output'];
  price: Scalars['Float']['output'];
  underlyingInstrumentName: Scalars['String']['output'];
};

export type DerivativeCollateralConnection = {
  __typename: 'DerivativeCollateralConnection';
  collateralsMarketValueWithHaircut: Scalars['Float']['output'];
  contractsMarketValue: Maybe<Scalars['Float']['output']>;
  creditEquivalentExcess: Scalars['Float']['output'];
  edges: Array<DerivativeCollateralEdge>;
  marginExcess: Scalars['Float']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DerivativeCollateralEdge = {
  __typename: 'DerivativeCollateralEdge';
  cursor: Scalars['String']['output'];
  node: DerivativeCollateral;
};

/** Derivative contract data */
export type DerivativeContract = Node & {
  __typename: 'DerivativeContract';
  closedDate: Maybe<Scalars['DateTimeISO']['output']>;
  closingPrice: Maybe<Scalars['Float']['output']>;
  contractNumber: Scalars['String']['output'];
  dirtyPrice: Maybe<Scalars['Float']['output']>;
  gainLoss: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  initialPrice: Scalars['Float']['output'];
  marketValue: Maybe<Scalars['Float']['output']>;
  marketValueIsk: Maybe<Scalars['Float']['output']>;
  maturityDate: Maybe<Scalars['DateTimeISO']['output']>;
  nominal: Scalars['Float']['output'];
  size: Maybe<Scalars['Float']['output']>;
  status: DerivativeContractStatus;
  tradeGroup: Scalars['String']['output'];
  underlyingInstrumentName: Scalars['String']['output'];
};

export type DerivativeContractConnection = {
  __typename: 'DerivativeContractConnection';
  edges: Array<DerivativeContractEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DerivativeContractEdge = {
  __typename: 'DerivativeContractEdge';
  cursor: Scalars['String']['output'];
  node: DerivativeContract;
};

export type DerivativeContractFilterArgs = {
  closedDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  closedDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<DerivativeContractStatus>;
};

export enum DerivativeContractStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export type DetailedPaymentUnion = CardDeposit | ClaimPayment | CreditTransfer | InternationalPayment;

export type DetailedPeriodicPaymentUnion = PeriodicCreditTransfer;

/** Returned when optUserOutOfCampaign operation does not find user or campaign. */
export type DidNotFindUserAndOrCampaignError = Error & {
  __typename: 'DidNotFindUserAndOrCampaignError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Online signature obtained with an electronic id */
export type DigitalSignatureDocument = Node & {
  __typename: 'DigitalSignatureDocument';
  completedSignatures: Maybe<Scalars['Int']['output']>;
  created: Scalars['DateTimeISO']['output'];
  documentDisplayName: Maybe<Scalars['String']['output']>;
  expires: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  minimumSignatures: Scalars['Int']['output'];
  /** How many signatures are left for this document */
  missingSignatures: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  ordered: Scalars['Boolean']['output'];
  /** Document owner kennitala */
  owner: Maybe<Scalars['String']['output']>;
  /** Document owner name */
  ownerName: Maybe<Scalars['String']['output']>;
  /** PDF of the digital signature document */
  pdf: Maybe<GenericFile>;
  /**
   * PDF (as a base64 string) of the digital signature document
   * @deprecated Rather use "pdf" from DigitalSignatureDocument | This field is used to circumvent an error that occurs for users with national tokens | Jira ticket to remove this: WEB-20081.
   */
  pdfAsBase64: Maybe<Scalars['String']['output']>;
  signatureSlots: Maybe<Array<DocumentSignatureSlot>>;
  signerGroups: Array<SignerGroup>;
  signersList: Array<DocumentSigner>;
  /** List of signers that have not signed the document and are eligible to sign it | There may be a duplicate signer if they hold multiple roles within the document. */
  signersThatCanSign: Array<DocumentSigner>;
  /** List of signers that have already signed this document | There may be a duplicate signer if they hold multiple roles within the document. */
  signersThatHaveSigned: Array<DocumentSigner>;
  status: DocumentSigningStatus;
  /** List of unique signers that can or have signed the document | There may be a duplicate signer if they hold multiple roles within the document. */
  uniqueSigners: Array<DocumentSigner>;
  /** Has the current user fully signed this document. Handles cases where the user has to sign multiple times the same document. */
  viewerHasSigned: Scalars['Boolean']['output'];
};

/** Online signature obtained with an electronic id | A group of digital signature objects */
export type DigitalSignatureGroup = Node & {
  __typename: 'DigitalSignatureGroup';
  completed: Scalars['Boolean']['output'];
  documentMetadataList: Array<DigitalSignatureDocument>;
  id: Scalars['ID']['output'];
  includesDeletedDocument: Scalars['Boolean']['output'];
  modified: Scalars['DateTimeISO']['output'];
  name: Scalars['String']['output'];
  nextDocumentToSign: Maybe<DigitalSignatureDocument>;
  /** ID (Global) of next document to sign in group. Use this if you do not want to make a secondary request to resolve the nextDocument */
  nextDocumentToSignId: Maybe<Scalars['ID']['output']>;
  /** Is true if multiple signatures are required to sign this group (can be multiple signers, multiple documents, multiple signatures on a single document) Used in the frontend to check if we should show a single signature or let the user choose what document to sign */
  requiresMultipleSignatures: Scalars['Boolean']['output'];
  viewerHasSignedGroup: Scalars['Boolean']['output'];
};

export type DigitalSignatureGroupConnection = {
  __typename: 'DigitalSignatureGroupConnection';
  edges: Array<DigitalSignatureGroupEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DigitalSignatureGroupEdge = {
  __typename: 'DigitalSignatureGroupEdge';
  cursor: Scalars['String']['output'];
  node: DigitalSignatureGroup;
};

export type DigitalSignatureGroupFilter = {
  needsSigning?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DigitalSignatureSlot = {
  __typename: 'DigitalSignatureSlot';
  signers: Array<Signer>;
};

/** Input to filter direct debit agreements */
export type DirectDebitAgreementFilterArgs = {
  /** Category code, 2 letter/digit (ISK: Textalykill) */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccount?: InputMaybe<Scalars['String']['input']>;
};

export type DirectDebitInitiation = Node & {
  __typename: 'DirectDebitInitiation';
  directDebitMandate: Maybe<DirectDebitMandate>;
  /** @deprecated Reason: Unused - only queried, but never referenced. Since: 2026-01-23. Issue to remove it: WEB-40153 */
  directDebitStatus: DirectDebitMandateStatus;
  errorSubject: Maybe<PaymentInitiationErrorSubject>;
  id: Scalars['ID']['output'];
  /** @deprecated Reason: Unused - only queried, but never referenced. Since: 2026-01-23. Issue to remove it: WEB-40152 */
  initiationType: InitiationType;
  /** @deprecated Reason: Unused - only queried, but never referenced. Since: 2026-01-23. Issue to remove it: WEB-40141 */
  paymentId: Maybe<Scalars['String']['output']>;
  /** @deprecated Reason: Unused - only queried, but never referenced. Since: 2026-01-23. Issue to remove it: WEB-40155 */
  pisId: Scalars['String']['output'];
  status: InitiationStatus;
};

/** DirectDebitMandate that user has applied for */
export type DirectDebitMandate = Node & {
  __typename: 'DirectDebitMandate';
  canBeCancelled: Scalars['Boolean']['output'];
  /**
   * Category code name
   * @deprecated This returns the category code name, not the code itself. Use categoryCodeV2 field for the code and categoryCodeName for the name. Since: 2026-02-12. Issue to remove it: https://jira.lais.net/browse/WEB-40754
   */
  categoryCode: Maybe<Scalars['String']['output']>;
  /** Direct debit mandate category code description. String with bank, code and name if available */
  categoryCodeDescription: Maybe<Scalars['String']['output']>;
  /** Direct debit mandate category code name */
  categoryCodeName: Maybe<Scalars['String']['output']>;
  /** Category code of the mandate, 2 letter/digit code */
  categoryCodeV2: Scalars['String']['output'];
  claimantKennitala: Scalars['String']['output'];
  claimantName: Maybe<Scalars['String']['output']>;
  /** Full name of user that registered the mandate */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber: Maybe<Scalars['String']['output']>;
  /** The signing date */
  date: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala: Maybe<Scalars['String']['output']>;
  /** Name of the payer */
  payorName: Maybe<Scalars['String']['output']>;
  /** The account node from which the direct debit mandate will be withdrawn, for direct debit agreements value will be null */
  withdrawalAccount: Maybe<Account>;
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Maybe<Scalars['String']['output']>;
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Maybe<Scalars['String']['output']>;
};

export type DirectDebitMandateConnection = {
  __typename: 'DirectDebitMandateConnection';
  edges: Array<DirectDebitMandateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DirectDebitMandateEdge = {
  __typename: 'DirectDebitMandateEdge';
  cursor: Scalars['String']['output'];
  node: DirectDebitMandate;
};

export type DirectDebitMandateError = Error & {
  __typename: 'DirectDebitMandateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type DirectDebitMandateFee = {
  __typename: 'DirectDebitMandateFee';
  /** Fee for creating a direct debit agreement */
  directDebitAgreementCreationFee: Maybe<Fee>;
};

export type DirectDebitMandateNotFound = Error & {
  __typename: 'DirectDebitMandateNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Node representing a direct debit mandate/agreement that user has ordered (ISK: Beingreiðslusamningur). */
export type DirectDebitMandateOrder = Node & {
  __typename: 'DirectDebitMandateOrder';
  /** Category code, 2 letters/digits (ISK: Textalykill) */
  categoryCode: Maybe<Scalars['String']['output']>;
  /** Branch number of the category code */
  categoryCodeBranch: Maybe<Scalars['String']['output']>;
  /** Direct debit mandate order category code description. String with bank, code and name if available */
  categoryCodeDescription: Maybe<Scalars['String']['output']>;
  /** Direct debit mandate order category code name */
  categoryCodeName: Maybe<Scalars['String']['output']>;
  /** Date of creation */
  creationDate: Maybe<Scalars['Date']['output']>;
  /** Customer number (ISK: Viðskiptanúmer) */
  customerNumber: Maybe<Scalars['String']['output']>;
  /** List of errors related to the order */
  errors: Maybe<Array<DirectDebitMandatesOrderError>>;
  /** ID (Global) for the direct debit mandate order */
  id: Scalars['ID']['output'];
  /** Payor kennitala (ISK: Kennitala greiðanda) */
  payorKennitala: Maybe<Scalars['String']['output']>;
  /** Status of the direct debit mandate order */
  status: Maybe<DirectDebitMandateOrderStatus>;
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Maybe<Scalars['String']['output']>;
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Maybe<Scalars['String']['output']>;
};

export type DirectDebitMandateOrderConnection = {
  __typename: 'DirectDebitMandateOrderConnection';
  edges: Array<DirectDebitMandateOrderEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DirectDebitMandateOrderEdge = {
  __typename: 'DirectDebitMandateOrderEdge';
  cursor: Scalars['String']['output'];
  node: DirectDebitMandateOrder;
};

export type DirectDebitMandateOrderFilterInput = {
  /** Show deleted orders (deleted failed direct debit agreements) */
  cleared?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter orders by status (failed/success) */
  status?: InputMaybe<DirectDebitMandateOrderStatus>;
};

/** Status of a direct debit mandate order */
export enum DirectDebitMandateOrderStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

/** Error type of a direct debit mandate order */
export enum DirectDebitMandateOrdersErrorType {
  BANK_NUMBER_NOT_AVAILABLE_TO_CLAIMANT = 'BANK_NUMBER_NOT_AVAILABLE_TO_CLAIMANT',
  CLAIMANT_ID_CATEGORY_CODE_COMBINATION_MISSING = 'CLAIMANT_ID_CATEGORY_CODE_COMBINATION_MISSING',
  DEPOSIT_ACCOUNT_DOES_NOT_EXIST = 'DEPOSIT_ACCOUNT_DOES_NOT_EXIST',
  INCORRECT_PIN_NUMBER_FOR_ACCOUNT = 'INCORRECT_PIN_NUMBER_FOR_ACCOUNT',
  INVALID_ACCOUNT_NUMBER = 'INVALID_ACCOUNT_NUMBER',
  INVALID_BRANCH_NUMBER = 'INVALID_BRANCH_NUMBER',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_FORMAT_CATEGORY_CODE = 'INVALID_FORMAT_CATEGORY_CODE',
  INVALID_FORMAT_CUSTOMER_NUMBER = 'INVALID_FORMAT_CUSTOMER_NUMBER',
  INVALID_FORMAT_PAYOR_KENNITALA = 'INVALID_FORMAT_PAYOR_KENNITALA',
  INVALID_FORMAT_SECURITY_CODE = 'INVALID_FORMAT_SECURITY_CODE',
  INVALID_FORMAT_WITHDRAWAL_ACCOUNT_ID = 'INVALID_FORMAT_WITHDRAWAL_ACCOUNT_ID',
  INVALID_FORMAT_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA = 'INVALID_FORMAT_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA',
  INVALID_KENNITALA = 'INVALID_KENNITALA',
  INVALID_KENNITALA_PAYOR_KENNITALA = 'INVALID_KENNITALA_PAYOR_KENNITALA',
  INVALID_KENNITALA_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA = 'INVALID_KENNITALA_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA',
  LENGTH_EXCEEDS_MAXIMUM = 'LENGTH_EXCEEDS_MAXIMUM',
  LENGTH_EXCEEDS_MAXIMUM_CUSTOMER_NUMBER = 'LENGTH_EXCEEDS_MAXIMUM_CUSTOMER_NUMBER',
  MANDATE_ALREADY_EXISTS = 'MANDATE_ALREADY_EXISTS',
  MISSING_REQUIRED_VALUE = 'MISSING_REQUIRED_VALUE',
  MISSING_REQUIRED_VALUE_CATEGORY_CODE = 'MISSING_REQUIRED_VALUE_CATEGORY_CODE',
  MISSING_REQUIRED_VALUE_CUSTOMER_NUMBER = 'MISSING_REQUIRED_VALUE_CUSTOMER_NUMBER',
  MISSING_REQUIRED_VALUE_PAYOR_KENNITALA = 'MISSING_REQUIRED_VALUE_PAYOR_KENNITALA',
  MISSING_REQUIRED_VALUE_SECURITY_CODE = 'MISSING_REQUIRED_VALUE_SECURITY_CODE',
  MISSING_REQUIRED_VALUE_WITHDRAWAL_ACCOUNT_ID = 'MISSING_REQUIRED_VALUE_WITHDRAWAL_ACCOUNT_ID',
  MISSING_REQUIRED_VALUE_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA = 'MISSING_REQUIRED_VALUE_WITHDRAWAL_ACCOUNT_OWNER_KENNITALA',
  PAYOR_NOT_FOUND = 'PAYOR_NOT_FOUND',
  SECURITY_CODE_MISSING = 'SECURITY_CODE_MISSING',
  SERVICE_ACCOUNT_NOT_FOUND = 'SERVICE_ACCOUNT_NOT_FOUND',
  SPECIFY_BRANCH_MORE_THAN_ONE_BRANCH_FOR_CATEGORY_CODE = 'SPECIFY_BRANCH_MORE_THAN_ONE_BRANCH_FOR_CATEGORY_CODE',
  UNKNOWN = 'UNKNOWN',
  WITHDRAWAL_ACCOUNT_AND_KENNITALA_DO_NOT_MATCH = 'WITHDRAWAL_ACCOUNT_AND_KENNITALA_DO_NOT_MATCH',
  WITHDRAWAL_ACCOUNT_NOT_FOUND = 'WITHDRAWAL_ACCOUNT_NOT_FOUND'
}

/** Boolean user permissions for direct debit mandates */
export type DirectDebitMandatePermissions = {
  __typename: 'DirectDebitMandatePermissions';
  /** User has authorization to create a direct debit agreement and correct a direct debit mandate order. */
  canCreate: Scalars['Boolean']['output'];
  /** User has access to direct debit mandates. User can edit a direct debit agreement, delete a direct debit agreement and delete a direct debit mandate order */
  hasAccessRole: Scalars['Boolean']['output'];
  /** User has a registered withdrawal account */
  hasServiceAccount: Scalars['Boolean']['output'];
};

export enum DirectDebitMandateStatus {
  Active = 'Active',
  /** This contract was declined by the user */
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Pending = 'Pending',
  Processing = 'Processing',
  Recalled = 'Recalled',
  /** This contract has been confirmed by the user and we have started processing the contract but it might still get rejected for several reasons. Normally the next status would be "Processing" or "Pending". */
  Received = 'Received',
  Rejected = 'Rejected',
  /** The contract execution is in processing but has been suspended, the system will retry the execution. This should not normally happen for contract initiations. */
  Suspended = 'Suspended',
  Unknown = 'Unknown',
  Validated = 'Validated',
  WaitsApproval = 'WaitsApproval'
}

export enum DirectDebitMandateType {
  CreditCard = 'CreditCard',
  IkClaim = 'IkClaim',
  RbLoan = 'RbLoan',
  bankLoan = 'bankLoan'
}

export type DirectDebitMandatesOrderError = {
  __typename: 'DirectDebitMandatesOrderError';
  errorCode: Maybe<Scalars['String']['output']>;
  errorContext: Maybe<Scalars['String']['output']>;
  errorMessage: Maybe<Scalars['String']['output']>;
  /** Enum value of error */
  errorType: Maybe<DirectDebitMandateOrdersErrorType>;
};

/** Does user want direct marketing */
export enum DirectMarketing {
  Allowed = 'Allowed',
  NotAllowed = 'NotAllowed',
  NotAnswered = 'NotAnswered',
  NotAvailable = 'NotAvailable'
}

export type DirectMarketingInput = {
  directMarketing: DirectMarketing;
};

export type DirectMarketingPayload = {
  __typename: 'DirectMarketingPayload';
  directMarketing: DirectMarketing;
};

/** Types of disclaimers that can be requested */
export enum DisclaimerType {
  /** Terms and conditions for payment card connection */
  PAYMENT_CARD_CONNECTION_TERMS = 'PAYMENT_CARD_CONNECTION_TERMS'
}

export type DismissNotificationBannerPayload = {
  __typename: 'DismissNotificationBannerPayload';
  error: Maybe<UpdateNotificationBannerErrorUnion>;
  /** The same notification message id that came from the input. */
  notificationBannerId: Scalars['String']['output'];
};

/** An object containing information about an amount of money that will become available for withdrawal at a certain date */
export type DisposableAmountInfo = {
  __typename: 'DisposableAmountInfo';
  /** Info for the total amount and the list of currently available amounts */
  availableAmounts: AvailableAmountInfo;
  /** Info for the total amount and the list of bound amounts */
  boundAmounts: BoundAmountInfo;
  /** Total amount that will never be bound again, most likely interest that is paid annually */
  neverBoundAgainAmount: CurrencyAmount;
};

export type DissmisNotificationBannerInput = {
  /** The id of the notification banner which also is the same id as the id of the message that is in the inbox that is connected to this notification. */
  notificationBannerId: Scalars['ID']['input'];
};

/** File extension of the document to be downloaded */
export enum DistributionPlanContentType {
  /** Excel document */
  EXCEL = 'EXCEL',
  /** PDF document */
  PDF = 'PDF'
}

export type DocumentBucket = {
  __typename: 'DocumentBucket';
  contentType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type DocumentPreference = Node & {
  __typename: 'DocumentPreference';
  id: Scalars['ID']['output'];
  modified: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sendInMail: Scalars['Boolean']['output'];
  type: ReceiptType;
};

/** Type of document that is missing for KYC */
export enum DocumentRequired {
  INDIRECT_OWNERSHIP = 'INDIRECT_OWNERSHIP',
  STAKEHOLDER_CHANGE = 'STAKEHOLDER_CHANGE',
  UNKNOWN = 'UNKNOWN'
}

/** Object that represent one signature (of possibly many) necessary slot to sign for the document to be signed */
export type DocumentSignatureSlot = {
  __typename: 'DocumentSignatureSlot';
  /** Tells if the document is signed or not */
  signed: Scalars['Boolean']['output'];
  signedByKennitala: Maybe<Scalars['String']['output']>;
  signedByName: Maybe<Scalars['String']['output']>;
  signers: Array<DocumentSigner>;
  signingDate: Maybe<Scalars['DateTimeISO']['output']>;
  signingText: Maybe<Scalars['String']['output']>;
};

/** Object with detail of a possible Signer */
export type DocumentSigner = {
  __typename: 'DocumentSigner';
  /** Signer's email */
  email: Maybe<Scalars['String']['output']>;
  /** Whether or not the signer has declined the electronic signature */
  hasDeclined: Scalars['Boolean']['output'];
  /** Whether or not the signer has signed the electronic signature */
  hasSigned: Scalars['Boolean']['output'];
  /** Signer's kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Signer's name */
  name: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  /** Date of signature */
  signed: Maybe<Scalars['DateTimeISO']['output']>;
  /** Additional text on signing */
  signingText: Maybe<Scalars['String']['output']>;
};

/** Object with detail of a possible Signer, a subset of DocumentSigner object */
export type DocumentSignerBase = {
  __typename: 'DocumentSignerBase';
  /** Signer's email */
  email: Maybe<Scalars['String']['output']>;
  /** Signer's kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Signer's name */
  name: Maybe<Scalars['String']['output']>;
  /** Additional text on signing */
  signingText: Maybe<Scalars['String']['output']>;
};

export enum DocumentSigningStatus {
  Cancelled = 'Cancelled',
  Deleted = 'Deleted',
  InReview = 'InReview',
  InSigning = 'InSigning',
  New = 'New',
  Rejected = 'Rejected',
  Reviewed = 'Reviewed',
  Signed = 'Signed',
  Unknown = 'Unknown'
}

/** Dropdown component */
export type DropdownFormComponent = FormComponentBase & {
  __typename: 'DropdownFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  options: Array<FormSelectOption>;
  placeholder: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export type DueDateRule = {
  __typename: 'DueDateRule';
  days: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  when: DueDateWhenType;
};

export enum DueDateWhenType {
  AfterCreationDate = 'AfterCreationDate',
  CurrentOrFollowingMonth = 'CurrentOrFollowingMonth'
}

export type DuplicateRegistration = Error & {
  __typename: 'DuplicateRegistration';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EditInvoiceScheduleErrorUnion = InvoiceScheduleFetchSchedulesError | InvoiceScheduleUnpaidClaimsCleanupError | UnknownError;

export type EditInvoiceScheduleInput = {
  /** Unique payor identification for claimant, used for direct debit - 16 chars max */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Description to be shown to the payor - 200 chars max */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Which day of the month should the dueDate be */
  dueDateDayOfMonth: Scalars['Int']['input'];
  /** The last possible due date of the claim created on this schedule */
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Which day of the month should the finalDueDate be */
  finalDueDateDayOfMonth: Scalars['Int']['input'];
  /** Principal amount of the claim to be created */
  principalAmount: Scalars['Float']['input'];
  /** If set - this is the reference month for the indexation calculations which will be added to the principalAmount each month. */
  principalAmountIndexDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Reference value to be put on each created claim - 16 chars max */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Unique id of the invoice schedule rule */
  scheduleId: Scalars['ID']['input'];
};

export type EditInvoiceSchedulePayload = {
  __typename: 'EditInvoiceSchedulePayload';
  error: Maybe<EditInvoiceScheduleErrorUnion>;
  invoiceSchedule: Maybe<InvoiceSchedule>;
};

/** Electronic Commerce Indicator (ECI). The ECI value is part of the 2 data elements that indicate the transaction was processed electronically. This should be passed on the authorization transaction to the Gateway/Processor */
export enum ElectronicCommerceIndicator {
  /** Attempted Authentication Transaction Mastercard (ECI: 01) */
  ATTEMPTED_AUTHENTICATION_TRANSACTION_MASTERCARD = 'ATTEMPTED_AUTHENTICATION_TRANSACTION_MASTERCARD',
  /** Attempted Authentication Transaction Visa (ECI: 06) */
  ATTEMPTED_AUTHENTICATION_TRANSACTION_VISA = 'ATTEMPTED_AUTHENTICATION_TRANSACTION_VISA',
  /** Fully Authenticated Transaction Mastercard (ECI: 02) */
  FULLY_AUTHENTICATED_TRANSACTION_MASTERCARD = 'FULLY_AUTHENTICATED_TRANSACTION_MASTERCARD',
  /** Fully Authenticated Transaction Visa (ECI: 05) */
  FULLY_AUTHENTICATED_TRANSACTION_VISA = 'FULLY_AUTHENTICATED_TRANSACTION_VISA',
  /** Non 3D Secure Transaction Mastercard (ECI: 00) */
  NON_3D_SECURE_TRANSACTION_MASTERCARD = 'NON_3D_SECURE_TRANSACTION_MASTERCARD',
  /** Non 3D Secure Transaction Visa (ECI: 07) */
  NON_3D_SECURE_TRANSACTION_VISA = 'NON_3D_SECURE_TRANSACTION_VISA',
  /** Unknown ECI value */
  UNKNOWN = 'UNKNOWN'
}

/** Electronic document meta data */
export type ElectronicDocument = Node & {
  __typename: 'ElectronicDocument';
  accountNumber: Maybe<Scalars['String']['output']>;
  /** @deprecated This field uses Bucket Service, which is deprecated. Use contentV2 instead. Removed: 2025-26-08. Issue to remove it: WEB-36497 */
  content: ElectronicDocumentContent;
  /** Electronic document content as HTML or PDF. Can return Adaptive Authentication step-up */
  contentV2: ElectronicDocumentContent;
  /** Electronic document content as HTML or PDF. Can return Adaptive Authentication step-up */
  contentV3: ElectronicDocumentContentResultV3;
  created: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPdf: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  /** A certain identification that is in association with the document, e.g. account number (tilvísun)) */
  reference: Maybe<Scalars['String']['output']>;
  senderKennitala: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
};


/** Electronic document meta data */
export type ElectronicDocumentContentV2Args = {
  contentDispositionType?: InputMaybe<ContentDispositionType>;
};


/** Electronic document meta data */
export type ElectronicDocumentContentV3Args = {
  contentDispositionType?: InputMaybe<ContentDispositionType>;
};

/** The query parameters that were applied to fetch the transactions in this connection. */
export type ElectronicDocumentAppliedQuery = {
  __typename: 'ElectronicDocumentAppliedQuery';
  period: CalendarPeriod;
};

/** Wrapper for paged electronic documents, along with possible types for user */
export type ElectronicDocumentConnection = {
  __typename: 'ElectronicDocumentConnection';
  /** The query parameters that were applied to fetch the transactions in this connection. */
  appliedQuery: ElectronicDocumentAppliedQuery;
  edges: Array<ElectronicDocumentEdge>;
  pageInfo: PageInfo;
  /** @deprecated Reason: We want to remove this from ElectronicDocumentConnection. Use relatedParties in ElectronicDocumentFilterOptions instead. Since: 2025-09-10. Issue to remove it: WEB-36819 */
  relatedParties: Array<ElectronicDocumentRelatedParty>;
  totalCount: Scalars['Int']['output'];
  /** @deprecated Reason: We want to remove this from ElectronicDocumentConnection. Use types in ElectronicDocumentFilterOptions instead. Since: 2025-09-10. Issue to remove it: WEB-36819 */
  types: Array<ElectronicDocumentType>;
};


/** Wrapper for paged electronic documents, along with possible types for user */
export type ElectronicDocumentConnectionTypesArgs = {
  kennitala?: InputMaybe<Scalars['String']['input']>;
};

export type ElectronicDocumentContent = ElectronicDocumentHtmlContent | ElectronicDocumentPdfBucketContent | GenericFile | RsaStepUpResponse;

export type ElectronicDocumentContentPayloadErrorUnion = UnknownError;

export type ElectronicDocumentContentPayloadResult = ElectronicDocumentHtmlContent | ElectronicDocumentPdfBucketContent | GenericFile;

export type ElectronicDocumentContentPayloadV3 = {
  __typename: 'ElectronicDocumentContentPayloadV3';
  error: Maybe<ElectronicDocumentContentPayloadErrorUnion>;
  result: Maybe<ElectronicDocumentContentPayloadResult>;
};

export type ElectronicDocumentContentResultV3 = AdaptiveAuthentication | ElectronicDocumentContentPayloadV3;

export type ElectronicDocumentEdge = {
  __typename: 'ElectronicDocumentEdge';
  cursor: Scalars['String']['output'];
  node: ElectronicDocument;
};

export enum ElectronicDocumentFilter {
  /** All electronic documents types. */
  ALL = 'ALL',
  /** Only documents that can never be digitally signed. */
  NOT_SIGNABLE = 'NOT_SIGNABLE',
  /** Only documents that can or have been signed. */
  SIGNABLE = 'SIGNABLE'
}

export type ElectronicDocumentFilterArgs = {
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Decides whether electronically signed documents are included */
  documentType?: InputMaybe<ElectronicDocumentFilter>;
  /** @deprecated Use calendarDateFrom instead. Since 2026-05-27; Issue to remove: WEB-43242 */
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use calendarDateTo instead. Since 2026-05-27; Issue to remove: WEB-43242 */
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
};

/** Filter options for electronic documents */
export type ElectronicDocumentFilterOptions = {
  __typename: 'ElectronicDocumentFilterOptions';
  /** Global ID of the filter options. Necessary for client caching. */
  id: Scalars['ID']['output'];
  /** List of related parties available for filtering */
  relatedParties: Array<ElectronicDocumentRelatedParty>;
  /** List of document types available for filtering */
  types: ElectronicDocumentTypeConnection;
};


/** Filter options for electronic documents */
export type ElectronicDocumentFilterOptionsTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ElectronicDocumentTypeFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** HTML Content for electronic document */
export type ElectronicDocumentHtmlContent = {
  __typename: 'ElectronicDocumentHtmlContent';
  content: Scalars['String']['output'];
};

/** Payslip entity */
export type ElectronicDocumentPayslip = {
  __typename: 'ElectronicDocumentPayslip';
  /** Date of the payslip creation */
  date: Scalars['DateTimeISO']['output'];
  /** ID (Global) of the payslip */
  id: Scalars['ID']['output'];
  /** Is payslip sent */
  isSent: Scalars['Boolean']['output'];
  /** Username of the sender */
  senderName: Scalars['String']['output'];
};

export type ElectronicDocumentPayslipConnection = {
  __typename: 'ElectronicDocumentPayslipConnection';
  edges: Array<ElectronicDocumentPayslipEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ElectronicDocumentPayslipEdge = {
  __typename: 'ElectronicDocumentPayslipEdge';
  cursor: Scalars['String']['output'];
  node: ElectronicDocumentPayslip;
};

/** Content for electronic document */
export type ElectronicDocumentPdfBucketContent = {
  __typename: 'ElectronicDocumentPdfBucketContent';
  /** @deprecated Uses Bucket Service, which is deprecated. Use GenericFile instead. Removed: 2025-26-08. Issue to remove it: WEB-36497 */
  document: DocumentBucket;
};

/** Possible individuals to fetch documents for */
export type ElectronicDocumentRelatedParty = {
  __typename: 'ElectronicDocumentRelatedParty';
  isOwner: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Electronic document type id's */
export type ElectronicDocumentType = {
  __typename: 'ElectronicDocumentType';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Wrapper for paged electronic document types */
export type ElectronicDocumentTypeConnection = {
  __typename: 'ElectronicDocumentTypeConnection';
  edges: Array<ElectronicDocumentTypeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ElectronicDocumentTypeEdge = {
  __typename: 'ElectronicDocumentTypeEdge';
  cursor: Scalars['String']['output'];
  node: ElectronicDocumentType;
};

export type ElectronicDocumentTypeFilterArgs = {
  kennitala?: InputMaybe<Scalars['String']['input']>;
};

/** Object that encapsulates electronic documents and additional data for electronic documents */
export type ElectronicDocumentsInfo = {
  __typename: 'ElectronicDocumentsInfo';
  /** Paged electronic documents for the user */
  documents: ElectronicDocumentConnection;
  filterOptions: ElectronicDocumentFilterOptions;
  /** Global ID of the electronic document payload. Necessary for client caching. */
  id: Scalars['ID']['output'];
  payslips: ElectronicDocumentPayslipConnection;
};


/** Object that encapsulates electronic documents and additional data for electronic documents */
export type ElectronicDocumentsInfoDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ElectronicDocumentFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Object that encapsulates electronic documents and additional data for electronic documents */
export type ElectronicDocumentsInfoPayslipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: PayslipsFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Eligible card holder for a given account id */
export type EligibleCardholderForDebitCard = {
  __typename: 'EligibleCardholderForDebitCard';
  fullName: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
};

export type EligibleCardholdersForDebitCardCreation = {
  __typename: 'EligibleCardholdersForDebitCardCreation';
  cardholders: Array<EligibleCardholderForDebitCard>;
  /** True if there are either multiple possible cardholders or if the only possible card holder is not the current viewer */
  hasMultipleCardholders: Scalars['Boolean']['output'];
};

/** User's email data */
export type Email = {
  __typename: 'Email';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
};

/** Email input component */
export type EmailFormComponent = FormComponentBase & {
  __typename: 'EmailFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  /**
   * Text to display during signing
   * @deprecated Unused by the web application and will be removed from form components.
   */
  signingText: Maybe<Scalars['String']['output']>;
  type: FormComponentType;
  validation: Maybe<FormComponentValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type EmailInput = {
  email: Scalars['String']['input'];
};

export type EmailLists = {
  __typename: 'EmailLists';
  fields: Array<MailingListInputFields>;
  mailingLists: Array<MailingLists>;
};

export type EmergencyClosurePayload = {
  __typename: 'EmergencyClosurePayload';
  /** Indication that the Emergency Closure has been requested successfully */
  success: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeeAccountAndKennitalaDoNotMatchError = Error & {
  __typename: 'EmployeeAccountAndKennitalaDoNotMatchError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EmployeeAlreadyExistsInPayrollError = Error & {
  __typename: 'EmployeeAlreadyExistsInPayrollError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EmployeeExcelCreationError = ExcelHeaderInvalidError | IncorrectExcelFileExtensionError | MissingValueInExcelDocumentError | TooManyExcelColumnsError | UnknownError;

/** Description of a failed insert of a row in employees Excel file */
export type EmployeeExcelFailedInsert = {
  __typename: 'EmployeeExcelFailedInsert';
  /** Error from the API regarding failed insert */
  error: Maybe<CreateEmployeeInPayrollError>;
  /** Kennitala of row that failed */
  kennitala: Maybe<Scalars['String']['output']>;
  /** In which line in the excel document did this insert fail? */
  line: Maybe<Scalars['Int']['output']>;
};

/** Information about each insertion | was it successful or unsuccessful */
export type EmployeeExcelInserts = {
  __typename: 'EmployeeExcelInserts';
  /** Array of each failed insertion from excel file with explanation */
  failed: Array<EmployeeExcelFailedInsert>;
  /** Employees that were successfully inserted from excel file */
  success: Array<PayrollEmployee>;
};

/** Contact information for Employee */
export type EmployeeInformation = {
  __typename: 'EmployeeInformation';
  email: Maybe<Scalars['String']['output']>;
  /** Employee's kennitala */
  id: Scalars['String']['output'];
  mobilePhone: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  workPhone: Maybe<Scalars['String']['output']>;
};

export type EmployeeInvalidAccountNumberError = Error & {
  __typename: 'EmployeeInvalidAccountNumberError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EmployeeInvalidKennitalaError = Error & {
  __typename: 'EmployeeInvalidKennitalaError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type EmployeeSearch = {
  __typename: 'EmployeeSearch';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
  workPhone: Scalars['String']['output'];
};

export type EmployeeSearchConnection = {
  __typename: 'EmployeeSearchConnection';
  edges: Array<EmployeeSearchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EmployeeSearchEdge = {
  __typename: 'EmployeeSearchEdge';
  cursor: Scalars['String']['output'];
  node: EmployeeSearch;
};

export type EndSavingGoalInput = {
  depositAccountId: Scalars['String']['input'];
  /** Graphql node id */
  id: Scalars['String']['input'];
};

export type EnrollCardToClickToPayErrorUnion = CardNotFoundError | ClickToPayNoAccessError | UnknownError;

export type EnrollCardToClickToPayInput = {
  /** The node id of the card */
  cardId: Scalars['ID']['input'];
  /** The email associated with Click to Pay */
  email: Scalars['String']['input'];
  /** The phone number associated with Click to Pay */
  phoneNumber: Scalars['String']['input'];
};

/** Returns EITHER the payload and no error OR no payload and an error. */
export type EnrollCardToClickToPayPayload = {
  __typename: 'EnrollCardToClickToPayPayload';
  clickToPayRequest: Maybe<ClickToPayRequest>;
  error: Maybe<EnrollCardToClickToPayErrorUnion>;
};

export type Error = {
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Estimate = {
  __typename: 'Estimate';
  amount: Scalars['Int']['output'];
  estimation: EstimationType;
};

export type EstimatedMarketOrder = {
  __typename: 'EstimatedMarketOrder';
  action: MarketInstrumentOrderAction;
  backLoadFee: Maybe<Scalars['Float']['output']>;
  backLoadFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  backLoadFeePercentage: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['DateTimeISO']['output']>;
  frontLoadFee: Maybe<Scalars['Float']['output']>;
  frontLoadFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  frontLoadFeePercentage: Maybe<Scalars['Float']['output']>;
  instrument: Instrument;
  orderAmount: Scalars['Float']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  serviceFee: Scalars['Float']['output'];
  totalFee: Scalars['Float']['output'];
  totalFeePercentage: Scalars['Float']['output'];
  totalPayment: Scalars['Float']['output'];
  transactionFee: Maybe<Scalars['Float']['output']>;
  transactionFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  transactionFeeMinimum: Maybe<Scalars['Float']['output']>;
  transactionFeePercentage: Maybe<Scalars['Float']['output']>;
};

export type EstimatedMarketOrderResult = AccountInsufficientAvailableToBuy | CustomerTradeNotAllowed | EstimatedMarketOrder | InvalidTypeFundOrder | MarketOrderMarketClosed | MinimumTradingOrderAmount | NotEnoughholdingError | OnlineTradeNotAvailableForInstrument | OrderBuyAccountNotAllowed | PortfolioBuyNotAllowed | PortfolioNotFound | PortfolioReadAccessError;

export type EstimatedMarketSubscription = {
  __typename: 'EstimatedMarketSubscription';
  amount: Scalars['Float']['output'];
  buyAmount: Maybe<Scalars['Float']['output']>;
  frontLoadFee: Maybe<Scalars['Float']['output']>;
  frontLoadFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  frontLoadFeePercentage: Maybe<Scalars['Float']['output']>;
  frontLoadFeeWithoutDiscountPercentage: Maybe<Scalars['Float']['output']>;
  nextPaymentDate: Scalars['DateTimeISO']['output'];
  totalFee: Maybe<Scalars['Float']['output']>;
  totalFeePercentage: Maybe<Scalars['Float']['output']>;
  tradeFee: Maybe<Scalars['Float']['output']>;
};

export type EstimatedMarketSubscriptionPayload = {
  __typename: 'EstimatedMarketSubscriptionPayload';
  estimatedSubscription: EstimatedMarketSubscription;
};

export type EstimatedMarketSubscriptionResult = EstimatedMarketSubscriptionPayload | MarketSubscriptionInstrumentNotAllowed | MaximumMarketSubscriptionAmountError | MinimumMarketSubscriptionAmountError;

export enum EstimationType {
  Completed = 'Completed',
  Failed = 'Failed',
  Invalid = 'Invalid',
  OffTrack = 'OffTrack',
  OnTrack = 'OnTrack',
  Unstarted = 'Unstarted'
}

/** EventRegistration */
export type EventRegistration = Node & {
  __typename: 'EventRegistration';
  id: Scalars['ID']['output'];
  maxNumberOfRegistrations: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  numberRegistered: Scalars['Int']['output'];
  registrationCloses: Scalars['DateTimeISO']['output'];
  registrationOpens: Scalars['DateTimeISO']['output'];
  status: Scalars['String']['output'];
  waitlistAvailable: Scalars['Boolean']['output'];
};

export type EventRegistrationAttribute = {
  __typename: 'EventRegistrationAttribute';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type EventRegistrationAttributeInput = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type EventRegistrationCustomerInput = {
  attributes?: InputMaybe<Array<EventRegistrationAttributeInput>>;
  companykennitala?: InputMaybe<Scalars['String']['input']>;
  companyname?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberRegistering: Scalars['Int']['input'];
  phonenumber?: InputMaybe<Scalars['String']['input']>;
};

export type EventRegistrationInput = {
  id: Scalars['String']['input'];
  model: EventRegistrationCustomerInput;
};

export type EventRegistrationPayload = {
  __typename: 'EventRegistrationPayload';
  attributes: Maybe<Array<EventRegistrationAttribute>>;
  companykennitala: Scalars['String']['output'];
  companyname: Scalars['String']['output'];
  email: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberRegistering: Scalars['Int']['output'];
  phonenumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExcelColumnsMustContainDataError = Error & FileValidationError & {
  __typename: 'ExcelColumnsMustContainDataError';
  /** The name of the column that caused the error. */
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /** The line number that caused the error. */
  row: Maybe<Scalars['Int']['output']>;
};

export type ExcelHeaderInvalidError = Error & {
  __typename: 'ExcelHeaderInvalidError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Currency exchange rates */
export type ExchangeRate = Node & {
  __typename: 'ExchangeRate';
  baseCurrency: Scalars['String']['output'];
  /** Not supported for source type: CentralBank */
  buy: Maybe<Scalars['Float']['output']>;
  /** Not supported for source type: Visa, CentralBank */
  change: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTimeISO']['output'];
  /** Not supported for source type: Visa */
  history: Maybe<ExchangeRateHistoryResponse>;
  id: Scalars['ID']['output'];
  mid: Scalars['Float']['output'];
  name: Maybe<Scalars['String']['output']>;
  quoteCurrency: Scalars['String']['output'];
  /** Not supported for source type: CentralBank */
  sell: Maybe<Scalars['Float']['output']>;
  /** TODO use ExchangeRateSource */
  source: Scalars['String']['output'];
};


/** Currency exchange rates */
export type ExchangeRateHistoryArgs = {
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  granularity?: InputMaybe<HistoryGranularity>;
};

export type ExchangeRateConnection = {
  __typename: 'ExchangeRateConnection';
  edges: Array<ExchangeRateEdge>;
  exchangeMarketStatus: MarketStatus;
  exchangeOpeningHours: Maybe<MarketOpeningHours>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExchangeRateEdge = {
  __typename: 'ExchangeRateEdge';
  cursor: Scalars['String']['output'];
  node: ExchangeRate;
};

/** The query parameters that were applied to fetch the exchange rates. */
export type ExchangeRateHistoryAppliedQuery = {
  __typename: 'ExchangeRateHistoryAppliedQuery';
  period: CalendarPeriod;
};

export type ExchangeRateHistoryEntries = {
  __typename: 'ExchangeRateHistoryEntries';
  /** The query parameters that were applied to fetch the exchange rates. */
  appliedQuery: ExchangeRateHistoryAppliedQuery;
  changes: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  entries: Array<ExchangeRateHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  open: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** ExchangeRateHistoryEntry */
export type ExchangeRateHistoryEntry = {
  __typename: 'ExchangeRateHistoryEntry';
  buy: Scalars['Float']['output'];
  /** Not supported for source type: CentralBank, Spot */
  change: Maybe<Scalars['Float']['output']>;
  date: Scalars['DateTimeISO']['output'];
  mid: Scalars['Float']['output'];
  sell: Scalars['Float']['output'];
};

export type ExchangeRateHistoryResponse = ExchangeRateHistoryEntries | HistoryTypeNotSupported;

/** What source to read rates from */
export enum ExchangeRateSource {
  CentralBank = 'CentralBank',
  Customs = 'Customs',
  General = 'General',
  Notes = 'Notes',
  Spot = 'Spot',
  Visa = 'Visa'
}

export enum ExchangeSymbol {
  All = 'All',
  FNIS = 'FNIS',
  XICE = 'XICE'
}

export type ExecutedPaymentsFilterArgs = {
  /** Payment amount from filter */
  amountFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Payment amount to filter */
  amountTo?: InputMaybe<Scalars['Float']['input']>;
  /** Filters by application channel (app/corporate bank/b2b) */
  applicationCode?: InputMaybe<PaymentApplicationCode>;
  /** Filter by currency of creditor account */
  creditorAccountCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Filter by creditor account number */
  creditorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Payment date from filter */
  dateFrom: Scalars['DateTimeISO']['input'];
  /** Payment date to filter */
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Filter by debtor account number */
  debtorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment currency */
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filters by payment type
   * @deprecated Single payment type filter will have less functionality in the api, use paymentTypes instead. Since: 2025-07. Issue to remove it: WEB-35778
   */
  paymentType?: InputMaybe<PaymentType>;
  /** Filters by multiple payment types */
  paymentTypes?: InputMaybe<Array<PaymentType>>;
  /** Filter by the kennitala of the payor */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Searches comma separated values (max 10) in the following columns Creditor name, Creditor kennitala, ultimate creditor name, ultimate creditor kennitala (where applicable), debtor reference, creditor reference, end to end id, remittance information unstructured */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter by username of person that performed the payment */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Filter options for executed payments */
export type ExecutedPaymentsFilterOptions = {
  __typename: 'ExecutedPaymentsFilterOptions';
  /** List of application codes possible to filter by */
  applicationCodes: Array<ApplicationCode>;
  /** List of currency codes possible to filter by */
  currencies: Array<Scalars['String']['output']>;
  /** List of accounts to filter payments by */
  debtorAccounts: Array<Account>;
  /** List of payment types possible to filter by */
  paymentTypes: Array<PaymentTypeWithDescription>;
  /** List of related parties possible to filter by */
  relatedParties: Array<RelatedParty>;
  /** List of users possible to filter by */
  users: Maybe<ExecutedPaymentsFilterUserConnection>;
};


/** Filter options for executed payments */
export type ExecutedPaymentsFilterOptionsUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExecutedPaymentsUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** User information for executed payments filter */
export type ExecutedPaymentsFilterUser = {
  __typename: 'ExecutedPaymentsFilterUser';
  /** User full name */
  name: Scalars['String']['output'];
  /** User's username */
  username: Scalars['String']['output'];
};

export type ExecutedPaymentsFilterUserConnection = {
  __typename: 'ExecutedPaymentsFilterUserConnection';
  edges: Array<ExecutedPaymentsFilterUserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExecutedPaymentsFilterUserEdge = {
  __typename: 'ExecutedPaymentsFilterUserEdge';
  cursor: Scalars['String']['output'];
  node: ExecutedPaymentsFilterUser;
};

export type ExecutedPaymentsUserFilterInput = {
  /** Filter by search string (name or kennitala) */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Details of the payor (IS: Greiðandi) */
export type ExpenseDistributionPayer = {
  __typename: 'ExpenseDistributionPayer';
  /** Details of the payments made */
  details: Maybe<Array<ExpenseDistributionPayerDetails>>;
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Details of the payments (expense/deposit) made */
export type ExpenseDistributionPayerDetails = {
  __typename: 'ExpenseDistributionPayerDetails';
  /** Account used for deposits */
  account: Scalars['String']['output'];
  amount: CurrencyAmount;
};

/** Expenses distribution overview (IS: Útgjaldadreifing) */
export type ExpensesDistribution = {
  __typename: 'ExpensesDistribution';
  /** End date of the distribution agreement */
  endDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  monthlyDeposits: Array<MonthlyDistribution>;
  monthlyExpenses: Array<MonthlyDistribution>;
  /** Start date of the distribution agreement */
  startDate: Scalars['Date']['output'];
};

export type ExpensesDistributionApplication = {
  __typename: 'ExpensesDistributionApplication';
  /** The current status of the expenses distribution application */
  status: ExpensesDistributionApplicationStatus;
};

/** The current status of a expenses distribution application. */
export enum ExpensesDistributionApplicationStatus {
  /** An active distribution plan exists. */
  COMPLETED = 'COMPLETED',
  /** No active distribution plan exists, but a CRM case for expenses distribution has been created and is in review */
  IN_REVIEW = 'IN_REVIEW',
  /** No active distribution plan exists and either no CRM case exists or a closed CRM case exists */
  NOT_STARTED = 'NOT_STARTED',
  /** Returned application status from API is unknown */
  UNKNOWN = 'UNKNOWN'
}

/** User with access to the expenses distribution overview and plan */
export type ExpensesDistributionUserAccess = {
  __typename: 'ExpensesDistributionUserAccess';
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExpensesDistributionUserAccessConnection = {
  __typename: 'ExpensesDistributionUserAccessConnection';
  edges: Array<ExpensesDistributionUserAccessEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExpensesDistributionUserAccessEdge = {
  __typename: 'ExpensesDistributionUserAccessEdge';
  cursor: Scalars['String']['output'];
  node: ExpensesDistributionUserAccess;
};

/** A bank account that a customer has provided consent to Landsbankinn to fetch from an external payment service provider */
export type ExternalAccount = Node & {
  __typename: 'ExternalAccount';
  /** Type of this account. Example "Current", "Savings", "Credit" */
  accountType: ExternalAccountType;
  /** Available amount to withdraw from the account */
  availableAmount: Scalars['Float']['output'];
  /** Total balance of the account */
  balance: Scalars['Float']['output'];
  /** Basic Bank Account Number (BBAN). Represents a country-specific bank account number */
  bban: Maybe<Scalars['String']['output']>;
  /** The consent made by a customer and provides this external account */
  consent: Maybe<ExternalAccountConsent>;
  /** The ISO 4217 currency code of the account */
  currency: Scalars['String']['output'];
  /** International Bank Account Number (IBAN) for the account */
  iban: Maybe<Scalars['String']['output']>;
  /** Global GraphQL identifier of this external account */
  id: Scalars['ID']['output'];
  /** Is the given account eligible for PIS */
  isEligibleForPayments: Scalars['Boolean']['output'];
  /** Name of the account */
  name: Scalars['String']['output'];
  /** The overdraft limit of the account */
  overdraftLimit: Scalars['Float']['output'];
  /** Kennitala of the owner of the account. */
  ownerKennitala: Scalars['String']['output'];
  provider: PaymentServiceProvider;
  /** A list of transactions made on this account */
  transactions: ExternalAccountTransactionConnection;
};


/** A bank account that a customer has provided consent to Landsbankinn to fetch from an external payment service provider */
export type ExternalAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalAccountTransactionFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

/** The query parameters that were applied to fetch the transactions in this connection. */
export type ExternalAccountAppliedQuery = {
  __typename: 'ExternalAccountAppliedQuery';
  period: CalendarPeriod;
};

/** Connection for a list of external accounts */
export type ExternalAccountConnection = {
  __typename: 'ExternalAccountConnection';
  edges: Array<ExternalAccountEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A consent a user has provided Landsbankinn to fetch bank accounts to an external payment service provider */
export type ExternalAccountConsent = Node & {
  __typename: 'ExternalAccountConsent';
  /** The external accounts this consent is valid for */
  accounts: Array<ExternalAccount>;
  /** Date when this consent was created */
  created: Scalars['DateTimeISO']['output'];
  /** Global GraphQL identifier of this consent */
  id: Scalars['ID']['output'];
  /** Date when this consent was last used */
  lastUsed: Scalars['DateTimeISO']['output'];
  provider: PaymentServiceProvider;
  /** Used when this consent is pending authorization */
  redirectUrl: Maybe<Scalars['String']['output']>;
  /** The state of this consent */
  status: ExternalConsentStatus;
  /** Date when this consent expires */
  validUntil: Scalars['DateTimeISO']['output'];
};

/** Connection for a list of external account consents */
export type ExternalAccountConsentConnection = {
  __typename: 'ExternalAccountConsentConnection';
  edges: Array<ExternalAccountConsentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAccountConsentEdge = {
  __typename: 'ExternalAccountConsentEdge';
  cursor: Scalars['String']['output'];
  node: ExternalAccountConsent;
};

/** Filter to use when querying for external account consents */
export type ExternalAccountConsentFilterArgs = {
  /** Filter by one or more possible states of consents */
  status?: InputMaybe<Array<ExternalConsentStatus>>;
};

export type ExternalAccountEdge = {
  __typename: 'ExternalAccountEdge';
  cursor: Scalars['String']['output'];
  node: ExternalAccount;
};

/** Filter to use when querying for external accounts */
export type ExternalAccountFilterArgs = {
  /** Show only accounts that can be used for payments */
  isEligibleForPayments?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Global GraphQL identifier of a payment service provider */
  providerId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter based on the consent status */
  status?: InputMaybe<ExternalConsentStatus>;
};

/** Financial transaction on external bank account */
export type ExternalAccountTransaction = Node & {
  __typename: 'ExternalAccountTransaction';
  /** The booked amount of this transaction */
  amount: Scalars['Float']['output'];
  /** The external accounts balance after this transaction was booked */
  balanceAfterTransaction: Scalars['Float']['output'];
  /** The date when this transaction was booked by external providers internal system */
  bookingDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The ISO 4217 currency code of this transaction */
  currency: Scalars['String']['output'];
  /** Description of the text key (Textalykill) for the transaction, e.g. "Millifærsla" */
  description: Maybe<Scalars['String']['output']>;
  /** Text description that was provided when the transaction was made */
  displayText: Scalars['String']['output'];
  /** Global GraphQL identifier of the external account that this transaction belongs to */
  externalAccountId: Scalars['ID']['output'];
  /** Global GraphQL identifier of this external account transaction. The identifier is composed of transactionId and accountId separated by a colon. */
  id: Scalars['ID']['output'];
  /** The date when this transaction was issued by the external account owner */
  transactionDate: Scalars['DateTimeISO']['output'];
};

/** Connection for a list of external account transactions */
export type ExternalAccountTransactionConnection = {
  __typename: 'ExternalAccountTransactionConnection';
  /** The query parameters that were applied to fetch the transactions in this connection. */
  appliedQuery: ExternalAccountAppliedQuery;
  edges: Array<ExternalAccountTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ExternalAccountTransactionEdge = {
  __typename: 'ExternalAccountTransactionEdge';
  cursor: Scalars['String']['output'];
  node: ExternalAccountTransaction;
};

/** Filter to use when querying for external accounts */
export type ExternalAccountTransactionFilterArgs = {
  /** Text description that was provided when the transaction was made */
  displayText?: InputMaybe<Scalars['String']['input']>;
};

/** Type of an external account */
export enum ExternalAccountType {
  CREDIT = 'CREDIT',
  CURRENT = 'CURRENT',
  SAVINGS = 'SAVINGS',
  UNKNOWN = 'UNKNOWN'
}

/** Possible states of an external consent */
export enum ExternalConsentStatus {
  /** The consent has expired and cannot be used anymore to fetch external information */
  EXPIRED = 'EXPIRED',
  /** The consent is valid */
  VALID = 'VALID'
}

/** Vehicle loan applicant lookup result */
export type ExternalVehicleLoanApplicantLookupResults = {
  __typename: 'ExternalVehicleLoanApplicantLookupResults';
  name: Scalars['String']['output'];
};

/** Vehicle loan application */
export type ExternalVehicleLoanApplication = Node & {
  __typename: 'ExternalVehicleLoanApplication';
  applicationDate: Scalars['DateTimeISO']['output'];
  /** Amount deposited for vehicle */
  depositAmount: Maybe<CurrencyAmount>;
  details: Maybe<ExternalVehicleLoanApplicationDetails>;
  /** Get the documents of the vehicle loan application */
  documents: Array<ExternalVehicleLoanApplicationDocument>;
  id: Scalars['ID']['output'];
  /** Total vehicle loan amount */
  loanAmount: CurrencyAmount;
  mainApplicantKennitala: Maybe<Scalars['String']['output']>;
  mainApplicantName: Maybe<Scalars['String']['output']>;
  /** Get list of payment instructions on this vehicle loan application */
  paymentInstructions: Array<ExternalVehicleLoanApplicationPaymentInstruction>;
  /** Registration number of the vehicle being bought */
  registrationNumber: Maybe<Scalars['String']['output']>;
  /** Get the signers of the vehicle loan application */
  signers: Array<ExternalVehicleLoanApplicationSigner>;
  status: VehicleLoanApplicationStatus;
  /** Total amount paid from bank */
  totalAmount: CurrencyAmount;
  /** Kennitala of the vehicle dealership */
  vehicleBrokerKennitala: Maybe<Scalars['String']['output']>;
  vehicleLoanType: VehicleLoanType;
};

/** Vehicle loan application applicant */
export type ExternalVehicleLoanApplicationApplicant = {
  __typename: 'ExternalVehicleLoanApplicationApplicant';
  /** Type of applicant */
  applicantType: VehicleLoanApplicationApplicantType;
  email: Maybe<Scalars['String']['output']>;
  kennitala: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type ExternalVehicleLoanApplicationApplicantInput = {
  /** The type of applicant */
  applicantType: VehicleLoanApplicationApplicantType;
  /** The email of the applicant */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The kennitala of the applicant */
  kennitala: Scalars['String']['input'];
  /** The phone number of the applicant */
  phoneNumber: Scalars['String']['input'];
};

/** Insurance company available to choose from when creating a vehicle loan application */
export type ExternalVehicleLoanApplicationAvailableInsuranceCompany = {
  __typename: 'ExternalVehicleLoanApplicationAvailableInsuranceCompany';
  /** Kennitala of the insurance company */
  kennitala: Scalars['String']['output'];
  /** Name of the insurance company */
  name: Scalars['String']['output'];
};

export type ExternalVehicleLoanApplicationConnection = {
  __typename: 'ExternalVehicleLoanApplicationConnection';
  edges: Array<ExternalVehicleLoanApplicationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Information about an accessible dealership */
export type ExternalVehicleLoanApplicationDealership = {
  __typename: 'ExternalVehicleLoanApplicationDealership';
  /** Kennitala of the dealership */
  kennitala: Scalars['String']['output'];
  /** Name of the dealership */
  name: Scalars['String']['output'];
};

/** Vehicle loan application details */
export type ExternalVehicleLoanApplicationDetails = {
  __typename: 'ExternalVehicleLoanApplicationDetails';
  /** List of applicants */
  applicants: Array<ExternalVehicleLoanApplicationApplicant>;
  /** Optional comment when application was created */
  comment: Maybe<Scalars['String']['output']>;
  /** Description of denial reason. Only populated if application is declined because something is wrong with the vehicle */
  declinedReason: Maybe<Scalars['String']['output']>;
  /** The date the vehicle was first registered */
  firstRegistrationDate: Maybe<Scalars['Date']['output']>;
  /** The interest rate of the loan */
  interestRate: Maybe<Scalars['Float']['output']>;
  /** The cost of taking out the loan */
  loanCost: CurrencyAmount;
  /** Loan duration in months */
  loanDurationMonths: Maybe<Scalars['Int']['output']>;
  /** The monthly payment of the loan */
  monthlyPayment: Maybe<CurrencyAmount>;
  /** Ratio of loan amount to the value of the vehicle being purchased (veðhlutfall) */
  mortgageRatio: Maybe<Scalars['Float']['output']>;
  /** The price of the vehicle */
  price: Maybe<CurrencyAmount>;
  /** trade-in vehicle registration number if any */
  tradeInVehicleRegistrationNumber: Maybe<Scalars['String']['output']>;
  /** The specific model or variant of the vehicle (e.g., Model S, Mustang, Corolla) */
  vehicleSubType: Scalars['String']['output'];
  /** The make or brand of the vehicle (e.g., Tesla, Ford, Toyota) */
  vehicleType: Scalars['String']['output'];
};

/** A document associated with an external vehicle loan application */
export type ExternalVehicleLoanApplicationDocument = Node & {
  __typename: 'ExternalVehicleLoanApplicationDocument';
  createdDate: Scalars['DateTimeISO']['output'];
  /** PDF (as a base64 string) of the document */
  documentContentAsBase64: Maybe<Scalars['String']['output']>;
  documentName: Maybe<Scalars['String']['output']>;
  documentType: LoanApplicationDocumentType;
  id: Scalars['ID']['output'];
};

export type ExternalVehicleLoanApplicationEdge = {
  __typename: 'ExternalVehicleLoanApplicationEdge';
  cursor: Scalars['String']['output'];
  node: ExternalVehicleLoanApplication;
};

export type ExternalVehicleLoanApplicationNoAccessError = Error & {
  __typename: 'ExternalVehicleLoanApplicationNoAccessError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Vehicle loan application payment instruction */
export type ExternalVehicleLoanApplicationPaymentInstruction = {
  __typename: 'ExternalVehicleLoanApplicationPaymentInstruction';
  /** Account that the instruction's action will affect */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Name of the owner of the claim */
  claimOwnerName: Maybe<Scalars['String']['output']>;
  /** Payment instruction ID */
  id: Scalars['ID']['output'];
  /** Kennitala of the owner of the account */
  payorKennitala: Maybe<Scalars['String']['output']>;
  /** Name of the owner of the account */
  payorName: Maybe<Scalars['String']['output']>;
  /** Amount to be paid */
  totalPaidAmount: CurrencyAmount;
  /** Type of payment instruction */
  type: VehicleLoanApplicationPaymentInstructionType;
};

/** Vehicle loan application payment instruction */
export type ExternalVehicleLoanApplicationSigner = {
  __typename: 'ExternalVehicleLoanApplicationSigner';
  /** Signer's email */
  email: Maybe<Scalars['String']['output']>;
  /** Whether or not the signer has signed all documents */
  hasSigned: Scalars['Boolean']['output'];
  /** Signer's kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Signer's name */
  name: Maybe<Scalars['String']['output']>;
  /** Additional text on signing */
  signingText: Maybe<Scalars['String']['output']>;
};

export type ExternalVehicleLoanApplicationTradeInInput = {
  /** Vehicle registration number (Fastanúmer) */
  registrationNumber: Scalars['String']['input'];
  /** Deposit amount */
  tradeInAmount: Scalars['Float']['input'];
};

/** Vehicle information */
export type ExternalVehicleLoanApplicationVehicleInformation = {
  __typename: 'ExternalVehicleLoanApplicationVehicleInformation';
  /** Permanent number of the vehicle (Fastanúmer). Unique and cannot be changed */
  permanentNumber: Scalars['String']['output'];
  /** Vehicle registration date */
  registrationDate: Scalars['Date']['output'];
  /** Registration number of the vehicle (Bílnúmer) */
  registrationNumber: Scalars['String']['output'];
  /** The subtype of the vehicle */
  subType: Scalars['String']['output'];
  /** The type of the vehicle */
  type: Scalars['String']['output'];
};

export type ExternalVehicleLoanApplicationsSearchFilterArgs = {
  /** Loan applicant kennitala (individual or company) */
  applicantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Loan applicant name */
  applicantName?: InputMaybe<Scalars['String']['input']>;
  /** Search for applications created from this date */
  createdFromDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Search for applications created to this date */
  createdToDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Vehicle registration number (Fastanúmer) */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter by list of loan application statuses */
  status?: InputMaybe<Array<VehicleLoanApplicationStatus>>;
};

export type ExternalVehicleLoanCalculationInput = {
  /** Kennitala of the dealership which is used for all external vehicle sources */
  dealershipKennitala: Scalars['String']['input'];
  /** True if applying for corporate loan */
  isCompany: Scalars['Boolean']['input'];
  /** Loan amount */
  loanAmount: Scalars['Float']['input'];
  /** Loan duration in months */
  loanDurationMonths?: InputMaybe<Scalars['Int']['input']>;
  /** The price of the vehicle */
  price: Scalars['Float']['input'];
  /** Vehicle registration number (Fastanúmer) */
  registrationNumber: Scalars['String']['input'];
};

/** Vehicle loan calculation result */
export type ExternalVehicleLoanCalculationResult = {
  __typename: 'ExternalVehicleLoanCalculationResult';
  interestRate: Scalars['Float']['output'];
  loanOptions: Array<ExternalVehicleLoanOption>;
  maxLoanDurationMonths: Scalars['Int']['output'];
  mortgageRatio: Scalars['Float']['output'];
};

export type ExternalVehicleLoanCalculationResultErrorUnion = UnknownError;

export type ExternalVehicleLoanCalculationResultPayload = {
  __typename: 'ExternalVehicleLoanCalculationResultPayload';
  error: Maybe<ExternalVehicleLoanCalculationResultErrorUnion>;
  externalVehicleLoanCalculations: Maybe<ExternalVehicleLoanCalculationResult>;
};

/** Vehicle loan option */
export type ExternalVehicleLoanOption = {
  __typename: 'ExternalVehicleLoanOption';
  firstPaymentAmount: CurrencyAmount;
  loanDurationMonths: Scalars['Int']['output'];
};

export type ExternalVehicleLoans = {
  __typename: 'ExternalVehicleLoans';
  /** Get list of insurance companies available to choose from when creating a external vehicle loan application */
  availableVehicleLoanApplicationInsuranceCompanies: Array<ExternalVehicleLoanApplicationAvailableInsuranceCompany>;
  /** Kennitala of the dealership which is used for all external vehicle sources */
  dealershipKennitala: Scalars['String']['output'];
  /** Get vehicle loan applicant lookup result */
  vehicleLoanApplicantLookup: Maybe<ExternalVehicleLoanApplicantLookupResults>;
  /** Get vehicle information from registration number */
  vehicleLoanApplicationVehicleInformation: Maybe<ExternalVehicleLoanApplicationVehicleInformation>;
  /** Returns list of external vehicle loan applications that are being handled by the car dealership requested */
  vehicleLoanApplications: ExternalVehicleLoanApplicationConnection;
};


export type ExternalVehicleLoansVehicleLoanApplicantLookupArgs = {
  kennitala: Scalars['String']['input'];
};


export type ExternalVehicleLoansVehicleLoanApplicationVehicleInformationArgs = {
  registrationNumber: Scalars['String']['input'];
};


export type ExternalVehicleLoansVehicleLoanApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalVehicleLoanApplicationsSearchFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The quality of the face in the uploaded image is too low */
export type FaceQualityTooLowError = Error & {
  __typename: 'FaceQualityTooLowError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Failed deletion of a direct debit agreement */
export type FailedDirectDebitAgreementDeletion = {
  __typename: 'FailedDirectDebitAgreementDeletion';
  /** Error causing the deletion to fail */
  error: Maybe<DeleteDirectDebitAgreementErrorUnion>;
  /** ID (Global) of agreement that could not be deleted */
  id: Scalars['ID']['output'];
};

export type FailedPaymentNotificationPayload = {
  __typename: 'FailedPaymentNotificationPayload';
  error: SendPaymentNotificationErrors;
  handle: Scalars['String']['output'];
};

/** User's family member */
export type FamilyMember = {
  __typename: 'FamilyMember';
  /** Family member's age */
  age: Maybe<Scalars['Float']['output']>;
  /** Family member's birthplace, two-digit ISO country code */
  birthplaceId: Maybe<Scalars['String']['output']>;
  /** Family member's gender */
  gender: FamilyMemberGender;
  /** National ID (ísl. kennitala) of the family member */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Family member's name */
  name: Maybe<Scalars['String']['output']>;
  /** Family member's nationality, two-digit ISO country code */
  nationalityId: Maybe<Scalars['String']['output']>;
  /** Family member's type, e.g. spouse, child, custodian */
  type: FamilyMemberType;
};

export type FamilyMemberFilterArgs = {
  /** Filter family members by their relationship type to the customer */
  types?: InputMaybe<Array<FamilyMemberType>>;
};

/** Family member's gender */
export enum FamilyMemberGender {
  /** Female gender. */
  FEMALE = 'FEMALE',
  /** Male gender. */
  MALE = 'MALE',
  /** Non-binary gender. */
  NON_BINARY = 'NON_BINARY',
  /** Unknown gender. */
  UNKNOWN = 'UNKNOWN'
}

/** The type of the family member. */
export enum FamilyMemberType {
  /** Child. */
  CHILD = 'CHILD',
  /** Custodian. */
  CUSTODIAN = 'CUSTODIAN',
  /** Spouse. */
  SPOUSE = 'SPOUSE',
  /** Unknown. */
  UNKNOWN = 'UNKNOWN'
}

/** Favorite accounts widget */
export type FavoriteAccountsWidget = {
  __typename: 'FavoriteAccountsWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type Feature = {
  __typename: 'Feature';
  featureType: FeatureType;
  isOn: Scalars['Boolean']['output'];
};

export type FeatureLookupResponse = Feature;

export enum FeatureType {
  UNKNOWN = 'UNKNOWN'
}

export type Fee = Node & {
  __typename: 'Fee';
  children: Array<Fee>;
  currency: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  footnote: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parentId: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  type: FeeType;
  validFrom: Scalars['DateTimeISO']['output'];
  value: Maybe<Scalars['Float']['output']>;
};

export enum FeeType {
  Amount = 'Amount',
  Information = 'Information',
  Label = 'Label',
  Percentage = 'Percentage'
}

/** Status of a customer feedback invitation to take a survey. */
export type FeedbackInvitation = {
  __typename: 'FeedbackInvitation';
  /** Yields the status of the feedback invitation. */
  status: FeedbackInvitationStatus;
};

export enum FeedbackInvitationStatus {
  ANSWERED = 'ANSWERED',
  EXPIRED = 'EXPIRED',
  NOT_ANSWERED = 'NOT_ANSWERED',
  NOT_FOUND = 'NOT_FOUND'
}

/** File upload component */
export type FileFormComponent = FormComponentBase & {
  __typename: 'FileFormComponent';
  accept: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  maxFileSizeMB: Maybe<Scalars['Int']['output']>;
  maxFiles: Maybe<Scalars['Int']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

/** An error that provides better context when dealing with file validation. */
export type FileValidationError = {
  /** The name of the column that caused the error. */
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  /** The line number that caused the error. */
  row: Maybe<Scalars['Int']['output']>;
};

export type FinalDueDateRule = {
  __typename: 'FinalDueDateRule';
  days: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  when: FinalDueDateWhenType;
};

export enum FinalDueDateWhenType {
  AfterDueDate = 'AfterDueDate'
}

export type FinancialStatement = {
  __typename: 'FinancialStatement';
  /** Excel file of the statement, if it exists */
  excel: Maybe<GenericFile>;
  /** ID (Global) of the financial statement period */
  id: Scalars['ID']['output'];
  /** Month of the statement period */
  month: Scalars['String']['output'];
  /** PDF of the statement, if it exists */
  pdf: Maybe<GenericFile>;
  /** Year of the statement period */
  year: Scalars['String']['output'];
};

export type FinancialStatementsSubscription = {
  __typename: 'FinancialStatementsSubscription';
  /** Date when the subscription was created */
  createdDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Customer identifier for the subscription */
  customerId: Maybe<Scalars['Int']['output']>;
  /** How often financial statements are delivered */
  frequency: FinancialStatementsSubscriptionFrequency;
  /** ID (Global) of the financial statements subscription */
  id: Scalars['ID']['output'];
  /** Payment status returned for the subscription */
  paymentStatus: Maybe<FinancialStatementsSubscriptionPaymentStatus>;
  /** Termination date for the subscription, if it has been scheduled for termination */
  terminationDate: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Frequency of a financial statements subscription */
export enum FinancialStatementsSubscriptionFrequency {
  MONTHLY = 'MONTHLY'
}

/** Payment status of a financial statements subscription */
export enum FinancialStatementsSubscriptionPaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID'
}

/** Summary information for user, for bank accounts, credit cards etc */
export type FinancialSummary = {
  __typename: 'FinancialSummary';
  claimPayers: Array<ClaimPayer>;
  /** Total amount of selected credit cards available amount. */
  creditCardAvailableAmountSummary: Scalars['Float']['output'];
  /** Summary of selected cards balance. Will be negative for debt and positive for positive balance. */
  creditCardBalanceSummary: Scalars['Float']['output'];
  /** Summary of selected cards debt. Will be negative for debt and positive for positive balance. */
  creditCardDebtSummary: Scalars['Float']['output'];
  creditCards: CreditCardConnection;
  /** Total available amount of selected currency accounts. */
  currencyAccountAvailableAmountSummary: Scalars['Float']['output'];
  /** Total balance of selected currency accounts. */
  currencyAccountBalanceSummary: Scalars['Float']['output'];
  /** Total amount of selected currency accounts. */
  currencyAccountSummary: Scalars['Float']['output'];
  /** Currency accounts user can select for financial summary. */
  currencyAccounts: AccountConnection;
  /** Total available amount of selected current accounts. */
  currentAccountAvailableAmountSummary: Scalars['Float']['output'];
  /** Total balance of selected current accounts. */
  currentAccountBalanceSummary: Scalars['Float']['output'];
  /** Total amount of selected current accounts. */
  currentAccountSummary: Scalars['Float']['output'];
  /** Type of summary to show for current account. */
  currentAccountSummaryType: AccountSummaryType;
  /** Current accounts user can select for financial summary. */
  currentAccounts: AccountConnection;
  /** Total amount of unpaid bills for the current month. */
  currentMonthUnpaidBillSummary: Scalars['Float']['output'];
  /** Is true if user has currency accounts */
  hasCurrencyAccounts: Scalars['Boolean']['output'];
  /** Is true if user has currency accounts and any of them are included in summary settings. */
  hasCurrencyAccountsSelectedInSummary: Scalars['Boolean']['output'];
  /** Is true if user has current accounts. */
  hasCurrentAccounts: Scalars['Boolean']['output'];
  /** Is true if user has current accounts and any of them are included in summary settings. */
  hasCurrentAccountsSelectedInSummary: Scalars['Boolean']['output'];
  /** Is true if user has savings accounts. */
  hasSavingAccounts: Scalars['Boolean']['output'];
  /** Is true if user has savings accounts and any of them are included in summary settings. */
  hasSavingAccountsSelectedInSummary: Scalars['Boolean']['output'];
  /** Is true if user has selected any credit cards. */
  hasSelectedCreditCards: Scalars['Boolean']['output'];
  /** Is true if user has selected any prepaid cards. */
  hasSelectedPrepaidCards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Types of claims to show in the summary */
  includedClaimTypes: Array<ClaimSummaryType>;
  /** Total amount of selected prepaid cards available amount. */
  prepaidCardAvailableAmountSummary: Scalars['Float']['output'];
  /** Saving accounts user can select for financial summary. */
  savingAccounts: AccountConnection;
  /** Total available amount of selected savings accounts. */
  savingsAccountAvailableAmountSummary: Scalars['Float']['output'];
  /** Total balance of selected savings accounts. */
  savingsAccountBalanceSummary: Scalars['Float']['output'];
  /** Total amount of selected savings accounts. */
  savingsAccountSummary: Scalars['Float']['output'];
  /** Type of summary to show for savings account. */
  savingsAccountSummaryType: AccountSummaryType;
  /** Is true if user has selected any credit cards. */
  showCreditCardSummary: Scalars['Boolean']['output'];
  /** Is true if user has selected any prepaid cards. */
  showPrepaidCardSummary: Scalars['Boolean']['output'];
  /** Total amount of unpaid bills. */
  unpaidBillSummary: Scalars['Float']['output'];
};


/** Summary information for user, for bank accounts, credit cards etc */
export type FinancialSummaryCreditCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Summary information for user, for bank accounts, credit cards etc */
export type FinancialSummaryCurrencyAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Summary information for user, for bank accounts, credit cards etc */
export type FinancialSummaryCurrentAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Summary information for user, for bank accounts, credit cards etc */
export type FinancialSummarySavingAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Flow = {
  __typename: 'Flow';
  feeAmount: Scalars['Float']['output'];
  interestAmount: Scalars['Float']['output'];
  interestIndexAmount: Scalars['Float']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  paymentNumber: Scalars['Float']['output'];
  principalAmount: Scalars['Float']['output'];
  principalIndexAmount: Scalars['Float']['output'];
  principalRemainder: Scalars['Float']['output'];
  principalRemainderBeforePayment: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type ForeignBankInformation = {
  __typename: 'ForeignBankInformation';
  address: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  isSepaValid: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type ForeignExchangeMarket = {
  __typename: 'ForeignExchangeMarket';
  isMarketOpen: Scalars['Boolean']['output'];
};

export type ForeignLegalAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
};

export type ForeignRecipient = {
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type FormComponent = AccountNumberFormComponent | ButtonFormComponent | CheckboxFormComponent | DateFormComponent | DropdownFormComponent | EmailFormComponent | FileFormComponent | GroupFormComponent | HiddenFormComponent | InfoFormComponent | KennitalaFormComponent | NumberFormComponent | PhoneFormComponent | RadioFormComponent | RepeatableFormComponent | SectionFormComponent | SubmitFormComponent | TextFormComponent | TextareaFormComponent | UnknownFormComponent;

/** Base interface for all form components */
export type FormComponentBase = {
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

/** Conditional rule that determines when a form component becomes required */
export type FormComponentRequiredWhen = {
  __typename: 'FormComponentRequiredWhen';
  dependsOnComponentId: Scalars['String']['output'];
  operator: FormRequiredWhenOperator;
  value: Maybe<Scalars['String']['output']>;
};

/** The type of a form component */
export enum FormComponentType {
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  BUTTON = 'BUTTON',
  CHECKBOX = 'CHECKBOX',
  DATE = 'DATE',
  DROPDOWN = 'DROPDOWN',
  EMAIL = 'EMAIL',
  FILE = 'FILE',
  GROUP = 'GROUP',
  HIDDEN = 'HIDDEN',
  INFO = 'INFO',
  KENNITALA = 'KENNITALA',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RADIO = 'RADIO',
  REPEATABLE = 'REPEATABLE',
  SECTION = 'SECTION',
  SUBMIT = 'SUBMIT',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  UNKNOWN = 'UNKNOWN'
}

/** Validation rules for a form component */
export type FormComponentValidation = {
  __typename: 'FormComponentValidation';
  message: Maybe<Scalars['String']['output']>;
  pattern: Maybe<Scalars['String']['output']>;
};

/** Form definition containing structure and components */
export type FormDefinition = {
  __typename: 'FormDefinition';
  components: Array<FormComponent>;
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  version: Maybe<Scalars['String']['output']>;
};

/** The display format of a number form component */
export enum FormNumberFormat {
  CURRENCY = 'CURRENCY',
  DECIMAL = 'DECIMAL',
  INTEGER = 'INTEGER',
  PERCENTAGE = 'PERCENTAGE',
  UNKNOWN = 'UNKNOWN'
}

/** The condition operator that determines when a form component becomes required */
export enum FormRequiredWhenOperator {
  EQUALS = 'EQUALS',
  HAS_VALUE = 'HAS_VALUE',
  IS_COMPANY_KENNITALA = 'IS_COMPANY_KENNITALA',
  UNKNOWN = 'UNKNOWN'
}

/** A selectable option in a form component */
export type FormSelectOption = {
  __typename: 'FormSelectOption';
  label: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** A form template with its definition */
export type FormTemplate = Node & {
  __typename: 'FormTemplate';
  definition: Maybe<FormDefinition>;
  description: Maybe<Scalars['String']['output']>;
  formId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Maybe<FormTemplateOwner>;
  title: Maybe<Scalars['String']['output']>;
};

export type FormTemplateConnection = {
  __typename: 'FormTemplateConnection';
  edges: Array<FormTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FormTemplateEdge = {
  __typename: 'FormTemplateEdge';
  cursor: Scalars['String']['output'];
  node: FormTemplate;
};

/** The owner of the form template */
export enum FormTemplateOwner {
  LANDSBANKINN = 'LANDSBANKINN',
  TM = 'TM',
  UNKNOWN = 'UNKNOWN'
}

/** Market data for a fund */
export type Fund = Node & {
  __typename: 'Fund';
  allowedOrderTypes: Maybe<Array<MarketInstrumentOrderType>>;
  annualizedReturns: AnnualizedReturns;
  ask: Scalars['Float']['output'];
  /** Only for ETF funds */
  assetComposition: Maybe<FundAssetCompositionConnection>;
  /** Only for mutual funds */
  backLoadFee: Maybe<MarketFee>;
  bid: Scalars['Float']['output'];
  /** @deprecated Use categoryId and categoryDisplayName instead. The category is not a true representation of the real data. Since: 2026-09-22. Issue to remove it: WEB-46106 */
  category: FundCategory;
  /** Translated display name for the group, e.g 'Skuldabréfasjóðir' */
  categoryDisplayName: Scalars['String']['output'];
  categoryId: Scalars['Int']['output'];
  classification: FundClassification;
  cumulativeReturns: CumulativeReturns;
  currency: Scalars['String']['output'];
  date: Maybe<Scalars['DateTimeISO']['output']>;
  details: Maybe<FundDetails>;
  /** Only for mutual funds */
  frontLoadFee: Maybe<MarketFee>;
  history: FundHistory;
  /** Only for authenticated users */
  holdings: Maybe<PortfolioHoldingConnection>;
  id: Scalars['ID']['output'];
  intradayNetAssetValue: Maybe<Scalars['Float']['output']>;
  isBuyAllowed: Scalars['Boolean']['output'];
  isSellAllowed: Scalars['Boolean']['output'];
  isSubscriptionAllowed: Scalars['Boolean']['output'];
  lastTradeDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Only for mutual funds */
  managementFeePercentage: Maybe<Scalars['Float']['output']>;
  maximumSubscriptionAmount: Maybe<Scalars['Float']['output']>;
  minimumBuyOrderAmount: Maybe<Scalars['Float']['output']>;
  minimumSellOrderAmount: Maybe<Scalars['Float']['output']>;
  minimumSubscriptionAmount: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  netAssetValue: Scalars['Float']['output'];
  nominalReturns: Array<NominalReturns>;
  /** Refers to the real time lowest price at which a seller will sell. This is the market price when buying. Only use when creating order for ETF's (exchange traded funds) for authenticated users. Is `null` when market is closed. */
  realTimeAsk: Maybe<Scalars['Float']['output']>;
  /** Refers to the real time highest price at which a buyer will buy. This is the market price when selling. Only use when creating order for ETF's (exchange traded funds) for authenticated users. Is `null` when market is closed. */
  realTimeBid: Maybe<Scalars['Float']['output']>;
  /** Only use when creating order for ETF's (exchange traded funds) for authenticated users. Is `null` when market is closed. */
  realTimeLast: Maybe<Scalars['Float']['output']>;
  serviceFee: Maybe<Scalars['Float']['output']>;
  shortName: Scalars['String']['output'];
  strategy: Maybe<Array<FundStrategy>>;
  /** Only for authenticated users */
  subscription: Maybe<MarketSubscriptionConnection>;
  symbol: Scalars['String']['output'];
  /** Only for ETF funds */
  transactionFee: Maybe<MarketFee>;
  updated: Maybe<Scalars['DateTimeISO']['output']>;
};


/** Market data for a fund */
export type FundAssetCompositionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Market data for a fund */
export type FundHistoryArgs = {
  from: Scalars['DateTimeISO']['input'];
  to: Scalars['DateTimeISO']['input'];
};


/** Market data for a fund */
export type FundHoldingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Market data for a fund */
export type FundSubscriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Entry in the price history of a fund */
export type FundAssetComposition = {
  __typename: 'FundAssetComposition';
  id: Scalars['ID']['output'];
  quantity: Scalars['Float']['output'];
  symbol: Scalars['String']['output'];
  type: AssetCompositionType;
};

export type FundAssetCompositionConnection = {
  __typename: 'FundAssetCompositionConnection';
  edges: Array<FundAssetCompositionEdge>;
  lastUpdated: Scalars['DateTimeISO']['output'];
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FundAssetCompositionEdge = {
  __typename: 'FundAssetCompositionEdge';
  cursor: Scalars['String']['output'];
  node: FundAssetComposition;
};

export enum FundCategory {
  AllianceBernstein = 'AllianceBernstein',
  BalancedFund = 'BalancedFund',
  BondFund = 'BondFund',
  EquityFund = 'EquityFund',
  ExchangeTradedFund = 'ExchangeTradedFund',
  GovernmentBondFund = 'GovernmentBondFund',
  MoneyMarketFund = 'MoneyMarketFund',
  PrivateBankingFund = 'PrivateBankingFund',
  ShortTermFund = 'ShortTermFund',
  UknownCategory = 'UknownCategory'
}

export enum FundClassification {
  BalancedFund = 'BalancedFund',
  BondsFund = 'BondsFund',
  EquityFund = 'EquityFund',
  ExchangeTradedFund = 'ExchangeTradedFund',
  PrivateBankingFund = 'PrivateBankingFund',
  UknownClassification = 'UknownClassification'
}

export type FundConnection = {
  __typename: 'FundConnection';
  edges: Array<FundEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Details for a fund */
export type FundDetails = {
  __typename: 'FundDetails';
  assistantFundManager: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not use - use backLoadFee -> feePercentage in the root */
  backLoadFeePercentage: Maybe<Scalars['Float']['output']>;
  benchmark: Maybe<Scalars['String']['output']>;
  bloombergId: Maybe<Scalars['String']['output']>;
  buySettlementDays: Maybe<Scalars['Float']['output']>;
  closeTime: Maybe<Scalars['String']['output']>;
  created: Maybe<Scalars['DateTimeISO']['output']>;
  documents: Maybe<Array<FundDocument>>;
  domicile: Maybe<Scalars['String']['output']>;
  /** Fee (percentage) applicable to a fund in order to be part of the exchange, as well as other operating costs. */
  exchangeFeesPercentage: Maybe<Scalars['Float']['output']>;
  /** @deprecated Reason: Use factSheetDocumentV2 instead. Since: 2026-03-20. Issue to remove it: WEB-41646 */
  factSheetDocument: DocumentBucket;
  factSheetDocumentV2: Maybe<GenericFile>;
  /** @deprecated Do not use - use frontLoadFee -> feePercentage in the root */
  frontLoadFeePercentage: Maybe<Scalars['Float']['output']>;
  fundManager: Maybe<Scalars['String']['output']>;
  isin: Maybe<Scalars['String']['output']>;
  kennitala: Maybe<Scalars['String']['output']>;
  /** @deprecated Reason: Use keyInformationDocumentV2 instead. Since: 2026-03-20. Issue to remove it: WEB-41646 */
  keyInformationDocument: DocumentBucket;
  keyInformationDocumentV2: Maybe<GenericFile>;
  /** @deprecated Do not use - use management fee in the root */
  managementFeePercentage: Maybe<Scalars['Float']['output']>;
  marketCap: Maybe<Scalars['Float']['output']>;
  marketCapFullDenomination: Maybe<Scalars['Float']['output']>;
  /** @deprecated Do not use - use minimumBuyOrderAmount in the root */
  minimumInvestment: Maybe<Scalars['Float']['output']>;
  onlineBuyAllowed: Maybe<Scalars['Boolean']['output']>;
  onlineSellAllowed: Maybe<Scalars['Boolean']['output']>;
  openTime: Maybe<Scalars['String']['output']>;
  /** The cost (percentage) of operating the fund. */
  otherAdministrativeOrOperatingCostsPercentage: Maybe<Scalars['Float']['output']>;
  /** Fee (percentage) that the fund owner withholds if the fund performs too well. Applicable only for some funds. */
  performanceFeePercentage: Maybe<Scalars['Float']['output']>;
  /** Expected cost (percentage) of buying and selling the fund's instruments. */
  portfolioTransactionCostPercentage: Maybe<Scalars['Float']['output']>;
  riskRating: Maybe<Scalars['Float']['output']>;
  sellSettlementDays: Maybe<Scalars['Float']['output']>;
  subscriptionAvailable: Maybe<Scalars['Boolean']['output']>;
  subscriptionFrontLoadFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  subscriptionTransactionFee: Maybe<Scalars['Float']['output']>;
  /** @deprecated Reason: Use taxationDocumentV2 instead. Since: 2026-03-20. Issue to remove it: WEB-41646 */
  taxationDocument: DocumentBucket;
  taxationDocumentV2: Maybe<GenericFile>;
  /** @deprecated Reason: Use tenderDocumentV2 instead. Since: 2026-03-20. Issue to remove it: WEB-41646 */
  tenderDocument: DocumentBucket;
  tenderDocumentV2: Maybe<GenericFile>;
  transactionFee: Maybe<Scalars['Float']['output']>;
  type: Maybe<FundType>;
  ucitsClassification: Maybe<Scalars['String']['output']>;
};

/** A static document available for a fund */
export type FundDocument = {
  __typename: 'FundDocument';
  created: Maybe<Scalars['DateTimeISO']['output']>;
  description: Maybe<Scalars['String']['output']>;
  file: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  uri: Maybe<Scalars['String']['output']>;
};

export type FundEdge = {
  __typename: 'FundEdge';
  cursor: Scalars['String']['output'];
  node: Fund;
};

/** Price history of a fund */
export type FundHistory = {
  __typename: 'FundHistory';
  changes: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  entries: Array<FundHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  open: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** Entry in the price history of a fund */
export type FundHistoryEntry = {
  __typename: 'FundHistoryEntry';
  close: Scalars['Float']['output'];
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  /** The closing price of the nearest preceding trading day */
  previousClose: Maybe<Scalars['Float']['output']>;
  /** The date of the nearest preceding trading day */
  previousCloseDate: Maybe<Scalars['DateTimeISO']['output']>;
};

export type FundKnowledgeInupt = {
  fundId: Scalars['String']['input'];
  hasKnowledge: Scalars['Boolean']['input'];
};

/** If you want the highest or lowest month return in funds */
export enum FundOrder {
  Low = 'Low',
  Rise = 'Rise'
}

/** Fund strategy */
export type FundStrategy = {
  __typename: 'FundStrategy';
  assetClass: Maybe<Scalars['String']['output']>;
  current: Maybe<Scalars['Float']['output']>;
  fundId: Maybe<Scalars['String']['output']>;
  maximum: Maybe<Scalars['Float']['output']>;
  minimum: Maybe<Scalars['Float']['output']>;
};

export enum FundType {
  Etf = 'Etf',
  MutualFund = 'MutualFund'
}

export enum GdprUpdateType {
  Correction = 'Correction',
  Deletion = 'Deletion',
  Limitation = 'Limitation'
}

export enum GenderType {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other'
}

/** Detail information for general insurance */
export type GeneralInsurancePolicyPreview = {
  __typename: 'GeneralInsurancePolicyPreview';
  description: Scalars['String']['output'];
  documents: Array<InsurancePolicyDocumentMeta>;
  /** The insurance amount */
  insuranceAmount: Maybe<CurrencyAmount>;
};

export enum GeneralKnowledgeAssessment {
  Advanced = 'Advanced',
  Basic = 'Basic',
  Informed = 'Informed',
  None = 'None'
}

/** General loan application request */
export type GeneralLoanApplication = {
  __typename: 'GeneralLoanApplication';
  /** Datetime when the application was created */
  createdDate: Scalars['DateTimeISO']['output'];
  /** ID (Global) of the general loan application */
  id: Scalars['ID']['output'];
  /** Requested loan amount */
  loanAmount: CurrencyAmount;
  /** Requested loan duration in months */
  loanDurationMonths: Scalars['Int']['output'];
  /** Purpose of the loan. Description supplied by the user */
  loanPurpose: Scalars['String']['output'];
  /** Status of the loan application */
  status: LoanApplicationStatus;
};

export type GeneralLoanApplicationAlreadyExistsError = Error & {
  __typename: 'GeneralLoanApplicationAlreadyExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Success data result for create general loan application */
export type GeneralLoanApplicationSuccessData = {
  __typename: 'GeneralLoanApplicationSuccessData';
  /** The created general loan application */
  application: GeneralLoanApplication;
  /** Whether the attachment upload was successful. Always true if there were no attachments */
  uploadAttachmentSuccess: Scalars['Boolean']['output'];
};

/** Represents a file */
export type GenericFile = {
  __typename: 'GenericFile';
  /** The MIME type of the file */
  mimeType: Maybe<Scalars['String']['output']>;
  /** The URL for the file */
  url: Scalars['URL']['output'];
};

export type GetCardResultUnion = CreditCard | CreditCardServiceUnavailable;

export type GetClaimPayersPayload = {
  __typename: 'GetClaimPayersPayload';
  payers: Array<ClaimPayer>;
};

export type GetLiabilityGuaranteesFilterInput = {
  /** Filter by guarantee category */
  category?: InputMaybe<LiabilityGuaranteeCategory>;
  /** Filter guarantees by owner kennitala. Default is acting kennitala in token. */
  ownerKennitala?: InputMaybe<Scalars['String']['input']>;
};

/** Input for retrieving the digital signature group to sign for a company being onboarded */
export type GetOnboardingCorporateDigitalSignatureGroupInput = {
  /** Onboarding application ID (Global) */
  applicationId: Scalars['ID']['input'];
  /** Kennitala of the company being onboarded */
  companyKennitala: Scalars['String']['input'];
};

export type GiftCard = Node & {
  __typename: 'GiftCard';
  /** Checks if the user can add this card to Apple Wallet. */
  appleWalletCardStatus: AppleWalletCardStatus;
  availableAmount: Scalars['Float']['output'];
  /** Allow card to be registered with mobile wallet products. */
  canAddToPaymentService: Scalars['Boolean']['output'];
  cardId: Scalars['Int']['output'];
  cardNumberFormatted: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Pan ID is used for registering card with mobile wallet products. */
  panId: Maybe<Scalars['String']['output']>;
  transactions: Array<GiftCardTransaction>;
};

export type GiftCardConnection = {
  __typename: 'GiftCardConnection';
  edges: Array<GiftCardEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GiftCardEdge = {
  __typename: 'GiftCardEdge';
  cursor: Scalars['String']['output'];
  node: GiftCard;
};

export type GiftCardLookupResponse = GiftCard | GiftCardNotFound;

export type GiftCardNotFound = {
  __typename: 'GiftCardNotFound';
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GiftCardTransaction = {
  __typename: 'GiftCardTransaction';
  billingAmount: CurrencyAmount;
  date: Scalars['DateTimeISO']['output'];
  foreignAmount: Maybe<CurrencyAmount>;
  merchantName: Maybe<Scalars['String']['output']>;
  message: Maybe<Scalars['String']['output']>;
};

export type GiveConversationFeedbackInput = {
  /** Id of the conversation. */
  conversationId: Scalars['ID']['input'];
  /** The feedback the user is giving. */
  feedback: ConversationFeedback;
  /** The text the user sends with his/her feedback. */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type GiveConversationSubjectInput = {
  /** Id of the conversation. */
  conversationId: Scalars['ID']['input'];
  /** The subject name the user is giving the conversation. If null then it removes the subject name the user has given. */
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type GiveFeedbackResponsePayload = {
  __typename: 'GiveFeedbackResponsePayload';
  /** Is true if it was successful to give a feedback. */
  success: Scalars['Boolean']['output'];
};

/** Third party grants used by third party applications */
export type Grant = Node & {
  __typename: 'Grant';
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issued: Scalars['DateTimeISO']['output'];
  records: A2ARecordConnection;
  scopes: Array<Scalars['String']['output']>;
  updated: Scalars['DateTimeISO']['output'];
};


/** Third party grants used by third party applications */
export type GrantRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type GrantConnection = {
  __typename: 'GrantConnection';
  edges: Array<GrantEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GrantEdge = {
  __typename: 'GrantEdge';
  cursor: Scalars['String']['output'];
  node: Grant;
};

/** Group container component */
export type GroupFormComponent = FormComponentBase & {
  __typename: 'GroupFormComponent';
  components: Array<FormComponent>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

/** Hate content was detected in the uploaded image */
export type HateContentDetectedError = Error & {
  __typename: 'HateContentDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Hidden input component */
export type HiddenFormComponent = FormComponentBase & {
  __typename: 'HiddenFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export enum HistoryGranularity {
  OneDay = 'OneDay',
  OneHour = 'OneHour'
}

export type HistoryTypeNotSupported = Error & {
  __typename: 'HistoryTypeNotSupported';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type HoldingFilterArgs = {
  instrumentId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<HoldingType>;
};

/** Portfolio holding summaries */
export type HoldingSummaries = {
  __typename: 'HoldingSummaries';
  /** Holding summaries */
  summaries: Array<HoldingSummary>;
  /** Calculated total amount of the portfolio holdings */
  totalAmount: CurrencyAmount;
};

/** Holding summary data */
export type HoldingSummary = {
  __typename: 'HoldingSummary';
  /** Holding amount of the holding type */
  holdingAmount: CurrencyAmount;
  /** Id of the holding summary */
  id: Scalars['ID']['output'];
  /** Type of holding */
  type: HoldingSummaryType;
};

export enum HoldingSummaryType {
  BOND = 'BOND',
  DEPOSIT = 'DEPOSIT',
  FUND = 'FUND',
  STOCK = 'STOCK'
}

/** Holding type */
export enum HoldingType {
  Bond = 'Bond',
  Deposit = 'Deposit',
  Fund = 'Fund',
  Stock = 'Stock'
}

/** Detail information for home insurance */
export type HomeInsurancePolicyPreview = {
  __typename: 'HomeInsurancePolicyPreview';
  address: Maybe<Scalars['String']['output']>;
  documents: Array<InsurancePolicyDocumentMeta>;
  /** The insurance amount */
  householdGoodsAmount: Maybe<CurrencyAmount>;
  unitLabel: Maybe<Scalars['String']['output']>;
};

export type IbanBankInformationResponse = BankNotFound | ForeignBankInformation | IbanNotValid;

export type IbanNotValid = Error & {
  __typename: 'IbanNotValid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type IbanStructure = Node & {
  __typename: 'IbanStructure';
  /** Position of the bank identifier in the IBAN number */
  bankIdentifierPosition: Scalars['Int']['output'];
  /** Two letter country code */
  countryCode: Scalars['String']['output'];
  /** Length of the national id in the IBAN number */
  ibanNationalIdLength: Scalars['Int']['output'];
  /** Total length of the IBAN number */
  ibanTotalLength: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Is the IBAN number the only allowed account identifier for SEPA/CrossBorder to this country */
  isIbanOnly: Scalars['Boolean']['output'];
  /** Is the country part of the SEPA zone */
  isSepaSupported: Scalars['Boolean']['output'];
};

export type IbanStructureFilterArgs = {
  isIbanOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Icelandair loyalty system information */
export type IcelandairLoyalty = {
  __typename: 'IcelandairLoyalty';
  /** The amount of points in the loyalty system (Vildarpunktar) */
  sagaPoints: Scalars['Float']['output'];
};

/** The status of saved identification i.e. rafræn skilríki, skönnuð skilríki */
export enum IdentificationStatus {
  Active = 'Active',
  Expired = 'Expired',
  NoIds = 'NoIds'
}

/** Image block for custom content */
export type ImageBlock = {
  __typename: 'ImageBlock';
  /** An object with cdn url's of the asset used for the header. */
  asset: CustomContentImageAsset;
  background: ContentBackground;
};

/** The uploaded image does not meet the required size constraints */
export type ImageSizeNotCorrectError = Error & {
  __typename: 'ImageSizeNotCorrectError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InboxConversationConnection = {
  __typename: 'InboxConversationConnection';
  edges: Array<CustomerConversationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InboxMessageConnection = {
  __typename: 'InboxMessageConnection';
  edges: Array<CustomerInboxMessageEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncomeRatioInfo = {
  __typename: 'IncomeRatioInfo';
  active: Scalars['Boolean']['output'];
  methodType: SavingMethodType;
  payors: Array<PayorInfo>;
  ratio: Scalars['Float']['output'];
  savingMethodId: Maybe<Scalars['String']['output']>;
};

export type IncomeSource = {
  __typename: 'IncomeSource';
  lastThreeMonthsAveragePerMonth: Scalars['Int']['output'];
  payorId: Scalars['String']['output'];
  payorName: Scalars['String']['output'];
};

export type IncorrectExcelFileExtensionError = Error & {
  __typename: 'IncorrectExcelFileExtensionError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum IndexType {
  Indexed = 'Indexed',
  NotIndexed = 'NotIndexed'
}

export type IndexTypeLookUpType = {
  __typename: 'IndexTypeLookUpType';
  /** The ID of the index type */
  id: Scalars['String']['output'];
  /** TODO use IndexType */
  name: Scalars['String']['output'];
};

/** Indexation */
export type Indexation = Node & {
  __typename: 'Indexation';
  created: Maybe<Scalars['DateTimeISO']['output']>;
  history: IndexationHistory;
  id: Scalars['ID']['output'];
  last12MonthsPercentageDifference: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  updated: Maybe<Scalars['DateTimeISO']['output']>;
  value: Maybe<Scalars['Float']['output']>;
  valueDate: Maybe<Scalars['DateTimeISO']['output']>;
  yearPercentageDifference: Maybe<Scalars['Float']['output']>;
};


/** Indexation */
export type IndexationHistoryArgs = {
  from: Scalars['DateTimeISO']['input'];
  to: Scalars['DateTimeISO']['input'];
};

export type IndexationConnection = {
  __typename: 'IndexationConnection';
  edges: Array<IndexationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IndexationEdge = {
  __typename: 'IndexationEdge';
  cursor: Scalars['String']['output'];
  node: Indexation;
};

/** Price history of a indexation */
export type IndexationHistory = {
  __typename: 'IndexationHistory';
  changes: Scalars['Float']['output'];
  changesPercentageDifference: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  closePercentageDifference: Maybe<Scalars['Float']['output']>;
  entries: Array<IndexationHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  highestPercentageDifference: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  lowestPercentageDifference: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  open: Maybe<Scalars['Float']['output']>;
  openPercentageDifference: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** Entry in the history of a indexation */
export type IndexationHistoryEntry = {
  __typename: 'IndexationHistoryEntry';
  createdUtc: Maybe<Scalars['DateTimeISO']['output']>;
  last12MonthsPercentageDifference: Maybe<Scalars['Float']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
  updatedUtc: Maybe<Scalars['DateTimeISO']['output']>;
  value: Maybe<Scalars['Float']['output']>;
  valueDate: Maybe<Scalars['DateTimeISO']['output']>;
  yearPercentageDifference: Maybe<Scalars['Float']['output']>;
};

/** Indice */
export type Indice = Node & {
  __typename: 'Indice';
  dayNominalDifference: Maybe<Scalars['Float']['output']>;
  dayPercentageDifference: Maybe<Scalars['Float']['output']>;
  highValue: Maybe<Scalars['Float']['output']>;
  history: IndiceHistory;
  id: Scalars['ID']['output'];
  last12MonthsNominalDifference: Maybe<Scalars['Float']['output']>;
  last12MonthsPercentageDifference: Maybe<Scalars['Float']['output']>;
  lowValue: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openValue: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  turnover: Maybe<Scalars['Float']['output']>;
  turnoverCurrency: Maybe<Scalars['String']['output']>;
  updatedUtc: Maybe<Scalars['DateTimeISO']['output']>;
  value: Maybe<Scalars['Float']['output']>;
  yearPercentageDifference: Maybe<Scalars['Float']['output']>;
  yearsNominalDifference: Maybe<Scalars['Float']['output']>;
};


/** Indice */
export type IndiceHistoryArgs = {
  from: Scalars['DateTimeISO']['input'];
  to: Scalars['DateTimeISO']['input'];
};

export type IndiceConnection = {
  __typename: 'IndiceConnection';
  edges: Array<IndiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IndiceEdge = {
  __typename: 'IndiceEdge';
  cursor: Scalars['String']['output'];
  node: Indice;
};

/** Price history of a indice */
export type IndiceHistory = {
  __typename: 'IndiceHistory';
  changes: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  entries: Array<IndiceHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  open: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** Entry in the price history of a indice */
export type IndiceHistoryEntry = {
  __typename: 'IndiceHistoryEntry';
  name: Maybe<Scalars['String']['output']>;
  turnover: Maybe<Scalars['Float']['output']>;
  updatedUtc: Maybe<Scalars['DateTimeISO']['output']>;
  value: Maybe<Scalars['Float']['output']>;
};

/** Informational display component */
export type InfoFormComponent = FormComponentBase & {
  __typename: 'InfoFormComponent';
  content: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

export type InitialPaymentDataUnion = CardDepositInitialPaymentData | ClaimPaymentInitialPaymentData | CreditTransferInitialPaymentData;

export type InitialPeriodicPaymentDataUnion = PeriodicCreditTransferInitialPaymentData;

export type InitializeSignatureProcessForAudkenniInput = {
  /** (Global) ID of digitalSignatureGroup */
  digitalSignatureGroupId: Scalars['ID']['input'];
};

/** Information regarding signature for Audkenni */
export type InitializeSignatureProcessForAudkenniPayload = {
  __typename: 'InitializeSignatureProcessForAudkenniPayload';
  /** 4 number code shown that represents the number that appears on the user's screen when authenticating */
  code: Maybe<Scalars['String']['output']>;
  /** Signature id necessary for Audkenni */
  signatureId: Maybe<Scalars['String']['output']>;
};

/** Result from initialization of Audkenni process */
export type InitializeSignatureProcessForAudkenniResult = {
  __typename: 'InitializeSignatureProcessForAudkenniResult';
  /** Error returned after an unsuccessful initialization */
  error: Maybe<SignDigitalSignatureGroupDocumentsError>;
  /** Payload of a successful initialization */
  payload: Maybe<InitializeSignatureProcessForAudkenniPayload>;
};

export type InitiatePaymentApprovalProcessInput = {
  payments: Array<PaymentApprovalProcessInput>;
};

/**
 * Response type for the initiatePaymentApprovalProcess mutation
 * Contains the initiated payment approval processes and any errors that occurred during the process
 */
export type InitiatePaymentApprovalProcessResponse = {
  __typename: 'InitiatePaymentApprovalProcessResponse';
  errors: Array<PaymentApprovalProcessError>;
  processes: Array<NewPaymentApprovalProcessResponse>;
};

/** Mismatch in exchange offers when initiating signing basket */
export type InitiateSigningBasketExchangeRateCurrenciesMismatchError = Error & {
  __typename: 'InitiateSigningBasketExchangeRateCurrenciesMismatchError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** An error occurred during payment initiation */
export type InitiateStoredPaymentError = Error & {
  __typename: 'InitiateStoredPaymentError';
  error: Scalars['String']['output'];
  errorSubject: PaymentInitiationErrorSubject;
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  pisId: Scalars['String']['output'];
};

export type InitiateStoredPaymentsInput = {
  batches?: InputMaybe<StoredBatchPaymentInput>;
  cardDeposits?: InputMaybe<StoredPaymentInput>;
  claims?: InputMaybe<StoredPaymentInput>;
  creditTransfers?: InputMaybe<StoredPaymentInput>;
  crossBorderTransfers?: InputMaybe<StoredPaymentInput>;
  /** The key to ensure idempotency for the payment, if null then idempotency protection is not applied */
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  /** The payments will be added to a new batch which will then be paid */
  payAsBatch?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  sepaTransfers?: InputMaybe<StoredPaymentInput>;
};

/** Simplified status of initiation operation */
export enum InitiationStatus {
  /**
   * Initiation failed - see errorSubject for more details
   * PaymentStatus: Rejected | Cancelled | Recalled | Deleted
   * PeriodicPaymentStatus: Closed | Rejected | Cancelled
   */
  Error = 'Error',
  /**
   * Initiation is being processed
   * PaymentStatus: Received | Processing
   * PeriodicPaymentStatus: Received
   */
  Processing = 'Processing',
  /**
   * Initiation is completed
   * PaymentStatus: Suspended | Pending | WaitsApproval | Completed
   * PeriodicPaymentStatus: Active
   */
  Success = 'Success',
  /** Unknown status */
  Unknown = 'Unknown'
}

/** Type of initiation operation */
export enum InitiationType {
  /** Direct payment agreements */
  DirectDebitMandate = 'DirectDebitMandate',
  /** Single international payment operation, sepa or swift */
  InternationalPayment = 'InternationalPayment',
  /** Single payment operation, transferring money from a to b. */
  Payment = 'Payment',
  /** Payment agreement operation, money will be transferred from a to b periodically. */
  PeriodicPayment = 'PeriodicPayment',
  /** Signing basket operation, multiple payments will be signed at once. */
  SigningBasket = 'SigningBasket'
}

export type Instrument = Bond | Fund | Stock;

export type Insurance = {
  __typename: 'Insurance';
  /** Check if the authenticated user has insurance access for the company */
  checkInsuranceAccess: InsuranceMandateAccess;
  /** Indicates whether the user or company is an active insurance customer. */
  customerInfo: Maybe<InsuranceCustomer>;
  /** Overview of users policies. Includes summary information about total premiums and subtotals for each insurance category. */
  overview: InsurancePolicyOverview;
  /** A list of users issued and pending insurance policies. */
  policies: InsurancePolicyConnection;
};


export type InsurancePoliciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type InsuranceBilling = {
  __typename: 'InsuranceBilling';
  numberOfPaymentsPerYear: Scalars['Int']['output'];
  /** List of payment dates with amounts and interest */
  paydates: Array<InsurancePaydate>;
};

/** A category of witch many types of insurance can belong to. */
export enum InsuranceCategory {
  ACCIDENT = 'ACCIDENT',
  ASSET = 'ASSET',
  FAMILY = 'FAMILY',
  HOME = 'HOME',
  LIFE_AND_HEALTH = 'LIFE_AND_HEALTH',
  OTHER = 'OTHER',
  PET = 'PET',
  RESPONSIBILITY = 'RESPONSIBILITY',
  SHIP = 'SHIP',
  TRANSPORT = 'TRANSPORT',
  TRAVEL = 'TRAVEL',
  VEHICLES = 'VEHICLES',
  VEHICLE_EXTRA = 'VEHICLE_EXTRA'
}

/** Insurance consultation request received */
export type InsuranceConsultationRequestData = {
  __typename: 'InsuranceConsultationRequestData';
  /** The email to contact. Can be null if phone (phone number) is defined. */
  email: Maybe<Scalars['String']['output']>;
  /** The type of insurance consultation was requested for. If omitted then we consider that a request for general consultation. */
  insuranceType: Maybe<InsuranceType>;
  /** The phone number to contact. Can be null if email is defined. */
  phone: Maybe<Scalars['String']['output']>;
};

export type InsuranceConsultationRequestErrorUnion = RequestInsuranceConsultationBadRequestError | UnknownError;

/** Insurance consultation request payload */
export type InsuranceConsultationRequestPayload = {
  __typename: 'InsuranceConsultationRequestPayload';
  data: Maybe<InsuranceConsultationRequestData>;
  error: Maybe<InsuranceConsultationRequestErrorUnion>;
};

/** Indicates whether a person or company is an active insurance customer */
export type InsuranceCustomer = {
  __typename: 'InsuranceCustomer';
  isCustomer: Scalars['Boolean']['output'];
};

/** Mandate access check for the authenticated user */
export type InsuranceMandateAccess = {
  __typename: 'InsuranceMandateAccess';
  /** Whether the user has mandates for the company */
  hasAccess: Scalars['Boolean']['output'];
};

export type InsurancePaydate = {
  __typename: 'InsurancePaydate';
  /** Payment amount */
  amount: CurrencyAmount;
  /** Due date for payment */
  dueDate: Maybe<Scalars['Date']['output']>;
  /** Interest amount */
  interest: CurrencyAmount;
  /** Payment amount */
  penaltyInterest: CurrencyAmount;
};

/** Information about an insurance policy between the insurer and the insured. */
export type InsurancePolicy = {
  __typename: 'InsurancePolicy';
  category: InsuranceCategory;
  /** The id of the policy. */
  id: Scalars['ID']['output'];
  /** The unique id of the package this policy belongs to. */
  packageId: Maybe<Scalars['String']['output']>;
  /** The name of the package this policy belongs to. */
  packageName: Maybe<Scalars['String']['output']>;
  /** The period during which an insurance policy is valid and provides coverage to the subject. */
  period: InsurancePolicyPeriod;
  policyNumber: Scalars['String']['output'];
  /** Yearly premium (iðgjald). */
  premium: Maybe<CurrencyAmount>;
  product: InsurancePolicyProduct;
  /** The state of the policy. */
  state: InsurancePolicyState;
  /** What is this policy insuring. */
  subject: InsuranceSubject;
};

export type InsurancePolicyCertificateDocumentMeta = {
  __typename: 'InsurancePolicyCertificateDocumentMeta';
  document: GenericFile;
};

/** Includes information about users issued and pending policies. */
export type InsurancePolicyConnection = {
  __typename: 'InsurancePolicyConnection';
  edges: Array<InsurancePolicyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InsurancePolicyDocumentMeta = InsurancePolicyCertificateDocumentMeta | InsurancePolicyTermDocumentMeta;

export type InsurancePolicyEdge = {
  __typename: 'InsurancePolicyEdge';
  cursor: Scalars['String']['output'];
  node: InsurancePolicy;
};

/** Summary information about users issued policies. */
export type InsurancePolicyOverview = {
  __typename: 'InsurancePolicyOverview';
  /** Information about payment agreement, will be null if none exists. */
  billing: Maybe<InsuranceBilling>;
  /** Total "monthly" premiums (iðgjöld). */
  monthlyPremiums: CurrencyAmount;
  /** Yearly premium (iðgjald). */
  possibleRefund: Maybe<CurrencyAmount>;
  /** If all users policies have the same renewal date this will be set to that date. */
  renewalDate: Maybe<Scalars['Date']['output']>;
  /** Total "yearly" premiums (iðgjöld). */
  totalPremiums: CurrencyAmount;
};

/** The policy period is the defined period during which an insurance policy is valid and provides coverage to the subject. */
export type InsurancePolicyPeriod = {
  __typename: 'InsurancePolicyPeriod';
  /** End of policy period. The value should not be null but we need to have it nullable because the string parsing could return null. */
  endDate: Maybe<Scalars['Date']['output']>;
  /** The start date of the next period if the policy is set to renew. */
  renewalDate: Maybe<Scalars['Date']['output']>;
  /** Start of policy period. The value should not be null but we need to have it nullable because the string parsing could return null. */
  startDate: Maybe<Scalars['Date']['output']>;
};

export type InsurancePolicyPreview = GeneralInsurancePolicyPreview | HomeInsurancePolicyPreview | PersonInsurancePolicyPreview | RealEstateInsurancePolicyPreview | VehicleInsurancePolicyPreview;

export type InsurancePolicyProduct = {
  __typename: 'InsurancePolicyProduct';
  /** The icelandic name of the policy product. For example "Ökutækjatrygging". */
  name: Scalars['String']['output'];
};

/** The current state of a policy. */
export enum InsurancePolicyState {
  CANCELED = 'CANCELED',
  ISSUED = 'ISSUED',
  PENDING = 'PENDING',
  QUOTE = 'QUOTE'
}

export type InsurancePolicyTermDocumentMeta = {
  __typename: 'InsurancePolicyTermDocumentMeta';
  /** Static URL to the PDF term document hosted on tm.is */
  document: GenericFile;
  name: Scalars['String']['output'];
};

/** Subject of the insurance, e.g. what is being insured. */
export type InsuranceSubject = {
  __typename: 'InsuranceSubject';
  /** Description of what this insurance is insuring. For car insurance it would be the type of car, "Toyota Yaris". For life insurance this would be the name of the subject. */
  description: Maybe<Scalars['String']['output']>;
  /** For a car insurance this would be the licence plate. For life insurance this would be the subjects kennitala. */
  reference: Maybe<Scalars['String']['output']>;
};

/** Type of insurance products available. */
export enum InsuranceType {
  BICYCLE = 'BICYCLE',
  CHILD = 'CHILD',
  ELECTRIC_BIKE = 'ELECTRIC_BIKE',
  FIRE = 'FIRE',
  HOME = 'HOME',
  LIFE = 'LIFE',
  MANDATORY_CAR = 'MANDATORY_CAR',
  PROPERTY = 'PROPERTY',
  RV = 'RV',
  SUMMER_HOUSE = 'SUMMER_HOUSE',
  UNKNOWN = 'UNKNOWN'
}

/** Information about and status of an online loan application */
export type InsuredLoanSelfServiceStatus = {
  __typename: 'InsuredLoanSelfServiceStatus';
  createdDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Id for the digitalSignatureDocument pdf */
  digitalSignatureDocumentId: Maybe<Scalars['String']['output']>;
  /** Id for signing digital signature document */
  digitalSignatureGroupId: Maybe<Scalars['String']['output']>;
  expirationDate: Maybe<Scalars['DateTimeISO']['output']>;
  spouse: Maybe<Spouse>;
  status: InsuredLoanSelfServiceStatusEnum;
};

/** The current status of an online loan application */
export enum InsuredLoanSelfServiceStatusEnum {
  CommissionPendingSignature = 'CommissionPendingSignature',
  CommissionWaitingForSpouse = 'CommissionWaitingForSpouse',
  CreditAssessmentConfirmed = 'CreditAssessmentConfirmed',
  CreditAssessmentInProgress = 'CreditAssessmentInProgress',
  CreditAssessmentNotFound = 'CreditAssessmentNotFound',
  LoanApplicationWaitingForApproval = 'LoanApplicationWaitingForApproval'
}

export type InterestOption = {
  __typename: 'InterestOption';
  description: Scalars['String']['output'];
  fixedInterestMonths: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  mortgageRatioFrom: Maybe<Scalars['Float']['output']>;
  mortgageRatioTo: Maybe<Scalars['Float']['output']>;
};

export type InterestRate = Node & {
  __typename: 'InterestRate';
  description: Maybe<Scalars['String']['output']>;
  group: InterstRateGroup;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  previousValue: Scalars['Float']['output'];
  started: Scalars['DateTimeISO']['output'];
  type: InterestRateType;
  value: Scalars['Float']['output'];
};

export type InterestRateFilterArgs = {
  interestRateType?: InputMaybe<InterestRateType>;
};

export type InterestRateOption = {
  __typename: 'InterestRateOption';
  fixedInterestMonths: Maybe<Scalars['Int']['output']>;
  interestId: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  /** Adjusted interest rate reflecting the customer's loyalty level (Vild). */
  interestRateWithMargin: Scalars['Float']['output'];
};

export enum InterestRateType {
  Deposit = 'Deposit',
  Loan = 'Loan'
}

export enum InterestType {
  FixedInterests = 'FixedInterests',
  VariableInterests = 'VariableInterests'
}

/** International payment, includes sepa and crossBorder */
export type InternationalPayment = InternationalPaymentInterface & Node & {
  __typename: 'InternationalPayment';
  /** Central bank category of the payment. */
  centralBankCategory: Maybe<CentralBankCategoryCode>;
  /** Three letter code that identifies the category of the payment. Use centralBankCategory for more details. */
  centralBankCategoryCode: Scalars['String']['output'];
  /** Details about the creditor */
  creditor: PaymentParticipant;
  /** Creditor account details */
  creditorAccount: PaymentCreditorAccount;
  debitedAmount: CurrencyAmount;
  /** Details about the debtor */
  debtor: PaymentParticipant;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  /** Account number for the debtor (withdrawal) */
  debtorAccountNumber: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  /** Payment Exchange Rate value */
  exchangeRate: Maybe<Scalars['Float']['output']>;
  /** Payment Exchange Rate information */
  exchangeRateInfo: Maybe<PaymentExchangeRate>;
  fees: Array<InternationalPaymentFee>;
  feesTotal: CurrencyAmount;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  /** Date of the payment */
  paymentDate: Scalars['DateTimeISO']['output'];
  /** ID (internal) of the payment */
  paymentId: Maybe<Scalars['ID']['output']>;
  /** Previously used notification recipients for similar payments */
  paymentNotificationRecipients: Maybe<Array<Scalars['String']['output']>>;
  /** Status of the payment */
  paymentStatus: PaymentStatus;
  /** Name of the recipient */
  recipientName: Scalars['String']['output'];
  /** Type of the payment */
  type: PaymentType;
};

export type InternationalPaymentAddressInput = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
};

/** Internation payment fee object */
export type InternationalPaymentFee = {
  __typename: 'InternationalPaymentFee';
  /** Amount and currency of the fee */
  amount: CurrencyAmount;
  /** Description of the fee */
  description: Scalars['String']['output'];
};

export type InternationalPaymentInitiation = Node & {
  __typename: 'InternationalPaymentInitiation';
  errorSubject: Maybe<InternationalPaymentInitiationErrorSubject>;
  id: Scalars['ID']['output'];
  initiationType: InitiationType;
  /** Detailed data for payment */
  payment: Maybe<InternationalPaymentUnion>;
  paymentId: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  paymentType: PaymentType;
  pisId: Scalars['String']['output'];
  status: InitiationStatus;
};

export enum InternationalPaymentInitiationErrorSubject {
  AccountNotFound = 'AccountNotFound',
  AmountInvalid = 'AmountInvalid',
  AmountOverFxLimits = 'AmountOverFxLimits',
  BBANMustForMexicoValidationFailure = 'BBANMustForMexicoValidationFailure',
  CategoryCodeInvalid = 'CategoryCodeInvalid',
  CreditorBankDoesNotSupportSepa = 'CreditorBankDoesNotSupportSepa',
  CreditorBankShouldNotBeLandsbankinn = 'CreditorBankShouldNotBeLandsbankinn',
  CurrencyInvalid = 'CurrencyInvalid',
  CurrencyQuoteMarketIsClosed = 'CurrencyQuoteMarketIsClosed',
  DebtorAddressInvalid = 'DebtorAddressInvalid',
  NotFound = 'NotFound',
  RecipientBankNotFound = 'RecipientBankNotFound',
  SepaPaymentIsNotAllowed = 'SepaPaymentIsNotAllowed',
  Unauthorized = 'Unauthorized',
  Unknown = 'Unknown',
  WithdrawalForCostFailed = 'WithdrawalForCostFailed',
  WithdrawalForTransferFailed = 'WithdrawalForTransferFailed'
}

/** Interface for all international payment objects to implement */
export type InternationalPaymentInterface = {
  /** Central bank category of the payment. */
  centralBankCategory: Maybe<CentralBankCategoryCode>;
  /** Three letter code that identifies the category of the payment. Use centralBankCategory for more details. */
  centralBankCategoryCode: Scalars['String']['output'];
  debitedAmount: CurrencyAmount;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  /** Account number for the debtor (withdrawal) */
  debtorAccountNumber: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  /** Payment Exchange Rate value */
  exchangeRate: Maybe<Scalars['Float']['output']>;
  /** Payment Exchange Rate information */
  exchangeRateInfo: Maybe<PaymentExchangeRate>;
  fees: Array<InternationalPaymentFee>;
  feesTotal: CurrencyAmount;
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  /** ID (internal) of the payment */
  paymentId: Maybe<Scalars['ID']['output']>;
  /** Previously used notification recipients for similar payments */
  paymentNotificationRecipients: Maybe<Array<Scalars['String']['output']>>;
  /** Status of the payment */
  paymentStatus: PaymentStatus;
  /** Name of the recipient */
  recipientName: Scalars['String']['output'];
  /** Type of the payment */
  type: PaymentType;
};

/** The international payment method */
export enum InternationalPaymentMethod {
  /** FEDWIRE */
  FEDWIRE = 'FEDWIRE',
  /** IBAN */
  IBAN = 'IBAN',
  /** SWIFT */
  SWIFT = 'SWIFT'
}

export type InternationalPaymentUnion = CrossBorderCreditTransfer | SepaCreditTransfer;

export enum InternationalPaymentValidationErrorField {
  CREDITOR_ACCOUNT_BBAN = 'CREDITOR_ACCOUNT_BBAN',
  CREDITOR_ACCOUNT_BIC = 'CREDITOR_ACCOUNT_BIC',
  CREDITOR_ACCOUNT_IBAN = 'CREDITOR_ACCOUNT_IBAN',
  CREDITOR_ADDRESS = 'CREDITOR_ADDRESS',
  CREDITOR_ADDRESS_CITY = 'CREDITOR_ADDRESS_CITY',
  CREDITOR_ADDRESS_POST_CODE = 'CREDITOR_ADDRESS_POST_CODE',
  CREDITOR_ADDRESS_STREET = 'CREDITOR_ADDRESS_STREET',
  CREDITOR_NAME = 'CREDITOR_NAME',
  REMITTANCE_INFORMATION_UNSTRUCTURED = 'REMITTANCE_INFORMATION_UNSTRUCTURED',
  UNKNOWN = 'UNKNOWN'
}

export type InterstRateGroup = {
  __typename: 'InterstRateGroup';
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** IntradayHistory */
export type IntradayHistory = Node & {
  __typename: 'IntradayHistory';
  date: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  price: Maybe<Scalars['Float']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
  value: Maybe<Scalars['Float']['output']>;
  volume: Maybe<Scalars['Float']['output']>;
};

export type InvalidBranchNumberError = Error & {
  __typename: 'InvalidBranchNumberError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidCountryId = Error & {
  __typename: 'InvalidCountryId';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** An error indicating that a file has invalid file extension */
export type InvalidFileExtensionError = Error & {
  __typename: 'InvalidFileExtensionError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidIsatCode = Error & {
  __typename: 'InvalidISATCode';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidPaymentNotificationHandle = Error & {
  __typename: 'InvalidPaymentNotificationHandle';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Prerequisites that are potentially not met for creating a debit card. The card owner values are relevant for the currently logged in user, while the card holder values are relevant for an individual that the currently logged in user intends to create a debit card for. */
export enum InvalidPrerequisiteForCreateDebitCard {
  /** The card holder has an invalid address */
  CARD_HOLDER_HAS_INVALID_ADDRESS = 'CARD_HOLDER_HAS_INVALID_ADDRESS',
  /** The card holder has invalid identification */
  CARD_HOLDER_HAS_INVALID_IDENTIFICATION = 'CARD_HOLDER_HAS_INVALID_IDENTIFICATION',
  /** The card holder has invalid kyc */
  CARD_HOLDER_HAS_INVALID_KYC = 'CARD_HOLDER_HAS_INVALID_KYC',
  /** Other reason for the card holder that is irrelevant for client */
  CARD_HOLDER_OTHER = 'CARD_HOLDER_OTHER',
  /** Fallback value that should never occur meaning that there is a new case that needs to be handled */
  CARD_HOLDER_UNKOWN = 'CARD_HOLDER_UNKOWN',
  /** Further business disallowed for the card owner */
  CARD_OWNER_FURTHER_BUSINESS_DISALLOWED = 'CARD_OWNER_FURTHER_BUSINESS_DISALLOWED',
  /** The card owner has an invalid address */
  CARD_OWNER_HAS_INVALID_ADDRESS = 'CARD_OWNER_HAS_INVALID_ADDRESS',
  /** The card owner has invalid identification */
  CARD_OWNER_HAS_INVALID_IDENTIFICATION = 'CARD_OWNER_HAS_INVALID_IDENTIFICATION',
  /** The card owner has invalid kyc */
  CARD_OWNER_HAS_INVALID_KYC = 'CARD_OWNER_HAS_INVALID_KYC',
  /** The email address for the card owner is missing. */
  CARD_OWNER_MISSING_EMAIL = 'CARD_OWNER_MISSING_EMAIL',
  /** The phone number for the card owner is missing. */
  CARD_OWNER_MISSING_PHONE_NUMBER = 'CARD_OWNER_MISSING_PHONE_NUMBER',
  /** Other reason for the card owner that is irrelevant for client */
  CARD_OWNER_OTHER = 'CARD_OWNER_OTHER',
  /** Fallback value that should never occur meaning that there is a new case that needs to be handled */
  CARD_OWNER_UNKNOWN = 'CARD_OWNER_UNKNOWN',
  /** Fallback value that should never occur meaning that there is a new case that needs to be handled */
  CARD_USER_UNKNOWN = 'CARD_USER_UNKNOWN',
  /** The user needs access to create a card in corporate account */
  NEEDS_ACCESS = 'NEEDS_ACCESS',
  TOO_MANY_ACTIVE_CARDS = 'TOO_MANY_ACTIVE_CARDS'
}

export type InvalidTypeFundOrder = Error & {
  __typename: 'InvalidTypeFundOrder';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invoice (claim), issued by user */
export type Invoice = Node & {
  __typename: 'Invoice';
  /** Number of the printed bill */
  billNumber: Maybe<Scalars['String']['output']>;
  /** Whether invoice can be cancelled, checks authorization rules and collection status */
  canCancelInvoice: Scalars['Boolean']['output'];
  /** Whether invoice can be sent to secondary collection or not */
  canSendToSecondaryCollection: Scalars['Boolean']['output'];
  /** The date when claim is scheduled to be cancelled */
  cancellationDate: Scalars['DateTimeISO']['output'];
  /** The date when the claim was cancelled */
  cancelledDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Tax applied to sale related profit that has been added to the claim */
  capitalGainsTaxDue: Scalars['Float']['output'];
  /** Category code of the invoice template used for the claim */
  categoryCode: Maybe<Scalars['String']['output']>;
  /** Number of the claim */
  claimNumber: Scalars['String']['output'];
  /** Claimant kennitala / identification number */
  claimantKennitala: Scalars['String']['output'];
  /** Invoice recipient name */
  claimantName: Maybe<Scalars['String']['output']>;
  /** The date when the claim was issued */
  creationDate: Scalars['DateTimeISO']['output'];
  /** Currency of the principle amount */
  currency: Scalars['String']['output'];
  /** Unique payor identification for the claimant, used for direct debit */
  customerNumber: Scalars['String']['output'];
  databaseId: Scalars['ID']['output'];
  /** Default charge that has been added to the claim */
  defaultChargeDue: Scalars['Float']['output'];
  /** Default interest that has been added to the claim */
  defaultInterestDue: Scalars['Float']['output'];
  /** Description shown in the invoice overview */
  description: Scalars['String']['output'];
  /** Discount that has added to the claim */
  discountDue: Scalars['Float']['output'];
  /** The set due date for the claim, after which additional fees may apply */
  dueDate: Scalars['DateTimeISO']['output'];
  /** Claim event representation, should only be resolved for single claim */
  events: Array<InvoiceEvent>;
  /** The set final due date for the claim, after which additional fees may apply */
  finalDueDate: Scalars['DateTimeISO']['output'];
  /** Fee added if claim is unpaid after the due date */
  firstDefaultCharge: Maybe<Scalars['Float']['output']>;
  /** How many days after the due date the firstDefaultCharge is applied */
  firstDefaultDays: Maybe<Scalars['Int']['output']>;
  /** Discount added if claim is paid before the due date */
  firstDiscount: Maybe<Scalars['Float']['output']>;
  /** The date when the claim was fully paid */
  fullPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date for an extended payment deadline before default charges apply */
  grantedPaymentDeadline: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** Claims with a younger due date can be paid first */
  isOutOfSequencePaymentAllowed: Scalars['Boolean']['output'];
  /** Can partial payments be made to the claim */
  isPartialPaymentAllowed: Scalars['Boolean']['output'];
  /** The date when the claim was last modified at */
  lastModifiedDate: Scalars['DateTimeISO']['output'];
  /** The date when a late payment notification was last sent */
  lastNotificationSentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when the claim was last granted a payment deadline */
  lastPaymentDeadlineGrantedDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Fee added for notifying payor, printed or electronic */
  notificationFee: Scalars['Float']['output'];
  /** Notification fee that has been added to the claim */
  notificationFeeDue: Scalars['Float']['output'];
  /** Other cost that has been added to the claim */
  otherCostDue: Scalars['Float']['output'];
  /** Amount of other cost that has been paid by the payor */
  otherCostPaid: Scalars['Float']['output'];
  /** Other default cost that has been added to the claim */
  otherDefaultCostDue: Scalars['Float']['output'];
  /** Amount of other default cost that has been paid by the payor */
  otherDefaultCostPaid: Scalars['Float']['output'];
  /** Amount that has been paid partially into the claim by the payor */
  partialPaymentPaid: Scalars['Float']['output'];
  /** Claim payment representation, should only be resolved for single claim */
  payments: Array<InvoicePayment>;
  /** Payors kennitala / identification number */
  payorKennitala: Scalars['String']['output'];
  /** Payors full name */
  payorName: Scalars['String']['output'];
  /** Amount to be collected, before additional fees and interests are applied */
  principalAmount: Scalars['Float']['output'];
  /** Comment shown on a printed claim slip */
  printedComment: Scalars['String']['output'];
  /** 7 letter reference */
  reference: Scalars['String']['output'];
  /** Fee added if claim is unpaid after the final due date */
  secondDefaultCharge: Maybe<Scalars['Float']['output']>;
  /** How many days after the final due date the secondDefaultCharge is applied */
  secondDefaultDays: Maybe<Scalars['Int']['output']>;
  /** Fee added if claim is unpaid after the final due date */
  secondDiscount: Maybe<Scalars['Float']['output']>;
  /** Name of the collection company */
  secondaryCollectionCompanyName: Maybe<Scalars['String']['output']>;
  /** Will a notification be sent when payment is late */
  sendLatePaymentNotification: Scalars['Boolean']['output'];
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning: Maybe<Scalars['Boolean']['output']>;
  /** The date when the claim was sent for secondary collection */
  sentForSecondaryCollectionDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Status of the invoice (paid, unpaid or cancelled) */
  status: InvoiceStatus;
  /** The parent invoice template this invoice was created from */
  template: InvoiceTemplate;
  /** Total amount to be paid, including all additional fees and discounts */
  totalAmountDue: Scalars['Float']['output'];
  /** Add default interest using the central bank rate if unpaid after the due date */
  useCentralBankRateDefaultInterest: Scalars['Boolean']['output'];
};


/** Invoice (claim), issued by user */
export type InvoiceEventsArgs = {
  filter?: InputMaybe<InvoiceEventFilterInput>;
};

export type InvoiceAlreadyExistsError = Error & {
  __typename: 'InvoiceAlreadyExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Authorization rules applied to the current user for the use of a given invoice template */
export type InvoiceAuthorizationRules = {
  __typename: 'InvoiceAuthorizationRules';
  /** Can the template be altered by the current user */
  alterInvoiceTemplate: Scalars['Boolean']['output'];
  /** Can the template accounts be altered by the current user */
  alterInvoiceTemplateAccounts: Scalars['Boolean']['output'];
  /** Can invoices created with the given template be cancelled by the current user */
  cancelInvoices: Scalars['Boolean']['output'];
  /** Can invoices be created using the given template by the current user */
  createInvoices: Scalars['Boolean']['output'];
  /** Can the template be deactivated by the current user */
  deactivateInvoiceTemplate: Scalars['Boolean']['output'];
  /** Can invoices created with the given template be edited by the current user */
  editInvoices: Scalars['Boolean']['output'];
  /** Can invoices created with the given template be read by the current user */
  readInvoices: Scalars['Boolean']['output'];
};

export type InvoiceBatch = Node & {
  __typename: 'InvoiceBatch';
  /** Username of the creator of the invoice batch. */
  createdBy: Maybe<Scalars['String']['output']>;
  /** The date invoice batch was created */
  dateCreated: Scalars['DateTimeISO']['output'];
  /** Tells whether batch has a connected document. */
  hasConnectedDocument: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Actions associated with a particular invoice batch */
  invoiceBatchActions: Maybe<InvoiceBatchActionConnection>;
  invoiceBatchActionsDocument: Maybe<DocumentBucket>;
  /** The current processing status of an invoice batch. */
  status: InvoiceBatchStatus;
  /** Total number of actions in the invoice batch. */
  totalActions: Scalars['Int']['output'];
  /** Number of actions that resulted in failure. */
  totalFailures: Scalars['Int']['output'];
  /** Number of actions that resulted in success. */
  totalSuccesses: Scalars['Int']['output'];
};


export type InvoiceBatchInvoiceBatchActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceBatchActionsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type InvoiceBatchActionConnection = {
  __typename: 'InvoiceBatchActionConnection';
  edges: Array<InvoiceBatchActionInterfaceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceBatchActionError = InvoiceBatchActionGeneralError | UnknownError;

export type InvoiceBatchActionFailure = InvoiceBatchActionInterface & {
  __typename: 'InvoiceBatchActionFailure';
  /** A number representing where in the order this action is. */
  actionNumber: Scalars['Int']['output'];
  /** Number of the claim */
  claimNumber: Maybe<Scalars['String']['output']>;
  /** The first error associated with this action */
  error: InvoiceBatchActionError;
  /** All errors associated with this action. */
  errors: Array<InvoiceBatchActionError>;
  id: Scalars['ID']['output'];
  /** The operation that was performed on the claim associated with action. */
  operation: InvoiceBatchActionOperation;
  /** Payors kennitala / identification number */
  payorKennitala: Maybe<Scalars['String']['output']>;
};

/** General error with a specific message from the API */
export type InvoiceBatchActionGeneralError = Error & {
  __typename: 'InvoiceBatchActionGeneralError';
  /** The name of the error */
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  /** Error message of the action */
  message: Scalars['String']['output'];
};

export type InvoiceBatchActionInterface = {
  /** A number representing where in the order this action is. */
  actionNumber: Scalars['Int']['output'];
  /** Number of the claim */
  claimNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The operation that was performed on the claim associated with action. */
  operation: InvoiceBatchActionOperation;
  /** Payors kennitala / identification number */
  payorKennitala: Maybe<Scalars['String']['output']>;
};

export type InvoiceBatchActionInterfaceEdge = {
  __typename: 'InvoiceBatchActionInterfaceEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceBatchActionInterface;
};

/** The operation that was performed on the claim associated with action. */
export enum InvoiceBatchActionOperation {
  /** Claim was created. */
  CREATE = 'CREATE',
  /** Claim was deleted. */
  DELETE = 'DELETE',
  /** Cant resolve operation of invoice batch action. */
  UNKNOWN = 'UNKNOWN',
  /** Claim was updated. */
  UPDATE = 'UPDATE'
}

export type InvoiceBatchActionProcessing = InvoiceBatchActionInterface & {
  __typename: 'InvoiceBatchActionProcessing';
  /** A number representing where in the order this action is. */
  actionNumber: Scalars['Int']['output'];
  /** Number of the claim */
  claimNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The operation that was performed on the claim associated with action. */
  operation: InvoiceBatchActionOperation;
  /** Payors kennitala / identification number */
  payorKennitala: Maybe<Scalars['String']['output']>;
};

/** The current processing status of an invoice batch. */
export enum InvoiceBatchActionStatus {
  /** Action was processed with failure. */
  FAILURE = 'FAILURE',
  /** Action is being processed. */
  PROCESSING = 'PROCESSING',
  /** Action was processed successfully. */
  SUCCESS = 'SUCCESS'
}

export type InvoiceBatchActionSuccess = InvoiceBatchActionInterface & {
  __typename: 'InvoiceBatchActionSuccess';
  /** A number representing where in the order this action is. */
  actionNumber: Scalars['Int']['output'];
  /** Number of the claim */
  claimNumber: Maybe<Scalars['String']['output']>;
  /** The final due date of the claim. */
  finalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** The operation that was performed on the claim associated with action. */
  operation: InvoiceBatchActionOperation;
  /** Payors kennitala / identification number */
  payorKennitala: Maybe<Scalars['String']['output']>;
  /** The name of the payor. */
  payorName: Maybe<Scalars['String']['output']>;
  /** The principal amount due on the claim. */
  principalAmount: Maybe<CurrencyAmount>;
};

export type InvoiceBatchActionUnknown = InvoiceBatchActionInterface & {
  __typename: 'InvoiceBatchActionUnknown';
  /** A number representing where in the order this action is. */
  actionNumber: Scalars['Int']['output'];
  /** Number of the claim */
  claimNumber: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The operation that was performed on the claim associated with action. */
  operation: InvoiceBatchActionOperation;
  /** Payors kennitala / identification number */
  payorKennitala: Maybe<Scalars['String']['output']>;
};

export type InvoiceBatchActionsFilterArgs = {
  status: InvoiceBatchActionStatus;
};

export type InvoiceBatchConnection = {
  __typename: 'InvoiceBatchConnection';
  edges: Array<InvoiceBatchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceBatchEdge = {
  __typename: 'InvoiceBatchEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceBatch;
};

/** The current processing status of an invoice batch. */
export enum InvoiceBatchStatus {
  /** Invoice batch was created successfully. */
  PROCESSED_SUCCESSFULLY = 'PROCESSED_SUCCESSFULLY',
  /** Invoice batch was created with some failure. */
  PROCESSED_WITH_FAILURE = 'PROCESSED_WITH_FAILURE',
  /** Invoice batch is being processed. */
  PROCESSING = 'PROCESSING',
  /** Cant resolve status of invoice batch. */
  UNKNOWN = 'UNKNOWN'
}

export type InvoiceBatchesFilterArgs = {
  /** The first day a invoice was created. */
  createdFrom: Scalars['DateTimeISO']['input'];
  /** The last day a invoice was created. */
  createdTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type InvoiceClaimNumberNotAvailableError = Error & {
  __typename: 'InvoiceClaimNumberNotAvailableError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceCollectionCompanyIsNotAvailableError = Error & {
  __typename: 'InvoiceCollectionCompanyIsNotAvailableError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceConnection = {
  __typename: 'InvoiceConnection';
  edges: Array<InvoiceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDefaults = {
  __typename: 'InvoiceDefaults';
  accounts: Array<Account>;
  canCreateInvoiceTemplate: Scalars['Boolean']['output'];
  canViewInvoices: Scalars['Boolean']['output'];
  categoryCodes: Array<InvoiceServiceCategory>;
  /** @deprecated Reason: Unnecessary, clients only use the id. Since: 2026-03-10. Removed: 2026-06-15. Issue(s) to remove it: WEB-41355 */
  depositAccount: Maybe<Account>;
  depositAccountId: Maybe<Scalars['String']['output']>;
  invoiceSettings: InvoiceSettings;
  /** @deprecated Reason: Unnecessary, clients only use the id. Since: 2026-03-10. Removed: 2026-06-15. Issue(s) to remove it: WEB-41355 */
  withdrawalAccount: Maybe<Account>;
  withdrawalAccountId: Maybe<Scalars['String']['output']>;
};


export type InvoiceDefaultsInvoiceSettingsArgs = {
  categoryCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceDeleted = Error & {
  __typename: 'InvoiceDeleted';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceDepositAccountLockedError = Error & {
  __typename: 'InvoiceDepositAccountLockedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceEdge = {
  __typename: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node: Invoice;
};

/** Events related to an invoice */
export type InvoiceEvent = {
  __typename: 'InvoiceEvent';
  /** Total amount that was deposited into the account of the claimant */
  amountDeposited: Maybe<Scalars['Float']['output']>;
  /** Total amount that was paid by the payor */
  amountPaid: Maybe<Scalars['Float']['output']>;
  /** Withheld capital gains tax */
  capitalGainsTax: Maybe<Scalars['Float']['output']>;
  /** Default charge */
  defaultCharge: Maybe<Scalars['Float']['output']>;
  /** Default interest paid */
  defaultInterest: Maybe<Scalars['Float']['output']>;
  /** Description of the event */
  description: Maybe<Scalars['String']['output']>;
  /** Discount applied */
  discount: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** Notification and payment fee */
  notificationFee: Maybe<Scalars['Float']['output']>;
  /** Other cost */
  otherCost: Maybe<Scalars['Float']['output']>;
  /** Other default cost */
  otherDefaultCost: Maybe<Scalars['Float']['output']>;
  /** Timestamp of this event */
  timestamp: Scalars['DateTimeISO']['output'];
  /** Total amount owed by payor after this event was resolved */
  totalAmountDue: Scalars['Float']['output'];
  /** Numeric id to represent the type of the event */
  typeId: Scalars['Float']['output'];
  /** Human readable description of the type */
  typeName: Scalars['String']['output'];
  /** Unpaid notification and payment fee */
  unpaidNotificationFee: Maybe<Scalars['Float']['output']>;
  /** Username */
  username: Maybe<Scalars['String']['output']>;
};

export type InvoiceEventFilterInput = {
  /** Whether to exclude payment events */
  excludePaymentEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceFilterArgs = {
  /** Earliest date when claim get automatically cancelled if its not paid or cancelled before in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  cancellationCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest date when claim get automatically cancelled if its not paid or cancelled before in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  cancellationCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest date when claim get automatically cancelled if its not paid or cancelled before
   * @deprecated Use cancellationCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  cancellationDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest date when claim get automatically cancelled if its not paid or cancelled before
   * @deprecated Use cancellationCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  cancellationDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Earliest date when claim was cancelled in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  cancelledCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest date when claim was cancelled in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  cancelledCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest date when claim was cancelled
   * @deprecated Use cancelledCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  cancelledDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest date when claim was cancelled
   * @deprecated Use cancelledCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  cancelledDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Claim number (14 chars, e.g.: 0101-66-000001) */
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  /** Claimant kennitala (e.g. 1505658479) */
  claimantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Earliest claim creation date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  creationCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest claim creation date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  creationCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest claim creation date
   * @deprecated Use creationCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  creationDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest claim creation date
   * @deprecated Use creationCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  creationDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Earliest claim due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  dueCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest claim due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  dueCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest claim due date
   * @deprecated Use dueCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  dueDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest claim due date
   * @deprecated Use dueCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  dueDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Earliest claim final due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  finalDueCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest claim final due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  finalDueCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest claim final due date
   * @deprecated Use finalDueCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  finalDueDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest claim final due date
   * @deprecated Use finalDueCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  finalDueDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Single parameter for partial search of payors kennitala, payors name, reference and claim number */
  freeTextSearch?: InputMaybe<Scalars['String']['input']>;
  /** Earliest claim payment date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  fullPaymentCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest claim payment date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  fullPaymentCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /**
   * Earliest claim payment date
   * @deprecated Use fullPaymentCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  fullPaymentDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Latest claim payment date
   * @deprecated Use fullPaymentCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696
   */
  fullPaymentDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Invoice Schedule ID */
  invoiceScheduleId?: InputMaybe<Scalars['String']['input']>;
  /** Only return partially paid claims */
  partiallyPaidOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payor kennitala (e.g. 1301940529) */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Payor name (e.g. Jane Doe) */
  payorName?: InputMaybe<Scalars['String']['input']>;
  /** Min principal amount */
  principalAmountFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Max principal amount */
  principalAmountTo?: InputMaybe<Scalars['Float']['input']>;
  /** Claim reference (up to 16 chars) */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Only return claims in secondary collection */
  secondaryCollectionOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Invoice status, for example one or combination of: Paid, Unpaid, Cancelled */
  status?: InputMaybe<Array<InvoiceStatus>>;
  /** Claim template code (3 chars, e.g. 0G7) */
  templateCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceFirstDefaultChargeIsNotProvidedInTemplateError = Error & {
  __typename: 'InvoiceFirstDefaultChargeIsNotProvidedInTemplateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceForbiddenUpdateFinalDueDateError = Error & {
  __typename: 'InvoiceForbiddenUpdateFinalDueDateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceInvalidFirstDefaultChargeNumberOfDaysError = Error & {
  __typename: 'InvoiceInvalidFirstDefaultChargeNumberOfDaysError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceNotFound = Error & {
  __typename: 'InvoiceNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum InvoiceOverviewField {
  CancelledDate = 'CancelledDate',
  CapitalGainsTax = 'CapitalGainsTax',
  ClaimNumber = 'ClaimNumber',
  CustomerNumber = 'CustomerNumber',
  DefaultCharge = 'DefaultCharge',
  DefaultInterest = 'DefaultInterest',
  DueDate = 'DueDate',
  FinalDueDate = 'FinalDueDate',
  FullPaymentDate = 'FullPaymentDate',
  GrantedPaymentDeadline = 'GrantedPaymentDeadline',
  NoticeAndPaymentFee = 'NoticeAndPaymentFee',
  PayorId = 'PayorId',
  PayorName = 'PayorName',
  PrincipalAmount = 'PrincipalAmount',
  Reference = 'Reference',
  Status = 'Status',
  TemplateCode = 'TemplateCode',
  TotalAmountDue = 'TotalAmountDue'
}

export enum InvoiceOverviewType {
  Excel = 'Excel',
  Pdf = 'Pdf'
}

export type InvoicePartialPaymentNotAllowedError = Error & {
  __typename: 'InvoicePartialPaymentNotAllowedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoicePartialPaymentWithForeignCurrencyNotAllowedError = Error & {
  __typename: 'InvoicePartialPaymentWithForeignCurrencyNotAllowedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** InvoicePayment */
export type InvoicePayment = {
  __typename: 'InvoicePayment';
  /** Capital income tax */
  capitalGainsTaxPaid: CurrencyAmount;
  /** ID (Api) of the claim */
  claimId: Scalars['String']['output'];
  /** Claim's number */
  claimNumber: Maybe<Scalars['String']['output']>;
  /** Currency code with 3 literals */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** Paid default charge fee */
  defaultChargePaid: CurrencyAmount;
  /** Paid default interest fee */
  defaultInterestPaid: CurrencyAmount;
  /** Amount deposited to creditors */
  depositedAmount: CurrencyAmount;
  /** Given discount amount */
  discountGiven: CurrencyAmount;
  /** Claim's due date */
  dueDate: Maybe<Scalars['Date']['output']>;
  /** Claim's final due date */
  finalDueDate: Maybe<Scalars['Date']['output']>;
  /** Claim's ID (Global) */
  id: Scalars['ID']['output'];
  /** Claim's payor kennitala */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Fee for notification */
  notificationFee: CurrencyAmount;
  /** Paid other costs */
  otherCostPaid: CurrencyAmount;
  /** Paid other default costs */
  otherDefaultCostPaid: CurrencyAmount;
  /** Amount paid for partial payment */
  partialAmountPaid: CurrencyAmount;
  /** Date when the transaction is made */
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Type of payment (i.e. complete, partial, or a refund) */
  paymentType: Maybe<InvoicePaymentPaymentType>;
  /** Claim's payor name */
  payorName: Maybe<Scalars['String']['output']>;
  /** Claim's principal amount */
  principalAmount: CurrencyAmount;
  /** Remaining principal balance after deposit */
  principalDue: CurrencyAmount;
  /** Amount paid to the claim's principal amount */
  principalPaid: CurrencyAmount;
  /** Claim's template code */
  templateCode: Maybe<Scalars['String']['output']>;
  /** Total amount of payment with accrued interest and fees */
  totalAmount: CurrencyAmount;
};

export type InvoicePaymentConnection = {
  __typename: 'InvoicePaymentConnection';
  edges: Array<InvoicePaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Invoice Payment Documents filters */
export type InvoicePaymentDocumentFilterArgs = {
  /** The start date for the payment date range, should be used instead of paymentDateFrom */
  bookingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** The end date for the payment date range */
  bookingDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Claimant's kennitala */
  claimantKennitala?: InputMaybe<Scalars['String']['input']>;
  /** ID of the deposit account */
  depositAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The start date for the payment date range */
  paymentDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** The end date for the payment date range */
  paymentDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Claim's template code */
  templateCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicePaymentEdge = {
  __typename: 'InvoicePaymentEdge';
  cursor: Scalars['String']['output'];
  node: InvoicePayment;
};

/** Invoice Payment filters */
export type InvoicePaymentFilterArgs = {
  /** The start date for the payment date range, should be used instead of paymentDateFrom */
  bookingDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** The end date for the payment date range */
  bookingDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** The start date for the payment date range */
  paymentDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** The end date for the payment date range */
  paymentDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Claim's payor kennitala */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Claim's template code */
  templateCode?: InputMaybe<Scalars['String']['input']>;
};

export type InvoicePaymentOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: InvoicePaymentOrderByOption;
};

export enum InvoicePaymentOrderByOption {
  CLAIM_NUMBER = 'CLAIM_NUMBER',
  DEPOSITED_AMOUNT = 'DEPOSITED_AMOUNT',
  KENNITALA = 'KENNITALA',
  PAYMENT_DATE = 'PAYMENT_DATE',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  PAYOR_NAME = 'PAYOR_NAME',
  TEMPLATE_CODE = 'TEMPLATE_CODE',
  TOTAL_AMOUNT = 'TOTAL_AMOUNT'
}

export enum InvoicePaymentPaymentType {
  COMPLETE = 'COMPLETE',
  PARTIAL = 'PARTIAL',
  REFUND = 'REFUND'
}

export enum InvoiceReminderType {
  Comment = 'Comment',
  Warning = 'Warning'
}

export type InvoiceRemindersInput = {
  /** IDs (Global) for invoices to send notifications for */
  invoiceIds: Array<Scalars['ID']['input']>;
  type: InvoiceReminderType;
};

/** Invoice schedule (systematic invoice creation), issued by user */
export type InvoiceSchedule = Node & {
  __typename: 'InvoiceSchedule';
  /** Unique payor identification for claimant, used for direct debit - 16 chars max */
  customerNumber: Maybe<Scalars['String']['output']>;
  /** Description to be shown to the payor - 200 chars max */
  description: Maybe<Scalars['String']['output']>;
  /** Which day of the month should the dueDate be */
  dueDateDayOfMonth: Scalars['Int']['output'];
  /** The last possible due date of the claim created on this schedule */
  endDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Which day of the month should the finalDueDate be */
  finalDueDateDayOfMonth: Scalars['Int']['output'];
  /** Unique id of the invoice schedule rule */
  id: Scalars['ID']['output'];
  /** Kennitala of the payor of this claim */
  payorKennitala: Scalars['String']['output'];
  /** Name of the payor of this claim */
  payorName: Scalars['String']['output'];
  /** Principal amount of the claim to be created */
  principalAmount: Scalars['Float']['output'];
  /** If set - this is the reference month for the indexation calculations which will be added to the principalAmount each month. */
  principalAmountIndexDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** This is the index value for the principalAmountIndexDate if set. */
  principalAmountIndexValue: Maybe<Scalars['Float']['output']>;
  /** Reference value to be put on each created claim - 16 chars max */
  reference: Maybe<Scalars['String']['output']>;
  /** The first possible due date of the claim created on this schedule */
  startDate: Scalars['DateTimeISO']['output'];
  /** The invoice template used to create claims. */
  template: InvoiceTemplate;
};

/** Claim schedule unpaid claims cleanup failed */
export type InvoiceScheduleCleanupFailedError = Error & {
  __typename: 'InvoiceScheduleCleanupFailedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceScheduleConnection = {
  __typename: 'InvoiceScheduleConnection';
  edges: Array<InvoiceScheduleEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceScheduleEdge = {
  __typename: 'InvoiceScheduleEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceSchedule;
};

export type InvoiceScheduleFetchSchedulesError = Error & {
  __typename: 'InvoiceScheduleFetchSchedulesError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invoice Schedule was not found */
export type InvoiceScheduleNotFound = Error & {
  __typename: 'InvoiceScheduleNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum InvoiceScheduleStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export type InvoiceScheduleUnpaidClaimsCleanupError = Error & {
  __typename: 'InvoiceScheduleUnpaidClaimsCleanupError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceSchedulesFilterArgs = {
  /** Id of the invoice template invoices are created in. */
  claimTemplateId?: InputMaybe<Scalars['String']['input']>;
  /** Kennitala of the payor of an invoice. */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Name of the payor of an invoice. API uses partial search. */
  payorName?: InputMaybe<Scalars['String']['input']>;
  /** Status of the invoice schedule. */
  status?: InputMaybe<InvoiceScheduleStatus>;
};

export type InvoiceServiceCategory = {
  __typename: 'InvoiceServiceCategory';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceSettings = {
  __typename: 'InvoiceSettings';
  centralBankRate: Scalars['Float']['output'];
  dueDateRule: Scalars['Int']['output'];
  dueDateRules: Array<DueDateRule>;
  finalDueDateRule: Scalars['Int']['output'];
  finalDueDateRules: Array<FinalDueDateRule>;
  firstDefaultCharge: Scalars['Float']['output'];
  firstDefaultChargeMax: Scalars['Float']['output'];
  firstDefaultChargeMin: Scalars['Float']['output'];
  firstDefaultDays: Scalars['Int']['output'];
  firstDefaultDaysMax: Scalars['Int']['output'];
  firstDefaultDaysMin: Scalars['Int']['output'];
  isOutOfSequencePaymentAllowed: Scalars['Boolean']['output'];
  isPartialPaymentAllowed: Scalars['Boolean']['output'];
  monthsUntilCancellation: Scalars['Int']['output'];
  monthsUntilCancellationMax: Scalars['Int']['output'];
  monthsUntilCancellationMin: Scalars['Int']['output'];
  notificationFee: Scalars['Float']['output'];
  notificationFeeMax: Scalars['Float']['output'];
  notificationFeeMin: Scalars['Float']['output'];
  secondDefaultCharge: Scalars['Float']['output'];
  secondDefaultChargeMax: Scalars['Float']['output'];
  secondDefaultChargeMin: Scalars['Float']['output'];
  secondDefaultDays: Scalars['Int']['output'];
  secondDefaultDaysMax: Scalars['Int']['output'];
  secondDefaultDaysMin: Scalars['Int']['output'];
  sendLatePaymentNotification: Scalars['Boolean']['output'];
  useCentralBankRate: Scalars['Boolean']['output'];
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

/** Invoice template */
export type InvoiceTemplate = Node & {
  __typename: 'InvoiceTemplate';
  /** Information about accounts for depositing */
  additionalDepositingAccounts: Maybe<AdditionalDepositingAccounts>;
  authorizationRules: InvoiceAuthorizationRules;
  /** ID of the bank branch */
  branch: Maybe<Scalars['String']['output']>;
  /** Code of the claim category */
  categoryCode: Scalars['String']['output'];
  /** Description of the claim category */
  categoryCodeDescription: Scalars['String']['output'];
  /** Settings for the claim */
  claimSettings: ClaimSettings;
  /** Description of the way we reference the claimant */
  claimantStatementReference: ClaimantStatementReference;
  /** Additional comments about the claim */
  comment: Maybe<Scalars['String']['output']>;
  /** Date when the template was created */
  creationDate: Scalars['String']['output'];
  /** Short code of the currency used in the claim */
  currencyCode: Scalars['String']['output'];
  depositAccount: Maybe<Account>;
  /** Account id of deposit account */
  depositAccountId: Scalars['String']['output'];
  /** Description of the claim template */
  description: Maybe<Scalars['String']['output']>;
  /** The date from where interests are calculated if claim is not paid on final due date. */
  dueDateRule: Maybe<Scalars['Int']['output']>;
  /** Final date to pay the claim, otherwise the customer must pay interest */
  finalDueDateRule: Maybe<Scalars['Int']['output']>;
  /**
   * Value of the first default charge
   * @deprecated Use firstDefaultChargeAmount which is more robust and consistent amount object, issue to remove WEB-31636
   */
  firstDefaultCharge: Maybe<Scalars['Float']['output']>;
  /** Value of the first default charge */
  firstDefaultChargeAmount: Maybe<CurrencyAmount>;
  /** Number of days after which apply the first charge */
  firstDefaultDays: Maybe<Scalars['Int']['output']>;
  /** ID (Global) for the claim. */
  id: Scalars['ID']['output'];
  /** Is claim active */
  isActive: Scalars['Boolean']['output'];
  /** A default template does not exist and is filled with default values for template creation */
  isDefault: Scalars['Boolean']['output'];
  /** Whether the claim can be payed non-consecutively */
  isOutOfSequencePaymentAllowed: Scalars['Boolean']['output'];
  /** Whether the payment can be done in parts */
  isPartialPaymentAllowed: Scalars['Boolean']['output'];
  /** Date when template was manipulated or used last */
  lastActivityDate: Scalars['String']['output'];
  /** Date when template was edited last */
  lastEditDate: Scalars['String']['output'];
  /** Number of month until the claim is cancelled */
  monthsUntilCancellation: Maybe<Scalars['Int']['output']>;
  /** Configuration for notifications to be sent to the claimant */
  notification: InvoiceTemplateNotificationInfo;
  /**
   * Fee for paperless notice
   * @deprecated Use notificationFeeAmount which is more robust and consistent amount object, issue to remove WEB-31636
   */
  notificationFee: Maybe<Scalars['Float']['output']>;
  /** Fee for paperless notice (amount object) */
  notificationFeeAmount: Maybe<CurrencyAmount>;
  /** Information about mailing to the claimant */
  printingAndMailing: PrintingAndMailingInfo;
  /**
   * Value of the second default charge
   * @deprecated Use secondDefaultChargeAmount which is more robust and consistent amount object, issue to remove WEB-31636
   */
  secondDefaultCharge: Maybe<Scalars['Float']['output']>;
  /** Value of the second default charge */
  secondDefaultChargeAmount: Maybe<CurrencyAmount>;
  /** Number of days after which apply the second charge */
  secondDefaultDays: Maybe<Scalars['Int']['output']>;
  /** Information about secondary connection */
  secondaryCollection: SecondaryCollection;
  /** Whether to send notification about being late with payment */
  sendLatePaymentNotification: Scalars['Boolean']['output'];
  /** Short code for the claim template */
  templateCode: Scalars['String']['output'];
  /** Type of the payment (primary/secondary/optional */
  type: InvoiceType;
  /** Whether central bank rate is applied */
  useCentralBankRateDefaultInterest: Scalars['Boolean']['output'];
  withdrawalAccount: Maybe<Account>;
  /** Account id of withdrawal account */
  withdrawalAccountId: Scalars['String']['output'];
};

export type InvoiceTemplateAccountCannotBeUsedError = Error & {
  __typename: 'InvoiceTemplateAccountCannotBeUsedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplateAdditionalDepositingAccountIsRequiredForForeignCurrencyClaimsError = Error & {
  __typename: 'InvoiceTemplateAdditionalDepositingAccountIsRequiredForForeignCurrencyClaimsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplateConnection = {
  __typename: 'InvoiceTemplateConnection';
  edges: Array<InvoiceTemplateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTemplateDepositAccountCurrencyChangeIsRestrictedError = Error & {
  __typename: 'InvoiceTemplateDepositAccountCurrencyChangeIsRestrictedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplateEdge = {
  __typename: 'InvoiceTemplateEdge';
  cursor: Scalars['String']['output'];
  node: InvoiceTemplate;
};

/** Description of the way we reference the claimant */
export enum InvoiceTemplateExtendedReference {
  /** Reference through ID of the claim */
  CLAIM_ID = 'CLAIM_ID',
  /** Use the customer ID */
  CUSTOMER_NUMBER = 'CUSTOMER_NUMBER',
  /** Use due date to reference the claim */
  DUE_DATE = 'DUE_DATE',
  /** Reference through ID of the payor */
  PAYOR_ID = 'PAYOR_ID',
  /** Use the ID of the reference */
  REFERENCE_NUMBER = 'REFERENCE_NUMBER'
}

export type InvoiceTemplateFilterArgs = {
  excludeDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  includeSecondaryCollection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTemplateMaximumIsExhaustedError = Error & {
  __typename: 'InvoiceTemplateMaximumIsExhaustedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplateNotFound = Error & {
  __typename: 'InvoiceTemplateNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Configuration for notifications to be sent to the claimant */
export type InvoiceTemplateNotificationInfo = {
  __typename: 'InvoiceTemplateNotificationInfo';
  /** Number of days after which to send the late notification */
  daysUntilLatePaymentNotification: Scalars['Int']['output'];
  /** Number of days after which to send the second collection notification */
  daysUntilSecondaryCollectionWarning: Scalars['Int']['output'];
  /** Whether to send notification about being late with payment */
  sendLatePaymentNotification: Scalars['Boolean']['output'];
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning: Scalars['Boolean']['output'];
};

export type InvoiceTemplateOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: InvoiceTemplateOrderByOption;
};

export enum InvoiceTemplateOrderByOption {
  CategoryCode = 'CategoryCode',
  CreationDate = 'CreationDate',
  Description = 'Description',
  LastEditDate = 'LastEditDate',
  LastUsed = 'LastUsed',
  TemplateCode = 'TemplateCode',
  Type = 'Type'
}

export type InvoiceTemplatePartialPaymentMayNotBeAllowedAlongWithPrincipalDeductionsError = Error & {
  __typename: 'InvoiceTemplatePartialPaymentMayNotBeAllowedAlongWithPrincipalDeductionsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplatePartialPaymentNotAllowedWithDeductionAccountsError = Error & {
  __typename: 'InvoiceTemplatePartialPaymentNotAllowedWithDeductionAccountsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplatePartialPaymentNotAllowedWithForeignCurrencyError = Error & {
  __typename: 'InvoiceTemplatePartialPaymentNotAllowedWithForeignCurrencyError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplatePercentageValueIsInvalidError = Error & {
  __typename: 'InvoiceTemplatePercentageValueIsInvalidError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplatePropertyMayNotBeSetError = Error & {
  __typename: 'InvoiceTemplatePropertyMayNotBeSetError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoiceTemplateSecondaryCollectionGracePeriodDaysIsInvalidError = Error & {
  __typename: 'InvoiceTemplateSecondaryCollectionGracePeriodDaysIsInvalidError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Description of the way we reference the claimant, short */
export enum InvoiceTemplateShortReference {
  /** Reference through ID of the bill */
  BILL_NUMBER = 'BILL_NUMBER',
  /** Use ID of the claim */
  CLAIM_NUMBER = 'CLAIM_NUMBER',
  /** Use due date to reference the claim */
  DUE_DATE = 'DUE_DATE'
}

export enum InvoiceType {
  OPTIONAL_COLLECTION = 'OPTIONAL_COLLECTION',
  PRIMARY_COLLECTION = 'PRIMARY_COLLECTION',
  SECONDARY_COLLECTION = 'SECONDARY_COLLECTION'
}

export type InvoiceUnavailableError = Error & {
  __typename: 'InvoiceUnavailableError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvoicesClaimsStatistics = {
  __typename: 'InvoicesClaimsStatistics';
  claimsCountAfterFinalDueDate: Scalars['Int']['output'];
  claimsCountBeforeFinalDueDate: Scalars['Int']['output'];
  totalAmountDue: Scalars['Float']['output'];
  totalAmountDueAfterFinalDueDate: Scalars['Float']['output'];
  totalAmountDueBeforeFinalDueDate: Scalars['Float']['output'];
  totalClaimsCount: Scalars['Int']['output'];
};

export type InvoicesOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: InvoicesOrderByOption;
};

export enum InvoicesOrderByOption {
  CancellationDate = 'CancellationDate',
  CapitalGainsTaxDue = 'CapitalGainsTaxDue',
  ClaimNumber = 'ClaimNumber',
  CreationDate = 'CreationDate',
  CustomerNumber = 'CustomerNumber',
  DefaultChargeDue = 'DefaultChargeDue',
  DefaultInterestDue = 'DefaultInterestDue',
  DueDate = 'DueDate',
  FinalDueDate = 'FinalDueDate',
  FullPaymentDate = 'FullPaymentDate',
  GrantedPaymentDeadline = 'GrantedPaymentDeadline',
  NotificationFeeDue = 'NotificationFeeDue',
  PayorKennitala = 'PayorKennitala',
  PayorName = 'PayorName',
  PrincipalAmount = 'PrincipalAmount',
  Reference = 'Reference',
  Status = 'Status',
  TemplateCode = 'TemplateCode',
  TotalAmountDue = 'TotalAmountDue'
}

export type InvoicesStatistics = {
  __typename: 'InvoicesStatistics';
  cancelled: Maybe<InvoicesStatisticsAggregation>;
  month: Scalars['DateTimeISO']['output'];
  paid: Maybe<InvoicesStatisticsAggregation>;
  total: Maybe<InvoicesStatisticsAggregation>;
  unpaid: Maybe<InvoicesStatisticsAggregation>;
};

export type InvoicesStatisticsAggregation = {
  __typename: 'InvoicesStatisticsAggregation';
  claimsCount: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type InvoicesStatisticsFilterArgs = {
  /** Earliest claim final due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  finalDueCalendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Latest claim final due date in CalendarDate format (YYYY-MM-DD), which excludes time information and resolves time zone issues. */
  finalDueCalendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** @deprecated Use finalDueCalendarDateFrom instead; Since 2025-11-20; Issue to remove: WEB-38696 */
  finalDueDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** @deprecated Use finalDueCalendarDateTo instead; Since 2025-11-20; Issue to remove: WEB-38696 */
  finalDueDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  status?: InputMaybe<InvoicesStatisticsStatus>;
};

export enum InvoicesStatisticsStatus {
  All = 'All',
  Cancelled = 'Cancelled',
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type IsPossibleDuplicateDomesticCreditTransferInput = {
  /** The payment amount and ISO currency code */
  currencyAmount: CurrencyAmountInput;
  /** Account number of withdrawal account */
  debtorAccountNumber: Scalars['String']['input'];
  /** Account number of deposit account */
  depositAccountNumber: Scalars['String']['input'];
};

export type IsPossibleDuplicateDomesticCreditTransferPayload = {
  __typename: 'IsPossibleDuplicateDomesticCreditTransferPayload';
  isPossibleDuplicate: Scalars['Boolean']['output'];
  possibleDuplicatePaymentTime: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Status of an issued card */
export enum IssuedCardStatus {
  /** Card is 'frozen' and cannot be used */
  FROZEN = 'FROZEN',
  /** Card is 'open' and can be used (e.g. for transactions) */
  OPEN = 'OPEN'
}

export enum IssuedCardType {
  DIGITAL = 'DIGITAL',
  PHYSICAL = 'PHYSICAL',
  UNKNOWN = 'UNKNOWN'
}

export type KennitalaDoesNotExistsError = Error & {
  __typename: 'KennitalaDoesNotExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Kennitala input component */
export type KennitalaFormComponent = FormComponentBase & {
  __typename: 'KennitalaFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  /**
   * Text to display during signing
   * @deprecated Unused by the web application and will be removed from form components.
   */
  signingText: Maybe<Scalars['String']['output']>;
  type: FormComponentType;
  validation: Maybe<FormComponentValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type KennitalaNotFoundError = Error & {
  __typename: 'KennitalaNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type KennitalaNotPersonError = Error & {
  __typename: 'KennitalaNotPersonError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Known party associated with a company (e.g. real owner or stakeholder) */
export type KnownParty = {
  __typename: 'KnownParty';
  /** Name of the known party */
  name: Scalars['String']['output'];
  /** National id (kennitala) of the known party */
  nationalId: Scalars['String']['output'];
  /** Roles held by the known party */
  roles: Array<KnownPartyRole>;
  /** Online bank user status of the known party */
  status: KnownPartyStatus;
};

/** Role of a known party associated with a company */
export enum KnownPartyRole {
  Ceo = 'Ceo',
  Chairman = 'Chairman',
  Procurator = 'Procurator',
  RealOwner = 'RealOwner'
}

/** Online bank user status of a known party */
export enum KnownPartyStatus {
  ActiveUser = 'ActiveUser',
  InactiveUser = 'InactiveUser',
  NoUser = 'NoUser'
}

/** Contains KYC information */
export type Kyc = {
  __typename: 'Kyc';
  /** Questions already answered in the KYC process */
  answeredQuestions: Array<KycQuestionName>;
  /** Whether the answers can be prefilled or not */
  answersPrefillable: Scalars['Boolean']['output'];
  /** Beneficial owners */
  beneficialOwners: Maybe<Array<BeneficialOwner>>;
  /** Business operation */
  businessOperation: Scalars['String']['output'];
  /** Business purpose, SalaryDeposit | BusinessOperations | SecuritiesTransactions | Savings | Acquiring | Other */
  businessPurpose: Maybe<Array<BusinessPurpose>>;
  /** Company contact */
  contact: Maybe<Contact>;
  /** Username of created KYC */
  createdBy: Maybe<Scalars['String']['output']>;
  /** Creation date of KYC */
  createdOn: Scalars['DateTimeISO']['output'];
  /** Types of documents that are missing for the KYC */
  documentsRequired: Maybe<Array<DocumentRequired>>;
  /** An unfinished documents case hangs on the KYC */
  hasUnfinishedDocuments: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the KYC has unfinished identification (e.g., from board members of a company) */
  hasUnfinishedIdentification: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Is company registered on a public market */
  isRegisteredOnMarket: Maybe<Scalars['Boolean']['output']>;
  /** Is KYC valid */
  isValid: Scalars['Boolean']['output'];
  /** ID of KYC */
  kycId: Scalars['ID']['output'];
  /** Legal address of KYC's user */
  legalAddress: Address;
  /** Modification date of KYC */
  modifiedOn: Maybe<Scalars['DateTimeISO']['output']>;
  occupation: Maybe<CustomerOccupation>;
  /** Origin of user's funds, Salary | Inheritance | Foreign | Profit | Loan | Other */
  originOfFunds: Array<OriginOfFunds>;
  originOfFundsCountries: Maybe<Array<CustomerLocation>>;
  originOfFundsCountry: Maybe<CustomerLocation>;
  /** When the user selects the option 'Other' on the business purpose question, they have to answer this */
  otherBusinessPurpose: Maybe<Scalars['String']['output']>;
  /** When the user selects the option 'Other' on the origin of funds question, they have to answer this */
  otherOriginOfFunds: Maybe<Scalars['String']['output']>;
  /** Politically exposed person (user is on the PEP list) */
  politicallyExposedPerson: Array<PoliticallyExposedPerson>;
  /** User's KYC questions and Select list */
  questionnaire: Maybe<KycQuestionsAndKycSelectList>;
  secondaryCitizenship: Maybe<CustomerLocation>;
  /** Stakeholders */
  stakeholders: Maybe<Array<Stakeholder>>;
  status: KycStatus;
  /** User's tax residencies */
  taxResidencies: Maybe<Array<TaxResidency>>;
  thirdParty: Maybe<Scalars['String']['output']>;
  /** Does the user have revenue from the USA */
  usaRevenue: Maybe<Scalars['Boolean']['output']>;
  /** The date the KYC is valid to (expiration date) */
  validTo: Maybe<Scalars['String']['output']>;
  /** URL to a website */
  website: Maybe<Scalars['String']['output']>;
};

export enum KycCategory {
  Flokkur1Ehf = 'Flokkur1Ehf',
  Flokkur2Hf = 'Flokkur2Hf',
  Flokkur3Felagasamtok = 'Flokkur3Felagasamtok',
  Flokkur4Husfelag = 'Flokkur4Husfelag',
  Flokkur5Ohf = 'Flokkur5Ohf',
  Flokkur6Annad = 'Flokkur6Annad',
  Flokkur7OnnurFelagasamtok = 'Flokkur7OnnurFelagasamtok'
}

export type KycInput = {
  businessPurpose?: InputMaybe<Array<BusinessPurpose>>;
  foreignLegalAddress?: InputMaybe<ForeignLegalAddressInput>;
  kennitala: Scalars['String']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  originOfFunds: Array<OriginOfFunds>;
  originOfFundsCountry?: InputMaybe<Scalars['String']['input']>;
  otherBusinessPurpose?: InputMaybe<Scalars['String']['input']>;
  otherOriginOfFunds?: InputMaybe<Scalars['String']['input']>;
  politicallyExposedPerson?: InputMaybe<Array<PoliticallyExposedPersonInput>>;
  secondaryCitizenship?: InputMaybe<Scalars['String']['input']>;
  taxResidencies?: InputMaybe<Array<TaxResidenciesInput>>;
  thirdParty?: InputMaybe<Scalars['String']['input']>;
  usaRevenue: Scalars['Boolean']['input'];
};

export enum KycItemValueType {
  AMBASSADOR = 'AMBASSADOR',
  ASSET_MANAGEMENT = 'ASSET_MANAGEMENT',
  BUSINESS_OPERATIONS = 'BUSINESS_OPERATIONS',
  CENTRAL_BANK_MEMBER = 'CENTRAL_BANK_MEMBER',
  CEO = 'CEO',
  CONGRESSMAN = 'CONGRESSMAN',
  CONTRACTOR = 'CONTRACTOR',
  DIVIDENDS = 'DIVIDENDS',
  EMPLOYED = 'EMPLOYED',
  EQUITY_CONTRIBUTION = 'EQUITY_CONTRIBUTION',
  FOREIGN = 'FOREIGN',
  GENERAL = 'GENERAL',
  GRANTS = 'GRANTS',
  JUDGE = 'JUDGE',
  LOAN = 'LOAN',
  MINISTER = 'MINISTER',
  NO = 'NO',
  NON_PROFIT = 'NON_PROFIT',
  NOTEMPLOYED = 'NOTEMPLOYED',
  OPERATING_REVENUE = 'OPERATING_REVENUE',
  OTHER = 'OTHER',
  PROFIT = 'PROFIT',
  PUBLIC_FIGURE = 'PUBLIC_FIGURE',
  SALARY = 'SALARY',
  SALARY_DEPOSIT = 'SALARY_DEPOSIT',
  SAVINGS = 'SAVINGS',
  SECURITIES_TRANSACTIONS = 'SECURITIES_TRANSACTIONS',
  STUDENT = 'STUDENT',
  UNEMPLOYED = 'UNEMPLOYED',
  UNKNOWN = 'UNKNOWN',
  YES = 'YES'
}

export type KycNotFound = Error & {
  __typename: 'KycNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type KycNotSubmittable = Error & {
  __typename: 'KycNotSubmittable';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** KYC payload */
export type KycPayload = {
  __typename: 'KycPayload';
  /** KYC's payload */
  kyc: Maybe<Kyc>;
};

/** KYC question */
export type KycQuestion = {
  __typename: 'KycQuestion';
  /** Accordion with definitions on a KYC question */
  accordions: Maybe<Array<KycQuestionAccordion>>;
  /** Names of the KYC questions that should be hidden when this question is answered with true. Empty when answering this question hides nothing */
  hideQuestionsWhenTrue: Array<KycQuestionName>;
  /** Id of a KYC question */
  id: Scalars['ID']['output'];
  /** List of inputs on a KYC question */
  inputs: Array<KycQuestionInput>;
  /** Optional metadata on a KYC question, null when the question has no metadata */
  metadata: Maybe<KycQuestionMetadata>;
  /** Name of KYC question, like Occupation or OriginOfFunds */
  questionName: KycQuestionName;
  /** The KYC question text */
  questionText: Maybe<Scalars['String']['output']>;
  /** Text that goes below the KYC question */
  subText: Maybe<Scalars['String']['output']>;
};

/** Accordion on a KYC question */
export type KycQuestionAccordion = {
  __typename: 'KycQuestionAccordion';
  /** Body of a definition accordion on a KYC question */
  body: KycQuestionAccordionBody;
  /** Title of a definition on a KYC question */
  title: Scalars['String']['output'];
};

/** Body of Accordion on a KYC question */
export type KycQuestionAccordionBody = {
  __typename: 'KycQuestionAccordionBody';
  /** Links on a definition on a KYC question */
  links: Maybe<Array<KycQuestionLink>>;
  /** Title of a definition on a KYC question */
  text: Array<Scalars['String']['output']>;
};

/** Button on a KYC question */
export type KycQuestionButton = {
  __typename: 'KycQuestionButton';
  /** Label on a button on a KYC question */
  label: Scalars['String']['output'];
  /** Type of button on a KYC question, Add | Remove */
  type: KycQuestionButtonType;
};

export enum KycQuestionButtonType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  UNKNOWN = 'UNKNOWN'
}

/** Input on a KYC question */
export type KycQuestionInput = {
  __typename: 'KycQuestionInput';
  /** Id on input on a KYC question */
  inputId: KycQuestionInputIdType;
  /** Invalid message on input on a KYC question */
  invalidMessage: Maybe<Scalars['String']['output']>;
  /** A list of items for a KYC question */
  items: Maybe<Array<KycQuestionItem>>;
  /** Label on input on a KYC question */
  label: Scalars['String']['output'];
  /** Placeholder text on input on a KYC question */
  placeholder: Maybe<Scalars['String']['output']>;
  /** The type of data in a Select list on a KYC question */
  selectListType: Maybe<Scalars['String']['output']>;
  /** Input type on a KYC question, RadioGroup | CheckboxGroup | Select | TextBox */
  type: KycQuestionInputType;
};

export enum KycQuestionInputIdType {
  ADD_STAKEHOLDER_BIRTH_DATE = 'ADD_STAKEHOLDER_BIRTH_DATE',
  ADD_STAKEHOLDER_EMAIL = 'ADD_STAKEHOLDER_EMAIL',
  ADD_STAKEHOLDER_HAS_NATIONAL_ID_SWITCH = 'ADD_STAKEHOLDER_HAS_NATIONAL_ID_SWITCH',
  ADD_STAKEHOLDER_NAME = 'ADD_STAKEHOLDER_NAME',
  ADD_STAKEHOLDER_NATIONAL_ID = 'ADD_STAKEHOLDER_NATIONAL_ID',
  ADD_STAKEHOLDER_ROLE = 'ADD_STAKEHOLDER_ROLE',
  BENEFICIAL_OWNER_FOREIGN_ADDRESS_ADDRESS = 'BENEFICIAL_OWNER_FOREIGN_ADDRESS_ADDRESS',
  BENEFICIAL_OWNER_FOREIGN_ADDRESS_CITY = 'BENEFICIAL_OWNER_FOREIGN_ADDRESS_CITY',
  BENEFICIAL_OWNER_FOREIGN_ADDRESS_COUNTRY = 'BENEFICIAL_OWNER_FOREIGN_ADDRESS_COUNTRY',
  BENEFICIAL_OWNER_FOREIGN_ADDRESS_POSTAL_CODE = 'BENEFICIAL_OWNER_FOREIGN_ADDRESS_POSTAL_CODE',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_FOREIGN_RADIO_GROUP = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_FOREIGN_RADIO_GROUP',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_PEP_LIST_RADIO_GROUP = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_PEP_LIST_RADIO_GROUP',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_SECOND_QUESTION_CHECKBOX_GROUP = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_SECOND_QUESTION_CHECKBOX_GROUP',
  BUSINESS_OPERATION_TEXT_BOX = 'BUSINESS_OPERATION_TEXT_BOX',
  FOREIGN_ADDRESS_ADDRESS = 'FOREIGN_ADDRESS_ADDRESS',
  FOREIGN_ADDRESS_CITY = 'FOREIGN_ADDRESS_CITY',
  FOREIGN_ADDRESS_COUNTRY = 'FOREIGN_ADDRESS_COUNTRY',
  FOREIGN_ADDRESS_POSTAL_CODE = 'FOREIGN_ADDRESS_POSTAL_CODE',
  NATIONAL_REGISTRY = 'NATIONAL_REGISTRY',
  NO_WEBSITE_CHECK_BOX = 'NO_WEBSITE_CHECK_BOX',
  OCCUPATION_RADIO_GROUP = 'OCCUPATION_RADIO_GROUP',
  ORIGIN_OF_FUNDS_CHECKBOX_GROUP = 'ORIGIN_OF_FUNDS_CHECKBOX_GROUP',
  ORIGIN_OF_FUNDS_FOREIGN = 'ORIGIN_OF_FUNDS_FOREIGN',
  ORIGIN_OF_FUNDS_OTHER = 'ORIGIN_OF_FUNDS_OTHER',
  PEP_REASON_AMBASSADOR = 'PEP_REASON_AMBASSADOR',
  PEP_REASON_BOARD_DIRECTOR = 'PEP_REASON_BOARD_DIRECTOR',
  PEP_REASON_CENTRAL_BANK = 'PEP_REASON_CENTRAL_BANK',
  PEP_REASON_CONGRESSMAN = 'PEP_REASON_CONGRESSMAN',
  PEP_REASON_DIRECTOR = 'PEP_REASON_DIRECTOR',
  PEP_REASON_HEAD_OF_STATE = 'PEP_REASON_HEAD_OF_STATE',
  PEP_REASON_JUDGE = 'PEP_REASON_JUDGE',
  PEP_REASON_MILITARY = 'PEP_REASON_MILITARY',
  PEP_REASON_NONE = 'PEP_REASON_NONE',
  POLITICAL_RELATIONS_FOREIGN_RADIO_GROUP = 'POLITICAL_RELATIONS_FOREIGN_RADIO_GROUP',
  POLITICAL_RELATIONS_PEP_LIST_RADIO_GROUP = 'POLITICAL_RELATIONS_PEP_LIST_RADIO_GROUP',
  POLITICAL_RELATIONS_SECOND_QUESTION_CHECKBOX_GROUP = 'POLITICAL_RELATIONS_SECOND_QUESTION_CHECKBOX_GROUP',
  PURPOSE_CHECKBOX_GROUP = 'PURPOSE_CHECKBOX_GROUP',
  PURPOSE_OTHER = 'PURPOSE_OTHER',
  REGISTERED_ON_MARKET_RADIO_GROUP = 'REGISTERED_ON_MARKET_RADIO_GROUP',
  SECONDARY_CITIZENSHIP_COUNTRY = 'SECONDARY_CITIZENSHIP_COUNTRY',
  SECONDARY_CITIZENSHIP_RADIO_GROUP = 'SECONDARY_CITIZENSHIP_RADIO_GROUP',
  TAX_RESIDENCY_COUNTRY = 'TAX_RESIDENCY_COUNTRY',
  TAX_RESIDENCY_RADIO_GROUP = 'TAX_RESIDENCY_RADIO_GROUP',
  TAX_RESIDENCY_TIN = 'TAX_RESIDENCY_TIN',
  THIRD_PARTY_RADIO_GROUP = 'THIRD_PARTY_RADIO_GROUP',
  THIRD_PARTY_REASON = 'THIRD_PARTY_REASON',
  UNKNOWN = 'UNKNOWN',
  USA_INCOME_RADIO_GROUP = 'USA_INCOME_RADIO_GROUP',
  WEBSITE_TEXT_BOX = 'WEBSITE_TEXT_BOX'
}

export enum KycQuestionInputType {
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
  CHECK_BOX = 'CHECK_BOX',
  DATE_INPUT = 'DATE_INPUT',
  RADIO_GROUP = 'RADIO_GROUP',
  SELECT = 'SELECT',
  SWITCH = 'SWITCH',
  TEXT_BOX = 'TEXT_BOX',
  UNKNOWN = 'UNKNOWN'
}

/** Item on a KYC question, an item can have a label and a sub container */
export type KycQuestionItem = {
  __typename: 'KycQuestionItem';
  /** Id on item on a KYC question */
  itemId: KycQuestionItemIdType;
  /** Label on a KYC question item */
  label: Scalars['String']['output'];
  /** Sub container on a KYC sub question */
  subContainer: Maybe<KycSubContainer>;
  /** Value of item on KYC question */
  value: KycItemValueType;
};

export enum KycQuestionItemIdType {
  NO = 'NO',
  OCCUPATION_CONTRACTOR = 'OCCUPATION_CONTRACTOR',
  OCCUPATION_EMPLOYED = 'OCCUPATION_EMPLOYED',
  OCCUPATION_STUDENT = 'OCCUPATION_STUDENT',
  OCCUPATION_UNEMPLOYED = 'OCCUPATION_UNEMPLOYED',
  ORIGIN_OF_FUNDS_DIVIDENDS = 'ORIGIN_OF_FUNDS_DIVIDENDS',
  ORIGIN_OF_FUNDS_EQUITY_CONTRIBUTION = 'ORIGIN_OF_FUNDS_EQUITY_CONTRIBUTION',
  ORIGIN_OF_FUNDS_FOREIGN = 'ORIGIN_OF_FUNDS_FOREIGN',
  ORIGIN_OF_FUNDS_GRANTS = 'ORIGIN_OF_FUNDS_GRANTS',
  ORIGIN_OF_FUNDS_LOAN = 'ORIGIN_OF_FUNDS_LOAN',
  ORIGIN_OF_FUNDS_OPERATING_REVENUE = 'ORIGIN_OF_FUNDS_OPERATING_REVENUE',
  ORIGIN_OF_FUNDS_OTHER = 'ORIGIN_OF_FUNDS_OTHER',
  ORIGIN_OF_FUNDS_PROFIT = 'ORIGIN_OF_FUNDS_PROFIT',
  ORIGIN_OF_FUNDS_SALARY = 'ORIGIN_OF_FUNDS_SALARY',
  ORIGIN_OF_FUNDS_SECURITIES_TRANSACTIONS = 'ORIGIN_OF_FUNDS_SECURITIES_TRANSACTIONS',
  PEP_REASON_AMBASSADOR = 'PEP_REASON_AMBASSADOR',
  PEP_REASON_BOARD_DIRECTOR = 'PEP_REASON_BOARD_DIRECTOR',
  PEP_REASON_CENTRAL_BANK = 'PEP_REASON_CENTRAL_BANK',
  PEP_REASON_CONGRESSMAN = 'PEP_REASON_CONGRESSMAN',
  PEP_REASON_DIRECTOR = 'PEP_REASON_DIRECTOR',
  PEP_REASON_HEAD_OF_STATE = 'PEP_REASON_HEAD_OF_STATE',
  PEP_REASON_JUDGE = 'PEP_REASON_JUDGE',
  PEP_REASON_MILITARY = 'PEP_REASON_MILITARY',
  PEP_REASON_NONE = 'PEP_REASON_NONE',
  PURPOSE_ASSET_MANAGEMENT = 'PURPOSE_ASSET_MANAGEMENT',
  PURPOSE_BUSINESS_OPERATIONS = 'PURPOSE_BUSINESS_OPERATIONS',
  PURPOSE_FOREIGN = 'PURPOSE_FOREIGN',
  PURPOSE_NON_PROFIT = 'PURPOSE_NON_PROFIT',
  PURPOSE_OTHER = 'PURPOSE_OTHER',
  PURPOSE_SALARY_DEPOSIT = 'PURPOSE_SALARY_DEPOSIT',
  PURPOSE_SAVINGS = 'PURPOSE_SAVINGS',
  PURPOSE_SECURITIES_TRANSACTIONS = 'PURPOSE_SECURITIES_TRANSACTIONS',
  UNKNOWN = 'UNKNOWN',
  YES = 'YES'
}

/** Link on a KYC question */
export type KycQuestionLink = {
  __typename: 'KycQuestionLink';
  /** Title of a link on a KYC question */
  title: Scalars['String']['output'];
  /** Link on a KYC question */
  url: Scalars['String']['output'];
};

/** Optional metadata on a KYC question, giving extra context about what the question relates to */
export type KycQuestionMetadata = {
  __typename: 'KycQuestionMetadata';
  /** Id of the beneficial owner the question is about. Only set on beneficial owner questions, it can be used to match a question to a beneficial owner */
  beneficialOwnerId: Maybe<Scalars['String']['output']>;
};

export enum KycQuestionName {
  ADD_STAKEHOLDER = 'ADD_STAKEHOLDER',
  BENEFICIAL_OWNERS = 'BENEFICIAL_OWNERS',
  BENEFICIAL_OWNER_FOREIGN_ADDRESS = 'BENEFICIAL_OWNER_FOREIGN_ADDRESS',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_FOREIGN = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_FOREIGN',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_PEP_LIST = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_PEP_LIST',
  BENEFICIAL_OWNER_POLITICAL_RELATIONS_SECOND_QUESTION = 'BENEFICIAL_OWNER_POLITICAL_RELATIONS_SECOND_QUESTION',
  BENEFICIAL_OWNER_TAX_RESIDENCY = 'BENEFICIAL_OWNER_TAX_RESIDENCY',
  FOREIGN_ADDRESS = 'FOREIGN_ADDRESS',
  GENERAL_INFORMATION = 'GENERAL_INFORMATION',
  OCCUPATION = 'OCCUPATION',
  ORIGIN_OF_FUNDS = 'ORIGIN_OF_FUNDS',
  POLITICAL_RELATIONS_FOREIGN = 'POLITICAL_RELATIONS_FOREIGN',
  POLITICAL_RELATIONS_PEP_LIST = 'POLITICAL_RELATIONS_PEP_LIST',
  POLITICAL_RELATIONS_SECOND_QUESTION = 'POLITICAL_RELATIONS_SECOND_QUESTION',
  PURPOSE = 'PURPOSE',
  REGISTERED_ON_MARKET = 'REGISTERED_ON_MARKET',
  SECONDARY_CITIZENSHIP = 'SECONDARY_CITIZENSHIP',
  STAKEHOLDERS_AUTOMATIC = 'STAKEHOLDERS_AUTOMATIC',
  STAKEHOLDERS_MANUAL = 'STAKEHOLDERS_MANUAL',
  TAX_RESIDENCY = 'TAX_RESIDENCY',
  THIRD_PARTY = 'THIRD_PARTY',
  UNKNOWN = 'UNKNOWN',
  USA_INCOME = 'USA_INCOME'
}

/** Input on a sub container on a KYC question */
export type KycQuestionSubContainerInput = {
  __typename: 'KycQuestionSubContainerInput';
  /** Id on input on a KYC question */
  inputId: KycQuestionInputIdType;
  /** Invalid message on input on a KYC question sub container */
  invalidMessage: Scalars['String']['output'];
  /** A list of items for a KYC question sub container */
  items: Maybe<Array<KycQuestionItem>>;
  /** Label on input on a KYC question sub container */
  label: Scalars['String']['output'];
  /** Placeholder text on input on a KYC question sub container */
  placeholder: Maybe<Scalars['String']['output']>;
  /** The type of data in a Select list on a KYC question sub container */
  selectListType: Maybe<Scalars['String']['output']>;
  /** Input type on a KYC question sub container, Select | TextBox */
  type: KycQuestionSubContainerInputType;
};

export enum KycQuestionSubContainerInputType {
  SELECT = 'SELECT',
  TEXT_BOX = 'TEXT_BOX',
  UNKNOWN = 'UNKNOWN'
}

/** KYC questionnaire, a list of questions and a list of KycSelectList */
export type KycQuestionsAndKycSelectList = {
  __typename: 'KycQuestionsAndKycSelectList';
  /** User's questions for KYC */
  questions: Array<KycQuestion>;
  /** A list of key-value pairs, the key being something descriptive like "Country" and the value then being a list of countries for example */
  selectLists: Array<KycSelectList>;
};

/** A list of key-value pairs that are used in the KYC questionnaire */
export type KycSelectList = {
  __typename: 'KycSelectList';
  /** Key of KycSelectList dictionary value, like "Country" for a list of countries */
  key: Scalars['String']['output'];
  /** Title of KycSelectList */
  title: Scalars['String']['output'];
  /** A list of items that can be accessed by a key. The key "Country" could give a list of countries for example */
  value: Array<KycSelectListCountry>;
};

/** Country id and name for country in KYC select list */
export type KycSelectListCountry = {
  __typename: 'KycSelectListCountry';
  /** Two letter country id, like 'is' or 'us' */
  countryId: Scalars['String']['output'];
  /** Name of country */
  name: Scalars['String']['output'];
  /** Tax identification number (TIN) pattern as regex. The pattern is used to validate TIN from user input, if there is no pattern (tinPattern is null) then the TIN can be any string */
  tinPattern: Maybe<Scalars['String']['output']>;
};

export enum KycStatus {
  Draft = 'Draft',
  Expired = 'Expired',
  Inactive = 'Inactive',
  Unvalidated = 'Unvalidated',
  Validated = 'Validated'
}

/** Sub container on a KYC question, a sub container can have accordions, inputs and a button */
export type KycSubContainer = {
  __typename: 'KycSubContainer';
  /** Accordion with definitions on a KYC question */
  accordions: Maybe<Array<KycQuestionAccordion>>;
  /** A button on a KYC question */
  buttons: Maybe<Array<KycQuestionButton>>;
  /** Info text, with title and content */
  infoText: Maybe<KycSubContainerInfoText>;
  /** List of inputs on a KYC sub question */
  inputs: Array<KycQuestionSubContainerInput>;
  /** Label on a button on a KYC sub container */
  label: Scalars['String']['output'];
};

/** Info text on sub container on a KYC question  */
export type KycSubContainerInfoText = {
  __typename: 'KycSubContainerInfoText';
  /** The info text itself */
  text: Scalars['String']['output'];
  /** Title of info text */
  title: Scalars['String']['output'];
};

export type LatestCardTransactionConnection = {
  __typename: 'LatestCardTransactionConnection';
  edges: Array<CardTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LatestCreditCardTransactionConnection = {
  __typename: 'LatestCreditCardTransactionConnection';
  edges: Array<CreditCardTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LegalEntityInput = {
  /** Questions already answered in the KYC process */
  answeredQuestions?: InputMaybe<Array<KycQuestionName>>;
  /** Lýsing á starfsemi */
  businessOperation: Scalars['String']['input'];
  /** Tilgangur viðskipta */
  businessPurpose?: InputMaybe<Array<BusinessPurpose>>;
  /** Email of the contact person */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Occupation of the contact person, either a ContactOccupation ID (832090001) or its value (ceo) */
  contactOccupation?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the contact person, 7 digits or + or 00 followed by 8 to 20 digits. Only registered on the contact if they have no phone number */
  contactPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Erlent lögheimilisfang */
  foreignLegalAddress?: InputMaybe<ForeignLegalAddressInput>;
  /** Skráð á skipulagðan markað í kauphöll */
  isRegisteredOnMarket?: InputMaybe<Scalars['Boolean']['input']>;
  /** Heiti lögaðila */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Uppruni fjármuna */
  originOfFunds: Array<OriginOfFunds>;
  /** Skýring á upprunalöndum erlends fjármagns */
  originOfFundsCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Skýring á upprunalandi erlends fjármagns
   * @deprecated use originOfFundCountries
   */
  originOfFundsCountry?: InputMaybe<Scalars['String']['input']>;
  /** Skýring á öðrum tilgangi viðskipta */
  otherBusinessPurpose?: InputMaybe<Scalars['String']['input']>;
  /** Skýring á öðrum uppruna fjármuna */
  otherOriginOfFunds?: InputMaybe<Scalars['String']['input']>;
  /** Skattalegar heimilisfestir */
  taxResidencies?: InputMaybe<Array<TaxResidenciesInput>>;
  /** Fjármunir í eigu annars aðila */
  thirdParty?: InputMaybe<Scalars['String']['input']>;
  /** Vefsíða lögaðila */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Node representing a guarantee (IS: ábyrgðir) */
export type LiabilityGuarantee = Node & {
  __typename: 'LiabilityGuarantee';
  /** The amount covered by the guarantee */
  amount: CurrencyAmount;
  /** The category of the guarantee type */
  category: LiabilityGuaranteeCategory;
  /** The date of establishment */
  creationDate: Scalars['Date']['output'];
  /** The specific name of the guarantee type */
  guaranteeTypeName: Scalars['String']['output'];
  /** ID (Global) of the guarantee */
  id: Scalars['ID']['output'];
  /** The account number of the guarantee. A unique identifier that has a two letter prefix (GI, RE, II, ...) */
  reference: Scalars['String']['output'];
};

/** The category of a guarantee. Each category can include many guarantee types. */
export enum LiabilityGuaranteeCategory {
  /** A counter guarantee, covers wide specifications of guarantees (IS: Bakábyrgðir/Efndaábyrgðir). */
  COUNTER_GUARANTEE = 'COUNTER_GUARANTEE',
  /** A documentary collection, can either be import or export (IS: Innheimtur). */
  DOCUMENTARY_COLLECTION = 'DOCUMENTARY_COLLECTION',
  /** A documentary credit, can either be import or export (IS: Skjalaábyrgðir). */
  DOCUMENTARY_CREDIT = 'DOCUMENTARY_CREDIT'
}

/** Index type for the loan (vísitala). Enum value description come from API documentation */
export enum LiabilityIndexType {
  /** Byggingarvísitala */
  BYVT = 'BYVT',
  /** Byggingarvísitala 1955 */
  BYVT55 = 'BYVT55',
  /** Byggingarvísitala 1975 */
  BYVT75 = 'BYVT75',
  /** Opnibert gengi ECU */
  ECU = 'ECU',
  /** Launavísitala */
  LAUNVT = 'LAUNVT',
  /** Lánskjaravísitala fjárskuldb. */
  LKVTE = 'LKVTE',
  /** Launavísitala 89+2 */
  LVT892 = 'LVT892',
  /** Óskilgreint */
  UNDEFINED = 'UNDEFINED',
  /** Óþekkt tegund */
  UNKNOWN = 'UNKNOWN',
  /** Opnibert gengi USD */
  USD = 'USD',
  /** Vísitala neysluverðs */
  VTNV = 'VTNV'
}

/** Interface for all liability objects to implement */
export type LiabilityLoanInterface = {
  annuitet: Scalars['Boolean']['output'];
  baseIndex: Maybe<Scalars['Float']['output']>;
  collectionStatus: CollectionBondStatus;
  /** Icelandic: vanskil */
  defaultedAmount: CurrencyAmount;
  firstDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  fullAccountNumber: Scalars['String']['output'];
  indexTypeEnum: LiabilityIndexType;
  indexed: Scalars['Boolean']['output'];
  initialAmount: CurrencyAmount;
  interestCategory: Maybe<Scalars['String']['output']>;
  interestRate: Scalars['Float']['output'];
  issueDate: Scalars['DateTimeISO']['output'];
  lastPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** account number of the loan */
  loanNumber: Scalars['String']['output'];
  loanStatusType: LiabilityLoanStatus;
  mainDebtor: LiabilityParty;
  monthsBetweenPayments: Scalars['Int']['output'];
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Total number of due dates */
  numberOfMonths: Scalars['Int']['output'];
  oldestDefaultedDate: Maybe<Scalars['DateTimeISO']['output']>;
  payBack: Maybe<LiabilityPayback>;
  payments: LiabilityPaymentsConnection;
  /** Icelandic: Eftirstöðvar */
  remainder: CurrencyAmount;
  remainingPayments: Scalars['Int']['output'];
};


/** Interface for all liability objects to implement */
export type LiabilityLoanInterfacePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LiabilityPaymentsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Status of the loan. Enum value description come from API documentation */
export enum LiabilityLoanStatus {
  /** Virkt */
  ACTIVE = 'ACTIVE',
  /** Í skilmálabreytingu (virkt) */
  CHANGEOFTERMS = 'CHANGEOFTERMS',
  /** Afhent */
  DELIVERED = 'DELIVERED',
  /** Niðurfellt (Bara RB) */
  DEPRECATED = 'DEPRECATED',
  /** Óvirkt (ekki skilgreint hvers vegna) */
  INACTIVE = 'INACTIVE',
  /** Flutt á milli lánakerfa */
  MIGRATED = 'MIGRATED',
  /** Uppgreitt */
  PAIDUP = 'PAIDUP',
  /** Óþekkt tegund */
  UNDEFINED = 'UNDEFINED',
  UNKNOWN = 'UNKNOWN',
  /** Afskrifað */
  WRITEOFF = 'WRITEOFF'
}

export type LiabilityOverdraft = {
  __typename: 'LiabilityOverdraft';
  /** The available amount of the account */
  accountAvailableAmount: Maybe<CurrencyAmount>;
  /** The current balance of the account */
  accountBalance: Maybe<CurrencyAmount>;
  /** Whether the account allows applying for or changing overdraft */
  accountIsOverdraftAllowed: Scalars['Boolean']['output'];
  /** Account name */
  accountName: Scalars['String']['output'];
  /** Account number */
  accountNumber: Scalars['String']['output'];
  /** The active overdraft application for the account, if any */
  activeOverdraftApplication: Maybe<ActiveOverdraftApplication>;
  /** The credit limit of the overdraft */
  creditLimitAmount: CurrencyAmount;
  /** The currency of the overdraft and the associated account */
  currency: Scalars['String']['output'];
  /** Date until which the overdraft is valid */
  finalDueDate: Maybe<Scalars['Date']['output']>;
  /** ID (Global) of the liability overdraft */
  id: Scalars['ID']['output'];
  /** The interest rate, a number that represents a percentage, e.g. a value of "17" would represent "17%" */
  interestRate: Scalars['Float']['output'];
  /** The amount of the overdraft that has been used */
  usedAmount: Maybe<CurrencyAmount>;
};

export type LiabilityOverdraftConnection = {
  __typename: 'LiabilityOverdraftConnection';
  edges: Array<LiabilityOverdraftEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** The total credit limit of all overdrafts */
  totalCreditLimitAmount: Maybe<CurrencyAmount>;
  /** The total used amount of all overdrafts */
  totalUsedAmount: Maybe<CurrencyAmount>;
};

export type LiabilityOverdraftEdge = {
  __typename: 'LiabilityOverdraftEdge';
  cursor: Scalars['String']['output'];
  node: LiabilityOverdraft;
};

export type LiabilityParty = {
  __typename: 'LiabilityParty';
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LiabilityPayback = {
  __typename: 'LiabilityPayback';
  defaultFee: CurrencyAmount;
  indexation: CurrencyAmount;
  installmentFee: CurrencyAmount;
  interest: CurrencyAmount;
  paybackValue: CurrencyAmount;
  principal: CurrencyAmount;
};

export type LiabilityPayment = {
  __typename: 'LiabilityPayment';
  /** Icelandic: Greiðsludagur */
  actualPaymentDate: Scalars['DateTimeISO']['output'];
  /** Icelandic: Kostnaður */
  chargesAmount: CurrencyAmount;
  /** Icelandic: Gjalddagi */
  expectedPaymentDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  /** Icelandic: Verðbætur */
  indexation: CurrencyAmount;
  /** Icelandic: Vextir */
  interestAmount: CurrencyAmount;
  /** Icelandic: Verðbætur vaxta */
  interestIndexation: CurrencyAmount;
  /** Icelandic: Dráttarvextir */
  penaltyInterest: CurrencyAmount;
  /** Icelandic: Afborgun á nafnverði */
  principalAmount: CurrencyAmount;
  /** Icelandic: Eftirstöðvar */
  remainingLoanAmount: CurrencyAmount;
  /** Icelandic: Alls greitt */
  totalAmount: CurrencyAmount;
};

export type LiabilityPaymentEdge = {
  __typename: 'LiabilityPaymentEdge';
  cursor: Scalars['String']['output'];
  node: LiabilityPayment;
};

export type LiabilityPaymentsConnection = {
  __typename: 'LiabilityPaymentsConnection';
  edges: Array<LiabilityPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LiabilityPaymentsFilter = {
  /** Start date of the period. If dateTo is provided and not dateFrom, dateFrom will be set as the start of unix time (1970) */
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** End date of the period */
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /**
   * Determines whether the payments are unpaid or paid
   * null or undefined - all payments
   * true - unpaid payments that have created for the bond
   * false - paid payments
   */
  unpaid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Loan = Node & {
  __typename: 'Loan';
  /** The account for debit associated with the loan */
  accountForDebit: Maybe<Scalars['String']['output']>;
  /** Account number of the loan. This is a combination of branch, ledger and account number, ex: 010636000366   */
  accountNumber: Scalars['String']['output'];
  /** The type name of the loan, ex "Lánssamningur" */
  accountTypeName: Maybe<Scalars['String']['output']>;
  /** The adjusted amount of the loan. Icelandic: Fjárhæð jöfnunarreiknings */
  adjustedAmount: Maybe<LoanCurrencyAmount>;
  /** A custom alias of the loan a customer has provided */
  alias: Maybe<Scalars['String']['output']>;
  /** The amount available for withdrawal in a drawdown loan */
  availableAmount: LoanCurrencyAmount;
  /** The currency codes associated with the loan */
  baseCurrencyCode: Array<Scalars['String']['output']>;
  /** The base index of the loan. Icelandic: Grunnvísitala láns */
  baseIndex: Maybe<Scalars['Float']['output']>;
  /** The classification/type of the loan */
  classification: LoanClassification;
  /** The classification ID/type of the loan */
  classificationId: Scalars['Int']['output'];
  /** The names of any co-debtors associated with the loan */
  coDebtorNames: Maybe<Array<Scalars['String']['output']>>;
  /** The credit limit for a drawdown loan (is: Heimild skuldbindingar, getur verið yfrdráttarheimild, kreditkortaheimild eða ádráttarheimild) */
  creditLimit: LoanCurrencyAmount;
  /** The used credit limit for a drawdown loan */
  creditLimitUsed: LoanCurrencyAmount;
  /** The name of the customer associated with the loan */
  customerName: Scalars['String']['output'];
  /** The social security number of the customer associated with the loan */
  customerSsn: Scalars['String']['output'];
  /** The default fee of the loan. This value belongs to the payback section of the loan. Icelandic: Kostnaður vegna vanskila */
  defaultFee: LoanCurrencyAmount;
  /** Total defaults of the loan. Icelandic: vanskil */
  defaultedAmount: LoanCurrencyAmount;
  /** Unique disbursement accounts for a draw down loan. Returns null for non draw down loans */
  disbursementAccounts: Maybe<Array<LoanDrawDownAccount>>;
  /** The display name of the loan */
  displayName: Scalars['String']['output'];
  /** The allowed change date for draw down. Icelandic: Síðasti dagur ádráttar */
  drawDownAllowedChangeDate: Maybe<Scalars['Date']['output']>;
  /** Calculates the cost of the draw down for a loan. Returns null if the loan is not a draw down loan. */
  drawDownCostCalculation: Maybe<LoanDrawDownCostCalculationResult>;
  /** The final date for draw down loans. Icelandic: Gildistími (viðskiptasamnings) */
  drawDownFinalDate: Maybe<Scalars['Date']['output']>;
  /** Options for a draw down on a loan. Returns null if the loan does no support draw downs. */
  drawDownOptions: Maybe<LoanDrawDownOptions>;
  /** Reason why a user can not perform a draw down on a loan. Returns null if there are no stoppers. */
  drawDownStopperReason: Maybe<LoanDrawDownStopperReason>;
  /** The excess payment fee of the loan. This value belongs to the payback section of the loan. Icelandic: Umframgreiðslugjald */
  excessPaymentFee: LoanCurrencyAmount;
  /** The final due date of the loan */
  finalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The first due date of the loan */
  firstDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The start date of the fixed interest period */
  fixedInterestPeriodDateFrom: Maybe<Scalars['DateTimeISO']['output']>;
  /** The end date of the fixed interest period */
  fixedInterestPeriodDateTo: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['ID']['output'];
  /** The account ID associated with the loan */
  idAccount: Scalars['String']['output'];
  /** The index type of the loan. Icelandic: Vísitala (ex. Vísitala neysluverðs, byggingarvísitala, etc.) */
  indexType: LoanIndexType;
  /** Indexation amount of the loan. This value belongs to the payback section of the loan. Icelandic: verðbætur */
  indexation: LoanCurrencyAmount;
  /** Indicates whether the loan is indexed or not. Icelandic (if true): Verðtryggt */
  indexed: Scalars['Boolean']['output'];
  /** The initial amount of the loan */
  initialAmount: LoanCurrencyAmount;
  /** Unique installment accounts for a draw down loan. Returns null for non draw down loans */
  installmentAccounts: Maybe<Array<LoanDrawDownAccount>>;
  /** The installment fee of the loan. This value belongs to the payback section of the loan. Icelandic: Tilkynningar- og greiðslugjald */
  installmentFee: LoanCurrencyAmount;
  /** The interest amount of the loan */
  interest: LoanCurrencyAmount;
  /** Interest category for the loan or leg */
  interestCategory: Scalars['String']['output'];
  /** Interest premium for the loan or leg */
  interestPremium: Scalars['Float']['output'];
  /** The interest rate of the loan */
  interestRate: Scalars['Float']['output'];
  /** Indicates whether the loan is an annuity loan or not. Icelandic true: Jafnar greiðslur, false: Jafnar afborganir */
  isAnnuitet: Scalars['Boolean']['output'];
  /** If true then this loan is a drawdown loan, which effectively means that the borrower can draw down the loan amount in installments rather than receiving the full amount upfront. If false, the loan is considered to be a standard, long-term, loan. */
  isDrawDownLoan: Scalars['Boolean']['output'];
  /** Indicates whether extra payments are allowed for the loan. Icelandic: Má greiða inn á lánið? */
  isExtraPaymentAllowed: Scalars['Boolean']['output'];
  isFixed: Scalars['Boolean']['output'];
  /** Indicates whether the loan is uninsured */
  isUninsuredLoan: Scalars['Boolean']['output'];
  /** The issue date of the loan */
  issueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The last payment date of the loan */
  lastPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** @deprecated Use `legNumber` of LoanLeg instead. Since 2025-11-12. Issue to remove it: WEB-38531 */
  legNumber: Maybe<Scalars['String']['output']>;
  /** The legs of the loan, if any */
  legs: Array<LoanLeg>;
  /** The status of the loan */
  loanStatus: LoanStatus;
  /** The kennitala of the main debtor */
  mainDebtorKennitala: Scalars['String']['output'];
  /** The full name of the main debtor */
  mainDebtorName: Scalars['String']['output'];
  /** The number of months between payments */
  monthsBetweenPayments: Scalars['Int']['output'];
  /** @deprecated Use `nextPayment` of LoanLeg instead. Since 2025-11-12. Issue to remove it: WEB-38532 */
  nextPayment: Maybe<LoanCurrencyAmount>;
  /** The next payment amount of the loan */
  nextPaymentAmount: Maybe<LoanCurrencyAmount>;
  /** The next payment date of the loan */
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Number of legs for loans that have multiple legs. A typical "Viðskiptasamingur" will have 0 or more legs. */
  numberOfLegs: Scalars['Int']['output'];
  /** The total number of payments of the loan */
  numberOfPayments: Scalars['Int']['output'];
  /** The last defaulted date for the loan (is: Síðasti ógreiddi gjalddagi) */
  oldestDefaultedDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when the loan was fully paid up */
  paidUpDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when payback calculation was last updated on the loan */
  paybackCalculationDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The payback value of the loan. Icelandic: Uppgreiðsluverðmæti */
  paybackValue: LoanCurrencyAmount;
  /** The payment per month for the loan */
  paymentPerMonth: LoanCurrencyAmount;
  payments: Maybe<LoanTransactionConnection>;
  /** The principal amount of the loan without all defaults and costs. This value belongs to the payback section of the loan. Icelandic: Eftirstöðvar höfuðstóls */
  principal: LoanCurrencyAmount;
  /** The total number of remaining payments of the loan */
  remainingPayments: Scalars['Int']['output'];
  /** This is the alias that the loan API suggests for the loan. This field is a prime candidate to be a default value for the alias when a customer wants to create a new loan alias. */
  suggestedAlias: Maybe<Scalars['String']['output']>;
  /** Summary grouped by currency code */
  summaryGroupedByCurrency: Maybe<Array<LoanCurrencySummary>>;
  /** The total remainder of the loan, including all defaults and costs. */
  totalRemainder: LoanCurrencyAmount;
};


export type LoanDrawDownCostCalculationArgs = {
  data: LoanDrawDownCostCalculationInput;
};


export type LoanPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  legNumber?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<LoanTransactionStatus>>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type LoanAccessForbiddenError = Error & {
  __typename: 'LoanAccessForbiddenError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanActor = {
  __typename: 'LoanActor';
  kennitala: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type LoanApplicant = {
  __typename: 'LoanApplicant';
  applicantId: Scalars['String']['output'];
  applicantType: LoanApplicantType;
  email: Maybe<Scalars['String']['output']>;
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Maybe<Scalars['String']['output']>;
  signer: Scalars['Boolean']['output'];
};

/** The type of a loan applicant */
export enum LoanApplicantType {
  /** Co applicant [2 in the API] */
  CO_APPLICANT = 'CO_APPLICANT',
  /** Main applicant [1 in the API] */
  MAIN_APPLICANT = 'MAIN_APPLICANT'
}

export type LoanApplication = {
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


export type LoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

/** Yfirleit er ástæðan 'Til er umsókn í stöðunni 'Samþykkt' eða 'Í útgreiðslu' */
export type LoanApplicationApprovalNotAllowed = Error & {
  __typename: 'LoanApplicationApprovalNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanApplicationBond = {
  __typename: 'LoanApplicationBond';
  /** Lánsupphæð */
  amount: Scalars['Float']['output'];
  averageMonthlyPayment: Scalars['Float']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  firstPayment: Scalars['Float']['output'];
  firstPaymentDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  indexType: IndexType;
  interestCategory: Maybe<Scalars['String']['output']>;
  /** Grunnvextir */
  interestRate: Scalars['Float']['output'];
  /** Vaxtaálag */
  interestRateMargin: Scalars['Float']['output'];
  interestRateOptions: Array<InterestRateOption>;
  /** Vextir sem á að birta í ytra viðmóti */
  interestRateWithMargin: Scalars['Float']['output'];
  interestType: InterestType;
  loanDurationMonths: Scalars['Int']['output'];
  loanPaymentType: LoanProductPaymentType;
  loanRequestId: Scalars['Int']['output'];
  /** Maximum months to pay down the loan */
  maxAllowedLoanDurationMonths: Maybe<Scalars['Int']['output']>;
  maxAllowedMortgageRate: Maybe<Scalars['Float']['output']>;
  /** Minimum months to pay down the loan */
  minAllowedLoanDurationMonths: Maybe<Scalars['Int']['output']>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  mortgageRatio: Maybe<Scalars['Float']['output']>;
  numberOfPayments: Scalars['Int']['output'];
  totalPaymentAmount: Scalars['Float']['output'];
  yearlyCostRatio: Scalars['Float']['output'];
};

/** Collateral request attached to a loan application */
export type LoanApplicationCollateralRequest = {
  __typename: 'LoanApplicationCollateralRequest';
  /** The ID of the collateral request */
  id: Scalars['ID']['output'];
  /** Product name of the collateral request. Example: "Sjálfskuldarábyrgð" */
  productName: Scalars['String']['output'];
  productType: LoanApplicationProductType;
};

export type LoanApplicationCommentPayload = {
  __typename: 'LoanApplicationCommentPayload';
  success: Scalars['Boolean']['output'];
};

/** Type of comment attached to a loan application */
export enum LoanApplicationCommentTypeId {
  /** Basic comment (Hefbundið) */
  BASIC_COMMENT = 'BASIC_COMMENT',
  /** Comment from customer regarding application where loan is over fixed interest on new real estate */
  CUSTOMER_ASKED_FOR_LOAN_OVER_FIXED_INTEREST_MAX_COMMENT = 'CUSTOMER_ASKED_FOR_LOAN_OVER_FIXED_INTEREST_MAX_COMMENT',
  /** Comment from customer that wants to refinance with a real estate that he does not own 100% */
  CUSTOMER_DOES_NOT_FULLY_OWN_REAL_ESTATE_COMMENT = 'CUSTOMER_DOES_NOT_FULLY_OWN_REAL_ESTATE_COMMENT',
  /** Comment from customer that cannot continue application due to one or more of the applicants not having a legal address in Iceland */
  CUSTOMER_DOES_NOT_HAVE_ICELANDIC_LEGAL_ADDRESS_COMMENT = 'CUSTOMER_DOES_NOT_HAVE_ICELANDIC_LEGAL_ADDRESS_COMMENT',
  /** Comment from customer that the ownership ratio is not correct */
  CUSTOMER_GUARANTOR_OWNERSHIP_RATIO_IS_WRONG_COMMENT = 'CUSTOMER_GUARANTOR_OWNERSHIP_RATIO_IS_WRONG_COMMENT',
  /** Comment from customer that wants to refinance with affiliate loan (hlutdeildarlán) */
  CUSTOMER_HAS_AFFILIATE_LOAN_COMMENT = 'CUSTOMER_HAS_AFFILIATE_LOAN_COMMENT',
  /** Comment from customer that wants to refinance with loan from another bank */
  CUSTOMER_HAS_LOAN_FROM_OTHER_BANK_COMMENT = 'CUSTOMER_HAS_LOAN_FROM_OTHER_BANK_COMMENT',
  /** Comment from customer regarding income */
  CUSTOMER_INCOME_COMMENT = 'CUSTOMER_INCOME_COMMENT',
  /** Comment from customer regarding being over mortgage ratio */
  CUSTOMER_MORTGAGE_RATIO_COMMENT = 'CUSTOMER_MORTGAGE_RATIO_COMMENT',
  /** Comment from customer in cases where mortgage requires manual processing */
  CUSTOMER_MORTGAGE_REQUIRES_MANUAL_PROCESS_COMMENT = 'CUSTOMER_MORTGAGE_REQUIRES_MANUAL_PROCESS_COMMENT',
  /** Comment from customer regarding payment per month */
  CUSTOMER_PAYMENT_PER_MONTH_COMMENT = 'CUSTOMER_PAYMENT_PER_MONTH_COMMENT',
  /** Comment from customer regarding transferred loans are over fixed interest on new real estate */
  CUSTOMER_TRANSFERRED_LOANS_ARE_OVER_FIXED_INTEREST_MAX_COMMENT = 'CUSTOMER_TRANSFERRED_LOANS_ARE_OVER_FIXED_INTEREST_MAX_COMMENT',
  /** Comment from customer that wants to cancel the loan application */
  CUSTOMER_WANTS_TO_CANCEL_LOAN_APPLICATION = 'CUSTOMER_WANTS_TO_CANCEL_LOAN_APPLICATION',
  /** Comment from customer that wants to use other collateral (fá ráðgjöf við val trygginga) */
  CUSTOMER_WANTS_TO_USE_OTHER_COLLATERAL = 'CUSTOMER_WANTS_TO_USE_OTHER_COLLATERAL',
  /** Comment related to decision (Samþykktarferli) */
  DECISION_COMMENT = 'DECISION_COMMENT',
  /** Comment reasoning revisiting process */
  LOAN_PROCESSING_REVISIT_COMMENT = 'LOAN_PROCESSING_REVISIT_COMMENT',
  /** Comment related to loan processing (Athugasemd Lánaumsjónar við endursendingu í útibú) */
  READY_FOR_DOCUMENT_PROCESS_COMMENT = 'READY_FOR_DOCUMENT_PROCESS_COMMENT'
}

export type LoanApplicationDecision = {
  __typename: 'LoanApplicationDecision';
  status: Scalars['String']['output'];
};

export type LoanApplicationDecisionPayload = {
  __typename: 'LoanApplicationDecisionPayload';
  decision: LoanApplicationDecision;
};

export type LoanApplicationDecisionUnion = LoanApplicationApprovalNotAllowed | LoanApplicationDecision;

export type LoanApplicationDocument = {
  __typename: 'LoanApplicationDocument';
  contractDocumentId: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  documentPdf: Scalars['String']['output'];
  documentType: LoanApplicationDocumentType;
  id: Scalars['Int']['output'];
  isAvailablePerLoanRequest: Scalars['Boolean']['output'];
  isCreditAssessmentDocument: Scalars['Boolean']['output'];
  /** If true then this document needs to be signed */
  isSignable: Scalars['Boolean']['output'];
  loanRequestId: Maybe<Scalars['Int']['output']>;
  onlyOverdraft: Scalars['Boolean']['output'];
  /** @deprecated Use documentType instead */
  type: Scalars['String']['output'];
  webDescription: Scalars['String']['output'];
};

/** The type of a loan applicant */
export enum LoanApplicationDocumentType {
  /** Allocation document || Ráðstöfunarblað */
  ALLOCATION_DOCUMENT = 'ALLOCATION_DOCUMENT',
  /** Conclusion document || Niðurstöðuskjal greiðslumats */
  CONCLUSION_DOCUMENT_WITH_LOAN = 'CONCLUSION_DOCUMENT_WITH_LOAN',
  /** Consumer loan document || Upplýsingaefni Neytendastofu */
  CONSUMER_LOAN_DOCUMENT = 'CONSUMER_LOAN_DOCUMENT',
  /** Consumer loan supporting package */
  CONSUMER_LOAN_SUPPORTING_PACKAGE = 'CONSUMER_LOAN_SUPPORTING_PACKAGE',
  /** Credit card distribution document || Stofnsamningur, greiðsludreifing kreditkorts */
  CREDITCARD_DISTRIBUTION_DOCUMENT = 'CREDITCARD_DISTRIBUTION_DOCUMENT',
  /** Information paper || Staðlað upplýsingablað */
  INFORMATION_PAPER = 'INFORMATION_PAPER',
  /** Loan application decision document || Ákvörðunarblað lánsumsóknar */
  LOAN_APPLICATION_DECISION_DOCUMENT = 'LOAN_APPLICATION_DECISION_DOCUMENT',
  /** Loan bond document || Skuldabréf */
  LOAN_BOND_DOCUMENT = 'LOAN_BOND_DOCUMENT',
  /** Loan document package */
  LOAN_DOCUMENT_PACKAGE = 'LOAN_DOCUMENT_PACKAGE',
  /** Loan equipment financing document */
  LOAN_EQUIPMENT_FINANCING_DOCUMENT = 'LOAN_EQUIPMENT_FINANCING_DOCUMENT',
  /** Overdraft contract || Stofnsamningur yfirdráttar */
  OVERDRAFT_CONTRACT = 'OVERDRAFT_CONTRACT',
  /** Overdraft notice || Tilkynning um breytingu yfirdráttar */
  OVERDRAFT_NOTICE = 'OVERDRAFT_NOTICE',
  /** Overdraft proxy || Umboð - yfirdráttur */
  OVERDRAFT_PROXY = 'OVERDRAFT_PROXY',
  /** Payment plan || Greiðsluáætlun */
  PAYMENT_PLAN = 'PAYMENT_PLAN',
  /** Printable documents package */
  PRINTABLE_DOCUMENTS_PACKAGE = 'PRINTABLE_DOCUMENTS_PACKAGE',
  /** Proposal || Tillaga */
  PROPOSAL = 'PROPOSAL',
  /** Signable documents package */
  SIGNABLE_DOCUMENTS_PACKAGE = 'SIGNABLE_DOCUMENTS_PACKAGE',
  /** Simple contract document || Staðfesting einfaldrar undirritunar */
  SIMPLE_CONTRACT_DOCUMENT = 'SIMPLE_CONTRACT_DOCUMENT',
  /** Surety document || Sjálfskuldarábyrgð */
  SURETY_DOCUMENT = 'SURETY_DOCUMENT',
  /** Unknown document type - returned by GraphQL whenever the API adds a new document type that is not handled yet by us */
  UNKNOWN = 'UNKNOWN'
}

/** Type of document contents related to loan application */
export enum LoanApplicationDocumentTypeId {
  /** A offer for a real estate (Kauptilboð) */
  ORDER_TO_BUY = 'ORDER_TO_BUY',
  /** Other documents */
  OTHER_DOCUMENTS = 'OTHER_DOCUMENTS',
  /** Contract showing the purchase to buy a real estate (Kaupsamningur/afsal) */
  PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
  /** Documents that verify a source of income. Used for a better credit assessment result. */
  REVENUE_INFORMATION = 'REVENUE_INFORMATION',
  /** A variety of documents (Óflokkað) */
  UNCATEGORIZED = 'UNCATEGORIZED'
}

export type LoanApplicationDoesNotExistError = Error & {
  __typename: 'LoanApplicationDoesNotExistError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanApplicationFee = {
  __typename: 'LoanApplicationFee';
  amount: Scalars['Float']['output'];
  /** Details of the fee. */
  details: Maybe<LoanFeeDetails>;
  feeType: LoanApplicationFeeType;
  id: Scalars['ID']['output'];
  productDescription: Scalars['String']['output'];
  unitPrice: Scalars['Float']['output'];
  unitPriceIsPercentage: Scalars['Boolean']['output'];
};

/** Type of fee */
export enum LoanApplicationFeeType {
  /** [Skuldabrefsgjald] Bond fee */
  BOND_FEE = 'BOND_FEE',
  /** [Greiðslumatsgjald] Credit assessment fee */
  CREDIT_ASSESSMENT_FEE = 'CREDIT_ASSESSMENT_FEE',
  /** [Fragangsgjald] Finish fee */
  FINISH_FEE = 'FINISH_FEE',
  /** [Lantokugjald] Loan fee */
  LOAN_FEE = 'LOAN_FEE',
  /** [Lanayfirlit] Loan overview fee */
  LOAN_OVERVIEW_FEE = 'LOAN_OVERVIEW_FEE',
  /** [VedbokarVottord] Mortgage book fee */
  MORTGAGE_BOOK_FEE = 'MORTGAGE_BOOK_FEE',
  /** Other known type of fee. Getting this type will not provide any value to the client */
  OTHER = 'OTHER',
  /** [Greidslugjald] Payment fee */
  PAYMENT_FEE = 'PAYMENT_FEE',
  /** [Tinglysingargjald] Registration fee */
  REGISTRATION_FEE = 'REGISTRATION_FEE',
  /** An Unknown document. This will be returned for new document types that are added in the API (and are not handled by GraphQL yet) */
  UNKNOWN = 'UNKNOWN'
}

/** Guarantor for surety on a loan application */
export type LoanApplicationGuarantor = {
  __typename: 'LoanApplicationGuarantor';
  id: Scalars['ID']['output'];
  /** Icelandic National Registry kennitala of the guarantor */
  kennitala: Scalars['String']['output'];
  /** Full name of the guarantor */
  name: Scalars['String']['output'];
  /** Ownership ratio of the guarantor. Example: 33.33 */
  ownershipRatio: Scalars['Float']['output'];
};

export type LoanApplicationNotApproved = Error & {
  __typename: 'LoanApplicationNotApproved';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Error types for a loan amount options in loan application */
export enum LoanApplicationOptionsResultError {
  /**
   * Not enough liquidity (Greiðslugeta ekki næg)
   * @deprecated Reason: No longer in use for loan applications. Since: 2024-01-15. Issue to remove it: WEB-20701
   */
  CANNOT_AFFORD_ANY_LOAN = 'CANNOT_AFFORD_ANY_LOAN',
  /** Applicants of the loan application do not own the real estate fully and can not continue the loan application without manual approval */
  DOES_NOT_FULLY_OWN_REAL_ESTATE = 'DOES_NOT_FULLY_OWN_REAL_ESTATE',
  /** Main applicant and/or the co applicant do not have a legal address in Iceland, meaning they can not fully complete loan application without manual approval */
  DOES_NOT_HAVE_ICELANDIC_LEGAL_ADDRESS = 'DOES_NOT_HAVE_ICELANDIC_LEGAL_ADDRESS',
  /** Customer is paying mortgage loan from other bank and has negative monthly ability to pay. User can not continue loan application without manual approval */
  LOAN_FROM_OTHER_BANK = 'LOAN_FROM_OTHER_BANK',
  /** Mortgages transferred over in mortgage application are above max mortgage ratio, the user can not continue the loan application without manual approval */
  MORTGAGE_TRANSFER_ABOVE_ALLOWED_MORTGAGE_RATIO = 'MORTGAGE_TRANSFER_ABOVE_ALLOWED_MORTGAGE_RATIO',
  MORTGAGE_TYPE_REQUIRES_MANUAL_PROCESSING = 'MORTGAGE_TYPE_REQUIRES_MANUAL_PROCESSING',
  /** Over mortgage ratio (Yfir hámarks veðhlutfall), can not continue loan application without manual approval */
  OVER_MAX_MORTGAGE_RATE = 'OVER_MAX_MORTGAGE_RATE',
  /** Unknown error */
  UNKNOWN = 'UNKNOWN'
}

/** Loan package calculated for loan application */
export type LoanApplicationPackagePayload = {
  __typename: 'LoanApplicationPackagePayload';
  /** The amount of the loan */
  amount: Scalars['Float']['output'];
  /** The package type of the loan (NonIndexedPackage, IndexedPackage, MixedPackage) */
  loanPackageType: LoanApplicationPackageType;
  /** loan details */
  loans: Array<LoanPackageLoan>;
  /** How many payments are paid per month */
  paymentPerMonth: Scalars['Float']['output'];
  /** Estimated total payment of the loan */
  totalPayment: Scalars['Float']['output'];
  /** Yearly cost ratio */
  yearlyCostRatio: Scalars['Float']['output'];
};

export enum LoanApplicationPackageType {
  INDEXED_PACKAGE = 'INDEXED_PACKAGE',
  MIXED_PACKAGE = 'MIXED_PACKAGE',
  NON_INDEXED_PACKAGE = 'NON_INDEXED_PACKAGE'
}

export type LoanApplicationParty = {
  __typename: 'LoanApplicationParty';
  email: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kennitala: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  type: LoanApplicationPartyType;
};

export type LoanApplicationPartyInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Type of loan application party */
export enum LoanApplicationPartyType {
  APPLICANT_ON_BEHALF_OF_COMPANY = 'APPLICANT_ON_BEHALF_OF_COMPANY',
  APPLICANT_SPOUSE = 'APPLICANT_SPOUSE',
  BOARD_CO_MANAGER = 'BOARD_CO_MANAGER',
  BOARD_MEMBER = 'BOARD_MEMBER',
  BOARD_SUBSTITUTE = 'BOARD_SUBSTITUTE',
  CHAIRMAN_OF_THE_BOARD = 'CHAIRMAN_OF_THE_BOARD',
  COMMISSIONER = 'COMMISSIONER',
  COMPANY_EMPLOYEE = 'COMPANY_EMPLOYEE',
  COMPANY_SIGNATORY = 'COMPANY_SIGNATORY',
  CO_APPLICANT = 'CO_APPLICANT',
  CO_OWNER = 'CO_OWNER',
  DEBTOR = 'DEBTOR',
  DOCUMENT_SIGNER = 'DOCUMENT_SIGNER',
  FINANCIAL_GUARDIAN = 'FINANCIAL_GUARDIAN',
  GUARANTOR = 'GUARANTOR',
  INSURANCE_COMPANY = 'INSURANCE_COMPANY',
  LEGAL_GUARDIAN = 'LEGAL_GUARDIAN',
  MAIN_APPLICANT = 'MAIN_APPLICANT',
  OTHER = 'OTHER',
  PRE_DEFINED_PAYMENT_RECEIVER = 'PRE_DEFINED_PAYMENT_RECEIVER',
  REAL_ESTATE_BROKER = 'REAL_ESTATE_BROKER',
  SELLER = 'SELLER',
  SELLER_SPOUSE = 'SELLER_SPOUSE',
  TRUSTEE = 'TRUSTEE',
  VEHICLE_BROKER = 'VEHICLE_BROKER',
  VEHICLE_DEALER = 'VEHICLE_DEALER'
}

export type LoanApplicationPaymentInstruction = {
  __typename: 'LoanApplicationPaymentInstruction';
  /** Account that the instruction's action will affect */
  accountNumber: Maybe<Scalars['String']['output']>;
  /** Amount to be paid */
  amount: Scalars['Float']['output'];
  /** Action performed by this instruction */
  paymentInstructionActionType: PaymentInstructionActionType;
  /** Describes the type of the instruction */
  paymentInstructionType: PaymentInstructionType;
  /** Kennitala of the owner of the account */
  payorKennitala: Maybe<Scalars['String']['output']>;
  /** Name of the owner of the account */
  payorName: Maybe<Scalars['String']['output']>;
};

export type LoanApplicationPaymentInstructionInput = {
  accountNumber: Scalars['String']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentInstructionActionType: PaymentInstructionActionType;
  paymentInstructionType: PaymentInstructionType;
};

/** Information about maximum and minimum payments per month onto mortgage loan */
export type LoanApplicationPaymentsPerMonthResult = {
  __typename: 'LoanApplicationPaymentsPerMonthResult';
  centralBankMaxPayment: Scalars['Float']['output'];
  lowestPaymentPerMonthToShowMaximumPackages: Scalars['Float']['output'];
  maxBaseLoanIndexedRatio: Scalars['Float']['output'];
  maxBaseLoanNonIndexedRatio: Scalars['Float']['output'];
  maximumPaymentPerMonth: Scalars['Float']['output'];
  minimumPaymentPerMonth: Scalars['Float']['output'];
};

/** Product type pertaining to a loan application */
export enum LoanApplicationProductType {
  AMENDMENT = 'AMENDMENT',
  BOND = 'BOND',
  COLLATERAL = 'COLLATERAL',
  CREDIT_CARD = 'CREDIT_CARD',
  CREDIT_CARD_BOND = 'CREDIT_CARD_BOND',
  LOAN_FRAME = 'LOAN_FRAME',
  MORTGAGE_TRANSFER = 'MORTGAGE_TRANSFER',
  OVERDRAFT = 'OVERDRAFT',
  UNKNOWN = 'UNKNOWN'
}

export type LoanApplicationSignature = {
  __typename: 'LoanApplicationSignature';
  canBeElectricallySigned: Scalars['Boolean']['output'];
  digitalSignatureGroup: Maybe<DigitalSignatureGroup>;
  /** Indicates whether a document has been signed, either electronically or in personal */
  isSigned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The order in which the documents are supposed to be signed in. Range from 1 to *, multiple signatures can have the same order */
  signatureOrder: Scalars['Int']['output'];
  signatureSlots: Array<DigitalSignatureSlot>;
  signatureStatus: SignatureStatus;
  signatureType: LoanApplicationSignatureType;
};

export type LoanApplicationSignatureGroup = {
  __typename: 'LoanApplicationSignatureGroup';
  digitalSignatureGroup: Maybe<DigitalSignatureGroup>;
  /** Loan application signatures that refer to the accompanying group id */
  signatures: Array<LoanApplicationSignature>;
};

/** Type of signature needed for a loan application  */
export enum LoanApplicationSignatureStatus {
  /** All documents have been signed */
  ALL_DOCUMENTS_SIGNED = 'ALL_DOCUMENTS_SIGNED',
  /** Loan application has been approved but electronic signatures have not been started by the bank */
  ELECTRONIC_SIGNATURE_NOT_STARTED = 'ELECTRONIC_SIGNATURE_NOT_STARTED',
  /** A document needs signing in a branch */
  NEEDS_BRANCH_SIGNATURE = 'NEEDS_BRANCH_SIGNATURE',
  /** An electronic document needs signing */
  NEEDS_TO_SIGN_ELECTRONIC_DOCUMENT = 'NEEDS_TO_SIGN_ELECTRONIC_DOCUMENT',
  /** Unknown signature status */
  UNKNOWN_SIGNATURE_STATUS = 'UNKNOWN_SIGNATURE_STATUS'
}

/** Type of signature needed for a loan application  */
export enum LoanApplicationSignatureType {
  /** Fylgiskjöl | Signature needed  for additional documents. This involve always multiple documents that need to be signed */
  ACCOMPANYING_DOCUMENT = 'ACCOMPANYING_DOCUMENT',
  /** Lánaskjöl | Signature needed for loan document. This involves always exactly one document that needs to be signed */
  LOAN_DOCUMENT = 'LOAN_DOCUMENT',
  /** Unknown signature type - when the are 0 documents */
  UNKNOWN = 'UNKNOWN'
}

export enum LoanApplicationStatus {
  ApprovalProcessInProgress = 'ApprovalProcessInProgress',
  Approved = 'Approved',
  AwaitingSignature = 'AwaitingSignature',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
  DocumentProcessCompleted = 'DocumentProcessCompleted',
  DocumentProcessInProgress = 'DocumentProcessInProgress',
  InProgress = 'InProgress',
  InProgressByApplicant = 'InProgressByApplicant',
  ManualPayOutInProgress = 'ManualPayOutInProgress',
  PaidOut = 'PaidOut',
  PayOutInProgress = 'PayOutInProgress',
  ReadyForDocumentProcess = 'ReadyForDocumentProcess',
  ReadyForPayOut = 'ReadyForPayOut',
  SentToApproval = 'SentToApproval',
  Unknown = 'Unknown',
  WaitingForCustomer = 'WaitingForCustomer',
  WaitingForPayoutReview = 'WaitingForPayoutReview'
}

/** Type of loan application */
export enum LoanApplicationType {
  /** API Id: 6 | Consumer loan application (on Individual users) */
  ConsumerLoan = 'ConsumerLoan',
  /** API Id: 10 | Consumer loan application (on Corporate users) */
  CorporateConsumerLoan = 'CorporateConsumerLoan',
  /** API Id: 11 | Loan application for a vehicle (on Corporate users) */
  CorportateCarloan = 'CorportateCarloan',
  /** API Id: 5 | Loan application for a credit card */
  CreditCard = 'CreditCard',
  /** API Id: 3 | Loan application of other type  */
  Other = 'Other',
  /** API Id: 7 | Loan application for payment difficulties */
  PaymentDifficulties = 'PaymentDifficulties',
  /** API Id: 1 | Loan application for real estate */
  RealEstate = 'RealEstate',
  /** API Id: 4 | Loan application of type refinance (for a real estate loan) */
  RealEstateRefinance = 'RealEstateRefinance',
  /** API Id: 2 | Loan application for a vehicle (on Individual users) */
  Vehicle = 'Vehicle'
}

/** The type of a loan applicant */
export enum LoanApplicationValidationName {
  /** The applicant is neither the executive director or the authorized signatory for the company. In the case of overdraft, this would result in the application being handled manually */
  APPLICANT_ON_BEHALF_OF_COMPANY_IS_NOT_EXECUTIVE_DIRECTOR_OR_AUTHORIZED_SIGNATORY = 'APPLICANT_ON_BEHALF_OF_COMPANY_IS_NOT_EXECUTIVE_DIRECTOR_OR_AUTHORIZED_SIGNATORY',
  /** Customer does not have a high enough burden (greiðslubyrði) to sustain the monthly payments */
  CANNOT_PAY_FOR_LOAN = 'CANNOT_PAY_FOR_LOAN',
  /** Credit assessment is inactive */
  CREDIT_ASSESSMENT_IS_INACTIVE = 'CREDIT_ASSESSMENT_IS_INACTIVE',
  /** The applicant has a red flag from the Early Warning System */
  EWS_RED_COLOR = 'EWS_RED_COLOR',
  /** The applicant does not have a legal address in Iceland */
  HAS_ICELANDIC_LEGAL_ADDRESS = 'HAS_ICELANDIC_LEGAL_ADDRESS',
  /** Boolean if applicant needs to sign the KYC */
  HAS_SIGNED_KYC = 'HAS_SIGNED_KYC',
  /** The applicant has not reached the age to apply (must be at least 18) */
  MINIMUM_AGE = 'MINIMUM_AGE',
  /** No collateral document is present. This can be amended by adding a collateral (trygging, t.d. sjálfskuldarábyrgð) document */
  MISSING_COLLATERAL_DOCUMENT = 'MISSING_COLLATERAL_DOCUMENT',
  /** The applicant can no longer conduct business with the bank */
  NO_BUSINESS_PERMITTED = 'NO_BUSINESS_PERMITTED',
  /** No credit assessment on application */
  NO_CREDIT_ASSESSMENT_ON_APPLICATION = 'NO_CREDIT_ASSESSMENT_ON_APPLICATION',
  /** Vehicle does not have a registered plate number */
  PLATE_NOT_ON_VEHICLE = 'PLATE_NOT_ON_VEHICLE',
  /** Individual does not fully own the real estate and some actions on the application might not be accessible */
  REAL_ESTATE_NOT_FULLY_OWNED = 'REAL_ESTATE_NOT_FULLY_OWNED',
  /** Other reason */
  UNKNOWN = 'UNKNOWN',
  /** Vehicle value does not reflect the price */
  VEHICLE_AMOUNT_OVERESTIMATED_VALUATION = 'VEHICLE_AMOUNT_OVERESTIMATED_VALUATION',
  /** Vehicle has been damaged (Tjónabíll) */
  VEHICLE_HAS_DISASTERS = 'VEHICLE_HAS_DISASTERS',
  /** Vehicle has been driven too much for loan */
  VEHICLE_ODOMETER_TOO_HIGH = 'VEHICLE_ODOMETER_TOO_HIGH',
  /** Vehicle too old for loan */
  VEHICLE_TOO_OLD = 'VEHICLE_TOO_OLD',
  /** Applicant has zero credit-rating (lánshæfiseinkun) */
  ZERO_RISK_RATING = 'ZERO_RISK_RATING'
}

/** Types of purchases when applying for a new mortgage loan */
export enum LoanApplicationValuationConstants {
  /** Purchase price of property */
  PURCHASE_CONTRACT = 'PURCHASE_CONTRACT',
  /** Purchase price of Property */
  PURCHASE_OFFER = 'PURCHASE_OFFER',
  /** Appraisal price of property */
  REAL_ESTATE_APPRAISAL = 'REAL_ESTATE_APPRAISAL',
  /** Appraisal price of property based on next year */
  REAL_ESTATE_APPRAISAL_NEXT_YEAR = 'REAL_ESTATE_APPRAISAL_NEXT_YEAR',
  /** Unknown type */
  UNKNOWN = 'UNKNOWN',
  /** Valuation price of property */
  VALUATION = 'VALUATION'
}

export type LoanCalculation = {
  __typename: 'LoanCalculation';
  averageFirstYearMonthlyPayment: Scalars['Float']['output'];
  /** Minimum monthly payments based from Seðlabanka */
  centralBankMinPaymentPerMonth: Maybe<Scalars['Float']['output']>;
  disbursementDate: Scalars['DateTimeISO']['output'];
  feeItems: Array<LoanFee>;
  firstMonthlyPayment: Scalars['Float']['output'];
  firstPaymentDate: Scalars['DateTimeISO']['output'];
  flows: Array<Flow>;
  id: Scalars['ID']['output'];
  indexType: IndexType;
  interestRate: Scalars['Float']['output'];
  isExtraLoan: Maybe<Scalars['Boolean']['output']>;
  loanDurationMonths: Scalars['Int']['output'];
  loanPaymentType: LoanProductPaymentType;
  /** Maximum number of months to pay down the loan */
  maxNumberOfPayments: Maybe<Scalars['Int']['output']>;
  monthlyPayment: Scalars['Float']['output'];
  oneYearIndexProjection: Scalars['Float']['output'];
  order: Maybe<Scalars['Int']['output']>;
  totalAmount: Scalars['Float']['output'];
  totalFeeAmount: Scalars['Float']['output'];
  /**
   * Total index amount for the loan (IS: Heildar Verðbætur).
   * PrincipalIndexAmount and InterestIndexAmount summed up for each payment
   */
  totalIndexAmount: Scalars['Float']['output'];
  totalInterestAmount: Scalars['Float']['output'];
  totalPrincipalAmount: Scalars['Float']['output'];
  yearlyCostRatio: Scalars['Float']['output'];
};

export type LoanCalculatorInput = {
  loanOptions: Array<LoanOptionInput>;
  marketValue?: InputMaybe<Scalars['Float']['input']>;
};

/** The classification of a loan */
export enum LoanClassification {
  /** Building loan (IS: Framkvæmdalán) */
  BUILDING = 'BUILDING',
  /** Credit agreement loan (IS: Lánssamningur) */
  CREDIT_AGREEMENT = 'CREDIT_AGREEMENT',
  /** Credit line loan (IS: Viðskiptasamningur/Lánalína) */
  CREDIT_LINE = 'CREDIT_LINE',
  /** Factoring loan */
  FACTORING = 'FACTORING',
  /** Inventory loan (IS: Afurðalán) */
  INVENTORY = 'INVENTORY',
  /** Revolver loan */
  REVOLVER = 'REVOLVER',
  /** SAK loan (IS: SAK kröfur) */
  SAK = 'SAK',
  /** Senior loan */
  SENIOR = 'SENIOR',
  /** Unknown loan classification */
  UNKNOWN = 'UNKNOWN'
}

export type LoanConnection = {
  __typename: 'LoanConnection';
  edges: Array<LoanEdge>;
  pageInfo: PageInfo;
  totalAmount: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
};

export type LoanCurrencyAmount = {
  __typename: 'LoanCurrencyAmount';
  amountInCurrency: Scalars['Float']['output'];
  amountInIsk: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
};

/** Summary of loan amounts grouped by currency code */
export type LoanCurrencySummary = {
  __typename: 'LoanCurrencySummary';
  currencyCode: Scalars['String']['output'];
  initialAmount: LoanCurrencyAmount;
  numberOfLegs: Scalars['Int']['output'];
  totalRemainder: LoanCurrencyAmount;
};

/** Node representing a loan draw down request */
export type LoanDrawDown = Node & {
  __typename: 'LoanDrawDown';
  /** The requested amount for the draw down */
  amount: CurrencyAmount;
  /** The email address the bank will contact in regards to the request */
  applicantEmailAddress: Maybe<Scalars['String']['output']>;
  /** The status of the draw down application */
  applicationStatus: LoanDrawDownApplicationStatus;
  /** The cost calculation for the draw down request */
  costCalculation: LoanDrawDownCostCalculationResult;
  /** The digital signature group to sign for the draw down request */
  digitalSignatureGroup: Maybe<DigitalSignatureGroup>;
  /** The account where the amount will be deposited to (ráðstöfunarreikningur) */
  disbursementAccount: LoanDrawDownAccount;
  /** The due date for the draw down */
  dueDate: Scalars['Date']['output'];
  /** ID (Global) of the draw down request */
  id: Scalars['ID']['output'];
  /** The account where the outstanding amount will be debited to */
  installmentAccount: Maybe<LoanDrawDownAccount>;
  /** The requested date for the draw down */
  requestDate: Scalars['Date']['output'];
};

/** An account associated with a draw down loan */
export type LoanDrawDownAccount = {
  __typename: 'LoanDrawDownAccount';
  /** The account number (BBAN) that identifies the account */
  accountNumber: Scalars['String']['output'];
  /** The currency code of the account */
  currencyCode: Scalars['String']['output'];
};

/** The status of a draw down request */
export enum LoanDrawDownApplicationStatus {
  /** The draw down request has been approved (IS: Samþykkt) */
  APPROVED = 'APPROVED',
  /** The draw down request has been cancelled (IS: Hætt við) */
  CANCELLED = 'CANCELLED',
  /** The draw down request has been completed (IS: Lokið) */
  COMPLETED = 'COMPLETED',
  /** There was an error with the draw down request (IS: Villa) */
  ERROR = 'ERROR',
  /** The draw down request is pending (IS: Í vinnslu) */
  PENDING = 'PENDING',
  /** The draw down request has been rejected (IS: Hafnað) */
  REJECTED = 'REJECTED',
  /** The draw down request has been signed (IS: Undirritað) */
  SIGNED = 'SIGNED',
  /** Unknown status of draw down request (in API it is called "Any") */
  UNKNOWN = 'UNKNOWN',
  /** The draw down request has been withdrawn (IS: Afturkallað) */
  WITHDRAWN = 'WITHDRAWN'
}

/** Fee cost calculation for a draw down request */
export type LoanDrawDownCostCalculation = {
  __typename: 'LoanDrawDownCostCalculation';
  /** Burrowing cost */
  loanCostAmount: Maybe<Scalars['Float']['output']>;
  /** Cost ratio in percentage */
  loanCostRatio: Maybe<Scalars['Float']['output']>;
  /** Amount for disbursment */
  paidOutAmount: Maybe<Scalars['Float']['output']>;
};

export type LoanDrawDownCostCalculationInput = {
  /** Loan amount for draw down */
  loanAmount: Scalars['Float']['input'];
};

export type LoanDrawDownCostCalculationResult = LoanDrawDownCostCalculation | LoanDrawDownNoCost;

/** Date options for the user when applying for a draw down */
export type LoanDrawDownDateOption = {
  __typename: 'LoanDrawDownDateOption';
  maxDate: Scalars['Date']['output'];
  minDate: Scalars['Date']['output'];
};

/** Object indicating that there is no cost for the draw down request */
export type LoanDrawDownNoCost = {
  __typename: 'LoanDrawDownNoCost';
  variant: LoanDrawDownNoCostVariant;
};

/** Variants indicating no cost for draw down */
export enum LoanDrawDownNoCostVariant {
  /** The cost is according to the contract */
  ACCORDING_TO_CONTRACT = 'ACCORDING_TO_CONTRACT',
  /** There is no cost for the draw down */
  NO_COST = 'NO_COST'
}

/** Options for a user when applying for a draw down */
export type LoanDrawDownOptions = {
  __typename: 'LoanDrawDownOptions';
  /** The minimum and maximum dates for the due date of the draw down */
  dueDateOptions: LoanDrawDownDateOption;
  /** The minimum and maximum dates for the request date of the draw down */
  requestDateOptions: LoanDrawDownDateOption;
};

/** Reason why a user can not perform a draw down on a loan */
export enum LoanDrawDownStopperReason {
  /** The draw down request has expired. It is past it's due date. */
  EXPIRED = 'EXPIRED',
  /** There is already a draw down in progress. In review by an employee. */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The loan does not allow draw downs in self service. */
  NOT_ALLOWED_IN_SELFSERVICE = 'NOT_ALLOWED_IN_SELFSERVICE',
  /** The user is not authorized to perform draw down on this loan. */
  NOT_AUTHORIZED = 'NOT_AUTHORIZED',
  /** Other reason is preventing the user from performing a draw down. */
  OTHER = 'OTHER'
}

export type LoanEdge = {
  __typename: 'LoanEdge';
  cursor: Scalars['String']['output'];
  node: Loan;
};

export type LoanFee = {
  __typename: 'LoanFee';
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  feeId: Scalars['Int']['output'];
  isPercentage: Scalars['Boolean']['output'];
};

/** Details of a loan fee. */
export type LoanFeeDetails = {
  __typename: 'LoanFeeDetails';
  /**
   * Upper limit of the interval which provides the category a borrowing fee falls into.
   * E.g. The fee for taking a vehicle loan will have the same value for any number of months between [60 and 71].
   * If the number goes over 71, the fee's amount will be different (as it will fall under [72, 84]).
   * The same goes for any value under 60 (there are more 'interval' categories).
   * This field is the 71 from the [60, 71] interval.
   * This field will be null for any type of fee, except the borrowing fee.
   */
  maxMonthsOfTheBorrowingFeeInterval: Maybe<Scalars['Int']['output']>;
  /**
   * Lower limit of the interval which provides the category a borrowing fee falls into.
   * E.g. The fee for taking a vehicle loan will have the same value for any number of months between [60 and 71].
   * If the number goes over 71, the fee's amount will be different (as it will fall under [72, 84]).
   * The same goes for any value under 60 (there are more 'interval' categories).
   * This field is the 60 from the [60, 71] interval.
   * This field will be null for any type of fee, except the borrowing fee.
   */
  minMonthsOfTheBorrowingFeeInterval: Maybe<Scalars['Int']['output']>;
};

export type LoanFilterInput = {
  /** Kennitala of the loan owner (payor) */
  ownerKennitala?: InputMaybe<Scalars['String']['input']>;
  /** The statuses of loans to include in the results. */
  status?: InputMaybe<Array<LoanSearchStatus>>;
  /** The types of loans to include in the results. */
  type?: InputMaybe<Array<LoanSearchType>>;
};

/** Index type for the loan (vísitala). Enum value description come from API documentation */
export enum LoanIndexType {
  /** Byggingarvísitala */
  BYVT = 'BYVT',
  /** Byggingarvísitala 1955 */
  BYVT55 = 'BYVT55',
  /** Byggingarvísitala 1975 */
  BYVT75 = 'BYVT75',
  /** Opnibert gengi ECU */
  ECU = 'ECU',
  /** Launavísitala */
  LAUNVT = 'LAUNVT',
  /** Lánskjaravísitala fjárskuldb. */
  LKVTE = 'LKVTE',
  /** Launavísitala 89+2 */
  LVT892 = 'LVT892',
  /** Óþekkt tegund */
  UNKNOWN = 'UNKNOWN',
  /** Opnibert gengi USD */
  USD = 'USD',
  /** Vísitala neysluverðs */
  VTNV = 'VTNV'
}

/** A leg of a loan with specific details */
export type LoanLeg = {
  __typename: 'LoanLeg';
  /** The account for debit associated with the loan */
  accountForDebit: Maybe<Scalars['String']['output']>;
  /** Account number of the loan. This is a combination of branch, ledger and account number, ex: 010636000366   */
  accountNumber: Scalars['String']['output'];
  /** The type name of the loan, ex "Lánssamningur" */
  accountTypeName: Maybe<Scalars['String']['output']>;
  /** The adjusted amount of the loan. Icelandic: Fjárhæð jöfnunarreiknings */
  adjustedAmount: Maybe<LoanCurrencyAmount>;
  /** The currency codes associated with the loan */
  baseCurrencyCode: Array<Scalars['String']['output']>;
  /** The base index of the loan. Icelandic: Grunnvísitala láns */
  baseIndex: Maybe<Scalars['Float']['output']>;
  /** The names of any co-debtors associated with the loan */
  coDebtorNames: Maybe<Array<Scalars['String']['output']>>;
  /** The credit limit for a drawdown loan (is: Heimild skuldbindingar, getur verið yfrdráttarheimild, kreditkortaheimild eða ádráttarheimild) */
  creditLimit: LoanCurrencyAmount;
  /** The name of the customer associated with the loan */
  customerName: Scalars['String']['output'];
  /** The social security number of the customer associated with the loan */
  customerSsn: Scalars['String']['output'];
  /** The default fee of the loan. This value belongs to the payback section of the loan. Icelandic: Kostnaður vegna vanskila */
  defaultFee: LoanCurrencyAmount;
  /** Total defaults of the loan. Icelandic: vanskil */
  defaultedAmount: LoanCurrencyAmount;
  /** The disbursement account number associated with this loan leg. Icelandic: "Ráðstöfunarreikningur" */
  disbursementAccountNumber: Maybe<Scalars['String']['output']>;
  /** The display name of the loan */
  displayName: Scalars['String']['output'];
  /** The excess payment fee of the loan. This value belongs to the payback section of the loan. Icelandic: Umframgreiðslugjald */
  excessPaymentFee: LoanCurrencyAmount;
  /** The final due date of the loan */
  finalDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The first due date of the loan */
  firstDueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The start date of the fixed interest period */
  fixedInterestPeriodDateFrom: Maybe<Scalars['DateTimeISO']['output']>;
  /** The end date of the fixed interest period */
  fixedInterestPeriodDateTo: Maybe<Scalars['DateTimeISO']['output']>;
  /** The global ID of the loan leg: "LoanLeg:<accountNumber>" */
  id: Scalars['ID']['output'];
  /** The account ID associated with the loan */
  idAccount: Scalars['String']['output'];
  /** The index type of the loan. Icelandic: Vísitala (ex. Vísitala neysluverðs, byggingarvísitala, etc.) */
  indexType: LoanIndexType;
  /** Indexation amount of the loan. This value belongs to the payback section of the loan. Icelandic: verðbætur */
  indexation: LoanCurrencyAmount;
  /** Indicates whether the loan is indexed or not. Icelandic (if true): Verðtryggt */
  indexed: Scalars['Boolean']['output'];
  /** The initial amount of the loan */
  initialAmount: LoanCurrencyAmount;
  /** The installment account number associated with this loan leg. Icelandic: "Afborgun" */
  installmentAccountNumber: Maybe<Scalars['String']['output']>;
  /** The installment fee of the loan. This value belongs to the payback section of the loan. Icelandic: Tilkynningar- og greiðslugjald */
  installmentFee: LoanCurrencyAmount;
  /** The interest amount of the loan */
  interest: LoanCurrencyAmount;
  /** Interest category for the loan or leg */
  interestCategory: Scalars['String']['output'];
  /** Interest premium for the loan or leg */
  interestPremium: Scalars['Float']['output'];
  /** The interest rate of the loan */
  interestRate: Scalars['Float']['output'];
  /** Determines if this leg is currently active, has an active debt. If false, the leg is paid up. */
  isActive: Scalars['Boolean']['output'];
  /** Indicates whether the loan is an annuity loan or not. Icelandic true: Jafnar greiðslur, false: Jafnar afborganir */
  isAnnuitet: Scalars['Boolean']['output'];
  /** Indicates whether extra payments are allowed for the loan. Icelandic: Má greiða inn á lánið? */
  isExtraPaymentAllowed: Scalars['Boolean']['output'];
  /** The issue date of the loan */
  issueDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The last payment date of the loan */
  lastPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The sequence number of the leg */
  legNumber: Scalars['Int']['output'];
  /** The global ID of the loan leg as a global loan ID: "Loan:<accountNumber>" */
  loanId: Scalars['ID']['output'];
  /** The status of the loan */
  loanStatus: LoanStatus;
  /** The kennitala of the main debtor */
  mainDebtorKennitala: Scalars['String']['output'];
  /** The full name of the main debtor */
  mainDebtorName: Scalars['String']['output'];
  /** The number of months between payments */
  monthsBetweenPayments: Scalars['Int']['output'];
  /** The next payment amount for this loan leg */
  nextPayment: Maybe<LoanCurrencyAmount>;
  /** The next payment amount of the loan */
  nextPaymentAmount: Maybe<LoanCurrencyAmount>;
  /** The next payment date of the loan */
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The total number of payments of the loan */
  numberOfPayments: Scalars['Int']['output'];
  /** The last defaulted date for the loan (is: Síðasti ógreiddi gjalddagi) */
  oldestDefaultedDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when the loan was fully paid up */
  paidUpDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The date when payback calculation was last updated on the loan */
  paybackCalculationDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The payback value of the loan. Icelandic: Uppgreiðsluverðmæti */
  paybackValue: LoanCurrencyAmount;
  /** The payment per month for the loan */
  paymentPerMonth: LoanCurrencyAmount;
  /** The principal amount of the loan without all defaults and costs. This value belongs to the payback section of the loan. Icelandic: Eftirstöðvar höfuðstóls */
  principal: LoanCurrencyAmount;
  /** The total number of remaining payments of the loan */
  remainingPayments: Scalars['Int']['output'];
  /** The total remainder of the loan, including all defaults and costs. */
  totalRemainder: LoanCurrencyAmount;
};

export type LoanNotFoundError = Error & {
  __typename: 'LoanNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanOptionInput = {
  allFeesExceptPaymentFee?: InputMaybe<Scalars['Float']['input']>;
  amount: Scalars['Float']['input'];
  disbursementDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstPaymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  indexType: LookUpTypeInput;
  interestRate: Scalars['Float']['input'];
  loanDurationMonths: Scalars['Int']['input'];
  oneYearIndexProjection?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** If omitted then will be fetched from product catalog */
  paymentFeePerPayment?: InputMaybe<Scalars['Float']['input']>;
  paymentType: LookUpTypeInput;
};

/** Ordering options for loans */
export type LoanOrderBy = {
  /** Direction to order loans by: ascending or descending */
  direction: OrderByDirection;
  /** Field to order loans by */
  field: LoanOrderByOption;
};

/** Options for ordering loans */
export enum LoanOrderByOption {
  /** Order by credit limit */
  CREDIT_LIMIT = 'CREDIT_LIMIT',
  /** Order by currency code */
  CURRENCY_CODE = 'CURRENCY_CODE',
  /** Order by initial amount */
  INITIAL_AMOUNT = 'INITIAL_AMOUNT',
  /** Order by issue date */
  ISSUE_DATE = 'ISSUE_DATE',
  /** Order by loan number (account number) */
  LOAN_NUMBER = 'LOAN_NUMBER',
  /** Order by paid-up date */
  PAID_UP_DATE = 'PAID_UP_DATE',
  /** Order by total remainder */
  TOTAL_REMAINDER = 'TOTAL_REMAINDER'
}

/** Loan details */
export type LoanPackageLoan = {
  __typename: 'LoanPackageLoan';
  /** The amount of the loan */
  amount: Scalars['Int']['output'];
  /** Interest type of the loan VariableInterests or FixedInterests */
  indexType: IndexType;
  /** Interest id */
  interestId: Scalars['Int']['output'];
  /** Interest rate for the loan */
  interestRate: Scalars['Float']['output'];
  /** Is this a base loan(Grunnlán) */
  isBaseProduct: Scalars['Boolean']['output'];
  /** The duration of the loan in months */
  loanDurationMonths: Scalars['Int']['output'];
  /** How many payments are paid per month */
  paymentPerMonth: Scalars['Float']['output'];
  /** Payment type of the loan */
  paymentType: LoanProductPaymentTypeItem;
  /** Product catalog id */
  productCatalogId: Scalars['Int']['output'];
  /** The product name */
  productName: Scalars['String']['output'];
  /** The total payment of the loan */
  totalPayment: Scalars['Float']['output'];
  /** Yearly cost ratio */
  yearlyCostRatio: Scalars['Float']['output'];
};

/** Loan deposit. Single- and scheduled deposit */
export type LoanPayment = Node & {
  __typename: 'LoanPayment';
  categoryCode: Scalars['String']['output'];
  categoryDescription: Scalars['String']['output'];
  debtorAccount: Account;
  debtorAccountNumber: Scalars['String']['output'];
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  isFuturePayment: Scalars['Boolean']['output'];
  loan: Loan;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  shortReference: Maybe<Scalars['String']['output']>;
  status: Maybe<PaymentStatus>;
  transactionBank: Maybe<Scalars['String']['output']>;
};

export type LoanPaymentAmountUnavailable = Error & {
  __typename: 'LoanPaymentAmountUnavailable';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanPaymentDepositFailedDepositAmountHigherThenLoanCapital = Error & {
  __typename: 'LoanPaymentDepositFailedDepositAmountHigherThenLoanCapital';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type LoanPaymentFees = {
  __typename: 'LoanPaymentFees';
  loanPaymentDirectDebitFee: Fee;
  loanPaymentManualDebitFee: Fee;
};

export enum LoanPaymentFrequency {
  Annual = 'Annual',
  Daily = 'Daily',
  EveryFourMonths = 'EveryFourMonths',
  EveryTwoMonths = 'EveryTwoMonths',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnual = 'SemiAnnual',
  SeveralTimesPerDay = 'SeveralTimesPerDay',
  ThreeTimesPerMonth = 'ThreeTimesPerMonth',
  TwoTimesPerMonth = 'TwoTimesPerMonth',
  Weekly = 'Weekly'
}

export type LoanPaymentInput = {
  amount: Scalars['Float']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  debtorReference?: InputMaybe<Scalars['String']['input']>;
  /** Explanation (Skýring á færsluyfirlit) */
  explanation?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<LoanPaymentFrequency>;
  indexation?: InputMaybe<Scalars['Boolean']['input']>;
  legNumber?: InputMaybe<Scalars['Int']['input']>;
  loanId: Scalars['String']['input'];
  loanKennitala: Scalars['String']['input'];
  /** Not to be used if startDate and frequency are supplied in input */
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Not to be used if paymentDate is supplied in input */
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  totalNumberOfPayments?: InputMaybe<Scalars['Int']['input']>;
  /** Withdrawal account number */
  withdrawalAccount: Scalars['String']['input'];
  /** Kennitala of the withdrawal account owner */
  withdrawalAccountKennitala?: InputMaybe<Scalars['String']['input']>;
};

export type LoanPaymentPayload = {
  __typename: 'LoanPaymentPayload';
  loanPayment: Maybe<LoanPayment>;
  loanPeriodicPayment: Maybe<LoanPeriodicPayment>;
};

export type LoanPaymentResultUnion = LoanPaymentAmountUnavailable | LoanPaymentDepositFailedDepositAmountHigherThenLoanCapital | LoanPaymentPayload;

/** Loan periodic deposit. */
export type LoanPeriodicPayment = Node & {
  __typename: 'LoanPeriodicPayment';
  /** @deprecated This field was never returned by the API. It will be removed. Since: 2026-09-23. Issue to remove it: WEB-46117 */
  categoryCode: Scalars['String']['output'];
  categoryDescription: Maybe<Scalars['String']['output']>;
  creditorAccount: Maybe<CreditorAccountType>;
  debtorAccount: Maybe<Account>;
  deposits: Maybe<LoanPeriodicPaymentDepositConnection>;
  description: Maybe<Scalars['String']['output']>;
  frequency: Maybe<PaymentFrequency>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  loan: Maybe<Loan>;
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  nextPaymentSequenceNumber: Maybe<Scalars['Float']['output']>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  paymentStatus: Maybe<PaymentStatus>;
  reference: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['String']['output'];
  statusDescription: Scalars['String']['output'];
  transactionBank: Maybe<Scalars['String']['output']>;
  validity: Maybe<PeriodicPaymentValidityType>;
};


/** Loan periodic deposit. */
export type LoanPeriodicPaymentDepositsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type LoanPeriodicPaymentConnection = {
  __typename: 'LoanPeriodicPaymentConnection';
  edges: Array<LoanPeriodicPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Loan payment deposit. The actual deposits that have or will be paid onto loan */
export type LoanPeriodicPaymentDeposit = Node & {
  __typename: 'LoanPeriodicPaymentDeposit';
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  errorStatusDescription: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  loanId: Scalars['String']['output'];
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  scheduledPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  scheduledPaymentSequenceNumber: Maybe<Scalars['Float']['output']>;
  statusCode: Maybe<Scalars['String']['output']>;
  statusDescription: Maybe<Scalars['String']['output']>;
};

export type LoanPeriodicPaymentDepositConnection = {
  __typename: 'LoanPeriodicPaymentDepositConnection';
  edges: Array<LoanPeriodicPaymentDepositEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LoanPeriodicPaymentDepositEdge = {
  __typename: 'LoanPeriodicPaymentDepositEdge';
  cursor: Scalars['String']['output'];
  node: LoanPeriodicPaymentDeposit;
};

export type LoanPeriodicPaymentEdge = {
  __typename: 'LoanPeriodicPaymentEdge';
  cursor: Scalars['String']['output'];
  node: LoanPeriodicPayment;
};

export type LoanProduct = Node & Product & {
  __typename: 'LoanProduct';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indexType: Maybe<IndexType>;
  interestOptions: Array<InterestOption>;
  isPrimaryProduct: Scalars['Boolean']['output'];
  loanFees: Array<LoanFee>;
  loanPaymentTypes: Maybe<Array<LoanProductPaymentType>>;
  /** Upper limit of the valid amount interval, for a specific loan product. For example, for car loans (individual users, id 201) -> the interval is [500.000 (ISK), 10.000.000 (ISK)]. The maxAmountWarning in this case is 10.000.000 (ISK). Note: We cannot reuse the maxAmount in this scope because that is used within Elisa, and has a different value compared to the one that we need. */
  maxAmountWarning: Maybe<Scalars['Float']['output']>;
  maxInterestRateLast20Years: Maybe<Scalars['Float']['output']>;
  maxMortgageRate: Maybe<Scalars['Float']['output']>;
  maxNumberOfPayments: Maybe<Scalars['Int']['output']>;
  minAmount: Maybe<Scalars['Float']['output']>;
  /** Lower limit of the valid amount interval, for a specific loan product. For example, for car loans (individual users, id 201) -> the interval is [500.000 (ISK), 10.000.000 (ISK)]. The minAmountWarning in this case is 500.000 (ISK). Note: We cannot reuse the minAmount in this scope because that is used within Elisa, and has a different value compared to the one that we need. */
  minAmountWarning: Maybe<Scalars['Float']['output']>;
  minNumberOfPayments: Maybe<Scalars['Int']['output']>;
  name: Maybe<Scalars['String']['output']>;
  oneYearIndexProjection: Maybe<Scalars['Float']['output']>;
  productCategoryId: Scalars['Int']['output'];
  tenYearIndexProjection: Maybe<Scalars['Float']['output']>;
  type: ProductType;
};


export type LoanProductInterestOptionsArgs = {
  mortgageRatio?: InputMaybe<Scalars['Int']['input']>;
  mortgageRatioExact?: InputMaybe<Scalars['Float']['input']>;
};

/** The IDs of loan products, as taken directly from the product catalog API */
export enum LoanProductCatalogType {
  /** Aukalán */
  AUKALAN = 'AUKALAN',
  /** Bílasamningur */
  CAR_CONTRACT = 'CAR_CONTRACT',
  /** Bílalán fyrirtækja */
  CAR_CONTRACT_CORPORATE = 'CAR_CONTRACT_CORPORATE',
  /** Bílalán */
  CAR_LOAN = 'CAR_LOAN',
  /** Bílasamningur fyrirtækja */
  CAR_LOAN_CORPORATE = 'CAR_LOAN_CORPORATE',
  /** Tryggingabréf */
  COLLATERAL_LETTER = 'COLLATERAL_LETTER',
  /** Yfirdráttur fyrirtækja */
  CORPORATE_OVERDRAFT = 'CORPORATE_OVERDRAFT',
  /** Kreditkort (breyta heimild) */
  CREDIT_CARD = 'CREDIT_CARD',
  /** Veðskuldabréf - Skuldabréf með veði (annað en fasteign) */
  MORTGAGE_BOND = 'MORTGAGE_BOND',
  /** Veðlaus skuldabréf */
  MORTGAGE_FREE_BOND = 'MORTGAGE_FREE_BOND',
  /** Yfirdráttur */
  OVERDRAFT = 'OVERDRAFT',
  /** Grunnlán */
  REAL_ESTATE_BASE_LOAN = 'REAL_ESTATE_BASE_LOAN',
  /** Fasteignalán/Íbúðarhúsnæði (Gjaldeyristenging) */
  REAL_ESTATE_CURRENCY_LOAN = 'REAL_ESTATE_CURRENCY_LOAN',
  /** Viðbótarlán */
  REAL_ESTATE_EXTRA_LOAN = 'REAL_ESTATE_EXTRA_LOAN',
  /** Fasteignalán/Íbúðarhúsnæði */
  REAL_ESTATE_LOAN = 'REAL_ESTATE_LOAN',
  /** Sjálfskuldarábyrgð */
  SURETY = 'SURETY',
  UNKNOWN = 'UNKNOWN'
}

export enum LoanProductPaymentType {
  Annuitet = 'Annuitet',
  EqualInstallments = 'EqualInstallments'
}

/** Loan product payment type, consist of id and payment type either EqualInstallments or Annuitet */
export type LoanProductPaymentTypeItem = {
  __typename: 'LoanProductPaymentTypeItem';
  /** ID of payment type */
  id: Scalars['ID']['output'];
  /** Payment type of the loan EqualInstallments or Annuitet */
  type: LoanProductPaymentType;
};

/** A loan request */
export type LoanRequest = {
  __typename: 'LoanRequest';
  bond: Maybe<LoanApplicationBond>;
  creditCard: Maybe<CreditCardLimitLoanBond>;
  fees: Array<LoanApplicationFee>;
  id: Scalars['ID']['output'];
  loanReference: Maybe<Scalars['String']['output']>;
  loanRequestPaymentTypes: Array<LoanRequestPaymentType>;
  /** A bond object that has been transferred between loan requests */
  mortgageTransfer: Maybe<LoanApplicationBond>;
  overdraft: Maybe<OverdraftLoanBond>;
  productCatalogId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
};

/** A payment type for loan request */
export type LoanRequestPaymentType = {
  __typename: 'LoanRequestPaymentType';
  id: Scalars['ID']['output'];
  /** loan application payment type, either variable or fixed */
  type: LoanProductPaymentType;
};

/** The status of a loan used for filtering. */
export enum LoanSearchStatus {
  /** Active loans */
  ACTIVE = 'ACTIVE',
  /** Inactive (paid-up) loans */
  INACTIVE = 'INACTIVE'
}

/** The type of a loan. */
export enum LoanSearchType {
  /** A draw down loan (IS: Viðskiptasamningar) */
  DRAW_DOWN_LOAN = 'DRAW_DOWN_LOAN',
  /** A regular loan. Can either be short-term or long-term. */
  LOAN = 'LOAN'
}

/** Status of the loan. Enum value description come from API documentation */
export enum LoanStatus {
  /** Virkt */
  ACTIVE = 'ACTIVE',
  /** Í skilmálabreytingu (virkt) */
  CHANGEOFTERMS = 'CHANGEOFTERMS',
  /** Afhent */
  DELIVERED = 'DELIVERED',
  /** Niðurfellt (Bara RB) */
  DEPRECATED = 'DEPRECATED',
  /** Óvirkt (ekki skilgreint hvers vegna) */
  INACTIVE = 'INACTIVE',
  /** Flutt á milli lánakerfa */
  MIGRATED = 'MIGRATED',
  /** Uppgreitt */
  PAIDUP = 'PAIDUP',
  /** Óþekkt tegund */
  UNKNOWN = 'UNKNOWN',
  /** Afskrifað */
  WRITEOFF = 'WRITEOFF'
}

/** Financial transaction on loan */
export type LoanTransaction = Node & {
  __typename: 'LoanTransaction';
  actualPaymentDate: Scalars['DateTimeISO']['output'];
  chargesAmount: LoanCurrencyAmount;
  currencyCode: Scalars['String']['output'];
  expectedPaymentDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  indexationAmount: LoanCurrencyAmount;
  interestAmount: LoanCurrencyAmount;
  interestIndexationAmount: LoanCurrencyAmount;
  legNumber: Scalars['Int']['output'];
  paymentNumber: Scalars['Int']['output'];
  paymentType: Scalars['String']['output'];
  penaltyInterestAmount: LoanCurrencyAmount;
  principalAmount: LoanCurrencyAmount;
  remainingLoanAmountAmount: LoanCurrencyAmount;
  status: LoanTransactionStatus;
  totalAmount: LoanCurrencyAmount;
};

/** The query parameters that were applied to fetch the transactions in this connection. */
export type LoanTransactionAppliedQuery = {
  __typename: 'LoanTransactionAppliedQuery';
  period: CalendarPeriod;
};

export type LoanTransactionConnection = {
  __typename: 'LoanTransactionConnection';
  /** The query parameters that were applied to fetch the transactions in this connection. Returns an error if the API was called without a date range. This happens when no date range is provided and the default date range is skipped, such as when fetching unpaid or overdue payments, or when fetching from clients other than the app or l.is (as of 27.5.2026). */
  appliedQuery: LoanTransactionAppliedQuery;
  edges: Array<LoanTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LoanTransactionEdge = {
  __typename: 'LoanTransactionEdge';
  cursor: Scalars['String']['output'];
  node: LoanTransaction;
};

export enum LoanTransactionStatus {
  Overdue = 'Overdue',
  Paid = 'Paid',
  Unpaid = 'Unpaid'
}

export type LoanValidation = {
  __typename: 'LoanValidation';
  applicantId: Maybe<Scalars['String']['output']>;
  name: LoanApplicationValidationName;
  /** The level or severity of the validation. Can be "error", "warning", "info" or "unknown" */
  severity: LoanValidationSeverity;
};

/** The level or severity of the validation. Can be "error", "warning", "info" or "unknown" */
export enum LoanValidationSeverity {
  ERROR = 'ERROR',
  INFO = 'INFO',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING'
}

export type LoansCalculations = {
  __typename: 'LoansCalculations';
  /** First monthly payment of loan */
  firstMonthlyPayment: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  loans: Array<LoanCalculation>;
  /** Total amount paid for loan */
  totalAmount: Scalars['Float']['output'];
  /** Total fees paid over loan period */
  totalFeeAmount: Scalars['Float']['output'];
  totalFlows: Array<Flow>;
  /**
   * Total index amount for the loans (IS: Heildar Verðbætur).
   * PrincipalIndexAmount and InterestIndexAmount summed up for each payment
   */
  totalIndexAmount: Scalars['Float']['output'];
  /** Total interest paid */
  totalInterestAmount: Scalars['Float']['output'];
  /** Total payment fees paid over loan period, (greiðslugjöld) */
  totalPaymentFeeAmount: Scalars['Float']['output'];
  /** The principal of the loan */
  totalPrincipalAmount: Scalars['Float']['output'];
  /** Total yearly cost ratio */
  yearlyCostRatio: Scalars['Float']['output'];
};

/** Input for fetching loans excel summary with detailed filtering options */
export type LoansExcelSummaryInputV2 = {
  /** Kennitala that owns the loans for the excel summary. Uses actingKennitala from token if null */
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** The statuses of loans to include in the excel results. */
  status?: InputMaybe<Array<LoanSearchStatus>>;
  /** The types of loans to include in the excel results. */
  type?: InputMaybe<Array<LoanSearchType>>;
};

/** Loans widget */
export type LoansWidget = {
  __typename: 'LoansWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type LocationGroupedByCurrencyEntry = {
  __typename: 'LocationGroupedByCurrencyEntry';
  /** Settlement currency */
  currency: Scalars['String']['output'];
  /** Locations for the currency */
  locations: Array<AcquiringMerchantLocation>;
};

export type LoginAudit = {
  __typename: 'LoginAudit';
  /** App version used for login */
  appVersion: Maybe<Scalars['String']['output']>;
  /** Authentication method used during login */
  authenticationMethod: LoginAuditAuthenticationMethod;
  /** Client name used for login */
  clientName: Maybe<Scalars['String']['output']>;
  /** Indicates the type of client used for login */
  clientType: LoginAuditClientType;
  /** Type of login event */
  eventType: LoginAuditLoginEventType;
  id: Scalars['ID']['output'];
  /** Remote IP address of the login */
  remoteIpAddress: Maybe<Scalars['String']['output']>;
  /** Timestamp of the login event */
  timestamp: Maybe<Scalars['DateTimeISO']['output']>;
  /** User agent string from the login request */
  userAgent: Maybe<Scalars['String']['output']>;
  /** Username used for login */
  username: Maybe<Scalars['String']['output']>;
};

/** Indicates the method used for authentication during login */
export enum LoginAuditAuthenticationMethod {
  /** Login was performed using Audkenni */
  AUDKENNI = 'AUDKENNI',
  /** Login was performed using biometric authentication */
  BIOMETRIC = 'BIOMETRIC',
  /** Login was performed using electronic ID */
  ELECTRONIC_ID = 'ELECTRONIC_ID',
  /** Unknown authentication method */
  UNKNOWN = 'UNKNOWN',
  /** Login was performed using username and password */
  USERNAME_AND_PASSWORD = 'USERNAME_AND_PASSWORD'
}

/** Indicates the type of client used for login */
export enum LoginAuditClientType {
  L_IS = 'L_IS',
  /** Login was from a mobile device */
  MOBILE = 'MOBILE',
  /** Unknown client type */
  UNKNOWN = 'UNKNOWN',
  /** Login was from the web */
  WEB = 'WEB'
}

export type LoginAuditConnection = {
  __typename: 'LoginAuditConnection';
  edges: Array<LoginAuditEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LoginAuditEdge = {
  __typename: 'LoginAuditEdge';
  cursor: Scalars['String']['output'];
  node: LoginAudit;
};

/** The type of login audit event */
export enum LoginAuditLoginEventType {
  /** Token issuance failed */
  TOKEN_ISSUE_FAILURE = 'TOKEN_ISSUE_FAILURE',
  /** Token issuance was successful */
  TOKEN_ISSUE_SUCCESS = 'TOKEN_ISSUE_SUCCESS',
  /** Unknown login event type */
  UNKNOWN = 'UNKNOWN',
  /** User account is locked */
  USER_LOCKED = 'USER_LOCKED',
  /** User login failed */
  USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE',
  /** User login was successful */
  USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
}

export type LookUpType = {
  __typename: 'LookUpType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LookUpTypeInput = {
  /** (Model) Id is only needed when calculating real estate loans */
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type LookupCreditcardAvailableBalance = CreditCardBalance | CreditCardBalanceNotFound | CreditCardServiceUnavailable;

export type Loyalty = {
  __typename: 'Loyalty';
  points: Scalars['Int']['output'];
  system: LoyaltySystemType;
};

/** A detail page shown in the loyalty program info page */
export type LoyaltyProgramDetailPage = {
  __typename: 'LoyaltyProgramDetailPage';
  /** Page identifier */
  pageId: Scalars['String']['output'];
  /** Type of detail page */
  type: LoyaltyProgramPageType;
};

/** Loyalty program information including all levels and detail pages */
export type LoyaltyProgramInfo = {
  __typename: 'LoyaltyProgramInfo';
  /** All public loyalty program levels */
  levels: Array<LoyaltyProgramLevel>;
};

/** A loyalty program level with its minimum points requirement */
export type LoyaltyProgramLevel = {
  __typename: 'LoyaltyProgramLevel';
  /** The loyalty level */
  level: CustomerLoyaltyLevel;
  /** Minimum points required to reach this level */
  minPoints: Scalars['Int']['output'];
};

/** Detail page types for the loyalty program */
export enum LoyaltyProgramPageType {
  /** General intro page */
  INTRO = 'INTRO',
  /** Intro page for Private Banking loyalty level */
  INTRO_PRIVATE_BANKING = 'INTRO_PRIVATE_BANKING',
  /** Intro page for Vild+ loyalty level */
  INTRO_VILD_PLUS = 'INTRO_VILD_PLUS',
  /** Unknown page type, possible new type added that is not yet supported */
  UNKNOWN = 'UNKNOWN'
}

export enum LoyaltySystemType {
  Aukakronur = 'Aukakronur',
  None = 'None',
  Vildarpunktar = 'Vildarpunktar'
}

export type MailingListInputFields = {
  __typename: 'MailingListInputFields';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MailingLists = {
  __typename: 'MailingLists';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MandateAlreadyExists = Error & {
  __typename: 'MandateAlreadyExists';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MandateAlreadyExistsError = Error & {
  __typename: 'MandateAlreadyExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MandateNotFoundError = Error & {
  __typename: 'MandateNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MandatesCustomerNumberAlwaysTheSameError = Error & {
  __typename: 'MandatesCustomerNumberAlwaysTheSameError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** News for a particular stock */
export type MarketDataNews = {
  __typename: 'MarketDataNews';
  /** The attached files for the news article */
  attachments: Array<MarketDataNewsAttachment>;
  /** The body of the given news article, with additional html injected within. */
  bodyHtml: Scalars['String']['output'];
  /** The entity which published the article, such as Landsbankinn.is */
  distributor: Scalars['String']['output'];
  /** An external URL link to the given news article. */
  link: Scalars['URL']['output'];
  /** The date which the news article was published. */
  publishDate: Scalars['DateTimeISO']['output'];
  /** The symbol or tag of the stock */
  symbol: Scalars['String']['output'];
  /** Title of the news article */
  title: Scalars['String']['output'];
};

/** The fields which exist within an attached file for a given news article */
export type MarketDataNewsAttachment = {
  __typename: 'MarketDataNewsAttachment';
  /** The MIME type of the file */
  mimeType: Maybe<Scalars['String']['output']>;
  /** The name of the attachment */
  name: Scalars['String']['output'];
  /** The URL for the file */
  url: Scalars['URL']['output'];
};

export type MarketDataNewsConnection = {
  __typename: 'MarketDataNewsConnection';
  edges: Array<MarketDataNewsEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MarketDataNewsEdge = {
  __typename: 'MarketDataNewsEdge';
  cursor: Scalars['String']['output'];
  node: MarketDataNews;
};

export enum MarketDataNewsLanguageFilter {
  EN = 'EN',
  IS = 'IS'
}

/** Market fee */
export type MarketFee = {
  __typename: 'MarketFee';
  assistedMinimumAmount: Maybe<Scalars['Float']['output']>;
  discountPercentage: Maybe<Scalars['Float']['output']>;
  employeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  feePercentage: Maybe<Scalars['Float']['output']>;
  feeWithDiscountPercentage: Maybe<Scalars['Float']['output']>;
  feeWithEmployeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  minimumAmount: Maybe<Scalars['Float']['output']>;
};

/** Market Indicators */
export type MarketIndicators = {
  __typename: 'MarketIndicators';
  /** Default Indice (OMX Iceland) */
  defaultIndice: Indice;
  /** Default Exchange rate (ISK - GVT) | gengisvísitala */
  exchangeRateIndex: ExchangeRate;
  /** Default Inflation (indexation) */
  inflation: Indexation;
  /** Default Interest Rate of the Central Bank */
  policyRate: CentralBankRate;
};

export type MarketInstrumentFilterType = {
  __typename: 'MarketInstrumentFilterType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum MarketInstrumentOrderAction {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum MarketInstrumentOrderType {
  Amount = 'Amount',
  Limit = 'Limit',
  Market = 'Market'
}

/** Type of notification for markets */
export enum MarketNotificationSettingType {
  ORDER_EVENTS = 'ORDER_EVENTS',
  UNKNOWN = 'UNKNOWN'
}

/** Represents the opening and closing hours of a market */
export type MarketOpeningHours = {
  __typename: 'MarketOpeningHours';
  /** The exact time the market closes in format hh:mm */
  closeTime: Scalars['String']['output'];
  /** The exact time the market opens in format hh:mm */
  openTime: Scalars['String']['output'];
};

export type MarketOrder = Node & {
  __typename: 'MarketOrder';
  account: Account;
  accountNumber: Maybe<Scalars['String']['output']>;
  action: MarketInstrumentOrderAction;
  amount: Maybe<Scalars['Float']['output']>;
  cancellable: Scalars['Boolean']['output'];
  creationDate: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['DateTimeISO']['output']>;
  filled: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  instrument: Instrument;
  portfolio: Portfolio;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  /** Number of decimal places for quantity */
  quantityDecimalPlaces: Scalars['Int']['output'];
  remaining: Scalars['Float']['output'];
  status: MarketOrderStatus;
  type: MarketInstrumentOrderType;
};

export type MarketOrderAccountNotAllowed = Error & {
  __typename: 'MarketOrderAccountNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MarketOrderMarketClosed = Error & {
  __typename: 'MarketOrderMarketClosed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum MarketOrderStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Expired = 'Expired',
  Open = 'Open',
  Rejected = 'Rejected'
}

/** Is the market closed, open or wasOpen */
export enum MarketStatus {
  Closed = 'Closed',
  Open = 'Open',
  WasOpen = 'WasOpen'
}

export type MarketSubscription = Node & {
  __typename: 'MarketSubscription';
  amount: Maybe<Scalars['Float']['output']>;
  canEditSubscription: Scalars['Boolean']['output'];
  currency: Maybe<Scalars['String']['output']>;
  fund: Fund;
  id: Scalars['ID']['output'];
  paymentMethod: MarketSubscriptionPaymentMethod;
  portfolio: Maybe<Portfolio>;
};

export type MarketSubscriptionConnection = {
  __typename: 'MarketSubscriptionConnection';
  edges: Array<MarketSubscriptionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  /** Api does not provide this property, so this just the sum for all the nodes. */
  totalSubscriptionAmount: Scalars['Float']['output'];
};

export type MarketSubscriptionCreditCardPaymentMethod = {
  __typename: 'MarketSubscriptionCreditCardPaymentMethod';
  creditCardNumber: Scalars['String']['output'];
};

export type MarketSubscriptionEdge = {
  __typename: 'MarketSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node: MarketSubscription;
};

export type MarketSubscriptionInstrumentNotAllowed = Error & {
  __typename: 'MarketSubscriptionInstrumentNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MarketSubscriptionNotAllowedForCustomer = Error & {
  __typename: 'MarketSubscriptionNotAllowedForCustomer';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MarketSubscriptionNotFound = Error & {
  __typename: 'MarketSubscriptionNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MarketSubscriptionPaymentMethod = Account | MarketSubscriptionCreditCardPaymentMethod | MarketSubscriptionUnknownAccountMethod;

export type MarketSubscriptionUnknownAccountMethod = {
  __typename: 'MarketSubscriptionUnknownAccountMethod';
  accountNumber: Maybe<Scalars['String']['output']>;
};

export type MarketTransaction = Node & {
  __typename: 'MarketTransaction';
  accountNumber: Maybe<Scalars['String']['output']>;
  action: MarketTransactionAction;
  /** @deprecated Unused (always null). Since: 2025-10-31. Issue to remove it: WEB-38189 */
  amount: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  currencyPrice: Maybe<Scalars['Float']['output']>;
  estimatedSettlementDate: Maybe<Scalars['DateTimeISO']['output']>;
  hasReceipt: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instrumentName: Maybe<Scalars['String']['output']>;
  orderAmount: Scalars['Float']['output'];
  paidDate: Maybe<Scalars['DateTimeISO']['output']>;
  portfolio: Maybe<Portfolio>;
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  /** Number of decimal places for quantity */
  quantityDecimalPlaces: Scalars['Int']['output'];
  /** @deprecated Reason: Use receiptV2 instead. Since: 2026-03-23. Issue to remove it: WEB-41667 */
  receipt: Maybe<DocumentBucket>;
  receiptV2: Maybe<GenericFile>;
  serviceFee: Maybe<Scalars['Float']['output']>;
  status: MarketTransactionStatus;
  taxAmount: Maybe<Scalars['Float']['output']>;
  totalFee: Scalars['Float']['output'];
  totalPayment: Scalars['Float']['output'];
  totalPaymentIsk: Maybe<Scalars['Float']['output']>;
  tradeDate: Maybe<Scalars['DateTimeISO']['output']>;
  transactionFee: Maybe<Scalars['Float']['output']>;
  transactionFeeDiscountPercentage: Maybe<Scalars['Float']['output']>;
  transactionFeePercentage: Maybe<Scalars['Float']['output']>;
  transactionFeeWithDiscountPercentage: Maybe<Scalars['Float']['output']>;
  type: MarketTransactionType;
  updated: Maybe<Scalars['DateTimeISO']['output']>;
};

export enum MarketTransactionAction {
  Buy = 'Buy',
  CustodyFee = 'CustodyFee',
  Delivery = 'Delivery',
  Dividend = 'Dividend',
  Installment = 'Installment',
  Interest = 'Interest',
  PortfolioTransfer = 'PortfolioTransfer',
  Reception = 'Reception',
  Redemption = 'Redemption',
  Sell = 'Sell',
  StockSplit = 'StockSplit'
}

export type MarketTransactionConnection = {
  __typename: 'MarketTransactionConnection';
  actions: Array<MarketTransactionAction>;
  /** The query parameters that were applied to fetch the transactions in this connection */
  appliedQuery: MarketTransactionsAppliedQuery;
  edges: Array<MarketTransactionUnionEdge>;
  instruments: Array<MarketInstrumentFilterType>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export enum MarketTransactionStatus {
  Completed = 'Completed',
  ConfirmedPrice = 'ConfirmedPrice',
  New = 'New',
  Settlement = 'Settlement',
  UnconfirmedPrice = 'UnconfirmedPrice'
}

export enum MarketTransactionType {
  Bond = 'Bond',
  Deposit = 'Deposit',
  Fund = 'Fund',
  Stock = 'Stock'
}

export type MarketTransactionUnion = MarketOrder | MarketTransaction;

export type MarketTransactionUnionEdge = {
  __typename: 'MarketTransactionUnionEdge';
  cursor: Scalars['String']['output'];
  node: MarketTransactionUnion;
};

/** The query parameters that were applied to fetch the market transactions in this connection */
export type MarketTransactionsAppliedQuery = {
  __typename: 'MarketTransactionsAppliedQuery';
  period: CalendarPeriod;
};

/** Push notification settings for markets */
export type MarketsPushNotificationSetting = {
  __typename: 'MarketsPushNotificationSetting';
  /** ID of the notification setting */
  id: Scalars['ID']['output'];
  /** Flag indicating whether the notification setting is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** Type of notification setting */
  type: MarketNotificationSettingType;
};

export type MassAdjustInvoicesForSecondaryCollectionInput = {
  /** ID of the collection company which will handle the collection */
  collectionCompanyId: Scalars['ID']['input'];
  /** IDs of the invoices to be adjusted for secondary collection */
  ids: Array<Scalars['ID']['input']>;
};

export type MassAdjustInvoicesForSecondaryCollectionPayload = {
  __typename: 'MassAdjustInvoicesForSecondaryCollectionPayload';
  errors: Array<MassInvoiceActionError>;
};

export type MassCancelInvoicesInput = {
  /** IDs of the invoices to be cancelled */
  ids: Array<Scalars['ID']['input']>;
};

export type MassCancelInvoicesPayload = {
  __typename: 'MassCancelInvoicesPayload';
  errors: Array<MassInvoiceActionError>;
};

/** Error for a single invoice which failed during a mass action (of multiple invoices) */
export type MassInvoiceActionError = Error & {
  __typename: 'MassInvoiceActionError';
  /** Error subject */
  error: Scalars['String']['output'];
  /** Id of the invoice that failed */
  invoiceId: Maybe<Scalars['ID']['output']>;
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  /** What failed */
  message: Scalars['String']['output'];
};

export type MaximumMarketSubscriptionAmountError = Error & {
  __typename: 'MaximumMarketSubscriptionAmountError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MinimumMarketSubscriptionAmountError = Error & {
  __typename: 'MinimumMarketSubscriptionAmountError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MinimumTradingOrderAmount = Error & {
  __typename: 'MinimumTradingOrderAmount';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type MissingValueInExcelDocumentError = Error & {
  __typename: 'MissingValueInExcelDocumentError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Values for the monthly distribution */
export type MonthlyDistribution = {
  __typename: 'MonthlyDistribution';
  /** Date of the current distribution to be paid */
  date: Scalars['Date']['output'];
  payors: Array<ExpenseDistributionPayer>;
  /** Total amount of the distribution */
  totalAmount: CurrencyAmount;
};

/** Multiple faces were detected in the uploaded image */
export type MultipleFacesDetectedError = Error & {
  __typename: 'MultipleFacesDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  acceptSavingGoalShare: AcceptSavingsShareResponse;
  addCardTransactionAttachment: AddCardTransactionAttachmentPayload;
  /** Add collateral (trygging) to a loan application, e.g. adding a collateral to a corporate overdraft loan application */
  addCollateralToLoanApplication: AddCollateralToLoanApplicationPayload;
  /** To add a new response. Result will include responses from the chatbot if the chat state is "bot". */
  addConversationResponse: AddConversationResponsePayload;
  /** Add existing collaterals (núverandi tryggingar) to a loan application, e.g. adding existing collaterals to a corporate overdraft loan application */
  addExistingCollateralsToLoanApplication: AddExistingCollateralsToLoanApplicationPayload;
  addGiftCard: GiftCardLookupResponse;
  addMultipleCardTransactionAttachments: AddMultipleCardTransactionAttachmentsPayload;
  addPaymentApproval: AddPaymentApprovalResponse;
  /**
   * Will attempt to resolve a security question stepup presented to the user.
   *      This will only throw an error if this is the last available attempt and it fails or if there is an unexpected error on the server
   */
  answerStepUpSequrityQuestionV2: AnswerStepUpSequrityQuestionPayload;
  /** Create a CRM case to apply for distribution */
  applyForExpenseDistribution: ApplyForExpenseDistributionPayload;
  approveTermsAndConditionsContract: TermsAndConditions;
  /** Approve a contract, without needing a document. This uses the V4 API. */
  approveTermsAndConditionsContractWithoutDocument: TermsAndConditions;
  /** Archives a company user so they no longer appear in the customer-facing user list */
  archiveCompanyUser: ArchiveCompanyUserPayload;
  /**
   * Mutation to initialize signature process for Auðkenni
   * @deprecated This mutation is deprecated, refer to the event approach. Use `startInitializeSignatureProcessForAudkenni` along with `initializeSignatureProcessForAudkenniResult` subscription. Since: 2026-09-02. Issue to remove it: WEB-45498
   */
  asyncInitializeSignatureProcessForAudkenni: AsyncInitializeSignatureProcessForAudkenniResult;
  /**
   * Mutation that signs the next possible signature document in a document group. If no document is signed, then it signs the first one. If the first one is signed it signs the second one and so forth. If all documents are signed, it will return an error
   * @deprecated This mutation is deprecated, refer to the event approach. Use `startSignNextDigitalSignatureDocument` along with `signNextDigitalSignatureDocumentResult` subscription. Since: 2026-09-02. Issue to remove it: WEB-45498
   */
  asyncSignNextDigitalSignatureDocumentById: AsyncNextDigitalSignatureDocumentByIdResult;
  bookAppointment: BookAppointmentUnioin;
  cancelAppointment: CancelAppointmentPayload;
  cancelCardSavingSubscription: CancelCardSavingSubscriptionResponse;
  cancelDirectDebitMandate: CancelDirectDebitMandateResult;
  cancelInvoiceScheduleV2: CancelInvoiceSchedulePayloadV2;
  cancelInvoiceV2: CancelInvoicePayloadV2;
  /** Cancel a draw down request */
  cancelLoanDrawDownRequest: LoanDrawDown;
  cancelLoanPeriodicPayment: CancelLoanPeriodicPaymentResponse;
  cancelMarketOrder: CancelMarketOrderResult;
  cancelMarketSubscription: CancelMarketSubscriptionResult;
  cancelNotice: Scalars['String']['output'];
  /** Mutation used to try cancelling payment. */
  cancelPayment: CancelPaymentResponse;
  cancelPaymentApproval: CancelPaymentApprovalResponse;
  cancelPaymentDistribution: CancelPaymentDistributionResponse;
  cancelPeriodicPayment: CancelPeriodicPaymentResponse;
  changeDirectMarketing: DirectMarketingPayload;
  changeEmployeeDetailsInPayroll: ChangeEmployeeDetailsInPayrollPayload;
  changePassword: ChangePasswordResult;
  changePasswordV2: ChangePasswordResultV2;
  changePayrollName: ChangePayrollNamePayload;
  closeCard: CardsClosurePayload;
  /** Mutation that closes a card specified by an Id in the input and then creates a new identical card. */
  closeCardAndCreateNew: CloseCardAndCreateNewPayload;
  /** Use this mutation when user need to verify email after startEmailVerification */
  completeEmailVerification: VerificationEmailResult;
  /** Use this mutation when user need to verify phone number after startPhoneNumberVerification */
  completePhoneVerification: VerificationPhoneNumberResult;
  confirmAdaptiveAuthenticationPhoneNumber: AdaptiveAuthenticationConfirmPhoneNumberResponse;
  /** Legal entity kyc */
  confirmLegalEntityKyc: KycPayload;
  confirmPaymentDistribution: ConfirmPaymentDistributionPayload;
  contactUs: CrmCaseResult;
  /** Correct a direct debit mandate order. Note that this creates a new direct debit agreement and only patches the visibility of the order behind the scenes. */
  correctDirectDebitMandateOrder: CorrectDirectDebitMandateOrderPayload;
  createAccountProduct: CreateAccountProductResponse;
  createAcquiringPreApplication: CreateAcquiringPreApplicationPayload;
  createAndApproveCreditCardLimitLoanApplication: CreateAndApproveCreditCardLimitLoanApplicationPayload;
  createAppleWalletOpaquePaymentCard: CreateAppleWalletOpcPayload;
  /** Create a new application account */
  createApplicationAccount: ApplicationAccountMutationPayload;
  /** Add a certificate to an application account */
  createApplicationAccountCertificate: CreateApplicationAccountCertificatePayload;
  /** Add a public certificate party to an application account */
  createApplicationAccountPublicCertificate: CreateApplicationAccountPublicCertificatePayload;
  createAukakronurTransfer: CreateAukakronurTransferPayload;
  createBondLoanApplication: CreateBondLoanApplicationPayload;
  /** Mutation that creates a new card application */
  createCardApplication: CreateCardApplicationPayload;
  /** Make a deposit to either a card.ID or a card number (Innborgun á kort) */
  createCardDeposit: CreateCardDepositResponse;
  /** Make a deposit to either a card.ID or a card number (Innborgun á kort) */
  createCardDepositV2: CreateCardDepositResultV2;
  createCardSavingSubscription: CreateCardSavingsResponse;
  createCardTransactionsLedgerKey: CreateCardTransactionsLedgerKeyPayload;
  createCardTransactionsLedgerKeyGroup: CreateCardTransactionsLedgerKeyGroupPayload;
  createCardTransactionsLedgerKeySubGroup: CreateCardTransactionsLedgerKeySubGroupPayload;
  createClaimSigningBasket: CreateClaimSigningBasketResponse;
  createCommission: CreateCommissionPayload;
  createCreditAssessment: CreateCreditAssessmentPayload;
  createCreditCardApplication: CreditApplicationResult;
  createCreditCardProductApplicationDocument: CreditCardApplicationDocumentResult;
  createCreditTransfer: CreateCreditTransferResponse;
  createCreditTransferV2: CreateCreditTransferResultV2;
  createCrossBorderCreditTransfer: CreateCrossBorderCreditTransferResponse;
  createCrossBorderCreditTransferV2: CreateCrossBorderCreditTransferResultV2;
  /** Create custodial agreement so user can trade stocks and funds  */
  createCustodialAgreement: CreateCustodialAgreementPayload;
  createDebitCardApplication: CreateDebitCardApplicationPayload;
  /**
   * This mutation must be called only once, before the final step of the buying process (in a vehicle loan application).
   * It returns valid values for the first call, and than it will return Forbidden for following calls.
   *
   */
  createDecisionForVehicleLoanApplication: VehicleLoanApplicationDecision;
  /** Create a direct debit agreement */
  createDirectDebitAgreement: CreateDirectDebitAgreementPayload;
  createDirectDebitInitiation: CreateDirectDebitMandateResponse;
  createDirectDebitMandateOrdersFromFile: CreateDirectDebitMandateOrdersFromFilePayload;
  createEmployeeInPayroll: CreateEmployeeInPayrollPayload;
  createEmployeesInPayrollFromExcel: CreateEmployeesInPayrollFromExcelPayload;
  /** Creates an external account consent for a specific payment service provider */
  createExternalAccountConsent: CreateExternalAccountConsentResponse;
  /** Create a external vehicle loan application */
  createExternalVehicleLoanApplication: CreateExternalVehicleLoanApplicationPayload;
  /** Create a form document from form values */
  createFormTemplateDocument: CreateFormTemplateDocumentPayload;
  /** Create a new general loan application */
  createGeneralLoanApplication: CreateGeneralLoanApplicationPayload;
  createGoogleWalletOpaguePaymentCard: CreateGoogleWalletOpcPayload;
  createIndexationNotice: CreateIndexationNoticePayload;
  /** Creates a sale opportunity for insurances in CRM. */
  createInsuranceOpportunity: CreateInsuranceOpportunityPayload;
  createInvoice: CreateInvoicePayload;
  createInvoiceBatchFromExcel: CreateInvoiceBatchFromExcelPayload;
  createInvoiceScheduleV2: CreateInvoiceSchedulePayloadV2;
  createInvoiceTemplate: CreateInvoiceTemplatePayload;
  createInvoiceV2: CreateInvoicePayloadV2;
  /** Individual kyc */
  createKyc: KycPayload;
  createLoanApplicationComment: LoanApplicationCommentPayload;
  createLoanApplicationPackages: Array<LoanApplicationPackagePayload>;
  createLoanApplicationPaymentInstruction: CreatePaymentInstructionPayload;
  /** Create a draw down request for a loan */
  createLoanDrawDownRequest: CreateLoanDrawDownRequestPayload;
  createLoanPayment: LoanPaymentResultUnion;
  createMandatoryPensionApplication: CreatePensionApplicationPayload;
  createMarketOrder: CreateMarketOrderResult;
  createMarketSubscription: CreateMarketSubscriptionResult;
  /** @deprecated Reason: Use `onboardCustomer` mutation instead. Since: [2024-05-30]. Removed: [2025-05-30]. Issue(s) to remove it: WEB-24213 */
  createOnboardingApplication: OnboardingApplicationPayload;
  /** @deprecated Use registerOnboardingCompanyApplication instead, which uses Onboarding v4. Since: 2026-09-15. Issue to remove it: WEB-45892 */
  createOnboardingCorporateApplication: CreateOnboardingCorporateApplicationPayload;
  createOnboardingCorporateApplicationDocument: Scalars['String']['output'];
  /** Creates a PDF document for terms and conditions. */
  createOnboardingTermsAndConditionsPdfDocument: OnboardingTermsAndConditionsPdfDocumentId;
  createOverdraftLoanApplication: CreateOverdraftLoanApplicationPayload;
  createOverdraftToBondLoanApplication: CreateOverdraftToBondLoanApplicationPayload;
  createPaidLeaveAccountsv2: PaidLeaveAccountResponse;
  createPaidLeaveAccountv2: PaidLeaveAccountResponse;
  /** Create a new payment batch from selected payments */
  createPaymentBatch: CreatePaymentBatchPayload;
  createPaymentDistribution: CreatePaymentDistributionPayload;
  /** Create a new recipient */
  createPaymentRecipient: CreatePaymentRecipientPayload;
  createPayroll: CreatePayrollPayload;
  createPensionApplication: CrmCaseResult;
  /** Creates a CRM correspondence for an abandoned pension savings flow. */
  createPensionCorrespondence: CreatePensionCorrespondencePayload;
  createPeriodicCreditTransfer: CreatePeriodicCreditTransferResponse;
  createPeriodicCreditTransferV2: CreatePeriodicCreditTransferResultV2;
  /** Creates and returns a new proxy access */
  createProxyAccess: ProxyAccess;
  createRealEstateLoanApplication: CreateRealEstateLoanApplicationPayload;
  createRealEstateLoanRequestOptions: CreateRealEstateLoanApplicationPayload;
  /** Create a recurring payment token. This token can be used for future recurring payments without requiring card details again. */
  createRecurringCardPayment: CreateRecurringCardPaymentPayload;
  createRegularSaving: CreateRegularSavingResponse;
  createSalaryPaymentBatch: CreatePaymentBatchPayload;
  createSavingGoal: SavingGoal;
  createSavingShare: CreateSavingShareResponse;
  createSepaCreditTransfer: CreateSepaCreditTransferResponse;
  createSepaCreditTransferV2: CreateSepaCreditTransferResultV2;
  /** Creates a simple commission provided by a customer to Landsbankinn. */
  createSimpleCommission: CreateSimpleCommissionPayload;
  createSupplementaryPensionApplication: CreatePensionApplicationPayload;
  createTermsAndConditionsDocument: TermsAndConditions;
  createThirdPartyPaymentCreditTransfer: CreateThirdPartyPaymentCreditTransferPayload;
  /** Create a new user for the current company */
  createUser: CreateUserPayload;
  deleteCardTransactionAttachment: DeleteCardTransactionAttachmentPayload;
  deleteCardTransactionsLedgerKey: DeleteCardTransactionsLedgerKeyPayload;
  deleteCardTransactionsLedgerKeyGroup: DeleteCardTransactionsLedgerKeyGroupPayload;
  deleteCardTransactionsLedgerKeySubGroup: DeleteCardTransactionsLedgerKeySubGroupPayload;
  /** To remove a conversation from a users list of conversations. */
  deleteConversation: DeleteConversationResponse;
  /** Delete a direct debit agreement */
  deleteDirectDebitAgreement: DeleteDirectDebitAgreementPayload;
  /** Delete multiple direct debit agreements */
  deleteDirectDebitAgreements: DeleteDirectDebitAgreementsPayload;
  /** Delete a direct debit mandate order. Note that this only patches the visibility of the order behind the scenes. */
  deleteDirectDebitMandateOrder: DeleteDirectDebitMandateOrderPayload;
  /** Delete multiple direct debit mandate orders at once. Note that this only patches the visibility of the orders behind the scenes. */
  deleteDirectDebitMandateOrders: DeleteDirectDebitMandateOrdersPayload;
  /** Deletes an external account consent, effectively revoking it */
  deleteExternalAccountConsent: DeleteExternalAccountConsentResponse;
  deleteKycStakeholder: Scalars['Boolean']['output'];
  /** Result of deleting an optional claim */
  deleteOptionalClaim: DeleteClaimResponse;
  /** Delete a known notification handle */
  deletePaymentNotificationsHandle: DeletePaymentNotificationsHandleResponse;
  /** Remove known Recipient */
  deletePaymentRecipient: Scalars['String']['output'];
  deletePhoneNumber: DeletePhoneNumberResult;
  deletePhoneNumberV2: DeletePhoneNumberResultV2;
  deleteStoredPayment: DeleteStoredPaymentResponse;
  deleteStoredPayments: DeleteStoredPaymentsPayload;
  /** Mutation to dismiss a notification banner away so it does not show again. */
  dismissNotificationBanner: DismissNotificationBannerPayload;
  editInvoiceSchedule: EditInvoiceSchedulePayload;
  emergencyClosure: EmergencyClosurePayload;
  endSavingGoal: SavingGoal;
  enrollCardToClickToPay: EnrollCardToClickToPayPayload;
  /** To give a conversation a feedback. */
  giveConversationFeedback: GiveFeedbackResponsePayload;
  /** To give a conversation a subject. It updates the subject field of the conversation. Returns the conversation if its found, otherwise it returns null. */
  giveConversationSubject: UpdateConversationSubjectPayload;
  /**
   * Mutation to initialize signature process for Auðkenni
   * @deprecated This mutation is deprecated, it does not maintain a persistent connection for mobile users. Use `startInitializeSignatureProcessForAudkenni` along with `initializeSignatureProcessForAudkenniResult` subscription. Since: 2026-09-02. Issue to remove it: WEB-45492
   */
  initializeSignatureProcessForAudkenni: InitializeSignatureProcessForAudkenniResult;
  initiatePaymentApprovalProcess: InitiatePaymentApprovalProcessResponse;
  initiateStoredPayments: CreateStoredPaymentSigningBasketResponse;
  /** @deprecated use bondCalculator instead */
  loanCalculator: LoansCalculations;
  /** Send a list of invoices for secondary collection to the provided company */
  massAdjustInvoicesForSecondaryCollection: MassAdjustInvoicesForSecondaryCollectionPayload;
  /** Cancel a list of invoices */
  massCancelInvoices: MassCancelInvoicesPayload;
  onboardCustomer: Maybe<OnboardingCustomerUsername>;
  /** Mutation to opt user out of campaign so he doesn't see this particular CustomerRecommendationBanner again but he can see other banners from other campaigns. */
  optOutOfCampaign: UpdateCampaignParticipationPayloadResponse;
  orderAukakronurCard: CrmCaseResult;
  orderGiftCard: CrmCaseResult;
  /** Mutation used to try paying immediately a scheduled payment. The arguments used here refer to the type of scheduled payment one is trying to complete. PayNow is used by payments that are scheduled to happen, but did not happen yet. Retry is for payments of which were scheduled in the future, and they failed on the due date (the payment becoming suspended). */
  payScheduledPayment: PayScheduledPaymentResponse;
  /** @deprecated Use postLoanApplicationDecision. It handles when loan application approval is not allowed. */
  postDecision: LoanApplicationDecisionPayload;
  /** Post a decision, such as "approved", to indicate that the application can be processed by the bank. If it should be automatically processed, then contracts is required. See contracts input description. */
  postLoanApplicationDecision: LoanApplicationDecisionUnion;
  /** Calculate the cards available amount, given a new limit estimate. */
  previewCreditCardLineChange: PreviewCreditCardLineChangePayload;
  /** Mutation that changes the security code for adaptive authentication. */
  registerAdaptiveAuthenticationSecurityCode: RegisterSecurityCodePayload;
  /** Registers a company onboarding application. Accepts role, email, and phone number for the contact person. */
  registerOnboardingCompanyApplication: RegisterOnboardingCompanyApplicationPayload;
  registerToEvent: EventRegistrationPayload;
  /** Mutation that reissues a card */
  reissueCard: ReissueCardPayload;
  rejectPaymentApproval: RejectPaymentApprovalResponse;
  rejectSavingGoalShare: RejectSavingsShareResponse;
  /** Remove an application account by updating its status to closed */
  removeApplicationAccount: ApplicationAccountMutationPayload;
  /** Remove a public certificate from an application account */
  removeApplicationAccountPublicCertificate: ApplicationAccountMutationPayload;
  removeAuthenticator: RemoveAuthenticatorPayload;
  /** Remove the avatar image of the current user */
  removeAvatarImage: RemoveAvatarImagePayload;
  removeCardFromClickToPay: RemoveCardFromClickToPayPayload;
  removeEmployeeFromPayroll: RemoveEmployeeFromPayrollPayload;
  removeGiftCard: DeleteGiftCardResponse;
  removeGrant: RemoveGrantPayload;
  removeInvoiceTemplate: RemoveInvoiceTemplatePayload;
  removePayroll: RemovePayrollPayload;
  /**
   * Changes the access status to inactive. Returns the updated version of the identified
   *     ProxyAccess or an error holding the access id if the proxy access could not be updated
   */
  removeProxyAccess: RemoveProxyAccessResponse;
  /** Method to send closure request for an account. If the account can be closed straightaway it will be, otherwise the account will be added to a list to be processed.  */
  requestAccountClosure: RequestAccountClosureResponse;
  /** Request to cancel a loan application. This is not instant, as it adds a comment to the application instead of modifying its status. */
  requestCancelLoanApplication: LoanApplicationCommentPayload;
  requestCreditAssessmentPhoneCall: RequestCreditAssessmentPhoneCallPayload;
  requestDeleteCurrentUser: RequestDeleteCurrentUserPayload;
  requestGdprData: RequestGdprDataPayload;
  /** Creates a insurance consultation request in CRM. */
  requestInsuranceConsultation: InsuranceConsultationRequestPayload;
  /**
   * Apply - via CRM - for a different credit limit (yfirheimild) for a company.
   * Note: if successful, this might take up to 2 working days to process and update the limit.
   */
  requestUpdateCompanyCreditLimit: RequestUpdateCompanyCreditLimitPayload;
  reserveAppointment: ReserveAppointmentPayload;
  /** Reset user password by sending the email */
  resetUserPassword: ResetUserPasswordPayload;
  resolveAdaptiveAuthenticationQuestionStepUp: AdaptiveAuthenticationStepUpChallengeResponse;
  resolveAdaptiveAuthenticationSecurityCodeStepUp: AdaptiveAuthenticationStepUpChallengeResponse;
  resolveAdaptiveAuthenticationSmsStepUp: AdaptiveAuthenticationStepUpChallengeResponse;
  resolveBiometricStepUp: BiometricStepUpPayload;
  /**
   * Will attempt to resolve a SMS stepup presented to the user.
   *      This will only throw an error if this is the last available attempt and it fails or if there is an unexpected error on the server
   */
  resolveSmsStepUpV2: RsaChallengeResponse;
  /**
   * Will attempt to resolve a Token stepup presented to the user.
   *      This will only throw an error if this is the last available attempt and it fails or if there is an unexpected error on the server
   */
  resolveTokenStepUpV2: TokenStepUpPayload;
  reviveInvoice: ReviveInvoiceResponse;
  /** Revoke a certificate from an application account */
  revokeApplicationAccountCertificate: ApplicationAccountMutationPayload;
  /** Will attempt to sync a Token for user. This will either be successful or fail with an error on the server */
  rsaSyncToken: SyncTokenPayload;
  /** @deprecated Use uploadKycDocuments instead. Since: 2026-10-02. Issue(s) to remove it: WEB-46545 */
  saveKycAttachments: Scalars['String']['output'];
  /** Legal entity kyc draft */
  saveLegalEntityKyc: KycPayload;
  /** Save the payment batch after processing, with extra options. Only available when the status is PROCESSED. This will ready the batch for payment */
  savePaymentBatch: SavePaymentBatchUnion;
  /** Initiate a 3D Secure lookup for card payment authentication. The lookup outcome will determine the next steps in the payment process. */
  secureCardPaymentLookup: ThreeDSecureLookupPayload;
  selectStepUpPhoneNumber: SelectStepUpPhoneNumberPayload;
  /** Mutation that submits customer feedback. Should be used in conjunction with CustomerFeedback to know if the user needs to send feedback */
  sendCustomerFeedback: CustomerFeedbackResponse;
  /** Mutation that submits customer feedback after invitation survey. */
  sendInvitationFeedback: SendInvitationFeedbackPayload;
  sendMultipleInvoiceReminders: SendMultipleInvoiceRemindersPayload;
  /** Send multiple notifications for multiple payments */
  sendMultiplePaymentNotifications: SendMultiplePaymentNotificationsResponse;
  /** Send multiple notifications for a single payment */
  sendPaymentNotifications: SendPaymentNotificationsResponse;
  /** Set password for a specific company user */
  setCompanyUserPassword: SetCompanyUserPasswordPayload;
  setCulture: Scalars['String']['output'];
  /** Updates the visibility of a front page widget */
  setFrontPageWidgetVisibility: SetFrontPageWidgetVisibilityPayload;
  /** Updates the visibility of front page widgets */
  setFrontPageWidgetsVisibility: SetFrontPageWidgetsVisibilityPayload;
  /**
   * Mutation that signs the next possible signature document in a document group. If no document is signed, then it signs the first one. If the first one is signed it signs the second one and so forth. If all documents are signed, it will return an error
   * @deprecated This mutation is deprecated, it does not maintain a persistent connection for mobile users. Use `startSignNextDigitalSignatureDocument` along with `signNextDigitalSignatureDocumentByIdResult` subscription. Since: 2026-09-02. Issue to remove it: WEB-45492
   */
  signNextDigitalSignatureDocument: SignDigitalSignatureGroupDocumentResult;
  /** To start a new conversation */
  startConversation: StartConversationResponsePayload;
  startEmailVerification: StartVerificationEmailResult;
  startEmailVerificationV2: StartVerificationEmailResultV2;
  /** Mutation that starts initialization for digital signature with Audkenni. When the request is finished, the server will emit an event. */
  startInitializeSignatureProcessForAudkenni: StartInitializeSignatureProcessForAudkenniResult;
  startPhoneNumberVerification: StartVerificationPhoneNumberResult;
  startPhoneNumberVerificationV2: StartVerificationPhoneNumberResultV2;
  /** Mutation that starts a digital signature process for a document group. When the request is finished, the server will emit an event. */
  startSignNextDigitalSignatureDocument: StartSignNextDigitalSignatureDocumentByIdResult;
  /** Submit a form request for signing */
  submitFormTemplateRequest: SubmitFormTemplateRequestPayload;
  /** Submits a KYC draft for review */
  submitKycDraft: SubmitKycDraftPayload;
  /** Change the status of loan application to InProgress */
  submitLoanApplication: SubmitLoanApplicationResponse;
  subscribeToEmailList: SubscribeToEmailListPayload;
  /** Create a financial statements subscription for the current user/company. */
  subscribeToFinancialStatements: CreateFinancialStatementsSubscriptionPayload;
  toggleCollectionServiceThirdPartyPermission: ToggleCollectionServiceThirdPartyPermissionPayload;
  /** To trigger an action link. Result will include responses from the chatbot if the chat state is "bot". */
  triggerConversationActionLink: TriggerActionLinkPayload;
  /** Delete a financial statements subscription for the current user/company. */
  unsubscribeFromFinancialStatements: DeleteFinancialStatementsSubscriptionPayload;
  updateAccountPin: UpdateAccountPinResponse;
  updateAccountPinV2: UpdateAccountPinResponseV2;
  updateAccounts: UpdateAccountsPayload;
  /** Update authorizations of users and accounts on a specific owner */
  updateAccountsAuthorizations: UpdateAccountsAuthorizationsPayload;
  updateApplicantsOfVehicleLoanApplication: UpdateVehicleLoanApplicationResponse;
  /** Update an application account name and description */
  updateApplicationAccount: ApplicationAccountMutationPayload;
  /** Update application account permissions */
  updateApplicationAccountPermission: UpdateApplicationAccountPermissionPayload;
  /** Update withdrawal limit for the acting user */
  updateAuthorizationWithdrawalLimit: UpdateAuthorizationWithdrawalLimitPayload;
  updateBondLoanApplication: UpdateBondLoanApplicationPayload;
  /** Enable/disable a card's push notification options */
  updateCardPushNotificationOptions: UpdateCardPushNotificationOptionsPayload;
  updateCardSavingSubscription: UpdateCardSavingsResponse;
  /** @deprecated Use updateCardTransactionV2 instead as it uses the base CardTransaction type, but not CreditCardTransaction. Since: 2025-11. Issue(s) to remove it: WEB-37058 */
  updateCardTransaction: UpdateCardTransactionPayload;
  /** Mutation that updates transaction controls for cards by providing */
  updateCardTransactionControl: UpdateCardTransactionControlPayload;
  updateCardTransactionV2: UpdateCardTransactionPayloadV2;
  /** Batch update multiple card authorizations for the current user */
  updateCardsAuthorization: UpdateCardsAuthorizationPayload;
  updateCashPoolAccountSettings: UpdateCashPoolAccountSettingsPayload;
  updateCashPoolBaseInterestRate: UpdateCashPoolBaseInterestRatePayload;
  /** Result of updating a claim */
  updateClaim: UpdateClaimResponse;
  /** @deprecated Use updateFinancialSummaryClaimPayers instead. Issue to remove this: WEB-30584. Deprecated since 2024-12-09 */
  updateClaimPayers: UpdateClaimPayersResult;
  /** Result of updating multiple claims */
  updateClaims: Array<UpdateClaimResponse>;
  updateCreditAssessment: UpdateCreditAssessmentPayload;
  /**
   * Mutation that creates/updates/removes expense(s) depending on input, the input must always contain a description
   *       | If the input only has PaymentPerMonth then it creates an expense
   *       | If the input has a paymentPerMonth and expenseId then it updates an expense
   *       | if the input has an expenseId but no paymentPerMonth then it deletes the expense
   */
  updateCreditAssessmentExpenses: UpdateCreditAssessmentPayload;
  /** Mutation that updates a credit assessment real estate information depending on input. realEstateType and marketValue are optional so one can be updated without the other */
  updateCreditAssessmentRealEstates: UpdateCreditAssessmentPayload;
  /** Update a card's alias (custom name) */
  updateCreditCardAlias: UpdateCreditCardAliasPayload;
  updateCreditCardApplication: CreditCardApplicationPayload;
  /** Update a card's credit line. Note: If successful, the mutation returns the card with its updated creditLine value; However, it might take the API few minutes to return the actual updated value. */
  updateCreditCardCreditLine: UpdateCreditCardCreditLinePayload;
  /** Update a card's issued card status. This is used to 'toggle' between Frozen/Open */
  updateCreditCardIssuedStatus: UpdateCreditCardIssuedStatusPayload;
  /**
   * Enable/disable a credit card push notification
   * @deprecated Use updateCardPushNotificationOptions instead. Since: 2026-04-10. Issue(s) to remove it: WEB-41822
   */
  updateCreditCardPushNotificationOptions: UpdateCreditCardPushNotificationOptionsPayload;
  updateCreditCards: UpdateCreditCardsResult;
  /** Update an existing custodial agreement and appropriateness test */
  updateCustodialAgreement: UpdateCustodialAgreementPayload;
  /** Update customer loyalty consent */
  updateCustomerLoyaltyConsent: UpdateCustomerLoyaltyConsentPayload;
  updateDebitCards: UpdateCardsPayload;
  updateDepositAmountOfVehicleLoanApplication: UpdateVehicleLoanApplicationResponse;
  /** Update a direct debit agreement */
  updateDirectDebitAgreement: UpdateDirectDebitAgreementPayload;
  updateDocumentPreferences: Array<DocumentPreference>;
  updateFavoriteAccounts: UpdateFavoriteAccountsPayload;
  /** Update accounts shown in the financial summary */
  updateFinancialSummaryAccounts: UpdateFinancialSummaryOptionsPayload;
  /** Update cards shown in the financial summary */
  updateFinancialSummaryCards: UpdateFinancialSummaryOptionsPayload;
  /** Update claim payers shown in the financial summary */
  updateFinancialSummaryClaimPayers: UpdateFinancialSummaryOptionsPayload;
  /** Update claim types shown in the financial summary */
  updateFinancialSummaryClaimTypes: UpdateFinancialSummaryOptionsPayload;
  /** @deprecated Use updateFinancialSummaryClaimTypes instead. Issue to remove this: WEB-30585. Deprecated since 2024-12-09 */
  updateFinancialSummaryOptions: UpdateFinancialSummaryOptionsPayload;
  updateGdprData: UpdateGdprDataPayload;
  updateInvoiceTemplateV2: UpdateInvoiceTemplatePayloadV2;
  updateInvoiceV2: UpdateInvoicePayloadV2;
  /** @deprecated Reason: Outdated, use updateLoanAlias instead. Since: 2025-12-02. Issue to remove it: WEB-39036 */
  updateLoan: UpdateLoanResponse;
  updateLoanAlias: UpdateLoanAliasPayload;
  updateLoanPeriodOfVehicleLoanApplication: UpdateVehicleLoanApplicationResponse;
  updateMarketSubscription: UpdateMarketSubscriptionResult;
  updateOnboardingApplication: OnboardingApplicationPayload;
  /** Saves the service representative (property manager) on a company onboarding application. */
  updateOnboardingCompanyServiceRepresentative: UpdateOnboardingCompanyServiceRepresentativePayload;
  updateOverdraftLoanApplication: UpdateOverdraftLoanApplicationPayload;
  updateOverdraftToBondLoanApplication: UpdateOverdraftToBondLoanApplicationPayload;
  /** Update the email and phone number of the specified loan application party */
  updatePartyOfLoanApplication: UpdateLoanApplicationPartyPayload;
  updatePartyOfVehicleLoanApplication: UpdateVehicleLoanApplicationResponse;
  /** Update an existing recipient */
  updatePaymentRecipient: UpdatePaymentRecipientResponse;
  /** Update automatic email notification settings for a recipient */
  updatePaymentRecipientEmailNotifications: UpdatePaymentRecipientEmailNotificationsPayload;
  updateProductTypeOfVehicleLoanApplication: UpdateVehicleLoanApplicationResponse;
  updatePushNotifications: PushNotifications;
  updateRealEstateLoanApplicationBond: UpdateLoanApplicationBondResponse;
  updateRealEstateLoanApplicationLoanRequests: UpdateRealEstateLoanApplicationLoanRequestsResponse;
  updateRealEstateLoanApplicationv2: UpdateRealEstateLoanApplicationResponse;
  updateRegularSaving: UpdateRegularSavingResponse;
  updateSavingGoal: UpdateSavingGoalResponse;
  updateSecurityQuestions: UpdateUserSecurityQuestionsResult;
  /** Batch update multiple service authorizations for the current user */
  updateServicesAuthorization: UpdateServicesAuthorizationPayload;
  /** Updates the simple commission. This operation confirms the previously created simple commission. */
  updateSimpleCommission: CreateSimpleCommissionPayload;
  /** Updating status of a specific user */
  updateUserStatus: UpdateUserPayload;
  /** Updating withdrawal limit for a specific user */
  updateUserWithdrawalLimit: UpdateUserPayload;
  /** Upload an avatar image for the current user */
  uploadAvatarImage: UploadAvatarImagePayload;
  /** Upload purchase contract for vehicle loan application */
  uploadExternalVehicleLoanApplicationPurchaseContract: UploadExternalVehicleLoanApplicationPurchaseContractPayload;
  /** Upload a file attachment for a dynamic form */
  uploadFormTemplateAttachment: CreateFormTemplateAttachmentPayload;
  /** Uploads documents to the KYC */
  uploadKycDocuments: UploadKycDocumentsPayload;
  uploadLoanApplicationDocuments: UploadLoanApplicationDocumentPayload;
  /** Upload a payment batch file for processing, initiates payment batch creation */
  uploadPaymentBatchFileV2: CreatePaymentBatchPayloadV2;
  /** Upload payslip file */
  uploadPayslipFile: UploadPayslipFilePayload;
  validateCreateInvoiceBatchFromExcel: ValidateCreateInvoiceBatchFromExcelPayload;
  validateEmployeesInPayrollFromExcel: ValidateEmployeesInPayrollFromExcelPayload;
  verifyToken: VerifyTokenResult;
  verifyTokenV2: VerifyTokenResultV2;
};


export type MutationAcceptSavingGoalShareArgs = {
  data: AcceptShareInput;
};


export type MutationAddCardTransactionAttachmentArgs = {
  data: AddCardTransactionAttachmentInput;
};


export type MutationAddCollateralToLoanApplicationArgs = {
  data: AddCollateralToLoanApplicationInput;
};


export type MutationAddConversationResponseArgs = {
  data: AddConversationResponseInput;
};


export type MutationAddExistingCollateralsToLoanApplicationArgs = {
  data: AddExistingCollateralToLoanApplicationInput;
};


export type MutationAddGiftCardArgs = {
  data: AddGiftCardInput;
};


export type MutationAddMultipleCardTransactionAttachmentsArgs = {
  data: AddMultipleCardTransactionAttachmentsInput;
};


export type MutationAddPaymentApprovalArgs = {
  data: AddPaymentApprovalInput;
};


export type MutationAnswerStepUpSequrityQuestionV2Args = {
  data: AnswerStepUpSequrityQuestionInput;
};


export type MutationApplyForExpenseDistributionArgs = {
  data: ApplyForExpenseDistributionInput;
};


export type MutationApproveTermsAndConditionsContractArgs = {
  data: TermsAndConditionsApproveContractInput;
};


export type MutationApproveTermsAndConditionsContractWithoutDocumentArgs = {
  data: TermsAndConditionsApproveContractWithoutDocumentInput;
};


export type MutationArchiveCompanyUserArgs = {
  data: ArchiveCompanyUserInput;
};


export type MutationAsyncInitializeSignatureProcessForAudkenniArgs = {
  data: InitializeSignatureProcessForAudkenniInput;
};


export type MutationAsyncSignNextDigitalSignatureDocumentByIdArgs = {
  data: SignNextDigitalSignatureGroupDocumentInput;
};


export type MutationBookAppointmentArgs = {
  data: BookAppointmentInput;
};


export type MutationCancelAppointmentArgs = {
  data: CancelAppointmentInput;
};


export type MutationCancelCardSavingSubscriptionArgs = {
  data: CancelCardSavingInput;
};


export type MutationCancelDirectDebitMandateArgs = {
  data: CancelDirectDebitMandateInput;
};


export type MutationCancelInvoiceScheduleV2Args = {
  data: CancelInvoiceScheduleInput;
};


export type MutationCancelInvoiceV2Args = {
  data: CancelInvoiceInput;
};


export type MutationCancelLoanDrawDownRequestArgs = {
  data: CancelLoanDrawDownRequestInput;
};


export type MutationCancelLoanPeriodicPaymentArgs = {
  data: CancelLoanPeriodicPaymentInput;
};


export type MutationCancelMarketOrderArgs = {
  data: CancelMarketOrderInput;
};


export type MutationCancelMarketSubscriptionArgs = {
  data: CancelMarketSubscriptionInput;
};


export type MutationCancelNoticeArgs = {
  data: CancelNoticeInput;
};


export type MutationCancelPaymentArgs = {
  data: CancelPaymentInput;
};


export type MutationCancelPaymentApprovalArgs = {
  data: UpdatePaymentApprovalInput;
};


export type MutationCancelPaymentDistributionArgs = {
  data: CancelPaymentDistributionInput;
};


export type MutationCancelPeriodicPaymentArgs = {
  data: CancelPeriodicPaymentInput;
};


export type MutationChangeDirectMarketingArgs = {
  data: DirectMarketingInput;
};


export type MutationChangeEmployeeDetailsInPayrollArgs = {
  data: ChangeEmployeeDetailsInPayrollInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationChangePasswordV2Args = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChangePayrollNameArgs = {
  data: ChangePayrollNameInput;
};


export type MutationCloseCardArgs = {
  input: CloseCardInput;
};


export type MutationCloseCardAndCreateNewArgs = {
  data: CloseCardAndCreateNewInput;
};


export type MutationCompleteEmailVerificationArgs = {
  data: VerificationCodeInput;
};


export type MutationCompletePhoneVerificationArgs = {
  data: VerificationCodeInput;
};


export type MutationConfirmAdaptiveAuthenticationPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationConfirmLegalEntityKycArgs = {
  data: ConfirmLegalEntityKycInput;
};


export type MutationConfirmPaymentDistributionArgs = {
  data: ConfirmPaymentDistributionInput;
};


export type MutationContactUsArgs = {
  data: ContactUsInput;
};


export type MutationCorrectDirectDebitMandateOrderArgs = {
  data: CorrectDirectDebitMandateOrderInput;
};


export type MutationCreateAccountProductArgs = {
  data: AccountProductInput;
};


export type MutationCreateAcquiringPreApplicationArgs = {
  data: AcquiringPreApplicationInput;
};


export type MutationCreateAndApproveCreditCardLimitLoanApplicationArgs = {
  data: CreateCreditCardLimitLoanApplicationInput;
};


export type MutationCreateAppleWalletOpaquePaymentCardArgs = {
  data: CreateAppleWalletOpaquePaymentCardInput;
};


export type MutationCreateApplicationAccountArgs = {
  data: CreateApplicationAccountInput;
};


export type MutationCreateApplicationAccountCertificateArgs = {
  data: CreateApplicationAccountCertificateInput;
};


export type MutationCreateApplicationAccountPublicCertificateArgs = {
  data: CreateApplicationAccountPublicCertificateInput;
};


export type MutationCreateAukakronurTransferArgs = {
  data: CreateAukakronurTransferInput;
};


export type MutationCreateBondLoanApplicationArgs = {
  data: CreateBondLoanApplicationInput;
};


export type MutationCreateCardApplicationArgs = {
  data: CreateCardApplicationInput;
};


export type MutationCreateCardDepositArgs = {
  data: CreateCardDepositInput;
};


export type MutationCreateCardDepositV2Args = {
  data: CreateCardDepositInput;
};


export type MutationCreateCardSavingSubscriptionArgs = {
  data: CreateCardSavingSubscriptionInput;
};


export type MutationCreateCardTransactionsLedgerKeyArgs = {
  data: CreateCardTransactionsLedgerKeyInput;
};


export type MutationCreateCardTransactionsLedgerKeyGroupArgs = {
  data: CreateCardTransactionsLedgerKeyGroupInput;
};


export type MutationCreateCardTransactionsLedgerKeySubGroupArgs = {
  data: CreateCardTransactionsLedgerKeySubGroupInput;
};


export type MutationCreateClaimSigningBasketArgs = {
  data: CreateClaimSigningBasketInput;
};


export type MutationCreateCommissionArgs = {
  data: CreateCommissionInput;
};


export type MutationCreateCreditAssessmentArgs = {
  data: CreateCreditAssessmentInput;
};


export type MutationCreateCreditCardApplicationArgs = {
  data: CreditCardApplicationInput;
};


export type MutationCreateCreditCardProductApplicationDocumentArgs = {
  data: CreditCardProductApplicationDocumentInput;
};


export type MutationCreateCreditTransferArgs = {
  data: CreateCreditTransferInput;
};


export type MutationCreateCreditTransferV2Args = {
  data: CreateCreditTransferInput;
};


export type MutationCreateCrossBorderCreditTransferArgs = {
  data: CreateCrossBorderCreditTransferInput;
};


export type MutationCreateCrossBorderCreditTransferV2Args = {
  data: CreateCrossBorderCreditTransferInput;
};


export type MutationCreateCustodialAgreementArgs = {
  data: CreateCustodialAgreementInput;
};


export type MutationCreateDebitCardApplicationArgs = {
  data: CreateDebitCardApplicationInput;
};


export type MutationCreateDecisionForVehicleLoanApplicationArgs = {
  data: CreateDecisionForVehicleLoanApplicationInput;
};


export type MutationCreateDirectDebitAgreementArgs = {
  data: CreateDirectDebitAgreementInput;
};


export type MutationCreateDirectDebitInitiationArgs = {
  data: CreateDirectDebitInitiationInput;
};


export type MutationCreateDirectDebitMandateOrdersFromFileArgs = {
  data: CreateDirectDebitMandateOrdersFromFileInput;
};


export type MutationCreateEmployeeInPayrollArgs = {
  data: CreateEmployeeInPayrollInput;
};


export type MutationCreateEmployeesInPayrollFromExcelArgs = {
  data: CreateEmployeesInPayrollFromExcelInput;
};


export type MutationCreateExternalAccountConsentArgs = {
  data: CreateExternalAccountConsentInput;
};


export type MutationCreateExternalVehicleLoanApplicationArgs = {
  data: CreateExternalVehicleLoanApplicationInput;
};


export type MutationCreateFormTemplateDocumentArgs = {
  input: CreateFormTemplateDocumentInput;
};


export type MutationCreateGeneralLoanApplicationArgs = {
  data: CreateGeneralLoanApplicationInput;
};


export type MutationCreateGoogleWalletOpaguePaymentCardArgs = {
  data: CreateGoogleWalletOpaquePaymentCardInput;
};


export type MutationCreateIndexationNoticeArgs = {
  data: NoticeInput;
};


export type MutationCreateInsuranceOpportunityArgs = {
  data: CreateInsuranceOpportunityInput;
};


export type MutationCreateInvoiceArgs = {
  data: CreateInvoiceInput;
};


export type MutationCreateInvoiceBatchFromExcelArgs = {
  data: CreateInvoiceBatchFromExcelInput;
};


export type MutationCreateInvoiceScheduleV2Args = {
  data: CreateInvoiceScheduleInput;
};


export type MutationCreateInvoiceTemplateArgs = {
  data: CreateInvoiceTemplateInput;
};


export type MutationCreateInvoiceV2Args = {
  data: CreateInvoiceInput;
};


export type MutationCreateKycArgs = {
  data: KycInput;
};


export type MutationCreateLoanApplicationCommentArgs = {
  data: CreateLoanApplicationCommentInput;
};


export type MutationCreateLoanApplicationPackagesArgs = {
  data: CreateLoanApplicationPackagesInput;
};


export type MutationCreateLoanApplicationPaymentInstructionArgs = {
  data: CreateLoanApplicationPaymentInstructionInput;
};


export type MutationCreateLoanDrawDownRequestArgs = {
  data: CreateLoanDrawDownRequestInput;
};


export type MutationCreateLoanPaymentArgs = {
  data: LoanPaymentInput;
};


export type MutationCreateMandatoryPensionApplicationArgs = {
  data: PensionsMandatoryApplicationInput;
};


export type MutationCreateMarketOrderArgs = {
  data: CreateMarketOrderInput;
};


export type MutationCreateMarketSubscriptionArgs = {
  data: CreateMarketSubscriptionInput;
};


export type MutationCreateOnboardingApplicationArgs = {
  data: OnboardingApplicationInput;
};


export type MutationCreateOnboardingCorporateApplicationArgs = {
  data: OnboardingCorporateApplicationInput;
};


export type MutationCreateOnboardingCorporateApplicationDocumentArgs = {
  data: OnboardingCorporateApplicationDocumentInput;
};


export type MutationCreateOnboardingTermsAndConditionsPdfDocumentArgs = {
  data: CreateOnboardingTermsAndConditionsPdfDocumentInput;
};


export type MutationCreateOverdraftLoanApplicationArgs = {
  data: CreateOverdraftLoanApplicationInput;
};


export type MutationCreateOverdraftToBondLoanApplicationArgs = {
  data: CreateOverdraftToBondLoanApplicationInput;
};


export type MutationCreatePaidLeaveAccountsv2Args = {
  data: Scalars['Upload']['input'];
};


export type MutationCreatePaidLeaveAccountv2Args = {
  data: CreatePaidLeaveAccountInputv2;
};


export type MutationCreatePaymentBatchArgs = {
  data: CreatePaymentBatchInput;
};


export type MutationCreatePaymentDistributionArgs = {
  data: CreatePaymentDistributionInput;
};


export type MutationCreatePaymentRecipientArgs = {
  data: CreatePaymentRecipientInput;
};


export type MutationCreatePayrollArgs = {
  data: CreatePayrollInput;
};


export type MutationCreatePensionApplicationArgs = {
  data: CreatePensionApplicationInput;
};


export type MutationCreatePensionCorrespondenceArgs = {
  data: CreatePensionCorrespondenceInput;
};


export type MutationCreatePeriodicCreditTransferArgs = {
  data: CreatePeriodicCreditTransferInput;
};


export type MutationCreatePeriodicCreditTransferV2Args = {
  data: CreatePeriodicCreditTransferInput;
};


export type MutationCreateProxyAccessArgs = {
  data: CreateProxyAccessInput;
};


export type MutationCreateRealEstateLoanApplicationArgs = {
  data: CreateLoanRequestsInput;
};


export type MutationCreateRealEstateLoanRequestOptionsArgs = {
  data: CreateRealEstateLoanRequestOptionsInput;
};


export type MutationCreateRecurringCardPaymentArgs = {
  data: SecureRecurringCardPaymentInput;
};


export type MutationCreateRegularSavingArgs = {
  data: CreateRegularSavingInput;
};


export type MutationCreateSalaryPaymentBatchArgs = {
  data: CreateSalaryPaymentBatchInput;
};


export type MutationCreateSavingGoalArgs = {
  data: CreateSavingGoalInput;
};


export type MutationCreateSavingShareArgs = {
  data: CreateSavingShareInput;
};


export type MutationCreateSepaCreditTransferArgs = {
  data: CreateSepaCreditTransferInput;
};


export type MutationCreateSepaCreditTransferV2Args = {
  data: CreateSepaCreditTransferInput;
};


export type MutationCreateSupplementaryPensionApplicationArgs = {
  data: PensionsSupplementaryApplicationInput;
};


export type MutationCreateTermsAndConditionsDocumentArgs = {
  data: TermsAndConditionsDocumentInput;
};


export type MutationCreateThirdPartyPaymentCreditTransferArgs = {
  data: CreateThirdPartyPaymentCreditTransferInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationDeleteCardTransactionAttachmentArgs = {
  data: DeleteCardTransactionAttachmentInput;
};


export type MutationDeleteCardTransactionsLedgerKeyArgs = {
  data: DeleteCardTransactionsLedgerKeyInput;
};


export type MutationDeleteCardTransactionsLedgerKeyGroupArgs = {
  data: DeleteCardTransactionsLedgerKeyGroupInput;
};


export type MutationDeleteCardTransactionsLedgerKeySubGroupArgs = {
  data: DeleteCardTransactionsLedgerKeySubGroupInput;
};


export type MutationDeleteConversationArgs = {
  data: DeleteConversationInput;
};


export type MutationDeleteDirectDebitAgreementArgs = {
  data: DeleteDirectDebitAgreementInput;
};


export type MutationDeleteDirectDebitAgreementsArgs = {
  data: DeleteDirectDebitAgreementsInput;
};


export type MutationDeleteDirectDebitMandateOrderArgs = {
  data: DeleteDirectDebitMandateOrderInput;
};


export type MutationDeleteDirectDebitMandateOrdersArgs = {
  data: DeleteDirectDebitMandateOrdersInput;
};


export type MutationDeleteExternalAccountConsentArgs = {
  data: DeleteExternalAccountConsentInput;
};


export type MutationDeleteKycStakeholderArgs = {
  data: DeleteKycStakeholderInput;
};


export type MutationDeleteOptionalClaimArgs = {
  data: DeleteOptionalClaimInput;
};


export type MutationDeletePaymentNotificationsHandleArgs = {
  data: DeletePaymentNotificationsHandleInput;
};


export type MutationDeletePaymentRecipientArgs = {
  data: DeletePaymentRecipientInput;
};


export type MutationDeletePhoneNumberArgs = {
  data: DeletePhoneNumberInput;
};


export type MutationDeletePhoneNumberV2Args = {
  phoneType: PhoneType;
};


export type MutationDeleteStoredPaymentArgs = {
  data: DeleteStoredPaymentInput;
};


export type MutationDeleteStoredPaymentsArgs = {
  data: DeleteStoredPaymentsInput;
};


export type MutationDismissNotificationBannerArgs = {
  data: DissmisNotificationBannerInput;
};


export type MutationEditInvoiceScheduleArgs = {
  data: EditInvoiceScheduleInput;
};


export type MutationEndSavingGoalArgs = {
  data: EndSavingGoalInput;
};


export type MutationEnrollCardToClickToPayArgs = {
  input: EnrollCardToClickToPayInput;
};


export type MutationGiveConversationFeedbackArgs = {
  data: GiveConversationFeedbackInput;
};


export type MutationGiveConversationSubjectArgs = {
  data: GiveConversationSubjectInput;
};


export type MutationInitializeSignatureProcessForAudkenniArgs = {
  data: InitializeSignatureProcessForAudkenniInput;
};


export type MutationInitiatePaymentApprovalProcessArgs = {
  data: InitiatePaymentApprovalProcessInput;
};


export type MutationInitiateStoredPaymentsArgs = {
  data: InitiateStoredPaymentsInput;
};


export type MutationLoanCalculatorArgs = {
  data: LoanCalculatorInput;
};


export type MutationMassAdjustInvoicesForSecondaryCollectionArgs = {
  data: MassAdjustInvoicesForSecondaryCollectionInput;
};


export type MutationMassCancelInvoicesArgs = {
  data: MassCancelInvoicesInput;
};


export type MutationOnboardCustomerArgs = {
  data: OnboardingCustomerInput;
};


export type MutationOptOutOfCampaignArgs = {
  data: OptOutOfCampaignInput;
};


export type MutationOrderAukakronurCardArgs = {
  data: OrderAukakronurCardInput;
};


export type MutationOrderGiftCardArgs = {
  data: OrderGiftCardInput;
};


export type MutationPayScheduledPaymentArgs = {
  data: PayScheduledPaymentInput;
};


export type MutationPostDecisionArgs = {
  data: PostLoanApplicationDecisionInput;
};


export type MutationPostLoanApplicationDecisionArgs = {
  data: PostLoanApplicationDecisionInput;
};


export type MutationPreviewCreditCardLineChangeArgs = {
  data: PreviewCreditCardLineChangeInput;
};


export type MutationRegisterAdaptiveAuthenticationSecurityCodeArgs = {
  securityCode: Scalars['String']['input'];
};


export type MutationRegisterOnboardingCompanyApplicationArgs = {
  data: RegisterOnboardingCompanyApplicationInput;
};


export type MutationRegisterToEventArgs = {
  data: EventRegistrationInput;
};


export type MutationReissueCardArgs = {
  input: ReissueCardInput;
};


export type MutationRejectPaymentApprovalArgs = {
  data: UpdatePaymentApprovalInput;
};


export type MutationRejectSavingGoalShareArgs = {
  data: RejectShareInput;
};


export type MutationRemoveApplicationAccountArgs = {
  data: ApplicationAccountIdInput;
};


export type MutationRemoveApplicationAccountPublicCertificateArgs = {
  data: RemoveApplicationAccountPublicCertificateInput;
};


export type MutationRemoveAuthenticatorArgs = {
  data: RemoveAuthenticatorInput;
};


export type MutationRemoveCardFromClickToPayArgs = {
  input: RemoveCardFromClickToPayInput;
};


export type MutationRemoveEmployeeFromPayrollArgs = {
  data: RemoveEmployeeFromPayrollInput;
};


export type MutationRemoveGiftCardArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveGrantArgs = {
  data: RemoveGrantInput;
};


export type MutationRemoveInvoiceTemplateArgs = {
  data: RemoveInvoiceTemplateInput;
};


export type MutationRemovePayrollArgs = {
  data: RemovePayrollInput;
};


export type MutationRemoveProxyAccessArgs = {
  data: RemoveProxyAccessesInput;
};


export type MutationRequestAccountClosureArgs = {
  data: RequestAccountClosureInput;
};


export type MutationRequestCancelLoanApplicationArgs = {
  data: RequestCancelLoanApplicationInput;
};


export type MutationRequestCreditAssessmentPhoneCallArgs = {
  data: RequestCreditAssessmentPhoneCallInput;
};


export type MutationRequestGdprDataArgs = {
  data: RequestGdprDataInput;
};


export type MutationRequestInsuranceConsultationArgs = {
  data: RequestInsuranceConsultationInput;
};


export type MutationRequestUpdateCompanyCreditLimitArgs = {
  data: RequestUpdateCompanyCreditLimitInput;
};


export type MutationReserveAppointmentArgs = {
  data: ReserveAppointmentInput;
};


export type MutationResetUserPasswordArgs = {
  data: ResetUserPasswordInput;
};


export type MutationResolveAdaptiveAuthenticationQuestionStepUpArgs = {
  answer: Scalars['String']['input'];
};


export type MutationResolveAdaptiveAuthenticationSecurityCodeStepUpArgs = {
  securityCode: Scalars['String']['input'];
};


export type MutationResolveAdaptiveAuthenticationSmsStepUpArgs = {
  answer: Scalars['String']['input'];
};


export type MutationResolveBiometricStepUpArgs = {
  data: ResolveBiometricStepUpInput;
};


export type MutationResolveSmsStepUpV2Args = {
  data: ResolveSmsStepUpInput;
};


export type MutationResolveTokenStepUpV2Args = {
  data: ResolveTokenStepUpInput;
};


export type MutationReviveInvoiceArgs = {
  data: ReviveInvoiceInput;
};


export type MutationRevokeApplicationAccountCertificateArgs = {
  data: RevokeApplicationAccountCertificateInput;
};


export type MutationRsaSyncTokenArgs = {
  data: SyncTokenStepUpInput;
};


export type MutationSaveKycAttachmentsArgs = {
  data: Array<Scalars['Upload']['input']>;
};


export type MutationSaveLegalEntityKycArgs = {
  data: SaveLegalEntityKycInput;
};


export type MutationSavePaymentBatchArgs = {
  data: SavePaymentBatchInput;
};


export type MutationSecureCardPaymentLookupArgs = {
  data: ThreeDSecureLookupInput;
};


export type MutationSelectStepUpPhoneNumberArgs = {
  data: SelectStepUpPhonenumberInput;
};


export type MutationSendCustomerFeedbackArgs = {
  SendCustomerFeedbackInput: SendCustomerFeedbackInput;
};


export type MutationSendInvitationFeedbackArgs = {
  SendInvitationFeedbackInput: SendInvitationFeedbackInput;
};


export type MutationSendMultipleInvoiceRemindersArgs = {
  data: InvoiceRemindersInput;
};


export type MutationSendMultiplePaymentNotificationsArgs = {
  data: SendMultiplePaymentNotificationsInput;
};


export type MutationSendPaymentNotificationsArgs = {
  data: SendPaymentNotificationsInput;
};


export type MutationSetCompanyUserPasswordArgs = {
  data: SetCompanyUserPasswordInput;
};


export type MutationSetCultureArgs = {
  data: SetCultureInput;
};


export type MutationSetFrontPageWidgetVisibilityArgs = {
  data: SetFrontPageWidgetVisibilityInput;
};


export type MutationSetFrontPageWidgetsVisibilityArgs = {
  data: SetFrontPageWidgetsVisibilityInput;
};


export type MutationSignNextDigitalSignatureDocumentArgs = {
  data: SignNextDigitalSignatureGroupDocumentInput;
};


export type MutationStartEmailVerificationArgs = {
  data: EmailInput;
};


export type MutationStartEmailVerificationV2Args = {
  email: Scalars['String']['input'];
};


export type MutationStartInitializeSignatureProcessForAudkenniArgs = {
  data: InitializeSignatureProcessForAudkenniInput;
};


export type MutationStartPhoneNumberVerificationArgs = {
  data: PhoneNumberInput;
};


export type MutationStartPhoneNumberVerificationV2Args = {
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  phoneType: PhoneType;
};


export type MutationStartSignNextDigitalSignatureDocumentArgs = {
  data: SignNextDigitalSignatureGroupDocumentInput;
};


export type MutationSubmitFormTemplateRequestArgs = {
  input: SubmitFormTemplateRequestInput;
};


export type MutationSubmitKycDraftArgs = {
  data: SubmitKycInput;
};


export type MutationSubmitLoanApplicationArgs = {
  data: SubmitLoanApplicationInput;
};


export type MutationSubscribeToEmailListArgs = {
  data: SubscribeToEmailListInput;
};


export type MutationSubscribeToFinancialStatementsArgs = {
  data: SubscribeToFinancialStatementsInput;
};


export type MutationToggleCollectionServiceThirdPartyPermissionArgs = {
  data: ToggleCollectionServiceThirdPartyPermissionInput;
};


export type MutationTriggerConversationActionLinkArgs = {
  data: TriggerConversationActionLinkInput;
};


export type MutationUnsubscribeFromFinancialStatementsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAccountPinArgs = {
  data: UpdateAccountPinInput;
};


export type MutationUpdateAccountPinV2Args = {
  id: Scalars['ID']['input'];
  pin: Scalars['String']['input'];
};


export type MutationUpdateAccountsArgs = {
  data: UpdateAccountsInput;
};


export type MutationUpdateAccountsAuthorizationsArgs = {
  data: UpdateAccountsAuthorizationsInput;
};


export type MutationUpdateApplicantsOfVehicleLoanApplicationArgs = {
  data: UpdateApplicantsOfVehicleLoanApplicationInput;
};


export type MutationUpdateApplicationAccountArgs = {
  data: UpdateApplicationAccountInput;
};


export type MutationUpdateApplicationAccountPermissionArgs = {
  data: UpdateApplicationAccountPermissionInput;
};


export type MutationUpdateAuthorizationWithdrawalLimitArgs = {
  withdrawalLimit: CurrencyAmountInput;
};


export type MutationUpdateBondLoanApplicationArgs = {
  data: UpdateBondLoanApplicationInput;
};


export type MutationUpdateCardPushNotificationOptionsArgs = {
  data: UpdateCardPushNotificationOptionsInput;
};


export type MutationUpdateCardSavingSubscriptionArgs = {
  data: UpdateCardSavingSubscriptionInput;
};


export type MutationUpdateCardTransactionArgs = {
  data: UpdateCardTransactionInput;
};


export type MutationUpdateCardTransactionControlArgs = {
  data: UpdateCardTransactionControlInput;
};


export type MutationUpdateCardTransactionV2Args = {
  data: UpdateCardTransactionInput;
};


export type MutationUpdateCardsAuthorizationArgs = {
  data: UpdateCardsAuthorizationInput;
};


export type MutationUpdateCashPoolAccountSettingsArgs = {
  data: UpdateCashPoolAccountSettingsInput;
};


export type MutationUpdateCashPoolBaseInterestRateArgs = {
  data: UpdateCashPoolBaseInterestRateInput;
};


export type MutationUpdateClaimArgs = {
  data: UpdateClaimInput;
};


export type MutationUpdateClaimPayersArgs = {
  data: UpdateClaimPayersInput;
};


export type MutationUpdateClaimsArgs = {
  data: UpdateClaimsInput;
};


export type MutationUpdateCreditAssessmentArgs = {
  data: UpdateCreditAssessmentInput;
};


export type MutationUpdateCreditAssessmentExpensesArgs = {
  data: UpdateCreditAssessmentExpensesInput;
};


export type MutationUpdateCreditAssessmentRealEstatesArgs = {
  data: UpdateCreditAssessmentRealEstatesInput;
};


export type MutationUpdateCreditCardAliasArgs = {
  data: UpdateCreditCardAliasInput;
};


export type MutationUpdateCreditCardApplicationArgs = {
  data: UpdateCreditCardApplicationInput;
};


export type MutationUpdateCreditCardCreditLineArgs = {
  data: UpdateCreditCardCreditLineInput;
};


export type MutationUpdateCreditCardIssuedStatusArgs = {
  data: UpdateCreditCardIssuedStatusInput;
};


export type MutationUpdateCreditCardPushNotificationOptionsArgs = {
  data: UpdateCreditCardPushNotificationOptionsInput;
};


export type MutationUpdateCreditCardsArgs = {
  data: UpdateCreditCardsInput;
};


export type MutationUpdateCustodialAgreementArgs = {
  data: UpdateCustodialAgreementInput;
};


export type MutationUpdateCustomerLoyaltyConsentArgs = {
  data: UpdateCustomerLoyaltyConsentInput;
};


export type MutationUpdateDebitCardsArgs = {
  data: UpdateCardsInput;
};


export type MutationUpdateDepositAmountOfVehicleLoanApplicationArgs = {
  data: UpdateDepositAmountOfVehicleLoanApplicationInput;
};


export type MutationUpdateDirectDebitAgreementArgs = {
  data: UpdateDirectDebitAgreementInput;
};


export type MutationUpdateDocumentPreferencesArgs = {
  data: UpdateDocumentPreferenceInput;
};


export type MutationUpdateFavoriteAccountsArgs = {
  data: UpdateFavoriteAccountsInput;
};


export type MutationUpdateFinancialSummaryAccountsArgs = {
  data: UpdateFinancialSummaryAccountsInput;
};


export type MutationUpdateFinancialSummaryCardsArgs = {
  data: UpdateFinancialSummaryCardsInput;
};


export type MutationUpdateFinancialSummaryClaimPayersArgs = {
  data: UpdateFinancialSummaryClaimPayersInput;
};


export type MutationUpdateFinancialSummaryClaimTypesArgs = {
  data: UpdateFinancialSummaryClaimTypesInput;
};


export type MutationUpdateFinancialSummaryOptionsArgs = {
  data: UpdateFinancialSummaryOptionsInput;
};


export type MutationUpdateGdprDataArgs = {
  data: UpdateGdprDataInput;
};


export type MutationUpdateInvoiceTemplateV2Args = {
  data: UpdateInvoiceTemplateInput;
};


export type MutationUpdateInvoiceV2Args = {
  data: UpdateInvoiceInput;
};


export type MutationUpdateLoanArgs = {
  data: UpdateLoanInput;
};


export type MutationUpdateLoanAliasArgs = {
  data: UpdateLoanAliasInput;
};


export type MutationUpdateLoanPeriodOfVehicleLoanApplicationArgs = {
  data: UpdateLoanPeriodOfVehicleLoanApplicationInput;
};


export type MutationUpdateMarketSubscriptionArgs = {
  data: UpdateMarketSubscriptionInput;
};


export type MutationUpdateOnboardingApplicationArgs = {
  data: OnboardingApplicationInput;
};


export type MutationUpdateOnboardingCompanyServiceRepresentativeArgs = {
  data: UpdateOnboardingCompanyServiceRepresentativeInput;
};


export type MutationUpdateOverdraftLoanApplicationArgs = {
  data: UpdateOverdraftLoanApplicationInput;
};


export type MutationUpdateOverdraftToBondLoanApplicationArgs = {
  data: UpdateOverdraftToBondLoanApplicationInput;
};


export type MutationUpdatePartyOfLoanApplicationArgs = {
  data: UpdateLoanApplicationPartyInput;
};


export type MutationUpdatePartyOfVehicleLoanApplicationArgs = {
  data: UpdateLoanApplicationPartyInput;
};


export type MutationUpdatePaymentRecipientArgs = {
  data: UpdatePaymentRecipientInput;
};


export type MutationUpdatePaymentRecipientEmailNotificationsArgs = {
  data: UpdatePaymentRecipientEmailNotificationsInput;
};


export type MutationUpdateProductTypeOfVehicleLoanApplicationArgs = {
  data: UpdateProductTypeOfVehicleLoanApplicationInput;
};


export type MutationUpdatePushNotificationsArgs = {
  data: UpdatePushNotificationsInput;
};


export type MutationUpdateRealEstateLoanApplicationBondArgs = {
  data: UpdateRealEstateLoanApplicationBondInput;
};


export type MutationUpdateRealEstateLoanApplicationLoanRequestsArgs = {
  data: UpdateRealEstateLoanApplicationLoanRequestsInput;
};


export type MutationUpdateRealEstateLoanApplicationv2Args = {
  data: UpdateLoanApplicationInput;
};


export type MutationUpdateRegularSavingArgs = {
  data: UpdateRegularSavingInput;
};


export type MutationUpdateSavingGoalArgs = {
  data: UpdateSavingGoalInput;
};


export type MutationUpdateSecurityQuestionsArgs = {
  data: UpdateSecurityQuestionsInput;
};


export type MutationUpdateServicesAuthorizationArgs = {
  data: UpdateServicesAuthorizationInput;
};


export type MutationUpdateSimpleCommissionArgs = {
  data: CreateSimpleCommissionInput;
};


export type MutationUpdateUserStatusArgs = {
  data: UpdateUserStatusInput;
};


export type MutationUpdateUserWithdrawalLimitArgs = {
  data: UpdateUserWithdrawalLimitInput;
};


export type MutationUploadAvatarImageArgs = {
  data: UploadAvatarImageInput;
};


export type MutationUploadExternalVehicleLoanApplicationPurchaseContractArgs = {
  data: UploadExternalVehicleLoanApplicationPurchaseContractInput;
};


export type MutationUploadFormTemplateAttachmentArgs = {
  input: UploadFormTemplateAttachmentInput;
};


export type MutationUploadKycDocumentsArgs = {
  data: UploadKycDocumentsInput;
};


export type MutationUploadLoanApplicationDocumentsArgs = {
  data: UploadLoanApplicationDocumentsInput;
};


export type MutationUploadPaymentBatchFileV2Args = {
  data: UploadPaymentBatchFileInput;
};


export type MutationUploadPayslipFileArgs = {
  data: UploadPayslipFileInput;
};


export type MutationValidateCreateInvoiceBatchFromExcelArgs = {
  data: ValidateCreateInvoiceBatchFromExcelInput;
};


export type MutationValidateEmployeesInPayrollFromExcelArgs = {
  data: ValidateEmployeesInPayrollFromExcelInput;
};

export type NationalRegistryEntry = Node & {
  __typename: 'NationalRegistryEntry';
  address: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
};

export type NationalRegistryEntryConnection = {
  __typename: 'NationalRegistryEntryConnection';
  edges: Array<NationalRegistryEntryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NationalRegistryEntryEdge = {
  __typename: 'NationalRegistryEntryEdge';
  cursor: Scalars['String']['output'];
  node: NationalRegistryEntry;
};

export type NationalRegistryEntryResponse = KennitalaNotFoundError | NationalRegistryEntry;

export type NationalRegistryOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: NationalRegistryOrderByField;
};

export enum NationalRegistryOrderByField {
  KENNITALA = 'KENNITALA',
  NAME = 'NAME'
}

export enum NationalRegistrySearchType {
  Company = 'Company',
  Individual = 'Individual'
}

export type NewPasswordNotValid = Error & {
  __typename: 'NewPasswordNotValid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type NewPaymentApprovalProcessResponse = {
  __typename: 'NewPaymentApprovalProcessResponse';
  /** The id of the payment approval process */
  approvalProcessId: Scalars['String']['output'];
  /** The id of the payment */
  paymentId: Scalars['ID']['output'];
  /** The status of the payment approval process */
  status: PaymentApprovalStatus;
};

export enum NextAssessmentType {
  CipAssessment = 'CipAssessment',
  Closed = 'Closed',
  OrderAssessment = 'OrderAssessment',
  StatusAssessment = 'StatusAssessment'
}

/** No face was detected in the uploaded image */
export type NoFaceDetectedError = Error & {
  __typename: 'NoFaceDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

/** Nominal returns per year */
export type NominalReturns = {
  __typename: 'NominalReturns';
  return: Maybe<Scalars['Float']['output']>;
  year: Maybe<Scalars['Float']['output']>;
};

export type NotCompletedPaymentStatus = Error & {
  __typename: 'NotCompletedPaymentStatus';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type NotEnoughholdingError = Error & {
  __typename: 'NotEnoughholdingError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Notices, pantaðar úttektir */
export type Notice = {
  __typename: 'Notice';
  amount: Scalars['Float']['output'];
  categoryCode: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  depositInfo: AccountInfo;
  extendedReference: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  referenceNumber: Scalars['String']['output'];
  remainingAmount: Scalars['Float']['output'];
  typeCode: Maybe<TypeCode>;
  withdrawalInfo: AccountInfo;
};

export type NoticeConnection = {
  __typename: 'NoticeConnection';
  edges: Array<NoticeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NoticeEdge = {
  __typename: 'NoticeEdge';
  cursor: Scalars['String']['output'];
  node: Notice;
};

export type NoticeInput = {
  amount: Scalars['Float']['input'];
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  depositInfo: DepositInfo;
  extendedReference?: InputMaybe<Scalars['String']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  typeCode: TypeCode;
  withdrawalInfo: WithdrawalInfo;
};

export enum NoticeType {
  Indexation = 'Indexation',
  Vx30 = 'Vx30'
}

/** Returned when dismissNotificationBanner operation does not find the notification message id. */
export type NotificationMessageNotFound = Error & {
  __typename: 'NotificationMessageNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Number input component */
export type NumberFormComponent = FormComponentBase & {
  __typename: 'NumberFormComponent';
  format: Maybe<FormNumberFormat>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  suffix: Maybe<Scalars['String']['output']>;
  type: FormComponentType;
  validation: Maybe<FormComponentValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type OldPasswordIncorrect = Error & {
  __typename: 'OldPasswordIncorrect';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Contains onboarding application */
export type OnboardingApplication = {
  __typename: 'OnboardingApplication';
  /** Id for the digitalSignatureDocument pdf */
  digitalSignatureDocumentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  /** Id for signing digital signature document */
  groupId: Scalars['ID']['output'];
  /** Application (model) id */
  id: Scalars['String']['output'];
  language: Maybe<OnboardingLanguage>;
  phoneNumber: Scalars['String']['output'];
  products: Array<OnboardingApplicationProduct>;
  status: OnboardingStatus;
};

export type OnboardingApplicationInput = {
  /** User's email. */
  email: Scalars['String']['input'];
  /** ID of user's terms and conditions document. */
  id: Scalars['String']['input'];
  /** User's KYC information accumulated throughout the onboarding process. */
  knowYourCustomer: KycInput;
  /** User's preferred language. */
  language: OnboardingLanguage;
  /** User's phone number. */
  phoneNumber: Scalars['String']['input'];
  products: Array<OnboardingProductInput>;
};

export type OnboardingApplicationNotFound = Error & {
  __typename: 'OnboardingApplicationNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type OnboardingApplicationPayload = {
  __typename: 'OnboardingApplicationPayload';
  onboardingApplication: OnboardingApplication;
};

/** Contains onboarding product */
export type OnboardingApplicationProduct = {
  __typename: 'OnboardingApplicationProduct';
  createDebitCardForOwner: Maybe<Scalars['Boolean']['output']>;
  productType: Maybe<OnboardingProductType>;
  securityCode: Maybe<Scalars['String']['output']>;
};

export type OnboardingCompaniesOrderBy = {
  /** Direction to order companies by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order companies by */
  field: OnboardingCompaniesOrderByOptions;
};

/** Fields that onboarding companies can be ordered by */
export enum OnboardingCompaniesOrderByOptions {
  KENNITALA = 'KENNITALA',
  NAME = 'NAME'
}

/** A company that the current contact is authorized to onboard. */
export type OnboardingCompany = {
  __typename: 'OnboardingCompany';
  /** Whether the company is a house association (ísl. húsfélag), based on its legal form. */
  isHouseAssociation: Scalars['Boolean']['output'];
  /** The company's kennitala. */
  kennitala: Scalars['String']['output'];
  /** The company's name. */
  name: Scalars['String']['output'];
  /** The current contact's known roles in the company. */
  roles: Array<CompanyContactRole>;
};

export type OnboardingCompanyConnection = {
  __typename: 'OnboardingCompanyConnection';
  edges: Array<OnboardingCompanyEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** A customer (person or company) referenced by a company onboarding application */
export type OnboardingCompanyCustomer = {
  __typename: 'OnboardingCompanyCustomer';
  /** The customer's national ID (kennitala) */
  kennitala: Scalars['String']['output'];
  /** The customer's name */
  name: Scalars['String']['output'];
  /** The customer's role in the company */
  role: Maybe<CompanyContactRole>;
};

export type OnboardingCompanyEdge = {
  __typename: 'OnboardingCompanyEdge';
  cursor: Scalars['String']['output'];
  node: OnboardingCompany;
};

export enum OnboardingCompanyPrerequisite {
  ALREADY_HAS_ONLINE_BANK = 'ALREADY_HAS_ONLINE_BANK',
  BANKRUPT = 'BANKRUPT',
  CONTACT_NOT_AUTHORIZED = 'CONTACT_NOT_AUTHORIZED',
  CONTACT_UNDER_AGE = 'CONTACT_UNDER_AGE',
  DELETED = 'DELETED',
  INCOMPATIBLE = 'INCOMPATIBLE',
  INVALID_ISAT_CODE = 'INVALID_ISAT_CODE',
  UNKNOWN = 'UNKNOWN',
  UNMET_CONDITIONS_FOR_COMPANY = 'UNMET_CONDITIONS_FOR_COMPANY',
  UNMET_CONDITIONS_FOR_CONTACT = 'UNMET_CONDITIONS_FOR_CONTACT',
  UNMET_CONDITIONS_FOR_OWNER = 'UNMET_CONDITIONS_FOR_OWNER',
  UNMET_CONDITIONS_FOR_STAKEHOLDER = 'UNMET_CONDITIONS_FOR_STAKEHOLDER'
}

export type OnboardingCompanyPrerequisitesPayload = {
  __typename: 'OnboardingCompanyPrerequisitesPayload';
  /** The company the prerequisites were checked for. Returns null if the company is not found. */
  company: Maybe<OnboardingCompany>;
  /** The conditions blocking the company from being onboarded */
  prerequisites: Array<OnboardingCompanyPrerequisite>;
};

export type OnboardingCompanyPrerequisitesResponse = CompanyNotFound | OnboardingCompanyPrerequisitesPayload | UnauthorizedContact;

/** Contains onboarding corporate application */
export type OnboardingCorporateApplication = Node & {
  __typename: 'OnboardingCorporateApplication';
  companyKennitala: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactKennitala: Scalars['String']['output'];
  contactOnCompletion: Scalars['Boolean']['output'];
  createDebitCardForOwner: Scalars['Boolean']['output'];
  createPurchaseCardForCompany: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  securityCode: Scalars['String']['output'];
  status: OnboardingCorporateStatus;
};

export type OnboardingCorporateApplicationDocumentContentInput = {
  documentId: Scalars['String']['input'];
};

export type OnboardingCorporateApplicationDocumentInput = {
  companyKennitala: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  language: OnboardingLanguage;
  termItems: Array<TermItem>;
};

export type OnboardingCorporateApplicationInput = {
  companyKennitala: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  contactEmail: Scalars['String']['input'];
  contactKennitala: Scalars['String']['input'];
  contactOnCompletion: Scalars['Boolean']['input'];
  contactPhoneNumber: Scalars['String']['input'];
  createDebitCardForOwner: Scalars['Boolean']['input'];
  createPurchaseCardForCompany: Scalars['Boolean']['input'];
  documentId: Scalars['String']['input'];
  language: OnboardingLanguage;
  loginDevice?: InputMaybe<Scalars['String']['input']>;
  securityCode: Scalars['String']['input'];
};

export enum OnboardingCorporateStatus {
  ApplicationAccepted = 'ApplicationAccepted',
  ApplicationRejected = 'ApplicationRejected',
  CreatingProducts = 'CreatingProducts',
  KycCompleted = 'KycCompleted',
  KycSubmitted = 'KycSubmitted',
  ProcessComplete = 'ProcessComplete',
  ProcessingApplication = 'ProcessingApplication',
  UserCreated = 'UserCreated'
}

export type OnboardingCustomerInput = {
  /** ID of user's terms and conditions document. */
  documentId: Scalars['String']['input'];
  /** User's email. */
  email: Scalars['String']['input'];
  /** User's preferred language. */
  language: OnboardingLanguage;
};

/** Contains the username of the newly onboarded user. */
export type OnboardingCustomerUsername = {
  __typename: 'OnboardingCustomerUsername';
  /** The username of the newly onboarded user. */
  username: Scalars['String']['output'];
};

export enum OnboardingLanguage {
  English = 'English',
  Icelandic = 'Icelandic',
  Polish = 'Polish'
}

export type OnboardingPrerequisites = {
  __typename: 'OnboardingPrerequisites';
  /** User's prerequisites for onboarding. */
  prerequisites: Array<OnboardingPrerequsiteType>;
};

export enum OnboardingPrerequsiteType {
  AlreadyRegistered = 'AlreadyRegistered',
  Bankruptcy = 'Bankruptcy',
  Discontinued = 'Discontinued',
  Estate = 'Estate',
  FurtherBusinessDisallowed = 'FurtherBusinessDisallowed',
  LockedDueToFraud = 'LockedDueToFraud',
  RefusalFromDueDiligence = 'RefusalFromDueDiligence',
  SeizureOfProperty = 'SeizureOfProperty',
  SelfServiceRestricted = 'SelfServiceRestricted',
  SuspensionOfFinancialAutonomy = 'SuspensionOfFinancialAutonomy',
  UnderAge = 'UnderAge'
}

export type OnboardingProductInput = {
  createDebitCardForOwner?: InputMaybe<Scalars['Boolean']['input']>;
  productType: OnboardingProductType;
  securityCode?: InputMaybe<Scalars['String']['input']>;
};

export enum OnboardingProductType {
  CurrentAccount = 'CurrentAccount',
  SavingsAccount = 'SavingsAccount',
  SecuritiesContract = 'SecuritiesContract'
}

export enum OnboardingStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  InSigning = 'InSigning'
}

export type OnboardingTermsAndConditionsPdfDocumentId = {
  __typename: 'OnboardingTermsAndConditionsPdfDocumentId';
  /** ID of the terms and conditions PDF document. */
  documentId: Scalars['String']['output'];
};

export type OnboardingTermsAndConditionsPdfDocumentInput = {
  /** ID of the terms and conditions PDF document. */
  documentId: Scalars['String']['input'];
};

export enum OnboardingType {
  Company = 'Company',
  Individual = 'Individual'
}

/** A validation failure */
export type OnboardingValidationError = Error & {
  __typename: 'OnboardingValidationError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Version of onlinebank corporate user should be routed to */
export enum OnlineBankVersion {
  /** Alpha version of onlinebank corporate. */
  ALPHA = 'ALPHA',
  /** Beta version of onlinebank corporate. */
  BETA = 'BETA',
  /** Release version of onlinebank corporate. Most users should be here. */
  DEFAULT = 'DEFAULT'
}

export type OnlineTradeNotAvailableForInstrument = Error & {
  __typename: 'OnlineTradeNotAvailableForInstrument';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Operational Status of a system component */
export type OperationalStatus = Node & {
  __typename: 'OperationalStatus';
  /** Id to be able to filter and map components in an understandable manner in frontend clients */
  componentId: OperationalStatusComponentId;
  /** @deprecated Use message instead. That field will yield a localized message. Or messages if you want all locales at once. This field is legacy and will be removed in the future. */
  description: Maybe<Array<OperationalStatusDescription>>;
  /** GraphQL global identifier of a component, a composite string of this objects name and operational component Id. See the `OperationalComponentId` enum */
  id: Scalars['ID']['output'];
  /** A localized message containing title, description and link. Description will always be populated but other fields can be null. */
  message: Maybe<OperationalStatusMessage>;
  /** Messages in all locales if clients want to cache them together. */
  messages: Maybe<Array<OperationalStatusMessageWithLanguage>>;
  /** Name of the component. If no configured name is set this field returns the components id */
  name: Scalars['String']['output'];
  /** Status of the component */
  status: OperationalStatusEnum;
};

/** A components ID that can be used to map different components in the frontend clients */
export enum OperationalStatusComponentId {
  ACCOUNTS = 'ACCOUNTS',
  ACQUIRING = 'ACQUIRING',
  APPOINTMENT = 'APPOINTMENT',
  AUKAKRONUR = 'AUKAKRONUR',
  AUTHORIZATIONS = 'AUTHORIZATIONS',
  BIOMETRICRSAANALYZE = 'BIOMETRICRSAANALYZE',
  CARLOANS = 'CARLOANS',
  CASHPOOL = 'CASHPOOL',
  CLAIMCOLLECTIONS = 'CLAIMCOLLECTIONS',
  COLLECTIONBOND = 'COLLECTIONBOND',
  CREDITASSESSMENT = 'CREDITASSESSMENT',
  CREDITCARDS = 'CREDITCARDS',
  CREDITLIMIT = 'CREDITLIMIT',
  CURRENCIES = 'CURRENCIES',
  CUSTOMERCHAT = 'CUSTOMERCHAT',
  CUSTOMERFEEDBACK = 'CUSTOMERFEEDBACK',
  CUSTOMERINBOX = 'CUSTOMERINBOX',
  CUSTOMERRECOMMENDATION = 'CUSTOMERRECOMMENDATION',
  DEBITCARDS = 'DEBITCARDS',
  DIGITALSIGNATURE = 'DIGITALSIGNATURE',
  ELECTRONICDOCUMENTS = 'ELECTRONICDOCUMENTS',
  EXTERNALVEHICLELOANS = 'EXTERNALVEHICLELOANS',
  FOREIGNTRANSFER = 'FOREIGNTRANSFER',
  FORMTEMPLATES = 'FORMTEMPLATES',
  FUNDGIFT = 'FUNDGIFT',
  GIFTCARDS = 'GIFTCARDS',
  INSURANCES = 'INSURANCES',
  INVOICEBATCHES = 'INVOICEBATCHES',
  LOANS = 'LOANS',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  MORTGAGELOANS = 'MORTGAGELOANS',
  MYPAGE = 'MYPAGE',
  NATIONALREGISTRY = 'NATIONALREGISTRY',
  ONBOARDING = 'ONBOARDING',
  PAYMENTSEARCH = 'PAYMENTSEARCH',
  PAYROLLS = 'PAYROLLS',
  PENSION = 'PENSION',
  SECURITIES = 'SECURITIES',
  SERVICEPOINTS = 'SERVICEPOINTS',
  STOREDPAYMENTS = 'STOREDPAYMENTS',
  TESTINGSTATUS = 'TESTINGSTATUS',
  TRANSFER = 'TRANSFER',
  TRANSFERRECIPIENTS = 'TRANSFERRECIPIENTS',
  UNKNOWN = 'UNKNOWN',
  UNPAIDCLAIMS = 'UNPAIDCLAIMS'
}

export type OperationalStatusDescription = {
  __typename: 'OperationalStatusDescription';
  culture: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Operational status of a component */
export enum OperationalStatusEnum {
  /**
   * An incident causes a degraded performance. Affected component is operating but with some limitations
   * @deprecated Reason: Outdated, Since: 2026-02-06. Removed: 2026-08-06. Issue to remove: WEB-40569. Use Info instead.
   */
  DegradedPerformance = 'DegradedPerformance',
  /** Info needs to be passed along to customers */
  Info = 'Info',
  /** An incident causes a major outage. Affected component is inoperable */
  MajorOutage = 'MajorOutage',
  /** System status is normal and component is operating normally */
  Operational = 'Operational',
  /** An incident causes a higher priority message to be announced, f.e. by using an orange banner instead of a standard one. */
  Warning = 'Warning'
}

/** Available arguments to filter results when fetching operational status */
export type OperationalStatusFilterArgs = {
  /** Limit results by these components */
  components?: InputMaybe<Array<OperationalStatusComponentId>>;
  /** Limit results by these status */
  status?: InputMaybe<Array<OperationalStatusEnum>>;
};

/** A localized message containing title, description and link. This message is sent when status is Info or DegradedPerformance. Description will always be populated but other fields can be null. */
export type OperationalStatusMessage = {
  __typename: 'OperationalStatusMessage';
  /** Basic information about the incident */
  description: Scalars['String']['output'];
  /** A link to a page with more information */
  link: Maybe<Scalars['String']['output']>;
  /** Title for operation status message */
  title: Maybe<Scalars['String']['output']>;
};

export type OperationalStatusMessageWithLanguage = {
  __typename: 'OperationalStatusMessageWithLanguage';
  langKey: Scalars['String']['output'];
  message: OperationalStatusMessage;
};

export type OptOutOfCampaignInput = {
  /** The id of the campaign the user who wants to opt out of. */
  campaignId: Scalars['String']['input'];
};

export type OrderAukakronurCardInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  place?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBuyAccountNotAllowed = Error & {
  __typename: 'OrderBuyAccountNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum OrderByDirection {
  Asc = 'Asc',
  Desc = 'Desc'
}

export type OrderGiftCardInput = {
  amountOnEachCard: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /**  The name of the person who filled out the form on behalf of the company */
  employeeName?: InputMaybe<Scalars['String']['input']>;
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberOfGiftCards: Scalars['Int']['input'];
  phoneNumber: Scalars['String']['input'];
  /** Place of delivery, (id of Landsbanki Branch form servicePoint node) */
  servicePointId?: InputMaybe<Scalars['String']['input']>;
  withdrawalAccountNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum OriginOfFunds {
  Dividends = 'Dividends',
  EquityContribution = 'EquityContribution',
  Foreign = 'Foreign',
  Grants = 'Grants',
  Inheritance = 'Inheritance',
  Loan = 'Loan',
  OperatingRevenue = 'OperatingRevenue',
  Other = 'Other',
  Profit = 'Profit',
  Salary = 'Salary',
  SecuritiesTransactions = 'SecuritiesTransactions',
  UNKNOWN = 'UNKNOWN'
}

/** Access level to set for all matching account permissions in a bulk update. Supports `COPY_FROM_USER`; requires `copyFromUsername` to be provided when used. */
export enum OverallAccountAccessLevel {
  COPY_FROM_USER = 'COPY_FROM_USER',
  FULL = 'FULL',
  NONE = 'NONE',
  READ_ONLY = 'READ_ONLY'
}

/** Overall account permission update configuration */
export type OverallAccountUpdateInput = {
  /** Username to copy access from (required when setAccessAs = copyFromUser) */
  copyFromUsername?: InputMaybe<Scalars['String']['input']>;
  /** Account display number (required when updateType = byAccount) */
  displayNumber?: InputMaybe<Scalars['String']['input']>;
  /** Access level to set for all matching permissions */
  setAccessAs: OverallAccountAccessLevel;
  /** Type of bulk update operation */
  updateType: AccountUpdateType;
  /** Username (required when updateType = byUser) */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Access level to set for all matching card permissions in a bulk update. Supports `COPY_FROM_USER`; requires `copyFromUsername` to be provided when used. */
export enum OverallCardAccessLevel {
  COPY_FROM_USER = 'COPY_FROM_USER',
  NONE = 'NONE',
  READ_ONLY = 'READ_ONLY'
}

/** Overall card permission update configuration */
export type OverallCardUpdateInput = {
  /** Card ID (Global) (required when updateType = byCard) */
  cardId?: InputMaybe<Scalars['ID']['input']>;
  /** Username to copy access from (required when setAccessAs = copyFromUser) */
  copyFromUsername?: InputMaybe<Scalars['String']['input']>;
  /** Access level to set for all matching permissions */
  setAccessAs: OverallCardAccessLevel;
  /** Type of bulk update operation */
  updateType: CardUpdateType;
  /** Username (required when updateType = byUser) */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Access level to set for all matching service permissions in a bulk update. Supports `COPY_FROM_USER`; requires `copyFromUsername` to be provided when used. */
export enum OverallServiceAccessLevel {
  COPY_FROM_USER = 'COPY_FROM_USER',
  FULL = 'FULL',
  NONE = 'NONE'
}

/** Overall service permission update configuration */
export type OverallServiceUpdateInput = {
  /** Username to copy access from (required when setAccessAs = copyFromUser) */
  copyFromUsername?: InputMaybe<Scalars['String']['input']>;
  /** Service type ID (required when updateType = byService) */
  serviceTypeId?: InputMaybe<Scalars['Int']['input']>;
  /** Access level to set for all matching permissions */
  setAccessAs: OverallServiceAccessLevel;
  /** Type of bulk update operation */
  updateType: ServiceUpdateType;
  /** Username (required when updateType = byUser) */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** An overdraft application */
export type OverdraftApplication = {
  __typename: 'OverdraftApplication';
  /** The bank account associated with the overdraft application */
  account: Maybe<Account>;
  /** The current balance of the account */
  accountBalance: Maybe<Scalars['Float']['output']>;
  /** The number of the account behind this application */
  accountNumber: Scalars['String']['output'];
  /** The current overdraft amount for the account */
  currentAmount: Scalars['Float']['output'];
  /** Indicates whether the requested overdraft amount can be automatically covered (insured) by the current collaterals. The current collaterals must be of the real estate mortgage arrangement type "general" */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  /** The end date for the overdraft */
  dateTo: Scalars['DateTimeISO']['output'];
  /** The interest rate, a number that represents a percentage, e.g. a value of "17" would represent "17%" */
  interestRate: Scalars['Float']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  /** ID of the loan application */
  loanApplicationId: Scalars['String']['output'];
  /** The amount (of money) requested for the overdraft */
  requestedAmount: Scalars['Float']['output'];
  /** The status of the loan application, as given by the API. We cannot modify the value of this field. An active overdraft application will always have the status "inProgressByApplicant". */
  status: LoanApplicationStatus;
};

/** A wrapper for multiple overdraft applications. Required for union with LoanAccessForbidden error */
export type OverdraftApplications = {
  __typename: 'OverdraftApplications';
  /** A list of overdraft applications */
  overdraftApplications: Array<OverdraftApplication>;
};

export enum OverdraftDuration {
  Month = 'Month',
  NineMonths = 'NineMonths',
  SixMonths = 'SixMonths',
  ThreeMonths = 'ThreeMonths',
  TwoMonths = 'TwoMonths',
  Year = 'Year'
}

export type OverdraftLoanApplication = LoanApplication & Node & {
  __typename: 'OverdraftLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  /** This field is currently used for corporate overdraft only. It indicates whether the current user can use surety bonds and if risk rating is missing. For freelance users this will always return SURETY_BOND_NOT_ALLOWED. */
  creditScoreRiskRatingResult: Maybe<CreditScoreRiskRatingResultType>;
  /** This field is currently used for corporate overdraft only. It indicates whether the requested amount for the overdraft loan application can be covered (insured) by existing collaterals. Currently, only truthful if there exists an "allsherjarveð í fasteign", with an unused value that exceeds the requested loan amount. */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** This field is currently used for corporate overdraft only. It returns surety guarantors (ábyrgðaraðilar) on an overdraft loan application. The list of guarantors is ordered with the main applicant as the first guarantor in the list. */
  guarantors: Maybe<Array<LoanApplicationGuarantor>>;
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. It indicates whether the applications could theoretically be automatically approved, as opposed to explicitly requiring manual approval. A true value does not always result in automatic approval, as there are other factors, but a false value will always result in manual approval. For freelance users this is always false. */
  isWithinPreApprovedAllowedLimits: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. Checks the company pre approved limit with the Surety product and new loan amount to determine whether the loan amount is within limits for a new surety collateral. For freelance users this is always false. */
  isWithinPreApprovedSuretyAllowedLimits: Maybe<Scalars['Boolean']['output']>;
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  overdraft: OverdraftLoanBond;
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  /** This field is currently used for corporate overdraft only. It returns the calculated fee for surety (sjálfskuldarábyrgð) on an overdraft loan application. */
  suretyCollateralFee: Maybe<CurrencyAmount>;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


export type OverdraftLoanApplicationCreditScoreRiskRatingResultArgs = {
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
};


export type OverdraftLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

export type OverdraftLoanBond = {
  __typename: 'OverdraftLoanBond';
  accountName: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountOwnerKennitala: Scalars['String']['output'];
  accountOwnerName: Scalars['String']['output'];
  averageMonthlyPayment: Scalars['Float']['output'];
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  currentAmount: Scalars['Float']['output'];
  dateFrom: Maybe<Scalars['DateTimeISO']['output']>;
  dateTo: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  interestRate: Scalars['Float']['output'];
  maxInterestRateLast20Years: Maybe<Scalars['Float']['output']>;
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  monthlyInterestPayment: Scalars['Float']['output'];
  requestedAmount: Scalars['Float']['output'];
  yearlyCostRatio: Scalars['Float']['output'];
};

/** The restrictions and limits placed on applying for an overdraft */
export type OverdraftRestrictions = {
  __typename: 'OverdraftRestrictions';
  /** Maximum amount for the overdraft. In case of null, there is no limit set. */
  maxAmount: Maybe<Scalars['Float']['output']>;
  /** The maximum duration for the loan. In case of null, this should not be used as a reference, as all loans should have some time limit. */
  maxDurationMonths: Maybe<Scalars['Int']['output']>;
};

export type OverdraftToBondLoanApplication = LoanApplication & Node & {
  __typename: 'OverdraftToBondLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  bond: LoanApplicationBond;
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  /** This field is currently used for corporate overdraft only. It indicates whether the current user can use surety bonds and if risk rating is missing. For freelance users this will always return SURETY_BOND_NOT_ALLOWED. */
  creditScoreRiskRatingResult: Maybe<CreditScoreRiskRatingResultType>;
  /** This field is currently used for corporate overdraft only. It indicates whether the requested amount for the overdraft loan application can be covered (insured) by existing collaterals. Currently, only truthful if there exists an "allsherjarveð í fasteign", with an unused value that exceeds the requested loan amount. */
  currentCollateralsCanInsureOverdraft: Scalars['Boolean']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** This field is currently used for corporate overdraft only. It returns surety guarantors (ábyrgðaraðilar) on an overdraft loan application. The list of guarantors is ordered with the main applicant as the first guarantor in the list. */
  guarantors: Maybe<Array<LoanApplicationGuarantor>>;
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  /** This field is currently used for corporate overdraft only. It indicates whether the applications could theoretically be automatically approved, as opposed to explicitly requiring manual approval. A true value does not always result in automatic approval, as there are other factors, but a false value will always result in manual approval. For freelance users this is always false. */
  isWithinPreApprovedAllowedLimits: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  overdraft: OverdraftLoanBond;
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  /** This field is currently used for corporate overdraft only. It returns the calculated fee for surety (sjálfskuldarábyrgð) on an overdraft loan application. */
  suretyCollateralFee: Maybe<CurrencyAmount>;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


export type OverdraftToBondLoanApplicationCreditScoreRiskRatingResultArgs = {
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
};


export type OverdraftToBondLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

export type OwnServicesAuthorizationFilter = {
  /** Filter services by their types */
  serviceTypes?: InputMaybe<Array<AuthorizationServiceType>>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaidLeaveAccountConnectionv2 = {
  __typename: 'PaidLeaveAccountConnectionv2';
  edges: Array<PaidLeaveAccountv2Edge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaidLeaveAccountError = {
  __typename: 'PaidLeaveAccountError';
  errorType: PaidLeaveAccountErrorType;
  line: Maybe<Scalars['Int']['output']>;
};

/** ErrorType */
export enum PaidLeaveAccountErrorType {
  AccountDestroyed = 'AccountDestroyed',
  AccountIdDoesNotExist = 'AccountIdDoesNotExist',
  AccountNumberIsNotTwelveDigitsLong = 'AccountNumberIsNotTwelveDigitsLong',
  DepositNotAllowed = 'DepositNotAllowed',
  EmployerIdMissing = 'EmployerIdMissing',
  ErrorCreatingNewAccountsRB = 'ErrorCreatingNewAccountsRB',
  ErrorValidating = 'ErrorValidating',
  ExcelColumnMustContainData = 'ExcelColumnMustContainData',
  InvalidCurrency = 'InvalidCurrency',
  InvalidValue = 'InvalidValue',
  KTHasBeenSentInTheLast30Days = 'KTHasBeenSentInTheLast30Days',
  KTIsNotAnIndividual = 'KTIsNotAnIndividual',
  KTIsNotTenDigitsLong = 'KTIsNotTenDigitsLong',
  MaximumNumberOfRows = 'MaximumNumberOfRows',
  MoreColumnsThanExpected = 'MoreColumnsThanExpected',
  OwnerIdDoesNotMatchAccountOwnerId = 'OwnerIdDoesNotMatchAccountOwnerId',
  TheNameOfTheHeaderColumnIsNotCorrect = 'TheNameOfTheHeaderColumnIsNotCorrect',
  UnknownError = 'UnknownError'
}

export type PaidLeaveAccountResponse = CreatePaidLeaveAccountPayload | CreatePaidLeaveAccountsErrorPayload | CreatePaidLeaveAccountsPayload;

export type PaidLeaveAccountsOrderBy = {
  direction: OrderByDirection;
  field: PaidLeaveAccountsOrderByOption;
};

/** Options for ordering paid leave accounts */
export enum PaidLeaveAccountsOrderByOption {
  /** Order by account number */
  ACCOUNT_NUMBER = 'ACCOUNT_NUMBER',
  /** Order by creation date */
  CREATION_DATE = 'CREATION_DATE',
  /** Order by owner kennitala */
  OWNER_KENNITALA = 'OWNER_KENNITALA',
  /** Order by owner name */
  OWNER_NAME = 'OWNER_NAME'
}

/** Orlofsreikningar og status á stofnun */
export type PaidLeaveAccountsv2 = {
  __typename: 'PaidLeaveAccountsv2';
  accounts: PaidLeaveAccountConnectionv2;
  created: Maybe<Scalars['Boolean']['output']>;
};


/** Orlofsreikningar og status á stofnun */
export type PaidLeaveAccountsv2AccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaidLeaveAccountsOrderBy>;
};

/** Orlofsreikningur */
export type PaidLeaveAccountv2 = Node & {
  __typename: 'PaidLeaveAccountv2';
  accountId: Scalars['String']['output'];
  created: Scalars['DateTimeISO']['output'];
  depositAccountId: Maybe<Scalars['String']['output']>;
  employerId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ownerId: Scalars['String']['output'];
  ownerName: Maybe<Scalars['String']['output']>;
};

export type PaidLeaveAccountv2Edge = {
  __typename: 'PaidLeaveAccountv2Edge';
  cursor: Scalars['String']['output'];
  node: PaidLeaveAccountv2;
};

export type PayScheduledPaymentInput = {
  id: Scalars['ID']['input'];
};

export type PayScheduledPaymentPayload = {
  __typename: 'PayScheduledPaymentPayload';
  payment: Payment;
};

export type PayScheduledPaymentResponse = AmountUnavailable | ClaimDoesNotExistCanBeAlreadyPaidOrDeleted | CreatePaymentScaResponse | PayScheduledPaymentPayload | PaymentNotFound;

export type Payment = Node & PaymentInterface & {
  __typename: 'Payment';
  /** Can current user perform this payment again with same input? */
  canReusePayment: Scalars['Boolean']['output'];
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Detailed payment object depending on its type */
  detailedPayment: Maybe<DetailedPaymentUnion>;
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** Payment supports notifications */
  isNotificationsAllowed: Scalars['Boolean']['output'];
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Previously used notification messages for similar payments */
  paymentNotificationMessages: Maybe<Array<Scalars['String']['output']>>;
  /** Previously used notification recipients for similar payments */
  paymentNotificationRecipients: Maybe<Array<Scalars['String']['output']>>;
  /** Notifications sent regarding the payment */
  paymentNotifications: Maybe<Array<PaymentNotification>>;
  /** Receipt for the payment */
  receipt: Maybe<DocumentBucket>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

/** Unable to get exchange rate when both the account currency and the payment currency are the same */
export type PaymentAndAccountCurrenciesAreTheSame = Error & {
  __typename: 'PaymentAndAccountCurrenciesAreTheSame';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum PaymentApplicationCode {
  /** The payment was performed in the app */
  APP = 'APP',
  /** The payment was performed through B2B */
  B2B = 'B2B',
  /** The payment was performed through the corporate bank (fbl.is) */
  CORPORATE_BANK = 'CORPORATE_BANK',
  /** The payment was performed through an unknown application */
  UNKNOWN = 'UNKNOWN'
}

/** The approval process of a payment */
export type PaymentApproval = Node & {
  __typename: 'PaymentApproval';
  /** Payment approval process id for more details */
  approvalProcessId: Scalars['String']['output'];
  /** List of those who have approved the payment */
  approvals: Array<PaymentApprovalApprover>;
  id: Scalars['ID']['output'];
  /** List of those who have the permissions required to approve the payment */
  possibleApprovals: Array<PaymentApprovalApprover>;
  requiredTypes: Array<PaymentApprovalRequiredApproval>;
  /**
   * The status of the payment's approval process (NOT_STARTED, IN_PROGRESS, COMPLETED, REJECTED).
   * Payment can be paid once reaching the required number of approvals, representing the COMPLETED status
   */
  status: PaymentApprovalStatus;
  /** The total number of approvers that have approved the payment */
  totalApprovers: Scalars['Int']['output'];
  /** The total number of approvers required to approve the payment */
  totalApproversRequired: Scalars['Int']['output'];
};

export type PaymentApprovalApprover = {
  __typename: 'PaymentApprovalApprover';
  /** The date the approver approved the payment */
  approvalDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The type of approval the approver can provide */
  approvalType: PaymentApprovalType;
  /** The full name of the approver */
  name: Scalars['String']['output'];
  /** The username of the approver */
  username: Scalars['String']['output'];
};

/** Approval process that was not successfully updated */
export type PaymentApprovalError = {
  __typename: 'PaymentApprovalError';
  approvalProcessId: Scalars['String']['output'];
  errorSubject: PaymentApprovalErrorSubject;
};

/** The subject of the payment approval error */
export enum PaymentApprovalErrorSubject {
  /** The approval was not found */
  APPROVAL_NOT_FOUND = 'APPROVAL_NOT_FOUND',
  /** Amount exceeds the currency exchange limits */
  CURRENCY_QUOTE_AMOUNT_UNAUTHORIZED = 'CURRENCY_QUOTE_AMOUNT_UNAUTHORIZED',
  /** Currency exchange market is closed */
  CURRENCY_QUOTE_MARKET_IS_CLOSED = 'CURRENCY_QUOTE_MARKET_IS_CLOSED',
  /** User does not have permission to perform this action */
  INSUFFICIENT_PRIVILEGES = 'INSUFFICIENT_PRIVILEGES',
  /** The payment approval process was not found */
  PROCESS_NOT_FOUND = 'PROCESS_NOT_FOUND',
  /** An unknown error occurred */
  UNKNOWN = 'UNKNOWN'
}

/** Approval process that was not successfully initiated */
export type PaymentApprovalProcessError = {
  __typename: 'PaymentApprovalProcessError';
  errorSubject: PaymentApprovalProcessErrorSubject;
  /** The id of the payment */
  paymentId: Scalars['ID']['output'];
};

/** The subject of the payment approval process error */
export enum PaymentApprovalProcessErrorSubject {
  /** User does not have permission to perform this action */
  INSUFFICIENT_PRIVILEGES = 'INSUFFICIENT_PRIVILEGES',
  /** The payment was not found */
  PAYMENT_NOT_FOUND = 'PAYMENT_NOT_FOUND',
  PROCESS_ALREADY_EXISTS = 'PROCESS_ALREADY_EXISTS',
  /** An unknown error occurred */
  UNKNOWN = 'UNKNOWN'
}

export type PaymentApprovalProcessInput = {
  amount: CurrencyAmountInput;
  instructionType: StoredPaymentInstructionType;
  paymentId: Scalars['ID']['input'];
};

export type PaymentApprovalRequiredApproval = {
  __typename: 'PaymentApprovalRequiredApproval';
  /**
   * The type of approval required. A, B or C.
   * A can accept A, B and C
   * B can accept B and C
   * C can accept C
   */
  approvalType: PaymentApprovalType;
  /** The number of approvals received of this type */
  approvalsReceived: Scalars['Int']['output'];
  /** The number of approvals remaining of this type */
  approvalsRemaining: Scalars['Int']['output'];
  /** The number of approvals required of this type */
  approvalsRequired: Scalars['Int']['output'];
};

/** The status of the payment approval process */
export enum PaymentApprovalStatus {
  /** The approval process has been completed with all required approvals */
  COMPLETED = 'COMPLETED',
  /** The approval process is in progress and awaiting approvals */
  IN_PROGRESS = 'IN_PROGRESS',
  /** The approval process has not started */
  NOT_STARTED = 'NOT_STARTED',
  /** The approval process has been rejected */
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

/** The type of the payment approval */
export enum PaymentApprovalType {
  /** Type A can accept A, B, and C */
  A = 'A',
  /** Type B can accept B and C */
  B = 'B',
  /** Type C can only accept C */
  C = 'C'
}

/** An initiated and saved payment batch */
export type PaymentBatch = Node & {
  __typename: 'PaymentBatch';
  /** The total amount paid */
  amountPaid: CurrencyAmount;
  /** The name of the payment batch */
  batchName: Scalars['String']['output'];
  batchType: PaymentBatchType;
  /** Can current user fetch receipt for this payment batch */
  canViewBreakdown: Scalars['Boolean']['output'];
  /** Error message for user indicating why batch can not be paid */
  errorMessage: Maybe<Scalars['String']['output']>;
  /** The number of payments that have an error */
  errorPaymentCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Does the batch include crossborder payments */
  includesCrossborderPayments: Scalars['Boolean']['output'];
  /** Is the payment batch an aggregate payment (multiple payments combined into a single transaction) */
  isAggregate: Scalars['Boolean']['output'];
  /** Is the payment batch disclosed in the statement (pa are hidden) */
  isDisclosedInStatement: Scalars['Boolean']['output'];
  /** The number of payments that have been paid */
  paidPaymentCount: Scalars['Int']['output'];
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  /** Payment date for payments in batch */
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** Date when payment batch was initiated (Date of creation) */
  paymentInitiationDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** The payments for inside of the payment batch, returns null if the user does not have access to the payments */
  paymentsV2: Maybe<Array<PaymentBatchPaymentsUnion>>;
  pisId: Scalars['String']['output'];
  /** The debtor account number used to pay the batch. Only available if the batch is paid as a single withdrawal */
  singleWithdrawalAccountNumber: Maybe<Scalars['String']['output']>;
  /** The payment status of the payment batch */
  status: Maybe<PaymentStatus>;
  /** The number of payments that are suspended */
  suspendedPaymentCount: Scalars['Int']['output'];
  /** The total amount of the payment batch */
  totalAmount: CurrencyAmount;
  /** The total amount on error */
  totalAmountOnError: Maybe<CurrencyAmount>;
  /** The total amount to be paid, (totalAmount - totalAmountOnError) */
  totalAmountToBePaid: Maybe<CurrencyAmount>;
  /** The total number of payments in the batch */
  totalPaymentCount: Scalars['Int']['output'];
};


/** An initiated and saved payment batch */
export type PaymentBatchPaymentsV2Args = {
  filter?: InputMaybe<PaymentBatchPaymentsInput>;
};

export type PaymentBatchConnection = {
  __typename: 'PaymentBatchConnection';
  edges: Array<PaymentBatchEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentBatchEdge = {
  __typename: 'PaymentBatchEdge';
  cursor: Scalars['String']['output'];
  node: PaymentBatch;
};

/** The initiation process of an uploaded batch file */
export type PaymentBatchFileInitiation = Node & {
  __typename: 'PaymentBatchFileInitiation';
  /** The error subject of the initiation, e.g. if the file is invalid or to many payments have errors */
  errorSubject: Maybe<PaymentBatchInitiationErrorSubject>;
  /** The errors of the payment batch file */
  errors: Array<PaymentBatchFileRowError>;
  id: Scalars['ID']['output'];
  /** The processed payment batch */
  paymentBatch: PaymentBatch;
  /** The processing status of the uploaded payment batch file */
  status: PaymentBatchFileStatus;
};

/** The error subjects of a payment row in an uploaded batch file */
export type PaymentBatchFileRowError = {
  __typename: 'PaymentBatchFileRowError';
  /** The error subjects of the row, can be more than one */
  errorSubjects: Array<PaymentBatchRowErrorSubject>;
  /** The number of the row that has an error */
  paymentNumber: Scalars['Int']['output'];
};

/** Status of the processing of a payment batch file */
export enum PaymentBatchFileStatus {
  /** No status */
  NONE = 'NONE',
  /** The file has been processed */
  PROCESSED = 'PROCESSED',
  /** The file is being processed */
  PROCESSING = 'PROCESSING',
  /** The file has been rejected */
  REJECTED = 'REJECTED',
  /** The status is unknown */
  UNKNOWN = 'UNKNOWN'
}

export type PaymentBatchFilterArgs = {
  /** Payment amount from filter */
  amountFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Payment amount to filter */
  amountTo?: InputMaybe<Scalars['Float']['input']>;
  /** Filters by application channel (app/corporate bank/b2b) */
  applicationCode?: InputMaybe<PaymentApplicationCode>;
  /** Payment date from filter */
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Payment date to filter */
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Filter by debtor account number */
  debtorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment currency */
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the kennitala of the payor */
  payorKennitala?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentBatchSearchStatus>;
  /** Filters for certain batch name */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** Filter by username of person that performed the payment batch */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Subject of a payment batch error. This enum also includes values from the PaymentBatchRowErrorSubject enum, as the first two rows (at least) can cause initiation errors */
export enum PaymentBatchInitiationErrorSubject {
  /** The account and payment currency mismatch */
  ACCOUNT_AND_PAYMENT_CURRENCY_MISMATCH = 'ACCOUNT_AND_PAYMENT_CURRENCY_MISMATCH',
  /** The aggregated account does not match the payments */
  AGGREGATED_ACCOUNT_DOESNT_MATCH_PAYMENTS = 'AGGREGATED_ACCOUNT_DOESNT_MATCH_PAYMENTS',
  /** The amount is not in numeric format */
  AMOUNT_IS_NOT_IN_NUMERIC_FORMAT = 'AMOUNT_IS_NOT_IN_NUMERIC_FORMAT',
  /** The amount must be positive */
  AMOUNT_MUST_BE_POSITIVE = 'AMOUNT_MUST_BE_POSITIVE',
  /** The user is not authorised to perform the action */
  AUTHORISATION_DENIED = 'AUTHORISATION_DENIED',
  /** The payment batch was not found */
  BATCH_NOT_FOUND = 'BATCH_NOT_FOUND',
  /** The status of the batch does not allow adding payments */
  BATCH_STATUS_NOT_ALLOWING_ADD_PAYMENTS = 'BATCH_STATUS_NOT_ALLOWING_ADD_PAYMENTS',
  CHECK_DEBTOR_ACCOUNT_ACCESS = 'CHECK_DEBTOR_ACCOUNT_ACCESS',
  DEPOSIT_NOT_ALLOWED = 'DEPOSIT_NOT_ALLOWED',
  /** The description must be less or equals 140 characters */
  DESCRIPTION_MUST_BE_LESS_OR_EQUALS_140_CHARACTERS = 'DESCRIPTION_MUST_BE_LESS_OR_EQUALS_140_CHARACTERS',
  /** The end-to-end identification must be less or equals 35 characters */
  END_TO_END_IDENTIFICATION_MUST_BE_LESS_OR_EQUALS_35_CHARACTERS = 'END_TO_END_IDENTIFICATION_MUST_BE_LESS_OR_EQUALS_35_CHARACTERS',
  /** The fee account must be equal to the debtor account */
  FEE_ACCOUNT_MUST_BE_EQUAL_DEBTOR_ACCOUNT = 'FEE_ACCOUNT_MUST_BE_EQUAL_DEBTOR_ACCOUNT',
  /** Cross payments in the future are not allowed */
  FUTURE_CROSS_PAYMENT_NOT_ALLOWED = 'FUTURE_CROSS_PAYMENT_NOT_ALLOWED',
  /** The IBAN duplicates the kennitala */
  IBAN_DUPLICATES_KENNITALA = 'IBAN_DUPLICATES_KENNITALA',
  /** There is insufficient balance in the cashpool account */
  INSUFFICIENT_CASHPOOL_BALANCE = 'INSUFFICIENT_CASHPOOL_BALANCE',
  /** The status of the batch is invalid */
  INVALID_BATCH_STATUS = 'INVALID_BATCH_STATUS',
  /** ISK amounts may not have a decimal fraction */
  ISK_AMOUNTS_MAY_NOT_HAVE_A_DECIMAL_FRACTION = 'ISK_AMOUNTS_MAY_NOT_HAVE_A_DECIMAL_FRACTION',
  /** The kennitala is missed */
  MISSED_KENNITALA = 'MISSED_KENNITALA',
  /** The number of payment entries is not in numeric format */
  NUMBER_OF_PAYMENT_ENTRIES_IS_NOT_IN_NUMERIC_FORMAT = 'NUMBER_OF_PAYMENT_ENTRIES_IS_NOT_IN_NUMERIC_FORMAT',
  /** The payment types in the file are not supported */
  PAIN001_UNSUPPORTED_PAYMENT_TYPES = 'PAIN001_UNSUPPORTED_PAYMENT_TYPES',
  /** The payments have different currencies */
  PAYMENTS_CURRENCY_MISMATCH = 'PAYMENTS_CURRENCY_MISMATCH',
  /** The payments need to be approved before they can be executed */
  PAYMENT_APPROVAL_REQUIRED_BEFORE_EXECUTION = 'PAYMENT_APPROVAL_REQUIRED_BEFORE_EXECUTION',
  /** The total number of payments in the file is incorrect */
  SI080_INCORRECT_TOTAL_NUMBER_OF_PAYMENTS = 'SI080_INCORRECT_TOTAL_NUMBER_OF_PAYMENTS',
  /** The total amount of payments in the file is incorrect */
  SI080_INCORRECT_TOTAL_PAYMENTS_AMOUNT = 'SI080_INCORRECT_TOTAL_PAYMENTS_AMOUNT',
  /** Multiple batch names are specified in the file */
  SI080_MULTIPLE_BATCH_NAMES_SPECIFIED = 'SI080_MULTIPLE_BATCH_NAMES_SPECIFIED',
  /** The payment types in the file are not supported */
  SI080_UNSUPPORTED_PAYMENT_TYPES = 'SI080_UNSUPPORTED_PAYMENT_TYPES',
  /** Too many errors occurred */
  TOO_MANY_ERRORS = 'TOO_MANY_ERRORS',
  /** The amount could not be parsed */
  UNABLE_PARSE_AMOUNT = 'UNABLE_PARSE_AMOUNT',
  /** The bank city could not be parsed */
  UNABLE_PARSE_BANK_CITY = 'UNABLE_PARSE_BANK_CITY',
  /** The bank postal code could not be parsed */
  UNABLE_PARSE_BANK_POSTAL_CODE = 'UNABLE_PARSE_BANK_POSTAL_CODE',
  /** The bill number could not be parsed */
  UNABLE_PARSE_BILLNUMBER = 'UNABLE_PARSE_BILLNUMBER',
  /** The category code could not be parsed */
  UNABLE_PARSE_CATEGORY_CODE = 'UNABLE_PARSE_CATEGORY_CODE',
  /** The creditor account number could not be parsed */
  UNABLE_PARSE_CREDITOR_ACCOUNT_NUMBER = 'UNABLE_PARSE_CREDITOR_ACCOUNT_NUMBER',
  /** The currency code could not be parsed */
  UNABLE_PARSE_CURRENCY_CODE = 'UNABLE_PARSE_CURRENCY_CODE',
  /** The debtor account number could not be parsed */
  UNABLE_PARSE_DEBTOR_ACCOUNT_NUMBER = 'UNABLE_PARSE_DEBTOR_ACCOUNT_NUMBER',
  /** The debtor kennitala could not be parsed */
  UNABLE_PARSE_DEBTOR_KENNITALA = 'UNABLE_PARSE_DEBTOR_KENNITALA',
  /** The description could not be parsed */
  UNABLE_PARSE_DESCRIPTION = 'UNABLE_PARSE_DESCRIPTION',
  /** The due date could not be parsed */
  UNABLE_PARSE_DUE_DATE = 'UNABLE_PARSE_DUE_DATE',
  /** The email could not be parsed */
  UNABLE_PARSE_EMAIL = 'UNABLE_PARSE_EMAIL',
  /** The end-to-end identification could not be parsed */
  UNABLE_PARSE_END_TO_END_IDENTIFICATION = 'UNABLE_PARSE_END_TO_END_IDENTIFICATION',
  /** The fee account number could not be parsed */
  UNABLE_PARSE_FEE_ACCOUNT_NUMBER = 'UNABLE_PARSE_FEE_ACCOUNT_NUMBER',
  /** The kennitala could not be parsed */
  UNABLE_PARSE_KENNITALA = 'UNABLE_PARSE_KENNITALA',
  /** The number of payment entries could not be parsed */
  UNABLE_PARSE_NUMBER_OF_PAYMENT_ENTRIES = 'UNABLE_PARSE_NUMBER_OF_PAYMENT_ENTRIES',
  /** The payment type could not be parsed */
  UNABLE_PARSE_PAYMENT_TYPE = 'UNABLE_PARSE_PAYMENT_TYPE',
  /** The remittance information unstructured could not be parsed */
  UNABLE_PARSE_REMITTANCE_INFORMATION_UNSTRUCTURED = 'UNABLE_PARSE_REMITTANCE_INFORMATION_UNSTRUCTURED',
  /** The required execution date could not be parsed */
  UNABLE_PARSE_REQD_EXCTN_DT = 'UNABLE_PARSE_REQD_EXCTN_DT',
  /** The ultimate name could not be parsed */
  UNABLE_PARSE_ULTIMATE_NAME = 'UNABLE_PARSE_ULTIMATE_NAME',
  /** The status of the batch could not be changed */
  UNABLE_TO_CHANGE_BATCH_STATUS = 'UNABLE_TO_CHANGE_BATCH_STATUS',
  /** The file could not be parsed */
  UNABLE_TO_PARSE_FILE = 'UNABLE_TO_PARSE_FILE',
  UNKNOWN = 'UNKNOWN',
  /** The payment type is not supported */
  UNSUPPORTED_PAYMENT_TYPE = 'UNSUPPORTED_PAYMENT_TYPE',
  /** The creditor account number has the wrong format */
  WRONG_FORMAT_CREDITOR_ACCOUNT_NUMBER = 'WRONG_FORMAT_CREDITOR_ACCOUNT_NUMBER',
  /** The debtor account number has the wrong format */
  WRONG_FORMAT_DEBTOR_ACCOUNT_NUMBER = 'WRONG_FORMAT_DEBTOR_ACCOUNT_NUMBER',
  /** The debtor kennitala has the wrong format */
  WRONG_FORMAT_DEBTOR_KENNITALA = 'WRONG_FORMAT_DEBTOR_KENNITALA',
  /** The due date has the wrong format */
  WRONG_FORMAT_DUE_DATE = 'WRONG_FORMAT_DUE_DATE',
  /** The kennitala has the wrong format */
  WRONG_FORMAT_KENNITALA = 'WRONG_FORMAT_KENNITALA'
}

/** Input for payments in payment batches */
export type PaymentBatchPaymentsInput = {
  status?: InputMaybe<PaymentBatchPaymentsStatus>;
};

/** Status of payments in payment batch */
export enum PaymentBatchPaymentsStatus {
  /** Return all payments in payment batch, regardless of status */
  ALL = 'ALL',
  /** Only return payments that have failed in payment batch */
  ERROR = 'ERROR',
  /** Only return successful payments in payment batch */
  SUCCESS = 'SUCCESS'
}

export type PaymentBatchPaymentsUnion = ClaimPayment | CreditTransfer;

/** Subject of a payment batch row error */
export enum PaymentBatchRowErrorSubject {
  /** The account and payment currency mismatch */
  ACCOUNT_AND_PAYMENT_CURRENCY_MISMATCH = 'ACCOUNT_AND_PAYMENT_CURRENCY_MISMATCH',
  /** The amount is not in numeric format */
  AMOUNT_IS_NOT_IN_NUMERIC_FORMAT = 'AMOUNT_IS_NOT_IN_NUMERIC_FORMAT',
  /** The amount must be positive */
  AMOUNT_MUST_BE_POSITIVE = 'AMOUNT_MUST_BE_POSITIVE',
  CHECK_DEBTOR_ACCOUNT_ACCESS = 'CHECK_DEBTOR_ACCOUNT_ACCESS',
  DEPOSIT_NOT_ALLOWED = 'DEPOSIT_NOT_ALLOWED',
  /** The description must be less or equals 140 characters */
  DESCRIPTION_MUST_BE_LESS_OR_EQUALS_140_CHARACTERS = 'DESCRIPTION_MUST_BE_LESS_OR_EQUALS_140_CHARACTERS',
  /** The end-to-end identification must be less or equals 35 characters */
  END_TO_END_IDENTIFICATION_MUST_BE_LESS_OR_EQUALS_35_CHARACTERS = 'END_TO_END_IDENTIFICATION_MUST_BE_LESS_OR_EQUALS_35_CHARACTERS',
  /** The fee account must be equal to the debtor account */
  FEE_ACCOUNT_MUST_BE_EQUAL_DEBTOR_ACCOUNT = 'FEE_ACCOUNT_MUST_BE_EQUAL_DEBTOR_ACCOUNT',
  /** The IBAN duplicates the kennitala */
  IBAN_DUPLICATES_KENNITALA = 'IBAN_DUPLICATES_KENNITALA',
  /** ISK amounts may not have a decimal fraction */
  ISK_AMOUNTS_MAY_NOT_HAVE_A_DECIMAL_FRACTION = 'ISK_AMOUNTS_MAY_NOT_HAVE_A_DECIMAL_FRACTION',
  /** The kennitala is missed */
  MISSED_KENNITALA = 'MISSED_KENNITALA',
  /** The number of payment entries is not in numeric format */
  NUMBER_OF_PAYMENT_ENTRIES_IS_NOT_IN_NUMERIC_FORMAT = 'NUMBER_OF_PAYMENT_ENTRIES_IS_NOT_IN_NUMERIC_FORMAT',
  /** The amount could not be parsed */
  UNABLE_PARSE_AMOUNT = 'UNABLE_PARSE_AMOUNT',
  /** The bank city could not be parsed */
  UNABLE_PARSE_BANK_CITY = 'UNABLE_PARSE_BANK_CITY',
  /** The bank postal code could not be parsed */
  UNABLE_PARSE_BANK_POSTAL_CODE = 'UNABLE_PARSE_BANK_POSTAL_CODE',
  /** The bill number could not be parsed */
  UNABLE_PARSE_BILLNUMBER = 'UNABLE_PARSE_BILLNUMBER',
  /** The category code could not be parsed */
  UNABLE_PARSE_CATEGORY_CODE = 'UNABLE_PARSE_CATEGORY_CODE',
  /** The creditor account number could not be parsed */
  UNABLE_PARSE_CREDITOR_ACCOUNT_NUMBER = 'UNABLE_PARSE_CREDITOR_ACCOUNT_NUMBER',
  /** The currency code could not be parsed */
  UNABLE_PARSE_CURRENCY_CODE = 'UNABLE_PARSE_CURRENCY_CODE',
  /** The debtor account number could not be parsed */
  UNABLE_PARSE_DEBTOR_ACCOUNT_NUMBER = 'UNABLE_PARSE_DEBTOR_ACCOUNT_NUMBER',
  /** The debtor kennitala could not be parsed */
  UNABLE_PARSE_DEBTOR_KENNITALA = 'UNABLE_PARSE_DEBTOR_KENNITALA',
  /** The description could not be parsed */
  UNABLE_PARSE_DESCRIPTION = 'UNABLE_PARSE_DESCRIPTION',
  /** The due date could not be parsed */
  UNABLE_PARSE_DUE_DATE = 'UNABLE_PARSE_DUE_DATE',
  /** The email could not be parsed */
  UNABLE_PARSE_EMAIL = 'UNABLE_PARSE_EMAIL',
  /** The end-to-end identification could not be parsed */
  UNABLE_PARSE_END_TO_END_IDENTIFICATION = 'UNABLE_PARSE_END_TO_END_IDENTIFICATION',
  /** The fee account number could not be parsed */
  UNABLE_PARSE_FEE_ACCOUNT_NUMBER = 'UNABLE_PARSE_FEE_ACCOUNT_NUMBER',
  /** The kennitala could not be parsed */
  UNABLE_PARSE_KENNITALA = 'UNABLE_PARSE_KENNITALA',
  /** The number of payment entries could not be parsed */
  UNABLE_PARSE_NUMBER_OF_PAYMENT_ENTRIES = 'UNABLE_PARSE_NUMBER_OF_PAYMENT_ENTRIES',
  /** The payment type could not be parsed */
  UNABLE_PARSE_PAYMENT_TYPE = 'UNABLE_PARSE_PAYMENT_TYPE',
  /** The remittance information unstructured could not be parsed */
  UNABLE_PARSE_REMITTANCE_INFORMATION_UNSTRUCTURED = 'UNABLE_PARSE_REMITTANCE_INFORMATION_UNSTRUCTURED',
  /** The required execution date could not be parsed */
  UNABLE_PARSE_REQD_EXCTN_DT = 'UNABLE_PARSE_REQD_EXCTN_DT',
  /** The ultimate name could not be parsed */
  UNABLE_PARSE_ULTIMATE_NAME = 'UNABLE_PARSE_ULTIMATE_NAME',
  UNKNOWN = 'UNKNOWN',
  /** The payment type is not supported */
  UNSUPPORTED_PAYMENT_TYPE = 'UNSUPPORTED_PAYMENT_TYPE',
  /** The creditor account number has the wrong format */
  WRONG_FORMAT_CREDITOR_ACCOUNT_NUMBER = 'WRONG_FORMAT_CREDITOR_ACCOUNT_NUMBER',
  /** The debtor account number has the wrong format */
  WRONG_FORMAT_DEBTOR_ACCOUNT_NUMBER = 'WRONG_FORMAT_DEBTOR_ACCOUNT_NUMBER',
  /** The debtor kennitala has the wrong format */
  WRONG_FORMAT_DEBTOR_KENNITALA = 'WRONG_FORMAT_DEBTOR_KENNITALA',
  /** The due date has the wrong format */
  WRONG_FORMAT_DUE_DATE = 'WRONG_FORMAT_DUE_DATE',
  /** The kennitala has the wrong format */
  WRONG_FORMAT_KENNITALA = 'WRONG_FORMAT_KENNITALA'
}

/** Status of a payment batch search */
export enum PaymentBatchSearchStatus {
  /** Find all payment batches that have been completed */
  COMPLETED = 'COMPLETED',
  /** Find all payment batches that are scheduled for future payment */
  PENDING = 'PENDING',
  /** Find all payment batches that being processed */
  PROCESSING = 'PROCESSING',
  /** Find all payment batches that have been suspended because of some error */
  SUSPENDED = 'SUSPENDED',
  /** Find all payment batches that are waiting for approval */
  WAITS_APPROVAL = 'WAITS_APPROVAL'
}

/** Type of a payment batch */
export enum PaymentBatchType {
  FOREIGN = 'FOREIGN',
  NONE = 'NONE',
  NORMAL = 'NORMAL',
  SALARY = 'SALARY'
}

export type PaymentByPeriodicPayment = Node & PaymentInterface & {
  __typename: 'PaymentByPeriodicPayment';
  creditorAccount: CreditorAccountType;
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorStatusDescription: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  scheduledPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  scheduledPaymentSequenceNumber: Maybe<Scalars['Float']['output']>;
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export type PaymentByPeriodicPaymentEdge = {
  __typename: 'PaymentByPeriodicPaymentEdge';
  cursor: Scalars['String']['output'];
  node: PaymentByPeriodicPayment;
};

export type PaymentCategoryCode = Node & {
  __typename: 'PaymentCategoryCode';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PaymentCategoryCodeConnection = {
  __typename: 'PaymentCategoryCodeConnection';
  edges: Array<PaymentCategoryCodeEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentCategoryCodeEdge = {
  __typename: 'PaymentCategoryCodeEdge';
  cursor: Scalars['String']['output'];
  node: PaymentCategoryCode;
};

export type PaymentConnection = {
  __typename: 'PaymentConnection';
  edges: Array<PaymentEdge>;
  pageInfo: PageInfo;
  totalAmount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PaymentCreditorAccount = {
  __typename: 'PaymentCreditorAccount';
  /** Details about the bank */
  bankInfo: PaymentParticipantBankInfo;
  /** BIC of the creditor */
  bic: Maybe<Scalars['String']['output']>;
  /** IBAN of the creditor */
  iban: Maybe<Scalars['String']['output']>;
};

export type PaymentDisclaimer = {
  __typename: 'PaymentDisclaimer';
  /** Next bank calendar date according to current date in format YYYY-MM-DD, which excludes time information and resolves time zone issues. */
  nextBankCalendarDay: Scalars['Date']['output'];
  /** Enum for knowing if current date is bank day or after business hours */
  status: PaymentDisclaimerStatus;
};

export enum PaymentDisclaimerStatus {
  AfterBusinessHours = 'AfterBusinessHours',
  None = 'None',
  NotBankDay = 'NotBankDay'
}

/** Payment distribution for a credit card */
export type PaymentDistribution = Node & {
  __typename: 'PaymentDistribution';
  annualCostPercentage: Scalars['Float']['output'];
  /** The GlobalID of the credit card this payment distribution belongs to */
  cardId: Scalars['ID']['output'];
  /**
   * Because of API behaviour this can only fetched during a creation or after the contract has been created
   * @deprecated Reason: Use contractDocumentV2 instead. Since: 2026-03-18. Issue to remove it: WEB-41537
   */
  contractDocument: Maybe<DocumentBucket>;
  /** Because of API behaviour this can only fetched during a creation or after the contract has been created */
  contractDocumentV2: Maybe<GenericFile>;
  /** Id of the contract for this payment distribution */
  contractId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installments: Array<PaymentDistributionInstallment>;
  interestRate: Scalars['Float']['output'];
  loanAmount: Scalars['Float']['output'];
  numberOfPayments: Scalars['Int']['output'];
  numberOfRemainingPayments: Scalars['Int']['output'];
  registrationDate: Scalars['DateTimeISO']['output'];
  remainingAmount: Scalars['Float']['output'];
  state: PaymentDistributionStatus;
};

export type PaymentDistributionConnection = {
  __typename: 'PaymentDistributionConnection';
  edges: Array<PaymentDistributionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentDistributionEdge = {
  __typename: 'PaymentDistributionEdge';
  cursor: Scalars['String']['output'];
  node: PaymentDistribution;
};

/** Constants for payment distribution */
export type PaymentDistributionInformation = {
  __typename: 'PaymentDistributionInformation';
  availableAmount: Scalars['Float']['output'];
  cardLoanMaxAmount: Scalars['Float']['output'];
  /** Calculated payment distribution based on default values */
  defaultCalculatedPaymentDistribution: Maybe<PaymentDistribution>;
  dueDate: Maybe<Scalars['DateTimeISO']['output']>;
  interestRateCategory: Scalars['String']['output'];
  maxNumberOfActiveCardLoans: Scalars['Int']['output'];
  maxNumberOfPayments: Scalars['Int']['output'];
  minAmount: Scalars['Float']['output'];
  monthsToFirstDueDate: Scalars['Int']['output'];
  numberOfActiveCardLoans: Scalars['Int']['output'];
  remainingAmount: Scalars['Float']['output'];
};


/** Constants for payment distribution */
export type PaymentDistributionInformationDefaultCalculatedPaymentDistributionArgs = {
  data?: InputMaybe<DefaultCalculatedPaymentDistributionInput>;
};

/** A single installment for payment distribution */
export type PaymentDistributionInstallment = {
  __typename: 'PaymentDistributionInstallment';
  amount: Scalars['Float']['output'];
  dueDate: Scalars['DateTimeISO']['output'];
  fee: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  interestAmount: Scalars['Float']['output'];
  interestRate: Scalars['Float']['output'];
  paid: Scalars['Boolean']['output'];
  totalPayment: Scalars['Float']['output'];
};

export type PaymentDistributionNotFound = Error & {
  __typename: 'PaymentDistributionNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum PaymentDistributionSearchType {
  Active = 'Active',
  All = 'All',
  Archived = 'Archived'
}

export enum PaymentDistributionStatus {
  CanContinue = 'CanContinue',
  Cancelled = 'Cancelled',
  Created = 'Created',
  NotCreated = 'NotCreated',
  Paid = 'Paid'
}

export type PaymentEdge = {
  __typename: 'PaymentEdge';
  cursor: Scalars['String']['output'];
  node: Payment;
};

/** Payment exchange rate info */
export type PaymentExchangeRate = {
  __typename: 'PaymentExchangeRate';
  /** Method of calculation, usually multiplier or divider */
  calculationMethod: Maybe<Scalars['String']['output']>;
  /** Tax rate applied to capital gains for a creditor */
  creditorCapitalGainsTaxRate: Maybe<Scalars['Float']['output']>;
  /** Tax rate applied to capital gains for a debtor */
  debtorCapitalGainsTaxRate: Maybe<Scalars['Float']['output']>;
  /** Exchange rate object */
  rate: Maybe<CurrencyAmount>;
};

export enum PaymentFrequency {
  Annual = 'Annual',
  Daily = 'Daily',
  EveryEightMonths = 'EveryEightMonths',
  EveryElevenMonths = 'EveryElevenMonths',
  EveryFiveMonths = 'EveryFiveMonths',
  EveryFourMonths = 'EveryFourMonths',
  EveryFourWeeks = 'EveryFourWeeks',
  EveryHalfMonth = 'EveryHalfMonth',
  EveryNineMonths = 'EveryNineMonths',
  EverySevenMonths = 'EverySevenMonths',
  EveryTenMonths = 'EveryTenMonths',
  /**
   * Payment occurs every three months
   * @deprecated Reason: Outdated - use Quarterly instead. Since: 2026-08-05. Issue to remove: WEB-44898.
   */
  EveryThreeMonths = 'EveryThreeMonths',
  EveryThreeWeeks = 'EveryThreeWeeks',
  EveryTwoMonths = 'EveryTwoMonths',
  EveryTwoWeeks = 'EveryTwoWeeks',
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnual = 'SemiAnnual',
  SeveralTimesPerDay = 'SeveralTimesPerDay',
  SinglePayment = 'SinglePayment',
  ThreeTimesPerMonth = 'ThreeTimesPerMonth',
  Weekly = 'Weekly'
}

export type PaymentInitiation = Node & {
  __typename: 'PaymentInitiation';
  batch: Maybe<PaymentBatch>;
  errorSubject: Maybe<PaymentInitiationErrorSubject>;
  id: Scalars['ID']['output'];
  /** Temporary data for payment if it has not been created yet */
  initialPaymentData: Maybe<InitialPaymentDataUnion>;
  initiationType: InitiationType;
  payment: Maybe<Payment>;
  paymentId: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  paymentType: PaymentType;
  pisId: Scalars['String']['output'];
  status: InitiationStatus;
};

export enum PaymentInitiationErrorSubject {
  AccountNotFound = 'AccountNotFound',
  AmountHigherThenClaimAmount = 'AmountHigherThenClaimAmount',
  AmountNotEqualToClaimAmount = 'AmountNotEqualToClaimAmount',
  AmountUnavailable = 'AmountUnavailable',
  BatchNameInvalid = 'BatchNameInvalid',
  CardNumberNotFound = 'CardNumberNotFound',
  ClaimAlreadyPaid = 'ClaimAlreadyPaid',
  ClaimNotFound = 'ClaimNotFound',
  CouldNotGetReceipt = 'CouldNotGetReceipt',
  CouldNotSendReceipt = 'CouldNotSendReceipt',
  CurrencyMarketIsClosed = 'CurrencyMarketIsClosed',
  DepositNotAllowed = 'DepositNotAllowed',
  DepositUnauthorised = 'DepositUnauthorised',
  InvalidPaymentCurrency = 'InvalidPaymentCurrency',
  InvalidPaymentDate = 'InvalidPaymentDate',
  LargeValuePaymentUnauthorised = 'LargeValuePaymentUnauthorised',
  MandateAlreadyExists = 'MandateAlreadyExists',
  NotCompletedPaymentStatus = 'NotCompletedPaymentStatus',
  PaymentAmountInvalid = 'PaymentAmountInvalid',
  PaymentAmountMustExceedOverdueFee = 'PaymentAmountMustExceedOverdueFee',
  PaymentApprovalRequired = 'PaymentApprovalRequired',
  PaymentExceedsCompanyDailyLimits = 'PaymentExceedsCompanyDailyLimits',
  PaymentExceedsDailyLimits = 'PaymentExceedsDailyLimits',
  PaymentExceedsLimit = 'PaymentExceedsLimit',
  PaymentInitiationInvalidStatus = 'PaymentInitiationInvalidStatus',
  PaymentInitiationNotFound = 'PaymentInitiationNotFound',
  PreviousDueDateMustBePaidBeforeThisOne = 'PreviousDueDateMustBePaidBeforeThisOne',
  ReceiptError = 'ReceiptError',
  SavingsAccountError = 'SavingsAccountError',
  ScheduledPaymentDateTimeNotSupported = 'ScheduledPaymentDateTimeNotSupported',
  TooManyErrors = 'TooManyErrors',
  UnknownError = 'UnknownError',
  UserAccessNotFound = 'UserAccessNotFound',
  WithdrawalUnathorised = 'WithdrawalUnathorised'
}

/** Action of a payment that comes from a loan application */
export enum PaymentInstructionActionType {
  /** Will be paid up (Greitt upp) */
  PAID_UP = 'PAID_UP',
  /** Will be paid into an account (Innborgun) */
  PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
  /** Remainder of payment (Afgangur) */
  REST = 'REST',
  /** Unknown type from API */
  UNKNOWN = 'UNKNOWN'
}

/** Type of instruction for payment in loanApplication */
export enum PaymentInstructionType {
  ACCOUNT_OUT_OF_BANK = 'ACCOUNT_OUT_OF_BANK',
  ACCOUNT_WITH_IN_BANK = 'ACCOUNT_WITH_IN_BANK',
  LOAN_OUT_OF_BANK = 'LOAN_OUT_OF_BANK',
  LOAN_WITH_IN_BANK = 'LOAN_WITH_IN_BANK',
  NEW_LOAN_PRINCIPAL = 'NEW_LOAN_PRINCIPAL',
  UNKNOWN = 'UNKNOWN'
}

/** Interface for all payment objects to implement */
export type PaymentInterface = {
  /** Also known as withdrawal account */
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description text of error for failed payment. IS/EN */
  errorMessage: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PaymentStatus>;
  type: PaymentType;
};

export type PaymentNotFound = Error & {
  __typename: 'PaymentNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Notification sent regarding a payment */
export type PaymentNotification = {
  __typename: 'PaymentNotification';
  /** Channel used to send the notification (i.e. SMS/Email) */
  channel: PaymentNotificationChannel;
  /** Handle for the specific channel (i.e. phone number/email address) */
  handle: Scalars['String']['output'];
  /** Message sent in the notification */
  message: Maybe<Scalars['String']['output']>;
  /** Date when the notification was sent */
  sent: Scalars['DateTimeISO']['output'];
};

export enum PaymentNotificationChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  UNKNOWN = 'UNKNOWN'
}

export type PaymentOption = {
  __typename: 'PaymentOption';
  /** Option (model) id */
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: PaymentTypeLookUpType;
};

export type PaymentParticipant = {
  __typename: 'PaymentParticipant';
  /** Address details of the participant */
  address: PaymentParticipantAddress;
  /** Name of the participant */
  name: Maybe<Scalars['String']['output']>;
};

/** Action of a participant in a payment */
export type PaymentParticipantAction = {
  __typename: 'PaymentParticipantAction';
  /** Description of the action */
  actionDescription: Scalars['String']['output'];
  /** Which application did the participant use? */
  application: Scalars['String']['output'];
  /** When did the participant performed the action? */
  date: Scalars['DateTimeISO']['output'];
  /** Full name of the participant */
  name: Scalars['String']['output'];
};

export type PaymentParticipantAddress = {
  __typename: 'PaymentParticipantAddress';
  /** City of the address */
  city: Maybe<Scalars['String']['output']>;
  /** Country */
  country: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postCode: Maybe<Scalars['String']['output']>;
  /** Street of the address */
  street: Maybe<Scalars['String']['output']>;
};

export type PaymentParticipantBankInfo = {
  __typename: 'PaymentParticipantBankInfo';
  /** Address details */
  address: PaymentParticipantAddress;
  /** Unique id number for the bank */
  bankIdentifier: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  name: Maybe<Scalars['String']['output']>;
};

/** The structure of the payment receipt */
export enum PaymentReceiptStructure {
  /** The default structure of the payment receipts, which is a single page for each receipt with full details */
  DEFAULT = 'DEFAULT',
  /** Summary structure of payment receipts, which congregates multiple receipts into a table */
  SUMMARY = 'SUMMARY'
}

export type PaymentReceiptsOptions = {
  /** Structure of the receipts in the file */
  structure?: InputMaybe<PaymentReceiptStructure>;
};

/** PaymentRecipient */
export type PaymentRecipient = Node & {
  __typename: 'PaymentRecipient';
  accountIdentifier: Scalars['String']['output'];
  accountIdentifierType: AccountIdentifierType;
  /** If a recipient is the users own account the account name is returned unless its the default account name given by the bank */
  accountName: Maybe<Scalars['String']['output']>;
  address: Maybe<PaymentRecipientAddress>;
  /** If the recipient has automatic email notifications enabled */
  automaticEmailNotifications: Scalars['Boolean']['output'];
  bankInfo: Maybe<PaymentRecipientBankInfo>;
  /** nickName */
  description: Maybe<Scalars['String']['output']>;
  /** List of email addresses that will receive email notifications */
  emailAddresses: Array<Scalars['String']['output']>;
  historyOfPayments: PaymentRecipientHistoryOfPaymentsConnection;
  id: Scalars['ID']['output'];
  internationalPaymentMethod: Maybe<InternationalPaymentMethod>;
  isFavorite: Maybe<Scalars['Boolean']['output']>;
  /** Whether the recipient's account is a Landsbankinn account or not. This can only be true if the transfer is a (domestic) credit transfer. */
  isLandsbankinnAccount: Scalars['Boolean']['output'];
  kennitala: Maybe<Scalars['String']['output']>;
  lastPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
  /** This might need to be of other type. Check later when we get more concrete data */
  orderingNumber: Maybe<Scalars['String']['output']>;
  paymentType: PaymentType;
};


/** PaymentRecipient */
export type PaymentRecipientHistoryOfPaymentsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PaymentRecipientAddress = {
  __typename: 'PaymentRecipientAddress';
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  street2: Maybe<Scalars['String']['output']>;
};

export type PaymentRecipientBankInfo = {
  __typename: 'PaymentRecipientBankInfo';
  address: Maybe<PaymentRecipientAddress>;
  /** BIC number of bank e.g. NBIIISRE */
  bankIdentifier: Maybe<Scalars['String']['output']>;
  /** Name of the bank */
  name: Maybe<Scalars['String']['output']>;
};

export type PaymentRecipientBankInfoInput = {
  address?: InputMaybe<InternationalPaymentAddressInput>;
  /** BIC number of bank e.g. NBIIISRE */
  bankIdentifier: Scalars['String']['input'];
  /** Name of the bank */
  name: Scalars['String']['input'];
};

export type PaymentRecipientConnection = {
  __typename: 'PaymentRecipientConnection';
  edges: Array<PaymentRecipientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PaymentRecipientEdge = {
  __typename: 'PaymentRecipientEdge';
  cursor: Scalars['String']['output'];
  node: PaymentRecipient;
};

export type PaymentRecipientFilterArgs = {
  /** This argument can be used to get a specific recipient (if it exists) based on a known account identifier. Note that if this parameter is not null, the query will return a list of either one or zero items. */
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Only getting the favorite recipients */
  onlyFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  paymentTypes?: InputMaybe<Array<PaymentType>>;
  /**
   * Search for recipients by their name
   * @deprecated Reason: Use textSearch instead. Since: 2025-05-20. Removed: 2025-09-30. Issue(s) to remove it: WEB-34465
   */
  recipientName?: InputMaybe<Scalars['String']['input']>;
  /** Search for recipients by text in different fields */
  textSearch?: InputMaybe<Scalars['String']['input']>;
  /** This argument is added to differentiate between getting a recipients list for a specific user or the company that the user is working for. By default (if this parameter is null), it will be false - meaning that the query will include only the recipients of the user. If this parameter is true (translating to the api's property: userRecipientsOnly = false) the company's recipients will be returned (and they will miss the following properties: isFavorite, description, orderingNumber). */
  useCorporateRecipients?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentRecipientHistoryOfPaymentsConnection = {
  __typename: 'PaymentRecipientHistoryOfPaymentsConnection';
  edges: Array<PaymentRecipientPaymentEdge>;
  /** The most frequently used central bank category code from the history of payments */
  mostFrequentlyUsedCentralBankCode: Maybe<Scalars['String']['output']>;
  /** The most frequently used currency from the history of payments */
  mostFrequentlyUsedCurrency: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** International payment details of a recipient */
export type PaymentRecipientInternationalPaymentDetails = {
  __typename: 'PaymentRecipientInternationalPaymentDetails';
  centralBankCategoryCode: Maybe<CentralBankCategoryCode>;
  /** For international payments, this is the old costSplitMethod */
  chargeBearer: Maybe<Scalars['String']['output']>;
  /** Request for urgent payment (serviceLevel) */
  isExpress: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentRecipientNotFound = Error & {
  __typename: 'PaymentRecipientNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Individual item from the history of payments of a recipient */
export type PaymentRecipientPayment = {
  __typename: 'PaymentRecipientPayment';
  cardId: Maybe<Scalars['String']['output']>;
  categoryCode: Maybe<Scalars['String']['output']>;
  debtorAccountId: Maybe<Scalars['ID']['output']>;
  /** Known in banking also as withdrawal account */
  debtorAccountNumber: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  endToEndIdentification: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  internationalPaymentDetails: Maybe<PaymentRecipientInternationalPaymentDetails>;
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  paymentType: PaymentType;
};

export type PaymentRecipientPaymentEdge = {
  __typename: 'PaymentRecipientPaymentEdge';
  cursor: Scalars['String']['output'];
  node: PaymentRecipientPayment;
};

/** Argument used when getting the list of (payment) recipients. This gives the API the sorting option that they need to use */
export enum PaymentRecipientSortingArg {
  /** Sort the data by the lastPaymentDate */
  BY_LAST_PAYMENT_DATE = 'BY_LAST_PAYMENT_DATE',
  /** Sort the data by orderingNumber */
  BY_ORDERING_NUMBER = 'BY_ORDERING_NUMBER',
  /** Sort the data by recipientName */
  BY_RECIPIENT_NAME = 'BY_RECIPIENT_NAME',
  /** No sorting */
  NONE = 'NONE'
}

/** Reasons why the payment needs no further action */
export enum PaymentScaNoActionReason {
  /** The payment is stored and won't require SCA consent until initiated */
  STORED_PAYMENT = 'STORED_PAYMENT',
  /** Unknown reason why the payment needs no further action */
  UNKNOWN = 'UNKNOWN',
  /** The payment is waiting for approval and won't require SCA consent until initiated after approval */
  WAITS_APPROVAL = 'WAITS_APPROVAL'
}

/** A Payment Service Provider (PSP) is a 3rd party entity that is a combination of payment gateways and payment processors according to the Payment Service Directive */
export type PaymentServiceProvider = Node & {
  __typename: 'PaymentServiceProvider';
  /** Authorization options of the provider. Example "oauth2", "embedded", "redirect" */
  authorization: Maybe<Array<Scalars['String']['output']>>;
  /** Capabilities */
  capabilities: Maybe<Array<Scalars['String']['output']>>;
  /** ISO 3166 country code of the country the provider operates */
  country: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** URL to the official website of the provider */
  homeUrl: Maybe<Scalars['String']['output']>;
  /** Global GraphQL identifier of this payment service provider */
  id: Scalars['ID']['output'];
  /** A reference to a graphic resource that represents the providers logo */
  logo: Maybe<PaymentServiceProviderImage>;
  /** Name of the payment service provider. Example: "Arion" */
  name: Scalars['String']['output'];
  /** Types of services this provider offers. Example "payment-initiation", "account-information" */
  serviceTypes: Maybe<Array<Scalars['String']['output']>>;
  /** Availability status. Example: "online", "disabled" */
  status: Maybe<Scalars['String']['output']>;
};

/** Filter arguments for fetching payment service providers */
export type PaymentServiceProviderFilterArgs = {
  /** Use this to filter the results by service type */
  serviceType?: InputMaybe<PaymentServiceProviderType>;
};

/** A graphic that represents a payment service providers identity, such as a logo */
export type PaymentServiceProviderImage = {
  __typename: 'PaymentServiceProviderImage';
  /** URL for the image */
  url: Scalars['String']['output'];
};

/** Type of a service a payment service provider offers */
export enum PaymentServiceProviderType {
  /** Account Information Services */
  AIS = 'AIS',
  /** Payment Initiation Services */
  PIS = 'PIS'
}

export enum PaymentStatus {
  /** This payment was declined by the user */
  Cancelled = 'Cancelled',
  /** The payment has been paid successfully */
  Completed = 'Completed',
  /** The payment has been deleted */
  Deleted = 'Deleted',
  /** The payment has a future payment date and is waiting for that day to come */
  Pending = 'Pending',
  /** The payment is being processed by our system (Sopra) and normally the next status would be "Completed". This status is typical during critical period in Sopra at the end of day. */
  Processing = 'Processing',
  /** The payment has been recalled by the user */
  Recalled = 'Recalled',
  /** This payment has been confirmed by the user and we have started processing the payment but it might still get rejected for several reasons. Normally the next status would be "Processing" or "Pending". */
  Received = 'Received',
  /** This payment received an error or was rejected, we return ErrorSubject value to explain the reason for for the rejection */
  Rejected = 'Rejected',
  /** The payment execution is in processing but has been suspended, the system will retry the execution soon or an employee will manually allow the payment to go through. This should not normally happen for payment initiations but for example high value payments (stórgreiðslur 100m+ ISK) will have this happen to them. */
  Suspended = 'Suspended',
  Unknown = 'Unknown',
  /** The payment is waiting for approval from a second user. (Corporate only) */
  WaitsApproval = 'WaitsApproval'
}

export enum PaymentType {
  AbGiro = 'AbGiro',
  CGiro = 'CGiro',
  CardCorrection = 'CardCorrection',
  CardDeposit = 'CardDeposit',
  CardDirectDebit = 'CardDirectDebit',
  CashDeposit = 'CashDeposit',
  CashWithdrawal = 'CashWithdrawal',
  ClaimDirectDebit = 'ClaimDirectDebit',
  ClaimPayment = 'ClaimPayment',
  ClaimRepayment = 'ClaimRepayment',
  CreditTransfer = 'CreditTransfer',
  CreditTransferBetweenOwnAccounts = 'CreditTransferBetweenOwnAccounts',
  CrossBorderCreditTransfer = 'CrossBorderCreditTransfer',
  ForeignTransfer = 'ForeignTransfer',
  LoanDeposit = 'LoanDeposit',
  Mobile = 'Mobile',
  None = 'None',
  Notice = 'Notice',
  PaymentCoupon = 'PaymentCoupon',
  SalaryPayment = 'SalaryPayment',
  SepaCreditTransfer = 'SepaCreditTransfer'
}

export type PaymentTypeLookUpType = {
  __typename: 'PaymentTypeLookUpType';
  /** The ID of the payment type */
  id: Scalars['String']['output'];
  /** TODO use PaymentType */
  name: Scalars['String']['output'];
};

/** Payment type option in filter options. Has the enum type and description for different languages */
export type PaymentTypeWithDescription = {
  __typename: 'PaymentTypeWithDescription';
  /** Name of the payment type for different languages depending on accept-language header */
  description: Scalars['String']['output'];
  /** Enum representing the payment type */
  type: PaymentType;
};

export type PaymentsByPeriodicPaymentConnection = {
  __typename: 'PaymentsByPeriodicPaymentConnection';
  edges: Array<PaymentByPeriodicPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayorInfo = {
  __typename: 'PayorInfo';
  activated: Scalars['Boolean']['output'];
  averageSalary: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  payorId: Scalars['String']['output'];
};

/** Payroll for a company */
export type Payroll = Node & {
  __typename: 'Payroll';
  /** Creation date of payroll */
  created: Scalars['DateTimeISO']['output'];
  employees: Array<PayrollEmployee>;
  /** Excel document bucket containing excel file with employees | Only fetched if this field is queried */
  employeesExcelDocument: Maybe<DocumentBucket>;
  /** ID (Global) of payroll */
  id: Scalars['ID']['output'];
  /** Name of payroll */
  name: Scalars['String']['output'];
  /** Current status of payroll | active or inactive */
  status: PayrollStatus;
};

export type PayrollEdge = {
  __typename: 'PayrollEdge';
  cursor: Scalars['String']['output'];
  node: Payroll;
};

/** Information of employee in a payroll */
export type PayrollEmployee = {
  __typename: 'PayrollEmployee';
  /** Bank account number of the employee */
  accountNumber: Scalars['String']['output'];
  /** Street name and number of the employee */
  address: Maybe<Scalars['String']['output']>;
  /** City where the employee lives */
  city: Maybe<Scalars['String']['output']>;
  /** ID (Global) of the employee in a payroll */
  id: Scalars['ID']['output'];
  /** Kennitala of the employee */
  kennitala: Scalars['String']['output'];
  /** Name of the employee */
  name: Scalars['String']['output'];
  /** The postal code of the employee */
  postalCode: Maybe<Scalars['String']['output']>;
  /** Status of the payroll for this employee | Either active or inactive */
  status: PayrollStatus;
};

/** Current status of payroll */
export enum PayrollStatus {
  /** Payroll is active and can be displayed */
  ACTIVE = 'ACTIVE',
  /** Payroll is inactive and should not be displayed */
  INACTIVE = 'INACTIVE',
  /** Unknown status came from the API */
  UNKNOWN = 'UNKNOWN'
}

export type PayrollsConnection = {
  __typename: 'PayrollsConnection';
  edges: Array<PayrollEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PayslipsFilterArgs = {
  /** Start date of the search */
  from: Scalars['Date']['input'];
  /** Kennitala to filter payslips */
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** End date of the search */
  to: Scalars['Date']['input'];
};

/** Financial transaction in a pending state on bank account, i.e. transfer, debit payments */
export type PendingAccountTransaction = Node & {
  __typename: 'PendingAccountTransaction';
  /** Amount of the pending transaction */
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  extendedReference: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  transactionDate: Scalars['DateTimeISO']['output'];
  ultimateCreditor: Maybe<Scalars['String']['output']>;
};

export type PendingAccountTransactionConnection = {
  __typename: 'PendingAccountTransactionConnection';
  edges: Array<PendingAccountTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PendingAccountTransactionEdge = {
  __typename: 'PendingAccountTransactionEdge';
  cursor: Scalars['String']['output'];
  node: PendingAccountTransaction;
};

export type PendingAccountTransactionsSortBy = {
  direction: OrderByDirection;
  field: PendingTransactionsSortByField;
};

export enum PendingTransactionsSortByField {
  /** Order by amount */
  Amount = 'Amount',
  /** Order by transaction date */
  Date = 'Date',
  /** Order by description */
  Description = 'Description'
}

export type PensionApplicationErrorUnion = UnknownError;

/** If the customer has a contract with another fund they can choose to transfer capital from that fund to the new fund */
export type PensionApplicationPreviousFundTerminationInput = {
  /** The previous fund that is being cancelled */
  previousFundId: Scalars['ID']['input'];
  /** Should be set to false if the capital should not be transferred between funds */
  transferFunds: Scalars['Boolean']['input'];
};

export type PensionApplicationSignableDocument = {
  __typename: 'PensionApplicationSignableDocument';
  /** Id of the document that should be signed in the `groupId` group. */
  documentGroupId: Scalars['ID']['output'];
  /** Group id of the document, There should only ever be one document in the group. */
  groupId: Scalars['ID']['output'];
};

/** The type of pension application */
export enum PensionApplicationType {
  MANDATORY = 'MANDATORY',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
  UNKNOWN = 'UNKNOWN'
}

/** Represents what percentage the customer pays per month to his pension */
export enum PensionApplicationsContributionPercentageNumber {
  FOUR = 'FOUR',
  THREE = 'THREE',
  TWO = 'TWO'
}

export type PensionCalculation = {
  __typename: 'PensionCalculation';
  development: Maybe<PensionCalculationDevelopment>;
  parameters: PensionCalculationParams;
  plans: Array<PensionInvestmentPlan>;
  results: Array<PensionCalculationResult>;
};

export type PensionCalculationDevelopment = {
  __typename: 'PensionCalculationDevelopment';
  employeeContribution: Scalars['Int']['output'];
  employerContribution: Scalars['Int']['output'];
  salaryTaxDeduction: Scalars['Int']['output'];
  totalContribution: Scalars['Int']['output'];
};

export type PensionCalculationInput = {
  age: Scalars['Int']['input'];
  mandatory?: InputMaybe<PensionCalculationMandatoryInput>;
  personal?: InputMaybe<PensionCalculationPersonalInput>;
  salary: Scalars['Float']['input'];
  type: Array<PensionCalculationType>;
};

export type PensionCalculationMandatoryInput = {
  fundId?: InputMaybe<Scalars['ID']['input']>;
  interest?: InputMaybe<Scalars['Float']['input']>;
  investmentPlanId?: InputMaybe<Scalars['ID']['input']>;
  payoutAge?: InputMaybe<Scalars['Int']['input']>;
  retirementAge?: InputMaybe<Scalars['Int']['input']>;
};

export type PensionCalculationMandatoryParams = {
  __typename: 'PensionCalculationMandatoryParams';
  fundId: Maybe<Scalars['ID']['output']>;
  interest: Maybe<Scalars['Float']['output']>;
  investmentPlanId: Maybe<Scalars['ID']['output']>;
  payoutAge: Maybe<Scalars['Int']['output']>;
  retirementAge: Maybe<Scalars['Int']['output']>;
};

export type PensionCalculationParams = {
  __typename: 'PensionCalculationParams';
  age: Scalars['Int']['output'];
  mandatory: Maybe<PensionCalculationMandatoryParams>;
  personal: Maybe<PensionCalculationPersonalParams>;
  salary: Scalars['Float']['output'];
  type: Array<PensionCalculationType>;
};

export type PensionCalculationPersonalInput = {
  currentSavings?: InputMaybe<Scalars['Float']['input']>;
  employeeContribution?: InputMaybe<Scalars['Float']['input']>;
  employerContribution?: InputMaybe<Scalars['Float']['input']>;
  interest?: InputMaybe<Scalars['Float']['input']>;
  payoutAge?: InputMaybe<Scalars['Int']['input']>;
  payoutYears?: InputMaybe<Scalars['Int']['input']>;
};

export type PensionCalculationPersonalParams = {
  __typename: 'PensionCalculationPersonalParams';
  currentSavings: Maybe<Scalars['Float']['output']>;
  employeeContribution: Maybe<Scalars['Float']['output']>;
  employerContribution: Maybe<Scalars['Float']['output']>;
  interest: Maybe<Scalars['Float']['output']>;
  payoutAge: Maybe<Scalars['Int']['output']>;
  payoutYears: Maybe<Scalars['Int']['output']>;
};

export type PensionCalculationResult = {
  __typename: 'PensionCalculationResult';
  monthly: Maybe<Scalars['Float']['output']>;
  name: PensionResultType;
  payoutAge: Maybe<Scalars['Int']['output']>;
  payoutYears: Maybe<Scalars['Int']['output']>;
  total: Maybe<Scalars['Float']['output']>;
};

export enum PensionCalculationType {
  Mandatory = 'Mandatory',
  Personal = 'Personal'
}

export type PensionContracts = {
  __typename: 'PensionContracts';
  /** 'Active' supplementary contracts that are invalid. */
  invalidSupplementaryContract: Array<PensionInvalidSupplementaryContract>;
  /** All 'active' mandatory contracts. Warning: contracts are considered 'active' so long that there is any money stored in the pension */
  mandatoryContract: Array<PensionMandatoryContract>;
  /** 'Active' supplementary contracts. Warning: contracts are considered 'active' so long that there is any money stored in the pension */
  supplementaryContract: Array<PensionSupplementaryContract>;
};

/** The type of pension flow for CRM correspondence */
export enum PensionCorrespondenceFlowType {
  MANDATORY = 'MANDATORY',
  SUPPLEMENTARY = 'SUPPLEMENTARY'
}

/** Pension custodian information */
export type PensionCustodian = Node & {
  __typename: 'PensionCustodian';
  custodianId: Scalars['String']['output'];
  /** Description of the custodian */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Get investment options for the custodian */
  investmentOptions: Maybe<PensionsInvestmentOptions>;
  /** Name of the custodian */
  name: Scalars['String']['output'];
};


/** Pension custodian information */
export type PensionCustodianInvestmentOptionsArgs = {
  applicationType: PensionApplicationType;
};

export type PensionFund = Node & {
  __typename: 'PensionFund';
  id: Scalars['ID']['output'];
  /** The icelandic name of the fund */
  name: Scalars['String']['output'];
};

export type PensionInvalidSupplementaryContract = {
  __typename: 'PensionInvalidSupplementaryContract';
  /** Returns the custodian if possible, note that some contracts do not have a custodian assigned since custodianId are nullable in the fund */
  custodian: Maybe<PensionCustodian>;
  error: Array<PensionSupplementaryContractErrorType>;
  fund: Maybe<PensionFund>;
  investmentOption: Maybe<PensionsInvestmentOptionResponse>;
  /** Amount of funds stored in the investmentOption/fund */
  investmentOptionRight: Maybe<PensionsSupplementaryInvestmentOptionsRight>;
  /** Returns they payer if possible, note that some contracts do not have a payor assigned */
  payer: Maybe<NationalRegistryEntry>;
  percentage: Scalars['Int']['output'];
};

/** When should you use this investment option */
export type PensionInvestmentOptionRecommendedAge = {
  __typename: 'PensionInvestmentOptionRecommendedAge';
  /** The upper bound of the age range. Can be null if this is recommended forever. */
  endAge: Maybe<Scalars['Int']['output']>;
  /** The lower bound of the age range. */
  startAge: Scalars['Int']['output'];
};

export type PensionInvestmentPlan = {
  __typename: 'PensionInvestmentPlan';
  fundId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  statementName: Scalars['String']['output'];
};

export type PensionMandatoryContract = {
  __typename: 'PensionMandatoryContract';
  fund: PensionFund;
  investmentOption: PensionsInvestmentOptionResponse;
  /** Returns they payer if possible, note that some contracts do not have a payor assigned */
  payer: Maybe<NationalRegistryEntry>;
  paymentPlan: PensionsPaymentPlan;
};

/** The type of mandatory pension payment. */
export enum PensionMandatoryPaymentType {
  MUTUAL_MONTHLY = 'MUTUAL_MONTHLY',
  RESTRICTED_PRIVATE = 'RESTRICTED_PRIVATE',
  SPECIFIED_ADDITIONAL = 'SPECIFIED_ADDITIONAL',
  UNKNOWN = 'UNKNOWN',
  UNRESTRICTED_PRIVATE = 'UNRESTRICTED_PRIVATE'
}

export type PensionPayment = Node & {
  __typename: 'PensionPayment';
  /** For deposits this is the customer + company contribution, for withdrawals this is disbursment after tax */
  amount: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fund: PensionFund;
  id: Scalars['ID']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  paymentDetails: PensionPaymentDetails;
  paymentType: PensionPaymentType;
};

export type PensionPaymentBreakdown = {
  __typename: 'PensionPaymentBreakdown';
  /** Percentage as a "whole" number e.g. 5.5 = 5.5% */
  allocationPercentage: Scalars['Float']['output'];
  companyContribution: Scalars['Float']['output'];
  customerContribution: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  totalContribution: Scalars['Float']['output'];
  type: PensionPaymentBreakdownType;
  typeDescription: Scalars['String']['output'];
};

/** The type of pension payment */
export enum PensionPaymentBreakdownType {
  INHERITED = 'INHERITED',
  MUTUAL_MONTHLY = 'MUTUAL_MONTHLY',
  RESTRICTED_PRIVATE = 'RESTRICTED_PRIVATE',
  SPECIFIED_ADDITIONAL = 'SPECIFIED_ADDITIONAL',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
  UNKNOWN = 'UNKNOWN',
  UNRESTRICTED_PRIVATE = 'UNRESTRICTED_PRIVATE'
}

export type PensionPaymentConnection = {
  __typename: 'PensionPaymentConnection';
  /** The query parameters that were applied to fetch the transactions in this connection. */
  appliedQuery: PensionsPaymentsAppliedQuery;
  edges: Array<PensionPaymentEdge>;
  /** What payment types are in the selected date range. These types can be used to filter for the specific type */
  metadata: PensionPaymentMetadata;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PensionPaymentDetails = PensionPaymentInheritedDisbursment | PensionPaymentLoan | PensionPaymentMandatoryDeposit | PensionPaymentMandatoryDisbursment | PensionPaymentSpecifiedAdditionalDeposit | PensionPaymentSpecifiedAdditionalDisbursment | PensionPaymentSupplementaryDeposit | PensionPaymentSupplementaryDisbursment | PensionPaymentTransferDeposit | PensionPaymentTransferDisbursment;

export type PensionPaymentEdge = {
  __typename: 'PensionPaymentEdge';
  cursor: Scalars['String']['output'];
  node: PensionPayment;
};

export type PensionPaymentFilterArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Filter that shows ONLY the specified type */
  type?: InputMaybe<PensionPaymentType>;
};

export type PensionPaymentInheritedDisbursment = {
  __typename: 'PensionPaymentInheritedDisbursment';
  disbursementAfterTax: Scalars['Float']['output'];
  disbursment: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  tax: Scalars['Float']['output'];
};

export type PensionPaymentLoan = {
  __typename: 'PensionPaymentLoan';
  companyContribution: Scalars['Float']['output'];
  customerContribution: Scalars['Float']['output'];
  paymentPeriod: Scalars['DateTimeISO']['output'];
  salaryPeriod: Scalars['DateTimeISO']['output'];
  totalContribution: Scalars['Float']['output'];
};

export type PensionPaymentMandatoryDeposit = {
  __typename: 'PensionPaymentMandatoryDeposit';
  breakdown: Array<PensionPaymentBreakdown>;
  companyContribution: Scalars['Float']['output'];
  customerContribution: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  /** Translated payment plan */
  paymentPlan: Scalars['String']['output'];
  /** Payor kennitala */
  payorId: Maybe<Scalars['String']['output']>;
  payorName: Scalars['String']['output'];
  salaryPeriod: Scalars['DateTimeISO']['output'];
  totalContribution: Scalars['Float']['output'];
};

export type PensionPaymentMandatoryDisbursment = {
  __typename: 'PensionPaymentMandatoryDisbursment';
  disbursementAfterTax: Scalars['Float']['output'];
  disbursment: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  tax: Scalars['Float']['output'];
  type: PensionMandatoryPaymentType;
};

export type PensionPaymentMetadata = {
  __typename: 'PensionPaymentMetadata';
  types: Array<PensionPaymentType>;
};

export type PensionPaymentSpecifiedAdditionalDeposit = {
  __typename: 'PensionPaymentSpecifiedAdditionalDeposit';
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  /** Payor kennitala */
  payorId: Maybe<Scalars['String']['output']>;
  payorName: Scalars['String']['output'];
  salaryPeriod: Scalars['DateTimeISO']['output'];
  totalContribution: Scalars['Float']['output'];
};

export type PensionPaymentSpecifiedAdditionalDisbursment = {
  __typename: 'PensionPaymentSpecifiedAdditionalDisbursment';
  disbursementAfterTax: Scalars['Float']['output'];
  disbursment: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  tax: Scalars['Float']['output'];
  type: PensionMandatoryPaymentType;
};

export type PensionPaymentSupplementaryDeposit = {
  __typename: 'PensionPaymentSupplementaryDeposit';
  companyContribution: Scalars['Float']['output'];
  customerContribution: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  /** Payor kennitala */
  payorId: Maybe<Scalars['String']['output']>;
  payorName: Scalars['String']['output'];
  salaryPeriod: Scalars['DateTimeISO']['output'];
  totalContribution: Scalars['Float']['output'];
};

export type PensionPaymentSupplementaryDisbursment = {
  __typename: 'PensionPaymentSupplementaryDisbursment';
  disbursementAfterTax: Scalars['Float']['output'];
  disbursment: Scalars['Float']['output'];
  investmentPlan: Maybe<Scalars['String']['output']>;
  paymentPeriod: Scalars['DateTimeISO']['output'];
  tax: Scalars['Float']['output'];
};

export type PensionPaymentTransferDeposit = {
  __typename: 'PensionPaymentTransferDeposit';
  breakdownType: Maybe<PensionPaymentBreakdownType>;
  investmentPlan: Maybe<Scalars['String']['output']>;
  payerKennitala: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type PensionPaymentTransferDisbursment = {
  __typename: 'PensionPaymentTransferDisbursment';
  breakdownType: Maybe<PensionPaymentBreakdownType>;
  investmentPlan: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  totalAmount: Scalars['Float']['output'];
};

/** What type of pension payment is it */
export enum PensionPaymentType {
  INHERITED = 'INHERITED',
  LOAN = 'LOAN',
  MANDATORY = 'MANDATORY',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
  TRANSFER = 'TRANSFER',
  UNKNOWN = 'UNKNOWN'
}

export enum PensionResultType {
  Mutual = 'Mutual',
  Private = 'Private',
  Restricted = 'Restricted',
  Unrestricted = 'Unrestricted'
}

export type PensionReturn = {
  __typename: 'PensionReturn';
  companyContibution: Scalars['Float']['output'];
  customerContibution: Scalars['Float']['output'];
  disbursement: Scalars['Float']['output'];
  endAmount: Scalars['Float']['output'];
  gainLoss: Scalars['Float']['output'];
  interest: Scalars['Float']['output'];
  startAmount: Scalars['Float']['output'];
  transfer: Scalars['Float']['output'];
};

export type PensionReturns = {
  __typename: 'PensionReturns';
  /** The query parameters that were applied to fetch the returns */
  appliedQuery: PensionsReturnsAppliedQuery;
  id: Scalars['ID']['output'];
  mandatory: Maybe<PensionReturn>;
  supplementary: Maybe<PensionReturn>;
};

export type PensionReturnsFilterArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PensionSupplementaryContract = {
  __typename: 'PensionSupplementaryContract';
  /** Returns the custodian if possible, note that some contracts do not have a custodian assigned since custodianId are nullable in the fund */
  custodian: Maybe<PensionCustodian>;
  fund: PensionFund;
  investmentOption: PensionsInvestmentOptionResponse;
  /** Amount of funds stored in the investmentOption/fund */
  investmentOptionRight: Maybe<PensionsSupplementaryInvestmentOptionsRight>;
  /** Returns they payer if possible, note that some contracts do not have a payor assigned */
  payer: Maybe<NationalRegistryEntry>;
  percentage: Scalars['Int']['output'];
};

/** Represents invalid contracts that FUGLAR stores */
export enum PensionSupplementaryContractErrorType {
  INVALID_INVESTMENT_PERCENTAGE = 'INVALID_INVESTMENT_PERCENTAGE',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

/** Pension widget */
export type PensionWidget = {
  __typename: 'PensionWidget';
  /** Pension widget data */
  data: Maybe<PrivateRightSummary>;
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

export type Pensions = {
  __typename: 'Pensions';
  contracts: PensionContracts;
  custodians: Array<PensionCustodian>;
  customerInformation: PensionsCustomerInformation;
  externalFunds: Array<PensionsExternalFund>;
  externalRights: Maybe<Array<PensionsExternalRightInterface>>;
  getEstimatedFutureRights: PensionsEstimatedFutureRights;
  id: Scalars['ID']['output'];
  investmentOptions: PensionsInvestmentOptions;
  investmentOptionsRights: PensionsInvestmentOptionsRight;
  packages: Array<PensionsApplicationPackage>;
  paymentPlans: Array<PensionsPaymentPlan>;
  pensionPayments: PensionPaymentConnection;
  returns: PensionReturns;
  rights: PensionsRights;
};


export type PensionsGetEstimatedFutureRightsArgs = {
  interestRate: Scalars['Float']['input'];
  retirementAge: Scalars['Int']['input'];
  salary: Scalars['Float']['input'];
  supplementaryPayout?: InputMaybe<PensionsSupplementaryPayout>;
  unrestrictedPrivatePayout?: InputMaybe<PensionsUnrestrictedPrivatePayout>;
};


export type PensionsInvestmentOptionsArgs = {
  applicationType: PensionApplicationType;
};


export type PensionsPensionPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: PensionPaymentFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PensionsReturnsArgs = {
  filter: PensionReturnsFilterArgs;
};

export type PensionsApplicationPackage = {
  __typename: 'PensionsApplicationPackage';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  investmentOption: PensionsInvestmentOptionResponse;
  name: Scalars['String']['output'];
  paymentPlan: PensionsPaymentPlan;
};

/** The type of allocation rights */
export enum PensionsApplicationsAllocationRightType {
  MUTUAL_MONTHLY = 'MUTUAL_MONTHLY',
  RESTRICTED_PRIVATE = 'RESTRICTED_PRIVATE',
  UNKNOWN = 'UNKNOWN',
  UNRESTRICTED_PRIVATE = 'UNRESTRICTED_PRIVATE'
}

export type PensionsCustomerInformation = {
  __typename: 'PensionsCustomerInformation';
  customerAge: Maybe<Scalars['Float']['output']>;
  /** If the user can compute future savings with the savings calculator. */
  hasCalculatorAccess: Scalars['Boolean']['output'];
  /** Is the user allowed to lookup external rights? */
  hasPensionPortalAccess: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mandatoryContractInformation: PensionsMandatoryContractInformation;
  /** Default retirement age, hardcoded to 65 */
  retirementAge: Scalars['Float']['output'];
  /** The customers estimated salary based on previous pension payments. Will be zero if no pension payments have been made */
  salary: Scalars['Float']['output'];
  supplementaryContractInformation: PensionsSupplementaryContractInformation;
};

export type PensionsEstimatedFutureRights = {
  __typename: 'PensionsEstimatedFutureRights';
  mandatory: Maybe<PensionsEstimatedMandatoryRights>;
  restrictedPrivate: Maybe<PensionsEstimatedRights>;
  supplementary: Maybe<PensionsEstimatedRights>;
  unrestrictedPrivate: Maybe<PensionsEstimatedRights>;
};

export type PensionsEstimatedMandatoryRights = {
  __typename: 'PensionsEstimatedMandatoryRights';
  monthlyAmount: Scalars['Float']['output'];
  payoutAge: Scalars['Int']['output'];
};

export type PensionsEstimatedRights = {
  __typename: 'PensionsEstimatedRights';
  amount: Scalars['Float']['output'];
  monthlyAmount: Scalars['Float']['output'];
  payoutAge: Scalars['Int']['output'];
  payoutYears: Scalars['Int']['output'];
};

export type PensionsExternalFund = {
  __typename: 'PensionsExternalFund';
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PensionsExternalRightAmount = PensionsExternalRightInterface & {
  __typename: 'PensionsExternalRightAmount';
  age65: Maybe<CurrencyAmount>;
  age67: Maybe<CurrencyAmount>;
  age70: Maybe<CurrencyAmount>;
  age75: Maybe<CurrencyAmount>;
  age80: Maybe<CurrencyAmount>;
  age85: Maybe<CurrencyAmount>;
  fundName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: PensionsExternalRightsType;
};

export type PensionsExternalRightInterface = {
  fundName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: PensionsExternalRightsType;
};

export type PensionsExternalRightProportion = PensionsExternalRightInterface & {
  __typename: 'PensionsExternalRightProportion';
  age65: Maybe<Scalars['Float']['output']>;
  age67: Maybe<Scalars['Float']['output']>;
  age70: Maybe<Scalars['Float']['output']>;
  age75: Maybe<Scalars['Float']['output']>;
  age80: Maybe<Scalars['Float']['output']>;
  age85: Maybe<Scalars['Float']['output']>;
  fundName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: PensionsExternalRightsType;
};

/** The type of external pension rights. */
export enum PensionsExternalRightsType {
  AMOUNT = 'AMOUNT',
  PROPORTION = 'PROPORTION',
  UNKNOWN = 'UNKNOWN'
}

/** Investment option of a pension fund */
export type PensionsInvestmentOption = Node & {
  __typename: 'PensionsInvestmentOption';
  /** Fluctuation points ranging from 0-7. Defined only in the pension fund application */
  fluctuation: Maybe<Scalars['Int']['output']>;
  fund: PensionFund;
  id: Scalars['ID']['output'];
  /** The allocation of the investment option. Defined only in the pension fund application */
  investmentAllocation: Maybe<PensionsInvestmentOptionAllocation>;
  /** Array of pdf document links. Changes based on the customer age. Defined only in the pension fund application */
  keyInformationUrls: Array<PensionsKeyInformationUrls>;
  name: Scalars['String']['output'];
  /** At what age the user use this investment option. Defined only in the pension fund application */
  recommendedAge: Maybe<PensionInvestmentOptionRecommendedAge>;
  returns: Maybe<PensionsInvestmentOptionReturns>;
};

/** The allocation of the investment option */
export type PensionsInvestmentOptionAllocation = {
  __typename: 'PensionsInvestmentOptionAllocation';
  /** The percentage of bond within the investment option */
  bondPercentage: Maybe<Scalars['Float']['output']>;
  /** The percentage of deposit within the investment option */
  depositPercentage: Maybe<Scalars['Float']['output']>;
  /** The percentage of equity within the investment option */
  equityPercentage: Maybe<Scalars['Float']['output']>;
};

export type PensionsInvestmentOptionAnnualReturns = {
  __typename: 'PensionsInvestmentOptionAnnualReturns';
  /** The annual return (as percentage) of a pension investment option, for a given year. */
  return: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

/** Represents the annualized returns of a pension investment option over various time horizons, reported as decimal-form percentages (e.g., 4.58 for 4.58%). */
export type PensionsInvestmentOptionAnnulizedReturns = {
  __typename: 'PensionsInvestmentOptionAnnulizedReturns';
  /** The annualized return on the investment option over a fifteen-year period, expressed as a decimal percentage (e.g., 4.58 for 4.58%). */
  fifteenYearReturn: Maybe<Scalars['Float']['output']>;
  /** The annualized return on the investment option over a five-year period, expressed as a decimal percentage (e.g., 4.58 for 4.58%). */
  fiveYearReturn: Maybe<Scalars['Float']['output']>;
  /** The annualized return on the investment option over a one-year period, expressed as a decimal percentage (e.g., 4.58 for 4.58%). */
  oneYearReturn: Maybe<Scalars['Float']['output']>;
  /** The annualized return on the investment option over a ten-year period, expressed as a decimal percentage (e.g., 4.58 for 4.58%). */
  tenYearReturn: Maybe<Scalars['Float']['output']>;
  /** The annualized return on the investment option over a three-year period, expressed as a decimal percentage (e.g., 4.58 for 4.58%). */
  threeYearReturn: Maybe<Scalars['Float']['output']>;
};

/** The customer type of the pension fund investment options */
export enum PensionsInvestmentOptionCustomerTypes {
  /** (Pension fund investment option for) Dentists */
  DENTIST = 'DENTIST',
  /** (Pension fund investment option for) General customers. This will return Landsbankinn funds */
  GENERAL = 'GENERAL'
}

export type PensionsInvestmentOptionNewestReturn = {
  __typename: 'PensionsInvestmentOptionNewestReturn';
  /** The period type (e.g., year, month, week) for the investment option. */
  periodType: PensionsInvestmentOptionPeriodType;
  /** The value of the period (e.g., 1 for one year, 6 for six months). */
  periodValue: Scalars['Int']['output'];
  /** The newest return (as a percentage) of a pension investment option, for a given year or month depending on the period type */
  return: Scalars['Float']['output'];
  /** The type of return (e.g., nominal) for the investment option. */
  returnType: PensionsInvestmentOptionReturnType;
};

/** The period type of the investment option (of a pension fund) */
export enum PensionsInvestmentOptionPeriodType {
  /** Monthly period of the investment option */
  MONTH = 'MONTH',
  /** Weekly period of the investment option */
  WEEK = 'WEEK',
  /** Yearly period of the investment option */
  YEAR = 'YEAR'
}

export type PensionsInvestmentOptionResponse = PensionsInvestmentOption | PensionsLifePathInvestmentOption;

/** The return type of the investment option (of a pension fund) */
export enum PensionsInvestmentOptionReturnType {
  /** Nominal return of the investment option */
  NOMINAL = 'NOMINAL'
}

export type PensionsInvestmentOptionReturns = {
  __typename: 'PensionsInvestmentOptionReturns';
  annualRealReturns: Maybe<Array<PensionsInvestmentOptionAnnualReturns>>;
  annualReturns: Maybe<Array<PensionsInvestmentOptionAnnualReturns>>;
  annualizedRealReturns: Maybe<PensionsInvestmentOptionAnnulizedReturns>;
  annualizedReturns: Maybe<PensionsInvestmentOptionAnnulizedReturns>;
  /** When were the returns last updated. */
  lastUpdated: Scalars['Date']['output'];
  newestReturn: Maybe<PensionsInvestmentOptionNewestReturn>;
};

/** The saving type of the investment option (of a pension fund) */
export enum PensionsInvestmentOptionSavingTypes {
  /** Mandatory pension funds */
  MANDATORY = 'MANDATORY',
  /** Supplementary pension funds */
  SUPPLEMENTARY = 'SUPPLEMENTARY'
}

export type PensionsInvestmentOptions = {
  __typename: 'PensionsInvestmentOptions';
  lifepath: Maybe<PensionsLifePathInvestmentOption>;
  otherPaths: Array<PensionsInvestmentOption>;
};

export type PensionsInvestmentOptionsFilterArgs = {
  customerTypes?: InputMaybe<PensionsInvestmentOptionCustomerTypes>;
  savingTypes?: InputMaybe<PensionsInvestmentOptionSavingTypes>;
};

export type PensionsInvestmentOptionsRight = {
  __typename: 'PensionsInvestmentOptionsRight';
  id: Scalars['ID']['output'];
  mandatory: Maybe<Array<PensionsMandatoryInvestmentOptionsRight>>;
  supplementary: Maybe<Array<PensionsSupplementaryInvestmentOptionsRight>>;
};

export type PensionsInvestmentOptionsRightInterface = {
  amount: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fund: PensionFund;
  id: Scalars['ID']['output'];
  /** The name of the investment plan */
  investmentPlan: Scalars['String']['output'];
};

export type PensionsKeyInformationUrls = {
  __typename: 'PensionsKeyInformationUrls';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PensionsLifePathInvestmentOption = {
  __typename: 'PensionsLifePathInvestmentOption';
  description: Maybe<Scalars['String']['output']>;
  fund: PensionFund;
  id: Scalars['ID']['output'];
  /** Array of pdf document links. Changes based on the customer age. */
  keyInformationUrls: Array<PensionsKeyInformationUrls>;
  name: Scalars['String']['output'];
};

export type PensionsMandatoryApplicationInput = {
  email: Scalars['String']['input'];
  fundId: Scalars['ID']['input'];
  investmentOptionId: Scalars['ID']['input'];
  /** National id of the company (kennitala) */
  payerId: Scalars['String']['input'];
  paymentPlanId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PensionsMandatoryContractInformation = {
  __typename: 'PensionsMandatoryContractInformation';
  /** Does the user have an active contract? */
  active: Scalars['Boolean']['output'];
  /** Payout duration for the specific contract type, currently hardcoded */
  payoutDuration: Scalars['Int']['output'];
};

export type PensionsMandatoryInvestmentOptionsRight = PensionsInvestmentOptionsRightInterface & {
  __typename: 'PensionsMandatoryInvestmentOptionsRight';
  amount: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fund: PensionFund;
  id: Scalars['ID']['output'];
  /** The name of the investment plan */
  investmentPlan: Scalars['String']['output'];
  rightType: PensionsMandatoryInvestmentOptionsRightType;
};

/** The type of pension investment option. */
export enum PensionsMandatoryInvestmentOptionsRightType {
  RESTRICTED_PRIVATE = 'RESTRICTED_PRIVATE',
  SPECIFIED_ADDITIONAL = 'SPECIFIED_ADDITIONAL',
  UNKNOWN = 'UNKNOWN',
  UNRESTRICTED_PRIVATE = 'UNRESTRICTED_PRIVATE'
}

export type PensionsPaymentPlan = {
  __typename: 'PensionsPaymentPlan';
  /** Breakdown of how payments will be payed out. */
  allocationBreakdown: Array<PensionsPaymentPlanAllocation>;
  /** Translated plan name */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** How much of the payment plan will be available for inheritance. Represented as a 'whole' number e.g 45 = 45% */
  inheritedPercentage: Scalars['Float']['output'];
};

export type PensionsPaymentPlanAllocation = {
  __typename: 'PensionsPaymentPlanAllocation';
  payoutAge: PensionsPaymentPlanAllocationAge;
  /** Percentage of payment plan. Represented as a 'whole' number e.g 45 = 45% */
  percentage: Scalars['Float']['output'];
  type: PensionsApplicationsAllocationRightType;
};

/** Single payments only have a 'startAge' that represents when the payment can be withdrawn. Monthly payments with an end age are payed out monthly in that age-range. Monthly payments without end age are payed out from the startAge to end of life. */
export type PensionsPaymentPlanAllocationAge = {
  __typename: 'PensionsPaymentPlanAllocationAge';
  /** Is null in two cases, when the type is single payment and when the payment duration is til end of life. */
  endAge: Maybe<Scalars['Int']['output']>;
  startAge: Scalars['Int']['output'];
  type: PensionsPaymentPlanAllocationAgeType;
};

/** How the payment plan pays out */
export enum PensionsPaymentPlanAllocationAgeType {
  MONTHLY_PAYMENTS = 'MONTHLY_PAYMENTS',
  SINGLE_PAYMENT = 'SINGLE_PAYMENT'
}

/** The query parameters that were applied to fetch the pension payments in this connection. */
export type PensionsPaymentsAppliedQuery = {
  __typename: 'PensionsPaymentsAppliedQuery';
  period: CalendarPeriod;
};

/** The query parameters that were applied to fetch the pension returns */
export type PensionsReturnsAppliedQuery = {
  __typename: 'PensionsReturnsAppliedQuery';
  period: CalendarPeriod;
};

export type PensionsRight = {
  __typename: 'PensionsRight';
  ageGroupedBreakdown: Array<PensionsRightBreakdown>;
  amount: Scalars['Float']['output'];
  /** @deprecated Reason: Use `ageGroupedBreakdown` instead, logic was moved to the API with minor changes to calculations. Since: 2024-09-24. Removed: 2025-??-??. Issue to remove it: WEB-28527 */
  breakdown: Array<PensionsRightBreakdown>;
  id: Scalars['ID']['output'];
};

export type PensionsRightBreakdown = {
  __typename: 'PensionsRightBreakdown';
  amount: Scalars['Float']['output'];
  /** Null if the payment lasts a lifetime */
  endAge: Maybe<Scalars['Int']['output']>;
  startAge: Scalars['Int']['output'];
};

export type PensionsRights = {
  __typename: 'PensionsRights';
  id: Scalars['ID']['output'];
  inherited: Maybe<PensionsRight>;
  mutualMonthly: Maybe<PensionsRight>;
  restrictedPrivate: Maybe<PensionsRight>;
  specifiedAdditional: Maybe<PensionsRight>;
  supplementary: Maybe<PensionsRight>;
  unrestrictedPrivate: Maybe<PensionsRight>;
};

export type PensionsSupplementaryApplicationInput = {
  contributionPercentage: PensionApplicationsContributionPercentageNumber;
  email: Scalars['String']['input'];
  fundId: Scalars['ID']['input'];
  fundTermination?: InputMaybe<PensionApplicationPreviousFundTerminationInput>;
  investmentOptionId: Scalars['ID']['input'];
  /** National id of the company (kennitala) */
  payerId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PensionsSupplementaryContractInformation = {
  __typename: 'PensionsSupplementaryContractInformation';
  /** Does the user have an active contract? */
  active: Scalars['Boolean']['output'];
  /** Payout duration for the specific contract type, currently hardcoded */
  payoutDuration: Scalars['Int']['output'];
  /** The age when payout starts, currently hardcoded */
  payoutStarts: Scalars['Float']['output'];
};

export type PensionsSupplementaryInvestmentOptionsRight = PensionsInvestmentOptionsRightInterface & {
  __typename: 'PensionsSupplementaryInvestmentOptionsRight';
  amount: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fund: PensionFund;
  id: Scalars['ID']['output'];
  /** The name of the investment plan */
  investmentPlan: Scalars['String']['output'];
  rightType: PensionsSupplementaryInvestmentOptionsRightType;
};

/** The type of pension investment option. */
export enum PensionsSupplementaryInvestmentOptionsRightType {
  INHERITED = 'INHERITED',
  SUPPLEMENTARY = 'SUPPLEMENTARY',
  UNKNOWN = 'UNKNOWN'
}

export type PensionsSupplementaryPayout = {
  payoutAge: Scalars['Int']['input'];
  /** A age range from 1 - 10. Null means a single payment */
  payoutDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type PensionsUnrestrictedPrivatePayout = {
  payoutDuration: Scalars['Int']['input'];
};

export enum PepType {
  Ambassador = 'Ambassador',
  CentralBankMember = 'CentralBankMember',
  Ceo = 'Ceo',
  Congressman = 'Congressman',
  General = 'General',
  Judge = 'Judge',
  Minister = 'Minister',
  PublicFigure = 'PublicFigure',
  UNKNOWN = 'UNKNOWN'
}

/** Endurtekin millifærsla */
export type PeriodicCreditTransfer = Node & PeriodicPaymentInterface & {
  __typename: 'PeriodicCreditTransfer';
  creditorAccount: CreditorAccountType;
  /** Day of execution in the form DD. [ 01, 02, ..., 31 ] */
  dayOfExecution: Scalars['String']['output'];
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  frequency: PaymentFrequency;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  status: Maybe<PeriodicPaymentStatus>;
  transactionBank: Maybe<Scalars['String']['output']>;
  type: Maybe<PeriodicPaymentType>;
  validity: Maybe<PeriodicPaymentValidityType>;
};

export type PeriodicCreditTransferInitialPaymentData = Node & PeriodicPaymentInterface & {
  __typename: 'PeriodicCreditTransferInitialPaymentData';
  creditorAccount: CreditorAccountType;
  /** Day of execution in the form DD. [ 01, 02, ..., 31 ] */
  dayOfExecution: Scalars['String']['output'];
  debtorAccount: Account;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for account statement (Skýring) */
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  frequency: PaymentFrequency;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Scalars['String']['output'];
  status: Maybe<PeriodicPaymentStatus>;
  transactionBank: Maybe<Scalars['String']['output']>;
  type: Maybe<PeriodicPaymentType>;
  validity: Maybe<PeriodicPaymentValidityType>;
};

export type PeriodicPayment = Node & PeriodicPaymentInterface & {
  __typename: 'PeriodicPayment';
  creditorAccount: CreditorAccountType;
  debtorAccount: Account;
  debtorAccountNumber: Scalars['String']['output'];
  detailedPayment: Maybe<DetailedPeriodicPaymentUnion>;
  errorSubject: Maybe<Scalars['String']['output']>;
  estimatedRemainingPayments: Maybe<Scalars['Int']['output']>;
  frequency: PaymentFrequency;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  payments: PaymentsByPeriodicPaymentConnection;
  recipientName: Maybe<Scalars['String']['output']>;
  status: Maybe<PeriodicPaymentStatus>;
  transactionBank: Maybe<Scalars['String']['output']>;
  type: Maybe<PeriodicPaymentType>;
  validity: Maybe<PeriodicPaymentValidityType>;
};


export type PeriodicPaymentPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PeriodicPaymentArgsFilterArgs = {
  creditorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  debtorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PeriodicPaymentInputStatus>;
  type?: InputMaybe<PeriodicPaymentType>;
};

export type PeriodicPaymentConnection = {
  __typename: 'PeriodicPaymentConnection';
  edges: Array<PeriodicPaymentEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PeriodicPaymentEdge = {
  __typename: 'PeriodicPaymentEdge';
  cursor: Scalars['String']['output'];
  node: PeriodicPayment;
};

export type PeriodicPaymentInitiation = Node & {
  __typename: 'PeriodicPaymentInitiation';
  errorSubject: Maybe<PaymentInitiationErrorSubject>;
  id: Scalars['ID']['output'];
  /** Temporary data for periodic payment if it has not been created yet */
  initialPaymentData: Maybe<InitialPeriodicPaymentDataUnion>;
  initiationType: InitiationType;
  periodicPayment: Maybe<PeriodicPayment>;
  periodicPaymentId: Maybe<Scalars['String']['output']>;
  periodicPaymentStatus: PeriodicPaymentStatus;
  periodicPaymentType: PeriodicPaymentType;
  pisId: Scalars['String']['output'];
  status: InitiationStatus;
};

export enum PeriodicPaymentInputStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED'
}

/** Interface for all periodic payment objects to implement */
export type PeriodicPaymentInterface = {
  creditorAccount: CreditorAccountType;
  debtorAccountNumber: Scalars['String']['output'];
  errorSubject: Maybe<Scalars['String']['output']>;
  frequency: PaymentFrequency;
  instructedAmount: CurrencyAmount;
  nextPaymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  recipientName: Maybe<Scalars['String']['output']>;
  status: Maybe<PeriodicPaymentStatus>;
  transactionBank: Maybe<Scalars['String']['output']>;
  type: Maybe<PeriodicPaymentType>;
  validity: Maybe<PeriodicPaymentValidityType>;
};

export type PeriodicPaymentNotFound = Error & {
  __typename: 'PeriodicPaymentNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum PeriodicPaymentStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Closed = 'Closed',
  Received = 'Received',
  Rejected = 'Rejected',
  Unknown = 'Unknown'
}

export enum PeriodicPaymentType {
  AbGiroPayment = 'AbGiroPayment',
  CGiroPayment = 'CGiroPayment',
  CardDeposit = 'CardDeposit',
  CharityPayment = 'CharityPayment',
  CreditTransfer = 'CreditTransfer',
  CreditTransferIndexed = 'CreditTransferIndexed',
  ExternalLoanDeposit = 'ExternalLoanDeposit',
  ExternalLoanDepositIndexed = 'ExternalLoanDepositIndexed',
  LoanDeposit = 'LoanDeposit',
  LoanDepositIndexed = 'LoanDepositIndexed',
  LoanDepositOld = 'LoanDepositOld',
  Mobile = 'Mobile',
  MobileTopUp = 'MobileTopUp',
  None = 'None',
  PaymentService = 'PaymentService',
  SavingsPlan = 'SavingsPlan',
  SavingsSweeping = 'SavingsSweeping',
  SavingsSweepingDC = 'SavingsSweepingDC',
  Sweeping = 'Sweeping',
  SweepingDC = 'SweepingDC',
  TransferToOwnAccount = 'TransferToOwnAccount'
}

export type PeriodicPaymentValidityType = {
  __typename: 'PeriodicPaymentValidityType';
  endDate: Maybe<Scalars['DateTimeISO']['output']>;
  startDate: Scalars['DateTimeISO']['output'];
  totalAmount: Maybe<Scalars['Float']['output']>;
  totalNumberOfPayments: Maybe<Scalars['Float']['output']>;
};

export type PermissionsAuthorizationFilter = {
  /** Search string to filter services */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter to only show services with access */
  withAccessOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Detail information for person insurance, "Barnatrygging", "Líftrygging". */
export type PersonInsurancePolicyPreview = {
  __typename: 'PersonInsurancePolicyPreview';
  documents: Array<InsurancePolicyDocumentMeta>;
  /** The insurance amount */
  insuranceAmount: Maybe<CurrencyAmount>;
  name: Scalars['String']['output'];
};

/** User's phone data */
export type Phone = {
  __typename: 'Phone';
  id: Scalars['ID']['output'];
  isMobile: Scalars['Boolean']['output'];
  isVerified: Maybe<Scalars['Boolean']['output']>;
  number: Scalars['String']['output'];
};

/** Status of a RSA phone call step up */
export enum PhoneCallStepUpStatus {
  Pending = 'Pending',
  Success = 'Success'
}

/** Phone input component */
export type PhoneFormComponent = FormComponentBase & {
  __typename: 'PhoneFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  validation: Maybe<FormComponentValidation>;
  value: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberInput = {
  /** Necessary to set it for non-Icelandic phone number. If "true" the user need verify the phone number. */
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  phoneType: PhoneType;
};

export enum PhoneType {
  Primary = 'Primary',
  Secondary = 'Secondary'
}

/** NOTE: You can only fetch one RSA object at a time. PIN cannot be fetched in a connection */
export type PinStepUpUnion = CardPin | RsaStepUpResponse;

/** Pixel density for avatar images */
export enum PixelDensity {
  /** 1x pixel density */
  X1 = 'X1',
  /** 2x pixel density */
  X2 = 'X2',
  /** 3x pixel density */
  X3 = 'X3'
}

/** Reason and type of politically exposed person */
export type PoliticallyExposedPerson = {
  __typename: 'PoliticallyExposedPerson';
  /** Reason for why user is considered PEP */
  pepReason: Scalars['String']['output'];
  /** Types of politically exposed person */
  pepType: PepType;
};

export type PoliticallyExposedPersonInput = {
  pepReason: Scalars['String']['input'];
  pepType?: InputMaybe<PepType>;
};

/** Portfolio data */
export type Portfolio = Node & {
  __typename: 'Portfolio';
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  history: Array<PortfolioHistory>;
  holdings: Array<PortfolioHolding>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  returns: PortfolioReturn;
  subscriptions: MarketSubscriptionConnection;
  type: PortfolioType;
};


/** Portfolio data */
export type PortfolioHistoryArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Portfolio data */
export type PortfolioHoldingsArgs = {
  conversionCurrency?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<HoldingFilterArgs>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Portfolio data */
export type PortfolioReturnsArgs = {
  conversionCurrency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Portfolio data */
export type PortfolioSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioBuyNotAllowed = Error & {
  __typename: 'PortfolioBuyNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Portfolio connection that includes summary information for all portfolios */
export type PortfolioConnection = {
  __typename: 'PortfolioConnection';
  edges: Array<PortfolioEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
  totalHistory: Array<PortfolioHistory>;
  totalHoldings: Array<PortfolioHolding>;
  totalReturns: PortfolioReturn;
};


/** Portfolio connection that includes summary information for all portfolios */
export type PortfolioConnectionTotalHistoryArgs = {
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Portfolio connection that includes summary information for all portfolios */
export type PortfolioConnectionTotalHoldingsArgs = {
  conversionCurrency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
  type?: InputMaybe<HoldingType>;
};


/** Portfolio connection that includes summary information for all portfolios */
export type PortfolioConnectionTotalReturnsArgs = {
  conversionCurrency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type PortfolioConvertedCurrencyReturn = {
  __typename: 'PortfolioConvertedCurrencyReturn';
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  marketValue: Scalars['Float']['output'];
};

export type PortfolioEdge = {
  __typename: 'PortfolioEdge';
  cursor: Scalars['String']['output'];
  node: Portfolio;
};

export type PortfolioFilterArgs = {
  /** Customer's kennitala */
  customerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PortfolioFilterType>;
};

/** Portfolio with active subscriptions */
export enum PortfolioFilterType {
  ActiveSubscription = 'ActiveSubscription'
}

/** History data */
export type PortfolioHistory = {
  __typename: 'PortfolioHistory';
  date: Maybe<Scalars['DateTimeISO']['output']>;
  gainLossPercentage: Maybe<Scalars['Float']['output']>;
};

/** Holding data */
export type PortfolioHolding = {
  __typename: 'PortfolioHolding';
  availableToSell: Maybe<PortfolioHoldingAvailableToSell>;
  convertedHolding: Maybe<PortfolioConvertedCurrencyReturn>;
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  endDate: Scalars['DateTimeISO']['output'];
  gainLoss: Scalars['Float']['output'];
  gainLossPercentage: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  instrument: Maybe<Instrument>;
  last: Scalars['Float']['output'];
  marketDataLink: Maybe<Scalars['String']['output']>;
  marketValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  portfolio: Maybe<Portfolio>;
  /** There is a portfolio that allows buy action for this holding */
  portfolioAllowsBuy: Scalars['Boolean']['output'];
  /** There is a portfolio that allows sell action for this holding */
  portfolioAllowsSell: Scalars['Boolean']['output'];
  /** The portfolioId of the breakdown in holding */
  portfolioId: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  /** Number of decimal places for quantity */
  quantityDecimalPlaces: Scalars['Int']['output'];
  startDate: Scalars['DateTimeISO']['output'];
  symbol: Scalars['String']['output'];
  type: HoldingType;
};

export type PortfolioHoldingAvailableToSell = {
  __typename: 'PortfolioHoldingAvailableToSell';
  /** Amount available to sell. Only for funds */
  amount: Maybe<Scalars['Float']['output']>;
  /** Quantity available to sell */
  quantity: Scalars['Float']['output'];
  /** Amount in open sell orders. Only for funds */
  reservedOrderAmount: Maybe<Scalars['Float']['output']>;
  /** Quantity in open sell orders */
  reservedOrderQuantity: Scalars['Float']['output'];
  /** Amount in unsettled sell transactions */
  reservedTransactionAmount: Maybe<Scalars['Float']['output']>;
  /** Quantity in unsettled sell transactions */
  reservedTransactionQuantity: Scalars['Float']['output'];
};

export type PortfolioHoldingConnection = {
  __typename: 'PortfolioHoldingConnection';
  /** The holding base currency */
  currency: Scalars['String']['output'];
  edges: Array<PortfolioHoldingEdge>;
  pageInfo: PageInfo;
  quantityDecimalPlaces: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalLast: Scalars['Float']['output'];
  totalMarketValue: Scalars['Float']['output'];
  totalQuantity: Scalars['Float']['output'];
};

export type PortfolioHoldingEdge = {
  __typename: 'PortfolioHoldingEdge';
  cursor: Scalars['String']['output'];
  node: PortfolioHolding;
};

export type PortfolioMarketSubscriptionNotAllowed = Error & {
  __typename: 'PortfolioMarketSubscriptionNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PortfolioNotFound = Error & {
  __typename: 'PortfolioNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PortfolioReadAccessError = Error & {
  __typename: 'PortfolioReadAccessError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PortfolioReturn = {
  __typename: 'PortfolioReturn';
  bonds: Maybe<PortfolioReturnSummary>;
  deposits: Maybe<PortfolioReturnSummary>;
  funds: Maybe<PortfolioReturnSummary>;
  stocks: Maybe<PortfolioReturnSummary>;
  total: Maybe<PortfolioReturnSummary>;
};

export type PortfolioReturnSummary = {
  __typename: 'PortfolioReturnSummary';
  assetAllocationPercentage: Scalars['Float']['output'];
  convertedReturn: Maybe<PortfolioConvertedCurrencyReturn>;
  currency: Scalars['String']['output'];
  currencyRate: Scalars['Float']['output'];
  deposit: Scalars['Float']['output'];
  gainLoss: Scalars['Float']['output'];
  gainLossPercentage: Scalars['Float']['output'];
  initialMarketValue: Scalars['Float']['output'];
  marketValue: Scalars['Float']['output'];
  paidCapitalTax: Scalars['Float']['output'];
  type: PortfolioReturnType;
  withdrawal: Scalars['Float']['output'];
};

/** Type of portfolio returns */
export enum PortfolioReturnType {
  Bond = 'Bond',
  Deposit = 'Deposit',
  Fund = 'Fund',
  Stock = 'Stock',
  Total = 'Total'
}

/** Portfolio type */
export enum PortfolioType {
  AssetManagement = 'AssetManagement',
  Custody = 'Custody',
  Storage = 'Storage'
}

export type PossibleLoan = {
  __typename: 'PossibleLoan';
  indexType: IndexType;
  interestOptions: Array<InterestOption>;
  isBaseProduct: Scalars['Boolean']['output'];
  maxNumberOfPayments: Scalars['Int']['output'];
  minNumberOfPayments: Scalars['Int']['output'];
  oneYearIndexProjection: Maybe<Scalars['Float']['output']>;
  order: Scalars['Int']['output'];
  paymentOptions: Array<PaymentOption>;
};

export type PossibleParticipants = {
  __typename: 'PossibleParticipants';
  availableRecipients: Array<AvailableRecipient>;
  canAdd: Scalars['Boolean']['output'];
};

export type PostLoanApplicationCommentInput = {
  /** A comment clarification or description, that accompanies the commentType */
  comment: Scalars['String']['input'];
  /** A comment that will be posted before the decision. Depending on the comment type, it may result in the loan application being manually  handled (by an employee of Landsbankinn). Currently only being used for corporate overdraft applications. */
  commentType: LoanApplicationCommentTypeId;
};

export type PostLoanApplicationContractInput = {
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentTypeId?: InputMaybe<Scalars['Float']['input']>;
  loanRequestId: Scalars['Float']['input'];
};

export type PostLoanApplicationDecisionInput = {
  applicationName?: InputMaybe<Scalars['String']['input']>;
  /** An optional comment field. If used, it must contain a comment as well as the commentType */
  comment?: InputMaybe<PostLoanApplicationCommentInput>;
  /** If the application will be automatically processed, then contracts will be required and an error will be returned if there is none. If the application will be manually handled (by an employee of Landsbankinn) then no contract is required for the customer to approve the application. */
  contracts?: InputMaybe<Array<PostLoanApplicationContractInput>>;
  /** In a corporate scenario: if a customer was subject to a credit assessment based on Landsbankinn data (internal Sas score) the Id of that credit assessment should be posted with the approval decision. This does not apply if the customer went through CreditInfo assessment. */
  creditAssessmentId?: InputMaybe<Scalars['String']['input']>;
  decision: Scalars['String']['input'];
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  loanApplicationId: Scalars['String']['input'];
};

/** A customers summary of pre-approved limit */
export type PreApprovedLimit = {
  __typename: 'PreApprovedLimit';
  bond: Maybe<PreApprovedLimitBond>;
  /** Ráðstöfuð lánaheimild */
  brutto: Scalars['Float']['output'];
  creditCard: Maybe<PreApprovedLimitCreditCard>;
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  id: Scalars['ID']['output'];
  /** Óráðstöfuð lánaheimild */
  netto: Scalars['Float']['output'];
  newCreditCard: Maybe<PreApprovedLimitNewCreditCard>;
  nextAssessmentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  overdraft: Maybe<PreApprovedLimitAccount>;
  overdraftBond: Maybe<PreApprovedLimitOverdraftBond>;
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
  totalCreditCardCommitment: Scalars['Float']['output'];
  totalCreditCardCreditLimit: Scalars['Float']['output'];
  totalCreditCardDebt: Scalars['Float']['output'];
  totalNonCollateralDebt: Scalars['Float']['output'];
  totalOverdraftLimit: Scalars['Float']['output'];
  totalUnusedLimit: Scalars['Float']['output'];
  totalUsedLimit: Scalars['Float']['output'];
  turnover: Scalars['Float']['output'];
  updatedBrutto: Scalars['Float']['output'];
  updatedBruttoDate: Scalars['DateTimeISO']['output'];
};


/** A customers summary of pre-approved limit */
export type PreApprovedLimitCreditCardArgs = {
  cardId: Scalars['String']['input'];
};


/** A customers summary of pre-approved limit */
export type PreApprovedLimitOverdraftArgs = {
  accountId: Scalars['String']['input'];
};


/** A customers summary of pre-approved limit */
export type PreApprovedLimitOverdraftBondArgs = {
  accountId: Scalars['String']['input'];
};

/** Pre-approved limit for bank account (overdraft) */
export type PreApprovedLimitAccount = PreApprovedLimitProduct & {
  __typename: 'PreApprovedLimitAccount';
  account: Account;
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  defaultPeriod: OverdraftDuration;
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  minAmount: Scalars['Float']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  periods: Array<OverdraftDuration>;
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  startValue: Scalars['Float']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

/** Pre-approved limit for bond */
export type PreApprovedLimitBond = PreApprovedLimitProduct & {
  __typename: 'PreApprovedLimitBond';
  /** Whether customer has too many consumer bond loans active (Aukalán) or not. If true then customer cannot apply for more in self service */
  aboveMaxConcurrentConsumerBondLoansCap: Scalars['Boolean']['output'];
  /** The fee charged for borrowing the money. This represents a percentage of the borrowed amount that the customer must pay. For example, if the borrowing fee is 2.0% and the customer borrows 100.000 ISK, the customer must pay 2.000 ISK as a borrowing fee. */
  borrowingFee: Scalars['Float']['output'];
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  maxLoanDurationMonths: Scalars['Int']['output'];
  minAmount: Scalars['Float']['output'];
  minLoanDurationMonths: Scalars['Int']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  startAmount: Scalars['Int']['output'];
  startCalculation: LoanCalculation;
  startLoanDurationMonths: Scalars['Int']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

/** Pre-approved limit for credit card */
export type PreApprovedLimitCreditCard = PreApprovedLimitProduct & {
  __typename: 'PreApprovedLimitCreditCard';
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditCard: GetCardResultUnion;
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  fee: Scalars['Float']['output'];
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  minAmount: Scalars['Float']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

export enum PreApprovedLimitDetailType {
  CalculatedFromCipType = 'CalculatedFromCipType',
  LandsbankaType = 'LandsbankaType',
  LigthCreditAssessmentType = 'LigthCreditAssessmentType',
  NoPreApprovedLimitType = 'NoPreApprovedLimitType',
  TurnOverBasedDetailType = 'TurnOverBasedDetailType'
}

/** Pre-approved limit new credit card */
export type PreApprovedLimitNewCreditCard = PreApprovedLimitProduct & {
  __typename: 'PreApprovedLimitNewCreditCard';
  availableLocations: Array<CustomerLocation>;
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  minAmount: Scalars['Float']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

/** Pre-approved limit for overdraft bond */
export type PreApprovedLimitOverdraftBond = PreApprovedLimitProduct & {
  __typename: 'PreApprovedLimitOverdraftBond';
  /** Whether customer has too many consumer bond loans active (Aukalán) or not. If true then customer cannot apply for more in self service */
  aboveMaxConcurrentConsumerBondLoansCap: Scalars['Boolean']['output'];
  account: Account;
  /** The fee charged for borrowing the money. This represents a percentage of the borrowed amount that the customer must pay. For example, if the borrowing fee is 2.0% and the customer borrows 100.000 ISK, the customer must pay 2.000 ISK as a borrowing fee. */
  borrowingFee: Scalars['Float']['output'];
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  maxLoanDurationMonths: Scalars['Int']['output'];
  minAmount: Scalars['Float']['output'];
  minLoanDurationMonths: Scalars['Int']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  startAmount: Scalars['Int']['output'];
  startCalculation: LoanCalculation;
  startLoanDurationMonths: Scalars['Int']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

/** Base class for pre-approved limit data */
export type PreApprovedLimitProduct = {
  canDecrease: Scalars['Boolean']['output'];
  canIncrease: Scalars['Boolean']['output'];
  consumerLoanAutomaticMaxAmount: Scalars['Float']['output'];
  creditLimitChangeAllowed: Scalars['Boolean']['output'];
  customerCreditWorthyList: Array<CustomerCreditWorthy>;
  defaultMinAmount: Scalars['Float']['output'];
  /** @deprecated Redundant (never referenced). Since: 2026-08-20. Issue to remove it: WEB-45158 */
  id: Scalars['ID']['output'];
  interest: Scalars['Float']['output'];
  isOwner: Scalars['Boolean']['output'];
  maxAllowedYearlyCostRatio: Scalars['Float']['output'];
  maxAmount: Scalars['Float']['output'];
  nextAssessMentType: NextAssessmentType;
  /** Charge amount for next status adjustment */
  nextStatusAdjustmentChargeAmount: Scalars['Float']['output'];
  preApprovedLimitDetailType: PreApprovedLimitDetailType;
  productOpen: Scalars['Boolean']['output'];
  /** Indicates if youth customers (18 - 24 years old) should see the scan certified step. This step is shown if the customer has an expired ID (ísl. rafræn skilríki) */
  showScanCertifiedStepForYouth: Scalars['Boolean']['output'];
  statusAdjustment: Maybe<StatusAdjustment>;
};

/** Prepaid cards widget */
export type PrepaidCardsWidget = {
  __typename: 'PrepaidCardsWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  /** Whether the widget has any cards to display */
  hasCards: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type PreviewCardLineChangePersonalError = Error & {
  __typename: 'PreviewCardLineChangePersonalError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PreviewCardLineChangePrepaidError = Error & {
  __typename: 'PreviewCardLineChangePrepaidError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type PreviewCreditCardLineChangeError = CardNotFoundError | PreviewCardLineChangePersonalError | PreviewCardLineChangePrepaidError;

/** Input to preview the cost and available amount with new credit card limit. */
export type PreviewCreditCardLineChangeInput = {
  cardId: Scalars['ID']['input'];
  newCreditCreditLine: Scalars['Float']['input'];
};

/** Payload a card's credit line change preview */
export type PreviewCreditCardLineChangePayload = {
  __typename: 'PreviewCreditCardLineChangePayload';
  /** Error returned if calculation is unsuccessful */
  error: Maybe<PreviewCreditCardLineChangeError>;
  /** Preview details of a card's credit line change */
  previewedChange: Maybe<CreditCardLineChangePreview>;
};

/** Information about mailing to the claimant */
export type PrintingAndMailingInfo = {
  __typename: 'PrintingAndMailingInfo';
  /** Determines the way we handle the mail */
  handlingOption: Scalars['Int']['output'];
  /** Comment to print in the mail */
  printedComment: Maybe<Scalars['String']['output']>;
  /** Address information to mail to */
  returnAddress: Maybe<ReturnAddress>;
};

/** Private right summary */
export type PrivateRightSummary = {
  __typename: 'PrivateRightSummary';
  /** Mandatory saving amount */
  mandatorySavingAmount: Maybe<CurrencyAmount>;
  /** Supplementary saving amount */
  supplementarySavingAmount: Maybe<CurrencyAmount>;
};

export type Product = {
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  type: ProductType;
};

export type ProductFilterArgs = {
  /** Applies to fixedInterestRateCatalog */
  classificationId?: InputMaybe<Scalars['Int']['input']>;
  indexType?: InputMaybe<Scalars['Int']['input']>;
  /** Applies to real estate loan products */
  isFirstLoan?: InputMaybe<Scalars['Boolean']['input']>;
  productType: ProductType;
  subType?: InputMaybe<ProductSubType>;
};

/** Sub types are used to filter products for a purpose, e.g. real estate loans  */
export enum ProductSubType {
  Bond = 'Bond',
  CorporateBond = 'CorporateBond',
  CreditCard = 'CreditCard',
  /** Loans for other real estate e.g. other then regular housing such as summerhouse. */
  OtherRealEstate = 'OtherRealEstate',
  RealEstate = 'RealEstate'
}

/** What type of product e.g. loan, credit card, account */
export enum ProductType {
  Account = 'Account',
  CreditCard = 'CreditCard',
  DebitCard = 'DebitCard',
  Loan = 'Loan',
  RealestateLoan = 'RealestateLoan'
}

export type ProductUnion = AccountProduct | CreditCardProduct | DebitCardProduct | LoanProduct;

/**
 * Proxy access (heimild) given to someone for a specific product and in some cases a specific item
 *     within the given product. For example a product might be bank account in which case this proxy
 *     will provide some access to a specific bank account but not all bank accounts; the id for this
 *     bank account would then be the productId. However, in some cases access is provided to the whole
 *     product. In the case of a product like unpaid bills it is not access to a specific bill but all bills.
 */
export type ProxyAccess = Node & {
  __typename: 'ProxyAccess';
  /** Read or transfer (write) access */
  accessType: ProxyAccessAccessType;
  /** Indicator for the client that the current customer can delete this access */
  canRemove: Scalars['Boolean']['output'];
  /** Date this proxy access was created */
  createdDate: Scalars['DateTimeISO']['output'];
  /** An identifier to use when requesting the document to be signed */
  documentGroupId: Maybe<Scalars['String']['output']>;
  /**
   * Human readable name of access. In some cases simply the same as the product name. For an Account product it
   *       will be a formatted Account number (i.e. 0101-26-010203). In the case of a CreditCard it will be the last 4 digits in
   *       the Card number with two stars in front of it (i.e. ** 1234).
   */
  friendlyName: Scalars['String']['output'];
  /** An identifier to use when requesting the document group */
  groupId: Maybe<Scalars['String']['output']>;
  /** Resolves a list of people that need to sign, and haven't yet, signed the document associated with this access */
  groupSigners: Maybe<Array<DocumentSigner>>;
  /** Id for proxy access that can be used to change the the access type */
  id: Scalars['ID']['output'];
  /**
   * Identifier for a specific product. This will not be null for products with productType Account and Card
   *       in which case it will be an Account number or masked Card number respectively.
   */
  productId: Maybe<Scalars['String']['output']>;
  /**
   * Banks name for a specific product. In the case of an Account and Card this will be the type of Account or Card
   *        this access holds for (i.e. 'Vaxtareikningur (30)', 'Gullkort', ...)
   */
  productName: Scalars['String']['output'];
  /** Product type this proxy access is on: Account | Card | Claim | Market | ElectronicDocument | Loan */
  productType: ProxyAccessProductType;
  /** A provider is the person who is giving access */
  provider: ProxyAccessAgent;
  /** A recipient is a person who is receiving access */
  recipient: ProxyAccessAgent;
  /**
   * Resolves a PDF document associated with this access
   * @deprecated Reason: Use recordV2 instead. Since: 2026-03-24. Issue to remove it: WEB-41705
   */
  record: Maybe<DocumentBucket>;
  /**
   * This is an identifier used to access the signed proxy access document in the case a signature was needed
   *       to create the proxy access
   */
  recordId: Maybe<Scalars['String']['output']>;
  /** Resolves a PDF document associated with this access */
  recordV2: Maybe<GenericFile>;
  /** Status of this proxy access */
  status: ProxyAccessStatus;
};

/** Read or transfer (write) access */
export enum ProxyAccessAccessType {
  READ = 'READ',
  TRANSFER = 'TRANSFER'
}

/** A provider or a recipient of a proxy access */
export type ProxyAccessAgent = {
  __typename: 'ProxyAccessAgent';
  /** Kennitala of provider or recipient */
  kennitala: Scalars['String']['output'];
  /** Name of provider or recipient */
  name: Scalars['String']['output'];
};

/** A provider or a recipient of a proxy access */
export type ProxyAccessApproverType = {
  /** Email of recipient or approver */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Kennitala of recipient or approver */
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of recipient or approver */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** A connection for a list of ProxyAccess objects */
export type ProxyAccessConnection = {
  __typename: 'ProxyAccessConnection';
  edges: Array<ProxyAccessEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProxyAccessEdge = {
  __typename: 'ProxyAccessEdge';
  cursor: Scalars['String']['output'];
  node: ProxyAccess;
};

/** A family member associated with a proxy access */
export type ProxyAccessFamilyMember = {
  __typename: 'ProxyAccessFamilyMember';
  /** If this family member is a customer of Landsbankinn this email will be filled out */
  email: Maybe<Scalars['String']['output']>;
  /** Indicator if this family member is a customer of Landsbankinn */
  isCustomer: Scalars['Boolean']['output'];
  /** Kennitala for this family member */
  kennitala: Scalars['String']['output'];
  /** The full name of this family member */
  name: Scalars['String']['output'];
  /** If this family member is a customer of Landsbankinn this phone number will be filled out */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** This family members connection to the current customer (i.e. spouse, child, ...)  */
  type: ProxyAccessFamilyMemberType;
};

/** A family connection to the current customer (i.e. spouse, child, ...) */
export enum ProxyAccessFamilyMemberType {
  CHILD = 'CHILD',
  CUSTODIAN = 'CUSTODIAN',
  SIBLING = 'SIBLING',
  SPOUSE = 'SPOUSE'
}

/** This input contains information used to filter proxy accesses. */
export type ProxyAccessFilterArgs = {
  /** Contains status for the returned proxy accesses */
  status: Array<ProxyAccessStatus>;
};

/** Contains a proxy provider/recipient and the proxies associated with them */
export type ProxyAccessGroup = {
  __typename: 'ProxyAccessGroup';
  /** List of accesses held by the given proxy holder */
  access: Array<ProxyAccess>;
  /** Either a provider or recipient of each of the accesses in this group */
  agent: ProxyAccessAgent;
};

/**
 * A way to fetch all accesses, in some way associated with the current user, in a single list or grouped by their respective
 *     recipients or providers. We resolve this in viewer.resolver as field proxyAccessGroups.
 */
export type ProxyAccessGroups = {
  __typename: 'ProxyAccessGroups';
  /** List of proxy accesses, null if no access is available */
  accessList: Maybe<ProxyAccessConnection>;
  /** A List of accesses grouped by the provider of said access */
  providers: Array<ProxyAccessGroup>;
  /** A List of accesses grouped by the recipient of said access */
  recipients: Array<ProxyAccessGroup>;
};


/**
 * A way to fetch all accesses, in some way associated with the current user, in a single list or grouped by their respective
 *     recipients or providers. We resolve this in viewer.resolver as field proxyAccessGroups.
 */
export type ProxyAccessGroupsAccessListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Indicates if lookup for proxy access recipient's kennitala was successful or not. */
export type ProxyAccessKennitalaLookupResponse = {
  __typename: 'ProxyAccessKennitalaLookupResponse';
  /** Holds reason for why lookup for proxy access recipient's kennitala was not successful. */
  reason: Maybe<Scalars['String']['output']>;
  /** Tells if lookup for proxy access recipient's kennitala was successful or not. */
  success: Scalars['Boolean']['output'];
};

/** Holds proxy access list including all proxy accesses available to the customer. */
export type ProxyAccessList = {
  __typename: 'ProxyAccessList';
  /** List of proxy accesses associated with current user */
  accessList: Array<ProxyAccess>;
};

/** Bank product this proxy access is on (i.e Account, Card, ...) */
export enum ProxyAccessProductType {
  ACCOUNT = 'ACCOUNT',
  CARD = 'CARD',
  CLAIM = 'CLAIM',
  ELECTRONICDOCUMENT = 'ELECTRONICDOCUMENT',
  LOAN = 'LOAN',
  MARKET = 'MARKET',
  PAYMENTSERVICE = 'PAYMENTSERVICE',
  UNKNOWN = 'UNKNOWN'
}

/** Status of proxy access (i.e. Active, Inactive, ...) */
export enum ProxyAccessStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  INACTIVE = 'INACTIVE',
  NEW = 'NEW',
  PENDING = 'PENDING',
  UNKNOWN = 'UNKNOWN'
}

/** Holds proxy access list and other information for a specific product type. */
export type ProxyAccessesForProduct = {
  __typename: 'ProxyAccessesForProduct';
  /** List of proxy accesses associated with current user */
  accessList: Array<ProxyAccess>;
  /** Whether or not the user can add read accesses */
  canAddReadAccess: Scalars['Boolean']['output'];
  /** Whether or not the user can add transfer accesses */
  canAddTransferAccess: Scalars['Boolean']['output'];
  /** List of family members associated with current user */
  familyMembers: Array<ProxyAccessFamilyMember>;
  /** Number of proxy accesses */
  numberOfProxyAccesses: Scalars['Float']['output'];
};

export enum ProxyStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  CancelledBeforeActivation = 'CancelledBeforeActivation',
  Expired = 'Expired',
  Waiting = 'Waiting'
}

/** Wrapper for push notifications for mobile. */
export type PushNotifications = {
  __typename: 'PushNotifications';
  /** Notification settings on all of customers accounts. */
  accounts: AccountsPushNotificationsSettings;
  claims: Maybe<ClaimsSubscriptions>;
  marketNotifications: Maybe<Array<MarketsPushNotificationSetting>>;
  savings: Maybe<Scalars['Boolean']['output']>;
};

/** Interface for push notification enabled setting. */
export type PushNotificationsEnabledSetting = {
  /** Flag indicating whether a push notification setting is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** Push notification settings object representing a flag indicating whether teh setting is enabled or not. */
export type PushNotificationsSetting = PushNotificationsEnabledSetting & {
  __typename: 'PushNotificationsSetting';
  /** Flag indicating whether a push notification setting is enabled. */
  enabled: Scalars['Boolean']['output'];
};

/** Push notification settings object representing a flag indicating whether the setting is enabled or not and a minimum amount for a notification to be triggered. */
export type PushNotificationsSettingWithAmount = PushNotificationsEnabledSetting & {
  __typename: 'PushNotificationsSettingWithAmount';
  /** Flag indicating whether a push notification setting is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** Minimum amount for a notification to be triggered. */
  minimumAmount: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename: 'Query';
  accountProductApplicantPrerequisites: Array<AccountProductPrerequisite>;
  /**
   * A query to make it possible to get the product service fees without querying the base api request, therefore making it work without authentication
   * @deprecated Reason: Use accountProductServiceFeesDocumentV2 instead. Since: 2026-03-18. Issue to remove it: WEB-41573
   */
  accountProductServiceFeesDocument: Maybe<DocumentBucket>;
  /** A query to make it possible to get the product service fees without querying the base api request, therefore making it work without authentication */
  accountProductServiceFeesDocumentV2: Maybe<GenericFile>;
  acquiringEcommerces: Array<AcquiringEcommerce>;
  acquiringTerminals: Array<AcquiringTerminal>;
  aukakronurCustomerLookup: AukakronurCustomerLookupResponse;
  aukakronurPartners: AukakronurPartnerConnection;
  /** Fetches all retail types for aukakronur partners */
  aukakronurRetailTypes: Array<AukakronurRetailType>;
  bondLoanCalculator: LoanCalculation;
  bonds: BondConnection;
  calculatePension: PensionCalculation;
  /** Calculates and returns the time difference between the client and server, along with the current server time. */
  calculateTimeOffset: TimeSyncStatus;
  carLoanCalculator: LoanCalculation;
  centralBankCategoryCodes: CentralBankCategoryCodeConnection;
  centralBankRates: CentralBankRateConnection;
  /** Result of claim lookup */
  claimLookup: ClaimLookupResponse;
  collectionCompanies: CollectionCompanyConnection;
  consultationServices: Array<ConsultationService>;
  contactOccupations: ContactOccupationConnection;
  /** To get a conversation after a certain response or if no response id is provided, it gets the whole conversation. */
  conversationUpdate: Maybe<CustomerConversation>;
  countryDialCodes: CountryDialCodeConnection;
  creditAssessmentCalculator: CreditAssessmentCalculation;
  creditAssessmentFees: CreditAssessmentFees;
  creditCardBalanceLookup: LookupCreditcardAvailableBalance;
  creditCardProductApplicationDocument: CreditCardProductApplicationDocument;
  creditCardfees: CreditCardFees;
  crossBorderCurrencies: CrossBorderCurrencies;
  currencyExchangeMarket: CurrencyExchangeMarketOpeningTime;
  /** To get CustomContent by model id. */
  customContent: Maybe<CustomContent>;
  customerLocations: CustomerLocationConnection;
  customerLookup: Maybe<CustomerResponse>;
  customerOccupations: CustomerOccupationConnection;
  /** Given an account number and a kennitala, this lookup query will return some basic information regarding the account (if the data matches and is valid). */
  depositAccountLookup: Maybe<DepositAccountLookupPayload>;
  directDebitMandateFees: DirectDebitMandateFee;
  disclaimer: Maybe<GenericFile>;
  employeeSearch: EmployeeSearchConnection;
  exchangeRates: ExchangeRateConnection;
  /** Get calculation result for possible vehicle loans */
  externalVehicleLoanCalculation: ExternalVehicleLoanCalculationResultPayload;
  /** Feature flag lookup */
  featureLookup: FeatureLookupResponse;
  /** Find all banks the fedwire code routes to */
  fedwireBankInformationSearch: Array<ForeignBankInformation>;
  /** To get the feedback status by invitation id. */
  feedbackInvitation: FeedbackInvitation;
  fees: Array<Fee>;
  foreignExchangeMarket: ForeignExchangeMarket;
  /** Get all available form templates */
  formTemplates: FormTemplateConnection;
  funds: FundConnection;
  getEmailLists: EmailLists;
  getOnboardingCorporateApplicationDocumentContent: Scalars['String']['output'];
  giftCardLookupByBin: GiftCardLookupResponse;
  giftCardLookupByCardNumber: GiftCardLookupResponse;
  /** Find bank registered for the account IBAN */
  ibanBankInformationLookup: IbanBankInformationResponse;
  ibanStructures: Array<IbanStructure>;
  indexations: IndexationConnection;
  indices: IndiceConnection;
  /** To get PolicyPreview by model id. */
  insurancePolicyPreview: Maybe<InsurancePolicyPreview>;
  interestRates: Array<InterestRate>;
  intradayHistory: Array<IntradayHistory>;
  invoiceBatchExcelTemplate: Maybe<CreateInvoiceBatchFromExcelTemplatePayload>;
  isPossibleDuplicateDomesticCreditTransfer: IsPossibleDuplicateDomesticCreditTransferPayload;
  loanPaymentFees: LoanPaymentFees;
  /** Get loyalty program information including all levels and detail pages */
  loyaltyProgramInfo: Maybe<LoyaltyProgramInfo>;
  /** Get Market Indicators */
  marketIndicators: MarketIndicators;
  marketNews: MarketDataNewsConnection;
  nationalRegistryKennitalaLookup: NationalRegistryEntryResponse;
  nationalRegistrySearch: NationalRegistryEntryConnection;
  node: Maybe<Node>;
  /** The companies that the current contact is authorized to onboard. */
  onboardingCompanies: OnboardingCompanyConnection;
  /** Get the group id for digital signature for onboarding. Returns null if no group is found */
  onboardingCorporateDigitalSignatureGroupId: Maybe<Scalars['ID']['output']>;
  onboardingPrerequisites: OnboardingPrerequisites;
  /** PDF document (as a base64 string) for terms and conditions. */
  onboardingTermsAndConditionsPdfDocument: Maybe<Scalars['String']['output']>;
  /** Returns all configured components with their operational status and other meta data */
  operationalStatus: Array<OperationalStatus>;
  /** Returns all configured components with their operational status and other meta data */
  operationalStatusV2: Array<OperationalStatus>;
  /** Excel document that can be downloaded and used as a template for creating paid leave accounts */
  paidLeaveAccountsExcelTemplate: GenericFile;
  paidLeaveAccountsv2: PaidLeaveAccountsv2;
  paymentCategoryCodes: PaymentCategoryCodeConnection;
  paymentDisclaimer: PaymentDisclaimer;
  /** Fetches all available payment service providers */
  paymentServiceProviders: Array<PaymentServiceProvider>;
  /** Excel document that can be downloaded and used as a template for creating employees */
  payrollEmployessExcelDocumentTemplate: Maybe<DocumentBucket>;
  pensionInvestmentOptions: Maybe<Array<PensionsInvestmentOption>>;
  /** PDF document (as a base64 string) for privacy policy. */
  privacyPolicyPdfDocument: Maybe<Scalars['String']['output']>;
  products: Array<ProductUnion>;
  realEstateLoanCalculator: LoansCalculations;
  /** Returns the most common max mortgage ratios for real estate loans. Useful to display to users that have not created loan requests. */
  realEstateLoanMaxMortgageRatios: RealEstateLoanMaxMortgageRatios;
  realEstateLookup: RealEstateLookupResponse;
  realEstateSearch: Array<RealEstate>;
  savingGoalCatalog: SavingsGoalCatalog;
  savingGoals: SavingGoalConnection;
  searchContent: ContentSearchConnection;
  securityQuestions: SecurityQuestionConnection;
  sepaPaymentFees: SepaPaymentFees;
  serverTime: Scalars['DateTimeISO']['output'];
  servicePoints: ServicePointConnection;
  stocks: StockConnection;
  /** Find bank by its Swift/BIC code */
  swiftBankInformationLookup: SwiftBankInformationResponse;
  swiftPaymentFees: SwiftPaymentFees;
  /** @deprecated Reason: Use termsAndConditionsPdfDocumentV2 instead. Since: 2026-03-18. Issue to remove it: WEB-41565 */
  termsAndConditionsPdfDocument: Maybe<DocumentBucket>;
  termsAndConditionsPdfDocumentV2: Maybe<GenericFile>;
  viewer: Viewer;
};


export type QueryAccountProductApplicantPrerequisitesArgs = {
  kennitala?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAccountProductServiceFeesDocumentArgs = {
  accountProductId: Scalars['String']['input'];
};


export type QueryAccountProductServiceFeesDocumentV2Args = {
  accountProductId: Scalars['String']['input'];
};


export type QueryAcquiringEcommercesArgs = {
  sortBy?: InputMaybe<AcquiringEcommerceOrderBy>;
};


export type QueryAcquiringTerminalsArgs = {
  sortBy?: InputMaybe<AcquiringTerminalOrderBy>;
};


export type QueryAukakronurCustomerLookupArgs = {
  kennitala: Scalars['String']['input'];
};


export type QueryAukakronurPartnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AukakronurPartnersFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AukakronurPartnerOrderBy>;
};


export type QueryBondLoanCalculatorArgs = {
  bondFee?: InputMaybe<Scalars['Float']['input']>;
  disbursementDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  firstPaymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexType?: InputMaybe<IndexType>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  isCorporateLoan?: InputMaybe<Scalars['Boolean']['input']>;
  loanAmount: Scalars['Float']['input'];
  loanDuration?: InputMaybe<Scalars['Int']['input']>;
  loanFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  loanPaymentType?: InputMaybe<LoanProductPaymentType>;
  monthsBetweenPayments?: InputMaybe<Scalars['Int']['input']>;
  oneYearIndexProjection?: InputMaybe<Scalars['Float']['input']>;
  paymentFeePerPayment?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryBondsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<BondOrder>;
};


export type QueryCalculatePensionArgs = {
  input: PensionCalculationInput;
};


export type QueryCalculateTimeOffsetArgs = {
  data: CalculateTimeOffsetInput;
};


export type QueryCarLoanCalculatorArgs = {
  emissionType?: InputMaybe<VehicleEmissionType>;
  loanAmount: Scalars['Float']['input'];
  loanDuration: Scalars['Float']['input'];
  marketValue: Scalars['Float']['input'];
  type?: InputMaybe<CarLoanType>;
};


export type QueryCentralBankCategoryCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<CentralBankCategoryCodeRank>;
};


export type QueryCentralBankRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClaimLookupArgs = {
  bankAndLedger: Scalars['String']['input'];
  claimDueDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  claimantkennitala: Scalars['String']['input'];
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  payorKennitala: Scalars['String']['input'];
  slipNumber: Scalars['String']['input'];
};


export type QueryCollectionCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConsultationServicesArgs = {
  consultationType?: InputMaybe<ConsultationType>;
  customerType?: InputMaybe<SmartBookingCustomerType>;
};


export type QueryContactOccupationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationUpdateArgs = {
  id: Scalars['ID']['input'];
  responseId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCountryDialCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreditAssessmentCalculatorArgs = {
  childrenCount?: InputMaybe<Scalars['Int']['input']>;
  customer: CreditAssessmentCalculatorCustomerArgs;
  equity?: InputMaybe<Scalars['Float']['input']>;
  otherExpenses?: InputMaybe<Scalars['Float']['input']>;
  otherIncome?: InputMaybe<Scalars['Float']['input']>;
  otherLoansPayment?: InputMaybe<Scalars['Float']['input']>;
  spouse?: InputMaybe<CreditAssessmentCalculatorCustomerArgs>;
  vehicleCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreditCardBalanceLookupArgs = {
  bin: Scalars['String']['input'];
};


export type QueryCreditCardProductApplicationDocumentArgs = {
  contractId: Scalars['String']['input'];
};


export type QueryCustomContentArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeIceland?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerLookupArgs = {
  includeBirthplace?: InputMaybe<Scalars['Boolean']['input']>;
  kennitala: Scalars['String']['input'];
};


export type QueryCustomerOccupationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDepositAccountLookupArgs = {
  data: DepositAccountLookupInput;
};


export type QueryDisclaimerArgs = {
  disclaimerType: DisclaimerType;
};


export type QueryEmployeeSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
};


export type QueryExchangeRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTimeISO']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  quoteCurrency: Scalars['String']['input'];
  source?: InputMaybe<ExchangeRateSource>;
};


export type QueryExternalVehicleLoanCalculationArgs = {
  data: ExternalVehicleLoanCalculationInput;
};


export type QueryFeatureLookupArgs = {
  featureType: FeatureType;
};


export type QueryFedwireBankInformationSearchArgs = {
  fedwire: Scalars['String']['input'];
  uniqueCities?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFeedbackInvitationArgs = {
  invitationId: Scalars['String']['input'];
};


export type QueryFormTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<FundOrder>;
};


export type QueryGetOnboardingCorporateApplicationDocumentContentArgs = {
  data: OnboardingCorporateApplicationDocumentContentInput;
};


export type QueryGiftCardLookupByBinArgs = {
  bin: Scalars['String']['input'];
};


export type QueryGiftCardLookupByCardNumberArgs = {
  captchaResponse?: InputMaybe<Scalars['String']['input']>;
  cardNumber: Scalars['String']['input'];
  cvv: Scalars['String']['input'];
};


export type QueryIbanBankInformationLookupArgs = {
  iban: Scalars['String']['input'];
};


export type QueryIbanStructuresArgs = {
  filter?: InputMaybe<IbanStructureFilterArgs>;
};


export type QueryIndexationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIndicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInsurancePolicyPreviewArgs = {
  policyNumber: Scalars['String']['input'];
};


export type QueryInterestRatesArgs = {
  filter?: InputMaybe<InterestRateFilterArgs>;
};


export type QueryIntradayHistoryArgs = {
  filter?: InputMaybe<SecuritiesHistoryFilter>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


export type QueryIsPossibleDuplicateDomesticCreditTransferArgs = {
  data: IsPossibleDuplicateDomesticCreditTransferInput;
};


export type QueryMarketNewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  lang?: InputMaybe<MarketDataNewsLanguageFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
  symbol: Scalars['String']['input'];
};


export type QueryNationalRegistryKennitalaLookupArgs = {
  kennitala: Scalars['String']['input'];
  type?: InputMaybe<NationalRegistrySearchType>;
};


export type QueryNationalRegistrySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NationalRegistryOrderBy>;
  query: Scalars['String']['input'];
  type?: InputMaybe<NationalRegistrySearchType>;
};


export type QueryNodeArgs = {
  id: Scalars['String']['input'];
};


export type QueryOnboardingCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OnboardingCompaniesOrderBy>;
};


export type QueryOnboardingCorporateDigitalSignatureGroupIdArgs = {
  data: GetOnboardingCorporateDigitalSignatureGroupInput;
};


export type QueryOnboardingTermsAndConditionsPdfDocumentArgs = {
  data: OnboardingTermsAndConditionsPdfDocumentInput;
};


export type QueryOperationalStatusArgs = {
  filter?: InputMaybe<OperationalStatusFilterArgs>;
};


export type QueryOperationalStatusV2Args = {
  filter?: InputMaybe<OperationalStatusFilterArgs>;
};


export type QueryPaymentCategoryCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentServiceProvidersArgs = {
  filter?: InputMaybe<PaymentServiceProviderFilterArgs>;
};


export type QueryPensionInvestmentOptionsArgs = {
  filter?: InputMaybe<PensionsInvestmentOptionsFilterArgs>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilterArgs>;
};


export type QueryRealEstateLoanCalculatorArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  indexedPercentage: Scalars['Float']['input'];
  indexedPrimaryLoanOption?: InputMaybe<RealEstateLoanOptionInput>;
  isFirstRealEstate: Scalars['Boolean']['input'];
  isRefinancing: Scalars['Boolean']['input'];
  marketValue: Scalars['Float']['input'];
  nonIndexExtraLoanOption?: InputMaybe<RealEstateLoanOptionInput>;
  nonIndexedPrimaryLoanOption?: InputMaybe<RealEstateLoanOptionInput>;
  totalLoanAmount: Scalars['Float']['input'];
};


export type QueryRealEstateLookupArgs = {
  registrationNumber: Scalars['String']['input'];
};


export type QueryRealEstateSearchArgs = {
  assessmentFloorUnit?: InputMaybe<Scalars['String']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  streetName?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySavingGoalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchContentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchQuery: Scalars['String']['input'];
  siteSearch?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySecurityQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  questionIndex: Scalars['Int']['input'];
};


export type QuerySepaPaymentFeesArgs = {
  countryCode: Scalars['String']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServicePointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  atmTypes?: InputMaybe<Array<AtmType>>;
  before?: InputMaybe<Scalars['String']['input']>;
  branchServices?: InputMaybe<Array<BranchServices>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Region>;
  service?: InputMaybe<ServicePointType>;
};


export type QueryStocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  exchange?: InputMaybe<ExchangeSymbol>;
  filter?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<StockOrder>;
  realTime?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySwiftBankInformationLookupArgs = {
  swift: Scalars['String']['input'];
};


export type QuerySwiftPaymentFeesArgs = {
  countryCode: Scalars['String']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
};

/** Radio component */
export type RadioFormComponent = FormComponentBase & {
  __typename: 'RadioFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  options: Array<FormSelectOption>;
  placeholder: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export type RealEstate = Node & {
  __typename: 'RealEstate';
  details: Maybe<RealEstateDetails>;
  id: Scalars['ID']['output'];
  /** A town or district that has local government */
  municipality: Maybe<RealEstateLand>;
};

export type RealEstateDetails = {
  __typename: 'RealEstateDetails';
  /** 101, 102, etc */
  assessmentFloorUnit: Maybe<Scalars['String']['output']>;
  /** Registration number (Fastanúmer) */
  assessmentNumber: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  /** Street number */
  number: Maybe<Scalars['String']['output']>;
};

export type RealEstateDoesNotExistError = Error & {
  __typename: 'RealEstateDoesNotExistError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Detail information for real estate insurance */
export type RealEstateInsurancePolicyPreview = {
  __typename: 'RealEstateInsurancePolicyPreview';
  address: Maybe<Scalars['String']['output']>;
  documents: Array<InsurancePolicyDocumentMeta>;
  /** The insurance amount */
  insuranceAmount: Maybe<CurrencyAmount>;
  unitLabel: Maybe<Scalars['String']['output']>;
};

export type RealEstateLand = {
  __typename: 'RealEstateLand';
  dativeName: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

/** Application for a real estate loan */
export type RealEstateLoanApplication = LoanApplication & Node & {
  __typename: 'RealEstateLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  calculationResult: LoansCalculations;
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  mortgages: Array<RealEstateMortgage>;
  newRealEstate: Maybe<RealEstateLoanApplicationNewRealEstate>;
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  possibleLoans: Array<PossibleLoan>;
  recommendedLoanSteps: Array<RecommendedLoanStep>;
  result: RealEstateLoanApplicationResult;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  totalFees: Scalars['Float']['output'];
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


/** Application for a real estate loan */
export type RealEstateLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};


/** Application for a real estate loan */
export type RealEstateLoanApplicationPossibleLoansArgs = {
  amount: Scalars['Float']['input'];
};


/** Application for a real estate loan */
export type RealEstateLoanApplicationRecommendedLoanStepsArgs = {
  amount: Scalars['Float']['input'];
};

export type RealEstateLoanApplicationBondInput = {
  /** New amount of loan | This applies if you have a mixed package loan and have to change amount for both loans */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** Interest object to patch */
  interest?: InputMaybe<RealEstateLoanApplicationBondInterstInput>;
  /** New loan period in months */
  loanPeriodInMonths?: InputMaybe<Scalars['Int']['input']>;
  /** ID of paymentType */
  paymentTypeId?: InputMaybe<Scalars['ID']['input']>;
};

export type RealEstateLoanApplicationBondInterstInput = {
  /** ID of interest */
  interestId: Scalars['ID']['input'];
  /** Type of interest, either variable or fixed */
  type: InterestType;
};

export type RealEstateLoanApplicationNewRealEstate = {
  __typename: 'RealEstateLoanApplicationNewRealEstate';
  address: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  estimatedMonthlyCostAmount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  /** Indicates if the real estate is defined as a summer house */
  isSummerHouse: Scalars['Boolean']['output'];
  marketPriceValuation: Maybe<Scalars['Float']['output']>;
  realEstateReference: Scalars['String']['output'];
  realEstateValuation: Scalars['Float']['output'];
};

/** Provides different types of validation amount for an active real estate application */
export type RealEstateLoanApplicationOptionsResult = {
  __typename: 'RealEstateLoanApplicationOptionsResult';
  /** Fees added on loan */
  bufferAmount: Maybe<Scalars['Float']['output']>;
  /** Validation error for loan amount */
  error: Maybe<LoanApplicationOptionsResultError>;
  /**
   * Max loan amount by fire and lot valuation
   * @deprecated Reason: maxAmountByFireAndLotValuation has been removed from api. Removed: 2024-01-05. api git commit: 7c65b4f. Issue(s) to remove it: WEB-19786
   */
  maxAmountByFireAndLotValuation: Maybe<Scalars['Float']['output']>;
  /** The maximum loan amount calculated by mortgage ratio, and the central bank indexes */
  maxLoanAmount: Scalars['Float']['output'];
  /** Max loan amount in cases where the user transfers loans with interests */
  maxLoanAmountByFixedInterests: Maybe<Scalars['Float']['output']>;
  /** Max loan amount by mortgage ratio */
  maxLoanAmountByMortgageRatio: Scalars['Float']['output'];
  /** Max loan amount by mortgage ratio without payment per month (Hámarksveðsetning) */
  maxLoanAmountByMortgageRatioWithoutPaymentPerMonth: Scalars['Float']['output'];
  /** Max loan amount calculated by payment per month */
  maxLoanAmountByPaymentPerMonth: Scalars['Float']['output'];
  /** Max loan amount when only settling(paying up) real estate loans: kronaVsKronaMax in api */
  maxLoanAmountOnlySettlementDebts: Maybe<Scalars['Float']['output']>;
  /** The minimum loan amount, calculated from selected settlement debts or minLoanAmountRealEstateLoans prop */
  minLoanAmount: Scalars['Float']['output'];
  /** The absolute minimum loan amount */
  minLoanAmountRealEstateLoans: Scalars['Float']['output'];
};

export type RealEstateLoanApplicationResult = {
  __typename: 'RealEstateLoanApplicationResult';
  /** The monthly expense of the new asset that the user is applying for */
  newAssetExpenses: Scalars['Float']['output'];
  /** Total amount on new loans. Not including transferred loans */
  newLoansAmount: Scalars['Float']['output'];
  /** Monthly payment on new loans. Not including transferred loans */
  paymentPerMonthOnNewLoans: Scalars['Float']['output'];
  /** Monthly ability to pay for the user after factoring in the loan that the user is applying for */
  remainderPerMonthAfterNewLoan: Scalars['Float']['output'];
  /** Monthly ability to pay for the user before factoring in the loan that the user is applying for */
  remainderPerMonthBeforeNewLoan: Scalars['Float']['output'];
  /** Monthly ability to pay for the user after factoring in the loan that the user is applying for but not the new loanRequests in the loan application */
  remainderPerMonthBeforeNewLoanWithAssetPayment: Scalars['Float']['output'];
};

/** Information about common maximum mortgage ratios. */
export type RealEstateLoanMaxMortgageRatios = {
  __typename: 'RealEstateLoanMaxMortgageRatios';
  /** Maximum mortgage ratio for first buyers indexed loans. Product type 216. As percentage. */
  maxFirstBuyerIndexedMortgageRatio: Scalars['Float']['output'];
  /** Maximum mortgage ratio for first buyers non-indexed loans. Product type 216 As percentage. */
  maxFirstBuyerNonIndexedMortgageRatio: Scalars['Float']['output'];
  /** Maximum mortgage ratio for indexed loans. Product type 210. As percentage. */
  maxNonIndexedMortgageRatio: Scalars['Float']['output'];
};

export type RealEstateLoanOptionInput = {
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  loanDurationMonths?: InputMaybe<Scalars['Int']['input']>;
  loanPaymentType?: InputMaybe<LoanProductPaymentType>;
  oneYearIndexProjection?: InputMaybe<Scalars['Float']['input']>;
  paymentFeePerPayment?: InputMaybe<Scalars['Float']['input']>;
};

export type RealEstateLookupResponse = RealEstate | RealEstateNotFoundError;

/** Veð í fasteignum */
export type RealEstateMortgage = {
  __typename: 'RealEstateMortgage';
  address: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  city: Scalars['String']['output'];
  estimatedMonthlyCostAmount: Scalars['Float']['output'];
  isRefinanced: Scalars['Boolean']['output'];
  loanRatio: Scalars['Float']['output'];
  marketPriceValuation: Scalars['Float']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  /** Fastanúmer */
  realEstateReference: Scalars['String']['output'];
  realEstateValuation: Scalars['Float']['output'];
};

/** Real estate not found */
export type RealEstateNotFoundError = Error & {
  __typename: 'RealEstateNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum ReceiptType {
  CreditCardStatement = 'CreditCardStatement',
  PensionStatement = 'PensionStatement',
  SecuritiesReceipt = 'SecuritiesReceipt',
  SecuritiesStatement = 'SecuritiesStatement'
}

export type RecommendedLoanStep = {
  __typename: 'RecommendedLoanStep';
  isDefault: Scalars['Boolean']['output'];
  loanPaymentPerMonth: Scalars['Float']['output'];
  option: Array<RecommendedLoanStepOption>;
  realEstateValue: Scalars['Float']['output'];
};

export type RecommendedLoanStepOption = {
  __typename: 'RecommendedLoanStepOption';
  amount: Scalars['Float']['output'];
  indexType: IndexTypeLookUpType;
  interestId: Scalars['Int']['output'];
  interestRate: Scalars['Float']['output'];
  isBaseProduct: Scalars['Boolean']['output'];
  loanDurationMonths: Scalars['Int']['output'];
  oneYearIndexProjection: Maybe<Scalars['Float']['output']>;
  order: Scalars['Int']['output'];
  paymentPerMonth: Scalars['Float']['output'];
  paymentType: PaymentTypeLookUpType;
  productCatalogId: Scalars['Int']['output'];
  productCategoryId: Scalars['Int']['output'];
  productName: Scalars['String']['output'];
};

export type RecurringCardPaymentTokenDetails = {
  __typename: 'RecurringCardPaymentTokenDetails';
  /** The masked card number associated with the token (e.g., **** **** **** 1234) */
  maskedCardNumber: Scalars['String']['output'];
  /** The current status of the token. */
  status: SecurePaymentsTokenStatus;
  /** The unique token identifier (IS: Sýndarnúmer). This is a merchant-specific value that merchants must store and provide when querying token details. */
  token: Scalars['String']['output'];
};

/** Input for retrieving recurring card payment token details. */
export type RecurringCardPaymentTokenDetailsInput = {
  /** The token identifier (IS: Sýndarnúmer) that is stored by the merchant. This is used to fetch the token details. */
  tokenId: Scalars['String']['input'];
};

export type RecurringPaymentTokenResponse = {
  __typename: 'RecurringPaymentTokenResponse';
  /** The masked card number associated with the token */
  maskedCardNumber: Scalars['String']['output'];
  /** The expiry date of the token in date-time format */
  tokenExpiryDate: Scalars['String']['output'];
  /** The unique identifier for the token (IS: Sýndarnúmer) */
  tokenId: Scalars['String']['output'];
};

/** Regions in Iceland */
export enum Region {
  All = 'All',
  Austurland = 'Austurland',
  Hofudborgarsvaedid = 'Hofudborgarsvaedid',
  Nordurland = 'Nordurland',
  Sudurland = 'Sudurland',
  Sudurnes = 'Sudurnes',
  Vestfirdir = 'Vestfirdir',
  Vesturland = 'Vesturland'
}

export type RegisterOnboardingCompanyApplicationInput = {
  /** The national ID (kennitala) of the company to register an application for */
  companyKennitala: Scalars['String']['input'];
  /** The contact person's email address */
  email: Scalars['String']['input'];
  /** The contact person's phone number */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** The contact person's role in the company */
  role?: InputMaybe<CompanyContactRole>;
};

export type RegisterOnboardingCompanyApplicationPayload = {
  __typename: 'RegisterOnboardingCompanyApplicationPayload';
  /** Registered application if the registration succeeded */
  application: Maybe<CompanyOnboardingApplication>;
  /** Error details if the registration failed */
  error: Maybe<RegisterOnboardingCompanyApplicationPayloadErrorUnion>;
  /** Indicates whether the company application was successfully registered */
  success: Scalars['Boolean']['output'];
};

export type RegisterOnboardingCompanyApplicationPayloadErrorUnion = CompanyNotFound | OnboardingValidationError | UnauthorizedContact | UnknownError;

/** Payload returned after registering the security code. */
export type RegisterSecurityCodePayload = {
  __typename: 'RegisterSecurityCodePayload';
  error: Maybe<RegisterSecurityCodePayloadErrorUnion>;
  success: Scalars['Boolean']['output'];
};

export type RegisterSecurityCodePayloadErrorUnion = SecurityCodeInvalid | SecurityCodeInvalidLength | SecurityCodeMatchesBirthday | SecurityCodeNotNumeric | SecurityCodePartOfNationalId | SecurityCodeRepeatedDigit | SecurityCodeRequired | SecurityCodeSequential | UnknownError;

export type RegularSavingCreditorAccountInput = {
  /** Basic Bank Account Number */
  bban: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
};

/** Creditor and Debtor Accounts cannot be the same */
export type RegularSavingCreditorAndDebtorAccountsCannotBeTheSame = Error & {
  __typename: 'RegularSavingCreditorAndDebtorAccountsCannotBeTheSame';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** It is not allowed to deposit on this regular saving account */
export type RegularSavingDepositNotAllowed = Error & {
  __typename: 'RegularSavingDepositNotAllowed';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Frequency type is not supported */
export type RegularSavingFrequencyTypeNotSupported = Error & {
  __typename: 'RegularSavingFrequencyTypeNotSupported';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid Account (either debtor or creditor). */
export type RegularSavingInvalidAccount = Error & {
  __typename: 'RegularSavingInvalidAccount';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid day of execution */
export type RegularSavingInvalidDayOfExecution = Error & {
  __typename: 'RegularSavingInvalidDayOfExecution';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid Instructed Amount. E.g. amount 0, invalid currency */
export type RegularSavingInvalidInstructedAmount = Error & {
  __typename: 'RegularSavingInvalidInstructedAmount';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** PaymentType is not valid (different than CreditTransfer) */
export type RegularSavingInvalidPaymentType = Error & {
  __typename: 'RegularSavingInvalidPaymentType';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid Security Number */
export type RegularSavingInvalidSecurityCode = Error & {
  __typename: 'RegularSavingInvalidSecurityCode';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Invalid validity (wrong/invalid startDate, endDate, totalAmount or totalNumberOfPayments) */
export type RegularSavingInvalidValidity = Error & {
  __typename: 'RegularSavingInvalidValidity';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Regular saving not found */
export type RegularSavingNotFound = Error & {
  __typename: 'RegularSavingNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RegularSavingPayload = {
  __typename: 'RegularSavingPayload';
  periodicPayment: Maybe<PeriodicPayment>;
};

/** There is already a Savings Plan assigned for the Debtor Account */
export type RegularSavingPlanAlreadyCreated = Error & {
  __typename: 'RegularSavingPlanAlreadyCreated';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Creditor (savings) account is not a regular savings account */
export type RegularSavingSavingsAccountNotFound = Error & {
  __typename: 'RegularSavingSavingsAccountNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The first payment date should not be earlier than the next date that the bank is open for business */
export type RegularSavingStartDateInvalid = Error & {
  __typename: 'RegularSavingStartDateInvalid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Unexpected Error */
export type RegularSavingUnexpectedError = Error & {
  __typename: 'RegularSavingUnexpectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RegularSavingUpdateInfoInput = {
  dayOfExecution?: InputMaybe<Scalars['String']['input']>;
  debtorAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** The update is called only from the APP, where Monthly is the only allowed frequency. Add more support to the validator if you'd like to use it in some place else, and if that place supports extra frequency types */
  frequency?: InputMaybe<PaymentFrequency>;
  /** Only the amount will be relevant */
  instructedAmount?: InputMaybe<CurrencyAmountInput>;
  validity?: InputMaybe<RegularSavingValidityUpdateInput>;
};

export type RegularSavingValidityInput = {
  /**
   * Valid format: yyyy-mm-dd OR yyyy/mm/dd OR yyyy.mm.dd OR mm.dd.yyyy
   * E.g. of valid date: 2022-03-01 (representing 1st of March, 2022).
   * In order for this date to be accepted, it must be > than today
   */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Valid format: yyyy-mm-dd OR yyyy/mm/dd OR yyyy.mm.dd OR mm.dd.yyyy
   * E.g. of valid date: 2022-03-01 (representing 1st of March, 2022).
   * In order for this date to be accepted, it must be > than today
   */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Total amount that will be paid (e.g. if I am transferring monthly [instructed amount] 1.000 ISK, and the total amount is 7.000 ISK, the transfer will repeat 7 times.
   *
   */
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The total number of payments (e.g. a transfer that is going to repeat X times) */
  totalNumberOfPayments?: InputMaybe<Scalars['Float']['input']>;
};

export type RegularSavingValidityUpdateInput = {
  /**
   * Valid format: yyyy-mm-dd OR yyyy/mm/dd OR yyyy.mm.dd OR mm.dd.yyyy
   * E.g. of valid date: 2022-03-01 (representing 1st of March, 2022).
   * In order for this date to be accepted, it must be > than today
   */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Total amount (in ISK) */
  totalAmount?: InputMaybe<Scalars['Float']['input']>;
  totalNumberOfPayments?: InputMaybe<Scalars['Float']['input']>;
};

/** Withdrawal account currency and Deposit currency must match */
export type RegularSavingWithdrawalDepositAccountCurrencyMismatch = Error & {
  __typename: 'RegularSavingWithdrawalDepositAccountCurrencyMismatch';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Input for reissuing a card. If no deliveryAddress and no deliveryBranchId is provided then the card is reissued without a plastic card */
export type ReissueCardInput = {
  /** The delivery address of the reissued card */
  deliveryAddress?: InputMaybe<CardDeliveryAddressInput>;
  /** A branch number. Used if the applicant chooses to get his card from a specific branch */
  deliveryBranchId?: InputMaybe<Scalars['String']['input']>;
  /** The node id of the card being reissued */
  id: Scalars['ID']['input'];
};

export type ReissueCardPayload = {
  __typename: 'ReissueCardPayload';
  /** The card id of the reissued card */
  cardId: Scalars['Float']['output'];
  /** The status of the reissue application */
  reissueStatus: CardReissueStatus;
};

/**
 * Response type for the rejectPaymentApproval mutation
 * Contains the updated approval or error that occurred during the process
 */
export type RejectPaymentApprovalResponse = {
  __typename: 'RejectPaymentApprovalResponse';
  approval: Maybe<PaymentApproval>;
  error: Maybe<PaymentApprovalError>;
};

export type RejectSavingsShareResponse = {
  __typename: 'RejectSavingsShareResponse';
  /** Unique id for access to saving, for a particular customer */
  customerProxyId: Scalars['String']['output'];
};

export type RejectShareInput = {
  customerProxyId: Scalars['String']['input'];
};

/** Related party to customer */
export type RelatedParty = {
  __typename: 'RelatedParty';
  id: Scalars['ID']['output'];
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RemoveApplicationAccountPublicCertificateInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
  /** ID (Global) of the public certificate to remove */
  certificateId: Scalars['ID']['input'];
};

export type RemoveAuthenticatorInput = {
  authenticatorId: Scalars['ID']['input'];
  deviceId: Scalars['String']['input'];
};

export type RemoveAuthenticatorPayload = {
  __typename: 'RemoveAuthenticatorPayload';
  authenticatorId: Scalars['String']['output'];
};

export type RemoveAvatarImageErrorUnion = UnknownError;

/** Payload returned when removing a user avatar */
export type RemoveAvatarImagePayload = {
  __typename: 'RemoveAvatarImagePayload';
  /** Error returned when removing a user avatar fails */
  error: Maybe<RemoveAvatarImageErrorUnion>;
  /** Whether removing the user avatar was successful or not */
  success: Scalars['Boolean']['output'];
};

export type RemoveCardFromClickToPayErrorUnion = CardNotFoundError | ClickToPayNoAccessError | UnknownError;

export type RemoveCardFromClickToPayInput = {
  /** The node id of the card */
  cardId: Scalars['ID']['input'];
};

/** Returns EITHER the payload and no error OR no payload and an error. */
export type RemoveCardFromClickToPayPayload = {
  __typename: 'RemoveCardFromClickToPayPayload';
  clickToPayRequest: Maybe<ClickToPayRequest>;
  error: Maybe<RemoveCardFromClickToPayErrorUnion>;
};

export type RemoveEmployeeFromPayrollError = UnknownError;

export type RemoveEmployeeFromPayrollInput = {
  /** ID (Global) of the employee in the specified payroll */
  employeeId: Scalars['ID']['input'];
  /** ID (Global) of the payroll where the employee is on */
  payrollId: Scalars['ID']['input'];
};

/** Payload for removing employee in payroll */
export type RemoveEmployeeFromPayrollPayload = {
  __typename: 'RemoveEmployeeFromPayrollPayload';
  /** Error object in case success is false */
  error: Maybe<RemoveEmployeeFromPayrollError>;
  /** Indicates whether remove request was successful or not */
  success: Scalars['Boolean']['output'];
};

export type RemoveGrantInput = {
  grantId: Scalars['ID']['input'];
};

export type RemoveGrantPayload = {
  __typename: 'RemoveGrantPayload';
  grantId: Scalars['ID']['output'];
};

export type RemoveInvoiceTemplateErrorUnion = InvoiceTemplateNotFound | UnknownError;

export type RemoveInvoiceTemplateInput = {
  id: Scalars['ID']['input'];
};

export type RemoveInvoiceTemplatePayload = {
  __typename: 'RemoveInvoiceTemplatePayload';
  error: Maybe<RemoveInvoiceTemplateErrorUnion>;
  success: Scalars['Boolean']['output'];
  template: Maybe<InvoiceTemplate>;
};

export type RemovePayrollError = UnknownError;

export type RemovePayrollInput = {
  /** ID (Global) of payroll to remove */
  id: Scalars['ID']['input'];
};

/** Payload for removing payroll */
export type RemovePayrollPayload = {
  __typename: 'RemovePayrollPayload';
  /** Error object if success is false */
  error: Maybe<RemovePayrollError>;
  /** Indicates whether remove request was successful or not */
  success: Scalars['Boolean']['output'];
};

/** An error occurred during proxy access update */
export type RemoveProxyAccessError = {
  __typename: 'RemoveProxyAccessError';
  /** id for proxy access that could not be removed */
  proxyAccessId: Scalars['ID']['output'];
};

/** A response object type for removing proxy access */
export type RemoveProxyAccessResponse = {
  __typename: 'RemoveProxyAccessResponse';
  /** A list of proxy errors for proxy accesses that could not be changed */
  errors: Array<RemoveProxyAccessError>;
  /** A list of valid proxy access that has been changed/removed */
  removed: Array<ProxyAccess>;
  /** Indicates if all accesses were successfully removed. If false the errors field should hold some errors. */
  success: Scalars['Boolean']['output'];
};

/** Deactivation of proxy access (setting status to inactive) */
export type RemoveProxyAccessesInput = {
  /** One or more ids for proxy accesses to be deactivated */
  proxyAccessIds: Array<Scalars['ID']['input']>;
};

/** Repeatable container component */
export type RepeatableFormComponent = FormComponentBase & {
  __typename: 'RepeatableFormComponent';
  addButtonLabel: Scalars['String']['output'];
  components: Array<FormComponent>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  maxItems: Scalars['Int']['output'];
  minItems: Scalars['Int']['output'];
  removeButtonLabel: Scalars['String']['output'];
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

export type RequestAccountClosureInput = {
  /** The bank account id of the account to close. */
  accountId: Scalars['ID']['input'];
  /** The bank account id of the settlement account. The settlement account is the account that will receive the balance of the closed account and/or be used to settle any remaining debts on the account being closed. */
  settlementAccountId: Scalars['ID']['input'];
};

export type RequestAccountClosureResponse = AccountClosureRequestForbidden | AccountClosureRequestSuccessPayload;

export type RequestCancelLoanApplicationInput = {
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
};

export type RequestCreditAssessmentPhoneCallInput = {
  /** Used by service desk to look up the credit assessment that requested a phonecall */
  creditAssessmentId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type RequestCreditAssessmentPhoneCallPayload = {
  __typename: 'RequestCreditAssessmentPhoneCallPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestDeleteCurrentUserPayload = {
  __typename: 'RequestDeleteCurrentUserPayload';
  caseId: Maybe<Scalars['String']['output']>;
};

export type RequestGdprDataInput = {
  email: Scalars['String']['input'];
  /** Has customer previously been a customer of Sparisjóður or other financing company that is now part of Landsbankinn? */
  formerSPCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber: Scalars['String']['input'];
  types: Array<RequestGdprDataType>;
};

export type RequestGdprDataPayload = {
  __typename: 'RequestGdprDataPayload';
  id: Scalars['String']['output'];
};

export enum RequestGdprDataType {
  AssetManagement = 'AssetManagement',
  CustomerInfo = 'CustomerInfo',
  Debt = 'Debt',
  DebtCollection = 'DebtCollection',
  Deposit = 'Deposit',
  GeneralAnnouncement = 'GeneralAnnouncement',
  JobApplication = 'JobApplication',
  Loan = 'Loan',
  Pension = 'Pension',
  Securities = 'Securities'
}

/** Requesting insurance consultation failed */
export type RequestInsuranceConsultationBadRequestError = Error & {
  __typename: 'RequestInsuranceConsultationBadRequestError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RequestInsuranceConsultationInput = {
  /** The email to contact. Can be null if phone is defined. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The type of insurance consultation that is requested for. If omitted then we consider that a request for general consultation. */
  insuranceType?: InputMaybe<InsuranceType>;
  /** The phone number to contact. Can be null if email is defined. */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type RequestUpdateCompanyCreditLimitInput = {
  /** New credit limit (yfirheimild) */
  newLimit: Scalars['Float']['input'];
};

export type RequestUpdateCompanyCreditLimitPayload = {
  __typename: 'RequestUpdateCompanyCreditLimitPayload';
  success: Scalars['Boolean']['output'];
};

export type RequestedCreditLineError = Error & {
  __typename: 'RequestedCreditLineError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type RequestedCreditLineTooHighError = Error & {
  __typename: 'RequestedCreditLineTooHighError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ReservationsTimeSlotExpiredError = {
  __typename: 'ReservationsTimeSlotExpiredError';
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ReserveAppointmentInput = {
  consultationServiceServiceId: Scalars['String']['input'];
  consultationType: ConsultationType;
  date: Scalars['DateTimeISO']['input'];
  serviceLocationId: Scalars['String']['input'];
};

export type ReserveAppointmentPayload = {
  __typename: 'ReserveAppointmentPayload';
  id: Scalars['String']['output'];
  type: ConsultationType;
};

export type ResetUserPasswordInput = {
  /** Username of the user to reset password for */
  username: Scalars['String']['input'];
};

export type ResetUserPasswordPayload = {
  __typename: 'ResetUserPasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type ResolveBiometricStepUpInput = {
  token: Scalars['String']['input'];
};

/** This input is used both when selecting a phone number to receive the SMS and when sending the code received to that phone number. */
export type ResolveSmsStepUpInput = {
  /** This is the code received by the customer via an SMS. */
  answer: Scalars['String']['input'];
  /** The phone number that should receive an SMS. */
  phoneNumber: Scalars['String']['input'];
};

export type ResolveTokenStepUpInput = {
  answer: Scalars['String']['input'];
};

/** Address information to mail to */
export type ReturnAddress = {
  __typename: 'ReturnAddress';
  /** Full name of the claimant */
  claimantName: Maybe<Scalars['String']['output']>;
  /** Postal code for the address */
  postalCode: Maybe<Scalars['String']['output']>;
  /** Address to mail to */
  streetAddress: Maybe<Scalars['String']['output']>;
  /** Whether to use registered address */
  useRegisteredAddress: Maybe<Scalars['Boolean']['output']>;
};

export type ReviveInvoiceInput = {
  id: Scalars['ID']['input'];
};

export type ReviveInvoicePayload = {
  __typename: 'ReviveInvoicePayload';
  invoice: Invoice;
};

export type ReviveInvoiceResponse = InvoiceNotFound | ReviveInvoicePayload;

export type RevokeApplicationAccountCertificateInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
  /** ID (Global) of the certificate to remove */
  id: Scalars['String']['input'];
};

export type RsaBiometricAction = {
  __typename: 'RsaBiometricAction';
  emptyField: Maybe<Scalars['String']['output']>;
};

/** Information on how often the customer has attempted to resolve the stepup and how often the customer can keep trying */
export type RsaChallengeAttempts = {
  __typename: 'RsaChallengeAttempts';
  /** The failed attempts by the user to resolve the SMS code correctly */
  failedAttempts: Maybe<Scalars['Int']['output']>;
  /** The remaining attempts for the user to resolve the SMS code correctly */
  remainingAttempts: Maybe<Scalars['Int']['output']>;
};

/** The payload to expect after an attempt has been made to resolve an RSA challenge */
export type RsaChallengeResponse = {
  __typename: 'RsaChallengeResponse';
  /** The attempt information for SMS stepup */
  attempts: Maybe<RsaChallengeAttempts>;
  /** Indication if the given request was successful */
  success: Scalars['Boolean']['output'];
};

/** The RSA deny the action. User will not do further authorization(RSA step up). */
export type RsaDeny = {
  __typename: 'RsaDeny';
  emptyField: Maybe<Scalars['String']['output']>;
};

export type RsaPhoneCallAction = {
  __typename: 'RsaPhoneCallAction';
  phoneNumbers: Array<Scalars['String']['output']>;
};

export type RsaQuestionAction = {
  __typename: 'RsaQuestionAction';
  question: Scalars['String']['output'];
};

export type RsaSecurityAction = RsaBiometricAction | RsaDeny | RsaPhoneCallAction | RsaQuestionAction | RsaSmsAction | RsaTokenAction;

export type RsaSmsAction = {
  __typename: 'RsaSmsAction';
  phoneNumbers: Array<Scalars['String']['output']>;
};

/** Some actions will force the user to do further authorization(RSA step up). This object describes what kind of action user need to perform */
export type RsaStepUpResponse = {
  __typename: 'RsaStepUpResponse';
  action: RsaSecurityAction;
  transactionId: Scalars['String']['output'];
};

export type RsaTokenAction = {
  __typename: 'RsaTokenAction';
  emptyField: Maybe<Scalars['String']['output']>;
};

/** Single salary payment input */
export type SalaryPaymentInput = {
  /** The kennitala of the payment receiver */
  creditorAccountKennitala: Scalars['String']['input'];
  /** The account number of the payment receiver */
  creditorAccountNumber: Scalars['String']['input'];
  /** The payment amount and ISO currency code */
  instructedAmount: CurrencyAmountInput;
};

export type SaveLegalEntityKycInput = {
  beneficialOwners?: InputMaybe<Array<BeneficialOwnerInput>>;
  legalEntity: LegalEntityInput;
  /** Kennitala of the company the KYC is for, for users that are not acting for that company (e.g. national token users) */
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
  stakeholders?: InputMaybe<Array<StakeholderInput>>;
};

/** Input to save a payment batch and ready for payment */
export type SavePaymentBatchInput = {
  /** The initiationId of the payment batch */
  initiationId: Scalars['String']['input'];
  /** Payment options for batch being saved */
  options?: InputMaybe<SavePaymentBatchOptions>;
};

/** Payment options for a payment batch */
export type SavePaymentBatchOptions = {
  /** The name of the payment batch */
  batchName?: InputMaybe<Scalars['String']['input']>;
  /** The category code for the payment batch */
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** The bearer of the charges for cross-border payments */
  chargeBearer?: InputMaybe<CrossBorderChargeBearer>;
  /** The account kennitala to be used for aggregated payments */
  debtorAccountKennitala?: InputMaybe<Scalars['String']['input']>;
  /** The account number to be used for aggregated payments */
  debtorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** If the payment batch should be initiated immediately after saving */
  initiateNow?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the payment batch should be aggregated (multiple payments combined into one) */
  isAggregate?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the payment batch should be disclosed in the statement (hides payment details on the statement) */
  isDisclosedInStatement?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the cross-border payments are urgent (express) */
  isExpress?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date the payment batch should be paid */
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type SavePaymentBatchPayload = {
  __typename: 'SavePaymentBatchPayload';
  paymentBatch: PaymentBatch;
  paymentBatchId: Scalars['ID']['output'];
};

export type SavePaymentBatchUnion = CreatePaymentScaResponse | InitiateStoredPaymentError | SavePaymentBatchPayload;

export type SavingGoal = Node & {
  __typename: 'SavingGoal';
  accountId: Scalars['String']['output'];
  activeSavingMethods: ActiveSavingMethodsInfo;
  availableSavingMethods: Array<SavingMethodType>;
  balance: Maybe<Scalars['Int']['output']>;
  category: SavingGoalCategory;
  categoryId: Scalars['String']['output'];
  closeDate: Maybe<Scalars['DateTimeISO']['output']>;
  contributionsForContributor: SavingGoalContributionConnection;
  contributionsTotal: Array<ContributionsTotalTransaction>;
  /** Unique id for access to saving, for a particular customer */
  customerProxyId: Maybe<Scalars['String']['output']>;
  /** The deposit interest rate for this saving goal */
  depositInterestRate: Maybe<Scalars['Float']['output']>;
  endGoalDate: Maybe<Scalars['DateTimeISO']['output']>;
  estimate: Estimate;
  finalAmount: Maybe<Scalars['Int']['output']>;
  goalAmount: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isSharingAllowed: Scalars['Boolean']['output'];
  lastChanged: Scalars['DateTimeISO']['output'];
  name: Maybe<Scalars['String']['output']>;
  numberOfCustomerProxies: Maybe<Scalars['Int']['output']>;
  ownerId: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  possibleParticipants: PossibleParticipants;
  progress: Maybe<Scalars['Float']['output']>;
  /** Monthly statistics for this individual saving goal account for the last 12 months including the current month (13 months total), including breakdown by month and totals for interest */
  savingGoalInfo: Maybe<AccountMonthlyStatisticsInfo>;
  startDate: Scalars['DateTimeISO']['output'];
  status: SavingGoalStatus;
};


export type SavingGoalContributionsForContributorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contributorId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SavingGoalAccountProduct = {
  __typename: 'SavingGoalAccountProduct';
  displayMarketingOnStartPage: Scalars['Boolean']['output'];
  /** The interest rate for the saving goal account product, either the base interest rate or a higher percentage based on loyalty level */
  interestRate: Maybe<Scalars['Float']['output']>;
};

export type SavingGoalCategory = {
  __typename: 'SavingGoalCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SavingGoalConnection = {
  __typename: 'SavingGoalConnection';
  edges: Array<SavingGoalEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SavingGoalContributionConnection = {
  __typename: 'SavingGoalContributionConnection';
  edges: Array<SavingGoalContributionTransactionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SavingGoalContributionTransaction = Node & {
  __typename: 'SavingGoalContributionTransaction';
  accountId: Scalars['String']['output'];
  amount: Scalars['Int']['output'];
  dateTransferred: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  /** TODO use SavingMethodType */
  methodType: Scalars['String']['output'];
  payorId: Scalars['String']['output'];
  payorName: Scalars['String']['output'];
  textCode: Scalars['String']['output'];
  textCodeDescription: Scalars['String']['output'];
};

export type SavingGoalContributionTransactionEdge = {
  __typename: 'SavingGoalContributionTransactionEdge';
  cursor: Scalars['String']['output'];
  node: SavingGoalContributionTransaction;
};

export type SavingGoalEdge = {
  __typename: 'SavingGoalEdge';
  cursor: Scalars['String']['output'];
  node: SavingGoal;
};

/** Status of saving goal */
export enum SavingGoalStatus {
  closed = 'closed',
  open = 'open'
}

/** Information about the user's saving goals */
export type SavingGoalsInfo = {
  __typename: 'SavingGoalsInfo';
  /** All the closed saving accounts that the current user owns */
  closedSavingAccounts: Array<SavingGoal>;
  id: Scalars['ID']['output'];
  /** Monthly statistics for all saving goal accounts owned by the current user for the last 12 months including the current month (13 months total), including aggregated totals across all accounts */
  monthlyStatisticsForOwnSavingsAccounts: Maybe<AccountsMonthlyStatisticsInfo>;
  /** All the open saving accounts owned by the current user */
  ownSavingAccounts: Array<SavingGoal>;
  /** All the open saving accounts shared with the current user */
  sharedWithCurrentUserSavingAccounts: Array<SavingGoal>;
  /** All the sharing offers that the current user has received and not yet accepted or rejected */
  sharingOffers: Array<SavingGoal>;
  /** The total balance amount across all open saving goal accounts owned by the current user */
  totalBalanceOfAllOwnOpenSavingsAccounts: Scalars['Int']['output'];
};

export enum SavingMethodType {
  CardSavings = 'CardSavings',
  IncomeRatio = 'IncomeRatio',
  PeriodicPayment = 'PeriodicPayment'
}

export type SavingsFields = {
  __typename: 'SavingsFields';
  maxGoalSlider: Scalars['Int']['output'];
  maxInputAmount: Scalars['Int']['output'];
  maxMonths: Scalars['Int']['output'];
  maxPeriodicPaymentSlider: Scalars['Int']['output'];
};

export type SavingsGoalCatalog = {
  __typename: 'SavingsGoalCatalog';
  cardSavingTypes: Maybe<Array<CardSavingType>>;
  categories: Maybe<Array<SavingGoalCategory>>;
  fields: Maybe<SavingsFields>;
};

export type SavingsTypeNotFound = Error & {
  __typename: 'SavingsTypeNotFound';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The payment needs to go through the sca process to be initiated */
export type ScaActionIdpConsentRequired = {
  __typename: 'ScaActionIdpConsentRequired';
  pisId: Scalars['String']['output'];
};

/** The payment needs no further action */
export type ScaActionNoActionRequired = {
  __typename: 'ScaActionNoActionRequired';
  /** Why the payment needs no further action */
  reason: PaymentScaNoActionReason;
};

export type ScannedCertificateMissing = Error & {
  __typename: 'ScannedCertificateMissing';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Scheduled payment for claim */
export type ScheduledClaimPayment = {
  __typename: 'ScheduledClaimPayment';
  detailedPayment: Maybe<Payment>;
  error: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentDate: Scalars['DateTimeISO']['output'];
  status: ScheduledClaimPaymentStatus;
  withdrawalAccountId: Maybe<Scalars['String']['output']>;
};

export type ScheduledClaimPaymentResponse = ScheduledClaimPayment;

export enum ScheduledClaimPaymentStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

/** Information about secondary collection (whom to call to collect) */
export type SecondaryCollection = {
  __typename: 'SecondaryCollection';
  /** ID of the collection company */
  collectionCompanyKennitala: Maybe<Scalars['String']['output']>;
  /** Name of the collection company */
  collectionCompanyName: Maybe<Scalars['String']['output']>;
  /** Days to wait until contacting the collection company */
  gracePeriodDays: Scalars['Int']['output'];
};

/** Section container component */
export type SectionFormComponent = FormComponentBase & {
  __typename: 'SectionFormComponent';
  components: Array<FormComponent>;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

export type SecureCardPaymentAuthentication = {
  __typename: 'SecureCardPaymentAuthentication';
  /** JSON Web Token for acquiring payments. Used to authenticate and authorize payment transactions. */
  jsonWebToken: Maybe<Scalars['String']['output']>;
};

/** Status of Authentication eligibility */
export enum SecurePaymentsEnrolledStatus {
  /** Bypass, Merchant authentication rule is triggered to bypass authentication in this use case (Enrolled: B) */
  BYPASS = 'BYPASS',
  /** No, Bank is not participating in 3D Secure protocol (Enrolled: N) */
  NO = 'NO',
  /** Unavailable, The DS or ACS is not available for authentication at the time of the request (Enrolled: U) */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Unknown enrolled status */
  UNKNOWN = 'UNKNOWN',
  /** Yes, Bank is participating in 3D Secure protocol and will return the ACSUrl (Enrolled: Y) */
  YES = 'YES'
}

/** Transaction status result identifier */
export enum SecurePaymentsParesStatus {
  /** Challenge required for authentication (Status: C) */
  CHALLENGE_REQUIRED_FOR_AUTHENTICATION = 'CHALLENGE_REQUIRED_FOR_AUTHENTICATION',
  /** Failed authentication (Status: N) */
  FAILED_AUTHENTICATION = 'FAILED_AUTHENTICATION',
  /** Authentication rejected (Status: R) */
  REJECTED_AUTHENTICATION = 'REJECTED_AUTHENTICATION',
  /** Successful attempts transaction (Status: A) */
  SUCCESSFUL_ATTEMPTS_TRANSACTION = 'SUCCESSFUL_ATTEMPTS_TRANSACTION',
  /** Successful authentication (Status: Y) */
  SUCCESSFUL_AUTHENTICATION = 'SUCCESSFUL_AUTHENTICATION',
  /** Unable to complete authentication (Status: U) */
  UNABLE_TO_COMPLETE_AUTHENTICATION = 'UNABLE_TO_COMPLETE_AUTHENTICATION',
  /** Unknown status */
  UNKNOWN = 'UNKNOWN'
}

/** Status of the recurring payment token */
export enum SecurePaymentsTokenStatus {
  /** Token is active and can be used for payments */
  ACTIVE = 'ACTIVE',
  /** Token has been deleted and cannot be used */
  DELETED = 'DELETED',
  /** Token is suspended and temporarily cannot be used */
  SUSPENDED = 'SUSPENDED',
  /** Unknown token status */
  UNKNOWN = 'UNKNOWN'
}

/** Input for secure creating a recurring card payment. threeDAuthentication is optional and is dependent on the 3D Secure lookup result. */
export type SecureRecurringCardPaymentInput = {
  /** card data encrypted by the client */
  encryptedCard: Scalars['String']['input'];
  /** 3D Secure authentication details from the lookup and client event response */
  threeDAuthentication?: InputMaybe<ThreeDSecureAuthentication>;
};

export type SecuritiesHistoryFilter = {
  type: SecurityHistoryType;
};

/** Securities widget */
export type SecuritiesWidget = {
  __typename: 'SecuritiesWidget';
  /** Securities widget data */
  data: Maybe<HoldingSummaries>;
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

/** Security actions are actions that need to be taken by our customers. This includes changing password and collecting questions so the customer is able to partake in RSA question stepup */
export enum SecurityAction {
  /** indicates the customer must change the account password. (see #nodes/viewer/viewer.resolver.ts#changePassword mutation on how to resolve this action) */
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  /** indicates the customer must select questions and provide answers to them. (see #nodes/securityQuestion/securityQuestion.resolver.ts on how to resolve this action) */
  COLLECT_QUESTIONS = 'COLLECT_QUESTIONS'
}

export type SecurityCodeInvalid = Error & {
  __typename: 'SecurityCodeInvalid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeInvalidLength = Error & {
  __typename: 'SecurityCodeInvalidLength';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeMatchesBirthday = Error & {
  __typename: 'SecurityCodeMatchesBirthday';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeMissingError = Error & {
  __typename: 'SecurityCodeMissingError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeNotNumeric = Error & {
  __typename: 'SecurityCodeNotNumeric';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodePartOfNationalId = Error & {
  __typename: 'SecurityCodePartOfNationalId';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeRepeatedDigit = Error & {
  __typename: 'SecurityCodeRepeatedDigit';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeRequired = Error & {
  __typename: 'SecurityCodeRequired';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SecurityCodeSequential = Error & {
  __typename: 'SecurityCodeSequential';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum SecurityHistoryType {
  Bonds = 'Bonds',
  Stocks = 'Stocks'
}

/** Security question that can be used by a user to secure their account */
export type SecurityQuestion = Node & {
  __typename: 'SecurityQuestion';
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type SecurityQuestionConnection = {
  __typename: 'SecurityQuestionConnection';
  edges: Array<SecurityQuestionEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SecurityQuestionEdge = {
  __typename: 'SecurityQuestionEdge';
  cursor: Scalars['String']['output'];
  node: SecurityQuestion;
};

export type SelectStepUpPhoneNumberPayload = {
  __typename: 'SelectStepUpPhoneNumberPayload';
  code: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export type SelectStepUpPhonenumberInput = {
  phoneNumber: Scalars['String']['input'];
  type: StepUpPhoneType;
};

/** Self-harm content was detected in the uploaded image */
export type SelfHarmDetectedError = Error & {
  __typename: 'SelfHarmDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SelfServiceProhibited = Error & {
  __typename: 'SelfServiceProhibited';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SendCustomerFeedbackInput = {
  /** Optional additional information from the user. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** What rating the user gave. Min 1 Max 5 */
  stars: Scalars['Int']['input'];
  /** The type of action the user just completed and is giving feedback for. */
  type: CustomerFeedbackType;
};

export type SendInvitationFeedbackErrorUnion = UnknownError;

export type SendInvitationFeedbackInput = {
  /** Optional additional information from the user. */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The id of the invitation to send feedback for. */
  invitationId: Scalars['String']['input'];
  /** What rating the user gave. Min 1 Max 5 */
  rating: Scalars['Int']['input'];
};

/** Payload returned when submitting customer feedback after invitation survey. */
export type SendInvitationFeedbackPayload = {
  __typename: 'SendInvitationFeedbackPayload';
  error: Maybe<SendInvitationFeedbackErrorUnion>;
  /** Did submitting the feedback work? */
  success: Scalars['Boolean']['output'];
};

export type SendMultipleInvoiceRemindersPayload = {
  __typename: 'SendMultipleInvoiceRemindersPayload';
  success: Scalars['Boolean']['output'];
};

/** Input used to send multiple SMS / email notifications after a payment */
export type SendMultiplePaymentNotificationsInput = {
  notifications: Array<SendPaymentNotificationsInput>;
};

export type SendMultiplePaymentNotificationsResponse = {
  __typename: 'SendMultiplePaymentNotificationsResponse';
  notifications: Array<SendPaymentNotificationsResponse>;
};

export type SendPaymentNotificationErrors = InvalidPaymentNotificationHandle | NotCompletedPaymentStatus;

/** Input used to send multiple SMS / email notifications after a payment */
export type SendPaymentNotificationsInput = {
  /** List of phone numbers or email addresses */
  handles: Array<Scalars['String']['input']>;
  /** Custom message included in notification */
  message?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type SendPaymentNotificationsResponse = {
  __typename: 'SendPaymentNotificationsResponse';
  failedNotifications: Array<FailedPaymentNotificationPayload>;
  paymentId: Scalars['ID']['output'];
};

/** SEPA millifærsla */
export type SepaCreditTransfer = InternationalPaymentInterface & Node & {
  __typename: 'SepaCreditTransfer';
  /** Central bank category of the payment. */
  centralBankCategory: Maybe<CentralBankCategoryCode>;
  /** Three letter code that identifies the category of the payment. Use centralBankCategory for more details. */
  centralBankCategoryCode: Scalars['String']['output'];
  debitedAmount: CurrencyAmount;
  debtorAccount: Maybe<Account>;
  debtorAccountNumber: Scalars['String']['output'];
  /** Description for the payment */
  description: Maybe<Scalars['String']['output']>;
  errorSubject: Maybe<Scalars['String']['output']>;
  exchangeRate: Maybe<Scalars['Float']['output']>;
  /** Payment Exchange Rate information */
  exchangeRateInfo: Maybe<PaymentExchangeRate>;
  fees: Array<InternationalPaymentFee>;
  feesTotal: CurrencyAmount;
  id: Scalars['ID']['output'];
  instructedAmount: CurrencyAmount;
  /** The actions that were performed on the payment. Also known as initiation and alterations */
  participantActions: Maybe<Array<PaymentParticipantAction>>;
  /** ID (internal) of the payment */
  paymentId: Maybe<Scalars['ID']['output']>;
  /** Previously used notification recipients for similar payments */
  paymentNotificationRecipients: Maybe<Array<Scalars['String']['output']>>;
  paymentStatus: PaymentStatus;
  /** Receipt for the payment */
  receipt: Maybe<DocumentBucket>;
  recipient: Maybe<SepaRecipient>;
  recipientName: Scalars['String']['output'];
  type: PaymentType;
};

export type SepaCreditTransferRecipientInput = {
  address: InternationalPaymentAddressInput;
  iban: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** The costs of SEPA payments */
export type SepaPaymentFees = {
  __typename: 'SepaPaymentFees';
  /** Base cost of sending a Sepa payment */
  cost: CurrencyAmount;
};

/** SEPA foreign recipient */
export type SepaRecipient = ForeignRecipient & {
  __typename: 'SepaRecipient';
  address: Scalars['String']['output'];
  bankInfo: ForeignBankInformation;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

/** Access level for a service permission */
export enum ServiceAccessLevel {
  FULL = 'FULL',
  NONE = 'NONE'
}

/** A service permission available to a company or user */
export type ServiceAuthorization = Node & {
  __typename: 'ServiceAuthorization';
  /** Access level for the service permission */
  access: ServiceAccessLevel;
  /** Description of the service type */
  description: Maybe<Scalars['String']['output']>;
  /** ID (Global) of the service */
  id: Scalars['ID']['output'];
  /** If the user is authorized to use the service */
  isAuthorized: Scalars['Boolean']['output'];
  /** If the authorization of the service is editable */
  isEditable: Scalars['Boolean']['output'];
  /** Name of the service */
  name: Scalars['String']['output'];
  /** Service type ID */
  serviceTypeId: Scalars['Int']['output'];
  /** All users with information about their access to the service, only resolve when getting one service */
  users: Maybe<UserAccessAuthorizationConnection>;
};


/** A service permission available to a company or user */
export type ServiceAuthorizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UsersAuthorizationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UsersAuthorizationOrderBy>;
};

export type ServiceLocationAvailableAppointments = Node & {
  __typename: 'ServiceLocationAvailableAppointments';
  date: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  timeSlots: Array<Scalars['DateTimeISO']['output']>;
};

/** Error detail for a service permission update */
export type ServicePermissionError = {
  __typename: 'ServicePermissionError';
  /** Field that caused the error */
  field: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
};

/** A failed service permission update with error details */
export type ServicePermissionUpdateFailure = {
  __typename: 'ServicePermissionUpdateFailure';
  /** Attempted access level */
  access: Maybe<ServiceAccessLevel>;
  /** List of validation or processing errors */
  errors: Array<ServicePermissionError>;
  /** Service type ID */
  serviceTypeId: Maybe<Scalars['Int']['output']>;
  /** Username involved in the failed update */
  username: Scalars['String']['output'];
};

/** ServicePoint */
export type ServicePoint = Node & {
  __typename: 'ServicePoint';
  atms: Maybe<Array<Atm>>;
  branches: Maybe<Array<Branch>>;
  city: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude: Maybe<Scalars['Float']['output']>;
  longitude: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  postalCode: Maybe<Scalars['String']['output']>;
  region: Maybe<Region>;
  street: Maybe<Scalars['String']['output']>;
};

export type ServicePointConnection = {
  __typename: 'ServicePointConnection';
  edges: Array<ServicePointEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ServicePointEdge = {
  __typename: 'ServicePointEdge';
  cursor: Scalars['String']['output'];
  node: ServicePoint;
};

export enum ServicePointType {
  Atm = 'Atm',
  Branch = 'Branch'
}

/** A service recommended for a given access profile */
export type ServiceType = {
  __typename: 'ServiceType';
  /** Whether the service is allowed in self service */
  allowedInSelfService: Scalars['Boolean']['output'];
  /** Service type ID */
  serviceTypeId: Scalars['Int']['output'];
};

/** Type of bulk service permission update operation */
export enum ServiceUpdateType {
  BY_SERVICE = 'BY_SERVICE',
  BY_USER = 'BY_USER'
}

export type ServicesAuthorizationFilter = {
  /** Search string to filter services */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter services by their types */
  serviceTypes?: InputMaybe<Array<AuthorizationServiceType>>;
  /** Filter to only show services with access */
  withAccessOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ServicesAuthorizationOrderBy = {
  /** Direction to order services by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order services by */
  field: ServicesOrderByOptions;
};

/** Fields that services can be ordered by */
export enum ServicesOrderByOptions {
  IS_EDITABLE = 'IS_EDITABLE',
  NAME = 'NAME'
}

export type SetCompanyUserPasswordInput = {
  /** New password to set for the user */
  newPassword: Scalars['String']['input'];
  /** Username of the user to set password for */
  username: Scalars['String']['input'];
};

/** Payload returned when setting a company user password */
export type SetCompanyUserPasswordPayload = {
  __typename: 'SetCompanyUserPasswordPayload';
  /** Message from the API describing the result of setting the company user password */
  message: Scalars['String']['output'];
  /** Whether setting the company user password was successful or not */
  success: Scalars['Boolean']['output'];
};

export type SetCultureInput = {
  culture: Culture;
};

export type SetFrontPageWidgetVisibilityErrorUnion = UnknownError | WidgetNotFoundError;

/** Input for setting the visibility of a front page widget */
export type SetFrontPageWidgetVisibilityInput = {
  /** Whether the widget should be visible */
  display: Scalars['Boolean']['input'];
  /** The widget type */
  widgetType: WidgetType;
};

export type SetFrontPageWidgetVisibilityPayload = {
  __typename: 'SetFrontPageWidgetVisibilityPayload';
  error: Maybe<SetFrontPageWidgetVisibilityErrorUnion>;
  widgets: Maybe<Widgets>;
};

/** Input for setting the visibility of multiple front page widgets */
export type SetFrontPageWidgetsVisibilityInput = {
  widgets: Array<SetFrontPageWidgetVisibilityInput>;
};

export type SetFrontPageWidgetsVisibilityPayload = {
  __typename: 'SetFrontPageWidgetsVisibilityPayload';
  error: Maybe<SetFrontPageWidgetVisibilityErrorUnion>;
  widgets: Maybe<Widgets>;
};

export type ShareLegalEntityError = Error & {
  __typename: 'ShareLegalEntityError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ShareOutsideFamilyError = Error & {
  __typename: 'ShareOutsideFamilyError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ShareToYoungError = Error & {
  __typename: 'ShareToYoungError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SharerToYoungError = Error & {
  __typename: 'SharerToYoungError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Response after a successful signature */
export type SignDigitalSignatureGroupDocumentPayload = {
  __typename: 'SignDigitalSignatureGroupDocumentPayload';
  /** ID (global) of next signature document to sign in group */
  nextDocumentId: Maybe<Scalars['ID']['output']>;
};

/** Result from a digital signature */
export type SignDigitalSignatureGroupDocumentResult = {
  __typename: 'SignDigitalSignatureGroupDocumentResult';
  /** Error returned after an unsuccessful signature */
  error: Maybe<SignDigitalSignatureGroupDocumentsError>;
  /** Payload of a successful digital signature */
  payload: Maybe<SignDigitalSignatureGroupDocumentPayload>;
};

export type SignDigitalSignatureGroupDocumentsError = SignatureAlreadySignedError | SignatureAudkenniUserNotFoundError | SignatureCardBlockedError | SignatureCertificateError | SignatureLockedForSigningError | SignaturePinBlockedError | SignatureTimedOutError | SignatureUserCancelledError | UnknownError;

/** Result from initialization of Audkenni process */
export type SignNextDigitalSignatureDocumentByIdResult = {
  __typename: 'SignNextDigitalSignatureDocumentByIdResult';
  /** Error returned after an unsuccessful signature */
  error: Maybe<SignDigitalSignatureGroupDocumentsError>;
  /** Payload of a successful digital signature */
  payload: Maybe<SignDigitalSignatureGroupDocumentPayload>;
  status: SignNextDigitalSignatureDocumentByIdStatus;
};

/** The status of the `asyncSignNextDigitalSignatureDocumentById` */
export enum SignNextDigitalSignatureDocumentByIdStatus {
  /** Signet has returned a result (error or otherwise) */
  READY = 'READY',
  /** Something has gone horribly wrong. Treat as error */
  UNKNOWN = 'UNKNOWN',
  /** Signet has not responded */
  WAITING = 'WAITING'
}

export type SignNextDigitalSignatureGroupDocumentInput = {
  /** (Global) ID of digitalSignatureGroup */
  digitalSignatureGroupId: Scalars['ID']['input'];
  /** (Optional) Phone number used for digital signature, if undefined, the service will read the token */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Signature id necessary for Audkenni */
  signatureId?: InputMaybe<Scalars['String']['input']>;
};

export type SignatureAlreadySignedError = Error & {
  __typename: 'SignatureAlreadySignedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureAudkenniUserNotFoundError = Error & {
  __typename: 'SignatureAudkenniUserNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureCardBlockedError = Error & {
  __typename: 'SignatureCardBlockedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureCertificateError = Error & {
  __typename: 'SignatureCertificateError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureLockedForSigningError = Error & {
  __typename: 'SignatureLockedForSigningError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignaturePinBlockedError = Error & {
  __typename: 'SignaturePinBlockedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureStatus = {
  __typename: 'SignatureStatus';
  documentStatus: SignatureStatusType;
};

/** The status of the electronic signature on the document */
export enum SignatureStatusType {
  /** Digital register cancelled */
  DIGITAL_REGISTER_CANCELLED = 'DIGITAL_REGISTER_CANCELLED',
  /** Digital register error */
  DIGITAL_REGISTER_ERROR = 'DIGITAL_REGISTER_ERROR',
  /** Digital register in process */
  DIGITAL_REGISTER_IN_PROCESS = 'DIGITAL_REGISTER_IN_PROCESS',
  /** Digital register ready */
  DIGITAL_REGISTER_READY = 'DIGITAL_REGISTER_READY',
  /** Digital register registered */
  DIGITAL_REGISTER_REGISTERED = 'DIGITAL_REGISTER_REGISTERED',
  /** Digital register rejected */
  DIGITAL_REGISTER_REJECTED = 'DIGITAL_REGISTER_REJECTED',
  /** Digital register requested */
  DIGITAL_REGISTER_REQUESTED = 'DIGITAL_REGISTER_REQUESTED',
  /** Signature completed */
  ELECTRIC_SIGNATURE_COMPLETED = 'ELECTRIC_SIGNATURE_COMPLETED',
  /** Signature error */
  ELECTRIC_SIGNATURE_ERROR = 'ELECTRIC_SIGNATURE_ERROR',
  /** Signature in progress */
  ELECTRIC_SIGNATURE_IN_PROGRESS = 'ELECTRIC_SIGNATURE_IN_PROGRESS',
  /** Signature not started */
  ELECTRIC_SIGNATURE_NOT_STARTED = 'ELECTRIC_SIGNATURE_NOT_STARTED',
  /** Signatures timeout, usually timeouts after 5 days */
  ELECTRIC_SIGNATURE_TIMEOUT = 'ELECTRIC_SIGNATURE_TIMEOUT',
  /** Waiting for signature */
  ELECTRIC_SIGNATURE_WAITING_IN_QUEUE = 'ELECTRIC_SIGNATURE_WAITING_IN_QUEUE',
  /** Signature will be manually signed */
  MANUALLY_SIGNED = 'MANUALLY_SIGNED',
  /** Signatures not available */
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  /** Signature ready after going through loan processing */
  READY_FROM_LOAN_PROCESSING = 'READY_FROM_LOAN_PROCESSING',
  /** Signature is required */
  REQUIRES_SIGNATURE = 'REQUIRES_SIGNATURE',
  /** Simple signature */
  SIMPLE_SIGNATURE = 'SIMPLE_SIGNATURE',
  /** Unknown signature */
  UNKNOWN = 'UNKNOWN'
}

export type SignatureTimedOutError = Error & {
  __typename: 'SignatureTimedOutError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SignatureUserCancelledError = Error & {
  __typename: 'SignatureUserCancelledError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Signer = {
  __typename: 'Signer';
  name: Scalars['String']['output'];
};

/** Object that has information about the signers and slots of a group */
export type SignerGroup = {
  __typename: 'SignerGroup';
  numberOfSlots: Scalars['Int']['output'];
  signers: Maybe<Array<DocumentSignerBase>>;
  signingText: Scalars['String']['output'];
};

/** Payment initiations grouped by payment type */
export type SigningBasketGroupedPaymentInitiations = {
  __typename: 'SigningBasketGroupedPaymentInitiations';
  batches: Array<PaymentInitiation>;
  cardDeposits: Array<PaymentInitiation>;
  claims: Array<PaymentInitiation>;
  creditTransfers: Array<PaymentInitiation>;
  crossBorderTransfers: Array<InternationalPaymentInitiation>;
  sepaTransfers: Array<InternationalPaymentInitiation>;
};

export type SigningBasketInitiation = Node & {
  __typename: 'SigningBasketInitiation';
  batchPaymentInitiations: Maybe<Array<PaymentInitiation>>;
  groupedInitiations: SigningBasketGroupedPaymentInitiations;
  hasFailedPaymentInitiations: Scalars['Boolean']['output'];
  /** True if some of the payment initiations are subject to corporate approval process */
  hasPaymentsWaitingApproval: Scalars['Boolean']['output'];
  hasProccessingPaymentInitiations: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  initiationType: InitiationType;
  internationalPaymentInitiations: Maybe<Array<InternationalPaymentInitiation>>;
  paymentInitiations: Maybe<Array<PaymentInitiation>>;
};

/** A commission granted to the bank by a customer without electronic ID */
export type SimpleCommission = {
  __typename: 'SimpleCommission';
  commissionStatus: CommissionStatus;
  createdDate: Scalars['DateTimeISO']['output'];
  /**
   * Storage object that describes the document for this simple commission and provides a URL so that it can be fetched.
   * @deprecated Reason: Use documentV2 instead. Since: 2026-03-17. Issue to remove it: WEB-41523
   */
  document: Maybe<DocumentBucket>;
  /** Used when updating the simple commission. */
  documentId: Scalars['String']['output'];
  /** Storage object that describes the document for this simple commission and provides a URL so that it can be fetched. */
  documentV2: Maybe<GenericFile>;
  expiredDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  simpleCommissionId: Scalars['String']['output'];
};

export type SmartBookingCompanyInput = {
  contactEmail: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
};

export type SmartBookingCustomer = {
  email: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SmartBookingCustomerInput = {
  additionalCustomer?: InputMaybe<SmartBookingCustomer>;
  email: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum SmartBookingCustomerType {
  Company = 'Company',
  Person = 'Person',
  PersonAndCompany = 'PersonAndCompany'
}

export type SmartBookingServiceLocation = Node & {
  __typename: 'SmartBookingServiceLocation';
  availableAppointments: Array<ServiceLocationAvailableAppointments>;
  branchId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  region: Maybe<Region>;
};


export type SmartBookingServiceLocationAvailableAppointmentsArgs = {
  consultationServiceId: Scalars['String']['input'];
  consultationType: ConsultationType;
};

export type SpecifyBranchMoreThenOneBranchForCategoryCodeError = Error & {
  __typename: 'SpecifyBranchMoreThenOneBranchForCategoryCodeError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Spouse = {
  __typename: 'Spouse';
  kennitala: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Contains stakeholder information */
export type Stakeholder = {
  __typename: 'Stakeholder';
  /** Date of birth as DD/MM/YYYY formatted string */
  dateOfBirth: Maybe<Scalars['String']['output']>;
  /** Email of stakeholder */
  email: Maybe<Scalars['String']['output']>;
  /** Does the stakeholder have a kennitala */
  hasKennitala: Maybe<Scalars['Boolean']['output']>;
  hasValidIdentification: Maybe<Scalars['Boolean']['output']>;
  /** Kennitala of stakeholder */
  kennitala: Maybe<Scalars['String']['output']>;
  /** Name of stakeholder */
  name: Scalars['String']['output'];
  /** Stakeholder roles, Unselected | Chairman | MemberOfTheBoard | CEO | Procurator | OtherRepresentative */
  roles: Maybe<Array<StakeholderRole>>;
  /** Stakeholder id in guid format from CRM */
  stakeholderId: Maybe<Scalars['String']['output']>;
};

export type StakeholderInput = {
  /** String format should be DD/MM/YYYY */
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  /** Email of stakeholder */
  email?: InputMaybe<Scalars['String']['input']>;
  hasKennitala?: InputMaybe<Scalars['Boolean']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roles?: InputMaybe<Array<StakeholderRole>>;
  /** Id in guid format from CRM */
  stakeholderId?: InputMaybe<Scalars['String']['input']>;
};

export enum StakeholderRole {
  CEO = 'CEO',
  Chairman = 'Chairman',
  MemberOfTheBoard = 'MemberOfTheBoard',
  OtherRepresentative = 'OtherRepresentative',
  Procurator = 'Procurator'
}

export type StartConversationResponsePayload = {
  __typename: 'StartConversationResponsePayload';
  /** The conversation with with initial response from the chatbot. */
  conversation: CustomerConversation;
};

/** Result from an initialization of a Audkenni process for digital signature */
export type StartInitializeSignatureProcessForAudkenniResult = {
  __typename: 'StartInitializeSignatureProcessForAudkenniResult';
  /** True if the initialization process was started successfully */
  success: Scalars['Boolean']['output'];
};

/** Result from a digital signature initialization */
export type StartSignNextDigitalSignatureDocumentByIdResult = {
  __typename: 'StartSignNextDigitalSignatureDocumentByIdResult';
  /** True if the signature process was started successfully */
  success: Scalars['Boolean']['output'];
};

export type StartVerificationEmailPayloadErrorUnion = DuplicateRegistration | UnknownError;

export type StartVerificationEmailPayloadV2 = {
  __typename: 'StartVerificationEmailPayloadV2';
  error: Maybe<StartVerificationEmailPayloadErrorUnion>;
  result: Maybe<VerificationEmailPayload>;
};

export type StartVerificationEmailResult = DuplicateRegistration | RsaStepUpResponse | VerificationEmailPayload;

export type StartVerificationEmailResultV2 = AdaptiveAuthentication | StartVerificationEmailPayloadV2;

export type StartVerificationPhoneNumberPayloadErrorUnion = UnknownError;

export type StartVerificationPhoneNumberPayloadV2 = {
  __typename: 'StartVerificationPhoneNumberPayloadV2';
  error: Maybe<StartVerificationPhoneNumberPayloadErrorUnion>;
  result: Maybe<VerificationPhoneNumberPayload>;
};

export type StartVerificationPhoneNumberResult = DuplicateRegistration | RsaStepUpResponse | VerificationPhoneNumberPayload;

export type StartVerificationPhoneNumberResultV2 = AdaptiveAuthentication | StartVerificationPhoneNumberPayloadV2;

/** Aggregated statistics totals for a specific time period */
export type StatisticTotalsInfo = {
  __typename: 'StatisticTotalsInfo';
  /** The total interest earned across all months */
  interest: CurrencyAmount;
};

/** Stöðumat */
export type StatusAdjustment = {
  __typename: 'StatusAdjustment';
  brutto: Scalars['Float']['output'];
  creditAssessmentId: Scalars['Int']['output'];
  dateFrom: Scalars['DateTimeISO']['output'];
  dateTo: Scalars['DateTimeISO']['output'];
  kennitala: Scalars['String']['output'];
  /** Upphæð af stöðumats-gjaldi, oftast 0. */
  statusAdjustmentChargeAmount: Scalars['Float']['output'];
  statusAdjustmentChargeTaken: Scalars['Boolean']['output'];
  statusAdjustmentChargeUsed: Scalars['Boolean']['output'];
};

export enum StepUpPhoneType {
  PhoneCall = 'PhoneCall',
  Sms = 'Sms'
}

/** Market data for a stock */
export type Stock = Node & {
  __typename: 'Stock';
  allowedOrderTypes: Maybe<Array<MarketInstrumentOrderType>>;
  ask: Maybe<Scalars['Float']['output']>;
  bid: Maybe<Scalars['Float']['output']>;
  currency: Scalars['String']['output'];
  /** TODO use exchange symbol */
  exchangeSymbol: Scalars['String']['output'];
  history: StockHistory;
  /** Only for authenticated users */
  holdings: Maybe<PortfolioHoldingConnection>;
  id: Scalars['ID']['output'];
  intradayAccumulatedTurnover: Maybe<Scalars['Float']['output']>;
  intradayHighPrice: Maybe<Scalars['Float']['output']>;
  intradayLowPrice: Maybe<Scalars['Float']['output']>;
  intradayNumberOfTrades: Maybe<Scalars['Int']['output']>;
  intradayPerChange: Maybe<Scalars['Float']['output']>;
  last: Maybe<Scalars['Float']['output']>;
  lastPriceDifference: Maybe<Scalars['Float']['output']>;
  lastTradeDate: Maybe<Scalars['DateTimeISO']['output']>;
  lastTradedToday: Maybe<Scalars['Boolean']['output']>;
  minimumBuyOrderAmount: Scalars['Float']['output'];
  minimumSellOrderAmount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** Refers to the real time lowest price at which a seller will sell. This is the market price when buying. Only use when creating order for stocks for authenticated users. Is `null` when market is closed. */
  realTimeAsk: Maybe<Scalars['Float']['output']>;
  /** Refers to the real time highest price at which a buyer will buy. This is the market price when selling. Only use when creating order for stocks for authenticated users. Is `null` when market is closed. */
  realTimeBid: Maybe<Scalars['Float']['output']>;
  /** Only use when creating order for stocks for authenticated users. Is `null` when market is closed. */
  realTimeLast: Maybe<Scalars['Float']['output']>;
  returns: Maybe<StockReturns>;
  symbol: Scalars['String']['output'];
  updatedUtc: Scalars['String']['output'];
};


/** Market data for a stock */
export type StockHistoryArgs = {
  from: Scalars['DateTimeISO']['input'];
  granularity?: InputMaybe<HistoryGranularity>;
  to: Scalars['DateTimeISO']['input'];
};


/** Market data for a stock */
export type StockHoldingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ownedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockConnection = {
  __typename: 'StockConnection';
  edges: Array<StockEdge>;
  exchangeOpeningHours: Maybe<MarketOpeningHours>;
  pageInfo: PageInfo;
  stockMarketStatus: MarketStatus;
  totalCount: Scalars['Int']['output'];
};

export type StockEdge = {
  __typename: 'StockEdge';
  cursor: Scalars['String']['output'];
  node: Stock;
};

/** Price history of a stock */
export type StockHistory = {
  __typename: 'StockHistory';
  changes: Scalars['Float']['output'];
  close: Maybe<Scalars['Float']['output']>;
  entries: Array<StockHistoryEntry>;
  highest: Maybe<Scalars['Float']['output']>;
  lowest: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Scalars['Int']['output'];
  open: Maybe<Scalars['Float']['output']>;
  turnover: Scalars['Float']['output'];
};

/** Entry in the price history of a stock */
export type StockHistoryEntry = {
  __typename: 'StockHistoryEntry';
  close: Maybe<Scalars['Float']['output']>;
  closeYield: Maybe<Scalars['Float']['output']>;
  date: Maybe<Scalars['DateTimeISO']['output']>;
  high: Maybe<Scalars['Float']['output']>;
  highYield: Maybe<Scalars['Float']['output']>;
  last: Maybe<Scalars['Float']['output']>;
  lastCorrected: Maybe<Scalars['Float']['output']>;
  lastYieldCorrected: Maybe<Scalars['Float']['output']>;
  low: Maybe<Scalars['Float']['output']>;
  lowYield: Maybe<Scalars['Float']['output']>;
  numberOfTrades: Maybe<Scalars['Float']['output']>;
  open: Maybe<Scalars['Float']['output']>;
  openYield: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  turnover: Maybe<Scalars['Float']['output']>;
  volume: Maybe<Scalars['Float']['output']>;
};

/** StockIndex */
export type StockIndex = Node & {
  __typename: 'StockIndex';
  dayNominalDifference: Scalars['Float']['output'];
  dayPercentageDifference: Scalars['Float']['output'];
  highValue: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  last12MonthsNominalDifference: Scalars['Float']['output'];
  last12MonthsPercentageDifference: Scalars['Float']['output'];
  lowValue: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  openValue: Maybe<Scalars['Float']['output']>;
  symbol: Scalars['String']['output'];
  turnover: Maybe<Scalars['Float']['output']>;
  turnoverCurrency: Maybe<Scalars['String']['output']>;
  updatedUtc: Scalars['DateTimeISO']['output'];
  value: Scalars['Float']['output'];
  yearPercentageDifference: Scalars['Float']['output'];
  yearsNominalDifference: Scalars['Float']['output'];
};

/** If you want the highest, lowest, turnovers or all in stocks */
export enum StockOrder {
  All = 'All',
  Low = 'Low',
  MostTraded = 'MostTraded',
  Rise = 'Rise',
  Turnover = 'Turnover'
}

/** Return data for a stock */
export type StockReturns = {
  __typename: 'StockReturns';
  cumulativeReturns: Maybe<CumulativeReturns>;
  id: Scalars['ID']['output'];
};

export type StoredBatchPaymentInput = {
  aggregatedPisIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pisIds: Array<Scalars['String']['input']>;
};

/** The payload from trying to create stored payments out of list of claims */
export type StoredClaimPaymentsPayload = {
  __typename: 'StoredClaimPaymentsPayload';
  /** Result of the stored payments on success */
  storedPayments: Array<CreatePaymentScaResponse>;
};

export type StoredPayment = Node & {
  __typename: 'StoredPayment';
  /** Approval details for the payment */
  approvalDetails: Maybe<StoredPaymentApprovalDetails>;
  /** Batch name for batches */
  batchName: Maybe<Scalars['String']['output']>;
  /** Indicates if current user can add approval to the payment */
  canApprove: Scalars['Boolean']['output'];
  /** Indicates if the payment date can be altered when paid */
  canBePaidWithFutureDate: Scalars['Boolean']['output'];
  /** Indicates if current user can initiate an approval process */
  canInitiateApprovalProcess: Scalars['Boolean']['output'];
  /** Indicates if current user can execute the payment */
  canPay: Scalars['Boolean']['output'];
  /** Indicates if current user can reject the payment */
  canReject: Scalars['Boolean']['output'];
  /** Indicates if current user can remove approval */
  canRemoveApproval: Scalars['Boolean']['output'];
  /** Indicates if the payment contains errors */
  containsErrors: Scalars['Boolean']['output'];
  /** The date the payment was created */
  creationDate: Scalars['DateTimeISO']['output'];
  debtorAccount: Account;
  /** Currency for debtor account used for stored payment. If multiple debtor accounts, returns the currency from the first one */
  debtorAccountCurrency: Maybe<Scalars['String']['output']>;
  /** Debtor account number for payment */
  debtorAccountNumber: Maybe<Scalars['String']['output']>;
  /** Debtor account numbers for batch payments */
  debtorAccountNumbers: Maybe<Array<Scalars['String']['output']>>;
  /** If there is only one debtorAccount, formatted debtorAccount, otherwise like "Margir (2)". Null if none */
  debtorAccountTitle: Maybe<Scalars['String']['output']>;
  debtorAccounts: Maybe<Array<Account>>;
  /** Indicates if current user has approved the payment */
  hasApproved: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  initialPaymentData: Maybe<StoredPaymentInitialDataUnion>;
  /** The amount of the payment */
  instructedAmount: CurrencyAmount;
  /** The type of payment instruction */
  instructionType: StoredPaymentInstructionType;
  /** Indicates if the payment is affected by an approval rule */
  isApprovalRequired: Scalars['Boolean']['output'];
  /** Indicates if the payment is capable for 1n payment */
  isBatch1NCapable: Scalars['Boolean']['output'];
  /** In case of future payments */
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** GraphQL node id created with pisId */
  paymentInitiationId: Scalars['ID']['output'];
  /** Payment initiation id */
  pisId: Scalars['String']['output'];
  /** If there is only one recipient, the name of the recipient, otherwise like "Margir (2)" */
  recipientTitle: Scalars['String']['output'];
  /** List of the recipients' names */
  recipients: Array<Scalars['String']['output']>;
};

export type StoredPaymentApprovalDetails = {
  __typename: 'StoredPaymentApprovalDetails';
  approvalProcessId: Scalars['String']['output'];
  process: PaymentApproval;
  status: PaymentApprovalStatus;
  totalApprovers: Scalars['Int']['output'];
  totalApproversRequired: Scalars['Int']['output'];
};

export type StoredPaymentConnection = {
  __typename: 'StoredPaymentConnection';
  edges: Array<StoredPaymentEdge>;
  filters: StoredPaymentFilterData;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StoredPaymentEdge = {
  __typename: 'StoredPaymentEdge';
  cursor: Scalars['String']['output'];
  node: StoredPayment;
};

export type StoredPaymentFilterArgs = {
  /** Amount is greater or equal to */
  amountFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Amount is less or equal to */
  amountTo?: InputMaybe<Scalars['Float']['input']>;
  /** Payment approval status */
  approvalStatus?: InputMaybe<PaymentApprovalStatus>;
  /** Creator of payment */
  creator?: InputMaybe<Scalars['String']['input']>;
  /** Currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Payment withdrawn from account */
  debtorAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Recipient name or kennitala */
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export type StoredPaymentFilterData = {
  __typename: 'StoredPaymentFilterData';
  /** List of the recipients' names used in the stored payments result */
  creators: Array<Scalars['String']['output']>;
  /** List of the possible currencies in the stored payments result */
  currencies: Array<Scalars['String']['output']>;
  /** List of the debtor account numbers used in the stored payments result */
  debtorAccounts: Array<Scalars['String']['output']>;
};

export type StoredPaymentInitialDataUnion = CardDepositInitialPaymentData | ClaimPaymentInitialPaymentData | CreditTransferInitialPaymentData | CrossBorderCreditTransfer | PaymentBatch | SepaCreditTransfer;

export type StoredPaymentInput = {
  pisIds: Array<Scalars['String']['input']>;
};

/** Instruction type of stored payment */
export enum StoredPaymentInstructionType {
  BATCH = 'BATCH',
  CARD_DEPOSIT = 'CARD_DEPOSIT',
  CLAIM_PAYMENT = 'CLAIM_PAYMENT',
  CREDIT_TRANSFER = 'CREDIT_TRANSFER',
  CROSS_BORDER_CREDIT_TRANSFER = 'CROSS_BORDER_CREDIT_TRANSFER',
  SALARY_BATCH = 'SALARY_BATCH',
  SEPA_CREDIT_TRANSFER = 'SEPA_CREDIT_TRANSFER',
  UNKNOWN = 'UNKNOWN'
}

export type StoredPaymentOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field: StoredPaymentOrderByOption;
};

export enum StoredPaymentOrderByOption {
  AMOUNT = 'AMOUNT',
  CREATION_DATE = 'CREATION_DATE',
  CURRENCY = 'CURRENCY',
  DEBTOR_ACCOUNT_NUMBER = 'DEBTOR_ACCOUNT_NUMBER',
  RECIPIENT = 'RECIPIENT',
  STATUS = 'STATUS'
}

export type StoredPaymentSummary = {
  __typename: 'StoredPaymentSummary';
  instructedAmount: CurrencyAmount;
  /** Indicates if the payment is capable for 1n payment. */
  isBatch1NCapable: Scalars['Boolean']['output'];
  /** If set, then the payment date of the payment. */
  paymentDate: Maybe<Scalars['DateTimeISO']['output']>;
  /** If there is only one recipient, the name of the recipient, otherwise like "Margir (2)". If payment is a batch payment, the name of the batch. */
  title: Scalars['String']['output'];
};

export type StoredPaymentsDebtorAccountSummary = {
  __typename: 'StoredPaymentsDebtorAccountSummary';
  accountNumber: Scalars['String']['output'];
  instructedAmount: CurrencyAmount;
  owner: Scalars['String']['output'];
};

export type StoredPaymentsSummary = {
  __typename: 'StoredPaymentsSummary';
  batches: Array<StoredPaymentSummary>;
  cardDeposits: Array<StoredPaymentSummary>;
  claimPayments: Array<StoredPaymentSummary>;
  creditTransfers: Array<StoredPaymentSummary>;
  crossBorderCreditTransfers: Array<StoredPaymentSummary>;
  /** Summary of debtor accounts. There will be a summary for each unique debtor account and currency. */
  debtorAccounts: Array<StoredPaymentsDebtorAccountSummary>;
  sepaCreditTransfers: Array<StoredPaymentSummary>;
  /** Total amount of all payments in the summary. Will return null if payments have different currencies. */
  totalAmount: Maybe<CurrencyAmount>;
};

/** Submit button component */
export type SubmitFormComponent = FormComponentBase & {
  __typename: 'SubmitFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  variant: Maybe<Scalars['String']['output']>;
};

export type SubmitFormTemplateRequestInput = {
  /** The ID of the form request to submit for signing */
  formRequestId: Scalars['String']['input'];
};

/** Payload after submitting a form request */
export type SubmitFormTemplateRequestPayload = {
  __typename: 'SubmitFormTemplateRequestPayload';
  error: Maybe<SubmitFormTemplateRequestPayloadErrorUnion>;
  result: Maybe<SubmitFormTemplateRequestResult>;
};

export type SubmitFormTemplateRequestPayloadErrorUnion = UnknownError;

/** Payload after submitting a form request */
export type SubmitFormTemplateRequestResult = {
  __typename: 'SubmitFormTemplateRequestResult';
  /** documentGroupId is the ID of the document that will be signed */
  documentGroupId: Maybe<Scalars['String']['output']>;
  userSignerStatus: Maybe<UserSignerStatus>;
};

/** Payload returned after submitting a KYC draft */
export type SubmitKycDraftPayload = {
  __typename: 'SubmitKycDraftPayload';
  /** Error details if the submit failed */
  error: Maybe<SubmitKycDraftPayloadErrorUnion>;
  /** The submitted KYC, null if the submit failed */
  result: Maybe<SubmitKycDraftResult>;
};

export type SubmitKycDraftPayloadErrorUnion = KycNotFound | KycNotSubmittable | UnknownError;

/** The KYC draft that was submitted */
export type SubmitKycDraftResult = {
  __typename: 'SubmitKycDraftResult';
  /** The submitted KYC */
  kyc: Maybe<Kyc>;
  /** ID of the submitted KYC */
  kycId: Scalars['ID']['output'];
  /** The status of the KYC after it was submitted */
  status: KycStatus;
};

export type SubmitKycInput = {
  /** ID (Api) of the KYC draft to submit (validate) */
  kycId: Scalars['String']['input'];
  /** Kennitala of the company the KYC is for, for users that are not acting for that company (e.g. national token users) */
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitLoanApplicationInput = {
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
};

export type SubmitLoanApplicationPayload = {
  __typename: 'SubmitLoanApplicationPayload';
  loanApplicationStatus: LoanApplicationStatus;
  success: Scalars['Boolean']['output'];
};

export type SubmitLoanApplicationResponse = LoanApplicationDoesNotExistError | SubmitLoanApplicationPayload;

export type SubscribeToEmailListFields = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeToEmailListInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<SubscribeToEmailListFields>>;
  mailinglists?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscribeToEmailListPayload = {
  __typename: 'SubscribeToEmailListPayload';
  worked: Scalars['Boolean']['output'];
};

export type SubscribeToFinancialStatementsInput = {
  /** Frequency to subscribe to. Initial flow uses monthly statements by default. */
  frequency?: FinancialStatementsSubscriptionFrequency;
};

/** Insufficient funds in account to create the financial statements subscription */
export type SubscribeToFinancialStatementsInsufficientFundsError = Error & {
  __typename: 'SubscribeToFinancialStatementsInsufficientFundsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Access to the withdrawal account is denied */
export type SubscribeToFinancialStatementsWithdrawalAccessDeniedError = Error & {
  __typename: 'SubscribeToFinancialStatementsWithdrawalAccessDeniedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Withdrawal account is locked or has insufficient funds */
export type SubscribeToFinancialStatementsWithdrawalAccountLockedError = Error & {
  __typename: 'SubscribeToFinancialStatementsWithdrawalAccountLockedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type Subscription = {
  __typename: 'Subscription';
  /** Mutation that listens to the result of initializing the signature process for Auðkenni. This event is completed when the server has finished initializing the signature process for Auðkenni, allowing the user to sign the next document in the group. */
  initializeSignatureProcessForAudkenniResult: InitializeSignatureProcessForAudkenniResult;
  /** A subscription that listens for a ping event and responds with the current server time. */
  redisServerTime: Scalars['DateTimeISO']['output'];
  serverTime: Scalars['DateTimeISO']['output'];
  /** Subscription that listens to the result of signing the next document in a digital signature group. The event is completed when the server has acknowledged that the signature process has finished, but the server might need a couple of seconds to update the state of the document. */
  signNextDigitalSignatureDocumentResult: SignDigitalSignatureGroupDocumentResult;
};


export type SubscriptionInitializeSignatureProcessForAudkenniResultArgs = {
  digitalSignatureGroupId: Scalars['ID']['input'];
};


export type SubscriptionSignNextDigitalSignatureDocumentResultArgs = {
  digitalSignatureGroupId: Scalars['ID']['input'];
};

export type SubscriptionDestinationInvalid = Error & {
  __typename: 'SubscriptionDestinationInvalid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type SwiftBankInformationResponse = BankNotFound | ForeignBankInformation | SwiftNotValid;

export type SwiftNotValid = Error & {
  __typename: 'SwiftNotValid';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The costs of SWIFT payments */
export type SwiftPaymentFees = {
  __typename: 'SwiftPaymentFees';
  /** Additional cost of using express method */
  expressCost: CurrencyAmount;
  /** Pay both receivers cost and senders costs */
  payAllCost: CurrencyAmount;
  /** Base cost of sending a Swift payment */
  sharedCost: CurrencyAmount;
};

/** SWIFT foreign recipient */
export type SwiftRecipient = ForeignRecipient & {
  __typename: 'SwiftRecipient';
  accountIdentifier: Scalars['String']['output'];
  address: Scalars['String']['output'];
  bankInfo: ForeignBankInformation;
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentMethod: CrossBorderPaymentMethod;
  postalCode: Scalars['String']['output'];
};

export type SyncTokenPayload = {
  __typename: 'SyncTokenPayload';
  /** Indication that a new token in the sequence is needed */
  success: Maybe<Scalars['Boolean']['output']>;
};

export type SyncTokenStepUpInput = {
  answer: Scalars['String']['input'];
};

export type TaxResidenciesInput = {
  countryId: Scalars['String']['input'];
  tin: Scalars['String']['input'];
};

/** Tax residency for KYC */
export type TaxResidency = {
  __typename: 'TaxResidency';
  country: CustomerLocation;
  tin: Scalars['String']['output'];
};

export enum TermItem {
  Account = 'Account',
  Card = 'Card',
  CreditCard = 'CreditCard',
  OnboardingPhoneCall = 'OnboardingPhoneCall',
  Onlinebank = 'Onlinebank'
}

/** A Terms & Conditions for a banking service */
export type TermsAndConditions = Node & {
  __typename: 'TermsAndConditions';
  contract: Maybe<TermsAndConditionsContract>;
  document: Maybe<Scalars['String']['output']>;
  documentV2: GenericFile;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  termId: Maybe<Scalars['Int']['output']>;
};

export type TermsAndConditionsApprovalMetadata = {
  applicationName: Scalars['String']['input'];
  loginDevice?: InputMaybe<Scalars['String']['input']>;
};

export type TermsAndConditionsApproveContractInput = {
  /** Description of a business process this Terms & Conditions approval is for. */
  businessProcess?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['String']['input'];
  metadata: TermsAndConditionsApprovalMetadata;
};

export type TermsAndConditionsApproveContractWithoutDocumentInput = {
  detailId: TermsAndConditionsContractDetailId;
  termItems: Array<TermsAndConditionsContractTermItem>;
};

/** A terms and conditions contract. */
export type TermsAndConditionsContract = {
  __typename: 'TermsAndConditionsContract';
  /** Kennitala of the user that approves the contract on behalf of a company/person */
  approverKennitala: Maybe<Scalars['String']['output']>;
  /** The ID of the associated document. Made nullable in V4 API, in which case we will return empty string */
  documentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The status of the contract. A signed contract will have the "signed" value */
  status: Scalars['String']['output'];
};

export enum TermsAndConditionsContractDetailId {
  CORPORATE_OVERDRAFT_SIMPLE_APPROVAL = 'CORPORATE_OVERDRAFT_SIMPLE_APPROVAL',
  Claims = 'Claims',
  TermsAndConditions = 'TermsAndConditions'
}

export enum TermsAndConditionsContractTermItem {
  CORPORATE_OVERDRAFT_SIMPLE_APPROVAL = 'CORPORATE_OVERDRAFT_SIMPLE_APPROVAL'
}

export type TermsAndConditionsDocumentInput = {
  contractDetailId: TermsAndConditionsContractDetailId;
  /** Kennitala of an entity this document is created for. */
  onBehalf?: InputMaybe<Scalars['String']['input']>;
  subjects: Array<TermsAndConditionsSubject>;
};

export enum TermsAndConditionsSubject {
  Account = 'Account',
  BusinessTerms = 'BusinessTerms',
  Claims = 'Claims'
}

/** Text input component */
export type TextFormComponent = FormComponentBase & {
  __typename: 'TextFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  /** Text to display during signing */
  signingText: Maybe<Scalars['String']['output']>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

/** Text key for claim */
export type TextKey = {
  __typename: 'TextKey';
  /** ID (Api) for text key */
  key: Maybe<Scalars['String']['output']>;
  /** Name of text key */
  name: Maybe<Scalars['String']['output']>;
};

/** Textarea component */
export type TextareaFormComponent = FormComponentBase & {
  __typename: 'TextareaFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
  value: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyPaymentAmount = {
  __typename: 'ThirdPartyPaymentAmount';
  amount: Maybe<Scalars['Int']['output']>;
  currencyCode: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyPaymentCreditTransfer = Node & {
  __typename: 'ThirdPartyPaymentCreditTransfer';
  /** Recipients account */
  creditorAccount: ThirdPartyPaymentCreditorAccountPayload;
  /** Payors withdrawal account */
  debtorAccount: ThirdPartyPaymentDebtorAccountPayload;
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructedAmount: ThirdPartyPaymentAmount;
  /** Requested payment date */
  paymentDate: Scalars['DateTimeISO']['output'];
  paymentTypeId: Maybe<Scalars['String']['output']>;
  /** The payment service provider that created this payment. */
  provider: Maybe<PaymentServiceProvider>;
  reference: Maybe<Scalars['String']['output']>;
  status: ThirdPartyPaymentStatus;
  textKey: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyPaymentCreditTransferErrorUnion = UnknownError;

/** The creditors name and iban or name, bban and kennitala */
export type ThirdPartyPaymentCreditorAccountInput = {
  bban?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
  /** Account owner name */
  ownerName: Scalars['String']['input'];
};

export type ThirdPartyPaymentCreditorAccountPayload = {
  __typename: 'ThirdPartyPaymentCreditorAccountPayload';
  bban: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
};

/** The recipients iban or the recipients bban and kennitala */
export type ThirdPartyPaymentDebtorAccountInput = {
  bban?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  kennitala?: InputMaybe<Scalars['String']['input']>;
};

export type ThirdPartyPaymentDebtorAccountPayload = {
  __typename: 'ThirdPartyPaymentDebtorAccountPayload';
  bban: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  kennitala: Scalars['String']['output'];
};

export type ThirdPartyPaymentInstructedAmountInput = {
  amount: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
};

/** Status of the payment */
export enum ThirdPartyPaymentStatus {
  ACCEPTED = 'ACCEPTED',
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN'
}

/** 3D Secure authentication details from the lookup or client event response (3ds action response) */
export type ThreeDSecureAuthentication = {
  /** Cardholder Authentication Verification Value */
  cavv: Scalars['String']['input'];
  directoryServerTransactionId: Scalars['String']['input'];
  /** The outcome of lookup authentication. It must be passed during authorization to prove liability shift */
  electronicCommerceIndicator: ElectronicCommerceIndicator;
  /** Indicates the enrolled status of the issuer (frictionless, challenge, or not enrolled). */
  enrolledStatus: SecurePaymentsEnrolledStatus;
  /** Payer Authentication Response Status (Should we ask the api for enum mapping?) */
  paresStatus: SecurePaymentsParesStatus;
  /** Version of the 3D Secure protocol used in the authentication. */
  threeDSecureVersion: Scalars['String']['input'];
};

/** Billing information for payment lookup */
export type ThreeDSecureBillingInformationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type ThreeDSecureLookup = {
  __typename: 'ThreeDSecureLookup';
  /** Unique identifier for the Access Control Server (ACS) transaction. Used for tracking the authentication session with the card issuer. */
  accessControlServerTransactionId: Maybe<Scalars['String']['output']>;
  /** URL of the Access Control Server for 3D Secure authentication. Used with Cardinal.continue() when challenge is required. */
  accessControlServerUrl: Maybe<Scalars['String']['output']>;
  /** Cardholder Authentication Verification Value */
  cavv: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the Directory Server (DS) transaction. Required when submitting the final payment authorization. */
  directoryServerTransactionId: Maybe<Scalars['String']['output']>;
  /** The outcome of lookup authentication. It must be passed during authorization to prove liability shift */
  electronicCommerceIndicator: ElectronicCommerceIndicator;
  /** Indicates whether the enrolled status of the card issuer */
  enrolledStatus: SecurePaymentsEnrolledStatus;
  /** JWT payload containing challenge request data. Used to initiate the challenge flow with Cardinal */
  jwtPayload: Maybe<Scalars['String']['output']>;
  /** Payer Authentication Response Status (PARes) */
  paresStatus: Maybe<SecurePaymentsParesStatus>;
  /** Version of the 3D Secure protocol used in the authentication. */
  threeDSecureVersion: Maybe<Scalars['String']['output']>;
  /** Unique transaction identifier from the 3DS lookup. Pass to Cardinal.continue() in OrderDetails.TransactionId for challenge authentication. */
  transactionId: Maybe<Scalars['String']['output']>;
};

export type ThreeDSecureLookupErrorUnion = UnknownError;

/** Input for 3D Secure payment lookup */
export type ThreeDSecureLookupInput = {
  /** amount for the payment lookup */
  amount: Scalars['Int']['input'];
  /** billing information for the payment lookup */
  billingInformation: ThreeDSecureBillingInformationInput;
  /** unique device info id generated by the client */
  deviceInfoId: Scalars['String']['input'];
  /** card data encrypted by the client */
  encryptedCard: Scalars['String']['input'];
  /** This can be a traceable merchant reference for the transaction (e.g. orderId, transactionId). If there is no applicable reference, a clientId is suggested. */
  merchantReference: Scalars['String']['input'];
};

export type ThreeDSecureLookupPayload = {
  __typename: 'ThreeDSecureLookupPayload';
  /** Errors encountered during the 3D Secure lookup process. */
  error: Maybe<ThreeDSecureLookupErrorUnion>;
  /** 3D Secure lookup information. Contains details required for authentication. */
  threeDSecureLookup: Maybe<ThreeDSecureLookup>;
};

/** Indicates the severity of the time difference between client and server. */
export enum TimeSyncSeverity {
  /** Significant time difference detected. Will prevent the user from signing in due to major desynchronization. */
  CRITICAL = 'CRITICAL',
  /** Moderate time difference detected. Might cause some service issues due to desynchronization. */
  MODERATE = 'MODERATE',
  /** No significant time difference detected. Users should experience no issues. */
  SYNCHRONIZED = 'SYNCHRONIZED'
}

export type TimeSyncStatus = {
  __typename: 'TimeSyncStatus';
  /** Current server time when the query is executed. */
  serverTime: Scalars['DateTimeISO']['output'];
  /** Severity level of the time difference, indicating potential issues. */
  severity: TimeSyncSeverity;
  /** Absolute difference in hours between client and server time. */
  totalDifferenceInHours: Scalars['Int']['output'];
  /** Absolute difference in minutes between client and server time. */
  totalDifferenceInMinutes: Scalars['Int']['output'];
  /** Difference in seconds between client and server times (client time - server time). */
  totalDifferenceInSeconds: Scalars['Int']['output'];
};

export type ToggleCollectionServiceThirdPartyPermissionInput = {
  /** Boolean value to enable or disable permission */
  enabled: Scalars['Boolean']['input'];
  /** Unique identifier of the permission (unique for the client) */
  permissionId: Scalars['String']['input'];
  /** Kennitala of the third party */
  thirdPartyId: Scalars['String']['input'];
};

/** Response from change third party permission */
export type ToggleCollectionServiceThirdPartyPermissionPayload = {
  __typename: 'ToggleCollectionServiceThirdPartyPermissionPayload';
  /** Error returned after an unsuccessful toggle request */
  error: Maybe<CollectionServiceThirdPartyTogglePermissionErrorUnion>;
  /** Updated third party permission from successful change request */
  thirdPartyPermission: Maybe<CollectionServiceThirdPartyPermission>;
};

export type TokenStepUpPayload = {
  __typename: 'TokenStepUpPayload';
  /** The attempt information for SMS stepup */
  attempts: Maybe<RsaChallengeAttempts>;
  /** Indication if the given request was successful */
  success: Scalars['Boolean']['output'];
  /** Indication that a new token in the sequence is needed */
  syncToken: Maybe<Scalars['Boolean']['output']>;
};

export type TooManyExcelColumnsError = Error & {
  __typename: 'TooManyExcelColumnsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Trade-in vehicle */
export type TradeInVehicle = {
  __typename: 'TradeInVehicle';
  /** The encumbrances (left-over loan) */
  encumbrances: Scalars['Float']['output'];
  /** Vehicle make & model. E.g. Volvo XC90, 2022 */
  name: Maybe<Scalars['String']['output']>;
  /** Amount that the customer gets out of the trade-in */
  ownedAmount: Scalars['Float']['output'];
  /** Registration number of the car. E.g. AB C01 */
  registrationNumber: Scalars['String']['output'];
  /** Selling price of a vehicle used as a trade-in. It represents the price that a salesperson pays to the customer */
  sellingPrice: Scalars['Float']['output'];
};

/** MiFID appropriateness test answers, two categories of question, knowledge and experience */
export type TradingAppropriatenessTest = {
  __typename: 'TradingAppropriatenessTest';
  education: GeneralKnowledgeAssessment;
  etfs: CategoryQuestion;
  experience: GeneralKnowledgeAssessment;
  investmentFunds: CategoryQuestion;
  jobExperience: GeneralKnowledgeAssessment;
  knowledge: GeneralKnowledgeAssessment;
  listedBonds: CategoryQuestion;
  listedEquities: CategoryQuestion;
  ucitsFunds: CategoryQuestion;
};

/** Compliance information for trading stocks */
export type TradingCompliance = {
  __typename: 'TradingCompliance';
  approvedInformation: Array<Scalars['String']['output']>;
  availableCustodialAccounts: Maybe<AccountConnection>;
  availablePortfolios: Maybe<PortfolioConnection>;
  buyAllowed: Scalars['Boolean']['output'];
  canCreateCustodialAgreement: Scalars['Boolean']['output'];
  eligibleInformation: Array<Scalars['String']['output']>;
  hasCustodialAgreement: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  instrument: Maybe<Instrument>;
  /** Returns if the stock market is open or closed, for funds it returns null */
  isMarketOpen: Maybe<Scalars['Boolean']['output']>;
  nextAction: TradingComplianceNextAction;
  notAllowedInformation: Maybe<TradingComplianceInstrumentNotAllowedInformation>;
  notEligibleInformation: Array<Scalars['String']['output']>;
  sellAllowed: Scalars['Boolean']['output'];
  status: TradingComplianceStatus;
};


/** Compliance information for trading stocks */
export type TradingComplianceAvailableCustodialAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Compliance information for trading stocks */
export type TradingComplianceAvailablePortfoliosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TradingComplianceDetailArgs = {
  action: TradingComplianceInstrumentAction;
  instrumentId: Scalars['String']['input'];
};

export enum TradingComplianceInstrumentAction {
  Buy = 'Buy',
  Sell = 'Sell',
  Subscription = 'Subscription'
}

export enum TradingComplianceInstrumentNotAllowedInformation {
  AppropriatenessTestUnanswered = 'AppropriatenessTestUnanswered',
  IllegalDomicile = 'IllegalDomicile',
  InstrumentDoseNotAllowTrading = 'InstrumentDoseNotAllowTrading',
  InvalidLei = 'InvalidLei',
  InvalidNci = 'InvalidNci',
  NoBankAccount = 'NoBankAccount',
  NoCustodialAgreement = 'NoCustodialAgreement',
  NotAppropriate = 'NotAppropriate',
  ReadAccess = 'ReadAccess',
  TemporaryBuyClosed = 'TemporaryBuyClosed',
  TemporarySellClosed = 'TemporarySellClosed',
  Underage = 'Underage',
  UserNotAllowedToTrade = 'UserNotAllowedToTrade'
}

export enum TradingComplianceNextAction {
  AnswerAppropriatenessTest = 'AnswerAppropriatenessTest',
  CanTrade = 'CanTrade',
  CreateCustodialAccount = 'CreateCustodialAccount',
  CreateCustodialAgreement = 'CreateCustodialAgreement',
  NoActionAvailable = 'NoActionAvailable',
  ShowEducation = 'ShowEducation'
}

export enum TradingComplianceStatus {
  Approved = 'Approved',
  Eligible = 'Eligible',
  NotEligible = 'NotEligible',
  Pending = 'Pending'
}

export type TransactionFilterArgs = {
  amountFrom?: InputMaybe<Scalars['Float']['input']>;
  amountTo?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TransactionsSearchType>;
};

export type TransactionsOrderBy = {
  direction?: InputMaybe<OrderByDirection>;
  field?: InputMaybe<TransactionsOrderByOption>;
};

export enum TransactionsOrderByOption {
  /** Order by amount of transaction */
  Amount = 'Amount',
  /** Order by balance of transaction account */
  Balance = 'Balance',
  /** Order by transaction date (for corporate users) or reservation date (for personal users) */
  Date = 'Date',
  /** Order alphabetically by "Lýsing" */
  Description = 'Description',
  /** Order alphabetically by "Nafn viðtakanda" */
  RecipientName = 'RecipientName',
  /** Order alphabetically by "Tilvísun" */
  Reference = 'Reference',
  /** Order by "Tilvísunar númer" */
  ReferenceNumber = 'ReferenceNumber',
  /** Order by "Kaupdagsetningu". Use Date instead, since it is resolved to the correct type of date */
  ReservationDate = 'ReservationDate',
  /** Order by "Færsludagsetningu". Use Date instead, since it is resolved to the correct type of date */
  TransactionDate = 'TransactionDate',
  /** Order alphabetically by "Skýring" */
  TransactionDescription = 'TransactionDescription'
}

export enum TransactionsSearchType {
  All = 'All',
  Deposit = 'Deposit',
  Withdrawal = 'Withdrawal'
}

export type TriggerActionLinkPayload = {
  __typename: 'TriggerActionLinkPayload';
  /** The conversation with the added replies if any. If the conversation status is VIRTUAL_AGENT then the responses from the chatbot will be included. */
  conversation: CustomerConversation;
};

export type TriggerConversationActionLinkInput = {
  /** Id of the action link to trigger. */
  actionLinkId: Scalars['ID']['input'];
  /** Id of the conversation to trigger the action link. */
  conversationId: Scalars['ID']['input'];
};

export enum TypeCode {
  AvailableAmount = 'AvailableAmount',
  EmptyAccount = 'EmptyAccount',
  FixedAmount = 'FixedAmount',
  SpecifiedAmount = 'SpecifiedAmount',
  WithdrawalNotice = 'WithdrawalNotice'
}

/** Information about ultimate party */
export type UltimateParty = {
  __typename: 'UltimateParty';
  kennitala: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type UltimatePartyInput = {
  identifier?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UnableToCreateMandateForCustomerNumber = Error & {
  __typename: 'UnableToCreateMandateForCustomerNumber';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UnauthorizedContact = Error & {
  __typename: 'UnauthorizedContact';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Unique claimant category, only code and name. */
export type UniqueClaimantCategory = {
  __typename: 'UniqueClaimantCategory';
  /** Category code of the claimant category */
  code: Scalars['String']['output'];
  /** Description of the claimant category, code and name if available. */
  description: Scalars['String']['output'];
  /** Name of the category */
  name: Maybe<Scalars['String']['output']>;
};

export type UnknownError = Error & {
  __typename: 'UnknownError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UnknownFileValidationError = Error & FileValidationError & {
  __typename: 'UnknownFileValidationError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** Unknown form component */
export type UnknownFormComponent = FormComponentBase & {
  __typename: 'UnknownFormComponent';
  id: Scalars['String']['output'];
  isRequired: Scalars['Boolean']['output'];
  label: Maybe<Scalars['String']['output']>;
  /** Rule that makes this component required based on another component value */
  requiredWhen: Maybe<FormComponentRequiredWhen>;
  type: FormComponentType;
};

export type UnmetOnboardingConditions = Error & {
  __typename: 'UnmetOnboardingConditions';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Unpaid bills widget */
export type UnpaidBillsWidget = {
  __typename: 'UnpaidBillsWidget';
  /** Whether the widget should be displayed */
  display: Scalars['Boolean']['output'];
  /** The reason the widget is not displayed if there is one */
  displayReason: Maybe<WidgetDisplayReason>;
  id: Scalars['ID']['output'];
};

/** An error occurred while deleting the financial statements subscription */
export type UnsubscribeFromFinancialStatementsError = Error & {
  __typename: 'UnsubscribeFromFinancialStatementsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** A single account permission update */
export type UpdateAccountAuthorizationInput = {
  /** Access level for the account */
  access: AccountAccessLevel;
  /** Display number of the account */
  displayNumber: Scalars['String']['input'];
  /** Company user username */
  username: Scalars['String']['input'];
};

export type UpdateAccountInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use updateFinancialSummaryAccounts instead. Issue to remove this: WEB-30583. Deprecated since 2024-12-09 */
  showInSummary?: InputMaybe<Scalars['Boolean']['input']>;
  showOnFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAccountPinInput = {
  id: Scalars['ID']['input'];
  pin: Scalars['String']['input'];
};

export type UpdateAccountPinPayloadErrorUnion = AccountSecurityCodeUnauthorized | UnknownError;

export type UpdateAccountPinPayloadV2 = {
  __typename: 'UpdateAccountPinPayloadV2';
  error: Maybe<UpdateAccountPinPayloadErrorUnion>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAccountPinResponse = AccountSecurityCodeChangedPayload | AccountSecurityCodeUnauthorized | RsaStepUpResponse;

export type UpdateAccountPinResponseV2 = AdaptiveAuthentication | UpdateAccountPinPayloadV2;

/** Input for batch updating account authorizations */
export type UpdateAccountsAuthorizationsInput = {
  /** Overall update to apply (optional) */
  overallUpdate?: InputMaybe<OverallAccountUpdateInput>;
  /** Individual permission updates to apply */
  updates: Array<UpdateAccountAuthorizationInput>;
};

/** Payload for batch updating account authorizations */
export type UpdateAccountsAuthorizationsPayload = {
  __typename: 'UpdateAccountsAuthorizationsPayload';
  /** Number of failed updates */
  failedUpdates: Scalars['Int']['output'];
  /** Overall status of the bulk update */
  status: BulkUpdateStatus;
  /** Number of successful updates */
  successfulUpdates: Scalars['Int']['output'];
  /** Total number of permission updates attempted */
  totalUpdates: Scalars['Int']['output'];
  /** List of unsuccessful updates with error details (null when all succeeded) */
  unsuccessfulUpdates: Maybe<Array<AccountPermissionUpdateFailure>>;
};

export type UpdateAccountsInput = {
  accounts: Array<UpdateAccountInput>;
};

/** Payload for updating notification settings for bank accounts */
export type UpdateAccountsNotificationsInput = {
  /** True for enabling notifications for deposits */
  depositsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** True for enabling notifications when available balance goes under some limit. */
  lowBalanceNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum balance for a notification to be triggered. */
  lowBalanceThresholdAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum amount for a notification to be triggered. */
  minimumDepositAmount?: InputMaybe<Scalars['Float']['input']>;
  /** True for enabling notifications on proxied accounts. */
  proxiedAccountsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAccountsPayload = {
  __typename: 'UpdateAccountsPayload';
  accounts: Array<Account>;
};

export type UpdateApplicantsOfVehicleLoanApplicationInput = {
  /** List of applicants that needs to be updated. */
  applicants: Array<UpdateLoanApplicantInput>;
  /** ID of a loan application */
  id: Scalars['ID']['input'];
};

/** Input for updating an application account */
export type UpdateApplicationAccountInput = {
  /** Description of the application account */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID (Global) of the application account */
  id: Scalars['ID']['input'];
  /** Name of the application account */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateApplicationAccountPermissionError = Error & {
  __typename: 'UpdateApplicationAccountPermissionError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateApplicationAccountPermissionErrorUnion = UnknownError | UpdateApplicationAccountPermissionError;

/** Input for updating application account permissions */
export type UpdateApplicationAccountPermissionInput = {
  /** ID (Global) of the application account */
  applicationAccountId: Scalars['ID']['input'];
  /** List of permissions to update */
  permissions: Array<UpdateApplicationAccountPermissionItemInput>;
};

/** A single permission item to update */
export type UpdateApplicationAccountPermissionItemInput = {
  /** Whether the permission is enabled or not */
  enabled: Scalars['Boolean']['input'];
  /** Unique identifier of the permission (unique for the client) */
  id: Scalars['ID']['input'];
};

/** Payload for updating application account permissions */
export type UpdateApplicationAccountPermissionPayload = {
  __typename: 'UpdateApplicationAccountPermissionPayload';
  /** Error, if any occurred during the permissions update */
  error: Maybe<UpdateApplicationAccountPermissionErrorUnion>;
  /** Updated list of permissions for the application account */
  permissions: Maybe<Array<ApplicationAccountPermission>>;
};

export type UpdateAuthorizationWithdrawalLimitData = {
  __typename: 'UpdateAuthorizationWithdrawalLimitData';
  /** Maximum withdrawal limit for the acting user */
  limit: Maybe<CurrencyAmount>;
};

export type UpdateAuthorizationWithdrawalLimitErrorUnion = UnknownError;

export type UpdateAuthorizationWithdrawalLimitPayload = {
  __typename: 'UpdateAuthorizationWithdrawalLimitPayload';
  /** Data returned when updating withdrawal limit for the acting user */
  data: Maybe<UpdateAuthorizationWithdrawalLimitData>;
  /** Error returned when updating withdrawal limit for the acting user */
  error: Maybe<UpdateAuthorizationWithdrawalLimitErrorUnion>;
};

export type UpdateBondLoanApplicationInput = {
  /** Reikningur sem á að greiða lánið inná. Ef greiða á lánið inn á kort þá skal setja hér inn sama og directDebitAccountnumber. */
  accountNumber: Scalars['String']['input'];
  /** Upphæð láns */
  amount: Scalars['Float']['input'];
  /** Ef greiða á lánið inn á kort. */
  cardId?: InputMaybe<Scalars['Int']['input']>;
  /** Skuldfærslureikningur. */
  directDebitAccountNumber: Scalars['String']['input'];
  loanApplicationId: Scalars['String']['input'];
  /** Lánstími í mánuðum. Möguleg gildi sótt úr product catalog. */
  loanDurationMonths: Scalars['Int']['input'];
};

export type UpdateBondLoanApplicationPayload = {
  __typename: 'UpdateBondLoanApplicationPayload';
  bondLoanApplication: BondLoanApplication;
};

export type UpdateCampaignParticipationPayload = {
  __typename: 'UpdateCampaignParticipationPayload';
  /** The same campaign id that came from the input. */
  campaignId: Scalars['String']['output'];
};

export type UpdateCampaignParticipationPayloadResponse = DidNotFindUserAndOrCampaignError | UpdateCampaignParticipationPayload;

/** A single card permission update */
export type UpdateCardAuthorizationInput = {
  /** Access level for the card */
  access: CardAccessLevel;
  /** Card ID (Global) */
  cardId: Scalars['ID']['input'];
  /** Company user username */
  username: Scalars['String']['input'];
};

/** Input to update a single push notification */
export type UpdateCardPushNotificationOptionInput = {
  isEnabled: Scalars['Boolean']['input'];
  notificationOptionId: Scalars['String']['input'];
};

export type UpdateCardPushNotificationOptionsErrorUnion = UnknownError;

/** Input to update multiple push notifications */
export type UpdateCardPushNotificationOptionsInput = {
  cardId: Scalars['ID']['input'];
  notifications: Array<UpdateCardPushNotificationOptionInput>;
};

/** Update credit card notification option payload */
export type UpdateCardPushNotificationOptionsPayload = {
  __typename: 'UpdateCardPushNotificationOptionsPayload';
  error: Maybe<UpdateCardPushNotificationOptionsErrorUnion>;
  notificationOptions: Maybe<Array<CardNotificationOption>>;
};

/** Create or change card saving of a given saving */
export type UpdateCardSavingInput = {
  destination: CardSavingDestinationInput;
  /** Card saving (model) id. Only applicable when updating an card saving */
  id?: InputMaybe<Scalars['String']['input']>;
  savingsType: CardSavingTypeInput;
  source: CardSavingSourceInput;
  type: UpdateCardSavingMethod;
};

/** For mutating card saving */
export enum UpdateCardSavingMethod {
  /** Creating new card saving */
  Create = 'Create',
  /** Updating existing card saving */
  Update = 'Update'
}

export type UpdateCardSavingSubscriptionInput = {
  destination?: InputMaybe<CardSavingDestinationInput>;
  id: Scalars['ID']['input'];
  /** The (global) id of the saving type */
  savingsTypeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCardSavingValidationError = Error & {
  __typename: 'UpdateCardSavingValidationError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateCardSavingsResponse = CardSavingSubscriptionNotFound | CardSavingSubscriptionPayload | SavingsTypeNotFound | SubscriptionDestinationInvalid;

export type UpdateCardTransactionControlInput = {
  /** The id of the card being updated */
  cardId: Scalars['ID']['input'];
  /** Indicates if the transaction control is on or off */
  isActive: Scalars['Boolean']['input'];
  /** The transaction control id of the object being updated */
  transactionControlId: Scalars['ID']['input'];
};

/** Returns either cardTransactionControl and no error or cardTransactionControl null and an error of type CardTransactionControlNotFoundError */
export type UpdateCardTransactionControlPayload = {
  __typename: 'UpdateCardTransactionControlPayload';
  /** If successful patch the return object is a card transaction control */
  cardTransactionControl: Maybe<CardTransactionControl>;
  error: Maybe<CardTransactionControlNotFoundError>;
};

export type UpdateCardTransactionErrorUnion = UnknownError;

export type UpdateCardTransactionInput = {
  /** A comment with details about a card transaction. To remove a comment pass in empty string. */
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of a new (already-existent) ledger key group.
   * To remove the current linked ledger key group, pass in empty string. Note that this will also remove the linked sub group.
   */
  ledgerKeyGroupId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The ID of a new (already-existent) ledger key.
   * To remove the current linked ledger key, pass in empty string. Note that this will also remove the linked ledger key group and sub group.
   */
  ledgerKeyId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The ID of a new (already-existent) ledger key sub group.
   * To remove the current linked ledger key sub group, pass in empty string.
   */
  ledgerKeySubGroupId?: InputMaybe<Scalars['ID']['input']>;
  transactionId: Scalars['ID']['input'];
};

/** Returns cardTransaction that contains id, ledgerKey and identifier or null */
export type UpdateCardTransactionPayload = {
  __typename: 'UpdateCardTransactionPayload';
  /** If the update is successful, this field contains the updated card transaction. */
  cardTransaction: Maybe<CreditCardTransaction>;
  error: Maybe<UpdateCardTransactionErrorUnion>;
};

/** Returns cardTransaction that contains id, attachments, comment, ledger key, ledger key group, ledger key subgroup, and other details. */
export type UpdateCardTransactionPayloadV2 = {
  __typename: 'UpdateCardTransactionPayloadV2';
  /** If the update is successful, this field contains the updated card transaction. */
  cardTransaction: Maybe<CardTransaction>;
  error: Maybe<UpdateCardTransactionErrorUnion>;
};

/** Input for batch updating card authorizations */
export type UpdateCardsAuthorizationInput = {
  /** Overall update to apply (optional) */
  overallUpdate?: InputMaybe<OverallCardUpdateInput>;
  /** Individual permission updates to apply */
  updates: Array<UpdateCardAuthorizationInput>;
};

/** Payload for batch updating card authorizations */
export type UpdateCardsAuthorizationPayload = {
  __typename: 'UpdateCardsAuthorizationPayload';
  /** Number of failed updates */
  failedUpdates: Scalars['Int']['output'];
  /** Overall status of the bulk update */
  status: BulkUpdateStatus;
  /** Number of successful updates */
  successfulUpdates: Scalars['Int']['output'];
  /** Total number of permission updates attempted */
  totalUpdates: Scalars['Int']['output'];
  /** List of unsuccessful updates with error details (null when all succeeded) */
  unsuccessfulUpdates: Maybe<Array<CardPermissionUpdateFailure>>;
};

export type UpdateCardsInput = {
  cards: Array<UpdateDebitCardInput>;
};

export type UpdateCardsPayload = {
  __typename: 'UpdateCardsPayload';
  cards: Array<DebitCard>;
};

export type UpdateCashPoolAccountSettingsErrorUnion = UnknownError;

export type UpdateCashPoolAccountSettingsInput = {
  /** Id of the cashPool account */
  cashPoolAccountId: Scalars['ID']['input'];
  data: CashPoolAccountSettingsInput;
};

/** Returns either cashPool account and no error or  cashPool account and an error from CustomerFeedbackResponseErrorUnion */
export type UpdateCashPoolAccountSettingsPayload = {
  __typename: 'UpdateCashPoolAccountSettingsPayload';
  cashPoolAccount: Maybe<CashPoolAccount>;
  error: Maybe<UpdateCashPoolAccountSettingsErrorUnion>;
};

export type UpdateCashPoolBaseInterestRateErrorUnion = UnknownError;

export type UpdateCashPoolBaseInterestRateInput = {
  baseDepositInterestRate?: InputMaybe<Scalars['Float']['input']>;
  baseOverdraftInterestRate?: InputMaybe<Scalars['Float']['input']>;
  cashPoolId: Scalars['ID']['input'];
};

export type UpdateCashPoolBaseInterestRatePayload = {
  __typename: 'UpdateCashPoolBaseInterestRatePayload';
  /** If the patch is successful the return object is the cash pool */
  cashPool: Maybe<CashPool>;
  error: Maybe<UpdateCashPoolBaseInterestRateErrorUnion>;
};

export type UpdateClaimInput = {
  hidden: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateClaimPayerInput = {
  kennitala: Scalars['String']['input'];
  showInSummary: Scalars['Boolean']['input'];
};

export type UpdateClaimPayersInput = {
  claimPayers: Array<UpdateClaimPayerInput>;
};

/** Update claim payers payload */
export type UpdateClaimPayersPayload = {
  __typename: 'UpdateClaimPayersPayload';
  claimPayers: Array<ClaimPayer>;
};

export type UpdateClaimPayersResult = UpdateClaimPayersPayload;

/** Response for successful claim update */
export type UpdateClaimPayload = {
  __typename: 'UpdateClaimPayload';
  claim: Claim;
};

export type UpdateClaimResponse = ClaimNotFound | UpdateClaimPayload;

export type UpdateClaimsInput = {
  claims: Array<UpdateClaimInput>;
};

export type UpdateClaimsNotificationsInput = {
  creation?: InputMaybe<Scalars['Boolean']['input']>;
  finalDueDate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateConversationSubjectPayload = {
  __typename: 'UpdateConversationSubjectPayload';
  /** The conversation with the updated subject." */
  conversation: Maybe<CustomerConversation>;
};

export type UpdateCreditAssessmentExpensesInput = {
  expenses: Array<CreditAssessmentExpenseInput>;
  id: Scalars['ID']['input'];
};

export type UpdateCreditAssessmentInput = {
  debt?: InputMaybe<CreditAssessmentDebtInput>;
  expense?: InputMaybe<CreditAssessmentExpenseInput>;
  id: Scalars['ID']['input'];
  realEstate?: InputMaybe<CreditAssessmentRealEstateInput>;
  reasonType?: InputMaybe<CreditAssessmentReasonType>;
  status?: InputMaybe<CreditAssessmentStatus>;
  vehicle?: InputMaybe<CreditAssessmentVehicleInput>;
};

export type UpdateCreditAssessmentPayload = {
  __typename: 'UpdateCreditAssessmentPayload';
  creditAssessment: CreditAssessment;
};

export type UpdateCreditAssessmentRealEstateInput = {
  /** The market value of the real estate */
  marketValue?: InputMaybe<Scalars['Float']['input']>;
  /** Real estate id */
  realEstateId: Scalars['String']['input'];
  /** Optional input field indicating if the real estate will be sold, bought, refinanced or none */
  realEstateType?: InputMaybe<CreditAssessmentRealEstateType>;
};

export type UpdateCreditAssessmentRealEstatesInput = {
  /** Credit assessment id */
  id: Scalars['ID']['input'];
  realEstates: Array<UpdateCreditAssessmentRealEstateInput>;
};

export type UpdateCreditCardAliasErrorUnion = UnknownError;

/** Input used to update a card's alias (customName) */
export type UpdateCreditCardAliasInput = {
  /** New alias for the card. If empty string is provided, this will set the current alias to null */
  alias: Scalars['String']['input'];
  /** (Global) ID of the credit card that will be updated */
  cardId: Scalars['ID']['input'];
};

export type UpdateCreditCardAliasPayload = {
  __typename: 'UpdateCreditCardAliasPayload';
  creditCardDetails: Maybe<UpdateCreditCardData>;
  error: Maybe<UpdateCreditCardAliasErrorUnion>;
};

export type UpdateCreditCardApplicationInput = {
  applicationStatus?: InputMaybe<CreditCardApplicationStatus>;
  id: Scalars['ID']['input'];
};

/** Input used to update a card's credit line. Note: If successful, the mutation returns the updated creditLine value; However, it might take the API few minutes to return the actual updated value */
export type UpdateCreditCardCreditLineInput = {
  cardId: Scalars['ID']['input'];
  creditLine: Scalars['Float']['input'];
};

/**
 * Returns EITHER the updated creditCard (*with updated value for creditLine) and no error OR no creditCard an error.
 * *We are not updating the credit line ourselves; Rather, request Rapyd to update - and this might be a bit slow.
 * We are manually updating this value inside GraphQL, but the API might take up to few minutes until that is returned
 */
export type UpdateCreditCardCreditLinePayload = {
  __typename: 'UpdateCreditCardCreditLinePayload';
  /** If successful patch, the return object is a card object */
  creditCard: Maybe<CreditCard>;
  error: Maybe<CardNotFoundError>;
};

export type UpdateCreditCardData = {
  __typename: 'UpdateCreditCardData';
  /** The new alias of the credit card */
  alias: Maybe<Scalars['String']['output']>;
  /** ID (Global) of the credit card */
  id: Scalars['ID']['output'];
};

export type UpdateCreditCardInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Notify if available amount is below the threshold amount */
  amountAvailableUnderThresholdNotification?: InputMaybe<CreditCardNotificationEventWithThresholdInput>;
  cardHolderEmail?: InputMaybe<Scalars['String']['input']>;
  cardHolderMobile?: InputMaybe<Scalars['String']['input']>;
  /** Notify if a deposit is made to the card */
  depositNotification?: InputMaybe<CreditCardNotificationEventInput>;
  id: Scalars['ID']['input'];
  /** Changes the issuedCardStatus into Frozen or Open */
  isFrozen?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notify if purchases made with amount higher than threshold amount */
  purchasesOverThresholdNotification?: InputMaybe<CreditCardNotificationEventWithThresholdInput>;
  /** @deprecated Use updateFinancialSummaryCards instead. Issue to remove this: WEB-30586. Deprecated since 2024-12-09 */
  showInSummary?: InputMaybe<Scalars['Boolean']['input']>;
  showOnFrontpage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notify if overdraft usage is above the given threshold percentage (0-100) */
  spendOverdraftPercentageNotification?: InputMaybe<CreditCardNotificationEventWithThresholdInput>;
  /** Notify if a withdrawal is made without the physical card */
  withdrawalWithoutCardNotification?: InputMaybe<CreditCardNotificationEventInput>;
};

/** Input used to update a card's issued card status. This is mainly used to 'toggle' the frozen/open status */
export type UpdateCreditCardIssuedStatusInput = {
  cardId: Scalars['ID']['input'];
  issuedCardStatus: IssuedCardStatus;
};

/** Returns either the updated creditCard (with updated value for issuedCardStatus) and no error OR no creditCard an error. */
export type UpdateCreditCardIssuedStatusPayload = {
  __typename: 'UpdateCreditCardIssuedStatusPayload';
  /** If successful patch, the return object is a card object */
  creditCard: Maybe<CreditCard>;
  error: Maybe<CardNotFoundError>;
};

/** Input to update a single push notification */
export type UpdateCreditCardPushNotificationOptionInput = {
  id: Scalars['ID']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type UpdateCreditCardPushNotificationOptionsErrorUnion = UnknownError;

/** Input to update multiple push notifications */
export type UpdateCreditCardPushNotificationOptionsInput = {
  cardId: Scalars['ID']['input'];
  notifications: Array<UpdateCreditCardPushNotificationOptionInput>;
};

/** Update credit card notification option payload */
export type UpdateCreditCardPushNotificationOptionsPayload = {
  __typename: 'UpdateCreditCardPushNotificationOptionsPayload';
  error: Maybe<UpdateCreditCardPushNotificationOptionsErrorUnion>;
  notificationOptions: Maybe<Array<CreditCardNotificationOption>>;
};

export type UpdateCreditCardsError = Error & {
  __typename: 'UpdateCreditCardsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateCreditCardsInput = {
  cards: Array<UpdateCreditCardInput>;
};

/** Update credit cards payload */
export type UpdateCreditCardsPayload = {
  __typename: 'UpdateCreditCardsPayload';
  cards: Array<CreditCard>;
};

export type UpdateCreditCardsResult = CreditCardServiceUnavailable | UpdateCreditCardsError | UpdateCreditCardsPayload;

export type UpdateCustodialAgreementInput = {
  fundKnowledge?: InputMaybe<FundKnowledgeInupt>;
  id?: InputMaybe<Scalars['ID']['input']>;
  sendStatementsAndReceiptsInMail?: InputMaybe<Scalars['Boolean']['input']>;
  tradingAppropriatenessTest?: InputMaybe<AnswerTradingAppropriatenessTestInput>;
};

export type UpdateCustodialAgreementPayload = {
  __typename: 'UpdateCustodialAgreementPayload';
  appropriatenessTest: Maybe<TradingAppropriatenessTest>;
  custodialAgreement: Maybe<CustodialAgreement>;
};

/** Input for updating customer loyalty consent */
export type UpdateCustomerLoyaltyConsentInput = {
  /** The identifier for the consent being updated */
  consentId: Scalars['Int']['input'];
  /** Indicates whether permission has been granted */
  granted: Scalars['Boolean']['input'];
  /** The version of the consent being granted or revoked */
  versionNo: Scalars['Int']['input'];
};

/** Response payload for updating customer loyalty consent */
export type UpdateCustomerLoyaltyConsentPayload = {
  __typename: 'UpdateCustomerLoyaltyConsentPayload';
  /** Unique consent type identifier */
  consentId: Scalars['Int']['output'];
  /** True if customer has granted the consent */
  granted: Scalars['Boolean']['output'];
  /** Latest version for this consent type */
  versionNo: Scalars['Int']['output'];
};

export type UpdateDebitCardInput = {
  id: Scalars['ID']['input'];
  isFrozen: Scalars['Boolean']['input'];
};

export type UpdateDepositAmountOfVehicleLoanApplicationInput = {
  /** New value for the depositAmount */
  depositAmount: Scalars['Float']['input'];
  /** ID of the loan application */
  id: Scalars['ID']['input'];
  /** ID of the vehicle mortgage (found under a loan application) */
  vehicleMortgageId: Scalars['ID']['input'];
};

export type UpdateDirectDebitAgreementErrorUnion = MandateNotFoundError | WithdrawalAccountAndKennitalaDoNotMatchError | WithdrawalAccountNotFoundError;

/** Input for updating a direct debit agreement */
export type UpdateDirectDebitAgreementInput = {
  /** ID (Global) of the direct debit mandate */
  id: Scalars['String']['input'];
  /** Withdrawal account ID (ISK: Skuldfærslureikningur) */
  withdrawalAccountId: Scalars['String']['input'];
  /** Withdrawal account owner kennitala (ISK: Kennitala skuldfærslureiknings) */
  withdrawalAccountOwnerKennitala: Scalars['String']['input'];
};

/** Payload with result of updating a direct debit agreement */
export type UpdateDirectDebitAgreementPayload = {
  __typename: 'UpdateDirectDebitAgreementPayload';
  /** The updated direct debit agreement */
  directDebitMandate: Maybe<DirectDebitMandate>;
  /** Error, if any occurred during the update of the direct debit agreement */
  error: Maybe<UpdateDirectDebitAgreementErrorUnion>;
  /** Was the update successful? */
  success: Scalars['Boolean']['output'];
};

export type UpdateDocumentPreferenceInput = {
  sendInMail: Scalars['Boolean']['input'];
  type: ReceiptType;
};

export type UpdateFavoriteAccountInput = {
  /** Global ID of the account to be marked as favorite */
  accountId: Scalars['ID']['input'];
};

/** List of accounts to be marked as favorite. Empty list will remove all favorites. */
export type UpdateFavoriteAccountsInput = {
  accounts: Array<UpdateFavoriteAccountInput>;
};

export type UpdateFavoriteAccountsPayload = {
  __typename: 'UpdateFavoriteAccountsPayload';
  /** List of accounts that were marked as favorite */
  accounts: Maybe<Array<Account>>;
};

/** Account global id and whether to show it in summary */
export type UpdateFinancialSummaryAccountInput = {
  accountId: Scalars['ID']['input'];
  showInSummary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Which accounts are shown/hidden in financial summary */
export type UpdateFinancialSummaryAccountsInput = {
  accounts: Array<UpdateFinancialSummaryAccountInput>;
};

/** Card global id and whether to show it in summary */
export type UpdateFinancialSummaryCardInput = {
  cardId: Scalars['ID']['input'];
  showInSummary?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Which cards are shown/hidden in financial summary */
export type UpdateFinancialSummaryCardsInput = {
  cards: Array<UpdateFinancialSummaryCardInput>;
};

/** Claim payer kennitala and whether to show it in summary */
export type UpdateFinancialSummaryClaimPayerInput = {
  kennitala: Scalars['String']['input'];
  showInSummary: Scalars['Boolean']['input'];
};

/** Which claim payers are shown/hidden in financial summary */
export type UpdateFinancialSummaryClaimPayersInput = {
  claimPayers: Array<UpdateFinancialSummaryClaimPayerInput>;
};

/** Which claim types are shown/hidden in financial summary */
export type UpdateFinancialSummaryClaimTypesInput = {
  includedClaimTypes: Array<ClaimSummaryType>;
};

export type UpdateFinancialSummaryOptionsInput = {
  currentAccountSummaryType?: InputMaybe<AccountSummaryType>;
  includedClaimTypes?: InputMaybe<Array<ClaimSummaryType>>;
  savingsAccountSummaryType?: InputMaybe<AccountSummaryType>;
};

export type UpdateFinancialSummaryOptionsPayload = {
  __typename: 'UpdateFinancialSummaryOptionsPayload';
  financialSummary: FinancialSummary;
};

export type UpdateGdprDataInput = {
  description: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  type: GdprUpdateType;
};

export type UpdateGdprDataPayload = {
  __typename: 'UpdateGdprDataPayload';
  id: Scalars['String']['output'];
};

/** Create or change income ratio of a given saving */
export type UpdateIncomeRatioInput = {
  /** Ratio (model) id. Not applicable when creating an income ratio, but must be defined when updating an income ratio */
  id?: InputMaybe<Scalars['String']['input']>;
  payors?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Must be between 1 and 100 when creating an income ratio, can be between 0 and 100 or not defined when updating an income ratio */
  ratio?: InputMaybe<Scalars['Int']['input']>;
  type: UpdateIncomeRatioMethod;
};

/** For mutating income ratio */
export enum UpdateIncomeRatioMethod {
  Create = 'Create',
  Update = 'Update'
}

export type UpdateIncomeRatioValidationError = Error & {
  __typename: 'UpdateIncomeRatioValidationError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpdateInvoiceErrorUnion = InvoiceDeleted | InvoiceForbiddenUpdateFinalDueDateError | InvoiceInvalidFirstDefaultChargeNumberOfDaysError | InvoiceNotFound | InvoicePartialPaymentNotAllowedError | InvoicePartialPaymentWithForeignCurrencyNotAllowedError | InvoiceUnavailableError | UnknownError;

export type UpdateInvoiceInput = {
  /** Date for when the claim is cancelled */
  cancellationDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** Unique payor identification for claimant, used for direct debit */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Description shown in the invoice overview */
  description: Scalars['String']['input'];
  /** The set final due date for the claim, after which additional fees may apply */
  finalDueDate: Scalars['DateTimeISO']['input'];
  /** Fee added if claim is unpaid after the due date */
  firstDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  /** How many days after the due date the firstDefaultCharge is applied */
  firstDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Date for an extended payment deadline before default charges apply */
  grantedPaymentDeadline?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id: Scalars['ID']['input'];
  /** Claims with a younger due date can be paid first */
  isOutOfSequencePaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can partial payments be made to the claim */
  isPartialPaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fee added for notifying payor, printed or electronic */
  notificationFee?: InputMaybe<Scalars['Float']['input']>;
  /** Amount to be collected, before additional fees and interests are applied */
  principalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** 7 letter reference */
  reference: Scalars['String']['input'];
  /** Fee added if claim is unpaid after the final due date */
  secondDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  /** How many days after the final due date the secondDefaultCharge is applied */
  secondDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Will a notification be sent if payment is late */
  sendLatePaymentNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Add default interest using the central bank rate if unpaid after the due date */
  useCentralBankRateDefaultInterest?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInvoicePayloadV2 = {
  __typename: 'UpdateInvoicePayloadV2';
  error: Maybe<UpdateInvoiceErrorUnion>;
  invoice: Maybe<Invoice>;
};

export type UpdateInvoiceTemplateErrorUnion = InvoiceTemplateAccountCannotBeUsedError | InvoiceTemplateAdditionalDepositingAccountIsRequiredForForeignCurrencyClaimsError | InvoiceTemplateDepositAccountCurrencyChangeIsRestrictedError | InvoiceTemplateMaximumIsExhaustedError | InvoiceTemplateNotFound | InvoiceTemplatePartialPaymentMayNotBeAllowedAlongWithPrincipalDeductionsError | InvoiceTemplatePartialPaymentNotAllowedWithDeductionAccountsError | InvoiceTemplatePartialPaymentNotAllowedWithForeignCurrencyError | InvoiceTemplatePercentageValueIsInvalidError | InvoiceTemplatePropertyMayNotBeSetError | InvoiceTemplateSecondaryCollectionGracePeriodDaysIsInvalidError | UnknownError;

export type UpdateInvoiceTemplateInput = {
  /** Secondary collection's collection company kennitala */
  collectionCompanyKennitala?: InputMaybe<Scalars['String']['input']>;
  /** Additional information for invoice template */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Number of days after which to send the second collection notification */
  daysUntilSecondaryCollectionWarning?: InputMaybe<Scalars['Int']['input']>;
  /** Rule to determine when to apply default charge */
  defaultChargeRule?: InputMaybe<CalculationRuleAfter>;
  /** Default interest rate */
  defaultInterestRate?: InputMaybe<Scalars['Float']['input']>;
  depositAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the invoice template. For example 'Félagsgjöld' */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Rule to determine when to apply discount */
  discountRule?: InputMaybe<CalculationRuleBefore>;
  dueDateRule?: InputMaybe<Scalars['Int']['input']>;
  /** Extended reference of the claimant */
  extendedReference?: InputMaybe<InvoiceTemplateExtendedReference>;
  finalDueDateRule?: InputMaybe<Scalars['Int']['input']>;
  firstDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  firstDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days to apply to the calculation rule to apply first discount */
  firstDiscountDays?: InputMaybe<Scalars['Int']['input']>;
  /** Value of the first discount (amount) */
  firstDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  /** Secondary collection's gracePeriodDays */
  gracePeriodDays?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isOutOfSequencePaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isPartialPaymentAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is default charge set in percentages */
  isPercentageDefaultCharge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is discount set to be applied in percentage */
  isPercentageDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  monthsUntilCancellation?: InputMaybe<Scalars['Int']['input']>;
  notificationFee?: InputMaybe<Scalars['Float']['input']>;
  /** Other costs related to the claim */
  otherCost?: InputMaybe<Scalars['Float']['input']>;
  /** Other default cost (annar vanskilakostnaður) */
  otherDefaultCost?: InputMaybe<Scalars['Float']['input']>;
  /** Comment to print in the mail */
  printedComment?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the claimant */
  printingClaimantName?: InputMaybe<Scalars['String']['input']>;
  /** Determines the way we handle the mail */
  printingHandlingOption?: InputMaybe<Scalars['Int']['input']>;
  /** Postal code for the address */
  printingPostalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address to mail to */
  printingStreetAddress?: InputMaybe<Scalars['String']['input']>;
  /** Whether to use registered address */
  printingUseRegisteredAddress?: InputMaybe<Scalars['Boolean']['input']>;
  secondDefaultCharge?: InputMaybe<Scalars['Float']['input']>;
  secondDefaultDays?: InputMaybe<Scalars['Int']['input']>;
  /** Number of days to apply to the calculation rule to apply second discount */
  secondDiscountDays?: InputMaybe<Scalars['Int']['input']>;
  /** Value of the second discount (amount) */
  secondDiscountValue?: InputMaybe<Scalars['Float']['input']>;
  sendLatePaymentNotification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to send notification about secondary collection */
  sendSecondaryCollectionWarning?: InputMaybe<Scalars['Boolean']['input']>;
  /** Short reference of the claimant */
  shortReference?: InputMaybe<InvoiceTemplateShortReference>;
  useCentralBankRateDefaultInterest?: InputMaybe<Scalars['Boolean']['input']>;
  withdrawalAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInvoiceTemplatePayloadV2 = {
  __typename: 'UpdateInvoiceTemplatePayloadV2';
  error: Maybe<UpdateInvoiceTemplateErrorUnion>;
  template: Maybe<InvoiceTemplate>;
};

/** Possible business errors when updating loan alias */
export type UpdateLoanAliasErrorUnion = LoanAccessForbiddenError;

/** Input for updating loan alias */
export type UpdateLoanAliasInput = {
  /** The new alias for the loan. null input will clear the alias */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** The (global) ID of the loan to update */
  id: Scalars['ID']['input'];
};

/** Payload with results for an update alias operation */
export type UpdateLoanAliasPayload = {
  __typename: 'UpdateLoanAliasPayload';
  /** Specific business error that occurred */
  error: Maybe<UpdateLoanAliasErrorUnion>;
  /** The loan after updating the alias. Will return null if unsuccessful */
  loan: Maybe<Loan>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type UpdateLoanApplicantInput = {
  /** Id of an applicant (from the list of applicants, found under a loan application) */
  applicantId: Scalars['String']['input'];
  /** Email of an applicant */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of an applicant */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLoanApplicationBondResponse = LoanApplicationDoesNotExistError | UpdateRealEstateLoanApplicationBondsPayload;

export type UpdateLoanApplicationInput = {
  /** Purchase amount usually defined with valuationBy property: amount: 60000000 and valuationBy: PURCHASE_OFFER */
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  marketValue?: InputMaybe<Scalars['Int']['input']>;
  realEstateId?: InputMaybe<Scalars['String']['input']>;
  realEstateRef?: InputMaybe<Scalars['String']['input']>;
  /** Specific type of loan that requires specific handling (Hlutdeildarlán) */
  requestHlutdeildarLoan?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<LoanApplicationStatus>;
  /** Types of valuation constants, e.g. PURCHASE_OFFER by the amount of 60000000 */
  valuationBy?: InputMaybe<LoanApplicationValuationConstants>;
};

export type UpdateLoanApplicationPartyInput = {
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
  /** Update data */
  loanApplicationParty: LoanApplicationPartyInput;
  /** (Global) ID of the party that will be updated */
  partyId: Scalars['ID']['input'];
};

/** Payload for updating loan application party */
export type UpdateLoanApplicationPartyPayload = {
  __typename: 'UpdateLoanApplicationPartyPayload';
  error: Maybe<LoanApplicationDoesNotExistError>;
  /** The ID of the updated loan application */
  loanApplicationId: Maybe<Scalars['String']['output']>;
  /** The ID of the updated party */
  partyId: Maybe<Scalars['String']['output']>;
};

/** New loan alias */
export type UpdateLoanInput = {
  alias: Scalars['String']['input'];
  /** The loan's ID */
  id: Scalars['String']['input'];
};

export type UpdateLoanPayload = {
  __typename: 'UpdateLoanPayload';
  loan: Loan;
};

export type UpdateLoanPeriodOfVehicleLoanApplicationInput = {
  /** ID of bond (found under a loan request) */
  bondId: Scalars['ID']['input'];
  /** ID of the loan application */
  id: Scalars['ID']['input'];
  /** New value for the loanPeriod */
  loanPeriod: Scalars['Int']['input'];
  /** ID of the loan request (found under a loan application) */
  loanRequestId: Scalars['ID']['input'];
};

export type UpdateLoanResponse = LoanNotFoundError | UpdateLoanPayload;

export type UpdateMarketSubscriptionInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  subscriptionId: Scalars['String']['input'];
};

export type UpdateMarketSubscriptionPaylaod = {
  __typename: 'UpdateMarketSubscriptionPaylaod';
  subscription: MarketSubscription;
};

export type UpdateMarketSubscriptionResult = MaximumMarketSubscriptionAmountError | MinimumMarketSubscriptionAmountError | UpdateMarketSubscriptionPaylaod;

/** Payload for updating notification settings for markets */
export type UpdateMarketsNotificationsInput = {
  /** Flag indicating whether push notification setting in Markets is enabled */
  isEnabled: Scalars['Boolean']['input'];
  /** ID of the notification setting */
  settingId: Scalars['ID']['input'];
};

export type UpdateNotificationBannerErrorUnion = NotificationMessageNotFound;

/** Input for updating the service representative of a company onboarding application */
export type UpdateOnboardingCompanyServiceRepresentativeInput = {
  /** Onboarding application ID (Global) */
  applicationId: Scalars['ID']['input'];
  /** The national ID (kennitala) of the service representative */
  serviceRepresentativeKennitala: Scalars['String']['input'];
};

export type UpdateOnboardingCompanyServiceRepresentativePayload = {
  __typename: 'UpdateOnboardingCompanyServiceRepresentativePayload';
  /** Error details if the update failed */
  error: Maybe<UpdateOnboardingCompanyServiceRepresentativePayloadErrorUnion>;
  /** The saved service representative if the update succeeded */
  serviceRepresentative: Maybe<OnboardingCompanyCustomer>;
  /** Indicates whether the service representative was successfully saved */
  success: Scalars['Boolean']['output'];
};

export type UpdateOnboardingCompanyServiceRepresentativePayloadErrorUnion = OnboardingApplicationNotFound | UnauthorizedContact | UnknownError;

export type UpdateOverdraftLoanApplicationInput = {
  accountNumber: Scalars['String']['input'];
  /** The exact end date for the overdraft, as opposed to the month-based overdraft duration object. */
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  loanApplicationId: Scalars['String']['input'];
  /** only nullable meanwhile duration exist */
  overdraftDuration?: InputMaybe<OverdraftDuration>;
  requestedAmount: Scalars['Float']['input'];
};

export type UpdateOverdraftLoanApplicationPayload = {
  __typename: 'UpdateOverdraftLoanApplicationPayload';
  overdraftLoanApplication: OverdraftLoanApplication;
};

export type UpdateOverdraftToBondLoanApplicationInput = {
  /** Reikningur sem á að greiða lánið inná. Yfirdráttur þessa reiknings verður færður niður sem nemur upphæð lánsins. */
  accountNumber: Scalars['String']['input'];
  /** Upphæð láns */
  amount: Scalars['Float']['input'];
  /** Skuldfærslureikningur. */
  directDebitAccountNumber: Scalars['String']['input'];
  loanApplicationId: Scalars['String']['input'];
  /** Lánstími í mánuðum. Möguleg gildi sótt úr product catalog. */
  loanDurationMonths: Scalars['Int']['input'];
};

export type UpdateOverdraftToBondLoanApplicationPayload = {
  __typename: 'UpdateOverdraftToBondLoanApplicationPayload';
  application: OverdraftToBondLoanApplication;
};

export type UpdatePaymentApprovalInput = {
  processId: Scalars['String']['input'];
};

export type UpdatePaymentRecipientEmailNotificationsErrorUnion = PaymentRecipientNotFound | UnknownError;

export type UpdatePaymentRecipientEmailNotificationsInput = {
  /** Should recipient automatically receive email notifications for payments. */
  automaticEmailNotifications: Scalars['Boolean']['input'];
  /** List of email addresses that will receive notifications for payments to this recipient. */
  emailAddresses: Array<Scalars['String']['input']>;
  /** GraphQL ID of a payment recipient */
  id: Scalars['ID']['input'];
};

/** Recipient automatic email notifications settings update payload */
export type UpdatePaymentRecipientEmailNotificationsPayload = {
  __typename: 'UpdatePaymentRecipientEmailNotificationsPayload';
  error: Maybe<UpdatePaymentRecipientEmailNotificationsErrorUnion>;
  recipient: Maybe<PaymentRecipient>;
};

export type UpdatePaymentRecipientInput = {
  /** Account identifier of the recipient e.g. IBAN, BBAN, Card number */
  accountIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Marks or unmarks the recipient as a favorite recipient. */
  address?: InputMaybe<InternationalPaymentAddressInput>;
  /** Marks or unmarks the recipient as a favorite recipient. */
  bankInfo?: InputMaybe<PaymentRecipientBankInfoInput>;
  /** A friendly name or description of the recipient. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** GraphQL ID of a payment recipient */
  id: Scalars['ID']['input'];
  /** Marks or unmarks the recipient as a favorite recipient. */
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Recipients name */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentRecipientResponse = PaymentRecipient | PaymentRecipientNotFound;

export type UpdateProductTypeOfVehicleLoanApplicationInput = {
  /** ID of the loan application */
  id: Scalars['ID']['input'];
  /** ID of the loan request (found under a loan application) */
  loanRequestId: Scalars['ID']['input'];
  /** New value for the ProductCatalogId */
  productCatalogId: VehicleLoanRequestProductCatalogId;
};

export type UpdatePushNotificationsInput = {
  /** Notification settings for bank accounts to be updated */
  accounts?: InputMaybe<UpdateAccountsNotificationsInput>;
  claims?: InputMaybe<UpdateClaimsNotificationsInput>;
  /** Notification settings for markets to be updated */
  markets?: InputMaybe<UpdateMarketsNotificationsInput>;
  savings?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRealEstateLoanApplicationBondInput = {
  /** Object with data to update */
  bond: RealEstateLoanApplicationBondInput;
  /** (Global) ID of loan application bond */
  bondId: Scalars['ID']['input'];
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
  /** (Global) ID of the loan request where the bond resides in */
  loanRequestId: Scalars['ID']['input'];
};

export type UpdateRealEstateLoanApplicationBondsPayload = {
  __typename: 'UpdateRealEstateLoanApplicationBondsPayload';
  loanApplication: RealEstateLoanApplication;
};

export type UpdateRealEstateLoanApplicationLoanRequestsInput = {
  directDebitAccountNumber?: InputMaybe<Scalars['String']['input']>;
  /** (Global) ID of a loan application */
  loanApplicationId: Scalars['ID']['input'];
};

export type UpdateRealEstateLoanApplicationLoanRequestsPayload = {
  __typename: 'UpdateRealEstateLoanApplicationLoanRequestsPayload';
  loanApplication: RealEstateLoanApplication;
};

export type UpdateRealEstateLoanApplicationLoanRequestsResponse = LoanApplicationDoesNotExistError | UpdateRealEstateLoanApplicationLoanRequestsPayload;

export type UpdateRealEstateLoanApplicationPayload = {
  __typename: 'UpdateRealEstateLoanApplicationPayload';
  loanApplication: RealEstateLoanApplication;
};

export type UpdateRealEstateLoanApplicationResponse = RealEstateDoesNotExistError | UpdateRealEstateLoanApplicationPayload;

export type UpdateRegularSavingInput = {
  id: Scalars['ID']['input'];
  updateInfo: RegularSavingUpdateInfoInput;
};

export type UpdateRegularSavingResponse = RegularSavingCreditorAndDebtorAccountsCannotBeTheSame | RegularSavingDepositNotAllowed | RegularSavingFrequencyTypeNotSupported | RegularSavingInvalidAccount | RegularSavingInvalidDayOfExecution | RegularSavingInvalidInstructedAmount | RegularSavingInvalidPaymentType | RegularSavingInvalidSecurityCode | RegularSavingInvalidValidity | RegularSavingNotFound | RegularSavingPayload | RegularSavingPlanAlreadyCreated | RegularSavingSavingsAccountNotFound | RegularSavingStartDateInvalid | RegularSavingUnexpectedError | RegularSavingWithdrawalDepositAccountCurrencyMismatch;

export type UpdateSavingGoalInput = {
  cardSaving?: InputMaybe<UpdateCardSavingInput>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  endGoalDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  goalAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Graphql node id */
  id: Scalars['String']['input'];
  incomeRatio?: InputMaybe<UpdateIncomeRatioInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavingGoalPayload = {
  __typename: 'UpdateSavingGoalPayload';
  savingGoal: SavingGoal;
};

export type UpdateSavingGoalResponse = CardSavingNotFound | UpdateCardSavingValidationError | UpdateIncomeRatioValidationError | UpdateSavingGoalPayload;

export type UpdateSecurityQuestionInput = {
  id: Scalars['ID']['input'];
  userAnswer: Scalars['String']['input'];
};

export type UpdateSecurityQuestionsInput = {
  questions: Array<UpdateSecurityQuestionInput>;
};

/** A single service permission update */
export type UpdateServiceAuthorizationInput = {
  /** Access level for the service */
  access: ServiceAccessLevel;
  /** Service type ID */
  serviceTypeId: Scalars['Int']['input'];
  /** Company user username */
  username: Scalars['String']['input'];
};

/** Input for batch updating service authorizations */
export type UpdateServicesAuthorizationInput = {
  /** Overall update to apply (optional) */
  overallUpdate?: InputMaybe<OverallServiceUpdateInput>;
  /** Individual permission updates to apply */
  updates: Array<UpdateServiceAuthorizationInput>;
};

/** Payload for batch updating service authorizations */
export type UpdateServicesAuthorizationPayload = {
  __typename: 'UpdateServicesAuthorizationPayload';
  /** Number of failed updates */
  failedUpdates: Scalars['Int']['output'];
  /** Overall status of the bulk update */
  status: BulkUpdateStatus;
  /** Number of successful updates */
  successfulUpdates: Scalars['Int']['output'];
  /** Total number of permission updates attempted */
  totalUpdates: Scalars['Int']['output'];
  /** List of unsuccessful updates with error details (null when all succeeded) */
  unsuccessfulUpdates: Maybe<Array<ServicePermissionUpdateFailure>>;
};

export type UpdateUserError = {
  __typename: 'UpdateUserError';
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UpdateUserPayload = {
  __typename: 'UpdateUserPayload';
  error: Maybe<UpdateUserError>;
  success: Scalars['Boolean']['output'];
  user: Maybe<CompanyUser>;
};

export type UpdateUserSecurityQuestionsPayload = {
  __typename: 'UpdateUserSecurityQuestionsPayload';
  questions: Array<SecurityQuestion>;
};

export type UpdateUserSecurityQuestionsResult = RsaStepUpResponse | UpdateUserSecurityQuestionsPayload;

export type UpdateUserStatusInput = {
  /** Shows if user is active or not */
  enabled: Scalars['Boolean']['input'];
  /** Username of the user who is being updated */
  username: Scalars['String']['input'];
};

export type UpdateUserWithdrawalLimitInput = {
  /** Username of the user who is being updated */
  username: Scalars['String']['input'];
  /** Withdrawal limit of the user */
  withdrawalLimit: CurrencyAmountInput;
};

export type UpdateVehicleLoanApplicationPayload = {
  __typename: 'UpdateVehicleLoanApplicationPayload';
  loanApplication: VehicleLoanApplication;
};

export type UpdateVehicleLoanApplicationResponse = LoanApplicationDoesNotExistError | UpdateVehicleLoanApplicationPayload;

export type UploadAvatarImageErrorUnion = AdultContentDetectedError | FaceQualityTooLowError | HateContentDetectedError | ImageSizeNotCorrectError | MultipleFacesDetectedError | NoFaceDetectedError | SelfHarmDetectedError | UnknownError | ViolenceDetectedError;

/** Input to upload an avatar for the current user */
export type UploadAvatarImageInput = {
  /** The avatar file to be uploaded */
  file: Scalars['Upload']['input'];
};

/** Payload returned when uploading a user avatar */
export type UploadAvatarImagePayload = {
  __typename: 'UploadAvatarImagePayload';
  /** Error returned when uploading a user avatar fails */
  error: Maybe<UploadAvatarImageErrorUnion>;
  /** Whether the avatar upload was successful or not */
  success: Scalars['Boolean']['output'];
};

export type UploadDirectDebitMandateOrdersFileErrorUnion = ExcelColumnsMustContainDataError | ExcelHeaderInvalidError | InvalidFileExtensionError | MandatesCustomerNumberAlwaysTheSameError | TooManyExcelColumnsError;

export type UploadExternalVehicleLoanApplicationPurchaseContractInput = {
  /** Kennitala of the dealership which is used for all external vehicle sources */
  dealershipKennitala: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
  loanApplicationId: Scalars['String']['input'];
};

export type UploadExternalVehicleLoanApplicationPurchaseContractPayload = {
  __typename: 'UploadExternalVehicleLoanApplicationPurchaseContractPayload';
  /** Shows whether the file was successfully uploaded */
  success: Scalars['Boolean']['output'];
};

export type UploadFormTemplateAttachmentInput = {
  /** The file to upload as a form attachment */
  file: Scalars['Upload']['input'];
};

export type UploadKycDocumentsInput = {
  /** Files to upload for the KYC */
  files: Array<Scalars['Upload']['input']>;
  /** Kennitala of the company the KYC is for, for users that are not acting for that company (e.g. national token users) */
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
};

/** Payload returned after uploading documents to a KYC */
export type UploadKycDocumentsPayload = {
  __typename: 'UploadKycDocumentsPayload';
  success: Scalars['Boolean']['output'];
};

export type UploadLoanApplicationDocumentPayload = {
  __typename: 'UploadLoanApplicationDocumentPayload';
  success: Scalars['Boolean']['output'];
};

export type UploadLoanApplicationDocumentsInput = {
  /** Document content type */
  documentTypeId: LoanApplicationDocumentTypeId;
  files: Array<Scalars['Upload']['input']>;
  /** (Global) ID of the loan application */
  loanApplicationId: Scalars['ID']['input'];
};

/** Input to create a payment batch from a file */
export type UploadPaymentBatchFileInput = {
  /** A file containing the payment batch data */
  file: Scalars['Upload']['input'];
};

/** Input to upload a payslip file */
export type UploadPayslipFileInput = {
  /** A file containing the payslip data */
  file: Scalars['Upload']['input'];
  /** Payslip sender kennitala */
  senderKennitala?: InputMaybe<Scalars['String']['input']>;
};

export type UploadPayslipFilePayload = {
  __typename: 'UploadPayslipFilePayload';
  success: Scalars['Boolean']['output'];
};

/** Represents a user available to the currently logged in customer */
export type User = Actor & {
  __typename: 'User';
  /** The online bank account can be accessed by the customer */
  enabled: Scalars['Boolean']['output'];
  /** A one-way hashed version of the kennitala (Icelandic national ID) that uniquely identifies the current user in a privacy friendly way. Returns null for users who are not logged in. */
  hashedKennitala: Maybe<Scalars['String']['output']>;
  /** A one-way hashed version of the username that uniquely identifies the current user in a privacy friendly way. Returns null for users who are not logged in. */
  hashedUsername: Maybe<Scalars['String']['output']>;
  /** ID (Global) of the user */
  id: Scalars['ID']['output'];
  /** Kennitala of current user */
  kennitala: Scalars['String']['output'];
  /** Name of current user */
  name: Scalars['String']['output'];
  /**
   * Does current user need new password?
   * @deprecated Reason: new API no longer returns this value. Always returns false. Since: 2026-04-09. Issue(s) to remove it: WEB-41915
   */
  needsNewPassword: Maybe<Scalars['Boolean']['output']>;
  /**
   * Does current user token need activation?
   * @deprecated Reason: new API no longer returns this value. Always returns false. Since: 2026-04-09. Issue(s) to remove it: WEB-41915
   */
  needsTokenActivation: Maybe<Scalars['Boolean']['output']>;
  /** Status of current user */
  state: CustomerStatus;
  /** Type of current user (i.e. corporate, personal) */
  type: UserType;
  /** Landsbankinn username of current user */
  username: Scalars['String']['output'];
};

export type UserAccessAuthorization = {
  __typename: 'UserAccessAuthorization';
  /** If user can view */
  canView: Scalars['Boolean']['output'];
  /** ID (Global) of the authorization object */
  id: Scalars['ID']['output'];
  /** Kennitala */
  kennitala: Scalars['String']['output'];
  /** User full name */
  name: Scalars['String']['output'];
  /** User name */
  username: Scalars['String']['output'];
};

export type UserAccessAuthorizationConnection = {
  __typename: 'UserAccessAuthorizationConnection';
  /** Overall access level for the users. Will have a value if all users have the same access level in the connection. Note that UsersAuthorizationFilterArgs.withAccessOnly affect the value of this field. */
  allAuthorizationAccessLevel: Maybe<AuthorizationAccessLevel>;
  edges: Array<UserAccessAuthorizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAccessAuthorizationEdge = {
  __typename: 'UserAccessAuthorizationEdge';
  cursor: Scalars['String']['output'];
  node: UserAccessAuthorization;
};

/** user connection to get paged data */
export type UserConnection = {
  __typename: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserDoesNotHaveAccessToTheDebtorAccountError = Error & {
  __typename: 'UserDoesNotHaveAccessToTheDebtorAccountError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UserDoesNotHavePermissionToTogglePermissionError = Error & {
  __typename: 'UserDoesNotHavePermissionToTogglePermissionError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UserEdge = {
  __typename: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserExistsError = Error & {
  __typename: 'UserExistsError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UserFilterArgs = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<UserType>;
};

export type UserIsNotAllowedToSeePrivateInfo = Error & {
  __typename: 'UserIsNotAllowedToSeePrivateInfo';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UserRoleAuthorizationFilter = {
  /** Field to filter roles by */
  roleTypes?: InputMaybe<Array<AuthorizationRoleType>>;
};

/** Users can create form requests that don't require their signature, this indicates whether a user is a signer on a form request or not */
export enum UserSignerStatus {
  NOT_SIGNER = 'NOT_SIGNER',
  SIGNER = 'SIGNER',
  UNKNOWN = 'UNKNOWN'
}

/** The type of user either personal or corporate */
export enum UserType {
  Corporate = 'Corporate',
  Personal = 'Personal',
  Unknown = 'Unknown'
}

export type UsersAuthorizationFilter = {
  /** Search by username, national ID and name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter to only show users with access */
  withAccessOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UsersAuthorizationOrderBy = {
  /** Direction to order users by */
  direction?: InputMaybe<OrderByDirection>;
  /** Field to order users by */
  field: AccountUsersAuthorizationOrderByOptions;
};

/** The deserialization failed in a line in a IKT40 file. */
export type ValidateCreateInvoiceBatchDeserializationFailureError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchDeserializationFailureError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** The document has been submitted before */
export type ValidateCreateInvoiceBatchDuplicateDocumentError = Error & {
  __typename: 'ValidateCreateInvoiceBatchDuplicateDocumentError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The document is empty. */
export type ValidateCreateInvoiceBatchEmptyBatchDocumentError = Error & {
  __typename: 'ValidateCreateInvoiceBatchEmptyBatchDocumentError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ValidateCreateInvoiceBatchError = UnknownError | UnknownFileValidationError | ValidateCreateInvoiceBatchDeserializationFailureError | ValidateCreateInvoiceBatchDuplicateDocumentError | ValidateCreateInvoiceBatchEmptyBatchDocumentError | ValidateCreateInvoiceBatchInvalidBranchOfCreditorsBankError | ValidateCreateInvoiceBatchInvalidCustomerNumberFormatError | ValidateCreateInvoiceBatchInvalidExcelBatchDocumentError | ValidateCreateInvoiceBatchInvalidExcelWorkbookError | ValidateCreateInvoiceBatchInvalidFileExtensionError | ValidateCreateInvoiceBatchInvalidFinalDueDateError | ValidateCreateInvoiceBatchInvalidKennitalaError | ValidateCreateInvoiceBatchInvalidReferenceFormatError | ValidateCreateInvoiceBatchInvalidValueError | ValidateCreateInvoiceBatchMissingRequiredValueError;

export type ValidateCreateInvoiceBatchFromExcelInput = {
  /** An excel file with either .xls or .xlsx extension, could also be a IKT40 file. */
  excelFile: Scalars['Upload']['input'];
};

export type ValidateCreateInvoiceBatchFromExcelPayload = {
  __typename: 'ValidateCreateInvoiceBatchFromExcelPayload';
  errors: Array<ValidateCreateInvoiceBatchError>;
  valid: Scalars['Boolean']['output'];
};

/** The branch of creditors bank is not a Landsbankinn branch. */
export type ValidateCreateInvoiceBatchInvalidBranchOfCreditorsBankError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidBranchOfCreditorsBankError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** The customer number format is invalid. */
export type ValidateCreateInvoiceBatchInvalidCustomerNumberFormatError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidCustomerNumberFormatError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** The file does not have the right format. */
export type ValidateCreateInvoiceBatchInvalidExcelBatchDocumentError = Error & {
  __typename: 'ValidateCreateInvoiceBatchInvalidExcelBatchDocumentError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The file is not a valid Excel workbook. */
export type ValidateCreateInvoiceBatchInvalidExcelWorkbookError = Error & {
  __typename: 'ValidateCreateInvoiceBatchInvalidExcelWorkbookError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The file extension is not .xls, .xlsx or .txt. */
export type ValidateCreateInvoiceBatchInvalidFileExtensionError = Error & {
  __typename: 'ValidateCreateInvoiceBatchInvalidFileExtensionError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The final due date is invalid, most likely before dueDate. */
export type ValidateCreateInvoiceBatchInvalidFinalDueDateError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidFinalDueDateError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** The kennitala is invalid. */
export type ValidateCreateInvoiceBatchInvalidKennitalaError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidKennitalaError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** The reference format is invalid, most likely not 16. */
export type ValidateCreateInvoiceBatchInvalidReferenceFormatError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidReferenceFormatError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** Some value is invalid. */
export type ValidateCreateInvoiceBatchInvalidValueError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchInvalidValueError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

/** Some required value is missing. */
export type ValidateCreateInvoiceBatchMissingRequiredValueError = Error & FileValidationError & {
  __typename: 'ValidateCreateInvoiceBatchMissingRequiredValueError';
  columnName: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Maybe<Scalars['Int']['output']>;
};

export type ValidateEmployeesInPayrollFromExcelInput = {
  excelFile: Scalars['Upload']['input'];
  /** ID (Global) of the payroll where the employees will be validated against */
  payrollId: Scalars['ID']['input'];
};

/** Payload for validating employees in excel document */
export type ValidateEmployeesInPayrollFromExcelPayload = {
  __typename: 'ValidateEmployeesInPayrollFromExcelPayload';
  /** Error object in cases where success is false */
  error: Maybe<EmployeeExcelCreationError>;
  /** Indicates success of validation */
  success: Scalars['Boolean']['output'];
};

export enum VehicleEmissionType {
  Electric = 'Electric',
  Gas = 'Gas',
  Hybrid = 'Hybrid'
}

/** Detail information for vehicle insurance */
export type VehicleInsurancePolicyPreview = {
  __typename: 'VehicleInsurancePolicyPreview';
  documents: Array<InsurancePolicyDocumentMeta>;
  /** The kasko insurance amount */
  kaskoAmount: Maybe<CurrencyAmount>;
  /** The kasko self risk amount */
  kaskoSelfRiskAmount: Maybe<CurrencyAmount>;
  licenceNumber: Maybe<Scalars['String']['output']>;
  vehicle: Scalars['String']['output'];
};

/** Application for a vehicle loan */
export type VehicleLoanApplication = LoanApplication & Node & {
  __typename: 'VehicleLoanApplication';
  amount: Scalars['Float']['output'];
  applicants: Array<LoanApplicant>;
  averageMonthlyPayment: Scalars['Float']['output'];
  branch: Scalars['String']['output'];
  /** Contains the product name and type of the first collateral request associated with the loan application */
  collateralRequest: Maybe<LoanApplicationCollateralRequest>;
  /** Commission assigned to the ongoing vehicleLoanApplication  */
  commission: Maybe<Commission>;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['DateTimeISO']['output'];
  creditAssessment: Maybe<CreditAssessment>;
  /** This field contains details about the fees which we might charge the customer with. */
  creditAssessmentNextFees: Maybe<CreditAssessmentNextFees>;
  customerAskedForHlutdeildarLan: Maybe<Scalars['Boolean']['output']>;
  document: LoanApplicationDocument;
  documents: Array<LoanApplicationDocument>;
  firstMonthlyPayment: Scalars['Float']['output'];
  /** Displays if there is a valid vehicle credit assessment (bílamat) that can be used for this loan application. This applies only for individual applications. For corporate applications, the field is false */
  hasValidVehicleCreditAssessment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Image (as a document bucket) representing the vehicle that acts as a mortgage for a loan application. */
  image: Maybe<DocumentBucket>;
  /** Indicates if the automatic approval process for the application can still be successful. If this is false, then the application cannot be automatically approved. */
  isAutomaticProcessOngoing: Scalars['Boolean']['output'];
  isSigned: Scalars['Boolean']['output'];
  loanFee: Scalars['Float']['output'];
  /** Type representing the product catalog id of the loan request for this vehicle loan application */
  loanRequestType: VehicleLoanRequestProductCatalogId;
  loanRequests: Array<LoanRequest>;
  loanRequestsMissingLoanCostFee: Scalars['Boolean']['output'];
  modifiedBy: Scalars['String']['output'];
  modifiedDate: Scalars['DateTimeISO']['output'];
  mortgages: Array<VehicleMortgage>;
  /** The amount paid out to the customer */
  paidOutAmount: CurrencyAmount;
  parties: Array<LoanApplicationParty>;
  paymentInstructions: Array<LoanApplicationPaymentInstruction>;
  /** Details regarding the loan product, which is tied to this (vehicle) loan application */
  product: Maybe<LoanProduct>;
  signatureGroups: Maybe<Array<LoanApplicationSignatureGroup>>;
  signatures: Maybe<Array<LoanApplicationSignature>>;
  status: LoanApplicationStatus;
  totalFees: Scalars['Float']['output'];
  /** List of trade-in vehicles, used in a (vehicle) loan application. This is empty if there are no trade-in vehicles */
  tradeInVehicles: Array<TradeInVehicle>;
  type: LoanApplicationType;
  validations: Array<LoanValidation>;
  yearlyCostRatio: Maybe<Scalars['Float']['output']>;
  yearlyCostRatioIsToHigh: Scalars['Boolean']['output'];
};


/** Application for a vehicle loan */
export type VehicleLoanApplicationDocumentArgs = {
  documentTypeId: Scalars['Float']['input'];
  loanRequestId?: InputMaybe<Scalars['Float']['input']>;
};

/** Type of vehicle loan applicant */
export enum VehicleLoanApplicationApplicantType {
  /** Company representative */
  COMPANY_REPRESENTATIVE = 'COMPANY_REPRESENTATIVE',
  /** Co-applicant */
  CO_APPLICANT = 'CO_APPLICANT',
  /** Main applicant */
  MAIN_APPLICANT = 'MAIN_APPLICANT',
  /** Unknown type of applicant */
  UNKNOWN = 'UNKNOWN'
}

export type VehicleLoanApplicationDecision = {
  __typename: 'VehicleLoanApplicationDecision';
  /** This field shows whether a vehicle loan application was automatically approved or not */
  isAutomaticallyApproved: Scalars['Boolean']['output'];
};

/** Type of payment instruction */
export enum VehicleLoanApplicationPaymentInstructionType {
  /** Money transferred to an account */
  ACCOUNT = 'ACCOUNT',
  /** Internal payments within Landsbankinn */
  INTERNAL = 'INTERNAL',
  /** Money used to pay off a loan */
  LOAN = 'LOAN',
  /** Where the remainder of paid out money goes */
  REMAINDER = 'REMAINDER',
  /** Unknown type of payment instruction */
  UNKNOWN = 'UNKNOWN'
}

/** Status of vehicle loan application mapped from LoanApplicationStatus */
export enum VehicleLoanApplicationStatus {
  /** All signatures have been completed and we are waiting for car ownership change before electronic registration */
  ALL_SIGNATURES_COMPLETED = 'ALL_SIGNATURES_COMPLETED',
  /** Application has been approved and needs staff member to send it to the next step */
  APPROVED = 'APPROVED',
  /** Application has been cancelled */
  CANCELLED = 'CANCELLED',
  /** Application has been declined */
  DECLINED = 'DECLINED',
  /** Application is ready for electronic registration */
  ELECTRONIC_REGISTRATION_READY = 'ELECTRONIC_REGISTRATION_READY',
  /** Application is in progress by customer or internal staff member (before being sent to approval) */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Application has been paid out */
  PAID_OUT = 'PAID_OUT',
  /** Application is ready for payout */
  READY_FOR_PAYOUT = 'READY_FOR_PAYOUT',
  /** Unknown status of application */
  UNKNOWN = 'UNKNOWN',
  /** Application is waiting for customer */
  WAITING_FOR_CUSTOMER = 'WAITING_FOR_CUSTOMER'
}

/** The type of VehicleLoanApplication with relation to the user */
export enum VehicleLoanApplicationType {
  /** Vehicle loan application of individual users */
  CORPORATE_APPLICATION = 'CORPORATE_APPLICATION',
  /** Vehicle loan application of corporate users */
  INDIVIDUAL_APPLICATION = 'INDIVIDUAL_APPLICATION'
}

/** The product catalog Id of the loan request (of a vehicle loan application) */
export enum VehicleLoanRequestProductCatalogId {
  /** Bílasamningur fyrirtækja | The loan provider is the owner of the vehicle until the mortgage is paid out */
  VEHICLE_AGREEMENT_CORPORATE = 'VEHICLE_AGREEMENT_CORPORATE',
  /** Bílalán fyrirtækja | The loan taker is the owner of the vehicle */
  VEHICLE_LOAN_CORPORATE = 'VEHICLE_LOAN_CORPORATE',
  /** Bílalán (einstaklingar) | Loan of the type Bílalán, and the only type allowed for individuals */
  VEHICLE_LOAN_INDIVIDUAL = 'VEHICLE_LOAN_INDIVIDUAL'
}

/** Type of vehicle loan */
export enum VehicleLoanType {
  /** Corporate leasing for companies (Bílasamningur) */
  CORPORATE_LEASING = 'CORPORATE_LEASING',
  /** Corporate loan for companies */
  CORPORATE_LOAN = 'CORPORATE_LOAN',
  /** Individual loans for individuals */
  INDIVIDUAL_LOAN = 'INDIVIDUAL_LOAN',
  /** Unknown type of loan */
  UNKNOWN = 'UNKNOWN'
}

/** Veð í bílaláni */
export type VehicleMortgage = {
  __typename: 'VehicleMortgage';
  /** Kaupverð */
  amount: Scalars['Float']['output'];
  amountWithoutVat: Maybe<Scalars['Int']['output']>;
  /** Innborgun */
  depositAmount: Scalars['Int']['output'];
  engine: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isVatVehicle: Scalars['Boolean']['output'];
  odometer: Scalars['Int']['output'];
  /** Loan Amount that the user applies for, without any added costs */
  paidLoanAmount: Scalars['Float']['output'];
  /** Permanent registration number that are bound to the vehicle */
  permanentNumber: Maybe<Scalars['String']['output']>;
  /** Current registration on vehicle (can be changed and could be a "einkanúmer") */
  registrationNumber: Maybe<Scalars['String']['output']>;
  subType: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  vehicleGroup: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

export type VerificationCodeInput = {
  code: Scalars['String']['input'];
  /** Verification code (model) id */
  id: Scalars['String']['input'];
};

export type VerificationEmailPayload = VerificationPayload & {
  __typename: 'VerificationEmailPayload';
  /** @deprecated Reason: All fields within "VerificationEmailPayload" are redundant, therefore "VerificationPayload" should be declared as a possible return type instead inside "StartVerificationEmailResult" and "VerificationEmailResult" unions. Since: 2023-09-28. Removed: 2024-03-28. Issue(s) to remove it: WEB-18431. */
  emailAddress: Scalars['String']['output'];
  /** Id of verification process */
  id: Scalars['String']['output'];
  status: ContactVerificationStatus;
  /** Present in payload for client cache, for fluid update of new/changed phone number or email after process has completed */
  viewer: Viewer;
};

export type VerificationEmailResult = VerificationEmailPayload | WrongVerificationCode;

export type VerificationPayload = {
  /** Id of verification process */
  id: Scalars['String']['output'];
  status: ContactVerificationStatus;
  /** Present in payload for client cache, for fluid update of new/changed phone number or email after process has completed */
  viewer: Viewer;
};

export type VerificationPhoneNumberPayload = VerificationPayload & {
  __typename: 'VerificationPhoneNumberPayload';
  /** Id of verification process */
  id: Scalars['String']['output'];
  /** @deprecated Reason: All fields within "VerificationPhoneNumberPayload" are redundant, therefore "VerificationPayload" should be declared as a possible return type instead inside "StartVerificationPhoneNumberResult" and "VerificationPhoneNumberResult" unions. Since: 2023-09-28. Removed: 2024-03-28. Issue(s) to remove it: WEB-18431. */
  isMobile: Scalars['Boolean']['output'];
  /** @deprecated Reason: All fields within "VerificationPhoneNumberPayload" are redundant, therefore "VerificationPayload" should be declared as a possible return type instead inside "StartVerificationPhoneNumberResult" and "VerificationPhoneNumberResult" unions. Since: 2023-09-28. Removed: 2024-03-28. Issue(s) to remove it: WEB-18431. */
  phoneNumber: Scalars['String']['output'];
  /** @deprecated Reason: All fields within "VerificationPhoneNumberPayload" are redundant, therefore "VerificationPayload" should be declared as a possible return type instead inside "StartVerificationPhoneNumberResult" and "VerificationPhoneNumberResult" unions. Since: 2023-09-28. Removed: 2024-03-28. Issue(s) to remove it: WEB-18431. */
  phoneType: PhoneType;
  status: ContactVerificationStatus;
  /** Present in payload for client cache, for fluid update of new/changed phone number or email after process has completed */
  viewer: Viewer;
};

export type VerificationPhoneNumberResult = VerificationPhoneNumberPayload | WrongVerificationCode;

export type VerifyTokenError = ClientVersionNotSupported | UnknownError;

/** Verify token response */
export type VerifyTokenResponse = {
  __typename: 'VerifyTokenResponse';
  /** Optional error regarding why the token could not be verified. Should only be defined if `verified` is false */
  error: Maybe<VerifyTokenError>;
  user: Maybe<User>;
  verified: Scalars['Boolean']['output'];
};

export type VerifyTokenResult = RsaStepUpResponse | VerifyTokenResponse;

export type VerifyTokenResultV2 = AdaptiveAuthentication | VerifyTokenResponse;

export type ViableLoan = {
  __typename: 'ViableLoan';
  addionalLoannumbererest: Scalars['Float']['output'];
  baseLoannumbererest: Scalars['Float']['output'];
  equity: Scalars['Float']['output'];
  estimatedMonhlyPaymentOnAddionalLoan: Scalars['Float']['output'];
  estimatedMonthlyPaymentBaseLoan: Scalars['Float']['output'];
  estimatedRealEstateOperationCost: Scalars['Float']['output'];
  estimatedRealEstateValuation: Scalars['Float']['output'];
  isIndexed: Scalars['Boolean']['output'];
  maxAdditionalLoan: Scalars['Float']['output'];
  maxBaseLoan: Scalars['Float']['output'];
  mortgageRatio: Scalars['Float']['output'];
  postLoanPaymentPerMonth: Scalars['Float']['output'];
};

/** Represents the current logged in user */
export type Viewer = Actor & Node & {
  __typename: 'Viewer';
  acceptedTermsAndConditions: Array<TermsAndConditions>;
  accountApplicationApplicants: Array<AccountProductApplicant>;
  accounts: AccountConnection;
  acquiring: Maybe<Acquiring>;
  acquiringSettlement: AcquiringSettlement;
  acquiringSettlementContractInfo: AcquiringSettlementContractInfo;
  /** Current active general loan application for the user, if any */
  activeGeneralLoanApplication: Maybe<GeneralLoanApplication>;
  activeOverdraftApplications: ActiveOverdraftApplicationsResponse;
  /** Returns the latest active mortgage loan application */
  activeRealEstateLoanApplication: Maybe<ActiveRealEstateLoanApplication>;
  adaptiveAuthenticationPhoneCallStatus: AdaptiveAuthenticationPhoneCallStatus;
  /** Age as in how many birthdays has this customer had */
  age: Maybe<Scalars['Int']['output']>;
  /** What will this customers age be by the end of the year. */
  ageByYear: Maybe<Scalars['Int']['output']>;
  /** Checks if the given kennitala is authorized to request a credit assessment with the viewer */
  allowedCreditAssessmentApplicant: AllowedCreditAssessmentApplicantPayload;
  /** A document with the annual statement for the specified year. */
  annualStatement: Maybe<GenericFile>;
  applyForCreditCard: ApplyForCreditCard;
  /** @deprecated Will no longer be needed. Use initializeSignatureProcessForAudkenniResult subscription instead. Since: 2026-09-02. Issue to remove it: WEB-45498 */
  asyncAudkenniSignatureInitializationResult: AudkenniSignatureInitializationResult;
  /** @deprecated Will no longer be needed. Use signNextDigitalSignatureDocumentResult subscription instead. Since: 2026-09-02. Issue to remove it: WEB-45498 */
  asyncSignNextDigitalSignatureDocumentByIdResult: SignNextDigitalSignatureDocumentByIdResult;
  aukakronur: Maybe<Aukakronur>;
  /** Auth source value from token */
  authSource: AuthSource;
  authenticators: AuthenticatorConnection;
  authorization: Maybe<Authorization>;
  /** Gets list of car dealerships available to the viewer */
  availableVehicleLoanApplicationDealerships: Array<ExternalVehicleLoanApplicationDealership>;
  /** Returns a list of years for which annual statements are available for the current user. */
  availableYearsForAnnualStatements: Maybe<Array<Scalars['String']['output']>>;
  /** Information about the user avatar and the avatar image itself */
  avatar: Maybe<AvatarInfo>;
  /** Download the excel file containing details about payments for a specific batch. */
  batchPaymentsExcelDocument: DocumentBucket;
  birthplace: Maybe<CustomerLocation>;
  /** @deprecated Use onboardingCompanyPrerequisites instead, which uses Onboarding v4. Since: 2026-09-15. Issue to remove it: WEB-45892 */
  canOnboardCompany: CanOnboardCompanyResponse;
  cardSavings: CardSavingsConnection;
  /**
   * Returns a list of LedgerKeys for card transaction for the company or customer
   * @deprecated Reason: Replaced by `ledgerKeysForCardTransactions`, which handles 403 Forbidden errors. Since: 2024-10-01. Removed: 2025-02-26. Issue(s) to remove it: WEB-29660.
   */
  cardTransactionLedgerKeys: Maybe<CardTransactionsLedgerKeyConnection>;
  /** Cards permissions for the currently logged in user. */
  cardsPermissions: CardsPermissions;
  /**
   * Gets a document (DocumentBucket) of the transactions for all the cards.
   * Individual users will get null results.
   * Note that the maximum time length (between the dateFrom and dateTo arguments) is 31 days.
   */
  cardsTransactionsDocument: Maybe<DocumentBucket>;
  /** CashPool services */
  cashPool: Maybe<CashPool>;
  claimPayers: GetClaimPayersPayload;
  /** Proxy accesses the current user has provided to others for unpaid claims */
  claimProxyAccesses: Maybe<ProxyAccessesForProduct>;
  claimSlipDocument: DocumentBucket;
  /** List of claimant categories for direct debit mandates, instance of per bank and code. */
  claimantCategories: Array<ClaimantCategory>;
  claims: ClaimConnection;
  /** Claims financing information for the current user */
  claimsFinancingInfo: ClaimsFinancingInfo;
  /**
   * Returns all collection bonds landed by the viewer.
   * This field uses the acting kennitala of the viewer to fetch the data.
   */
  collectionBonds: Maybe<CollectionBondConnection>;
  /** Excel document bucket containing excel file with general information about the users bonds. The field uses the acting kennitala and only has results for a company user */
  collectionBondsExcelReport: Maybe<DocumentBucket>;
  /** Claims access permissions for third parties */
  collectionServiceThirdParties: CollectionServiceThirdPartyConnection;
  /** @deprecated Use onboardingCompanies instead, which uses Onboarding v4. Since: 2026-09-15. Issue to remove it: WEB-45892 */
  companiesAvailableForOnboarding: CompaniesAvailableForOnboardingPayload;
  company: Maybe<Company>;
  /** The companies where the current person is a procurator or CEO, according to the companies register. Discontinued companies are left out, and each company is listed once, sorted by name. */
  companyParticipations: Array<CompanyParticipation>;
  /** All of user's conversations. */
  conversations: Maybe<InboxConversationConnection>;
  creditAssessmentCreationStatus: CreditAssessmentCreationStatus;
  creditCardLimits: CreditCardLimitsResponse;
  creditCards: CreditCardConnectionUnion;
  creditScore: CreditScore;
  culture: Culture;
  currencyQuote: CurrencyQuoteResponse;
  /** Checks if the current user needs to answer a feedback survey after completing an action. */
  customerFeedback: Maybe<CustomerFeedback>;
  /** Returns a financial summary for the current user */
  customerSummary: Maybe<CustomerSummary>;
  debitCardsV2: Maybe<DebitCardConnection>;
  defaultAccount: Maybe<Account>;
  derivativeCollaterals: DerivativeCollateralConnection;
  derivativeContracts: DerivativeContractConnection;
  digitalSignatureGroups: DigitalSignatureGroupConnection;
  /**
   * Direct debit agreements are automatic payment of receivables using funds from the customers account.
   * Uses the acting kennitala of the viewer to fetch the data. Returns all mandates for the acting kennitala.
   */
  directDebitAgreements: DirectDebitMandateConnection;
  /**
   * Direct debit agreements are automatic payment of receivables using funds from the customers account.
   * Uses the acting kennitala of the viewer to fetch the dat file. Returns dat file including all mandates for the acting kennitala.
   */
  directDebitAgreementsFile: Maybe<GenericFile>;
  directDebitMandateOrders: DirectDebitMandateOrderConnection;
  /** Template file for direct debit mandate orders excel creation */
  directDebitMandateOrdersExcelTemplate: GenericFile;
  /** Get direct debit agreements permissions */
  directDebitMandatePermissions: DirectDebitMandatePermissions;
  directDebitMandates: DirectDebitMandateConnection;
  directMarketing: DirectMarketing;
  documentPreferences: Array<DocumentPreference>;
  /** Proxy accesses the current user has provided to others for electronic documents */
  electronicDocumentProxyAccesses: Maybe<ProxyAccessesForProduct>;
  /** @deprecated Reason: This field is not optimal, use electronicDocumentsInfo instead. Since: 2025-09-10. Issue to remove it: WEB-36819 */
  electronicDocuments: ElectronicDocumentConnection;
  /** Object containing electronic documents and additional data for the current user */
  electronicDocumentsInfo: ElectronicDocumentsInfo;
  /** @deprecated Use emailInfo instead; it has isVerified property. Since: 2025-05-14. Removed: 2025-11-14. Issue(s) to remove it: WEB-34309 */
  email: Maybe<Scalars['String']['output']>;
  emailInfo: Maybe<Email>;
  estimatedMarketOrder: EstimatedMarketOrderResult;
  estimatedMarketSubscription: EstimatedMarketSubscriptionResult;
  executedPayments: PaymentConnection;
  /** Download an Excel document containing all executed payments based on the provided search filters. */
  executedPaymentsExcelDocument: DocumentBucket;
  executedPaymentsFilterOptions: ExecutedPaymentsFilterOptions;
  /**
   * Document with the distribution plan for expenses
   * @deprecated Reason: Use expenseDistributionPlanDocumentV2 instead. Since: 2026-03-03. Issue to remove it: WEB-41207
   */
  expenseDistributionPlanDocument: DocumentBucket;
  /** Document with the distribution plan for expenses */
  expenseDistributionPlanDocumentV2: GenericFile;
  /** Expenses distribution overview */
  expensesDistribution: Maybe<ExpensesDistribution>;
  /** Returns the status of the expenses distribution application */
  expensesDistributionApplication: ExpensesDistributionApplication;
  /** List of users having access for the expenses distribution of the viewer */
  expensesDistributionUserAccesses: ExpensesDistributionUserAccessConnection;
  /** External bank accounts the current user has provided Landsbankinn consent to fetch from external payment service providers and display in products. */
  externalAccounts: ExternalAccountConnection;
  /** External Accounts Consents the current user has provided */
  externalAccountsConsents: ExternalAccountConsentConnection;
  /** External vehicle loans for car dealerships */
  externalVehicleLoans: Maybe<ExternalVehicleLoans>;
  /** List of user's family members */
  familyMembers: Array<FamilyMember>;
  /** List of financial statement available, grouped by year and month. Each period may have a PDF and/or Excel file. */
  financialStatements: Array<FinancialStatement>;
  /** Financial statements subscription */
  financialStatementsSubscription: Maybe<FinancialStatementsSubscription>;
  firstName: Scalars['String']['output'];
  gender: GenderType;
  giftCards: GiftCardConnection;
  grants: GrantConnection;
  /** @deprecated Reason: This field is not in use and should not be used. Since: 2026-08-20. Issue(s) to remove it: WEB-45188 */
  hasCashpoolAccess: Scalars['Boolean']['output'];
  hasInternationalPaymentsAccess: Scalars['Boolean']['output'];
  /** Returns true if the current user has owned a real estate according to our data. Our data reaches back to 2011 */
  hasOwnedRealEstate: Scalars['Boolean']['output'];
  /** Hashed kennitala */
  hashedKennitala: Maybe<Scalars['String']['output']>;
  /** Hashed userId also known as dbname */
  hashedUsername: Maybe<Scalars['String']['output']>;
  /** All portfolio holding summaries */
  holdingSummaries: Maybe<HoldingSummaries>;
  /** Information about the Icelandair loyalty system if the user has any */
  icelandairLoyalty: Maybe<IcelandairLoyalty>;
  id: Scalars['ID']['output'];
  identificationStatus: IdentificationStatus;
  /** Includes all notifications and messages for the user */
  inbox: Maybe<CustomerInbox>;
  incomeSources: Array<IncomeSource>;
  /** Information about users insurance policies from TM. Currently corporate users are not supported and will return API calls will return forbidden status. */
  insurance: Maybe<Insurance>;
  insuredLoanSelfServiceStatus: InsuredLoanSelfServiceStatus;
  /** Returns invalid prerequisites when applying for a debit card */
  invalidPrerequisitesForDebitCard: Array<InvalidPrerequisiteForCreateDebitCard>;
  invalidPrerequisitesForDebitCardCreation: Array<InvalidPrerequisiteForCreateDebitCard>;
  invoiceBatches: Maybe<InvoiceBatchConnection>;
  invoiceDefaultValues: InvoiceDefaults;
  invoicePayments: Maybe<InvoicePaymentConnection>;
  invoicePaymentsDocument: Maybe<DocumentBucket>;
  invoiceSchedules: InvoiceScheduleConnection;
  invoiceTemplates: InvoiceTemplateConnection;
  invoices: InvoiceConnection;
  invoicesClaimsStatistics: InvoicesClaimsStatistics;
  invoicesOverviewDocument: DocumentBucket;
  invoicesStatistics: Array<InvoicesStatistics>;
  /** Indicates whether this customer is an active customer (has more than one active product) */
  isActiveCustomer: Scalars['Boolean']['output'];
  /** If the current user is a freelancer with corporate access */
  isFreelance: Scalars['Boolean']['output'];
  /** If the current user is a new onboarding customer */
  isNewCustomer: Scalars['Boolean']['output'];
  /** Whether the company is a house association (ísl. húsfélag), based on its legal form in the companies register. */
  isOnboardingCompanyHouseAssociation: Scalars['Boolean']['output'];
  kennitala: Scalars['String']['output'];
  kyc: Maybe<Kyc>;
  kycQuestions: KycQuestionsAndKycSelectList;
  /** The date the KYC is valid to (expiration date) */
  kycValidTo: Maybe<Scalars['String']['output']>;
  lastLogin: Maybe<Scalars['DateTimeISO']['output']>;
  /** List of last successful login events for the current user */
  lastLogins: LoginAuditConnection;
  latestCommission: Maybe<Commission>;
  latestCreditAssessment: Maybe<CreditAssessment>;
  /** The latest onboarding application of the company the user is acting as. Returns null if the user is not acting as a company or no application is found */
  latestOnboardingCompanyApplication: Maybe<CompanyOnboardingApplication>;
  /** Returns a list of ledger key groups for card transactions */
  ledgerKeyGroupsForCardTransactions: CardTransactionLedgerKeyGroupsResponse;
  /** Returns a list of ledger key SubGroups for card transactions */
  ledgerKeySubGroupsForCardTransactions: CardTransactionLedgerKeysSubGroupsResponse;
  /** Returns a list of LedgerKeys for card transaction for the company or customer */
  ledgerKeysForCardTransactions: CardTransactionLedgerKeysResponse;
  /** Based on token context (corporate or personal user), if corporate user then the company's legal address otherwise the persons legal address */
  legalAddress: Maybe<Address>;
  /** Returns all guarantees for the viewer. Only available for corporate users. */
  liabilityGuarantees: Array<LiabilityGuarantee>;
  /** Excel document containing all guarantees for the viewer */
  liabilityGuaranteesExcelSummary: GenericFile;
  /** Returns the available loan durations for Aukalan in array of numbers representing the months available. E.g. it can return [3, 6, 9, 12] represents 3, 6, 9 and 12 months available. */
  loanDurationForAukalan: Array<Scalars['Float']['output']>;
  loanPeriodicPayments: LoanPeriodicPaymentConnection;
  loans: LoanConnection;
  /** Excel document containing loans matching the provided filter */
  loansExcelSummaryV2: GenericFile;
  /** Customer loyalty information for the current user */
  loyalty: Maybe<CustomerLoyalty>;
  /** Proxy accesses the current user has provided to others for market */
  marketProxyAccesses: Maybe<ProxyAccessesForProduct>;
  marketSubscriptions: MarketSubscriptionConnection;
  marketTransactions: MarketTransactionConnection;
  marketTransactionsProcessing: Scalars['Int']['output'];
  /** @deprecated Use primaryPhone and secondaryPhone */
  mobilePhone: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationality: Maybe<CustomerLocation>;
  needsNewSecurityCode: Scalars['Boolean']['output'];
  /** If the current user needs to answer kyc questions */
  needsToAnswerKyc: Scalars['Boolean']['output'];
  /** A company onboarding application. Returns null if no application is found. */
  onboardingCompanyApplication: Maybe<CompanyOnboardingApplication>;
  /** The conditions that block a company from being onboarded by the current contact */
  onboardingCompanyPrerequisites: OnboardingCompanyPrerequisitesResponse;
  /** @deprecated Use latestOnboardingCompanyApplication instead, which uses Onboarding v4. Since: 2026-09-15. Issue to remove it: WEB-45892 */
  onboardingCorporateApplication: Maybe<OnboardingCorporateApplication>;
  /** Returns the latest vehicle loan application that has not been finalized. The type of loan application (corporate or individual) depends on the vehicleLoanApplicationType argument that's passed in from the client. The default of this is: Individual user. */
  ongoingVehicleLoanApplication: Maybe<VehicleLoanApplication>;
  onlineBankVersion: Maybe<OnlineBankVersion>;
  /** Returns active overdrafts for the viewer */
  overdrafts: LiabilityOverdraftConnection;
  /** Excel document with paid leave accounts created in the last 30 days */
  paidLeaveAccountsCreationExcel: GenericFile;
  paymentBatches: PaymentBatchConnection;
  /** All payment distributions of this viewer */
  paymentDistributions: PaymentDistributionConnection;
  /** Returns a single PDF document with all the payment receipts for the given paymentIds */
  paymentReceiptsDocument: DocumentBucket;
  paymentRecipients: PaymentRecipientConnection;
  /** Proxy accesses the current user has provided to others for payment services */
  paymentServiceProxyAccesses: ProxyAccessesForProduct;
  payments: PaymentConnection;
  /** Payrolls for a company */
  payrolls: Maybe<PayrollsConnection>;
  pensions: Maybe<Pensions>;
  periodicPayments: PeriodicPaymentConnection;
  phoneCallStepUpStatus: PhoneCallStepUpStatus;
  portfolios: PortfolioConnection;
  preApprovedLimit: Maybe<PreApprovedLimit>;
  primaryPhone: Maybe<Phone>;
  productForDebitCardCreation: DebitCardProduct;
  /** Checks if proxy access' recipient is allowed to have certain proxy access */
  proxyAccessAuthorisationLookup: ProxyAccessKennitalaLookupResponse;
  /** Proxy accesses received or provided by current user along with all proxy accesses available in a single list. Proxy access groups are used in settings */
  proxyAccessGroups: ProxyAccessGroups;
  proxyAccesses: Maybe<ProxyAccessList>;
  pushNotifications: PushNotifications;
  realEstates: Maybe<Array<RealEstate>>;
  /** Includes recommendations for the user such as product cards (Vöruspjöld) and campaign banners (Meðmælaborðar). */
  recommendations: CustomerRecommendation;
  /** Get details about a recurring card payment token (IS: Sýndarnúmer). The tokenId is merchant-specific and merchants must store and provide it to retrieve token details. */
  recurringCardPaymentTokenDetails: RecurringCardPaymentTokenDetails;
  /** Returns a list of related parties for the current user */
  relatedParties: Array<RelatedParty>;
  residentialAddress: Maybe<CustomerInfoCivicAddress>;
  /**
   * The viewer's risk rating source SAS. For corporate users, this returns the current user's data as he is a guarantor on behalf of the company.
   *       A null value indicates that it is missing
   */
  riskRatingSourceSas: Maybe<Scalars['Float']['output']>;
  savingGoalAccountProduct: SavingGoalAccountProduct;
  /** Information about the user's saving goals */
  savingGoalsInfo: SavingGoalsInfo;
  secondaryPhone: Maybe<Phone>;
  /** Secure card payment authentication token to be used for authenticating payments (Boðgreiðslur). This is jwt token is used by clients to initialize 3D Secure authentication. querying this field will return the same token until it expires in the third-party system. */
  secureCardPaymentAuthentication: SecureCardPaymentAuthentication;
  /** Returns security actions the customer needs to take such as changing password or updating questions. */
  securityActions: Array<SecurityAction>;
  securityQuestions: SecurityQuestionConnection;
  /** If application should prompt user to answer kyc questions */
  shouldPromptKyc: Scalars['Boolean']['output'];
  showAppleWalletPromotion: Scalars['Boolean']['output'];
  /** The current users spouse, returns an empty object for companies */
  spouse: Maybe<Spouse>;
  storedPayments: Maybe<StoredPaymentConnection>;
  storedPaymentsSummary: StoredPaymentsSummary;
  tradingCompliance: TradingCompliance;
  /** List of unique claimant categories for direct debit mandates, only one instance per code and no bank details. */
  uniqueClaimantCategories: Array<UniqueClaimantCategory>;
  username: Scalars['String']['output'];
  /**
   * Returns all users available for the logged in customer.
   * @deprecated Reason: Use usersV2 with pagination instead. Since: 2026-04-17. Issue to remove it: WEB-42126
   */
  users: Array<User>;
  /** Returns a paginated list of current users available for the logged in customer. */
  usersV2: UserConnection;
  viewerCanViewDerivatives: Scalars['Boolean']['output'];
  viewerFinancialSummary: FinancialSummary;
  /** Returns widget settings for the current user */
  widgets: Widgets;
  withdrawalAccountsForDebitCardCreation: AccountConnection;
};


/** Represents the current logged in user */
export type ViewerAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountOrderBy>;
};


/** Represents the current logged in user */
export type ViewerAcquiringSettlementArgs = {
  dateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  dateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Represents the current logged in user */
export type ViewerActiveOverdraftApplicationsArgs = {
  filter?: InputMaybe<ActiveOverdraftApplicationsFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerAllowedCreditAssessmentApplicantArgs = {
  kennitala: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerAnnualStatementArgs = {
  documentFormatType: AnnualStatementFormat;
  year: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerAsyncAudkenniSignatureInitializationResultArgs = {
  key: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerAsyncSignNextDigitalSignatureDocumentByIdResultArgs = {
  key: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerAuthenticatorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerBatchPaymentsExcelDocumentArgs = {
  id: Scalars['ID']['input'];
};


/** Represents the current logged in user */
export type ViewerCanOnboardCompanyArgs = {
  companyKennitala: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerCardSavingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerCardTransactionLedgerKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerCardsTransactionsDocumentArgs = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
};


/** Represents the current logged in user */
export type ViewerClaimProxyAccessesArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerClaimSlipDocumentArgs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};


/** Represents the current logged in user */
export type ViewerClaimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ascending?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClaimsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  payerId?: InputMaybe<Scalars['ID']['input']>;
  payorId?: InputMaybe<Scalars['String']['input']>;
  searchStringKennitala?: InputMaybe<Scalars['String']['input']>;
  searchStringName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClaimSearchType>;
};


/** Represents the current logged in user */
export type ViewerClaimsFinancingInfoArgs = {
  kennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerCollectionBondsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CollectionBondFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerCollectionServiceThirdPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerCompanyArgs = {
  companyKennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ConversationsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerCreditCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CreditCardFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CreditCardOrderBy>;
};


/** Represents the current logged in user */
export type ViewerCurrencyQuoteArgs = {
  payment: CurrencyAmountInput;
  withdrawalAccount: CurrencyQuoteAccount;
};


/** Represents the current logged in user */
export type ViewerCustomerFeedbackArgs = {
  type: CustomerFeedbackType;
};


/** Represents the current logged in user */
export type ViewerDebitCardsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DebitCardFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DebitCardsOrderBy>;
};


/** Represents the current logged in user */
export type ViewerDefaultAccountArgs = {
  filter?: InputMaybe<DefaultAccountFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerDerivativeCollateralsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerDerivativeContractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DerivativeContractFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerDigitalSignatureGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DigitalSignatureGroupFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerDirectDebitAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DirectDebitAgreementFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerDirectDebitMandateOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DirectDebitMandateOrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerDirectDebitMandatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DirectDebitMandateType>;
};


/** Represents the current logged in user */
export type ViewerElectronicDocumentProxyAccessesArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerElectronicDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ElectronicDocumentFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerEstimatedMarketOrderArgs = {
  action: MarketInstrumentOrderAction;
  amount?: InputMaybe<Scalars['Float']['input']>;
  instrumentId: Scalars['String']['input'];
  portfolioId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: MarketInstrumentOrderType;
};


/** Represents the current logged in user */
export type ViewerEstimatedMarketSubscriptionArgs = {
  amount: Scalars['Float']['input'];
  instrumentId: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerExecutedPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExecutedPaymentsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerExecutedPaymentsExcelDocumentArgs = {
  filter?: InputMaybe<ExecutedPaymentsFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerExpenseDistributionPlanDocumentArgs = {
  format: DistributionPlanContentType;
  kennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerExpenseDistributionPlanDocumentV2Args = {
  format: DistributionPlanContentType;
  kennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerExpensesDistributionArgs = {
  kennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerExpensesDistributionUserAccessesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerExternalAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalAccountFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerExternalAccountsConsentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ExternalAccountConsentFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerExternalVehicleLoansArgs = {
  dealershipKennitala: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerFamilyMembersArgs = {
  filter?: InputMaybe<FamilyMemberFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerGiftCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerGrantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerInvalidPrerequisitesForDebitCardArgs = {
  cardId?: InputMaybe<Scalars['ID']['input']>;
  cardPrerequisiteType: CardPrerequisiteType;
};


/** Represents the current logged in user */
export type ViewerInvoiceBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: InvoiceBatchesFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerInvoicePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: InvoicePaymentFilterArgs;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoicePaymentOrderBy>;
};


/** Represents the current logged in user */
export type ViewerInvoicePaymentsDocumentArgs = {
  filter: InvoicePaymentDocumentFilterArgs;
};


/** Represents the current logged in user */
export type ViewerInvoiceSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceSchedulesFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerInvoiceTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceTemplateFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoiceTemplateOrderBy>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InvoicesOrderBy>;
};


/** Represents the current logged in user */
export type ViewerInvoicesOverviewDocumentArgs = {
  fields?: InputMaybe<Array<InvoiceOverviewField>>;
  filter: InvoiceFilterArgs;
  type: InvoiceOverviewType;
};


/** Represents the current logged in user */
export type ViewerInvoicesStatisticsArgs = {
  filter: InvoicesStatisticsFilterArgs;
};


/** Represents the current logged in user */
export type ViewerKycArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerKycQuestionsArgs = {
  onBehalfKennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerLastLoginsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerLatestCommissionArgs = {
  filter?: InputMaybe<CommissionFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerLatestCreditAssessmentArgs = {
  isUpdatable?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents the current logged in user */
export type ViewerLedgerKeyGroupsForCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerLedgerKeySubGroupsForCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerLedgerKeysForCardTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerLiabilityGuaranteesArgs = {
  filter?: InputMaybe<GetLiabilityGuaranteesFilterInput>;
};


/** Represents the current logged in user */
export type ViewerLiabilityGuaranteesExcelSummaryArgs = {
  ownerKennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerLoanDurationForAukalanArgs = {
  data: AukalanLoanDurationInput;
};


/** Represents the current logged in user */
export type ViewerLoanPeriodicPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerLoansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<LoanFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LoanOrderBy>;
};


/** Represents the current logged in user */
export type ViewerLoansExcelSummaryV2Args = {
  filter?: InputMaybe<LoansExcelSummaryInputV2>;
};


/** Represents the current logged in user */
export type ViewerMarketProxyAccessesArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerMarketSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Represents the current logged in user */
export type ViewerMarketTransactionsArgs = {
  action?: InputMaybe<MarketTransactionAction>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calendarDateFrom?: InputMaybe<Scalars['Date']['input']>;
  calendarDateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  instrumentId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
};


/** Represents the current logged in user */
export type ViewerOnboardingCompanyApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


/** Represents the current logged in user */
export type ViewerOnboardingCompanyPrerequisitesArgs = {
  companyKennitala: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerOngoingVehicleLoanApplicationArgs = {
  vehicleLoanApplicationType?: InputMaybe<VehicleLoanApplicationType>;
};


/** Represents the current logged in user */
export type ViewerOverdraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerPaymentBatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentBatchFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerPaymentDistributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<PaymentDistributionSearchType>;
};


/** Represents the current logged in user */
export type ViewerPaymentReceiptsDocumentArgs = {
  options?: InputMaybe<PaymentReceiptsOptions>;
  paymentIds: Array<Scalars['ID']['input']>;
};


/** Represents the current logged in user */
export type ViewerPaymentRecipientsArgs = {
  filter?: InputMaybe<PaymentRecipientFilterArgs>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<PaymentRecipientSortingArg>;
};


/** Represents the current logged in user */
export type ViewerPaymentServiceProxyAccessesArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
};


/** Represents the current logged in user */
export type ViewerPayrollsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerPeriodicPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PeriodicPaymentArgsFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerPortfoliosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PortfolioFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerProductForDebitCardCreationArgs = {
  cardholderKennitala?: InputMaybe<Scalars['String']['input']>;
};


/** Represents the current logged in user */
export type ViewerProxyAccessAuthorisationLookupArgs = {
  accessType: ProxyAccessAccessType;
  productId?: InputMaybe<Scalars['String']['input']>;
  productType: ProxyAccessProductType;
  recipientKennitala: Scalars['String']['input'];
};


/** Represents the current logged in user */
export type ViewerProxyAccessGroupsArgs = {
  filter?: InputMaybe<ProxyAccessFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerRecurringCardPaymentTokenDetailsArgs = {
  input: RecurringCardPaymentTokenDetailsInput;
};


/** Represents the current logged in user */
export type ViewerRelatedPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerSecurityQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerStoredPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StoredPaymentFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StoredPaymentOrderBy>;
};


/** Represents the current logged in user */
export type ViewerStoredPaymentsSummaryArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Represents the current logged in user */
export type ViewerTradingComplianceArgs = {
  instrumentDetail?: InputMaybe<TradingComplianceDetailArgs>;
};


/** Represents the current logged in user */
export type ViewerUsersArgs = {
  filter?: InputMaybe<UserFilterArgs>;
};


/** Represents the current logged in user */
export type ViewerUsersV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents the current logged in user */
export type ViewerWithdrawalAccountsForDebitCardCreationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccountFilterArgs>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AccountOrderBy>;
};

export type ViewerDoesNotHaveAccessToCustomer = Error & {
  __typename: 'ViewerDoesNotHaveAccessToCustomer';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** Violence was detected in the uploaded image */
export type ViolenceDetectedError = Error & {
  __typename: 'ViolenceDetectedError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The reason the widget is hidden */
export enum WidgetDisplayReason {
  HIDDEN_BY_USER = 'HIDDEN_BY_USER',
  HIDDEN_DUE_TO_AGE = 'HIDDEN_DUE_TO_AGE',
  HIDDEN_DUE_TO_AVAILABILITY = 'HIDDEN_DUE_TO_AVAILABILITY',
  HIDDEN_DUE_TO_USER_TYPE = 'HIDDEN_DUE_TO_USER_TYPE',
  UNKNOWN = 'UNKNOWN'
}

export type WidgetNotFoundError = Error & {
  __typename: 'WidgetNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** The type of widget */
export enum WidgetType {
  ACCOUNTS = 'ACCOUNTS',
  ACQUIRING = 'ACQUIRING',
  AUKAKRONUR = 'AUKAKRONUR',
  CARDS = 'CARDS',
  CLAIMS = 'CLAIMS',
  FAVORITE_ACCOUNTS = 'FAVORITE_ACCOUNTS',
  LOANS = 'LOANS',
  PENSION = 'PENSION',
  PREPAID_CARDS = 'PREPAID_CARDS',
  SECURITIES = 'SECURITIES',
  UNKNOWN = 'UNKNOWN',
  UNPAID_BILLS = 'UNPAID_BILLS'
}

/** Widgets */
export type Widgets = {
  __typename: 'Widgets';
  /** Accounts widget settings */
  accounts: Maybe<AccountsWidget>;
  /** Acquiring widget */
  acquiring: Maybe<AcquiringWidget>;
  /** Aukakronur widget settings */
  aukakronur: Maybe<AukakronurWidget>;
  /** Claims widget */
  claims: Maybe<ClaimsWidget>;
  /** Credit cards widget settings */
  creditCards: Maybe<CreditCardsWidget>;
  /** Favorite accounts widget settings */
  favoriteAccounts: Maybe<FavoriteAccountsWidget>;
  id: Scalars['ID']['output'];
  /** Loans widget settings */
  loans: Maybe<LoansWidget>;
  /** Pension widget */
  pension: Maybe<PensionWidget>;
  /** Prepaid cards widget settings */
  prepaidCards: Maybe<PrepaidCardsWidget>;
  /** Securities widget settings and data */
  securities: Maybe<SecuritiesWidget>;
  /** Unpaid bills widget settings */
  unpaidBills: Maybe<UnpaidBillsWidget>;
};

export type WithdrawalAccountAndKennitalaDoNotMatchError = Error & {
  __typename: 'WithdrawalAccountAndKennitalaDoNotMatchError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type WithdrawalAccountNotFoundError = Error & {
  __typename: 'WithdrawalAccountNotFoundError';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type WithdrawalInfo = {
  accountNumber: Scalars['String']['input'];
  kennitala: Scalars['String']['input'];
  noticeType: NoticeType;
  securityCode: Scalars['String']['input'];
};

export type WrongVerificationCode = Error & {
  __typename: 'WrongVerificationCode';
  error: Scalars['String']['output'];
  /** Translated and ready for use inside the UI. Can be used as a fallback if client does not understand the error type. */
  localizedMessage: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type OperationalStatusFragment = { __typename: 'OperationalStatus', name: string, id: string, status: OperationalStatusEnum, message: { __typename: 'OperationalStatusMessage', title: string | null, description: string, link: string | null } | null };

export type OperationalStatusQueryVariables = Exact<{
  filter?: InputMaybe<OperationalStatusFilterArgs>;
}>;


export type OperationalStatusQuery = { operationalStatus: Array<{ __typename: 'OperationalStatus', name: string, id: string, status: OperationalStatusEnum, message: { __typename: 'OperationalStatusMessage', title: string | null, description: string, link: string | null } | null }> };

export const OperationalStatusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperationalStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<OperationalStatusFragment, unknown>;
export const OperationalStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"operationalStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalStatusFilterArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperationalStatus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperationalStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalStatus"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}}]}}]} as unknown as DocumentNode<OperationalStatusQuery, OperationalStatusQueryVariables>;